var map = {
	"./00001/00001-01/00001-01-01/0.jpg": [
		6688,
		7,
		5365
	],
	"./00001/00001-01/00001-01-01/1.jpg": [
		7480,
		7,
		7503
	],
	"./00001/00001-01/00001-01-01/2.jpg": [
		7481,
		7,
		7504
	],
	"./00001/00001-01/00001-01-01/3.jpg": [
		7482,
		7,
		7505
	],
	"./00001/00001-01/00001-01-01/4.jpg": [
		7483,
		7,
		7506
	],
	"./00001/00001-01/00001-01-01/5.jpg": [
		7484,
		7,
		7507
	],
	"./00001/00001-01/00001-01-01/6.jpg": [
		7485,
		7,
		7508
	],
	"./00001/00001-01/00001-01-01/7.jpg": [
		7486,
		7,
		7509
	],
	"./00001/00001-01/00001-01-01/here comes a blue airplane.mp3": [
		1734,
		7,
		409
	],
	"./00001/00001-01/00001-01-01/here comes a blue bus.mp3": [
		1735,
		7,
		410
	],
	"./00001/00001-01/00001-01-01/here comes a blue car.mp3": [
		1736,
		7,
		411
	],
	"./00001/00001-01/00001-01-01/here comes a blue helicopter.mp3": [
		1737,
		7,
		412
	],
	"./00001/00001-01/00001-01-01/here comes a blue motorcycle.mp3": [
		1738,
		7,
		413
	],
	"./00001/00001-01/00001-01-01/here comes a blue train.mp3": [
		1739,
		7,
		414
	],
	"./00001/00001-01/00001-01-01/here comes a blue truck.mp3": [
		1740,
		7,
		415
	],
	"./00001/00001-01/00001-01-01/intro.mp3": [
		357,
		7
	],
	"./00001/00001-01/00001-01-01/main idea.mp3": [
		738,
		7
	],
	"./00001/00001-01/00001-01-01/module": [
		1136,
		9,
		0
	],
	"./00001/00001-01/00001-01-01/module.js": [
		1136,
		9,
		0
	],
	"./00001/00001-01/00001-01-01/the blue vehicle book.mp3": [
		1741,
		7,
		416
	],
	"./00001/00001-01/00001-01-01/things that fly.mp3": [
		1742,
		7,
		417
	],
	"./00001/00001-01/00001-01-02/0.jpg": [
		6689,
		7,
		5366
	],
	"./00001/00001-01/00001-01-02/1.jpg": [
		7487,
		7,
		7510
	],
	"./00001/00001-01/00001-01-02/2.jpg": [
		7488,
		7,
		7511
	],
	"./00001/00001-01/00001-01-02/3.jpg": [
		7489,
		7,
		7512
	],
	"./00001/00001-01/00001-01-02/4.jpg": [
		7490,
		7,
		7513
	],
	"./00001/00001-01/00001-01-02/5.jpg": [
		7491,
		7,
		7514
	],
	"./00001/00001-01/00001-01-02/6.jpg": [
		7492,
		7,
		7515
	],
	"./00001/00001-01/00001-01-02/7.jpg": [
		7493,
		7,
		7516
	],
	"./00001/00001-01/00001-01-02/intro.mp3": [
		358,
		7
	],
	"./00001/00001-01/00001-01-02/main idea.mp3": [
		739,
		7
	],
	"./00001/00001-01/00001-01-02/module": [
		1137,
		9,
		1
	],
	"./00001/00001-01/00001-01-02/module.js": [
		1137,
		9,
		1
	],
	"./00001/00001-01/00001-01-02/the bird is red.mp3": [
		1743,
		7,
		418
	],
	"./00001/00001-01/00001-01-02/the butterfly is red.mp3": [
		1744,
		7,
		419
	],
	"./00001/00001-01/00001-01-02/the fire truck is red.mp3": [
		1745,
		7,
		420
	],
	"./00001/00001-01/00001-01-02/the frog is red.mp3": [
		1746,
		7,
		421
	],
	"./00001/00001-01/00001-01-02/the ladybug is red.mp3": [
		1747,
		7,
		422
	],
	"./00001/00001-01/00001-01-02/the red book.mp3": [
		1748,
		7,
		423
	],
	"./00001/00001-01/00001-01-02/the snake is red.mp3": [
		1749,
		7,
		424
	],
	"./00001/00001-01/00001-01-02/the starfish is red.mp3": [
		1750,
		7,
		425
	],
	"./00001/00001-01/00001-01-02/things that are red.mp3": [
		1751,
		7,
		426
	],
	"./00001/00001-01/00001-01-03/0.jpg": [
		6690,
		7,
		5367
	],
	"./00001/00001-01/00001-01-03/1.jpg": [
		7494,
		7,
		7517
	],
	"./00001/00001-01/00001-01-03/2.jpg": [
		7495,
		7,
		7518
	],
	"./00001/00001-01/00001-01-03/3.jpg": [
		7496,
		7,
		7519
	],
	"./00001/00001-01/00001-01-03/4.jpg": [
		7497,
		7,
		7520
	],
	"./00001/00001-01/00001-01-03/5.jpg": [
		7498,
		7,
		7521
	],
	"./00001/00001-01/00001-01-03/6.jpg": [
		7499,
		7,
		7522
	],
	"./00001/00001-01/00001-01-03/7.jpg": [
		7500,
		7,
		7523
	],
	"./00001/00001-01/00001-01-03/i see the yellow bananas.mp3": [
		1752,
		7,
		427
	],
	"./00001/00001-01/00001-01-03/i see the yellow chick.mp3": [
		1753,
		7,
		428
	],
	"./00001/00001-01/00001-01-03/i see the yellow lion.mp3": [
		1754,
		7,
		429
	],
	"./00001/00001-01/00001-01-03/i see the yellow slug.mp3": [
		1755,
		7,
		430
	],
	"./00001/00001-01/00001-01-03/i see the yellow snake.mp3": [
		1756,
		7,
		431
	],
	"./00001/00001-01/00001-01-03/i see the yellow sun.mp3": [
		1757,
		7,
		432
	],
	"./00001/00001-01/00001-01-03/i see the yellow yoyo.mp3": [
		1758,
		7,
		433
	],
	"./00001/00001-01/00001-01-03/intro.mp3": [
		359,
		7
	],
	"./00001/00001-01/00001-01-03/main idea.mp3": [
		740,
		7
	],
	"./00001/00001-01/00001-01-03/module": [
		1138,
		9,
		2
	],
	"./00001/00001-01/00001-01-03/module.js": [
		1138,
		9,
		2
	],
	"./00001/00001-01/00001-01-03/the blue vehicle book.mp3": [
		1759,
		7,
		434
	],
	"./00001/00001-01/00001-01-03/the yellow book.mp3": [
		1760,
		7,
		435
	],
	"./00001/00001-01/00001-01-03/things that are yellow.mp3": [
		1761,
		7,
		436
	],
	"./00001/00001-01/00001-01-04/0.jpg": [
		6691,
		7,
		5368
	],
	"./00001/00001-01/00001-01-04/1.jpg": [
		7501,
		7,
		7524
	],
	"./00001/00001-01/00001-01-04/2.jpg": [
		7502,
		7,
		7525
	],
	"./00001/00001-01/00001-01-04/3.jpg": [
		7503,
		7,
		7526
	],
	"./00001/00001-01/00001-01-04/4.jpg": [
		7504,
		7,
		7527
	],
	"./00001/00001-01/00001-01-04/5.jpg": [
		7505,
		7,
		7528
	],
	"./00001/00001-01/00001-01-04/6.jpg": [
		7506,
		7,
		7529
	],
	"./00001/00001-01/00001-01-04/7.jpg": [
		7507,
		7,
		7530
	],
	"./00001/00001-01/00001-01-04/intro.mp3": [
		360,
		7
	],
	"./00001/00001-01/00001-01-04/look at the orange butterfly.mp3": [
		1762,
		7,
		437
	],
	"./00001/00001-01/00001-01-04/look at the orange cat.mp3": [
		1763,
		7,
		438
	],
	"./00001/00001-01/00001-01-04/look at the orange fish.mp3": [
		1764,
		7,
		439
	],
	"./00001/00001-01/00001-01-04/look at the orange fox.mp3": [
		1765,
		7,
		440
	],
	"./00001/00001-01/00001-01-04/look at the orange octopus.mp3": [
		1766,
		7,
		441
	],
	"./00001/00001-01/00001-01-04/look at the orange salamander.mp3": [
		1767,
		7,
		442
	],
	"./00001/00001-01/00001-01-04/look at the orange tiger.mp3": [
		1768,
		7,
		443
	],
	"./00001/00001-01/00001-01-04/main idea.mp3": [
		741,
		7
	],
	"./00001/00001-01/00001-01-04/module": [
		1139,
		9,
		3
	],
	"./00001/00001-01/00001-01-04/module.js": [
		1139,
		9,
		3
	],
	"./00001/00001-01/00001-01-04/orange things.mp3": [
		1769,
		7,
		444
	],
	"./00001/00001-01/00001-01-04/the orange animal book.mp3": [
		1770,
		7,
		445
	],
	"./00001/00001-01/00001-01-05/0.jpg": [
		6692,
		7,
		5369
	],
	"./00001/00001-01/00001-01-05/1.jpg": [
		7508,
		7,
		7531
	],
	"./00001/00001-01/00001-01-05/2.jpg": [
		7509,
		7,
		7532
	],
	"./00001/00001-01/00001-01-05/3.jpg": [
		7510,
		7,
		7533
	],
	"./00001/00001-01/00001-01-05/4.jpg": [
		7511,
		7,
		7534
	],
	"./00001/00001-01/00001-01-05/5.jpg": [
		7512,
		7,
		7535
	],
	"./00001/00001-01/00001-01-05/6.jpg": [
		7513,
		7,
		7536
	],
	"./00001/00001-01/00001-01-05/7.jpg": [
		7514,
		7,
		7537
	],
	"./00001/00001-01/00001-01-05/i like the purple ball.mp3": [
		1771,
		7,
		446
	],
	"./00001/00001-01/00001-01-05/i like the purple dinosaur.mp3": [
		1772,
		7,
		447
	],
	"./00001/00001-01/00001-01-05/i like the purple flower.mp3": [
		1773,
		7,
		448
	],
	"./00001/00001-01/00001-01-05/i like the purple hat.mp3": [
		1774,
		7,
		449
	],
	"./00001/00001-01/00001-01-05/i like the purple jellyfish.mp3": [
		1775,
		7,
		450
	],
	"./00001/00001-01/00001-01-05/i like the purple monster.mp3": [
		1776,
		7,
		451
	],
	"./00001/00001-01/00001-01-05/i like the purple starfish.mp3": [
		1777,
		7,
		452
	],
	"./00001/00001-01/00001-01-05/intro.mp3": [
		361,
		7
	],
	"./00001/00001-01/00001-01-05/main idea.mp3": [
		742,
		7
	],
	"./00001/00001-01/00001-01-05/module": [
		1140,
		9,
		4
	],
	"./00001/00001-01/00001-01-05/module.js": [
		1140,
		9,
		4
	],
	"./00001/00001-01/00001-01-05/the purple book.mp3": [
		1778,
		7,
		453
	],
	"./00001/00001-01/00001-01-05/things that are purple.mp3": [
		1779,
		7,
		454
	],
	"./00001/00001-01/00001-01-06/0.jpg": [
		6693,
		7,
		5370
	],
	"./00001/00001-01/00001-01-06/1.jpg": [
		7515,
		7,
		7538
	],
	"./00001/00001-01/00001-01-06/2.jpg": [
		7516,
		7,
		7539
	],
	"./00001/00001-01/00001-01-06/3.jpg": [
		7517,
		7,
		7540
	],
	"./00001/00001-01/00001-01-06/4.jpg": [
		7518,
		7,
		7541
	],
	"./00001/00001-01/00001-01-06/5.jpg": [
		7519,
		7,
		7542
	],
	"./00001/00001-01/00001-01-06/6.jpg": [
		7520,
		7,
		7543
	],
	"./00001/00001-01/00001-01-06/7.jpg": [
		7521,
		7,
		7544
	],
	"./00001/00001-01/00001-01-06/animals that are green.mp3": [
		1780,
		7,
		455
	],
	"./00001/00001-01/00001-01-06/i see the green alligator.mp3": [
		1781,
		7,
		456
	],
	"./00001/00001-01/00001-01-06/i see the green caterpillar.mp3": [
		1782,
		7,
		457
	],
	"./00001/00001-01/00001-01-06/i see the green frog.mp3": [
		1783,
		7,
		458
	],
	"./00001/00001-01/00001-01-06/i see the green grasshopper.mp3": [
		1784,
		7,
		459
	],
	"./00001/00001-01/00001-01-06/i see the green iguana.mp3": [
		1785,
		7,
		460
	],
	"./00001/00001-01/00001-01-06/i see the green leaf.mp3": [
		1786,
		7,
		461
	],
	"./00001/00001-01/00001-01-06/i see the green turtle.mp3": [
		1787,
		7,
		462
	],
	"./00001/00001-01/00001-01-06/intro.mp3": [
		362,
		7
	],
	"./00001/00001-01/00001-01-06/main idea.mp3": [
		743,
		7
	],
	"./00001/00001-01/00001-01-06/module": [
		1141,
		9,
		5
	],
	"./00001/00001-01/00001-01-06/module.js": [
		1141,
		9,
		5
	],
	"./00001/00001-01/00001-01-06/the green book.mp3": [
		1788,
		7,
		463
	],
	"./00001/00001-01/00001-01-07/0.jpg": [
		6694,
		7,
		5371
	],
	"./00001/00001-01/00001-01-07/1.jpg": [
		7522,
		7,
		7545
	],
	"./00001/00001-01/00001-01-07/2.jpg": [
		7523,
		7,
		7546
	],
	"./00001/00001-01/00001-01-07/3.jpg": [
		7524,
		7,
		7547
	],
	"./00001/00001-01/00001-01-07/4.jpg": [
		7525,
		7,
		7548
	],
	"./00001/00001-01/00001-01-07/5-.jpg": [
		7526,
		7,
		7549
	],
	"./00001/00001-01/00001-01-07/5.jpg": [
		7527,
		7,
		7550
	],
	"./00001/00001-01/00001-01-07/6.jpg": [
		7528,
		7,
		7551
	],
	"./00001/00001-01/00001-01-07/7.jpg": [
		7529,
		7,
		7552
	],
	"./00001/00001-01/00001-01-07/animals that are brown.mp3": [
		1789,
		7,
		464
	],
	"./00001/00001-01/00001-01-07/i am a brown bat.mp3": [
		1790,
		7,
		465
	],
	"./00001/00001-01/00001-01-07/i am a brown bear.mp3": [
		1791,
		7,
		466
	],
	"./00001/00001-01/00001-01-07/i am a brown deer.mp3": [
		1792,
		7,
		467
	],
	"./00001/00001-01/00001-01-07/i am a brown eagle.mp3": [
		1793,
		7,
		468
	],
	"./00001/00001-01/00001-01-07/i am a brown mouse.mp3": [
		1794,
		7,
		469
	],
	"./00001/00001-01/00001-01-07/i am a brown rabbit.mp3": [
		1795,
		7,
		470
	],
	"./00001/00001-01/00001-01-07/intro.mp3": [
		363,
		7
	],
	"./00001/00001-01/00001-01-07/main idea.mp3": [
		744,
		7
	],
	"./00001/00001-01/00001-01-07/module": [
		1142,
		9,
		6
	],
	"./00001/00001-01/00001-01-07/module.js": [
		1142,
		9,
		6
	],
	"./00001/00001-01/00001-01-07/the brown book.mp3": [
		1796,
		7,
		471
	],
	"./00001/00001-01/00001-01-07/we are brown kangaroos.mp3": [
		1797,
		7,
		472
	],
	"./00001/00001-01/00001-01-08/0.jpg": [
		6695,
		7,
		5372
	],
	"./00001/00001-01/00001-01-08/1.jpg": [
		7530,
		7,
		7553
	],
	"./00001/00001-01/00001-01-08/2.jpg": [
		7531,
		7,
		7554
	],
	"./00001/00001-01/00001-01-08/3.jpg": [
		7532,
		7,
		7555
	],
	"./00001/00001-01/00001-01-08/4.jpg": [
		7533,
		7,
		7556
	],
	"./00001/00001-01/00001-01-08/5.jpg": [
		7534,
		7,
		7557
	],
	"./00001/00001-01/00001-01-08/6.jpg": [
		7535,
		7,
		7558
	],
	"./00001/00001-01/00001-01-08/7.jpg": [
		7536,
		7,
		7559
	],
	"./00001/00001-01/00001-01-08/animals.mp3": [
		1798,
		7,
		473
	],
	"./00001/00001-01/00001-01-08/intro.mp3": [
		364,
		7
	],
	"./00001/00001-01/00001-01-08/look at the black ant.mp3": [
		1799,
		7,
		474
	],
	"./00001/00001-01/00001-01-08/look at the black bear.mp3": [
		1800,
		7,
		475
	],
	"./00001/00001-01/00001-01-08/look at the black bird.mp3": [
		1801,
		7,
		476
	],
	"./00001/00001-01/00001-01-08/look at the black cat.mp3": [
		1802,
		7,
		477
	],
	"./00001/00001-01/00001-01-08/look at the black dog.mp3": [
		1803,
		7,
		478
	],
	"./00001/00001-01/00001-01-08/look at the black horse.mp3": [
		1804,
		7,
		479
	],
	"./00001/00001-01/00001-01-08/look at the black spider.mp3": [
		1805,
		7,
		480
	],
	"./00001/00001-01/00001-01-08/main idea.mp3": [
		745,
		7
	],
	"./00001/00001-01/00001-01-08/module": [
		1143,
		9,
		7
	],
	"./00001/00001-01/00001-01-08/module.js": [
		1143,
		9,
		7
	],
	"./00001/00001-01/00001-01-08/the black book.mp3": [
		1806,
		7,
		481
	],
	"./00001/00001-01/00001-01-09/0.jpg": [
		6696,
		7,
		5373
	],
	"./00001/00001-01/00001-01-09/1.jpg": [
		7537,
		7,
		7560
	],
	"./00001/00001-01/00001-01-09/2.jpg": [
		7538,
		7,
		7561
	],
	"./00001/00001-01/00001-01-09/3.jpg": [
		7539,
		7,
		7562
	],
	"./00001/00001-01/00001-01-09/4.jpg": [
		7540,
		7,
		7563
	],
	"./00001/00001-01/00001-01-09/5.jpg": [
		7541,
		7,
		7564
	],
	"./00001/00001-01/00001-01-09/6.jpg": [
		7542,
		7,
		7565
	],
	"./00001/00001-01/00001-01-09/7.jpg": [
		7543,
		7,
		7566
	],
	"./00001/00001-01/00001-01-09/animals that live in the snow.mp3": [
		1807,
		7,
		482
	],
	"./00001/00001-01/00001-01-09/intro.mp3": [
		365,
		7
	],
	"./00001/00001-01/00001-01-09/main idea.mp3": [
		746,
		7
	],
	"./00001/00001-01/00001-01-09/module": [
		1144,
		9,
		8
	],
	"./00001/00001-01/00001-01-09/module.js": [
		1144,
		9,
		8
	],
	"./00001/00001-01/00001-01-09/the fox is white.mp3": [
		1808,
		7,
		483
	],
	"./00001/00001-01/00001-01-09/the owl is white.mp3": [
		1809,
		7,
		484
	],
	"./00001/00001-01/00001-01-09/the penguin is black and white.mp3": [
		1810,
		7,
		485
	],
	"./00001/00001-01/00001-01-09/the polar bear is white.mp3": [
		1811,
		7,
		486
	],
	"./00001/00001-01/00001-01-09/the rabbit is white.mp3": [
		1812,
		7,
		487
	],
	"./00001/00001-01/00001-01-09/the seal is white.mp3": [
		1813,
		7,
		488
	],
	"./00001/00001-01/00001-01-09/the white book.mp3": [
		1814,
		7,
		489
	],
	"./00001/00001-01/00001-01-09/the wolf is white.mp3": [
		1815,
		7,
		490
	],
	"./00001/00001-01/00001-01-10/0.jpg": [
		6697,
		7,
		5374
	],
	"./00001/00001-01/00001-01-10/1.jpg": [
		7544,
		7,
		7567
	],
	"./00001/00001-01/00001-01-10/2.jpg": [
		7545,
		7,
		7568
	],
	"./00001/00001-01/00001-01-10/3.jpg": [
		7546,
		7,
		7569
	],
	"./00001/00001-01/00001-01-10/4.jpg": [
		7547,
		7,
		7570
	],
	"./00001/00001-01/00001-01-10/5.jpg": [
		7548,
		7,
		7571
	],
	"./00001/00001-01/00001-01-10/6.jpg": [
		7549,
		7,
		7572
	],
	"./00001/00001-01/00001-01-10/7.jpg": [
		7550,
		7,
		7573
	],
	"./00001/00001-01/00001-01-10/i like the pink crab.mp3": [
		1816,
		7,
		491
	],
	"./00001/00001-01/00001-01-10/i like the pink flamingo.mp3": [
		1817,
		7,
		492
	],
	"./00001/00001-01/00001-01-10/i like the pink flower.mp3": [
		1818,
		7,
		493
	],
	"./00001/00001-01/00001-01-10/i like the pink hat.mp3": [
		1819,
		7,
		494
	],
	"./00001/00001-01/00001-01-10/i like the pink heart.mp3": [
		1820,
		7,
		495
	],
	"./00001/00001-01/00001-01-10/i like the pink pig.mp3": [
		1821,
		7,
		496
	],
	"./00001/00001-01/00001-01-10/i like the pink shell.mp3": [
		1822,
		7,
		497
	],
	"./00001/00001-01/00001-01-10/intro.mp3": [
		366,
		7
	],
	"./00001/00001-01/00001-01-10/main idea.mp3": [
		747,
		7
	],
	"./00001/00001-01/00001-01-10/module": [
		1145,
		9,
		9
	],
	"./00001/00001-01/00001-01-10/module.js": [
		1145,
		9,
		9
	],
	"./00001/00001-01/00001-01-10/the pink book.mp3": [
		1823,
		7,
		498
	],
	"./00001/00001-01/00001-01-10/things that are pink.mp3": [
		1824,
		7,
		499
	],
	"./00001/00001-01/00001-01-11/0.jpg": [
		6698,
		7,
		5375
	],
	"./00001/00001-01/00001-01-11/1.jpg": [
		7551,
		7,
		7574
	],
	"./00001/00001-01/00001-01-11/2.jpg": [
		7552,
		7,
		7575
	],
	"./00001/00001-01/00001-01-11/3.jpg": [
		7553,
		7,
		7576
	],
	"./00001/00001-01/00001-01-11/4.jpg": [
		7554,
		7,
		7577
	],
	"./00001/00001-01/00001-01-11/5.jpg": [
		7555,
		7,
		7578
	],
	"./00001/00001-01/00001-01-11/6.jpg": [
		7556,
		7,
		7579
	],
	"./00001/00001-01/00001-01-11/7.jpg": [
		7557,
		7,
		7580
	],
	"./00001/00001-01/00001-01-11/animals that are gray.mp3": [
		1825,
		7,
		500
	],
	"./00001/00001-01/00001-01-11/here comes the gray elephant.mp3": [
		1826,
		7,
		501
	],
	"./00001/00001-01/00001-01-11/here comes the gray hippo.mp3": [
		1827,
		7,
		502
	],
	"./00001/00001-01/00001-01-11/here comes the gray raccoon.mp3": [
		1828,
		7,
		503
	],
	"./00001/00001-01/00001-01-11/here comes the gray rhino.mp3": [
		1829,
		7,
		504
	],
	"./00001/00001-01/00001-01-11/here comes the gray seal.mp3": [
		1830,
		7,
		505
	],
	"./00001/00001-01/00001-01-11/here comes the gray whale.mp3": [
		1831,
		7,
		506
	],
	"./00001/00001-01/00001-01-11/here comes the gray wolf.mp3": [
		1832,
		7,
		507
	],
	"./00001/00001-01/00001-01-11/intro.mp3": [
		367,
		7
	],
	"./00001/00001-01/00001-01-11/main idea.mp3": [
		748,
		7
	],
	"./00001/00001-01/00001-01-11/module": [
		1146,
		9,
		10
	],
	"./00001/00001-01/00001-01-11/module.js": [
		1146,
		9,
		10
	],
	"./00001/00001-01/00001-01-11/the gray book.mp3": [
		1833,
		7,
		508
	],
	"./00001/00001-01/color park.mp3": [
		1834,
		7,
		509
	],
	"./00001/00001-01/colors.mp3": [
		1835,
		7,
		510
	],
	"./00001/00001-01/cover.jpg": [
		6699,
		7,
		5376
	],
	"./00001/00001-01/unit": [
		1147,
		9,
		11
	],
	"./00001/00001-01/unit.js": [
		1147,
		9,
		11
	],
	"./00001/00001-02/00001-02-01/0.jpg": [
		6700,
		7,
		5377
	],
	"./00001/00001-02/00001-02-01/1.jpg": [
		7558,
		7,
		7581
	],
	"./00001/00001-02/00001-02-01/2.jpg": [
		7559,
		7,
		7582
	],
	"./00001/00001-02/00001-02-01/3.jpg": [
		7560,
		7,
		7583
	],
	"./00001/00001-02/00001-02-01/4.jpg": [
		7561,
		7,
		7584
	],
	"./00001/00001-02/00001-02-01/5.jpg": [
		7562,
		7,
		7585
	],
	"./00001/00001-02/00001-02-01/6.jpg": [
		7563,
		7,
		7586
	],
	"./00001/00001-02/00001-02-01/7.jpg": [
		7564,
		7,
		7587
	],
	"./00001/00001-02/00001-02-01/animals.mp3": [
		1836,
		7,
		511
	],
	"./00001/00001-02/00001-02-01/intro.mp3": [
		368,
		7
	],
	"./00001/00001-02/00001-02-01/look at the bear.mp3": [
		1837,
		7,
		512
	],
	"./00001/00001-02/00001-02-01/look at the fox.mp3": [
		1838,
		7,
		513
	],
	"./00001/00001-02/00001-02-01/look at the mitten.mp3": [
		1839,
		7,
		514
	],
	"./00001/00001-02/00001-02-01/look at the mouse.mp3": [
		1840,
		7,
		515
	],
	"./00001/00001-02/00001-02-01/look at the owl.mp3": [
		1841,
		7,
		516
	],
	"./00001/00001-02/00001-02-01/look at the rabbit.mp3": [
		1842,
		7,
		517
	],
	"./00001/00001-02/00001-02-01/main idea.mp3": [
		749,
		7
	],
	"./00001/00001-02/00001-02-01/module": [
		1148,
		9,
		12
	],
	"./00001/00001-02/00001-02-01/module.js": [
		1148,
		9,
		12
	],
	"./00001/00001-02/00001-02-01/the mitten.mp3": [
		1843,
		7,
		518
	],
	"./00001/00001-02/00001-02-02/0.jpg": [
		6701,
		7,
		5378
	],
	"./00001/00001-02/00001-02-02/1.jpg": [
		7565,
		7,
		7588
	],
	"./00001/00001-02/00001-02-02/2.jpg": [
		7566,
		7,
		7589
	],
	"./00001/00001-02/00001-02-02/3.jpg": [
		7567,
		7,
		7590
	],
	"./00001/00001-02/00001-02-02/4.jpg": [
		7568,
		7,
		7591
	],
	"./00001/00001-02/00001-02-02/5.jpg": [
		7569,
		7,
		7592
	],
	"./00001/00001-02/00001-02-02/6.jpg": [
		7570,
		7,
		7593
	],
	"./00001/00001-02/00001-02-02/7.jpg": [
		7571,
		7,
		7594
	],
	"./00001/00001-02/00001-02-02/dogs.mp3": [
		1844,
		7,
		519
	],
	"./00001/00001-02/00001-02-02/intro.mp3": [
		369,
		7
	],
	"./00001/00001-02/00001-02-02/look in the bathroom.mp3": [
		1845,
		7,
		520
	],
	"./00001/00001-02/00001-02-02/look in the bedroom.mp3": [
		1846,
		7,
		521
	],
	"./00001/00001-02/00001-02-02/look in the box.mp3": [
		1847,
		7,
		522
	],
	"./00001/00001-02/00001-02-02/look in the kitchen.mp3": [
		1848,
		7,
		523
	],
	"./00001/00001-02/00001-02-02/look in the living room.mp3": [
		1849,
		7,
		524
	],
	"./00001/00001-02/00001-02-02/look in the shower.mp3": [
		1850,
		7,
		525
	],
	"./00001/00001-02/00001-02-02/look.mp3": [
		1851,
		7,
		526
	],
	"./00001/00001-02/00001-02-02/main idea.mp3": [
		750,
		7
	],
	"./00001/00001-02/00001-02-02/module": [
		1149,
		9,
		13
	],
	"./00001/00001-02/00001-02-02/module.js": [
		1149,
		9,
		13
	],
	"./00001/00001-02/00001-02-02/where are the puppies.mp3": [
		1852,
		7,
		527
	],
	"./00001/00001-02/00001-02-03/0.jpg": [
		6702,
		7,
		5379
	],
	"./00001/00001-02/00001-02-03/1.jpg": [
		7572,
		7,
		7595
	],
	"./00001/00001-02/00001-02-03/2.jpg": [
		7573,
		7,
		7596
	],
	"./00001/00001-02/00001-02-03/3.jpg": [
		7574,
		7,
		7597
	],
	"./00001/00001-02/00001-02-03/4.jpg": [
		7575,
		7,
		7598
	],
	"./00001/00001-02/00001-02-03/5.jpg": [
		7576,
		7,
		7599
	],
	"./00001/00001-02/00001-02-03/6.jpg": [
		7577,
		7,
		7600
	],
	"./00001/00001-02/00001-02-03/7.jpg": [
		7578,
		7,
		7601
	],
	"./00001/00001-02/00001-02-03/farm animals.mp3": [
		1853,
		7,
		528
	],
	"./00001/00001-02/00001-02-03/intro.mp3": [
		370,
		7
	],
	"./00001/00001-02/00001-02-03/main idea.mp3": [
		751,
		7
	],
	"./00001/00001-02/00001-02-03/module": [
		1150,
		9,
		14
	],
	"./00001/00001-02/00001-02-03/module.js": [
		1150,
		9,
		14
	],
	"./00001/00001-02/00001-02-03/the bus ride.mp3": [
		1854,
		7,
		529
	],
	"./00001/00001-02/00001-02-03/the cats go on the bus.mp3": [
		1855,
		7,
		530
	],
	"./00001/00001-02/00001-02-03/the cows go on the bus.mp3": [
		1856,
		7,
		531
	],
	"./00001/00001-02/00001-02-03/the dogs go on the bus.mp3": [
		1857,
		7,
		532
	],
	"./00001/00001-02/00001-02-03/the ducks go on the bus.mp3": [
		1858,
		7,
		533
	],
	"./00001/00001-02/00001-02-03/the horses go on the bus.mp3": [
		1859,
		7,
		534
	],
	"./00001/00001-02/00001-02-03/the lions go on the bus.mp3": [
		1860,
		7,
		535
	],
	"./00001/00001-02/00001-02-03/the sheep go on the bus.mp3": [
		1861,
		7,
		536
	],
	"./00001/00001-02/00001-02-04/0.jpg": [
		6703,
		7,
		5380
	],
	"./00001/00001-02/00001-02-04/1.jpg": [
		7579,
		7,
		7602
	],
	"./00001/00001-02/00001-02-04/2.jpg": [
		7580,
		7,
		7603
	],
	"./00001/00001-02/00001-02-04/3.jpg": [
		7581,
		7,
		7604
	],
	"./00001/00001-02/00001-02-04/4.jpg": [
		7582,
		7,
		7605
	],
	"./00001/00001-02/00001-02-04/5.jpg": [
		7583,
		7,
		7606
	],
	"./00001/00001-02/00001-02-04/6.jpg": [
		7584,
		7,
		7607
	],
	"./00001/00001-02/00001-02-04/7.jpg": [
		7585,
		7,
		7608
	],
	"./00001/00001-02/00001-02-04/dogs.mp3": [
		1862,
		7,
		537
	],
	"./00001/00001-02/00001-02-04/intro.mp3": [
		371,
		7
	],
	"./00001/00001-02/00001-02-04/main idea.mp3": [
		752,
		7
	],
	"./00001/00001-02/00001-02-04/module": [
		1151,
		9,
		15
	],
	"./00001/00001-02/00001-02-04/module.js": [
		1151,
		9,
		15
	],
	"./00001/00001-02/00001-02-04/no no puppy.mp3": [
		1863,
		7,
		538
	],
	"./00001/00001-02/00001-02-04/you can not play with the hedgehog.mp3": [
		1864,
		7,
		539
	],
	"./00001/00001-02/00001-02-04/you can not play with the owl.mp3": [
		1865,
		7,
		540
	],
	"./00001/00001-02/00001-02-04/you can not play with the rabbit.mp3": [
		1866,
		7,
		541
	],
	"./00001/00001-02/00001-02-04/you can not play with the skunk.mp3": [
		1867,
		7,
		542
	],
	"./00001/00001-02/00001-02-04/you can not play with the snake.mp3": [
		1868,
		7,
		543
	],
	"./00001/00001-02/00001-02-04/you can not play with the turtle.mp3": [
		1869,
		7,
		544
	],
	"./00001/00001-02/00001-02-04/you can play with the kitten.mp3": [
		1870,
		7,
		545
	],
	"./00001/00001-02/00001-02-05/0.jpg": [
		6704,
		7,
		5381
	],
	"./00001/00001-02/00001-02-05/1.jpg": [
		7586,
		7,
		7609
	],
	"./00001/00001-02/00001-02-05/2.jpg": [
		7587,
		7,
		7610
	],
	"./00001/00001-02/00001-02-05/3.jpg": [
		7588,
		7,
		7611
	],
	"./00001/00001-02/00001-02-05/4.jpg": [
		7589,
		7,
		7612
	],
	"./00001/00001-02/00001-02-05/5.jpg": [
		7590,
		7,
		7613
	],
	"./00001/00001-02/00001-02-05/6.jpg": [
		7591,
		7,
		7614
	],
	"./00001/00001-02/00001-02-05/7.jpg": [
		7592,
		7,
		7615
	],
	"./00001/00001-02/00001-02-05/animals that are gray.mp3": [
		1871,
		7,
		546
	],
	"./00001/00001-02/00001-02-05/i love black and white.mp3": [
		1872,
		7,
		547
	],
	"./00001/00001-02/00001-02-05/i love blue.mp3": [
		1873,
		7,
		548
	],
	"./00001/00001-02/00001-02-05/i love gray.mp3": [
		1874,
		7,
		549
	],
	"./00001/00001-02/00001-02-05/i love green.mp3": [
		1875,
		7,
		550
	],
	"./00001/00001-02/00001-02-05/i love orange.mp3": [
		1876,
		7,
		551
	],
	"./00001/00001-02/00001-02-05/i love purple.mp3": [
		1877,
		7,
		552
	],
	"./00001/00001-02/00001-02-05/i love red.mp3": [
		1878,
		7,
		553
	],
	"./00001/00001-02/00001-02-05/i love to paint.mp3": [
		1879,
		7,
		554
	],
	"./00001/00001-02/00001-02-05/intro.mp3": [
		372,
		7
	],
	"./00001/00001-02/00001-02-05/main idea.mp3": [
		753,
		7
	],
	"./00001/00001-02/00001-02-05/module": [
		1152,
		9,
		16
	],
	"./00001/00001-02/00001-02-05/module.js": [
		1152,
		9,
		16
	],
	"./00001/00001-02/00001-02-06/0.jpg": [
		6705,
		7,
		5382
	],
	"./00001/00001-02/00001-02-06/1.jpg": [
		7593,
		7,
		7616
	],
	"./00001/00001-02/00001-02-06/2.jpg": [
		7594,
		7,
		7617
	],
	"./00001/00001-02/00001-02-06/3.jpg": [
		7595,
		7,
		7618
	],
	"./00001/00001-02/00001-02-06/4.jpg": [
		7596,
		7,
		7619
	],
	"./00001/00001-02/00001-02-06/5.jpg": [
		7597,
		7,
		7620
	],
	"./00001/00001-02/00001-02-06/6.jpg": [
		7598,
		7,
		7621
	],
	"./00001/00001-02/00001-02-06/7.jpg": [
		7599,
		7,
		7622
	],
	"./00001/00001-02/00001-02-06/food.mp3": [
		1880,
		7,
		555
	],
	"./00001/00001-02/00001-02-06/intro.mp3": [
		373,
		7
	],
	"./00001/00001-02/00001-02-06/look at the alligator.mp3": [
		1881,
		7,
		556
	],
	"./00001/00001-02/00001-02-06/look at the cow.mp3": [
		1882,
		7,
		557
	],
	"./00001/00001-02/00001-02-06/look at the dog.mp3": [
		1883,
		7,
		558
	],
	"./00001/00001-02/00001-02-06/look at the gingerbread man.mp3": [
		1884,
		7,
		559
	],
	"./00001/00001-02/00001-02-06/look at the horse.mp3": [
		1885,
		7,
		560
	],
	"./00001/00001-02/00001-02-06/look at the sheep.mp3": [
		1886,
		7,
		561
	],
	"./00001/00001-02/00001-02-06/main idea.mp3": [
		754,
		7
	],
	"./00001/00001-02/00001-02-06/module": [
		1153,
		9,
		17
	],
	"./00001/00001-02/00001-02-06/module.js": [
		1153,
		9,
		17
	],
	"./00001/00001-02/00001-02-06/the gingerbread man.mp3": [
		1887,
		7,
		562
	],
	"./00001/00001-02/00001-02-07/0 little frogs sat on a log.mp3": [
		1888,
		7,
		563
	],
	"./00001/00001-02/00001-02-07/0.jpg": [
		6706,
		7,
		5383
	],
	"./00001/00001-02/00001-02-07/1 little frog sat on a log.mp3": [
		1889,
		7,
		564
	],
	"./00001/00001-02/00001-02-07/1.jpg": [
		7600,
		7,
		7623
	],
	"./00001/00001-02/00001-02-07/2 little frogs sat on a log.mp3": [
		1890,
		7,
		565
	],
	"./00001/00001-02/00001-02-07/2.jpg": [
		7601,
		7,
		7624
	],
	"./00001/00001-02/00001-02-07/3 little frogs sat on a log.mp3": [
		1891,
		7,
		566
	],
	"./00001/00001-02/00001-02-07/3.jpg": [
		7602,
		7,
		7625
	],
	"./00001/00001-02/00001-02-07/4 little frogs sat on a log.mp3": [
		1892,
		7,
		567
	],
	"./00001/00001-02/00001-02-07/4.jpg": [
		7603,
		7,
		7626
	],
	"./00001/00001-02/00001-02-07/5 little frogs sat in the pond.mp3": [
		1893,
		7,
		568
	],
	"./00001/00001-02/00001-02-07/5 little frogs sat on a log.mp3": [
		1894,
		7,
		569
	],
	"./00001/00001-02/00001-02-07/5 little frogs.mp3": [
		1895,
		7,
		570
	],
	"./00001/00001-02/00001-02-07/5.jpg": [
		7604,
		7,
		7627
	],
	"./00001/00001-02/00001-02-07/6.jpg": [
		7605,
		7,
		7628
	],
	"./00001/00001-02/00001-02-07/7.jpg": [
		7606,
		7,
		7629
	],
	"./00001/00001-02/00001-02-07/intro.mp3": [
		374,
		7
	],
	"./00001/00001-02/00001-02-07/main idea.mp3": [
		755,
		7
	],
	"./00001/00001-02/00001-02-07/module": [
		1154,
		9,
		18
	],
	"./00001/00001-02/00001-02-07/module.js": [
		1154,
		9,
		18
	],
	"./00001/00001-02/00001-02-07/water animals.mp3": [
		1896,
		7,
		571
	],
	"./00001/00001-02/00001-02-08/0.jpg": [
		6707,
		7,
		5384
	],
	"./00001/00001-02/00001-02-08/1.jpg": [
		7607,
		7,
		7630
	],
	"./00001/00001-02/00001-02-08/2.jpg": [
		7608,
		7,
		7631
	],
	"./00001/00001-02/00001-02-08/3.jpg": [
		7609,
		7,
		7632
	],
	"./00001/00001-02/00001-02-08/4.jpg": [
		7610,
		7,
		7633
	],
	"./00001/00001-02/00001-02-08/5.jpg": [
		7611,
		7,
		7634
	],
	"./00001/00001-02/00001-02-08/6.jpg": [
		7612,
		7,
		7635
	],
	"./00001/00001-02/00001-02-08/7.jpg": [
		7613,
		7,
		7636
	],
	"./00001/00001-02/00001-02-08/can i have a pet.mp3": [
		1897,
		7,
		572
	],
	"./00001/00001-02/00001-02-08/cover.idraw": [
		7614,
		7,
		5818
	],
	"./00001/00001-02/00001-02-08/intro.mp3": [
		375,
		7
	],
	"./00001/00001-02/00001-02-08/main idea.mp3": [
		756,
		7
	],
	"./00001/00001-02/00001-02-08/module": [
		1155,
		9,
		19
	],
	"./00001/00001-02/00001-02-08/module.js": [
		1155,
		9,
		19
	],
	"./00001/00001-02/00001-02-08/pets.mp3": [
		1898,
		7,
		573
	],
	"./00001/00001-02/00001-02-08/you can have a dog.mp3": [
		1899,
		7,
		574
	],
	"./00001/00001-02/00001-02-08/you can not have a crocodile.mp3": [
		1900,
		7,
		575
	],
	"./00001/00001-02/00001-02-08/you can not have a giraffe.mp3": [
		1901,
		7,
		576
	],
	"./00001/00001-02/00001-02-08/you can not have a monkey.mp3": [
		1902,
		7,
		577
	],
	"./00001/00001-02/00001-02-08/you can not have a snake.mp3": [
		1903,
		7,
		578
	],
	"./00001/00001-02/00001-02-08/you can not have an elephant.mp3": [
		1904,
		7,
		579
	],
	"./00001/00001-02/00001-02-08/you can not have an ostrich.mp3": [
		1905,
		7,
		580
	],
	"./00001/00001-02/00001-02-09/0.jpg": [
		6708,
		7,
		5385
	],
	"./00001/00001-02/00001-02-09/1.jpg": [
		7615,
		7,
		7637
	],
	"./00001/00001-02/00001-02-09/2.jpg": [
		7616,
		7,
		7638
	],
	"./00001/00001-02/00001-02-09/3.jpg": [
		7617,
		7,
		7639
	],
	"./00001/00001-02/00001-02-09/4.jpg": [
		7618,
		7,
		7640
	],
	"./00001/00001-02/00001-02-09/5.jpg": [
		7619,
		7,
		7641
	],
	"./00001/00001-02/00001-02-09/6.jpg": [
		7620,
		7,
		7642
	],
	"./00001/00001-02/00001-02-09/7.jpg": [
		7621,
		7,
		7643
	],
	"./00001/00001-02/00001-02-09/i like the horse.mp3": [
		1906,
		7,
		581
	],
	"./00001/00001-02/00001-02-09/i like the slide.mp3": [
		1907,
		7,
		582
	],
	"./00001/00001-02/00001-02-09/i like the swings.mp3": [
		1908,
		7,
		583
	],
	"./00001/00001-02/00001-02-09/intro.mp3": [
		376,
		7
	],
	"./00001/00001-02/00001-02-09/main idea.mp3": [
		757,
		7
	],
	"./00001/00001-02/00001-02-09/module": [
		1156,
		9,
		20
	],
	"./00001/00001-02/00001-02-09/module.js": [
		1156,
		9,
		20
	],
	"./00001/00001-02/00001-02-09/the playground.mp3": [
		1909,
		7,
		584
	],
	"./00001/00001-02/00001-02-09/toys.mp3": [
		1910,
		7,
		585
	],
	"./00001/00001-02/00001-02-09/we like the seesaw.mp3": [
		1911,
		7,
		586
	],
	"./00001/00001-02/00001-02-10/0.jpg": [
		6709,
		7,
		5386
	],
	"./00001/00001-02/00001-02-10/1.jpg": [
		7622,
		7,
		7644
	],
	"./00001/00001-02/00001-02-10/2.jpg": [
		7623,
		7,
		7645
	],
	"./00001/00001-02/00001-02-10/3.jpg": [
		7624,
		7,
		7646
	],
	"./00001/00001-02/00001-02-10/4.jpg": [
		7625,
		7,
		7647
	],
	"./00001/00001-02/00001-02-10/5.jpg": [
		7626,
		7,
		7648
	],
	"./00001/00001-02/00001-02-10/6.jpg": [
		7627,
		7,
		7649
	],
	"./00001/00001-02/00001-02-10/7.jpg": [
		7628,
		7,
		7650
	],
	"./00001/00001-02/00001-02-10/farm animals.mp3": [
		1912,
		7,
		587
	],
	"./00001/00001-02/00001-02-10/hello cat i like your hat.mp3": [
		1913,
		7,
		588
	],
	"./00001/00001-02/00001-02-10/hello chicken i like your hat.mp3": [
		1914,
		7,
		589
	],
	"./00001/00001-02/00001-02-10/hello cow i like your hat.mp3": [
		1915,
		7,
		590
	],
	"./00001/00001-02/00001-02-10/hello dog i like your hat.mp3": [
		1916,
		7,
		591
	],
	"./00001/00001-02/00001-02-10/hello goat i like your hat.mp3": [
		1917,
		7,
		592
	],
	"./00001/00001-02/00001-02-10/hello horse i like your hat.mp3": [
		1918,
		7,
		593
	],
	"./00001/00001-02/00001-02-10/hello sheep i like your hat.mp3": [
		1919,
		7,
		594
	],
	"./00001/00001-02/00001-02-10/intro.mp3": [
		377,
		7
	],
	"./00001/00001-02/00001-02-10/main idea.mp3": [
		758,
		7
	],
	"./00001/00001-02/00001-02-10/module": [
		1157,
		9,
		21
	],
	"./00001/00001-02/00001-02-10/module.js": [
		1157,
		9,
		21
	],
	"./00001/00001-02/00001-02-11/0.jpg": [
		6710,
		7,
		5387
	],
	"./00001/00001-02/00001-02-11/1.jpg": [
		7629,
		7,
		7651
	],
	"./00001/00001-02/00001-02-11/2.jpg": [
		7630,
		7,
		7652
	],
	"./00001/00001-02/00001-02-11/3.jpg": [
		7631,
		7,
		7653
	],
	"./00001/00001-02/00001-02-11/4.jpg": [
		7632,
		7,
		7654
	],
	"./00001/00001-02/00001-02-11/5.jpg": [
		7633,
		7,
		7655
	],
	"./00001/00001-02/00001-02-11/6.jpg": [
		7634,
		7,
		7656
	],
	"./00001/00001-02/00001-02-11/7.jpg": [
		7635,
		7,
		7657
	],
	"./00001/00001-02/00001-02-11/animals.mp3": [
		1920,
		7,
		595
	],
	"./00001/00001-02/00001-02-11/intro.mp3": [
		378,
		7
	],
	"./00001/00001-02/00001-02-11/main idea.mp3": [
		759,
		7
	],
	"./00001/00001-02/00001-02-11/module": [
		1158,
		9,
		22
	],
	"./00001/00001-02/00001-02-11/module.js": [
		1158,
		9,
		22
	],
	"./00001/00001-02/00001-02-11/the bat likes ice cream.mp3": [
		1921,
		7,
		596
	],
	"./00001/00001-02/00001-02-11/the cat likes ice cream.mp3": [
		1922,
		7,
		597
	],
	"./00001/00001-02/00001-02-11/the dog likes ice cream.mp3": [
		1923,
		7,
		598
	],
	"./00001/00001-02/00001-02-11/the elephant likes ice cream.mp3": [
		1924,
		7,
		599
	],
	"./00001/00001-02/00001-02-11/the lion likes ice cream.mp3": [
		1925,
		7,
		600
	],
	"./00001/00001-02/00001-02-11/the octopus loves ice cream.mp3": [
		1926,
		7,
		601
	],
	"./00001/00001-02/00001-02-11/the snake likes ice cream.mp3": [
		1927,
		7,
		602
	],
	"./00001/00001-02/00001-02-11/we like ice cream.mp3": [
		1928,
		7,
		603
	],
	"./00001/00001-02/cover.jpg": [
		6711,
		7,
		5388
	],
	"./00001/00001-02/story park.mp3": [
		1929,
		7,
		604
	],
	"./00001/00001-02/unit": [
		1159,
		9,
		23
	],
	"./00001/00001-02/unit.js": [
		1159,
		9,
		23
	],
	"./00001/00001-03/00001-03-01/0.jpg": [
		6712,
		7,
		5389
	],
	"./00001/00001-03/00001-03-01/1.jpg": [
		7636,
		7,
		7658
	],
	"./00001/00001-03/00001-03-01/2.jpg": [
		7637,
		7,
		7659
	],
	"./00001/00001-03/00001-03-01/3.jpg": [
		7638,
		7,
		7660
	],
	"./00001/00001-03/00001-03-01/4.jpg": [
		7639,
		7,
		7661
	],
	"./00001/00001-03/00001-03-01/5.jpg": [
		7640,
		7,
		7662
	],
	"./00001/00001-03/00001-03-01/6.jpg": [
		7641,
		7,
		7663
	],
	"./00001/00001-03/00001-03-01/7.jpg": [
		7642,
		7,
		7664
	],
	"./00001/00001-03/00001-03-01/a sea turtle lives in the sea.mp3": [
		1930,
		7,
		605
	],
	"./00001/00001-03/00001-03-01/a seahorse lives in the sea.mp3": [
		1931,
		7,
		606
	],
	"./00001/00001-03/00001-03-01/a shark lives in the sea.mp3": [
		1932,
		7,
		607
	],
	"./00001/00001-03/00001-03-01/a whale lives in the sea.mp3": [
		1933,
		7,
		608
	],
	"./00001/00001-03/00001-03-01/intro.mp3": [
		379,
		7
	],
	"./00001/00001-03/00001-03-01/main idea.mp3": [
		760,
		7
	],
	"./00001/00001-03/00001-03-01/module": [
		1160,
		9,
		24
	],
	"./00001/00001-03/00001-03-01/module.js": [
		1160,
		9,
		24
	],
	"./00001/00001-03/00001-03-01/sea animals.mp3": [
		1934,
		7,
		609
	],
	"./00001/00001-03/00001-03-01/the crab lives in the sea.mp3": [
		1935,
		7,
		610
	],
	"./00001/00001-03/00001-03-01/the dolphin lives in the sea.mp3": [
		1936,
		7,
		611
	],
	"./00001/00001-03/00001-03-01/the octopus lives in the sea.mp3": [
		1937,
		7,
		612
	],
	"./00001/00001-03/00001-03-02/0.jpg": [
		6713,
		7,
		5390
	],
	"./00001/00001-03/00001-03-02/1.jpg": [
		7643,
		7,
		7665
	],
	"./00001/00001-03/00001-03-02/2.jpg": [
		7644,
		7,
		7666
	],
	"./00001/00001-03/00001-03-02/3.jpg": [
		7645,
		7,
		7667
	],
	"./00001/00001-03/00001-03-02/4.jpg": [
		7646,
		7,
		7668
	],
	"./00001/00001-03/00001-03-02/5.jpg": [
		7647,
		7,
		7669
	],
	"./00001/00001-03/00001-03-02/6.jpg": [
		7648,
		7,
		7670
	],
	"./00001/00001-03/00001-03-02/7.jpg": [
		7649,
		7,
		7671
	],
	"./00001/00001-03/00001-03-02/intro.mp3": [
		380,
		7
	],
	"./00001/00001-03/00001-03-02/look at the beaver.mp3": [
		1938,
		7,
		613
	],
	"./00001/00001-03/00001-03-02/look at the dragonfly.mp3": [
		1939,
		7,
		614
	],
	"./00001/00001-03/00001-03-02/look at the duck.mp3": [
		1940,
		7,
		615
	],
	"./00001/00001-03/00001-03-02/look at the frog.mp3": [
		1941,
		7,
		616
	],
	"./00001/00001-03/00001-03-02/look at the salamander.mp3": [
		1942,
		7,
		617
	],
	"./00001/00001-03/00001-03-02/look at the toad.mp3": [
		1943,
		7,
		618
	],
	"./00001/00001-03/00001-03-02/look at the turtle.mp3": [
		1944,
		7,
		619
	],
	"./00001/00001-03/00001-03-02/main idea.mp3": [
		761,
		7
	],
	"./00001/00001-03/00001-03-02/module": [
		1161,
		9,
		25
	],
	"./00001/00001-03/00001-03-02/module.js": [
		1161,
		9,
		25
	],
	"./00001/00001-03/00001-03-02/pond animals.mp3": [
		1945,
		7,
		620
	],
	"./00001/00001-03/00001-03-03/0.jpg": [
		6714,
		7,
		5391
	],
	"./00001/00001-03/00001-03-03/1.jpg": [
		7650,
		7,
		7672
	],
	"./00001/00001-03/00001-03-03/2.jpg": [
		7651,
		7,
		7673
	],
	"./00001/00001-03/00001-03-03/3.jpg": [
		7652,
		7,
		7674
	],
	"./00001/00001-03/00001-03-03/4.jpg": [
		7653,
		7,
		7675
	],
	"./00001/00001-03/00001-03-03/5.jpg": [
		7654,
		7,
		7676
	],
	"./00001/00001-03/00001-03-03/6.jpg": [
		7655,
		7,
		7677
	],
	"./00001/00001-03/00001-03-03/7.jpg": [
		7656,
		7,
		7678
	],
	"./00001/00001-03/00001-03-03/i am a giraffe.mp3": [
		1946,
		7,
		621
	],
	"./00001/00001-03/00001-03-03/i am a hippo.mp3": [
		1947,
		7,
		622
	],
	"./00001/00001-03/00001-03-03/i am a lion.mp3": [
		1948,
		7,
		623
	],
	"./00001/00001-03/00001-03-03/i am a rhino.mp3": [
		1949,
		7,
		624
	],
	"./00001/00001-03/00001-03-03/i am a tiger.mp3": [
		1950,
		7,
		625
	],
	"./00001/00001-03/00001-03-03/i am a zebra.mp3": [
		1951,
		7,
		626
	],
	"./00001/00001-03/00001-03-03/intro.mp3": [
		381,
		7
	],
	"./00001/00001-03/00001-03-03/main idea.mp3": [
		762,
		7
	],
	"./00001/00001-03/00001-03-03/module": [
		1162,
		9,
		26
	],
	"./00001/00001-03/00001-03-03/module.js": [
		1162,
		9,
		26
	],
	"./00001/00001-03/00001-03-03/we are kangaroos.mp3": [
		1952,
		7,
		627
	],
	"./00001/00001-03/00001-03-03/wild animals.mp3": [
		1953,
		7,
		628
	],
	"./00001/00001-03/00001-03-04/0.jpg": [
		6715,
		7,
		5392
	],
	"./00001/00001-03/00001-03-04/1.jpg": [
		7657,
		7,
		7679
	],
	"./00001/00001-03/00001-03-04/2.jpg": [
		7658,
		7,
		7680
	],
	"./00001/00001-03/00001-03-04/3.jpg": [
		7659,
		7,
		7681
	],
	"./00001/00001-03/00001-03-04/4.jpg": [
		7660,
		7,
		7682
	],
	"./00001/00001-03/00001-03-04/5.jpg": [
		7661,
		7,
		7683
	],
	"./00001/00001-03/00001-03-04/6.jpg": [
		7662,
		7,
		7684
	],
	"./00001/00001-03/00001-03-04/7.jpg": [
		7663,
		7,
		7685
	],
	"./00001/00001-03/00001-03-04/i love my cat.mp3": [
		1954,
		7,
		629
	],
	"./00001/00001-03/00001-03-04/i love my dinosaur.mp3": [
		1955,
		7,
		630
	],
	"./00001/00001-03/00001-03-04/i love my dog.mp3": [
		1956,
		7,
		631
	],
	"./00001/00001-03/00001-03-04/i love my fish.mp3": [
		1957,
		7,
		632
	],
	"./00001/00001-03/00001-03-04/i love my rabbit.mp3": [
		1958,
		7,
		633
	],
	"./00001/00001-03/00001-03-04/i love my snake.mp3": [
		1959,
		7,
		634
	],
	"./00001/00001-03/00001-03-04/i love my turtle.mp3": [
		1960,
		7,
		635
	],
	"./00001/00001-03/00001-03-04/intro.mp3": [
		382,
		7
	],
	"./00001/00001-03/00001-03-04/main idea.mp3": [
		763,
		7
	],
	"./00001/00001-03/00001-03-04/module": [
		1163,
		9,
		27
	],
	"./00001/00001-03/00001-03-04/module.js": [
		1163,
		9,
		27
	],
	"./00001/00001-03/00001-03-04/pets.mp3": [
		1961,
		7,
		636
	],
	"./00001/00001-03/00001-03-05/0.jpg": [
		6716,
		7,
		5393
	],
	"./00001/00001-03/00001-03-05/1.jpg": [
		7664,
		7,
		7686
	],
	"./00001/00001-03/00001-03-05/2.jpg": [
		7665,
		7,
		7687
	],
	"./00001/00001-03/00001-03-05/3.jpg": [
		7666,
		7,
		7688
	],
	"./00001/00001-03/00001-03-05/4.jpg": [
		7667,
		7,
		7689
	],
	"./00001/00001-03/00001-03-05/5.jpg": [
		7668,
		7,
		7690
	],
	"./00001/00001-03/00001-03-05/6.jpg": [
		7669,
		7,
		7691
	],
	"./00001/00001-03/00001-03-05/7.jpg": [
		7670,
		7,
		7692
	],
	"./00001/00001-03/00001-03-05/forest animals.mp3": [
		1962,
		7,
		637
	],
	"./00001/00001-03/00001-03-05/i see a bear.mp3": [
		1963,
		7,
		638
	],
	"./00001/00001-03/00001-03-05/i see a bird.mp3": [
		1964,
		7,
		639
	],
	"./00001/00001-03/00001-03-05/i see a deer.mp3": [
		1965,
		7,
		640
	],
	"./00001/00001-03/00001-03-05/i see a fox.mp3": [
		1966,
		7,
		641
	],
	"./00001/00001-03/00001-03-05/i see a hedgehog.mp3": [
		1967,
		7,
		642
	],
	"./00001/00001-03/00001-03-05/i see a rabbit.mp3": [
		1968,
		7,
		643
	],
	"./00001/00001-03/00001-03-05/i see a squirrel.mp3": [
		1969,
		7,
		644
	],
	"./00001/00001-03/00001-03-05/intro.mp3": [
		383,
		7
	],
	"./00001/00001-03/00001-03-05/main idea.mp3": [
		764,
		7
	],
	"./00001/00001-03/00001-03-05/module": [
		1164,
		9,
		28
	],
	"./00001/00001-03/00001-03-05/module.js": [
		1164,
		9,
		28
	],
	"./00001/00001-03/00001-03-06/0.jpg": [
		6717,
		7,
		5394
	],
	"./00001/00001-03/00001-03-06/1.jpg": [
		7671,
		7,
		7693
	],
	"./00001/00001-03/00001-03-06/2.jpg": [
		7672,
		7,
		7694
	],
	"./00001/00001-03/00001-03-06/3.jpg": [
		7673,
		7,
		7695
	],
	"./00001/00001-03/00001-03-06/4.jpg": [
		7674,
		7,
		7696
	],
	"./00001/00001-03/00001-03-06/5.jpg": [
		7675,
		7,
		7697
	],
	"./00001/00001-03/00001-03-06/6.jpg": [
		7676,
		7,
		7698
	],
	"./00001/00001-03/00001-03-06/7.jpg": [
		7677,
		7,
		7699
	],
	"./00001/00001-03/00001-03-06/farm animals.mp3": [
		1970,
		7,
		645
	],
	"./00001/00001-03/00001-03-06/here is a chicken.mp3": [
		1971,
		7,
		646
	],
	"./00001/00001-03/00001-03-06/here is a cow.mp3": [
		1972,
		7,
		647
	],
	"./00001/00001-03/00001-03-06/here is a donkey.mp3": [
		1973,
		7,
		648
	],
	"./00001/00001-03/00001-03-06/here is a goat.mp3": [
		1974,
		7,
		649
	],
	"./00001/00001-03/00001-03-06/here is a horse.mp3": [
		1975,
		7,
		650
	],
	"./00001/00001-03/00001-03-06/here is a pig.mp3": [
		1976,
		7,
		651
	],
	"./00001/00001-03/00001-03-06/here is a sheep.mp3": [
		1977,
		7,
		652
	],
	"./00001/00001-03/00001-03-06/intro.mp3": [
		384,
		7
	],
	"./00001/00001-03/00001-03-06/main idea.mp3": [
		765,
		7
	],
	"./00001/00001-03/00001-03-06/module": [
		1165,
		9,
		29
	],
	"./00001/00001-03/00001-03-06/module.js": [
		1165,
		9,
		29
	],
	"./00001/00001-03/00001-03-07/0.jpg": [
		6718,
		7,
		5395
	],
	"./00001/00001-03/00001-03-07/1.jpg": [
		7678,
		7,
		7700
	],
	"./00001/00001-03/00001-03-07/2.jpg": [
		7679,
		7,
		7701
	],
	"./00001/00001-03/00001-03-07/3.jpg": [
		7680,
		7,
		7702
	],
	"./00001/00001-03/00001-03-07/4.jpg": [
		7681,
		7,
		7703
	],
	"./00001/00001-03/00001-03-07/5.jpg": [
		7682,
		7,
		7704
	],
	"./00001/00001-03/00001-03-07/6.jpg": [
		7683,
		7,
		7705
	],
	"./00001/00001-03/00001-03-07/7.jpg": [
		7684,
		7,
		7706
	],
	"./00001/00001-03/00001-03-07/animals that live in the snow.mp3": [
		1978,
		7,
		653
	],
	"./00001/00001-03/00001-03-07/arctic animals.mp3": [
		1979,
		7,
		654
	],
	"./00001/00001-03/00001-03-07/intro.mp3": [
		385,
		7
	],
	"./00001/00001-03/00001-03-07/main idea.mp3": [
		766,
		7
	],
	"./00001/00001-03/00001-03-07/module": [
		1166,
		9,
		30
	],
	"./00001/00001-03/00001-03-07/module.js": [
		1166,
		9,
		30
	],
	"./00001/00001-03/00001-03-07/the bird is white.mp3": [
		1980,
		7,
		655
	],
	"./00001/00001-03/00001-03-07/the fox is white.mp3": [
		1981,
		7,
		656
	],
	"./00001/00001-03/00001-03-07/the owl is white.mp3": [
		1982,
		7,
		657
	],
	"./00001/00001-03/00001-03-07/the polar bear is white.mp3": [
		1983,
		7,
		658
	],
	"./00001/00001-03/00001-03-07/the rabbit is white.mp3": [
		1984,
		7,
		659
	],
	"./00001/00001-03/00001-03-07/the seal is white.mp3": [
		1985,
		7,
		660
	],
	"./00001/00001-03/00001-03-07/the wolf is white.mp3": [
		1986,
		7,
		661
	],
	"./00001/00001-03/00001-03-08/0.jpg": [
		6719,
		7,
		5396
	],
	"./00001/00001-03/00001-03-08/1.jpg": [
		7685,
		7,
		7707
	],
	"./00001/00001-03/00001-03-08/2.jpg": [
		7686,
		7,
		7708
	],
	"./00001/00001-03/00001-03-08/3.jpg": [
		7687,
		7,
		7709
	],
	"./00001/00001-03/00001-03-08/4.jpg": [
		7688,
		7,
		7710
	],
	"./00001/00001-03/00001-03-08/5.jpg": [
		7689,
		7,
		7711
	],
	"./00001/00001-03/00001-03-08/6.jpg": [
		7690,
		7,
		7712
	],
	"./00001/00001-03/00001-03-08/7.jpg": [
		7691,
		7,
		7713
	],
	"./00001/00001-03/00001-03-08/desert animals.mp3": [
		1987,
		7,
		662
	],
	"./00001/00001-03/00001-03-08/i am a bighorn sheep.mp3": [
		1988,
		7,
		663
	],
	"./00001/00001-03/00001-03-08/i am a camel.mp3": [
		1989,
		7,
		664
	],
	"./00001/00001-03/00001-03-08/i am a fox.mp3": [
		1990,
		7,
		665
	],
	"./00001/00001-03/00001-03-08/i am a rabbit.mp3": [
		1991,
		7,
		666
	],
	"./00001/00001-03/00001-03-08/i am a snake.mp3": [
		1992,
		7,
		667
	],
	"./00001/00001-03/00001-03-08/i am a spider.mp3": [
		1993,
		7,
		668
	],
	"./00001/00001-03/00001-03-08/i am an iguana.mp3": [
		1994,
		7,
		669
	],
	"./00001/00001-03/00001-03-08/i live in the desert.mp3": [
		1995,
		7,
		670
	],
	"./00001/00001-03/00001-03-08/intro.mp3": [
		386,
		7
	],
	"./00001/00001-03/00001-03-08/main idea.mp3": [
		767,
		7
	],
	"./00001/00001-03/00001-03-08/module": [
		1167,
		9,
		31
	],
	"./00001/00001-03/00001-03-08/module.js": [
		1167,
		9,
		31
	],
	"./00001/00001-03/00001-03-09/0.jpg": [
		6720,
		7,
		5397
	],
	"./00001/00001-03/00001-03-09/1.jpg": [
		7692,
		7,
		7714
	],
	"./00001/00001-03/00001-03-09/2.jpg": [
		7693,
		7,
		7715
	],
	"./00001/00001-03/00001-03-09/3.jpg": [
		7694,
		7,
		7716
	],
	"./00001/00001-03/00001-03-09/4.jpg": [
		7695,
		7,
		7717
	],
	"./00001/00001-03/00001-03-09/5.jpg": [
		7696,
		7,
		7718
	],
	"./00001/00001-03/00001-03-09/6.jpg": [
		7697,
		7,
		7719
	],
	"./00001/00001-03/00001-03-09/7.jpg": [
		7698,
		7,
		7720
	],
	"./00001/00001-03/00001-03-09/i am a butterfly.mp3": [
		1996,
		7,
		671
	],
	"./00001/00001-03/00001-03-09/i am a frog.mp3": [
		1997,
		7,
		672
	],
	"./00001/00001-03/00001-03-09/i am a jaguar.mp3": [
		1998,
		7,
		673
	],
	"./00001/00001-03/00001-03-09/i am a monket.mp3": [
		1999,
		7,
		674
	],
	"./00001/00001-03/00001-03-09/i am a monkey.mp3": [
		2000,
		7,
		675
	],
	"./00001/00001-03/00001-03-09/i am a parrot.mp3": [
		2001,
		7,
		676
	],
	"./00001/00001-03/00001-03-09/i am a snake.mp3": [
		2002,
		7,
		677
	],
	"./00001/00001-03/00001-03-09/i am a toucan.mp3": [
		2003,
		7,
		678
	],
	"./00001/00001-03/00001-03-09/i live in the rainforest.mp3": [
		2004,
		7,
		679
	],
	"./00001/00001-03/00001-03-09/intro.mp3": [
		387,
		7
	],
	"./00001/00001-03/00001-03-09/main idea.mp3": [
		768,
		7
	],
	"./00001/00001-03/00001-03-09/module": [
		1168,
		9,
		32
	],
	"./00001/00001-03/00001-03-09/module.js": [
		1168,
		9,
		32
	],
	"./00001/00001-03/00001-03-09/rainforest animals.mp3": [
		2005,
		7,
		680
	],
	"./00001/00001-03/00001-03-10/0.jpg": [
		6721,
		7,
		5398
	],
	"./00001/00001-03/00001-03-10/1.jpg": [
		7699,
		7,
		7721
	],
	"./00001/00001-03/00001-03-10/2.jpg": [
		7700,
		7,
		7722
	],
	"./00001/00001-03/00001-03-10/3.jpg": [
		7701,
		7,
		7723
	],
	"./00001/00001-03/00001-03-10/4.jpg": [
		7702,
		7,
		7724
	],
	"./00001/00001-03/00001-03-10/5.jpg": [
		7703,
		7,
		7725
	],
	"./00001/00001-03/00001-03-10/6.jpg": [
		7704,
		7,
		7726
	],
	"./00001/00001-03/00001-03-10/7.jpg": [
		7705,
		7,
		7727
	],
	"./00001/00001-03/00001-03-10/i am a cat.mp3": [
		2006,
		7,
		681
	],
	"./00001/00001-03/00001-03-10/i am a dog.mp3": [
		2007,
		7,
		682
	],
	"./00001/00001-03/00001-03-10/i am a horse.mp3": [
		2008,
		7,
		683
	],
	"./00001/00001-03/00001-03-10/i am a lion.mp3": [
		2009,
		7,
		684
	],
	"./00001/00001-03/00001-03-10/i am a parrot.mp3": [
		2010,
		7,
		685
	],
	"./00001/00001-03/00001-03-10/i am a zebra.mp3": [
		2011,
		7,
		686
	],
	"./00001/00001-03/00001-03-10/i am an owl.mp3": [
		2012,
		7,
		687
	],
	"./00001/00001-03/00001-03-10/i am wild.mp3": [
		2013,
		7,
		688
	],
	"./00001/00001-03/00001-03-10/intro.mp3": [
		388,
		7
	],
	"./00001/00001-03/00001-03-10/main idea.mp3": [
		769,
		7
	],
	"./00001/00001-03/00001-03-10/module": [
		1169,
		9,
		33
	],
	"./00001/00001-03/00001-03-10/module.js": [
		1169,
		9,
		33
	],
	"./00001/00001-03/00001-03-10/wild animals.mp3": [
		2014,
		7,
		689
	],
	"./00001/00001-03/00001-03-10/wild or tame.mp3": [
		2015,
		7,
		690
	],
	"./00001/00001-03/animal park.mp3": [
		2016,
		7,
		691
	],
	"./00001/00001-03/animals.mp3": [
		2017,
		7,
		692
	],
	"./00001/00001-03/cover.jpg": [
		6722,
		7,
		5399
	],
	"./00001/00001-03/unit": [
		1170,
		9,
		34
	],
	"./00001/00001-03/unit.js": [
		1170,
		9,
		34
	],
	"./00001/00001-04/00001-04-01/0.jpg": [
		6723,
		7,
		5400
	],
	"./00001/00001-04/00001-04-01/1.jpg": [
		7706,
		7,
		7728
	],
	"./00001/00001-04/00001-04-01/2.jpg": [
		7707,
		7,
		7729
	],
	"./00001/00001-04/00001-04-01/3.jpg": [
		7708,
		7,
		7730
	],
	"./00001/00001-04/00001-04-01/4.jpg": [
		7709,
		7,
		7731
	],
	"./00001/00001-04/00001-04-01/5.jpg": [
		7710,
		7,
		7732
	],
	"./00001/00001-04/00001-04-01/6.jpg": [
		7711,
		7,
		7733
	],
	"./00001/00001-04/00001-04-01/7.jpg": [
		7712,
		7,
		7734
	],
	"./00001/00001-04/00001-04-01/animals.mp3": [
		2018,
		7,
		693
	],
	"./00001/00001-04/00001-04-01/i see 1 box.mp3": [
		2019,
		7,
		694
	],
	"./00001/00001-04/00001-04-01/i see 1 cat.mp3": [
		2020,
		7,
		695
	],
	"./00001/00001-04/00001-04-01/i see 1 fox.mp3": [
		2021,
		7,
		696
	],
	"./00001/00001-04/00001-04-01/i see 1 hat.mp3": [
		2022,
		7,
		697
	],
	"./00001/00001-04/00001-04-01/i see 1 house.mp3": [
		2023,
		7,
		698
	],
	"./00001/00001-04/00001-04-01/i see 1 mouse.mp3": [
		2024,
		7,
		699
	],
	"./00001/00001-04/00001-04-01/i see 1 sun.mp3": [
		2025,
		7,
		700
	],
	"./00001/00001-04/00001-04-01/intro.mp3": [
		389,
		7
	],
	"./00001/00001-04/00001-04-01/main idea.mp3": [
		770,
		7
	],
	"./00001/00001-04/00001-04-01/module": [
		1171,
		9,
		35
	],
	"./00001/00001-04/00001-04-01/module.js": [
		1171,
		9,
		35
	],
	"./00001/00001-04/00001-04-01/my book of one.mp3": [
		2026,
		7,
		701
	],
	"./00001/00001-04/00001-04-02/0.jpg": [
		6724,
		7,
		5401
	],
	"./00001/00001-04/00001-04-02/1.jpg": [
		7713,
		7,
		7735
	],
	"./00001/00001-04/00001-04-02/2.jpg": [
		7714,
		7,
		7736
	],
	"./00001/00001-04/00001-04-02/3.jpg": [
		7715,
		7,
		7737
	],
	"./00001/00001-04/00001-04-02/4.jpg": [
		7716,
		7,
		7738
	],
	"./00001/00001-04/00001-04-02/5.jpg": [
		7717,
		7,
		7739
	],
	"./00001/00001-04/00001-04-02/6.jpg": [
		7718,
		7,
		7740
	],
	"./00001/00001-04/00001-04-02/7.jpg": [
		7719,
		7,
		7741
	],
	"./00001/00001-04/00001-04-02/animals with two legs.mp3": [
		2027,
		7,
		702
	],
	"./00001/00001-04/00001-04-02/i have 2 ears.mp3": [
		2028,
		7,
		703
	],
	"./00001/00001-04/00001-04-02/i have 2 eyes.mp3": [
		2029,
		7,
		704
	],
	"./00001/00001-04/00001-04-02/i have 2 horns.mp3": [
		2030,
		7,
		705
	],
	"./00001/00001-04/00001-04-02/i have 2 humps.mp3": [
		2031,
		7,
		706
	],
	"./00001/00001-04/00001-04-02/i have 2 legs.mp3": [
		2032,
		7,
		707
	],
	"./00001/00001-04/00001-04-02/i have 2 tusks.mp3": [
		2033,
		7,
		708
	],
	"./00001/00001-04/00001-04-02/i have 2 wings.mp3": [
		2034,
		7,
		709
	],
	"./00001/00001-04/00001-04-02/intro.mp3": [
		390,
		7
	],
	"./00001/00001-04/00001-04-02/main idea.mp3": [
		771,
		7
	],
	"./00001/00001-04/00001-04-02/module": [
		1172,
		9,
		36
	],
	"./00001/00001-04/00001-04-02/module.js": [
		1172,
		9,
		36
	],
	"./00001/00001-04/00001-04-02/my book of two.mp3": [
		2035,
		7,
		710
	],
	"./00001/00001-04/00001-04-03/0.jpg": [
		6725,
		7,
		5402
	],
	"./00001/00001-04/00001-04-03/1.jpg": [
		7720,
		7,
		7742
	],
	"./00001/00001-04/00001-04-03/2.jpg": [
		7721,
		7,
		7743
	],
	"./00001/00001-04/00001-04-03/3.jpg": [
		7722,
		7,
		7744
	],
	"./00001/00001-04/00001-04-03/4.jpg": [
		7723,
		7,
		7745
	],
	"./00001/00001-04/00001-04-03/5.jpg": [
		7724,
		7,
		7746
	],
	"./00001/00001-04/00001-04-03/6.jpg": [
		7725,
		7,
		7747
	],
	"./00001/00001-04/00001-04-03/7.jpg": [
		7726,
		7,
		7748
	],
	"./00001/00001-04/00001-04-03/animals with four legs.mp3": [
		2036,
		7,
		711
	],
	"./00001/00001-04/00001-04-03/can you see 3 dogs.mp3": [
		2037,
		7,
		712
	],
	"./00001/00001-04/00001-04-03/can you see 3 frogs.mp3": [
		2038,
		7,
		713
	],
	"./00001/00001-04/00001-04-03/can you see 3 hats.mp3": [
		2039,
		7,
		714
	],
	"./00001/00001-04/00001-04-03/can you see 3 kittens.mp3": [
		2040,
		7,
		715
	],
	"./00001/00001-04/00001-04-03/can you see 3 mittens.mp3": [
		2041,
		7,
		716
	],
	"./00001/00001-04/00001-04-03/can you see 3 rats.mp3": [
		2042,
		7,
		717
	],
	"./00001/00001-04/00001-04-03/can you see 3 trees.mp3": [
		2043,
		7,
		718
	],
	"./00001/00001-04/00001-04-03/intro.mp3": [
		391,
		7
	],
	"./00001/00001-04/00001-04-03/main idea.mp3": [
		772,
		7
	],
	"./00001/00001-04/00001-04-03/module": [
		1173,
		9,
		37
	],
	"./00001/00001-04/00001-04-03/module.js": [
		1173,
		9,
		37
	],
	"./00001/00001-04/00001-04-03/my book of three.mp3": [
		2044,
		7,
		719
	],
	"./00001/00001-04/00001-04-04/0.jpg": [
		6726,
		7,
		5403
	],
	"./00001/00001-04/00001-04-04/1.jpg": [
		7727,
		7,
		7749
	],
	"./00001/00001-04/00001-04-04/2.jpg": [
		7728,
		7,
		7750
	],
	"./00001/00001-04/00001-04-04/3.jpg": [
		7729,
		7,
		7751
	],
	"./00001/00001-04/00001-04-04/4.jpg": [
		7730,
		7,
		7752
	],
	"./00001/00001-04/00001-04-04/5.jpg": [
		7731,
		7,
		7753
	],
	"./00001/00001-04/00001-04-04/6.jpg": [
		7732,
		7,
		7754
	],
	"./00001/00001-04/00001-04-04/7.jpg": [
		7733,
		7,
		7755
	],
	"./00001/00001-04/00001-04-04/here come 4 boats.mp3": [
		2045,
		7,
		720
	],
	"./00001/00001-04/00001-04-04/here come 4 cars.mp3": [
		2046,
		7,
		721
	],
	"./00001/00001-04/00001-04-04/here come 4 fire trucks.mp3": [
		2047,
		7,
		722
	],
	"./00001/00001-04/00001-04-04/here come 4 helicopters.mp3": [
		2048,
		7,
		723
	],
	"./00001/00001-04/00001-04-04/here come 4 planes.mp3": [
		2049,
		7,
		724
	],
	"./00001/00001-04/00001-04-04/here come 4 rockets.mp3": [
		2050,
		7,
		725
	],
	"./00001/00001-04/00001-04-04/here come 4 trucks.mp3": [
		2051,
		7,
		726
	],
	"./00001/00001-04/00001-04-04/intro.mp3": [
		392,
		7
	],
	"./00001/00001-04/00001-04-04/main idea.mp3": [
		773,
		7
	],
	"./00001/00001-04/00001-04-04/module": [
		1174,
		9,
		38
	],
	"./00001/00001-04/00001-04-04/module.js": [
		1174,
		9,
		38
	],
	"./00001/00001-04/00001-04-04/my book of four.mp3": [
		2052,
		7,
		727
	],
	"./00001/00001-04/00001-04-04/vehicles.mp3": [
		2053,
		7,
		728
	],
	"./00001/00001-04/00001-04-05/0.jpg": [
		6727,
		7,
		5404
	],
	"./00001/00001-04/00001-04-05/1.jpg": [
		7734,
		7,
		7756
	],
	"./00001/00001-04/00001-04-05/2.jpg": [
		7735,
		7,
		7757
	],
	"./00001/00001-04/00001-04-05/3.jpg": [
		7736,
		7,
		7758
	],
	"./00001/00001-04/00001-04-05/4.jpg": [
		7737,
		7,
		7759
	],
	"./00001/00001-04/00001-04-05/5.jpg": [
		7738,
		7,
		7760
	],
	"./00001/00001-04/00001-04-05/6.jpg": [
		7739,
		7,
		7761
	],
	"./00001/00001-04/00001-04-05/7.jpg": [
		7740,
		7,
		7762
	],
	"./00001/00001-04/00001-04-05/farm animals.mp3": [
		2054,
		7,
		729
	],
	"./00001/00001-04/00001-04-05/i can see 5 animals on the farm.mp3": [
		2055,
		7,
		730
	],
	"./00001/00001-04/00001-04-05/i can see 5 animals.mp3": [
		2056,
		7,
		731
	],
	"./00001/00001-04/00001-04-05/i can see 5 chickens.mp3": [
		2057,
		7,
		732
	],
	"./00001/00001-04/00001-04-05/i can see 5 cows.mp3": [
		2058,
		7,
		733
	],
	"./00001/00001-04/00001-04-05/i can see 5 goats.mp3": [
		2059,
		7,
		734
	],
	"./00001/00001-04/00001-04-05/i can see 5 horses.mp3": [
		2060,
		7,
		735
	],
	"./00001/00001-04/00001-04-05/i can see 5 rabbits.mp3": [
		2061,
		7,
		736
	],
	"./00001/00001-04/00001-04-05/i can see 5 sheep.mp3": [
		2062,
		7,
		737
	],
	"./00001/00001-04/00001-04-05/intro.mp3": [
		393,
		7
	],
	"./00001/00001-04/00001-04-05/main idea.mp3": [
		774,
		7
	],
	"./00001/00001-04/00001-04-05/module": [
		1175,
		9,
		39
	],
	"./00001/00001-04/00001-04-05/module.js": [
		1175,
		9,
		39
	],
	"./00001/00001-04/00001-04-05/my book of five.mp3": [
		2063,
		7,
		738
	],
	"./00001/00001-04/00001-04-06/0.jpg": [
		6728,
		7,
		5405
	],
	"./00001/00001-04/00001-04-06/1.jpg": [
		7741,
		7,
		7763
	],
	"./00001/00001-04/00001-04-06/2.jpg": [
		7742,
		7,
		7764
	],
	"./00001/00001-04/00001-04-06/3.jpg": [
		7743,
		7,
		7765
	],
	"./00001/00001-04/00001-04-06/4.jpg": [
		7744,
		7,
		7766
	],
	"./00001/00001-04/00001-04-06/5.jpg": [
		7745,
		7,
		7767
	],
	"./00001/00001-04/00001-04-06/6.jpg": [
		7746,
		7,
		7768
	],
	"./00001/00001-04/00001-04-06/7.jpg": [
		7747,
		7,
		7769
	],
	"./00001/00001-04/00001-04-06/can you see 6 birds.mp3": [
		2064,
		7,
		739
	],
	"./00001/00001-04/00001-04-06/can you see 6 cats.mp3": [
		2065,
		7,
		740
	],
	"./00001/00001-04/00001-04-06/can you see 6 dogs.mp3": [
		2066,
		7,
		741
	],
	"./00001/00001-04/00001-04-06/can you see 6 fish.mp3": [
		2067,
		7,
		742
	],
	"./00001/00001-04/00001-04-06/can you see 6 pets.mp3": [
		2068,
		7,
		743
	],
	"./00001/00001-04/00001-04-06/can you see 6 snakes.mp3": [
		2069,
		7,
		744
	],
	"./00001/00001-04/00001-04-06/can you see 6 turtles.mp3": [
		2070,
		7,
		745
	],
	"./00001/00001-04/00001-04-06/intro.mp3": [
		394,
		7
	],
	"./00001/00001-04/00001-04-06/main idea.mp3": [
		775,
		7
	],
	"./00001/00001-04/00001-04-06/module": [
		1176,
		9,
		40
	],
	"./00001/00001-04/00001-04-06/module.js": [
		1176,
		9,
		40
	],
	"./00001/00001-04/00001-04-06/my book of six.mp3": [
		2071,
		7,
		746
	],
	"./00001/00001-04/00001-04-06/pet animals.mp3": [
		2072,
		7,
		747
	],
	"./00001/00001-04/00001-04-07/0.jpg": [
		6729,
		7,
		5406
	],
	"./00001/00001-04/00001-04-07/1.jpg": [
		7748,
		7,
		7770
	],
	"./00001/00001-04/00001-04-07/2.jpg": [
		7749,
		7,
		7771
	],
	"./00001/00001-04/00001-04-07/3.jpg": [
		7750,
		7,
		7772
	],
	"./00001/00001-04/00001-04-07/4.jpg": [
		7751,
		7,
		7773
	],
	"./00001/00001-04/00001-04-07/5.jpg": [
		7752,
		7,
		7774
	],
	"./00001/00001-04/00001-04-07/6.jpg": [
		7753,
		7,
		7775
	],
	"./00001/00001-04/00001-04-07/7.jpg": [
		7754,
		7,
		7776
	],
	"./00001/00001-04/00001-04-07/intro.mp3": [
		395,
		7
	],
	"./00001/00001-04/00001-04-07/main idea.mp3": [
		776,
		7
	],
	"./00001/00001-04/00001-04-07/module": [
		1177,
		9,
		41
	],
	"./00001/00001-04/00001-04-07/module.js": [
		1177,
		9,
		41
	],
	"./00001/00001-04/00001-04-07/my book of seven.mp3": [
		2073,
		7,
		748
	],
	"./00001/00001-04/00001-04-07/sea animals.mp3": [
		2074,
		7,
		749
	],
	"./00001/00001-04/00001-04-07/you can count 7 animals in the sea.mp3": [
		2075,
		7,
		750
	],
	"./00001/00001-04/00001-04-07/you can count 7 penguins.mp3": [
		2076,
		7,
		751
	],
	"./00001/00001-04/00001-04-07/you can count 7 sea turtles.mp3": [
		2077,
		7,
		752
	],
	"./00001/00001-04/00001-04-07/you can count 7 seahorses.mp3": [
		2078,
		7,
		753
	],
	"./00001/00001-04/00001-04-07/you can count 7 sharks.mp3": [
		2079,
		7,
		754
	],
	"./00001/00001-04/00001-04-07/you can count 7 swordfish.mp3": [
		2080,
		7,
		755
	],
	"./00001/00001-04/00001-04-07/you can count 7 whales.mp3": [
		2081,
		7,
		756
	],
	"./00001/00001-04/00001-04-07/you can count to 7.mp3": [
		2082,
		7,
		757
	],
	"./00001/00001-04/00001-04-08/0.jpg": [
		6730,
		7,
		5407
	],
	"./00001/00001-04/00001-04-08/1.jpg": [
		7755,
		7,
		7777
	],
	"./00001/00001-04/00001-04-08/2.jpg": [
		7756,
		7,
		7778
	],
	"./00001/00001-04/00001-04-08/3.jpg": [
		7757,
		7,
		7779
	],
	"./00001/00001-04/00001-04-08/4.jpg": [
		7758,
		7,
		7780
	],
	"./00001/00001-04/00001-04-08/5.jpg": [
		7759,
		7,
		7781
	],
	"./00001/00001-04/00001-04-08/6.jpg": [
		7760,
		7,
		7782
	],
	"./00001/00001-04/00001-04-08/7.jpg": [
		7761,
		7,
		7783
	],
	"./00001/00001-04/00001-04-08/can you count 8 astronauts.mp3": [
		2083,
		7,
		758
	],
	"./00001/00001-04/00001-04-08/can you count 8 planets.mp3": [
		2084,
		7,
		759
	],
	"./00001/00001-04/00001-04-08/can you count 8 rockets.mp3": [
		2085,
		7,
		760
	],
	"./00001/00001-04/00001-04-08/can you count 8 satellites.mp3": [
		2086,
		7,
		761
	],
	"./00001/00001-04/00001-04-08/can you count 8 spaceships.mp3": [
		2087,
		7,
		762
	],
	"./00001/00001-04/00001-04-08/can you count 8 stars.mp3": [
		2088,
		7,
		763
	],
	"./00001/00001-04/00001-04-08/can you count 8 things up in space.mp3": [
		2089,
		7,
		764
	],
	"./00001/00001-04/00001-04-08/can you count to 8.mp3": [
		2090,
		7,
		765
	],
	"./00001/00001-04/00001-04-08/intro.mp3": [
		396,
		7
	],
	"./00001/00001-04/00001-04-08/main idea.mp3": [
		777,
		7
	],
	"./00001/00001-04/00001-04-08/module": [
		1178,
		9,
		42
	],
	"./00001/00001-04/00001-04-08/module.js": [
		1178,
		9,
		42
	],
	"./00001/00001-04/00001-04-08/my book of eight.mp3": [
		2091,
		7,
		766
	],
	"./00001/00001-04/00001-04-08/things in space.mp3": [
		2092,
		7,
		767
	],
	"./00001/00001-04/00001-04-09/0.jpg": [
		6731,
		7,
		5408
	],
	"./00001/00001-04/00001-04-09/1.jpg": [
		7762,
		7,
		7784
	],
	"./00001/00001-04/00001-04-09/2.jpg": [
		7763,
		7,
		7785
	],
	"./00001/00001-04/00001-04-09/3.jpg": [
		7764,
		7,
		7786
	],
	"./00001/00001-04/00001-04-09/4.jpg": [
		7765,
		7,
		7787
	],
	"./00001/00001-04/00001-04-09/5.jpg": [
		7766,
		7,
		7788
	],
	"./00001/00001-04/00001-04-09/6.jpg": [
		7767,
		7,
		7789
	],
	"./00001/00001-04/00001-04-09/7.jpg": [
		7768,
		7,
		7790
	],
	"./00001/00001-04/00001-04-09/i see 9 baby alligators.mp3": [
		2093,
		7,
		768
	],
	"./00001/00001-04/00001-04-09/i see 9 baby animals.mp3": [
		2094,
		7,
		769
	],
	"./00001/00001-04/00001-04-09/i see 9 baby elephants.mp3": [
		2095,
		7,
		770
	],
	"./00001/00001-04/00001-04-09/i see 9 baby lions.mp3": [
		2096,
		7,
		771
	],
	"./00001/00001-04/00001-04-09/i see 9 baby rhinos.mp3": [
		2097,
		7,
		772
	],
	"./00001/00001-04/00001-04-09/i see 9 baby tigers.mp3": [
		2098,
		7,
		773
	],
	"./00001/00001-04/00001-04-09/i see 9 baby zebras.mp3": [
		2099,
		7,
		774
	],
	"./00001/00001-04/00001-04-09/intro.mp3": [
		397,
		7
	],
	"./00001/00001-04/00001-04-09/main idea.mp3": [
		778,
		7
	],
	"./00001/00001-04/00001-04-09/module": [
		1179,
		9,
		43
	],
	"./00001/00001-04/00001-04-09/module.js": [
		1179,
		9,
		43
	],
	"./00001/00001-04/00001-04-09/my book of 9.mp3": [
		2100,
		7,
		775
	],
	"./00001/00001-04/00001-04-09/my book of nine.mp3": [
		2101,
		7,
		776
	],
	"./00001/00001-04/00001-04-09/wild animals.mp3": [
		2102,
		7,
		777
	],
	"./00001/00001-04/00001-04-10/0.jpg": [
		6732,
		7,
		5409
	],
	"./00001/00001-04/00001-04-10/1.jpg": [
		7769,
		7,
		7791
	],
	"./00001/00001-04/00001-04-10/2.jpg": [
		7770,
		7,
		7792
	],
	"./00001/00001-04/00001-04-10/3.jpg": [
		7771,
		7,
		7793
	],
	"./00001/00001-04/00001-04-10/4.jpg": [
		7772,
		7,
		7794
	],
	"./00001/00001-04/00001-04-10/5.jpg": [
		7773,
		7,
		7795
	],
	"./00001/00001-04/00001-04-10/6.jpg": [
		7774,
		7,
		7796
	],
	"./00001/00001-04/00001-04-10/7.jpg": [
		7775,
		7,
		7797
	],
	"./00001/00001-04/00001-04-10/brown animals.mp3": [
		2103,
		7,
		778
	],
	"./00001/00001-04/00001-04-10/intro.mp3": [
		398,
		7
	],
	"./00001/00001-04/00001-04-10/main idea.mp3": [
		779,
		7
	],
	"./00001/00001-04/00001-04-10/module": [
		1180,
		9,
		44
	],
	"./00001/00001-04/00001-04-10/module.js": [
		1180,
		9,
		44
	],
	"./00001/00001-04/00001-04-10/my book of ten.mp3": [
		2104,
		7,
		779
	],
	"./00001/00001-04/00001-04-10/you can see 10 blue elephants.mp3": [
		2105,
		7,
		780
	],
	"./00001/00001-04/00001-04-10/you can see 10 brown monkeys.mp3": [
		2106,
		7,
		781
	],
	"./00001/00001-04/00001-04-10/you can see 10 gray hippos.mp3": [
		2107,
		7,
		782
	],
	"./00001/00001-04/00001-04-10/you can see 10 green dragons.mp3": [
		2108,
		7,
		783
	],
	"./00001/00001-04/00001-04-10/you can see 10 pink dinosaurs.mp3": [
		2109,
		7,
		784
	],
	"./00001/00001-04/00001-04-10/you can see 10 white unicorns.mp3": [
		2110,
		7,
		785
	],
	"./00001/00001-04/00001-04-10/you can see 10 yellow giraffes.mp3": [
		2111,
		7,
		786
	],
	"./00001/00001-04/cover.jpg": [
		6733,
		7,
		5410
	],
	"./00001/00001-04/number park.mp3": [
		2112,
		7,
		787
	],
	"./00001/00001-04/numbers.mp3": [
		2113,
		7,
		788
	],
	"./00001/00001-04/unit": [
		1181,
		9,
		45
	],
	"./00001/00001-04/unit.js": [
		1181,
		9,
		45
	],
	"./00001/00001-05/00001-05-01/0.jpg": [
		6734,
		7,
		5411
	],
	"./00001/00001-05/00001-05-01/1.jpg": [
		7776,
		7,
		7798
	],
	"./00001/00001-05/00001-05-01/2.jpg": [
		7777,
		7,
		7799
	],
	"./00001/00001-05/00001-05-01/3.jpg": [
		7778,
		7,
		7800
	],
	"./00001/00001-05/00001-05-01/4.jpg": [
		7779,
		7,
		7801
	],
	"./00001/00001-05/00001-05-01/5.jpg": [
		7780,
		7,
		7802
	],
	"./00001/00001-05/00001-05-01/6.jpg": [
		7781,
		7,
		7803
	],
	"./00001/00001-05/00001-05-01/7.jpg": [
		7782,
		7,
		7804
	],
	"./00001/00001-05/00001-05-01/all circles are round.mp3": [
		2114,
		7,
		789
	],
	"./00001/00001-05/00001-05-01/circles are round.mp3": [
		2115,
		7,
		790
	],
	"./00001/00001-05/00001-05-01/i can see big circles.mp3": [
		2116,
		7,
		791
	],
	"./00001/00001-05/00001-05-01/i can see little circles.mp3": [
		2117,
		7,
		792
	],
	"./00001/00001-05/00001-05-01/intro.mp3": [
		399,
		7
	],
	"./00001/00001-05/00001-05-01/main idea.mp3": [
		780,
		7
	],
	"./00001/00001-05/00001-05-01/module": [
		1182,
		9,
		46
	],
	"./00001/00001-05/00001-05-01/module.js": [
		1182,
		9,
		46
	],
	"./00001/00001-05/00001-05-01/some circles are black.mp3": [
		2118,
		7,
		793
	],
	"./00001/00001-05/00001-05-01/some circles are blue.mp3": [
		2119,
		7,
		794
	],
	"./00001/00001-05/00001-05-01/some circles are green.mp3": [
		2120,
		7,
		795
	],
	"./00001/00001-05/00001-05-01/some circles are orange.mp3": [
		2121,
		7,
		796
	],
	"./00001/00001-05/00001-05-01/some circles are purple.mp3": [
		2122,
		7,
		797
	],
	"./00001/00001-05/00001-05-01/some circles are red.mp3": [
		2123,
		7,
		798
	],
	"./00001/00001-05/00001-05-01/some circles are white.mp3": [
		2124,
		7,
		799
	],
	"./00001/00001-05/00001-05-01/some circles are yellow.mp3": [
		2125,
		7,
		800
	],
	"./00001/00001-05/00001-05-01/things that are round.mp3": [
		2126,
		7,
		801
	],
	"./00001/00001-05/00001-05-02/0.jpg": [
		6735,
		7,
		5412
	],
	"./00001/00001-05/00001-05-02/1.jpg": [
		7783,
		7,
		7805
	],
	"./00001/00001-05/00001-05-02/2.jpg": [
		7784,
		7,
		7806
	],
	"./00001/00001-05/00001-05-02/3.jpg": [
		7785,
		7,
		7807
	],
	"./00001/00001-05/00001-05-02/4.jpg": [
		7786,
		7,
		7808
	],
	"./00001/00001-05/00001-05-02/5.jpg": [
		7787,
		7,
		7809
	],
	"./00001/00001-05/00001-05-02/6.jpg": [
		7788,
		7,
		7810
	],
	"./00001/00001-05/00001-05-02/7.jpg": [
		7789,
		7,
		7811
	],
	"./00001/00001-05/00001-05-02/intro.mp3": [
		400,
		7
	],
	"./00001/00001-05/00001-05-02/main idea.mp3": [
		781,
		7
	],
	"./00001/00001-05/00001-05-02/module": [
		1183,
		9,
		47
	],
	"./00001/00001-05/00001-05-02/module.js": [
		1183,
		9,
		47
	],
	"./00001/00001-05/00001-05-02/my square is black.mp3": [
		2127,
		7,
		802
	],
	"./00001/00001-05/00001-05-02/my square is blue.mp3": [
		2128,
		7,
		803
	],
	"./00001/00001-05/00001-05-02/my square is orange.mp3": [
		2129,
		7,
		804
	],
	"./00001/00001-05/00001-05-02/my square is red.mp3": [
		2130,
		7,
		805
	],
	"./00001/00001-05/00001-05-02/my square is yellow.mp3": [
		2131,
		7,
		806
	],
	"./00001/00001-05/00001-05-02/my squares are green.mp3": [
		2132,
		7,
		807
	],
	"./00001/00001-05/00001-05-02/my squares are pink.mp3": [
		2133,
		7,
		808
	],
	"./00001/00001-05/00001-05-02/shapes.mp3": [
		2134,
		7,
		809
	],
	"./00001/00001-05/00001-05-02/squares have four corners.mp3": [
		2135,
		7,
		810
	],
	"./00001/00001-05/00001-05-02/squares have four sides.mp3": [
		2136,
		7,
		811
	],
	"./00001/00001-05/00001-05-03/0.jpg": [
		6736,
		7,
		5413
	],
	"./00001/00001-05/00001-05-03/1.jpg": [
		7790,
		7,
		7812
	],
	"./00001/00001-05/00001-05-03/2.jpg": [
		7791,
		7,
		7813
	],
	"./00001/00001-05/00001-05-03/3.jpg": [
		7792,
		7,
		7814
	],
	"./00001/00001-05/00001-05-03/4.jpg": [
		7793,
		7,
		7815
	],
	"./00001/00001-05/00001-05-03/5.jpg": [
		7794,
		7,
		7816
	],
	"./00001/00001-05/00001-05-03/6.jpg": [
		7795,
		7,
		7817
	],
	"./00001/00001-05/00001-05-03/7.jpg": [
		7796,
		7,
		7818
	],
	"./00001/00001-05/00001-05-03/elephant likes the gray triangle.mp3": [
		2137,
		7,
		812
	],
	"./00001/00001-05/00001-05-03/goat likes the orange triangle.mp3": [
		2138,
		7,
		813
	],
	"./00001/00001-05/00001-05-03/intro.mp3": [
		401,
		7
	],
	"./00001/00001-05/00001-05-03/main idea.mp3": [
		782,
		7
	],
	"./00001/00001-05/00001-05-03/module": [
		1184,
		9,
		48
	],
	"./00001/00001-05/00001-05-03/module.js": [
		1184,
		9,
		48
	],
	"./00001/00001-05/00001-05-03/monkey likes the triangle.mp3": [
		2139,
		7,
		814
	],
	"./00001/00001-05/00001-05-03/mouse likes the blue triangle.mp3": [
		2140,
		7,
		815
	],
	"./00001/00001-05/00001-05-03/musical instruments.mp3": [
		2141,
		7,
		816
	],
	"./00001/00001-05/00001-05-03/rabbit likes the red triangle.mp3": [
		2142,
		7,
		817
	],
	"./00001/00001-05/00001-05-03/the boy likes the purple triangle.mp3": [
		2143,
		7,
		818
	],
	"./00001/00001-05/00001-05-03/the girl likes the green triangle.mp3": [
		2144,
		7,
		819
	],
	"./00001/00001-05/00001-05-03/this triangle is big.mp3": [
		2145,
		7,
		820
	],
	"./00001/00001-05/00001-05-03/this triangle is little.mp3": [
		2146,
		7,
		821
	],
	"./00001/00001-05/00001-05-03/triangles have three corners.mp3": [
		2147,
		7,
		822
	],
	"./00001/00001-05/00001-05-03/triangles have three sides.mp3": [
		2148,
		7,
		823
	],
	"./00001/00001-05/00001-05-04/0.jpg": [
		6737,
		7,
		5414
	],
	"./00001/00001-05/00001-05-04/1.jpg": [
		7797,
		7,
		7819
	],
	"./00001/00001-05/00001-05-04/2.jpg": [
		7798,
		7,
		7820
	],
	"./00001/00001-05/00001-05-04/3.jpg": [
		7799,
		7,
		7821
	],
	"./00001/00001-05/00001-05-04/4.jpg": [
		7800,
		7,
		7822
	],
	"./00001/00001-05/00001-05-04/5.jpg": [
		7801,
		7,
		7823
	],
	"./00001/00001-05/00001-05-04/6.jpg": [
		7802,
		7,
		7824
	],
	"./00001/00001-05/00001-05-04/7.jpg": [
		7803,
		7,
		7825
	],
	"./00001/00001-05/00001-05-04/animals with four legs.mp3": [
		2149,
		7,
		824
	],
	"./00001/00001-05/00001-05-04/crocodile can see a long rectangle.mp3": [
		2150,
		7,
		825
	],
	"./00001/00001-05/00001-05-04/giraffe can see a long rectangle.mp3": [
		2151,
		7,
		826
	],
	"./00001/00001-05/00001-05-04/hedgehog can see a short rectangle.mp3": [
		2152,
		7,
		827
	],
	"./00001/00001-05/00001-05-04/intro.mp3": [
		402,
		7
	],
	"./00001/00001-05/00001-05-04/main idea.mp3": [
		783,
		7
	],
	"./00001/00001-05/00001-05-04/module": [
		1185,
		9,
		49
	],
	"./00001/00001-05/00001-05-04/module.js": [
		1185,
		9,
		49
	],
	"./00001/00001-05/00001-05-04/pig can see a fat rectangle.mp3": [
		2153,
		7,
		828
	],
	"./00001/00001-05/00001-05-04/rectangles have four sides.mp3": [
		2154,
		7,
		829
	],
	"./00001/00001-05/00001-05-04/sheep can see a fat rectangle.mp3": [
		2155,
		7,
		830
	],
	"./00001/00001-05/00001-05-04/snake can see a thin rectangle.mp3": [
		2156,
		7,
		831
	],
	"./00001/00001-05/00001-05-04/turtle can see a short rectangle.mp3": [
		2157,
		7,
		832
	],
	"./00001/00001-05/00001-05-05/0.jpg": [
		6738,
		7,
		5415
	],
	"./00001/00001-05/00001-05-05/1.jpg": [
		7804,
		7,
		7826
	],
	"./00001/00001-05/00001-05-05/2.jpg": [
		7805,
		7,
		7827
	],
	"./00001/00001-05/00001-05-05/3.jpg": [
		7806,
		7,
		7828
	],
	"./00001/00001-05/00001-05-05/4.jpg": [
		7807,
		7,
		7829
	],
	"./00001/00001-05/00001-05-05/5.jpg": [
		7808,
		7,
		7830
	],
	"./00001/00001-05/00001-05-05/6.jpg": [
		7809,
		7,
		7831
	],
	"./00001/00001-05/00001-05-05/7.jpg": [
		7810,
		7,
		7832
	],
	"./00001/00001-05/00001-05-05/i can see a pentagon.mp3": [
		2158,
		7,
		833
	],
	"./00001/00001-05/00001-05-05/i can see a rectangle.mp3": [
		2159,
		7,
		834
	],
	"./00001/00001-05/00001-05-05/i can see a square.mp3": [
		2160,
		7,
		835
	],
	"./00001/00001-05/00001-05-05/i can see a triangle.mp3": [
		2161,
		7,
		836
	],
	"./00001/00001-05/00001-05-05/i can see an octagon.mp3": [
		2162,
		7,
		837
	],
	"./00001/00001-05/00001-05-05/i can see circles.mp3": [
		2163,
		7,
		838
	],
	"./00001/00001-05/00001-05-05/i can see hexagons.mp3": [
		2164,
		7,
		839
	],
	"./00001/00001-05/00001-05-05/intro.mp3": [
		403,
		7
	],
	"./00001/00001-05/00001-05-05/lets go look for shapes.mp3": [
		2165,
		7,
		840
	],
	"./00001/00001-05/00001-05-05/main idea.mp3": [
		784,
		7
	],
	"./00001/00001-05/00001-05-05/module": [
		1186,
		9,
		50
	],
	"./00001/00001-05/00001-05-05/module.js": [
		1186,
		9,
		50
	],
	"./00001/00001-05/00001-05-05/shapes.mp3": [
		2166,
		7,
		841
	],
	"./00001/00001-05/00001-05-06/0.jpg": [
		6739,
		7,
		5416
	],
	"./00001/00001-05/00001-05-06/1.jpg": [
		7811,
		7,
		7833
	],
	"./00001/00001-05/00001-05-06/2.jpg": [
		7812,
		7,
		7834
	],
	"./00001/00001-05/00001-05-06/3.jpg": [
		7813,
		7,
		7835
	],
	"./00001/00001-05/00001-05-06/4.jpg": [
		7814,
		7,
		7836
	],
	"./00001/00001-05/00001-05-06/5.jpg": [
		7815,
		7,
		7837
	],
	"./00001/00001-05/00001-05-06/6.jpg": [
		7816,
		7,
		7838
	],
	"./00001/00001-05/00001-05-06/7.jpg": [
		7817,
		7,
		7839
	],
	"./00001/00001-05/00001-05-06/balls are solid.mp3": [
		2167,
		7,
		842
	],
	"./00001/00001-05/00001-05-06/boxes are solid.mp3": [
		2168,
		7,
		843
	],
	"./00001/00001-05/00001-05-06/cones are solid.mp3": [
		2169,
		7,
		844
	],
	"./00001/00001-05/00001-05-06/cubes are solid.mp3": [
		2170,
		7,
		845
	],
	"./00001/00001-05/00001-05-06/cylinders are solid.mp3": [
		2171,
		7,
		846
	],
	"./00001/00001-05/00001-05-06/intro.mp3": [
		404,
		7
	],
	"./00001/00001-05/00001-05-06/main idea.mp3": [
		785,
		7
	],
	"./00001/00001-05/00001-05-06/module": [
		1187,
		9,
		51
	],
	"./00001/00001-05/00001-05-06/module.js": [
		1187,
		9,
		51
	],
	"./00001/00001-05/00001-05-06/pyramids are solid.mp3": [
		2172,
		7,
		847
	],
	"./00001/00001-05/00001-05-06/solid shapes.mp3": [
		2173,
		7,
		848
	],
	"./00001/00001-05/00001-05-06/spheres are solid.mp3": [
		2174,
		7,
		849
	],
	"./00001/00001-05/00001-05-07/0.jpg": [
		6740,
		7,
		5417
	],
	"./00001/00001-05/00001-05-07/1.jpg": [
		7818,
		7,
		7840
	],
	"./00001/00001-05/00001-05-07/2.jpg": [
		7819,
		7,
		7841
	],
	"./00001/00001-05/00001-05-07/3.jpg": [
		7820,
		7,
		7842
	],
	"./00001/00001-05/00001-05-07/4.jpg": [
		7821,
		7,
		7843
	],
	"./00001/00001-05/00001-05-07/5.jpg": [
		7822,
		7,
		7844
	],
	"./00001/00001-05/00001-05-07/6.jpg": [
		7823,
		7,
		7845
	],
	"./00001/00001-05/00001-05-07/7.jpg": [
		7824,
		7,
		7846
	],
	"./00001/00001-05/00001-05-07/cubes have six faces.mp3": [
		2175,
		7,
		850
	],
	"./00001/00001-05/00001-05-07/forest animals.mp3": [
		2176,
		7,
		851
	],
	"./00001/00001-05/00001-05-07/intro.mp3": [
		405,
		7
	],
	"./00001/00001-05/00001-05-07/look at the bear face.mp3": [
		2177,
		7,
		852
	],
	"./00001/00001-05/00001-05-07/look at the deer face.mp3": [
		2178,
		7,
		853
	],
	"./00001/00001-05/00001-05-07/look at the elephant face.mp3": [
		2179,
		7,
		854
	],
	"./00001/00001-05/00001-05-07/look at the faces.mp3": [
		2180,
		7,
		855
	],
	"./00001/00001-05/00001-05-07/look at the fox face.mp3": [
		2181,
		7,
		856
	],
	"./00001/00001-05/00001-05-07/look at the panda face.mp3": [
		2182,
		7,
		857
	],
	"./00001/00001-05/00001-05-07/look at the rabbit face.mp3": [
		2183,
		7,
		858
	],
	"./00001/00001-05/00001-05-07/main idea.mp3": [
		786,
		7
	],
	"./00001/00001-05/00001-05-07/module": [
		1188,
		9,
		52
	],
	"./00001/00001-05/00001-05-07/module.js": [
		1188,
		9,
		52
	],
	"./00001/00001-05/00001-05-08/0.jpg": [
		6741,
		7,
		5418
	],
	"./00001/00001-05/00001-05-08/1.jpg": [
		7825,
		7,
		7847
	],
	"./00001/00001-05/00001-05-08/2.jpg": [
		7826,
		7,
		7848
	],
	"./00001/00001-05/00001-05-08/3.jpg": [
		7827,
		7,
		7849
	],
	"./00001/00001-05/00001-05-08/4.jpg": [
		7828,
		7,
		7850
	],
	"./00001/00001-05/00001-05-08/5.jpg": [
		7829,
		7,
		7851
	],
	"./00001/00001-05/00001-05-08/6.jpg": [
		7830,
		7,
		7852
	],
	"./00001/00001-05/00001-05-08/7.jpg": [
		7831,
		7,
		7853
	],
	"./00001/00001-05/00001-05-08/intro.mp3": [
		406,
		7
	],
	"./00001/00001-05/00001-05-08/look at the circles.mp3": [
		2184,
		7,
		859
	],
	"./00001/00001-05/00001-05-08/look at the hexagons.mp3": [
		2185,
		7,
		860
	],
	"./00001/00001-05/00001-05-08/look at the octagons.mp3": [
		2186,
		7,
		861
	],
	"./00001/00001-05/00001-05-08/look at the pentagons.mp3": [
		2187,
		7,
		862
	],
	"./00001/00001-05/00001-05-08/look at the rectangles.mp3": [
		2188,
		7,
		863
	],
	"./00001/00001-05/00001-05-08/look at the squares.mp3": [
		2189,
		7,
		864
	],
	"./00001/00001-05/00001-05-08/look at the triangles.mp3": [
		2190,
		7,
		865
	],
	"./00001/00001-05/00001-05-08/main idea.mp3": [
		787,
		7
	],
	"./00001/00001-05/00001-05-08/module": [
		1189,
		9,
		53
	],
	"./00001/00001-05/00001-05-08/module.js": [
		1189,
		9,
		53
	],
	"./00001/00001-05/00001-05-08/non living things.mp3": [
		2191,
		7,
		866
	],
	"./00001/00001-05/00001-05-08/there are shapes on the quilt.mp3": [
		2192,
		7,
		867
	],
	"./00001/00001-05/00001-05-09/0.jpg": [
		6742,
		7,
		5419
	],
	"./00001/00001-05/00001-05-09/1.jpg": [
		7832,
		7,
		7854
	],
	"./00001/00001-05/00001-05-09/2.jpg": [
		7833,
		7,
		7855
	],
	"./00001/00001-05/00001-05-09/3.jpg": [
		7834,
		7,
		7856
	],
	"./00001/00001-05/00001-05-09/4.jpg": [
		7835,
		7,
		7857
	],
	"./00001/00001-05/00001-05-09/5.jpg": [
		7836,
		7,
		7858
	],
	"./00001/00001-05/00001-05-09/6.jpg": [
		7837,
		7,
		7859
	],
	"./00001/00001-05/00001-05-09/7.jpg": [
		7838,
		7,
		7860
	],
	"./00001/00001-05/00001-05-09/i can make a circle.mp3": [
		2193,
		7,
		868
	],
	"./00001/00001-05/00001-05-09/i can make a fox.mp3": [
		2194,
		7,
		869
	],
	"./00001/00001-05/00001-05-09/i can make a hexagon.mp3": [
		2195,
		7,
		870
	],
	"./00001/00001-05/00001-05-09/i can make a new shape.mp3": [
		2196,
		7,
		871
	],
	"./00001/00001-05/00001-05-09/i can make a pentagon.mp3": [
		2197,
		7,
		872
	],
	"./00001/00001-05/00001-05-09/i can make a rectangle.mp3": [
		2198,
		7,
		873
	],
	"./00001/00001-05/00001-05-09/i can make a square.mp3": [
		2199,
		7,
		874
	],
	"./00001/00001-05/00001-05-09/i can make an octagon.mp3": [
		2200,
		7,
		875
	],
	"./00001/00001-05/00001-05-09/intro.mp3": [
		407,
		7
	],
	"./00001/00001-05/00001-05-09/main idea.mp3": [
		788,
		7
	],
	"./00001/00001-05/00001-05-09/module": [
		1190,
		9,
		54
	],
	"./00001/00001-05/00001-05-09/module.js": [
		1190,
		9,
		54
	],
	"./00001/00001-05/00001-05-09/shapes.mp3": [
		2201,
		7,
		876
	],
	"./00001/00001-05/00001-05-10/0.jpg": [
		6743,
		7,
		5420
	],
	"./00001/00001-05/00001-05-10/1.jpg": [
		7839,
		7,
		7861
	],
	"./00001/00001-05/00001-05-10/2.jpg": [
		7840,
		7,
		7862
	],
	"./00001/00001-05/00001-05-10/3.jpg": [
		7841,
		7,
		7863
	],
	"./00001/00001-05/00001-05-10/4.jpg": [
		7842,
		7,
		7864
	],
	"./00001/00001-05/00001-05-10/5.jpg": [
		7843,
		7,
		7865
	],
	"./00001/00001-05/00001-05-10/6.jpg": [
		7844,
		7,
		7866
	],
	"./00001/00001-05/00001-05-10/7.jpg": [
		7845,
		7,
		7867
	],
	"./00001/00001-05/00001-05-10/intro.mp3": [
		408,
		7
	],
	"./00001/00001-05/00001-05-10/main idea.mp3": [
		789,
		7
	],
	"./00001/00001-05/00001-05-10/module": [
		1191,
		9,
		55
	],
	"./00001/00001-05/00001-05-10/module.js": [
		1191,
		9,
		55
	],
	"./00001/00001-05/00001-05-10/places.mp3": [
		2202,
		7,
		877
	],
	"./00001/00001-05/00001-05-10/shapes are all around us.mp3": [
		2203,
		7,
		878
	],
	"./00001/00001-05/00001-05-10/we can see circles.mp3": [
		2204,
		7,
		879
	],
	"./00001/00001-05/00001-05-10/we can see cones.mp3": [
		2205,
		7,
		880
	],
	"./00001/00001-05/00001-05-10/we can see cubes.mp3": [
		2206,
		7,
		881
	],
	"./00001/00001-05/00001-05-10/we can see cylinders.mp3": [
		2207,
		7,
		882
	],
	"./00001/00001-05/00001-05-10/we can see rectangles.mp3": [
		2208,
		7,
		883
	],
	"./00001/00001-05/00001-05-10/we can see squares.mp3": [
		2209,
		7,
		884
	],
	"./00001/00001-05/00001-05-10/we can see triangles.mp3": [
		2210,
		7,
		885
	],
	"./00001/00001-05/cover.jpg": [
		6744,
		7,
		5421
	],
	"./00001/00001-05/shapes park.mp3": [
		2211,
		7,
		886
	],
	"./00001/00001-05/shapes.mp3": [
		2212,
		7,
		887
	],
	"./00001/00001-05/unit": [
		1192,
		9,
		56
	],
	"./00001/00001-05/unit.js": [
		1192,
		9,
		56
	],
	"./00001/00001-06/00001-06-01/0.jpg": [
		6745,
		7,
		5422
	],
	"./00001/00001-06/00001-06-01/1.jpg": [
		7846,
		7,
		7868
	],
	"./00001/00001-06/00001-06-01/2.jpg": [
		7847,
		7,
		7869
	],
	"./00001/00001-06/00001-06-01/3.jpg": [
		7848,
		7,
		7870
	],
	"./00001/00001-06/00001-06-01/4.jpg": [
		7849,
		7,
		7871
	],
	"./00001/00001-06/00001-06-01/5.jpg": [
		7850,
		7,
		7872
	],
	"./00001/00001-06/00001-06-01/6.jpg": [
		7851,
		7,
		7873
	],
	"./00001/00001-06/00001-06-01/7.jpg": [
		7852,
		7,
		7874
	],
	"./00001/00001-06/00001-06-01/i do not need air said the octopus.mp3": [
		2213,
		7,
		888
	],
	"./00001/00001-06/00001-06-01/i need air said the astronaut.mp3": [
		2214,
		7,
		889
	],
	"./00001/00001-06/00001-06-01/i need air said the bee.mp3": [
		2215,
		7,
		890
	],
	"./00001/00001-06/00001-06-01/i need air said the cat.mp3": [
		2216,
		7,
		891
	],
	"./00001/00001-06/00001-06-01/i need air said the dolphin.mp3": [
		2217,
		7,
		892
	],
	"./00001/00001-06/00001-06-01/i need air said the scuba diver.mp3": [
		2218,
		7,
		893
	],
	"./00001/00001-06/00001-06-01/i need air said the seal.mp3": [
		2219,
		7,
		894
	],
	"./00001/00001-06/00001-06-01/intro.mp3": [
		409,
		7
	],
	"./00001/00001-06/00001-06-01/main idea.mp3": [
		790,
		7
	],
	"./00001/00001-06/00001-06-01/module": [
		1193,
		9,
		57
	],
	"./00001/00001-06/00001-06-01/module.js": [
		1193,
		9,
		57
	],
	"./00001/00001-06/00001-06-01/water animals.mp3": [
		2220,
		7,
		895
	],
	"./00001/00001-06/00001-06-01/we need air.mp3": [
		2221,
		7,
		896
	],
	"./00001/00001-06/00001-06-02/0.jpg": [
		6746,
		7,
		5423
	],
	"./00001/00001-06/00001-06-02/1.jpg": [
		7853,
		7,
		7875
	],
	"./00001/00001-06/00001-06-02/2.jpg": [
		7854,
		7,
		7876
	],
	"./00001/00001-06/00001-06-02/3.jpg": [
		7855,
		7,
		7877
	],
	"./00001/00001-06/00001-06-02/4.jpg": [
		7856,
		7,
		7878
	],
	"./00001/00001-06/00001-06-02/5.jpg": [
		7857,
		7,
		7879
	],
	"./00001/00001-06/00001-06-02/6.jpg": [
		7858,
		7,
		7880
	],
	"./00001/00001-06/00001-06-02/7.jpg": [
		7859,
		7,
		7881
	],
	"./00001/00001-06/00001-06-02/farm animals.mp3": [
		2222,
		7,
		897
	],
	"./00001/00001-06/00001-06-02/intro.mp3": [
		410,
		7
	],
	"./00001/00001-06/00001-06-02/main idea.mp3": [
		791,
		7
	],
	"./00001/00001-06/00001-06-02/module": [
		1194,
		9,
		58
	],
	"./00001/00001-06/00001-06-02/module.js": [
		1194,
		9,
		58
	],
	"./00001/00001-06/00001-06-02/the cow lives on the farm.mp3": [
		2223,
		7,
		898
	],
	"./00001/00001-06/00001-06-02/the duck lives at the pond too.mp3": [
		2224,
		7,
		899
	],
	"./00001/00001-06/00001-06-02/the frog lives at the pond.mp3": [
		2225,
		7,
		900
	],
	"./00001/00001-06/00001-06-02/the monkey lives in a tree.mp3": [
		2226,
		7,
		901
	],
	"./00001/00001-06/00001-06-02/the shark lives in the sea too.mp3": [
		2227,
		7,
		902
	],
	"./00001/00001-06/00001-06-02/the sheep lives on the farm too.mp3": [
		2228,
		7,
		903
	],
	"./00001/00001-06/00001-06-02/the whale lives in the sea.mp3": [
		2229,
		7,
		904
	],
	"./00001/00001-06/00001-06-02/we need homes.mp3": [
		2230,
		7,
		905
	],
	"./00001/00001-06/00001-06-03/0.jpg": [
		6747,
		7,
		5424
	],
	"./00001/00001-06/00001-06-03/1.jpg": [
		7860,
		7,
		7882
	],
	"./00001/00001-06/00001-06-03/2.jpg": [
		7861,
		7,
		7883
	],
	"./00001/00001-06/00001-06-03/3.jpg": [
		7862,
		7,
		7884
	],
	"./00001/00001-06/00001-06-03/4.jpg": [
		7863,
		7,
		7885
	],
	"./00001/00001-06/00001-06-03/5.jpg": [
		7864,
		7,
		7886
	],
	"./00001/00001-06/00001-06-03/6.jpg": [
		7865,
		7,
		7887
	],
	"./00001/00001-06/00001-06-03/7.jpg": [
		7866,
		7,
		7888
	],
	"./00001/00001-06/00001-06-03/animals that eat plants.mp3": [
		2231,
		7,
		906
	],
	"./00001/00001-06/00001-06-03/intro.mp3": [
		411,
		7
	],
	"./00001/00001-06/00001-06-03/main idea.mp3": [
		792,
		7
	],
	"./00001/00001-06/00001-06-03/module": [
		1195,
		9,
		59
	],
	"./00001/00001-06/00001-06-03/module.js": [
		1195,
		9,
		59
	],
	"./00001/00001-06/00001-06-03/the bat likes insects.mp3": [
		2232,
		7,
		907
	],
	"./00001/00001-06/00001-06-03/the dinosaur likes leaves too.mp3": [
		2233,
		7,
		908
	],
	"./00001/00001-06/00001-06-03/the giraffe likes leaves.mp3": [
		2234,
		7,
		909
	],
	"./00001/00001-06/00001-06-03/the monkey likes bananas.mp3": [
		2235,
		7,
		910
	],
	"./00001/00001-06/00001-06-03/the shark likes fish.mp3": [
		2236,
		7,
		911
	],
	"./00001/00001-06/00001-06-03/the squirrel likes nuts.mp3": [
		2237,
		7,
		912
	],
	"./00001/00001-06/00001-06-03/the zebra likes grass.mp3": [
		2238,
		7,
		913
	],
	"./00001/00001-06/00001-06-03/we need to eat.mp3": [
		2239,
		7,
		914
	],
	"./00001/00001-06/00001-06-04/0.jpg": [
		6748,
		7,
		5425
	],
	"./00001/00001-06/00001-06-04/1.jpg": [
		7867,
		7,
		7889
	],
	"./00001/00001-06/00001-06-04/2.jpg": [
		7868,
		7,
		7890
	],
	"./00001/00001-06/00001-06-04/3.jpg": [
		7869,
		7,
		7891
	],
	"./00001/00001-06/00001-06-04/4.jpg": [
		7870,
		7,
		7892
	],
	"./00001/00001-06/00001-06-04/5.jpg": [
		7871,
		7,
		7893
	],
	"./00001/00001-06/00001-06-04/6.jpg": [
		7872,
		7,
		7894
	],
	"./00001/00001-06/00001-06-04/7.jpg": [
		7873,
		7,
		7895
	],
	"./00001/00001-06/00001-06-04/animals that live in the snow.mp3": [
		2240,
		7,
		915
	],
	"./00001/00001-06/00001-06-04/he is out in the snow.mp3": [
		2241,
		7,
		916
	],
	"./00001/00001-06/00001-06-04/i am out in the snow too.mp3": [
		2242,
		7,
		917
	],
	"./00001/00001-06/00001-06-04/i am out in the snow.mp3": [
		2243,
		7,
		918
	],
	"./00001/00001-06/00001-06-04/intro.mp3": [
		412,
		7
	],
	"./00001/00001-06/00001-06-04/it is snowing.mp3": [
		2244,
		7,
		919
	],
	"./00001/00001-06/00001-06-04/it is winter.mp3": [
		2245,
		7,
		920
	],
	"./00001/00001-06/00001-06-04/look at me.mp3": [
		2246,
		7,
		921
	],
	"./00001/00001-06/00001-06-04/look at the deer.mp3": [
		2247,
		7,
		922
	],
	"./00001/00001-06/00001-06-04/look at the dog.mp3": [
		2248,
		7,
		923
	],
	"./00001/00001-06/00001-06-04/look at the fox.mp3": [
		2249,
		7,
		924
	],
	"./00001/00001-06/00001-06-04/look at the owl.mp3": [
		2250,
		7,
		925
	],
	"./00001/00001-06/00001-06-04/look at the rabbit.mp3": [
		2251,
		7,
		926
	],
	"./00001/00001-06/00001-06-04/look at the squirrel.mp3": [
		2252,
		7,
		927
	],
	"./00001/00001-06/00001-06-04/main idea.mp3": [
		793,
		7
	],
	"./00001/00001-06/00001-06-04/module": [
		1196,
		9,
		60
	],
	"./00001/00001-06/00001-06-04/module.js": [
		1196,
		9,
		60
	],
	"./00001/00001-06/00001-06-04/out in the snow.mp3": [
		2253,
		7,
		928
	],
	"./00001/00001-06/00001-06-04/she is out in the snow.mp3": [
		2254,
		7,
		929
	],
	"./00001/00001-06/00001-06-05/0.jpg": [
		6749,
		7,
		5426
	],
	"./00001/00001-06/00001-06-05/1.jpg": [
		7874,
		7,
		7896
	],
	"./00001/00001-06/00001-06-05/2.jpg": [
		7875,
		7,
		7897
	],
	"./00001/00001-06/00001-06-05/3.jpg": [
		7876,
		7,
		7898
	],
	"./00001/00001-06/00001-06-05/4.jpg": [
		7877,
		7,
		7899
	],
	"./00001/00001-06/00001-06-05/5.jpg": [
		7878,
		7,
		7900
	],
	"./00001/00001-06/00001-06-05/6.jpg": [
		7879,
		7,
		7901
	],
	"./00001/00001-06/00001-06-05/7.jpg": [
		7880,
		7,
		7902
	],
	"./00001/00001-06/00001-06-05/are they alive.mp3": [
		2255,
		7,
		930
	],
	"./00001/00001-06/00001-06-05/intro.mp3": [
		413,
		7
	],
	"./00001/00001-06/00001-06-05/living things.mp3": [
		2256,
		7,
		931
	],
	"./00001/00001-06/00001-06-05/main idea.mp3": [
		794,
		7
	],
	"./00001/00001-06/00001-06-05/module": [
		1197,
		9,
		61
	],
	"./00001/00001-06/00001-06-05/module.js": [
		1197,
		9,
		61
	],
	"./00001/00001-06/00001-06-05/the cat is alive.mp3": [
		2257,
		7,
		932
	],
	"./00001/00001-06/00001-06-05/the duck is alive.mp3": [
		2258,
		7,
		933
	],
	"./00001/00001-06/00001-06-05/the fox is alive.mp3": [
		2259,
		7,
		934
	],
	"./00001/00001-06/00001-06-05/the frog is alive.mp3": [
		2260,
		7,
		935
	],
	"./00001/00001-06/00001-06-05/the mouse is alive.mp3": [
		2261,
		7,
		936
	],
	"./00001/00001-06/00001-06-05/the seal is alive.mp3": [
		2262,
		7,
		937
	],
	"./00001/00001-06/00001-06-05/the sheep is alive.mp3": [
		2263,
		7,
		938
	],
	"./00001/00001-06/00001-06-05/which one is alive.mp3": [
		2264,
		7,
		939
	],
	"./00001/00001-06/00001-06-06/0.jpg": [
		6750,
		7,
		5427
	],
	"./00001/00001-06/00001-06-06/1.jpg": [
		7881,
		7,
		7903
	],
	"./00001/00001-06/00001-06-06/2.jpg": [
		7882,
		7,
		7904
	],
	"./00001/00001-06/00001-06-06/3.jpg": [
		7883,
		7,
		7905
	],
	"./00001/00001-06/00001-06-06/4.jpg": [
		7884,
		7,
		7906
	],
	"./00001/00001-06/00001-06-06/5.jpg": [
		7885,
		7,
		7907
	],
	"./00001/00001-06/00001-06-06/6.jpg": [
		7886,
		7,
		7908
	],
	"./00001/00001-06/00001-06-06/7.jpg": [
		7887,
		7,
		7909
	],
	"./00001/00001-06/00001-06-06/baby animals.mp3": [
		2265,
		7,
		940
	],
	"./00001/00001-06/00001-06-06/here is my mother.mp3": [
		2266,
		7,
		941
	],
	"./00001/00001-06/00001-06-06/i love my mother.mp3": [
		2267,
		7,
		942
	],
	"./00001/00001-06/00001-06-06/intro.mp3": [
		414,
		7
	],
	"./00001/00001-06/00001-06-06/main idea.mp3": [
		795,
		7
	],
	"./00001/00001-06/00001-06-06/mammals.mp3": [
		2268,
		7,
		943
	],
	"./00001/00001-06/00001-06-06/module": [
		1198,
		9,
		62
	],
	"./00001/00001-06/00001-06-06/module.js": [
		1198,
		9,
		62
	],
	"./00001/00001-06/00001-06-06/mother.mp3": [
		2269,
		7,
		944
	],
	"./00001/00001-06/00001-06-06/my mother is a bear.mp3": [
		2270,
		7,
		945
	],
	"./00001/00001-06/00001-06-06/my mother is a cow.mp3": [
		2271,
		7,
		946
	],
	"./00001/00001-06/00001-06-06/my mother is a dolphin.mp3": [
		2272,
		7,
		947
	],
	"./00001/00001-06/00001-06-06/my mother is a duck.mp3": [
		2273,
		7,
		948
	],
	"./00001/00001-06/00001-06-06/my mother is a kangaroo.mp3": [
		2274,
		7,
		949
	],
	"./00001/00001-06/00001-06-06/my mother is a rabbit.mp3": [
		2275,
		7,
		950
	],
	"./00001/00001-06/00001-06-06/my mother is a sheep.mp3": [
		2276,
		7,
		951
	],
	"./00001/00001-06/00001-06-07/0.jpg": [
		6751,
		7,
		5428
	],
	"./00001/00001-06/00001-06-07/1.jpg": [
		7888,
		7,
		7910
	],
	"./00001/00001-06/00001-06-07/2.jpg": [
		7889,
		7,
		7911
	],
	"./00001/00001-06/00001-06-07/3.jpg": [
		7890,
		7,
		7912
	],
	"./00001/00001-06/00001-06-07/4.jpg": [
		7891,
		7,
		7913
	],
	"./00001/00001-06/00001-06-07/5.jpg": [
		7892,
		7,
		7914
	],
	"./00001/00001-06/00001-06-07/6.jpg": [
		7893,
		7,
		7915
	],
	"./00001/00001-06/00001-06-07/7.jpg": [
		7894,
		7,
		7916
	],
	"./00001/00001-06/00001-06-07/birds need water.mp3": [
		2277,
		7,
		952
	],
	"./00001/00001-06/00001-06-07/deer need water.mp3": [
		2278,
		7,
		953
	],
	"./00001/00001-06/00001-06-07/dogs need water too.mp3": [
		2279,
		7,
		954
	],
	"./00001/00001-06/00001-06-07/dolphins need water.mp3": [
		2280,
		7,
		955
	],
	"./00001/00001-06/00001-06-07/ducks need water.mp3": [
		2281,
		7,
		956
	],
	"./00001/00001-06/00001-06-07/everyone needs water.mp3": [
		2282,
		7,
		957
	],
	"./00001/00001-06/00001-06-07/flowers need water.mp3": [
		2283,
		7,
		958
	],
	"./00001/00001-06/00001-06-07/frogs need water.mp3": [
		2284,
		7,
		959
	],
	"./00001/00001-06/00001-06-07/intro.mp3": [
		415,
		7
	],
	"./00001/00001-06/00001-06-07/main idea.mp3": [
		796,
		7
	],
	"./00001/00001-06/00001-06-07/module": [
		1199,
		9,
		63
	],
	"./00001/00001-06/00001-06-07/module.js": [
		1199,
		9,
		63
	],
	"./00001/00001-06/00001-06-07/water.mp3": [
		2285,
		7,
		960
	],
	"./00001/00001-06/00001-06-08/0.jpg": [
		6752,
		7,
		5429
	],
	"./00001/00001-06/00001-06-08/1.jpg": [
		7895,
		7,
		7917
	],
	"./00001/00001-06/00001-06-08/2.jpg": [
		7896,
		7,
		7918
	],
	"./00001/00001-06/00001-06-08/3.jpg": [
		7897,
		7,
		7919
	],
	"./00001/00001-06/00001-06-08/4.jpg": [
		7898,
		7,
		7920
	],
	"./00001/00001-06/00001-06-08/5.jpg": [
		7899,
		7,
		7921
	],
	"./00001/00001-06/00001-06-08/6.jpg": [
		7900,
		7,
		7922
	],
	"./00001/00001-06/00001-06-08/7.jpg": [
		7901,
		7,
		7923
	],
	"./00001/00001-06/00001-06-08/grow seeds grow.mp3": [
		2286,
		7,
		961
	],
	"./00001/00001-06/00001-06-08/intro.mp3": [
		416,
		7
	],
	"./00001/00001-06/00001-06-08/look at the apples.mp3": [
		2287,
		7,
		962
	],
	"./00001/00001-06/00001-06-08/look at the branch.mp3": [
		2288,
		7,
		963
	],
	"./00001/00001-06/00001-06-08/look at the flowers.mp3": [
		2289,
		7,
		964
	],
	"./00001/00001-06/00001-06-08/look at the leaves.mp3": [
		2290,
		7,
		965
	],
	"./00001/00001-06/00001-06-08/look at the roots.mp3": [
		2291,
		7,
		966
	],
	"./00001/00001-06/00001-06-08/look at the seeds.mp3": [
		2292,
		7,
		967
	],
	"./00001/00001-06/00001-06-08/look at the stem.mp3": [
		2293,
		7,
		968
	],
	"./00001/00001-06/00001-06-08/main idea.mp3": [
		797,
		7
	],
	"./00001/00001-06/00001-06-08/module": [
		1200,
		9,
		64
	],
	"./00001/00001-06/00001-06-08/module.js": [
		1200,
		9,
		64
	],
	"./00001/00001-06/00001-06-08/things that grow on trees.mp3": [
		2294,
		7,
		969
	],
	"./00001/00001-06/00001-06-09/0.jpg": [
		6753,
		7,
		5430
	],
	"./00001/00001-06/00001-06-09/1.jpg": [
		7902,
		7,
		7924
	],
	"./00001/00001-06/00001-06-09/2.jpg": [
		7903,
		7,
		7925
	],
	"./00001/00001-06/00001-06-09/3.jpg": [
		7904,
		7,
		7926
	],
	"./00001/00001-06/00001-06-09/4.jpg": [
		7905,
		7,
		7927
	],
	"./00001/00001-06/00001-06-09/5.jpg": [
		7906,
		7,
		7928
	],
	"./00001/00001-06/00001-06-09/6.jpg": [
		7907,
		7,
		7929
	],
	"./00001/00001-06/00001-06-09/7.jpg": [
		7908,
		7,
		7930
	],
	"./00001/00001-06/00001-06-09/baby animals.mp3": [
		2295,
		7,
		970
	],
	"./00001/00001-06/00001-06-09/i love my dad.mp3": [
		2296,
		7,
		971
	],
	"./00001/00001-06/00001-06-09/intro.mp3": [
		417,
		7
	],
	"./00001/00001-06/00001-06-09/main idea.mp3": [
		798,
		7
	],
	"./00001/00001-06/00001-06-09/module": [
		1201,
		9,
		65
	],
	"./00001/00001-06/00001-06-09/module.js": [
		1201,
		9,
		65
	],
	"./00001/00001-06/00001-06-09/my dad is a deer.mp3": [
		2297,
		7,
		972
	],
	"./00001/00001-06/00001-06-09/my dad is a dinosaur.mp3": [
		2298,
		7,
		973
	],
	"./00001/00001-06/00001-06-09/my dad is a dog.mp3": [
		2299,
		7,
		974
	],
	"./00001/00001-06/00001-06-09/my dad is a pig.mp3": [
		2300,
		7,
		975
	],
	"./00001/00001-06/00001-06-09/my dad is a rooster.mp3": [
		2301,
		7,
		976
	],
	"./00001/00001-06/00001-06-09/my dad is a seahorse.mp3": [
		2302,
		7,
		977
	],
	"./00001/00001-06/00001-06-09/my dad is an elephant.mp3": [
		2303,
		7,
		978
	],
	"./00001/00001-06/00001-06-10/0.jpg": [
		6754,
		7,
		5431
	],
	"./00001/00001-06/00001-06-10/1.jpg": [
		7909,
		7,
		7931
	],
	"./00001/00001-06/00001-06-10/2.jpg": [
		7910,
		7,
		7932
	],
	"./00001/00001-06/00001-06-10/3.jpg": [
		7911,
		7,
		7933
	],
	"./00001/00001-06/00001-06-10/4.jpg": [
		7912,
		7,
		7934
	],
	"./00001/00001-06/00001-06-10/5.jpg": [
		7913,
		7,
		7935
	],
	"./00001/00001-06/00001-06-10/6.jpg": [
		7914,
		7,
		7936
	],
	"./00001/00001-06/00001-06-10/7.jpg": [
		7915,
		7,
		7937
	],
	"./00001/00001-06/00001-06-10/do they grow.mp3": [
		2304,
		7,
		979
	],
	"./00001/00001-06/00001-06-10/intro.mp3": [
		418,
		7
	],
	"./00001/00001-06/00001-06-10/living things.mp3": [
		2305,
		7,
		980
	],
	"./00001/00001-06/00001-06-10/main idea.mp3": [
		799,
		7
	],
	"./00001/00001-06/00001-06-10/module": [
		1202,
		9,
		66
	],
	"./00001/00001-06/00001-06-10/module.js": [
		1202,
		9,
		66
	],
	"./00001/00001-06/00001-06-10/non living things.mp3": [
		2306,
		7,
		981
	],
	"./00001/00001-06/00001-06-10/the foxes grow.mp3": [
		2307,
		7,
		982
	],
	"./00001/00001-06/00001-06-10/the frogs grow.mp3": [
		2308,
		7,
		983
	],
	"./00001/00001-06/00001-06-10/the goats grow.mp3": [
		2309,
		7,
		984
	],
	"./00001/00001-06/00001-06-10/the kittens grow.mp3": [
		2310,
		7,
		985
	],
	"./00001/00001-06/00001-06-10/the rats grow.mp3": [
		2311,
		7,
		986
	],
	"./00001/00001-06/00001-06-10/the snails grow.mp3": [
		2312,
		7,
		987
	],
	"./00001/00001-06/00001-06-10/the snakes grow.mp3": [
		2313,
		7,
		988
	],
	"./00001/00001-06/cover.jpg": [
		6755,
		7,
		5432
	],
	"./00001/00001-06/life science.mp3": [
		2314,
		7,
		989
	],
	"./00001/00001-06/unit": [
		1203,
		9,
		67
	],
	"./00001/00001-06/unit.js": [
		1203,
		9,
		67
	],
	"./00001/00001-07/00001-07-01/0.jpg": [
		6756,
		7,
		5433
	],
	"./00001/00001-07/00001-07-01/1.jpg": [
		7916,
		7,
		7938
	],
	"./00001/00001-07/00001-07-01/2.jpg": [
		7917,
		7,
		7939
	],
	"./00001/00001-07/00001-07-01/3.jpg": [
		7918,
		7,
		7940
	],
	"./00001/00001-07/00001-07-01/4.jpg": [
		7919,
		7,
		7941
	],
	"./00001/00001-07/00001-07-01/5.jpg": [
		7920,
		7,
		7942
	],
	"./00001/00001-07/00001-07-01/6.jpg": [
		7921,
		7,
		7943
	],
	"./00001/00001-07/00001-07-01/7.jpg": [
		7922,
		7,
		7944
	],
	"./00001/00001-07/00001-07-01/intro.mp3": [
		419,
		7
	],
	"./00001/00001-07/00001-07-01/little things.mp3": [
		2315,
		7,
		990
	],
	"./00001/00001-07/00001-07-01/main idea.mp3": [
		800,
		7
	],
	"./00001/00001-07/00001-07-01/module": [
		1204,
		9,
		68
	],
	"./00001/00001-07/00001-07-01/module.js": [
		1204,
		9,
		68
	],
	"./00001/00001-07/00001-07-01/my bus is little.mp3": [
		2316,
		7,
		991
	],
	"./00001/00001-07/00001-07-01/my car is little.mp3": [
		2317,
		7,
		992
	],
	"./00001/00001-07/00001-07-01/my dump truck is little.mp3": [
		2318,
		7,
		993
	],
	"./00001/00001-07/00001-07-01/my fire truck is little.mp3": [
		2319,
		7,
		994
	],
	"./00001/00001-07/00001-07-01/my helicopter is little.mp3": [
		2320,
		7,
		995
	],
	"./00001/00001-07/00001-07-01/my monster is little.mp3": [
		2321,
		7,
		996
	],
	"./00001/00001-07/00001-07-01/my plane is little.mp3": [
		2322,
		7,
		997
	],
	"./00001/00001-07/00001-07-01/vehicles.mp3": [
		2323,
		7,
		998
	],
	"./00001/00001-07/00001-07-02/0.jpg": [
		6757,
		7,
		5434
	],
	"./00001/00001-07/00001-07-02/1.jpg": [
		7923,
		7,
		7945
	],
	"./00001/00001-07/00001-07-02/2.jpg": [
		7924,
		7,
		7946
	],
	"./00001/00001-07/00001-07-02/3.jpg": [
		7925,
		7,
		7947
	],
	"./00001/00001-07/00001-07-02/4.jpg": [
		7926,
		7,
		7948
	],
	"./00001/00001-07/00001-07-02/5.jpg": [
		7927,
		7,
		7949
	],
	"./00001/00001-07/00001-07-02/6.jpg": [
		7928,
		7,
		7950
	],
	"./00001/00001-07/00001-07-02/7.jpg": [
		7929,
		7,
		7951
	],
	"./00001/00001-07/00001-07-02/intro.mp3": [
		420,
		7
	],
	"./00001/00001-07/00001-07-02/loud and soft.mp3": [
		2324,
		7,
		999
	],
	"./00001/00001-07/00001-07-02/main idea.mp3": [
		801,
		7
	],
	"./00001/00001-07/00001-07-02/module": [
		1205,
		9,
		69
	],
	"./00001/00001-07/00001-07-02/module.js": [
		1205,
		9,
		69
	],
	"./00001/00001-07/00001-07-02/musical instruments.mp3": [
		2325,
		7,
		1000
	],
	"./00001/00001-07/00001-07-02/the banjo is loud.mp3": [
		2326,
		7,
		1001
	],
	"./00001/00001-07/00001-07-02/the drum is loud.mp3": [
		2327,
		7,
		1002
	],
	"./00001/00001-07/00001-07-02/the piano is loud.mp3": [
		2328,
		7,
		1003
	],
	"./00001/00001-07/00001-07-02/the tambourine is soft.mp3": [
		2329,
		7,
		1004
	],
	"./00001/00001-07/00001-07-02/the triangle is soft.mp3": [
		2330,
		7,
		1005
	],
	"./00001/00001-07/00001-07-02/the violin is loud.mp3": [
		2331,
		7,
		1006
	],
	"./00001/00001-07/00001-07-02/the xylophone is soft.mp3": [
		2332,
		7,
		1007
	],
	"./00001/00001-07/00001-07-03/0.jpg": [
		6758,
		7,
		5435
	],
	"./00001/00001-07/00001-07-03/1.jpg": [
		7930,
		7,
		7952
	],
	"./00001/00001-07/00001-07-03/2.jpg": [
		7931,
		7,
		7953
	],
	"./00001/00001-07/00001-07-03/3.jpg": [
		7932,
		7,
		7954
	],
	"./00001/00001-07/00001-07-03/4.jpg": [
		7933,
		7,
		7955
	],
	"./00001/00001-07/00001-07-03/5.jpg": [
		7934,
		7,
		7956
	],
	"./00001/00001-07/00001-07-03/6.jpg": [
		7935,
		7,
		7957
	],
	"./00001/00001-07/00001-07-03/7.jpg": [
		7936,
		7,
		7958
	],
	"./00001/00001-07/00001-07-03/electricity.mp3": [
		2333,
		7,
		1008
	],
	"./00001/00001-07/00001-07-03/intro.mp3": [
		421,
		7
	],
	"./00001/00001-07/00001-07-03/main idea.mp3": [
		802,
		7
	],
	"./00001/00001-07/00001-07-03/module": [
		1206,
		9,
		70
	],
	"./00001/00001-07/00001-07-03/module.js": [
		1206,
		9,
		70
	],
	"./00001/00001-07/00001-07-03/the computer uses electricity.mp3": [
		2334,
		7,
		1009
	],
	"./00001/00001-07/00001-07-03/the fan uses electricity.mp3": [
		2335,
		7,
		1010
	],
	"./00001/00001-07/00001-07-03/the fridge uses electricity.mp3": [
		2336,
		7,
		1011
	],
	"./00001/00001-07/00001-07-03/the guitar uses electricity.mp3": [
		2337,
		7,
		1012
	],
	"./00001/00001-07/00001-07-03/the light uses electricity.mp3": [
		2338,
		7,
		1013
	],
	"./00001/00001-07/00001-07-03/the stove uses electricity.mp3": [
		2339,
		7,
		1014
	],
	"./00001/00001-07/00001-07-03/the television uses electricity.mp3": [
		2340,
		7,
		1015
	],
	"./00001/00001-07/00001-07-03/things that use electricity.mp3": [
		2341,
		7,
		1016
	],
	"./00001/00001-07/00001-07-04/0.jpg": [
		6759,
		7,
		5436
	],
	"./00001/00001-07/00001-07-04/1.jpg": [
		7937,
		7,
		7959
	],
	"./00001/00001-07/00001-07-04/2.jpg": [
		7938,
		7,
		7960
	],
	"./00001/00001-07/00001-07-04/3.jpg": [
		7939,
		7,
		7961
	],
	"./00001/00001-07/00001-07-04/4.jpg": [
		7940,
		7,
		7962
	],
	"./00001/00001-07/00001-07-04/5.jpg": [
		7941,
		7,
		7963
	],
	"./00001/00001-07/00001-07-04/6.jpg": [
		7942,
		7,
		7964
	],
	"./00001/00001-07/00001-07-04/7.jpg": [
		7943,
		7,
		7965
	],
	"./00001/00001-07/00001-07-04/deer goes up in the pulley.mp3": [
		2342,
		7,
		1017
	],
	"./00001/00001-07/00001-07-04/elephant goes down in the pulley.mp3": [
		2343,
		7,
		1018
	],
	"./00001/00001-07/00001-07-04/elephant goes up in the pulley.mp3": [
		2344,
		7,
		1019
	],
	"./00001/00001-07/00001-07-04/intro.mp3": [
		422,
		7
	],
	"./00001/00001-07/00001-07-04/lion goes up in the pulley.mp3": [
		2345,
		7,
		1020
	],
	"./00001/00001-07/00001-07-04/main idea.mp3": [
		803,
		7
	],
	"./00001/00001-07/00001-07-04/module": [
		1207,
		9,
		71
	],
	"./00001/00001-07/00001-07-04/module.js": [
		1207,
		9,
		71
	],
	"./00001/00001-07/00001-07-04/panda goes up in the pulley.mp3": [
		2346,
		7,
		1021
	],
	"./00001/00001-07/00001-07-04/skunk goes up in the pulley.mp3": [
		2347,
		7,
		1022
	],
	"./00001/00001-07/00001-07-04/tiger goes up in the pulley.mp3": [
		2348,
		7,
		1023
	],
	"./00001/00001-07/00001-07-04/up in the pulley.mp3": [
		2349,
		7,
		1024
	],
	"./00001/00001-07/00001-07-04/wild animals.mp3": [
		2350,
		7,
		1025
	],
	"./00001/00001-07/00001-07-05/0.jpg": [
		6760,
		7,
		5437
	],
	"./00001/00001-07/00001-07-05/1.jpg": [
		7944,
		7,
		7966
	],
	"./00001/00001-07/00001-07-05/2.jpg": [
		7945,
		7,
		7967
	],
	"./00001/00001-07/00001-07-05/3.jpg": [
		7946,
		7,
		7968
	],
	"./00001/00001-07/00001-07-05/4.jpg": [
		7947,
		7,
		7969
	],
	"./00001/00001-07/00001-07-05/5.jpg": [
		7948,
		7,
		7970
	],
	"./00001/00001-07/00001-07-05/6.jpg": [
		7949,
		7,
		7971
	],
	"./00001/00001-07/00001-07-05/7.jpg": [
		7950,
		7,
		7972
	],
	"./00001/00001-07/00001-07-05/intro.mp3": [
		423,
		7
	],
	"./00001/00001-07/00001-07-05/main idea.mp3": [
		804,
		7
	],
	"./00001/00001-07/00001-07-05/module": [
		1208,
		9,
		72
	],
	"./00001/00001-07/00001-07-05/module.js": [
		1208,
		9,
		72
	],
	"./00001/00001-07/00001-07-05/the ball will move.mp3": [
		2351,
		7,
		1026
	],
	"./00001/00001-07/00001-07-05/the car will move.mp3": [
		2352,
		7,
		1027
	],
	"./00001/00001-07/00001-07-05/the swing will move.mp3": [
		2353,
		7,
		1028
	],
	"./00001/00001-07/00001-07-05/the swing will not move.mp3": [
		2354,
		7,
		1029
	],
	"./00001/00001-07/00001-07-05/the truck will move.mp3": [
		2355,
		7,
		1030
	],
	"./00001/00001-07/00001-07-05/the truck will not move.mp3": [
		2356,
		7,
		1031
	],
	"./00001/00001-07/00001-07-05/toys.mp3": [
		2357,
		7,
		1032
	],
	"./00001/00001-07/00001-07-05/will it move.mp3": [
		2358,
		7,
		1033
	],
	"./00001/00001-07/00001-07-06/0.jpg": [
		6761,
		7,
		5438
	],
	"./00001/00001-07/00001-07-06/1.jpg": [
		7951,
		7,
		7973
	],
	"./00001/00001-07/00001-07-06/2.jpg": [
		7952,
		7,
		7974
	],
	"./00001/00001-07/00001-07-06/3.jpg": [
		7953,
		7,
		7975
	],
	"./00001/00001-07/00001-07-06/4.jpg": [
		7954,
		7,
		7976
	],
	"./00001/00001-07/00001-07-06/5.jpg": [
		7955,
		7,
		7977
	],
	"./00001/00001-07/00001-07-06/6.jpg": [
		7956,
		7,
		7978
	],
	"./00001/00001-07/00001-07-06/7.jpg": [
		7957,
		7,
		7979
	],
	"./00001/00001-07/00001-07-06/intro.mp3": [
		424,
		7
	],
	"./00001/00001-07/00001-07-06/main idea.mp3": [
		805,
		7
	],
	"./00001/00001-07/00001-07-06/module": [
		1209,
		9,
		73
	],
	"./00001/00001-07/00001-07-06/module.js": [
		1209,
		9,
		73
	],
	"./00001/00001-07/00001-07-06/the apple floats.mp3": [
		2359,
		7,
		1034
	],
	"./00001/00001-07/00001-07-06/the ball floats.mp3": [
		2360,
		7,
		1035
	],
	"./00001/00001-07/00001-07-06/the boat floats.mp3": [
		2361,
		7,
		1036
	],
	"./00001/00001-07/00001-07-06/the cube floats.mp3": [
		2362,
		7,
		1037
	],
	"./00001/00001-07/00001-07-06/the duck floats too.mp3": [
		2363,
		7,
		1038
	],
	"./00001/00001-07/00001-07-06/the key sinks.mp3": [
		2364,
		7,
		1039
	],
	"./00001/00001-07/00001-07-06/the nail sinks.mp3": [
		2365,
		7,
		1040
	],
	"./00001/00001-07/00001-07-06/things that float.mp3": [
		2366,
		7,
		1041
	],
	"./00001/00001-07/00001-07-06/will it float.mp3": [
		2367,
		7,
		1042
	],
	"./00001/00001-07/00001-07-06/will it sink.mp3": [
		2368,
		7,
		1043
	],
	"./00001/00001-07/00001-07-07/0.jpg": [
		6762,
		7,
		5439
	],
	"./00001/00001-07/00001-07-07/1.jpg": [
		7958,
		7,
		7980
	],
	"./00001/00001-07/00001-07-07/2.jpg": [
		7959,
		7,
		7981
	],
	"./00001/00001-07/00001-07-07/3.jpg": [
		7960,
		7,
		7982
	],
	"./00001/00001-07/00001-07-07/4.jpg": [
		7961,
		7,
		7983
	],
	"./00001/00001-07/00001-07-07/5.jpg": [
		7962,
		7,
		7984
	],
	"./00001/00001-07/00001-07-07/6.jpg": [
		7963,
		7,
		7985
	],
	"./00001/00001-07/00001-07-07/7.jpg": [
		7964,
		7,
		7986
	],
	"./00001/00001-07/00001-07-07/fishing with a magnet.mp3": [
		2369,
		7,
		1044
	],
	"./00001/00001-07/00001-07-07/intro.mp3": [
		425,
		7
	],
	"./00001/00001-07/00001-07-07/made.mp3": [
		2370,
		7,
		1045
	],
	"./00001/00001-07/00001-07-07/magnet.mp3": [
		2371,
		7,
		1046
	],
	"./00001/00001-07/00001-07-07/magnets.mp3": [
		2372,
		7,
		1047
	],
	"./00001/00001-07/00001-07-07/main idea.mp3": [
		806,
		7
	],
	"./00001/00001-07/00001-07-07/metal.mp3": [
		2373,
		7,
		1048
	],
	"./00001/00001-07/00001-07-07/module": [
		1210,
		9,
		74
	],
	"./00001/00001-07/00001-07-07/module.js": [
		1210,
		9,
		74
	],
	"./00001/00001-07/00001-07-07/the chipmunk got a nail.mp3": [
		2374,
		7,
		1049
	],
	"./00001/00001-07/00001-07-07/the deer got a helicopter.mp3": [
		2375,
		7,
		1050
	],
	"./00001/00001-07/00001-07-07/the fox got a magnet.mp3": [
		2376,
		7,
		1051
	],
	"./00001/00001-07/00001-07-07/the lion got a rocket.mp3": [
		2377,
		7,
		1052
	],
	"./00001/00001-07/00001-07-07/the sheep got an anchor.mp3": [
		2378,
		7,
		1053
	],
	"./00001/00001-07/00001-07-07/the squirrel got a ball.mp3": [
		2379,
		7,
		1054
	],
	"./00001/00001-07/00001-07-07/the tiger got a car.mp3": [
		2380,
		7,
		1055
	],
	"./00001/00001-07/00001-07-07/things made of metal.mp3": [
		2381,
		7,
		1056
	],
	"./00001/00001-07/00001-07-08/0.jpg": [
		6763,
		7,
		5440
	],
	"./00001/00001-07/00001-07-08/1.jpg": [
		7965,
		7,
		7987
	],
	"./00001/00001-07/00001-07-08/2.jpg": [
		7966,
		7,
		7988
	],
	"./00001/00001-07/00001-07-08/3.jpg": [
		7967,
		7,
		7989
	],
	"./00001/00001-07/00001-07-08/4.jpg": [
		7968,
		7,
		7990
	],
	"./00001/00001-07/00001-07-08/5.jpg": [
		7969,
		7,
		7991
	],
	"./00001/00001-07/00001-07-08/6.jpg": [
		7970,
		7,
		7992
	],
	"./00001/00001-07/00001-07-08/7.jpg": [
		7971,
		7,
		7993
	],
	"./00001/00001-07/00001-07-08/intro.mp3": [
		426,
		7
	],
	"./00001/00001-07/00001-07-08/main idea.mp3": [
		807,
		7
	],
	"./00001/00001-07/00001-07-08/module": [
		1211,
		9,
		75
	],
	"./00001/00001-07/00001-07-08/module.js": [
		1211,
		9,
		75
	],
	"./00001/00001-07/00001-07-08/the bus has 6 wheels.mp3": [
		2382,
		7,
		1057
	],
	"./00001/00001-07/00001-07-08/the car has 4 wheels.mp3": [
		2383,
		7,
		1058
	],
	"./00001/00001-07/00001-07-08/the car truck has 4 wheels.mp3": [
		2384,
		7,
		1059
	],
	"./00001/00001-07/00001-07-08/the dump truck has 4 wheels.mp3": [
		2385,
		7,
		1060
	],
	"./00001/00001-07/00001-07-08/the motorcycle has 2 wheels.mp3": [
		2386,
		7,
		1061
	],
	"./00001/00001-07/00001-07-08/the plane has 3 wheels.mp3": [
		2387,
		7,
		1062
	],
	"./00001/00001-07/00001-07-08/the train has 8 wheels.mp3": [
		2388,
		7,
		1063
	],
	"./00001/00001-07/00001-07-08/the unicycle has 1 wheel.mp3": [
		2389,
		7,
		1064
	],
	"./00001/00001-07/00001-07-08/vehicles.mp3": [
		2390,
		7,
		1065
	],
	"./00001/00001-07/00001-07-08/wheels make things go.mp3": [
		2391,
		7,
		1066
	],
	"./00001/00001-07/00001-07-08/wheels.mp3": [
		2392,
		7,
		1067
	],
	"./00001/00001-07/00001-07-09/0.jpg": [
		6764,
		7,
		5441
	],
	"./00001/00001-07/00001-07-09/1.jpg": [
		7972,
		7,
		7994
	],
	"./00001/00001-07/00001-07-09/2.jpg": [
		7973,
		7,
		7995
	],
	"./00001/00001-07/00001-07-09/3.jpg": [
		7974,
		7,
		7996
	],
	"./00001/00001-07/00001-07-09/4.jpg": [
		7975,
		7,
		7997
	],
	"./00001/00001-07/00001-07-09/5.jpg": [
		7976,
		7,
		7998
	],
	"./00001/00001-07/00001-07-09/6.jpg": [
		7977,
		7,
		7999
	],
	"./00001/00001-07/00001-07-09/7.jpg": [
		7978,
		7,
		8000
	],
	"./00001/00001-07/00001-07-09/intro.mp3": [
		427,
		7
	],
	"./00001/00001-07/00001-07-09/is it cold.mp3": [
		2393,
		7,
		1068
	],
	"./00001/00001-07/00001-07-09/is it hot is it cold.mp3": [
		2394,
		7,
		1069
	],
	"./00001/00001-07/00001-07-09/is it hot.mp3": [
		2395,
		7,
		1070
	],
	"./00001/00001-07/00001-07-09/main idea.mp3": [
		808,
		7
	],
	"./00001/00001-07/00001-07-09/module": [
		1212,
		9,
		76
	],
	"./00001/00001-07/00001-07-09/module.js": [
		1212,
		9,
		76
	],
	"./00001/00001-07/00001-07-09/non living things.mp3": [
		2396,
		7,
		1071
	],
	"./00001/00001-07/00001-07-09/saturn is cold.mp3": [
		2397,
		7,
		1072
	],
	"./00001/00001-07/00001-07-09/the fire is hot.mp3": [
		2398,
		7,
		1073
	],
	"./00001/00001-07/00001-07-09/the fridge is cold.mp3": [
		2399,
		7,
		1074
	],
	"./00001/00001-07/00001-07-09/the iceberg is cold.mp3": [
		2400,
		7,
		1075
	],
	"./00001/00001-07/00001-07-09/the stove is hot.mp3": [
		2401,
		7,
		1076
	],
	"./00001/00001-07/00001-07-09/the sun is hot.mp3": [
		2402,
		7,
		1077
	],
	"./00001/00001-07/00001-07-09/the volcano is hot.mp3": [
		2403,
		7,
		1078
	],
	"./00001/00001-07/00001-07-10/0.jpg": [
		6765,
		7,
		5442
	],
	"./00001/00001-07/00001-07-10/1.jpg": [
		7979,
		7,
		8001
	],
	"./00001/00001-07/00001-07-10/2.jpg": [
		7980,
		7,
		8002
	],
	"./00001/00001-07/00001-07-10/3.jpg": [
		7981,
		7,
		8003
	],
	"./00001/00001-07/00001-07-10/4.jpg": [
		7982,
		7,
		8004
	],
	"./00001/00001-07/00001-07-10/5.jpg": [
		7983,
		7,
		8005
	],
	"./00001/00001-07/00001-07-10/6.jpg": [
		7984,
		7,
		8006
	],
	"./00001/00001-07/00001-07-10/7.jpg": [
		7985,
		7,
		8007
	],
	"./00001/00001-07/00001-07-10/big things.mp3": [
		2404,
		7,
		1079
	],
	"./00001/00001-07/00001-07-10/intro.mp3": [
		428,
		7
	],
	"./00001/00001-07/00001-07-10/main idea.mp3": [
		809,
		7
	],
	"./00001/00001-07/00001-07-10/module": [
		1213,
		9,
		77
	],
	"./00001/00001-07/00001-07-10/module.js": [
		1213,
		9,
		77
	],
	"./00001/00001-07/00001-07-10/this bus is big.mp3": [
		2405,
		7,
		1080
	],
	"./00001/00001-07/00001-07-10/this car is big.mp3": [
		2406,
		7,
		1081
	],
	"./00001/00001-07/00001-07-10/this dump truck is big.mp3": [
		2407,
		7,
		1082
	],
	"./00001/00001-07/00001-07-10/this fire truck is big.mp3": [
		2408,
		7,
		1083
	],
	"./00001/00001-07/00001-07-10/this helicopter is big.mp3": [
		2409,
		7,
		1084
	],
	"./00001/00001-07/00001-07-10/this monster is big.mp3": [
		2410,
		7,
		1085
	],
	"./00001/00001-07/00001-07-10/this plane is big.mp3": [
		2411,
		7,
		1086
	],
	"./00001/00001-07/00001-07-10/vehicles.mp3": [
		2412,
		7,
		1087
	],
	"./00001/00001-07/cover.jpg": [
		6766,
		7,
		5443
	],
	"./00001/00001-07/physical science.mp3": [
		2413,
		7,
		1088
	],
	"./00001/00001-07/unit": [
		1214,
		9,
		78
	],
	"./00001/00001-07/unit.js": [
		1214,
		9,
		78
	],
	"./00001/00001-08/00001-08-01/0.jpg": [
		6767,
		7,
		5444
	],
	"./00001/00001-08/00001-08-01/1.jpg": [
		7986,
		7,
		8008
	],
	"./00001/00001-08/00001-08-01/2.jpg": [
		7987,
		7,
		8009
	],
	"./00001/00001-08/00001-08-01/3.jpg": [
		7988,
		7,
		8010
	],
	"./00001/00001-08/00001-08-01/4.jpg": [
		7989,
		7,
		8011
	],
	"./00001/00001-08/00001-08-01/5.jpg": [
		7990,
		7,
		8012
	],
	"./00001/00001-08/00001-08-01/6.jpg": [
		7991,
		7,
		8013
	],
	"./00001/00001-08/00001-08-01/7.jpg": [
		7992,
		7,
		8014
	],
	"./00001/00001-08/00001-08-01/intro.mp3": [
		429,
		7
	],
	"./00001/00001-08/00001-08-01/main idea.mp3": [
		810,
		7
	],
	"./00001/00001-08/00001-08-01/module": [
		1215,
		9,
		79
	],
	"./00001/00001-08/00001-08-01/module.js": [
		1215,
		9,
		79
	],
	"./00001/00001-08/00001-08-01/things on the earth.mp3": [
		2414,
		7,
		1089
	],
	"./00001/00001-08/00001-08-01/we love the animals.mp3": [
		2415,
		7,
		1090
	],
	"./00001/00001-08/00001-08-01/we love the earth.mp3": [
		2416,
		7,
		1091
	],
	"./00001/00001-08/00001-08-01/we love the forests.mp3": [
		2417,
		7,
		1092
	],
	"./00001/00001-08/00001-08-01/we love the lakes.mp3": [
		2418,
		7,
		1093
	],
	"./00001/00001-08/00001-08-01/we love the mountains.mp3": [
		2419,
		7,
		1094
	],
	"./00001/00001-08/00001-08-01/we love the rivers.mp3": [
		2420,
		7,
		1095
	],
	"./00001/00001-08/00001-08-01/we love the sea.mp3": [
		2421,
		7,
		1096
	],
	"./00001/00001-08/00001-08-02/0.jpg": [
		6768,
		7,
		5445
	],
	"./00001/00001-08/00001-08-02/1.jpg": [
		7993,
		7,
		8015
	],
	"./00001/00001-08/00001-08-02/2.jpg": [
		7994,
		7,
		8016
	],
	"./00001/00001-08/00001-08-02/3.jpg": [
		7995,
		7,
		8017
	],
	"./00001/00001-08/00001-08-02/4.jpg": [
		7996,
		7,
		8018
	],
	"./00001/00001-08/00001-08-02/5.jpg": [
		7997,
		7,
		8019
	],
	"./00001/00001-08/00001-08-02/6.jpg": [
		7998,
		7,
		8020
	],
	"./00001/00001-08/00001-08-02/7.jpg": [
		7999,
		7,
		8021
	],
	"./00001/00001-08/00001-08-02/earth is the 3rd planet.mp3": [
		2422,
		7,
		1097
	],
	"./00001/00001-08/00001-08-02/intro.mp3": [
		430,
		7
	],
	"./00001/00001-08/00001-08-02/jupiter is the 5th planet.mp3": [
		2423,
		7,
		1098
	],
	"./00001/00001-08/00001-08-02/main idea.mp3": [
		811,
		7
	],
	"./00001/00001-08/00001-08-02/mars is the 4th planet.mp3": [
		2424,
		7,
		1099
	],
	"./00001/00001-08/00001-08-02/mercury is the 1st planet.mp3": [
		2425,
		7,
		1100
	],
	"./00001/00001-08/00001-08-02/module": [
		1216,
		9,
		80
	],
	"./00001/00001-08/00001-08-02/module.js": [
		1216,
		9,
		80
	],
	"./00001/00001-08/00001-08-02/neptune is the 8th planet.mp3": [
		2426,
		7,
		1101
	],
	"./00001/00001-08/00001-08-02/saturn is the 6th planet.mp3": [
		2427,
		7,
		1102
	],
	"./00001/00001-08/00001-08-02/the planets.mp3": [
		2428,
		7,
		1103
	],
	"./00001/00001-08/00001-08-02/things in space.mp3": [
		2429,
		7,
		1104
	],
	"./00001/00001-08/00001-08-02/uranus is the 7th planet.mp3": [
		2430,
		7,
		1105
	],
	"./00001/00001-08/00001-08-02/venus is the 2nd planet.mp3": [
		2431,
		7,
		1106
	],
	"./00001/00001-08/00001-08-03/0.jpg": [
		6769,
		7,
		5446
	],
	"./00001/00001-08/00001-08-03/1.jpg": [
		8000,
		7,
		8022
	],
	"./00001/00001-08/00001-08-03/2.jpg": [
		8001,
		7,
		8023
	],
	"./00001/00001-08/00001-08-03/3.jpg": [
		8002,
		7,
		8024
	],
	"./00001/00001-08/00001-08-03/4.jpg": [
		8003,
		7,
		8025
	],
	"./00001/00001-08/00001-08-03/5.jpg": [
		8004,
		7,
		8026
	],
	"./00001/00001-08/00001-08-03/6.jpg": [
		8005,
		7,
		8027
	],
	"./00001/00001-08/00001-08-03/7.jpg": [
		8006,
		7,
		8028
	],
	"./00001/00001-08/00001-08-03/animals that live in the snow.mp3": [
		2432,
		7,
		1107
	],
	"./00001/00001-08/00001-08-03/in the winter.mp3": [
		2433,
		7,
		1108
	],
	"./00001/00001-08/00001-08-03/intro.mp3": [
		431,
		7
	],
	"./00001/00001-08/00001-08-03/look at the bear.mp3": [
		2434,
		7,
		1109
	],
	"./00001/00001-08/00001-08-03/look at the frost.mp3": [
		2435,
		7,
		1110
	],
	"./00001/00001-08/00001-08-03/look at the ice.mp3": [
		2436,
		7,
		1111
	],
	"./00001/00001-08/00001-08-03/look at the mountains.mp3": [
		2437,
		7,
		1112
	],
	"./00001/00001-08/00001-08-03/look at the pond.mp3": [
		2438,
		7,
		1113
	],
	"./00001/00001-08/00001-08-03/look at the river.mp3": [
		2439,
		7,
		1114
	],
	"./00001/00001-08/00001-08-03/look at the trees.mp3": [
		2440,
		7,
		1115
	],
	"./00001/00001-08/00001-08-03/main idea.mp3": [
		812,
		7
	],
	"./00001/00001-08/00001-08-03/module": [
		1217,
		9,
		81
	],
	"./00001/00001-08/00001-08-03/module.js": [
		1217,
		9,
		81
	],
	"./00001/00001-08/00001-08-04/0.jpg": [
		6770,
		7,
		5447
	],
	"./00001/00001-08/00001-08-04/1.jpg": [
		8007,
		7,
		8029
	],
	"./00001/00001-08/00001-08-04/2.jpg": [
		8008,
		7,
		8030
	],
	"./00001/00001-08/00001-08-04/3.jpg": [
		8009,
		7,
		8031
	],
	"./00001/00001-08/00001-08-04/4.jpg": [
		8010,
		7,
		8032
	],
	"./00001/00001-08/00001-08-04/5.jpg": [
		8011,
		7,
		8033
	],
	"./00001/00001-08/00001-08-04/6.jpg": [
		8012,
		7,
		8034
	],
	"./00001/00001-08/00001-08-04/7.jpg": [
		8013,
		7,
		8035
	],
	"./00001/00001-08/00001-08-04/i can see 2 lambs.mp3": [
		2441,
		7,
		1116
	],
	"./00001/00001-08/00001-08-04/i can see 3 frogs.mp3": [
		2442,
		7,
		1117
	],
	"./00001/00001-08/00001-08-04/i can see 4 chicks.mp3": [
		2443,
		7,
		1118
	],
	"./00001/00001-08/00001-08-04/i can see 5 ducklings.mp3": [
		2444,
		7,
		1119
	],
	"./00001/00001-08/00001-08-04/i can see 6 butterflies.mp3": [
		2445,
		7,
		1120
	],
	"./00001/00001-08/00001-08-04/i can see 7 flowers.mp3": [
		2446,
		7,
		1121
	],
	"./00001/00001-08/00001-08-04/i can see the 4 chicks.mp3": [
		2447,
		7,
		1122
	],
	"./00001/00001-08/00001-08-04/i can see the 5 ducklings.mp3": [
		2448,
		7,
		1123
	],
	"./00001/00001-08/00001-08-04/i can see the rain.mp3": [
		2449,
		7,
		1124
	],
	"./00001/00001-08/00001-08-04/intro.mp3": [
		432,
		7
	],
	"./00001/00001-08/00001-08-04/main idea.mp3": [
		813,
		7
	],
	"./00001/00001-08/00001-08-04/module": [
		1218,
		9,
		82
	],
	"./00001/00001-08/00001-08-04/module.js": [
		1218,
		9,
		82
	],
	"./00001/00001-08/00001-08-04/signs of spring.mp3": [
		2450,
		7,
		1125
	],
	"./00001/00001-08/00001-08-04/spring is here.mp3": [
		2451,
		7,
		1126
	],
	"./00001/00001-08/00001-08-04/spring is on the way.mp3": [
		2452,
		7,
		1127
	],
	"./00001/00001-08/00001-08-04/what can i see.mp3": [
		2453,
		7,
		1128
	],
	"./00001/00001-08/00001-08-05/0.jpg": [
		6771,
		7,
		5448
	],
	"./00001/00001-08/00001-08-05/1.jpg": [
		8014,
		7,
		8036
	],
	"./00001/00001-08/00001-08-05/2.jpg": [
		8015,
		7,
		8037
	],
	"./00001/00001-08/00001-08-05/3.jpg": [
		8016,
		7,
		8038
	],
	"./00001/00001-08/00001-08-05/4.jpg": [
		8017,
		7,
		8039
	],
	"./00001/00001-08/00001-08-05/5.jpg": [
		8018,
		7,
		8040
	],
	"./00001/00001-08/00001-08-05/6.jpg": [
		8019,
		7,
		8041
	],
	"./00001/00001-08/00001-08-05/7.jpg": [
		8020,
		7,
		8042
	],
	"./00001/00001-08/00001-08-05/i like summer.mp3": [
		2454,
		7,
		1129
	],
	"./00001/00001-08/00001-08-05/i like the hermit crab.mp3": [
		2455,
		7,
		1130
	],
	"./00001/00001-08/00001-08-05/i like the sandcastle.mp3": [
		2456,
		7,
		1131
	],
	"./00001/00001-08/00001-08-05/i like the sea.mp3": [
		2457,
		7,
		1132
	],
	"./00001/00001-08/00001-08-05/i like the seagull.mp3": [
		2458,
		7,
		1133
	],
	"./00001/00001-08/00001-08-05/i like the shell.mp3": [
		2459,
		7,
		1134
	],
	"./00001/00001-08/00001-08-05/i like the starfish.mp3": [
		2460,
		7,
		1135
	],
	"./00001/00001-08/00001-08-05/i like the sun.mp3": [
		2461,
		7,
		1136
	],
	"./00001/00001-08/00001-08-05/intro.mp3": [
		433,
		7
	],
	"./00001/00001-08/00001-08-05/main idea.mp3": [
		814,
		7
	],
	"./00001/00001-08/00001-08-05/module": [
		1219,
		9,
		83
	],
	"./00001/00001-08/00001-08-05/module.js": [
		1219,
		9,
		83
	],
	"./00001/00001-08/00001-08-05/sea animals.mp3": [
		2462,
		7,
		1137
	],
	"./00001/00001-08/00001-08-06/0.jpg": [
		6772,
		7,
		5449
	],
	"./00001/00001-08/00001-08-06/1.jpg": [
		8021,
		7,
		8043
	],
	"./00001/00001-08/00001-08-06/2.jpg": [
		8022,
		7,
		8044
	],
	"./00001/00001-08/00001-08-06/3.jpg": [
		8023,
		7,
		8045
	],
	"./00001/00001-08/00001-08-06/4.jpg": [
		8024,
		7,
		8046
	],
	"./00001/00001-08/00001-08-06/5.jpg": [
		8025,
		7,
		8047
	],
	"./00001/00001-08/00001-08-06/6.jpg": [
		8026,
		7,
		8048
	],
	"./00001/00001-08/00001-08-06/7.jpg": [
		8027,
		7,
		8049
	],
	"./00001/00001-08/00001-08-06/colors in the fall.mp3": [
		2463,
		7,
		1138
	],
	"./00001/00001-08/00001-08-06/intro.mp3": [
		434,
		7
	],
	"./00001/00001-08/00001-08-06/look at the brown nuts.mp3": [
		2464,
		7,
		1139
	],
	"./00001/00001-08/00001-08-06/look at the gray geese.mp3": [
		2465,
		7,
		1140
	],
	"./00001/00001-08/00001-08-06/look at the green apples.mp3": [
		2466,
		7,
		1141
	],
	"./00001/00001-08/00001-08-06/look at the orange pumpkin.mp3": [
		2467,
		7,
		1142
	],
	"./00001/00001-08/00001-08-06/look at the purple grapes.mp3": [
		2468,
		7,
		1143
	],
	"./00001/00001-08/00001-08-06/look at the red leaves.mp3": [
		2469,
		7,
		1144
	],
	"./00001/00001-08/00001-08-06/look at the yellow hay.mp3": [
		2470,
		7,
		1145
	],
	"./00001/00001-08/00001-08-06/main idea.mp3": [
		815,
		7
	],
	"./00001/00001-08/00001-08-06/module": [
		1220,
		9,
		84
	],
	"./00001/00001-08/00001-08-06/module.js": [
		1220,
		9,
		84
	],
	"./00001/00001-08/00001-08-06/things we see in the fall.mp3": [
		2471,
		7,
		1146
	],
	"./00001/00001-08/00001-08-07/0.jpg": [
		6773,
		7,
		5450
	],
	"./00001/00001-08/00001-08-07/1.jpg": [
		8028,
		7,
		8050
	],
	"./00001/00001-08/00001-08-07/2.jpg": [
		8029,
		7,
		8051
	],
	"./00001/00001-08/00001-08-07/3.jpg": [
		8030,
		7,
		8052
	],
	"./00001/00001-08/00001-08-07/4.jpg": [
		8031,
		7,
		8053
	],
	"./00001/00001-08/00001-08-07/5.jpg": [
		8032,
		7,
		8054
	],
	"./00001/00001-08/00001-08-07/6.jpg": [
		8033,
		7,
		8055
	],
	"./00001/00001-08/00001-08-07/7.jpg": [
		8034,
		7,
		8056
	],
	"./00001/00001-08/00001-08-07/intro.mp3": [
		435,
		7
	],
	"./00001/00001-08/00001-08-07/main idea.mp3": [
		816,
		7
	],
	"./00001/00001-08/00001-08-07/module": [
		1221,
		9,
		85
	],
	"./00001/00001-08/00001-08-07/module.js": [
		1221,
		9,
		85
	],
	"./00001/00001-08/00001-08-07/things we see in the soil.mp3": [
		2472,
		7,
		1147
	],
	"./00001/00001-08/00001-08-07/we can see ants.mp3": [
		2473,
		7,
		1148
	],
	"./00001/00001-08/00001-08-07/we can see bones.mp3": [
		2474,
		7,
		1149
	],
	"./00001/00001-08/00001-08-07/we can see leaves.mp3": [
		2475,
		7,
		1150
	],
	"./00001/00001-08/00001-08-07/we can see rocks.mp3": [
		2476,
		7,
		1151
	],
	"./00001/00001-08/00001-08-07/we can see roots.mp3": [
		2477,
		7,
		1152
	],
	"./00001/00001-08/00001-08-07/we can see shells.mp3": [
		2478,
		7,
		1153
	],
	"./00001/00001-08/00001-08-07/we can see worms.mp3": [
		2479,
		7,
		1154
	],
	"./00001/00001-08/00001-08-07/what is in the soil.mp3": [
		2480,
		7,
		1155
	],
	"./00001/00001-08/00001-08-08/0.jpg": [
		6774,
		7,
		5451
	],
	"./00001/00001-08/00001-08-08/1.jpg": [
		8035,
		7,
		8057
	],
	"./00001/00001-08/00001-08-08/2.jpg": [
		8036,
		7,
		8058
	],
	"./00001/00001-08/00001-08-08/3.jpg": [
		8037,
		7,
		8059
	],
	"./00001/00001-08/00001-08-08/4.jpg": [
		8038,
		7,
		8060
	],
	"./00001/00001-08/00001-08-08/5.jpg": [
		8039,
		7,
		8061
	],
	"./00001/00001-08/00001-08-08/6.jpg": [
		8040,
		7,
		8062
	],
	"./00001/00001-08/00001-08-08/7.jpg": [
		8041,
		7,
		8063
	],
	"./00001/00001-08/00001-08-08/alligator likes the green rock.mp3": [
		2481,
		7,
		1156
	],
	"./00001/00001-08/00001-08-08/cheetah likes the yellow rock.mp3": [
		2482,
		7,
		1157
	],
	"./00001/00001-08/00001-08-08/chipmunk likes the brown rock.mp3": [
		2483,
		7,
		1158
	],
	"./00001/00001-08/00001-08-08/elephant likes the gray rock.mp3": [
		2484,
		7,
		1159
	],
	"./00001/00001-08/00001-08-08/fox likes the red rock.mp3": [
		2485,
		7,
		1160
	],
	"./00001/00001-08/00001-08-08/intro.mp3": [
		436,
		7
	],
	"./00001/00001-08/00001-08-08/main idea.mp3": [
		817,
		7
	],
	"./00001/00001-08/00001-08-08/module": [
		1222,
		9,
		86
	],
	"./00001/00001-08/00001-08-08/module.js": [
		1222,
		9,
		86
	],
	"./00001/00001-08/00001-08-08/non living things.mp3": [
		2486,
		7,
		1161
	],
	"./00001/00001-08/00001-08-08/rocks.mp3": [
		2487,
		7,
		1162
	],
	"./00001/00001-08/00001-08-08/skunk likes the black rock.mp3": [
		2488,
		7,
		1163
	],
	"./00001/00001-08/00001-08-08/tiger likes the orange rock.mp3": [
		2489,
		7,
		1164
	],
	"./00001/00001-08/00001-08-09/0.jpg": [
		6775,
		7,
		5452
	],
	"./00001/00001-08/00001-08-09/1.jpg": [
		8042,
		7,
		8064
	],
	"./00001/00001-08/00001-08-09/2.jpg": [
		8043,
		7,
		8065
	],
	"./00001/00001-08/00001-08-09/3.jpg": [
		8044,
		7,
		8066
	],
	"./00001/00001-08/00001-08-09/4.jpg": [
		8045,
		7,
		8067
	],
	"./00001/00001-08/00001-08-09/5.jpg": [
		8046,
		7,
		8068
	],
	"./00001/00001-08/00001-08-09/6.jpg": [
		8047,
		7,
		8069
	],
	"./00001/00001-08/00001-08-09/7.jpg": [
		8048,
		7,
		8070
	],
	"./00001/00001-08/00001-08-09/intro.mp3": [
		437,
		7
	],
	"./00001/00001-08/00001-08-09/main idea.mp3": [
		818,
		7
	],
	"./00001/00001-08/00001-08-09/module": [
		1223,
		9,
		87
	],
	"./00001/00001-08/00001-08-09/module.js": [
		1223,
		9,
		87
	],
	"./00001/00001-08/00001-08-09/things in the sky.mp3": [
		2490,
		7,
		1165
	],
	"./00001/00001-08/00001-08-09/what can you see in the sky.mp3": [
		2491,
		7,
		1166
	],
	"./00001/00001-08/00001-08-09/you can see a dragon.mp3": [
		2492,
		7,
		1167
	],
	"./00001/00001-08/00001-08-09/you can see the clouds.mp3": [
		2493,
		7,
		1168
	],
	"./00001/00001-08/00001-08-09/you can see the moon.mp3": [
		2494,
		7,
		1169
	],
	"./00001/00001-08/00001-08-09/you can see the rain.mp3": [
		2495,
		7,
		1170
	],
	"./00001/00001-08/00001-08-09/you can see the rainbow.mp3": [
		2496,
		7,
		1171
	],
	"./00001/00001-08/00001-08-09/you can see the stars.mp3": [
		2497,
		7,
		1172
	],
	"./00001/00001-08/00001-08-09/you can see the sun.mp3": [
		2498,
		7,
		1173
	],
	"./00001/00001-08/00001-08-10/0.jpg": [
		6776,
		7,
		5453
	],
	"./00001/00001-08/00001-08-10/1.jpg": [
		8049,
		7,
		8071
	],
	"./00001/00001-08/00001-08-10/2.jpg": [
		8050,
		7,
		8072
	],
	"./00001/00001-08/00001-08-10/3.jpg": [
		8051,
		7,
		8073
	],
	"./00001/00001-08/00001-08-10/4.jpg": [
		8052,
		7,
		8074
	],
	"./00001/00001-08/00001-08-10/5.jpg": [
		8053,
		7,
		8075
	],
	"./00001/00001-08/00001-08-10/6.jpg": [
		8054,
		7,
		8076
	],
	"./00001/00001-08/00001-08-10/7.jpg": [
		8055,
		7,
		8077
	],
	"./00001/00001-08/00001-08-10/intro.mp3": [
		438,
		7
	],
	"./00001/00001-08/00001-08-10/it is a cloudy day.mp3": [
		2499,
		7,
		1174
	],
	"./00001/00001-08/00001-08-10/it is a rainy day.mp3": [
		2500,
		7,
		1175
	],
	"./00001/00001-08/00001-08-10/it is a rainy night.mp3": [
		2501,
		7,
		1176
	],
	"./00001/00001-08/00001-08-10/it is a snowy day.mp3": [
		2502,
		7,
		1177
	],
	"./00001/00001-08/00001-08-10/it is a snowy night.mp3": [
		2503,
		7,
		1178
	],
	"./00001/00001-08/00001-08-10/it is a sunny day.mp3": [
		2504,
		7,
		1179
	],
	"./00001/00001-08/00001-08-10/it is a windy day.mp3": [
		2505,
		7,
		1180
	],
	"./00001/00001-08/00001-08-10/main idea.mp3": [
		819,
		7
	],
	"./00001/00001-08/00001-08-10/module": [
		1224,
		9,
		88
	],
	"./00001/00001-08/00001-08-10/module.js": [
		1224,
		9,
		88
	],
	"./00001/00001-08/00001-08-10/weather.mp3": [
		2506,
		7,
		1181
	],
	"./00001/00001-08/cover.jpg": [
		6777,
		7,
		5454
	],
	"./00001/00001-08/earth and space.mp3": [
		2507,
		7,
		1182
	],
	"./00001/00001-08/unit": [
		1225,
		9,
		89
	],
	"./00001/00001-08/unit.js": [
		1225,
		9,
		89
	],
	"./00001/00001-09/00001-09-01/0.jpg": [
		6778,
		7,
		5455
	],
	"./00001/00001-09/00001-09-01/1.jpg": [
		8056,
		7,
		8078
	],
	"./00001/00001-09/00001-09-01/2.jpg": [
		8057,
		7,
		8079
	],
	"./00001/00001-09/00001-09-01/3.jpg": [
		8058,
		7,
		8080
	],
	"./00001/00001-09/00001-09-01/4.jpg": [
		8059,
		7,
		8081
	],
	"./00001/00001-09/00001-09-01/5.jpg": [
		8060,
		7,
		8082
	],
	"./00001/00001-09/00001-09-01/6.jpg": [
		8061,
		7,
		8083
	],
	"./00001/00001-09/00001-09-01/7.jpg": [
		8062,
		7,
		8084
	],
	"./00001/00001-09/00001-09-01/fish.mp3": [
		2508,
		7,
		1183
	],
	"./00001/00001-09/00001-09-01/i see the clown fish.mp3": [
		2509,
		7,
		1184
	],
	"./00001/00001-09/00001-09-01/i see the eel.mp3": [
		2510,
		7,
		1185
	],
	"./00001/00001-09/00001-09-01/i see the flying fish.mp3": [
		2511,
		7,
		1186
	],
	"./00001/00001-09/00001-09-01/i see the hammerhead shark.mp3": [
		2512,
		7,
		1187
	],
	"./00001/00001-09/00001-09-01/i see the seahorse.mp3": [
		2513,
		7,
		1188
	],
	"./00001/00001-09/00001-09-01/i see the shark.mp3": [
		2514,
		7,
		1189
	],
	"./00001/00001-09/00001-09-01/i see the swordfish.mp3": [
		2515,
		7,
		1190
	],
	"./00001/00001-09/00001-09-01/intro.mp3": [
		439,
		7
	],
	"./00001/00001-09/00001-09-01/main idea.mp3": [
		820,
		7
	],
	"./00001/00001-09/00001-09-01/module": [
		1226,
		9,
		90
	],
	"./00001/00001-09/00001-09-01/module.js": [
		1226,
		9,
		90
	],
	"./00001/00001-09/00001-09-02/0.jpg": [
		6779,
		7,
		5456
	],
	"./00001/00001-09/00001-09-02/1.jpg": [
		8063,
		7,
		8085
	],
	"./00001/00001-09/00001-09-02/2.jpg": [
		8064,
		7,
		8086
	],
	"./00001/00001-09/00001-09-02/3.jpg": [
		8065,
		7,
		8087
	],
	"./00001/00001-09/00001-09-02/4.jpg": [
		8066,
		7,
		8088
	],
	"./00001/00001-09/00001-09-02/5.jpg": [
		8067,
		7,
		8089
	],
	"./00001/00001-09/00001-09-02/6.jpg": [
		8068,
		7,
		8090
	],
	"./00001/00001-09/00001-09-02/7.jpg": [
		8069,
		7,
		8091
	],
	"./00001/00001-09/00001-09-02/i like the bat.mp3": [
		2516,
		7,
		1191
	],
	"./00001/00001-09/00001-09-02/i like the fox.mp3": [
		2517,
		7,
		1192
	],
	"./00001/00001-09/00001-09-02/i like the panda.mp3": [
		2518,
		7,
		1193
	],
	"./00001/00001-09/00001-09-02/i like the skunk.mp3": [
		2519,
		7,
		1194
	],
	"./00001/00001-09/00001-09-02/i like the tiger.mp3": [
		2520,
		7,
		1195
	],
	"./00001/00001-09/00001-09-02/i like the whale.mp3": [
		2521,
		7,
		1196
	],
	"./00001/00001-09/00001-09-02/i like the zebra.mp3": [
		2522,
		7,
		1197
	],
	"./00001/00001-09/00001-09-02/intro.mp3": [
		440,
		7
	],
	"./00001/00001-09/00001-09-02/main idea.mp3": [
		821,
		7
	],
	"./00001/00001-09/00001-09-02/mammals.mp3": [
		2523,
		7,
		1198
	],
	"./00001/00001-09/00001-09-02/module": [
		1227,
		9,
		91
	],
	"./00001/00001-09/00001-09-02/module.js": [
		1227,
		9,
		91
	],
	"./00001/00001-09/00001-09-03/0.jpg": [
		6780,
		7,
		5457
	],
	"./00001/00001-09/00001-09-03/1.jpg": [
		8070,
		7,
		8092
	],
	"./00001/00001-09/00001-09-03/2.jpg": [
		8071,
		7,
		8093
	],
	"./00001/00001-09/00001-09-03/3.jpg": [
		8072,
		7,
		8094
	],
	"./00001/00001-09/00001-09-03/4.jpg": [
		8073,
		7,
		8095
	],
	"./00001/00001-09/00001-09-03/5.jpg": [
		8074,
		7,
		8096
	],
	"./00001/00001-09/00001-09-03/6.jpg": [
		8075,
		7,
		8097
	],
	"./00001/00001-09/00001-09-03/7.jpg": [
		8076,
		7,
		8098
	],
	"./00001/00001-09/00001-09-03/intro.mp3": [
		441,
		7
	],
	"./00001/00001-09/00001-09-03/look at the alligator.mp3": [
		2524,
		7,
		1199
	],
	"./00001/00001-09/00001-09-03/look at the crocodile.mp3": [
		2525,
		7,
		1200
	],
	"./00001/00001-09/00001-09-03/look at the iguana.mp3": [
		2526,
		7,
		1201
	],
	"./00001/00001-09/00001-09-03/look at the lizard.mp3": [
		2527,
		7,
		1202
	],
	"./00001/00001-09/00001-09-03/look at the sea turtle.mp3": [
		2528,
		7,
		1203
	],
	"./00001/00001-09/00001-09-03/look at the snake.mp3": [
		2529,
		7,
		1204
	],
	"./00001/00001-09/00001-09-03/look at the turtle.mp3": [
		2530,
		7,
		1205
	],
	"./00001/00001-09/00001-09-03/main idea.mp3": [
		822,
		7
	],
	"./00001/00001-09/00001-09-03/module": [
		1228,
		9,
		92
	],
	"./00001/00001-09/00001-09-03/module.js": [
		1228,
		9,
		92
	],
	"./00001/00001-09/00001-09-03/reptiles.mp3": [
		2531,
		7,
		1206
	],
	"./00001/00001-09/00001-09-04/0.jpg": [
		6781,
		7,
		5458
	],
	"./00001/00001-09/00001-09-04/1.jpg": [
		8077,
		7,
		8099
	],
	"./00001/00001-09/00001-09-04/2.jpg": [
		8078,
		7,
		8100
	],
	"./00001/00001-09/00001-09-04/3.jpg": [
		8079,
		7,
		8101
	],
	"./00001/00001-09/00001-09-04/4.jpg": [
		8080,
		7,
		8102
	],
	"./00001/00001-09/00001-09-04/5.jpg": [
		8081,
		7,
		8103
	],
	"./00001/00001-09/00001-09-04/6.jpg": [
		8082,
		7,
		8104
	],
	"./00001/00001-09/00001-09-04/7.jpg": [
		8083,
		7,
		8105
	],
	"./00001/00001-09/00001-09-04/amphibians.mp3": [
		2532,
		7,
		1207
	],
	"./00001/00001-09/00001-09-04/i can see 1 frog.mp3": [
		2533,
		7,
		1208
	],
	"./00001/00001-09/00001-09-04/i can see 1 salamander.mp3": [
		2534,
		7,
		1209
	],
	"./00001/00001-09/00001-09-04/i can see 1 toad.mp3": [
		2535,
		7,
		1210
	],
	"./00001/00001-09/00001-09-04/i can see 2 frogs.mp3": [
		2536,
		7,
		1211
	],
	"./00001/00001-09/00001-09-04/i can see 2 salamanders.mp3": [
		2537,
		7,
		1212
	],
	"./00001/00001-09/00001-09-04/i can see 2 toads.mp3": [
		2538,
		7,
		1213
	],
	"./00001/00001-09/00001-09-04/i can see 6 amphibians.mp3": [
		2539,
		7,
		1214
	],
	"./00001/00001-09/00001-09-04/intro.mp3": [
		442,
		7
	],
	"./00001/00001-09/00001-09-04/main idea.mp3": [
		823,
		7
	],
	"./00001/00001-09/00001-09-04/module": [
		1229,
		9,
		93
	],
	"./00001/00001-09/00001-09-04/module.js": [
		1229,
		9,
		93
	],
	"./00001/00001-09/00001-09-05/0.jpg": [
		6782,
		7,
		5459
	],
	"./00001/00001-09/00001-09-05/1.jpg": [
		8084,
		7,
		8106
	],
	"./00001/00001-09/00001-09-05/2.jpg": [
		8085,
		7,
		8107
	],
	"./00001/00001-09/00001-09-05/3.jpg": [
		8086,
		7,
		8108
	],
	"./00001/00001-09/00001-09-05/4.jpg": [
		8087,
		7,
		8109
	],
	"./00001/00001-09/00001-09-05/5.jpg": [
		8088,
		7,
		8110
	],
	"./00001/00001-09/00001-09-05/6.jpg": [
		8089,
		7,
		8111
	],
	"./00001/00001-09/00001-09-05/7.jpg": [
		8090,
		7,
		8112
	],
	"./00001/00001-09/00001-09-05/birds.mp3": [
		2540,
		7,
		1215
	],
	"./00001/00001-09/00001-09-05/intro.mp3": [
		443,
		7
	],
	"./00001/00001-09/00001-09-05/main idea.mp3": [
		824,
		7
	],
	"./00001/00001-09/00001-09-05/module": [
		1230,
		9,
		94
	],
	"./00001/00001-09/00001-09-05/module.js": [
		1230,
		9,
		94
	],
	"./00001/00001-09/00001-09-05/the bat is not a bird.mp3": [
		2541,
		7,
		1216
	],
	"./00001/00001-09/00001-09-05/the duck is a bird.mp3": [
		2542,
		7,
		1217
	],
	"./00001/00001-09/00001-09-05/the eagle is a bird.mp3": [
		2543,
		7,
		1218
	],
	"./00001/00001-09/00001-09-05/the flamingo is a bird.mp3": [
		2544,
		7,
		1219
	],
	"./00001/00001-09/00001-09-05/the ostrich is a bird.mp3": [
		2545,
		7,
		1220
	],
	"./00001/00001-09/00001-09-05/the penguin is a bird.mp3": [
		2546,
		7,
		1221
	],
	"./00001/00001-09/00001-09-05/the rooster is a bird.mp3": [
		2547,
		7,
		1222
	],
	"./00001/00001-09/00001-09-06/0.jpg": [
		6783,
		7,
		5460
	],
	"./00001/00001-09/00001-09-06/1.jpg": [
		8091,
		7,
		8113
	],
	"./00001/00001-09/00001-09-06/2.jpg": [
		8092,
		7,
		8114
	],
	"./00001/00001-09/00001-09-06/3.jpg": [
		8093,
		7,
		8115
	],
	"./00001/00001-09/00001-09-06/4.jpg": [
		8094,
		7,
		8116
	],
	"./00001/00001-09/00001-09-06/5.jpg": [
		8095,
		7,
		8117
	],
	"./00001/00001-09/00001-09-06/6.jpg": [
		8096,
		7,
		8118
	],
	"./00001/00001-09/00001-09-06/7.jpg": [
		8097,
		7,
		8119
	],
	"./00001/00001-09/00001-09-06/animals without backbones.mp3": [
		2548,
		7,
		1223
	],
	"./00001/00001-09/00001-09-06/here is a butterfly.mp3": [
		2549,
		7,
		1224
	],
	"./00001/00001-09/00001-09-06/here is a jellyfish.mp3": [
		2550,
		7,
		1225
	],
	"./00001/00001-09/00001-09-06/here is a ladybug.mp3": [
		2551,
		7,
		1226
	],
	"./00001/00001-09/00001-09-06/here is a lobster.mp3": [
		2552,
		7,
		1227
	],
	"./00001/00001-09/00001-09-06/here is a slug.mp3": [
		2553,
		7,
		1228
	],
	"./00001/00001-09/00001-09-06/here is a squid.mp3": [
		2554,
		7,
		1229
	],
	"./00001/00001-09/00001-09-06/here is a starfish.mp3": [
		2555,
		7,
		1230
	],
	"./00001/00001-09/00001-09-06/intro.mp3": [
		444,
		7
	],
	"./00001/00001-09/00001-09-06/main idea.mp3": [
		825,
		7
	],
	"./00001/00001-09/00001-09-06/module": [
		1231,
		9,
		95
	],
	"./00001/00001-09/00001-09-06/module.js": [
		1231,
		9,
		95
	],
	"./00001/00001-09/00001-09-07/0.jpg": [
		6784,
		7,
		5461
	],
	"./00001/00001-09/00001-09-07/1.jpg": [
		8098,
		7,
		8120
	],
	"./00001/00001-09/00001-09-07/2.jpg": [
		8099,
		7,
		8121
	],
	"./00001/00001-09/00001-09-07/3.jpg": [
		8100,
		7,
		8122
	],
	"./00001/00001-09/00001-09-07/4.jpg": [
		8101,
		7,
		8123
	],
	"./00001/00001-09/00001-09-07/5.jpg": [
		8102,
		7,
		8124
	],
	"./00001/00001-09/00001-09-07/6.jpg": [
		8103,
		7,
		8125
	],
	"./00001/00001-09/00001-09-07/7.jpg": [
		8104,
		7,
		8126
	],
	"./00001/00001-09/00001-09-07/ants are insects.mp3": [
		2556,
		7,
		1231
	],
	"./00001/00001-09/00001-09-07/bees are insects.mp3": [
		2557,
		7,
		1232
	],
	"./00001/00001-09/00001-09-07/butterflies are insects.mp3": [
		2558,
		7,
		1233
	],
	"./00001/00001-09/00001-09-07/grasshoppers are insects.mp3": [
		2559,
		7,
		1234
	],
	"./00001/00001-09/00001-09-07/insects.mp3": [
		2560,
		7,
		1235
	],
	"./00001/00001-09/00001-09-07/intro.mp3": [
		445,
		7
	],
	"./00001/00001-09/00001-09-07/ladybugs are insects.mp3": [
		2561,
		7,
		1236
	],
	"./00001/00001-09/00001-09-07/main idea.mp3": [
		826,
		7
	],
	"./00001/00001-09/00001-09-07/module": [
		1232,
		9,
		96
	],
	"./00001/00001-09/00001-09-07/module.js": [
		1232,
		9,
		96
	],
	"./00001/00001-09/00001-09-07/praying mantises are insects.mp3": [
		2562,
		7,
		1237
	],
	"./00001/00001-09/00001-09-07/spiders are not insects.mp3": [
		2563,
		7,
		1238
	],
	"./00001/00001-09/00001-09-08/0.jpg": [
		6785,
		7,
		5462
	],
	"./00001/00001-09/00001-09-08/1.jpg": [
		8105,
		7,
		8127
	],
	"./00001/00001-09/00001-09-08/2.jpg": [
		8106,
		7,
		8128
	],
	"./00001/00001-09/00001-09-08/3.jpg": [
		8107,
		7,
		8129
	],
	"./00001/00001-09/00001-09-08/4.jpg": [
		8108,
		7,
		8130
	],
	"./00001/00001-09/00001-09-08/5.jpg": [
		8109,
		7,
		8131
	],
	"./00001/00001-09/00001-09-08/6.jpg": [
		8110,
		7,
		8132
	],
	"./00001/00001-09/00001-09-08/7.jpg": [
		8111,
		7,
		8133
	],
	"./00001/00001-09/00001-09-08/big animals.mp3": [
		2564,
		7,
		1239
	],
	"./00001/00001-09/00001-09-08/intro.mp3": [
		446,
		7
	],
	"./00001/00001-09/00001-09-08/main idea.mp3": [
		827,
		7
	],
	"./00001/00001-09/00001-09-08/module": [
		1233,
		9,
		97
	],
	"./00001/00001-09/00001-09-08/module.js": [
		1233,
		9,
		97
	],
	"./00001/00001-09/00001-09-08/this dinosaur is huge.mp3": [
		2565,
		7,
		1240
	],
	"./00001/00001-09/00001-09-08/this elephant is big.mp3": [
		2566,
		7,
		1241
	],
	"./00001/00001-09/00001-09-08/this giraffe is big.mp3": [
		2567,
		7,
		1242
	],
	"./00001/00001-09/00001-09-08/this ostrich is big.mp3": [
		2568,
		7,
		1243
	],
	"./00001/00001-09/00001-09-08/this squid is big.mp3": [
		2569,
		7,
		1244
	],
	"./00001/00001-09/00001-09-08/this whale is big.mp3": [
		2570,
		7,
		1245
	],
	"./00001/00001-09/00001-09-08/this whale shark is big.mp3": [
		2571,
		7,
		1246
	],
	"./00001/00001-09/00001-09-09/0.jpg": [
		6786,
		7,
		5463
	],
	"./00001/00001-09/00001-09-09/1.jpg": [
		8112,
		7,
		8134
	],
	"./00001/00001-09/00001-09-09/2.jpg": [
		8113,
		7,
		8135
	],
	"./00001/00001-09/00001-09-09/3.jpg": [
		8114,
		7,
		8136
	],
	"./00001/00001-09/00001-09-09/4.jpg": [
		8115,
		7,
		8137
	],
	"./00001/00001-09/00001-09-09/5.jpg": [
		8116,
		7,
		8138
	],
	"./00001/00001-09/00001-09-09/6.jpg": [
		8117,
		7,
		8139
	],
	"./00001/00001-09/00001-09-09/7.jpg": [
		8118,
		7,
		8140
	],
	"./00001/00001-09/00001-09-09/animals.mp3": [
		2572,
		7,
		1247
	],
	"./00001/00001-09/00001-09-09/intro.mp3": [
		447,
		7
	],
	"./00001/00001-09/00001-09-09/main idea.mp3": [
		828,
		7
	],
	"./00001/00001-09/00001-09-09/module": [
		1234,
		9,
		98
	],
	"./00001/00001-09/00001-09-09/module.js": [
		1234,
		9,
		98
	],
	"./00001/00001-09/00001-09-09/the alligator is a reptile.mp3": [
		2573,
		7,
		1248
	],
	"./00001/00001-09/00001-09-09/the animal book.mp3": [
		2574,
		7,
		1249
	],
	"./00001/00001-09/00001-09-09/the cat is a mammal.mp3": [
		2575,
		7,
		1250
	],
	"./00001/00001-09/00001-09-09/the eagle is a bird.mp3": [
		2576,
		7,
		1251
	],
	"./00001/00001-09/00001-09-09/the frog is an amphibian.mp3": [
		2577,
		7,
		1252
	],
	"./00001/00001-09/00001-09-09/the ladybug is an insect.mp3": [
		2578,
		7,
		1253
	],
	"./00001/00001-09/00001-09-09/the shark is a fish.mp3": [
		2579,
		7,
		1254
	],
	"./00001/00001-09/00001-09-09/the skunk is a mammal.mp3": [
		2580,
		7,
		1255
	],
	"./00001/00001-09/00001-09-10/0.jpg": [
		6787,
		7,
		5464
	],
	"./00001/00001-09/00001-09-10/1.jpg": [
		8119,
		7,
		8141
	],
	"./00001/00001-09/00001-09-10/2.jpg": [
		8120,
		7,
		8142
	],
	"./00001/00001-09/00001-09-10/3.jpg": [
		8121,
		7,
		8143
	],
	"./00001/00001-09/00001-09-10/4.jpg": [
		8122,
		7,
		8144
	],
	"./00001/00001-09/00001-09-10/5.jpg": [
		8123,
		7,
		8145
	],
	"./00001/00001-09/00001-09-10/6.jpg": [
		8124,
		7,
		8146
	],
	"./00001/00001-09/00001-09-10/7.jpg": [
		8125,
		7,
		8147
	],
	"./00001/00001-09/00001-09-10/dinosaurs.mp3": [
		2581,
		7,
		1256
	],
	"./00001/00001-09/00001-09-10/i am a long neck dinosaur.mp3": [
		2582,
		7,
		1257
	],
	"./00001/00001-09/00001-09-10/i am a pterosaur.mp3": [
		2583,
		7,
		1258
	],
	"./00001/00001-09/00001-09-10/i am a raptor.mp3": [
		2584,
		7,
		1259
	],
	"./00001/00001-09/00001-09-10/i am a stegosaurus.mp3": [
		2585,
		7,
		1260
	],
	"./00001/00001-09/00001-09-10/i am a swimming dinosaur.mp3": [
		2586,
		7,
		1261
	],
	"./00001/00001-09/00001-09-10/i am a t rex.mp3": [
		2587,
		7,
		1262
	],
	"./00001/00001-09/00001-09-10/i am a triceratops.mp3": [
		2588,
		7,
		1263
	],
	"./00001/00001-09/00001-09-10/intro.mp3": [
		448,
		7
	],
	"./00001/00001-09/00001-09-10/main idea.mp3": [
		829,
		7
	],
	"./00001/00001-09/00001-09-10/module": [
		1235,
		9,
		99
	],
	"./00001/00001-09/00001-09-10/module.js": [
		1235,
		9,
		99
	],
	"./00001/00001-09/animal groups.mp3": [
		2589,
		7,
		1264
	],
	"./00001/00001-09/cover.jpg": [
		6788,
		7,
		5465
	],
	"./00001/00001-09/unit": [
		1236,
		9,
		100
	],
	"./00001/00001-09/unit.js": [
		1236,
		9,
		100
	],
	"./00001/00001-10/00001-10-01/0.jpg": [
		6789,
		7,
		5466
	],
	"./00001/00001-10/00001-10-01/1.jpg": [
		8126,
		7,
		8148
	],
	"./00001/00001-10/00001-10-01/2.jpg": [
		8127,
		7,
		8149
	],
	"./00001/00001-10/00001-10-01/3.jpg": [
		8128,
		7,
		8150
	],
	"./00001/00001-10/00001-10-01/4.jpg": [
		8129,
		7,
		8151
	],
	"./00001/00001-10/00001-10-01/5.jpg": [
		8130,
		7,
		8152
	],
	"./00001/00001-10/00001-10-01/6.jpg": [
		8131,
		7,
		8153
	],
	"./00001/00001-10/00001-10-01/7.jpg": [
		8132,
		7,
		8154
	],
	"./00001/00001-10/00001-10-01/animals with 4 legs.mp3": [
		2590,
		7,
		1265
	],
	"./00001/00001-10/00001-10-01/i have 10 legs.mp3": [
		2591,
		7,
		1266
	],
	"./00001/00001-10/00001-10-01/i have 12 legs.mp3": [
		2592,
		7,
		1267
	],
	"./00001/00001-10/00001-10-01/i have 2 legs.mp3": [
		2593,
		7,
		1268
	],
	"./00001/00001-10/00001-10-01/i have 3 legs.mp3": [
		2594,
		7,
		1269
	],
	"./00001/00001-10/00001-10-01/i have 4 legs.mp3": [
		2595,
		7,
		1270
	],
	"./00001/00001-10/00001-10-01/i have 6 legs.mp3": [
		2596,
		7,
		1271
	],
	"./00001/00001-10/00001-10-01/i have 8 legs.mp3": [
		2597,
		7,
		1272
	],
	"./00001/00001-10/00001-10-01/intro.mp3": [
		449,
		7
	],
	"./00001/00001-10/00001-10-01/legs.mp3": [
		2598,
		7,
		1273
	],
	"./00001/00001-10/00001-10-01/main idea.mp3": [
		830,
		7
	],
	"./00001/00001-10/00001-10-01/module": [
		1237,
		9,
		101
	],
	"./00001/00001-10/00001-10-01/module.js": [
		1237,
		9,
		101
	],
	"./00001/00001-10/00001-10-02/0.jpg": [
		6790,
		7,
		5467
	],
	"./00001/00001-10/00001-10-02/1.jpg": [
		8133,
		7,
		8155
	],
	"./00001/00001-10/00001-10-02/2.jpg": [
		8134,
		7,
		8156
	],
	"./00001/00001-10/00001-10-02/3.jpg": [
		8135,
		7,
		8157
	],
	"./00001/00001-10/00001-10-02/4.jpg": [
		8136,
		7,
		8158
	],
	"./00001/00001-10/00001-10-02/5.jpg": [
		8137,
		7,
		8159
	],
	"./00001/00001-10/00001-10-02/6.jpg": [
		8138,
		7,
		8160
	],
	"./00001/00001-10/00001-10-02/7.jpg": [
		8139,
		7,
		8161
	],
	"./00001/00001-10/00001-10-02/animals with spots.mp3": [
		2599,
		7,
		1274
	],
	"./00001/00001-10/00001-10-02/intro.mp3": [
		450,
		7
	],
	"./00001/00001-10/00001-10-02/main idea.mp3": [
		831,
		7
	],
	"./00001/00001-10/00001-10-02/module": [
		1238,
		9,
		102
	],
	"./00001/00001-10/00001-10-02/module.js": [
		1238,
		9,
		102
	],
	"./00001/00001-10/00001-10-02/stripes and spots.mp3": [
		2600,
		7,
		1275
	],
	"./00001/00001-10/00001-10-02/the deer has spots.mp3": [
		2601,
		7,
		1276
	],
	"./00001/00001-10/00001-10-02/the dinosaur has spots too.mp3": [
		2602,
		7,
		1277
	],
	"./00001/00001-10/00001-10-02/the giraffe has spots.mp3": [
		2603,
		7,
		1278
	],
	"./00001/00001-10/00001-10-02/the ladybug has spots.mp3": [
		2604,
		7,
		1279
	],
	"./00001/00001-10/00001-10-02/the raccoon has stripes.mp3": [
		2605,
		7,
		1280
	],
	"./00001/00001-10/00001-10-02/the tiger has stripes.mp3": [
		2606,
		7,
		1281
	],
	"./00001/00001-10/00001-10-02/the zebra has stripes.mp3": [
		2607,
		7,
		1282
	],
	"./00001/00001-10/00001-10-03/0.jpg": [
		6791,
		7,
		5468
	],
	"./00001/00001-10/00001-10-03/1.jpg": [
		8140,
		7,
		8162
	],
	"./00001/00001-10/00001-10-03/2.jpg": [
		8141,
		7,
		8163
	],
	"./00001/00001-10/00001-10-03/3.jpg": [
		8142,
		7,
		8164
	],
	"./00001/00001-10/00001-10-03/4.jpg": [
		8143,
		7,
		8165
	],
	"./00001/00001-10/00001-10-03/5.jpg": [
		8144,
		7,
		8166
	],
	"./00001/00001-10/00001-10-03/6.jpg": [
		8145,
		7,
		8167
	],
	"./00001/00001-10/00001-10-03/7.jpg": [
		8146,
		7,
		8168
	],
	"./00001/00001-10/00001-10-03/animals with 2 eyes.mp3": [
		2608,
		7,
		1283
	],
	"./00001/00001-10/00001-10-03/eyes.mp3": [
		2609,
		7,
		1284
	],
	"./00001/00001-10/00001-10-03/i have 10 eyes.mp3": [
		2610,
		7,
		1285
	],
	"./00001/00001-10/00001-10-03/i have 2 eyes.mp3": [
		2611,
		7,
		1286
	],
	"./00001/00001-10/00001-10-03/i have 5 eyes.mp3": [
		2612,
		7,
		1287
	],
	"./00001/00001-10/00001-10-03/i have 8 eyes.mp3": [
		2613,
		7,
		1288
	],
	"./00001/00001-10/00001-10-03/intro.mp3": [
		451,
		7
	],
	"./00001/00001-10/00001-10-03/main idea.mp3": [
		832,
		7
	],
	"./00001/00001-10/00001-10-03/module": [
		1239,
		9,
		103
	],
	"./00001/00001-10/00001-10-03/module.js": [
		1239,
		9,
		103
	],
	"./00001/00001-10/00001-10-04/0.jpg": [
		6792,
		7,
		5469
	],
	"./00001/00001-10/00001-10-04/1.jpg": [
		8147,
		7,
		8169
	],
	"./00001/00001-10/00001-10-04/2.jpg": [
		8148,
		7,
		8170
	],
	"./00001/00001-10/00001-10-04/3.jpg": [
		8149,
		7,
		8171
	],
	"./00001/00001-10/00001-10-04/4.jpg": [
		8150,
		7,
		8172
	],
	"./00001/00001-10/00001-10-04/5.jpg": [
		8151,
		7,
		8173
	],
	"./00001/00001-10/00001-10-04/6.jpg": [
		8152,
		7,
		8174
	],
	"./00001/00001-10/00001-10-04/7.jpg": [
		8153,
		7,
		8175
	],
	"./00001/00001-10/00001-10-04/animals with 2 horns.mp3": [
		2614,
		7,
		1289
	],
	"./00001/00001-10/00001-10-04/here is a cow.mp3": [
		2615,
		7,
		1290
	],
	"./00001/00001-10/00001-10-04/here is a dinosaur.mp3": [
		2616,
		7,
		1291
	],
	"./00001/00001-10/00001-10-04/here is a giraffe.mp3": [
		2617,
		7,
		1292
	],
	"./00001/00001-10/00001-10-04/here is a goat.mp3": [
		2618,
		7,
		1293
	],
	"./00001/00001-10/00001-10-04/here is a monster.mp3": [
		2619,
		7,
		1294
	],
	"./00001/00001-10/00001-10-04/here is a rhino.mp3": [
		2620,
		7,
		1295
	],
	"./00001/00001-10/00001-10-04/here is a unicorn.mp3": [
		2621,
		7,
		1296
	],
	"./00001/00001-10/00001-10-04/horns.mp3": [
		2622,
		7,
		1297
	],
	"./00001/00001-10/00001-10-04/intro.mp3": [
		452,
		7
	],
	"./00001/00001-10/00001-10-04/main idea.mp3": [
		833,
		7
	],
	"./00001/00001-10/00001-10-04/module": [
		1240,
		9,
		104
	],
	"./00001/00001-10/00001-10-04/module.js": [
		1240,
		9,
		104
	],
	"./00001/00001-10/00001-10-05/0.jpg": [
		6793,
		7,
		5470
	],
	"./00001/00001-10/00001-10-05/1.jpg": [
		8154,
		7,
		8176
	],
	"./00001/00001-10/00001-10-05/2.jpg": [
		8155,
		7,
		8177
	],
	"./00001/00001-10/00001-10-05/3.jpg": [
		8156,
		7,
		8178
	],
	"./00001/00001-10/00001-10-05/4.jpg": [
		8157,
		7,
		8179
	],
	"./00001/00001-10/00001-10-05/5.jpg": [
		8158,
		7,
		8180
	],
	"./00001/00001-10/00001-10-05/6.jpg": [
		8159,
		7,
		8181
	],
	"./00001/00001-10/00001-10-05/7.jpg": [
		8160,
		7,
		8182
	],
	"./00001/00001-10/00001-10-05/animals with long necks.mp3": [
		2623,
		7,
		1298
	],
	"./00001/00001-10/00001-10-05/i can see a camel.mp3": [
		2624,
		7,
		1299
	],
	"./00001/00001-10/00001-10-05/i can see a dinosaur.mp3": [
		2625,
		7,
		1300
	],
	"./00001/00001-10/00001-10-05/i can see a flamingo.mp3": [
		2626,
		7,
		1301
	],
	"./00001/00001-10/00001-10-05/i can see a giraffe.mp3": [
		2627,
		7,
		1302
	],
	"./00001/00001-10/00001-10-05/i can see a goose.mp3": [
		2628,
		7,
		1303
	],
	"./00001/00001-10/00001-10-05/i can see a snake.mp3": [
		2629,
		7,
		1304
	],
	"./00001/00001-10/00001-10-05/i can see an ostrich.mp3": [
		2630,
		7,
		1305
	],
	"./00001/00001-10/00001-10-05/intro.mp3": [
		453,
		7
	],
	"./00001/00001-10/00001-10-05/main idea.mp3": [
		834,
		7
	],
	"./00001/00001-10/00001-10-05/module": [
		1241,
		9,
		105
	],
	"./00001/00001-10/00001-10-05/module.js": [
		1241,
		9,
		105
	],
	"./00001/00001-10/00001-10-05/necks.mp3": [
		2631,
		7,
		1306
	],
	"./00001/00001-10/00001-10-06/0.jpg": [
		6794,
		7,
		5471
	],
	"./00001/00001-10/00001-10-06/1.jpg": [
		8161,
		7,
		8183
	],
	"./00001/00001-10/00001-10-06/2.jpg": [
		8162,
		7,
		8184
	],
	"./00001/00001-10/00001-10-06/3.jpg": [
		8163,
		7,
		8185
	],
	"./00001/00001-10/00001-10-06/4.jpg": [
		8164,
		7,
		8186
	],
	"./00001/00001-10/00001-10-06/5.jpg": [
		8165,
		7,
		8187
	],
	"./00001/00001-10/00001-10-06/6.jpg": [
		8166,
		7,
		8188
	],
	"./00001/00001-10/00001-10-06/7.jpg": [
		8167,
		7,
		8189
	],
	"./00001/00001-10/00001-10-06/animals we saw in the book.mp3": [
		2632,
		7,
		1307
	],
	"./00001/00001-10/00001-10-06/animals with long teeth.mp3": [
		2633,
		7,
		1308
	],
	"./00001/00001-10/00001-10-06/intro.mp3": [
		454,
		7
	],
	"./00001/00001-10/00001-10-06/look at the alligator.mp3": [
		2634,
		7,
		1309
	],
	"./00001/00001-10/00001-10-06/look at the bat.mp3": [
		2635,
		7,
		1310
	],
	"./00001/00001-10/00001-10-06/look at the beaver.mp3": [
		2636,
		7,
		1311
	],
	"./00001/00001-10/00001-10-06/look at the dinosaur.mp3": [
		2637,
		7,
		1312
	],
	"./00001/00001-10/00001-10-06/look at the eel.mp3": [
		2638,
		7,
		1313
	],
	"./00001/00001-10/00001-10-06/look at the elephant.mp3": [
		2639,
		7,
		1314
	],
	"./00001/00001-10/00001-10-06/look at the walrus.mp3": [
		2640,
		7,
		1315
	],
	"./00001/00001-10/00001-10-06/main idea.mp3": [
		835,
		7
	],
	"./00001/00001-10/00001-10-06/module": [
		1242,
		9,
		106
	],
	"./00001/00001-10/00001-10-06/module.js": [
		1242,
		9,
		106
	],
	"./00001/00001-10/00001-10-06/teeth.mp3": [
		2641,
		7,
		1316
	],
	"./00001/00001-10/00001-10-07/0.jpg": [
		6795,
		7,
		5472
	],
	"./00001/00001-10/00001-10-07/1.jpg": [
		8168,
		7,
		8190
	],
	"./00001/00001-10/00001-10-07/2.jpg": [
		8169,
		7,
		8191
	],
	"./00001/00001-10/00001-10-07/3.jpg": [
		8170,
		7,
		8192
	],
	"./00001/00001-10/00001-10-07/4.jpg": [
		8171,
		7,
		8193
	],
	"./00001/00001-10/00001-10-07/5.jpg": [
		8172,
		7,
		8194
	],
	"./00001/00001-10/00001-10-07/6.jpg": [
		8173,
		7,
		8195
	],
	"./00001/00001-10/00001-10-07/7.jpg": [
		8174,
		7,
		8196
	],
	"./00001/00001-10/00001-10-07/animals with 2 feet.mp3": [
		2642,
		7,
		1317
	],
	"./00001/00001-10/00001-10-07/feet.mp3": [
		2643,
		7,
		1318
	],
	"./00001/00001-10/00001-10-07/intro.mp3": [
		455,
		7
	],
	"./00001/00001-10/00001-10-07/main idea.mp3": [
		836,
		7
	],
	"./00001/00001-10/00001-10-07/module": [
		1243,
		9,
		107
	],
	"./00001/00001-10/00001-10-07/module.js": [
		1243,
		9,
		107
	],
	"./00001/00001-10/00001-10-07/the bird has 2 feet.mp3": [
		2644,
		7,
		1319
	],
	"./00001/00001-10/00001-10-07/the duck has 2 feet.mp3": [
		2645,
		7,
		1320
	],
	"./00001/00001-10/00001-10-07/the frog has 4 feet.mp3": [
		2646,
		7,
		1321
	],
	"./00001/00001-10/00001-10-07/the raccoon has 4 feet.mp3": [
		2647,
		7,
		1322
	],
	"./00001/00001-10/00001-10-07/the slug has 1 foot.mp3": [
		2648,
		7,
		1323
	],
	"./00001/00001-10/00001-10-07/the snail has 1 foot.mp3": [
		2649,
		7,
		1324
	],
	"./00001/00001-10/00001-10-07/the whale has no feet.mp3": [
		2650,
		7,
		1325
	],
	"./00001/00001-10/00001-10-08/0.jpg": [
		6796,
		7,
		5473
	],
	"./00001/00001-10/00001-10-08/1.jpg": [
		8175,
		7,
		8197
	],
	"./00001/00001-10/00001-10-08/2.jpg": [
		8176,
		7,
		8198
	],
	"./00001/00001-10/00001-10-08/3.jpg": [
		8177,
		7,
		8199
	],
	"./00001/00001-10/00001-10-08/4.jpg": [
		8178,
		7,
		8200
	],
	"./00001/00001-10/00001-10-08/5.jpg": [
		8179,
		7,
		8201
	],
	"./00001/00001-10/00001-10-08/6.jpg": [
		8180,
		7,
		8202
	],
	"./00001/00001-10/00001-10-08/7.jpg": [
		8181,
		7,
		8203
	],
	"./00001/00001-10/00001-10-08/animals with shells.mp3": [
		2651,
		7,
		1326
	],
	"./00001/00001-10/00001-10-08/i am a crab.mp3": [
		2652,
		7,
		1327
	],
	"./00001/00001-10/00001-10-08/i am a hermit crab.mp3": [
		2653,
		7,
		1328
	],
	"./00001/00001-10/00001-10-08/i am a lobster.mp3": [
		2654,
		7,
		1329
	],
	"./00001/00001-10/00001-10-08/i am a sea turtle.mp3": [
		2655,
		7,
		1330
	],
	"./00001/00001-10/00001-10-08/i am a shrimp.mp3": [
		2656,
		7,
		1331
	],
	"./00001/00001-10/00001-10-08/i am a snail.mp3": [
		2657,
		7,
		1332
	],
	"./00001/00001-10/00001-10-08/i am a turtle.mp3": [
		2658,
		7,
		1333
	],
	"./00001/00001-10/00001-10-08/intro.mp3": [
		456,
		7
	],
	"./00001/00001-10/00001-10-08/main idea.mp3": [
		837,
		7
	],
	"./00001/00001-10/00001-10-08/module": [
		1244,
		9,
		108
	],
	"./00001/00001-10/00001-10-08/module.js": [
		1244,
		9,
		108
	],
	"./00001/00001-10/00001-10-08/shells.mp3": [
		2659,
		7,
		1334
	],
	"./00001/00001-10/00001-10-09/0.jpg": [
		6797,
		7,
		5474
	],
	"./00001/00001-10/00001-10-09/1.jpg": [
		8182,
		7,
		8204
	],
	"./00001/00001-10/00001-10-09/2.jpg": [
		8183,
		7,
		8205
	],
	"./00001/00001-10/00001-10-09/3.jpg": [
		8184,
		7,
		8206
	],
	"./00001/00001-10/00001-10-09/4.jpg": [
		8185,
		7,
		8207
	],
	"./00001/00001-10/00001-10-09/5.jpg": [
		8186,
		7,
		8208
	],
	"./00001/00001-10/00001-10-09/6.jpg": [
		8187,
		7,
		8209
	],
	"./00001/00001-10/00001-10-09/7.jpg": [
		8188,
		7,
		8210
	],
	"./00001/00001-10/00001-10-09/animals with long noses.mp3": [
		2660,
		7,
		1335
	],
	"./00001/00001-10/00001-10-09/i see the alligator.mp3": [
		2661,
		7,
		1336
	],
	"./00001/00001-10/00001-10-09/i see the anteater.mp3": [
		2662,
		7,
		1337
	],
	"./00001/00001-10/00001-10-09/i see the dog.mp3": [
		2663,
		7,
		1338
	],
	"./00001/00001-10/00001-10-09/i see the elephant.mp3": [
		2664,
		7,
		1339
	],
	"./00001/00001-10/00001-10-09/i see the monster.mp3": [
		2665,
		7,
		1340
	],
	"./00001/00001-10/00001-10-09/i see the seahorse.mp3": [
		2666,
		7,
		1341
	],
	"./00001/00001-10/00001-10-09/i see the swordfish.mp3": [
		2667,
		7,
		1342
	],
	"./00001/00001-10/00001-10-09/intro.mp3": [
		457,
		7
	],
	"./00001/00001-10/00001-10-09/main idea.mp3": [
		838,
		7
	],
	"./00001/00001-10/00001-10-09/module": [
		1245,
		9,
		109
	],
	"./00001/00001-10/00001-10-09/module.js": [
		1245,
		9,
		109
	],
	"./00001/00001-10/00001-10-09/noses.mp3": [
		2668,
		7,
		1343
	],
	"./00001/00001-10/00001-10-10/0.jpg": [
		6798,
		7,
		5475
	],
	"./00001/00001-10/00001-10-10/1.jpg": [
		8189,
		7,
		8211
	],
	"./00001/00001-10/00001-10-10/2.jpg": [
		8190,
		7,
		8212
	],
	"./00001/00001-10/00001-10-10/3.jpg": [
		8191,
		7,
		8213
	],
	"./00001/00001-10/00001-10-10/4.jpg": [
		8192,
		7,
		8214
	],
	"./00001/00001-10/00001-10-10/5.jpg": [
		8193,
		7,
		8215
	],
	"./00001/00001-10/00001-10-10/6.jpg": [
		8194,
		7,
		8216
	],
	"./00001/00001-10/00001-10-10/7.jpg": [
		8195,
		7,
		8217
	],
	"./00001/00001-10/00001-10-10/animals with big ears.mp3": [
		2669,
		7,
		1344
	],
	"./00001/00001-10/00001-10-10/i like the donkey.mp3": [
		2670,
		7,
		1345
	],
	"./00001/00001-10/00001-10-10/i like the elephant.mp3": [
		2671,
		7,
		1346
	],
	"./00001/00001-10/00001-10-10/i like the fox.mp3": [
		2672,
		7,
		1347
	],
	"./00001/00001-10/00001-10-10/i like the kangaroo.mp3": [
		2673,
		7,
		1348
	],
	"./00001/00001-10/00001-10-10/i like the monster.mp3": [
		2674,
		7,
		1349
	],
	"./00001/00001-10/00001-10-10/i like the mouse.mp3": [
		2675,
		7,
		1350
	],
	"./00001/00001-10/00001-10-10/i like the rabbit.mp3": [
		2676,
		7,
		1351
	],
	"./00001/00001-10/00001-10-10/intro.mp3": [
		458,
		7
	],
	"./00001/00001-10/00001-10-10/main idea.mp3": [
		839,
		7
	],
	"./00001/00001-10/00001-10-10/module": [
		1246,
		9,
		110
	],
	"./00001/00001-10/00001-10-10/module.js": [
		1246,
		9,
		110
	],
	"./00001/00001-10/cover.jpg": [
		6799,
		7,
		5476
	],
	"./00001/00001-10/creature features.mp3": [
		2677,
		7,
		1352
	],
	"./00001/00001-10/unit": [
		1247,
		9,
		111
	],
	"./00001/00001-10/unit.js": [
		1247,
		9,
		111
	],
	"./00001/00001-11/00001-11-01/0.jpg": [
		6800,
		7,
		5477
	],
	"./00001/00001-11/00001-11-01/1.jpg": [
		8196,
		7,
		8218
	],
	"./00001/00001-11/00001-11-01/2.jpg": [
		8197,
		7,
		8219
	],
	"./00001/00001-11/00001-11-01/3.jpg": [
		8198,
		7,
		8220
	],
	"./00001/00001-11/00001-11-01/4.jpg": [
		8199,
		7,
		8221
	],
	"./00001/00001-11/00001-11-01/5.jpg": [
		8200,
		7,
		8222
	],
	"./00001/00001-11/00001-11-01/6.jpg": [
		8201,
		7,
		8223
	],
	"./00001/00001-11/00001-11-01/7.jpg": [
		8202,
		7,
		8224
	],
	"./00001/00001-11/00001-11-01/flying animals.mp3": [
		2678,
		7,
		1353
	],
	"./00001/00001-11/00001-11-01/intro.mp3": [
		459,
		7
	],
	"./00001/00001-11/00001-11-01/main idea.mp3": [
		840,
		7
	],
	"./00001/00001-11/00001-11-01/module": [
		1248,
		9,
		112
	],
	"./00001/00001-11/00001-11-01/module.js": [
		1248,
		9,
		112
	],
	"./00001/00001-11/00001-11-01/the dragon can fly.mp3": [
		2679,
		7,
		1354
	],
	"./00001/00001-11/00001-11-01/the eagle can fly.mp3": [
		2680,
		7,
		1355
	],
	"./00001/00001-11/00001-11-01/the pig can fly.mp3": [
		2681,
		7,
		1356
	],
	"./00001/00001-11/00001-11-01/the rabbit can fly.mp3": [
		2682,
		7,
		1357
	],
	"./00001/00001-11/00001-11-01/the spaceship can fly.mp3": [
		2683,
		7,
		1358
	],
	"./00001/00001-11/00001-11-01/the tiger can fly.mp3": [
		2684,
		7,
		1359
	],
	"./00001/00001-11/00001-11-01/the unicorn can fly.mp3": [
		2685,
		7,
		1360
	],
	"./00001/00001-11/00001-11-01/what can fly.mp3": [
		2686,
		7,
		1361
	],
	"./00001/00001-11/00001-11-02/0.jpg": [
		6801,
		7,
		5478
	],
	"./00001/00001-11/00001-11-02/1.jpg": [
		8203,
		7,
		8225
	],
	"./00001/00001-11/00001-11-02/2.jpg": [
		8204,
		7,
		8226
	],
	"./00001/00001-11/00001-11-02/3.jpg": [
		8205,
		7,
		8227
	],
	"./00001/00001-11/00001-11-02/4.jpg": [
		8206,
		7,
		8228
	],
	"./00001/00001-11/00001-11-02/5 little dinosaurs.mp3": [
		2687,
		7,
		1362
	],
	"./00001/00001-11/00001-11-02/5.jpg": [
		8207,
		7,
		8229
	],
	"./00001/00001-11/00001-11-02/6.jpg": [
		8208,
		7,
		8230
	],
	"./00001/00001-11/00001-11-02/7.jpg": [
		8209,
		7,
		8231
	],
	"./00001/00001-11/00001-11-02/dinosaurs.mp3": [
		2688,
		7,
		1363
	],
	"./00001/00001-11/00001-11-02/i see 0 little dinosaurs.mp3": [
		2689,
		7,
		1364
	],
	"./00001/00001-11/00001-11-02/i see 1 big dinosaur.mp3": [
		2690,
		7,
		1365
	],
	"./00001/00001-11/00001-11-02/i see 1 little dinosaur.mp3": [
		2691,
		7,
		1366
	],
	"./00001/00001-11/00001-11-02/i see 2 little dinosaurs.mp3": [
		2692,
		7,
		1367
	],
	"./00001/00001-11/00001-11-02/i see 3 little dinosaurs.mp3": [
		2693,
		7,
		1368
	],
	"./00001/00001-11/00001-11-02/i see 4 little dinosaurs.mp3": [
		2694,
		7,
		1369
	],
	"./00001/00001-11/00001-11-02/i see 5 little dinosaurs.mp3": [
		2695,
		7,
		1370
	],
	"./00001/00001-11/00001-11-02/intro.mp3": [
		460,
		7
	],
	"./00001/00001-11/00001-11-02/main idea.mp3": [
		841,
		7
	],
	"./00001/00001-11/00001-11-02/module": [
		1249,
		9,
		113
	],
	"./00001/00001-11/00001-11-02/module.js": [
		1249,
		9,
		113
	],
	"./00001/00001-11/00001-11-03/0.jpg": [
		6802,
		7,
		5479
	],
	"./00001/00001-11/00001-11-03/1.jpg": [
		8210,
		7,
		8232
	],
	"./00001/00001-11/00001-11-03/2.jpg": [
		8211,
		7,
		8233
	],
	"./00001/00001-11/00001-11-03/3.jpg": [
		8212,
		7,
		8234
	],
	"./00001/00001-11/00001-11-03/4.jpg": [
		8213,
		7,
		8235
	],
	"./00001/00001-11/00001-11-03/5.jpg": [
		8214,
		7,
		8236
	],
	"./00001/00001-11/00001-11-03/6.jpg": [
		8215,
		7,
		8237
	],
	"./00001/00001-11/00001-11-03/7.jpg": [
		8216,
		7,
		8238
	],
	"./00001/00001-11/00001-11-03/i am flying.mp3": [
		2696,
		7,
		1371
	],
	"./00001/00001-11/00001-11-03/i am running.mp3": [
		2697,
		7,
		1372
	],
	"./00001/00001-11/00001-11-03/i am skating.mp3": [
		2698,
		7,
		1373
	],
	"./00001/00001-11/00001-11-03/i am sleeping.mp3": [
		2699,
		7,
		1374
	],
	"./00001/00001-11/00001-11-03/i am sliding.mp3": [
		2700,
		7,
		1375
	],
	"./00001/00001-11/00001-11-03/i am swimming.mp3": [
		2701,
		7,
		1376
	],
	"./00001/00001-11/00001-11-03/intro.mp3": [
		461,
		7
	],
	"./00001/00001-11/00001-11-03/main idea.mp3": [
		842,
		7
	],
	"./00001/00001-11/00001-11-03/module": [
		1250,
		9,
		114
	],
	"./00001/00001-11/00001-11-03/module.js": [
		1250,
		9,
		114
	],
	"./00001/00001-11/00001-11-03/swimming animals.mp3": [
		2702,
		7,
		1377
	],
	"./00001/00001-11/00001-11-03/we are jumping.mp3": [
		2703,
		7,
		1378
	],
	"./00001/00001-11/00001-11-04/0.jpg": [
		6803,
		7,
		5480
	],
	"./00001/00001-11/00001-11-04/1.jpg": [
		8217,
		7,
		8239
	],
	"./00001/00001-11/00001-11-04/2.jpg": [
		8218,
		7,
		8240
	],
	"./00001/00001-11/00001-11-04/3.jpg": [
		8219,
		7,
		8241
	],
	"./00001/00001-11/00001-11-04/4.jpg": [
		8220,
		7,
		8242
	],
	"./00001/00001-11/00001-11-04/5.jpg": [
		8221,
		7,
		8243
	],
	"./00001/00001-11/00001-11-04/6.jpg": [
		8222,
		7,
		8244
	],
	"./00001/00001-11/00001-11-04/7.jpg": [
		8223,
		7,
		8245
	],
	"./00001/00001-11/00001-11-04/intro.mp3": [
		462,
		7
	],
	"./00001/00001-11/00001-11-04/look at the big snowball.mp3": [
		2704,
		7,
		1379
	],
	"./00001/00001-11/00001-11-04/look at the carrot.mp3": [
		2705,
		7,
		1380
	],
	"./00001/00001-11/00001-11-04/look at the hat.mp3": [
		2706,
		7,
		1381
	],
	"./00001/00001-11/00001-11-04/look at the little snowball.mp3": [
		2707,
		7,
		1382
	],
	"./00001/00001-11/00001-11-04/look at the rocks.mp3": [
		2708,
		7,
		1383
	],
	"./00001/00001-11/00001-11-04/look at the scarf.mp3": [
		2709,
		7,
		1384
	],
	"./00001/00001-11/00001-11-04/look at the snowman.mp3": [
		2710,
		7,
		1385
	],
	"./00001/00001-11/00001-11-04/main idea.mp3": [
		843,
		7
	],
	"./00001/00001-11/00001-11-04/making a snowman.mp3": [
		2711,
		7,
		1386
	],
	"./00001/00001-11/00001-11-04/module": [
		1251,
		9,
		115
	],
	"./00001/00001-11/00001-11-04/module.js": [
		1251,
		9,
		115
	],
	"./00001/00001-11/00001-11-04/things you need to make a snowman.mp3": [
		2712,
		7,
		1387
	],
	"./00001/00001-11/00001-11-05/0.jpg": [
		6804,
		7,
		5481
	],
	"./00001/00001-11/00001-11-05/1.jpg": [
		8224,
		7,
		8246
	],
	"./00001/00001-11/00001-11-05/2.jpg": [
		8225,
		7,
		8247
	],
	"./00001/00001-11/00001-11-05/3.jpg": [
		8226,
		7,
		8248
	],
	"./00001/00001-11/00001-11-05/4.jpg": [
		8227,
		7,
		8249
	],
	"./00001/00001-11/00001-11-05/5.jpg": [
		8228,
		7,
		8250
	],
	"./00001/00001-11/00001-11-05/6.jpg": [
		8229,
		7,
		8251
	],
	"./00001/00001-11/00001-11-05/7.jpg": [
		8230,
		7,
		8252
	],
	"./00001/00001-11/00001-11-05/going up and down.mp3": [
		2713,
		7,
		1388
	],
	"./00001/00001-11/00001-11-05/intro.mp3": [
		463,
		7
	],
	"./00001/00001-11/00001-11-05/look at the cat.mp3": [
		2714,
		7,
		1389
	],
	"./00001/00001-11/00001-11-05/look at the dog.mp3": [
		2715,
		7,
		1390
	],
	"./00001/00001-11/00001-11-05/look at the mouse.mp3": [
		2716,
		7,
		1391
	],
	"./00001/00001-11/00001-11-05/main idea.mp3": [
		844,
		7
	],
	"./00001/00001-11/00001-11-05/module": [
		1252,
		9,
		116
	],
	"./00001/00001-11/00001-11-05/module.js": [
		1252,
		9,
		116
	],
	"./00001/00001-11/00001-11-05/the cat is going down.mp3": [
		2717,
		7,
		1392
	],
	"./00001/00001-11/00001-11-05/the cat is going up.mp3": [
		2718,
		7,
		1393
	],
	"./00001/00001-11/00001-11-05/the dog is going down.mp3": [
		2719,
		7,
		1394
	],
	"./00001/00001-11/00001-11-05/the dog is going up.mp3": [
		2720,
		7,
		1395
	],
	"./00001/00001-11/00001-11-05/the mouse is going down.mp3": [
		2721,
		7,
		1396
	],
	"./00001/00001-11/00001-11-05/the mouse is going up.mp3": [
		2722,
		7,
		1397
	],
	"./00001/00001-11/00001-11-05/things you can see up in the sky.mp3": [
		2723,
		7,
		1398
	],
	"./00001/00001-11/00001-11-06/0.jpg": [
		6805,
		7,
		5482
	],
	"./00001/00001-11/00001-11-06/1.jpg": [
		8231,
		7,
		8253
	],
	"./00001/00001-11/00001-11-06/2.jpg": [
		8232,
		7,
		8254
	],
	"./00001/00001-11/00001-11-06/3.jpg": [
		8233,
		7,
		8255
	],
	"./00001/00001-11/00001-11-06/4.jpg": [
		8234,
		7,
		8256
	],
	"./00001/00001-11/00001-11-06/5.jpg": [
		8235,
		7,
		8257
	],
	"./00001/00001-11/00001-11-06/6.jpg": [
		8236,
		7,
		8258
	],
	"./00001/00001-11/00001-11-06/7.jpg": [
		8237,
		7,
		8259
	],
	"./00001/00001-11/00001-11-06/here comes the cheetah.mp3": [
		2724,
		7,
		1399
	],
	"./00001/00001-11/00001-11-06/here comes the elephant.mp3": [
		2725,
		7,
		1400
	],
	"./00001/00001-11/00001-11-06/here comes the fox.mp3": [
		2726,
		7,
		1401
	],
	"./00001/00001-11/00001-11-06/here comes the giraffe.mp3": [
		2727,
		7,
		1402
	],
	"./00001/00001-11/00001-11-06/here comes the lion.mp3": [
		2728,
		7,
		1403
	],
	"./00001/00001-11/00001-11-06/here comes the ostrich.mp3": [
		2729,
		7,
		1404
	],
	"./00001/00001-11/00001-11-06/here comes the zebra.mp3": [
		2730,
		7,
		1405
	],
	"./00001/00001-11/00001-11-06/intro.mp3": [
		464,
		7
	],
	"./00001/00001-11/00001-11-06/main idea.mp3": [
		845,
		7
	],
	"./00001/00001-11/00001-11-06/module": [
		1253,
		9,
		117
	],
	"./00001/00001-11/00001-11-06/module.js": [
		1253,
		9,
		117
	],
	"./00001/00001-11/00001-11-06/the animal race.mp3": [
		2731,
		7,
		1406
	],
	"./00001/00001-11/00001-11-06/wild animals.mp3": [
		2732,
		7,
		1407
	],
	"./00001/00001-11/00001-11-07/0.jpg": [
		6806,
		7,
		5483
	],
	"./00001/00001-11/00001-11-07/1.jpg": [
		8238,
		7,
		8260
	],
	"./00001/00001-11/00001-11-07/2.jpg": [
		8239,
		7,
		8261
	],
	"./00001/00001-11/00001-11-07/3.jpg": [
		8240,
		7,
		8262
	],
	"./00001/00001-11/00001-11-07/4.jpg": [
		8241,
		7,
		8263
	],
	"./00001/00001-11/00001-11-07/5.jpg": [
		8242,
		7,
		8264
	],
	"./00001/00001-11/00001-11-07/6.jpg": [
		8243,
		7,
		8265
	],
	"./00001/00001-11/00001-11-07/7.jpg": [
		8244,
		7,
		8266
	],
	"./00001/00001-11/00001-11-07/here is my bird said the dinosaur.mp3": [
		2733,
		7,
		1408
	],
	"./00001/00001-11/00001-11-07/here is my bird said the girl.mp3": [
		2734,
		7,
		1409
	],
	"./00001/00001-11/00001-11-07/here is my bird said the monster.mp3": [
		2735,
		7,
		1410
	],
	"./00001/00001-11/00001-11-07/here is my cat said the boy.mp3": [
		2736,
		7,
		1411
	],
	"./00001/00001-11/00001-11-07/here is my cat said the monster.mp3": [
		2737,
		7,
		1412
	],
	"./00001/00001-11/00001-11-07/here is my dog said the girl.mp3": [
		2738,
		7,
		1413
	],
	"./00001/00001-11/00001-11-07/here is my dog said the monster.mp3": [
		2739,
		7,
		1414
	],
	"./00001/00001-11/00001-11-07/here is my pet.mp3": [
		2740,
		7,
		1415
	],
	"./00001/00001-11/00001-11-07/intro.mp3": [
		465,
		7
	],
	"./00001/00001-11/00001-11-07/main idea.mp3": [
		846,
		7
	],
	"./00001/00001-11/00001-11-07/module": [
		1254,
		9,
		118
	],
	"./00001/00001-11/00001-11-07/module.js": [
		1254,
		9,
		118
	],
	"./00001/00001-11/00001-11-07/pets.mp3": [
		2741,
		7,
		1416
	],
	"./00001/00001-11/00001-11-07/wild animals.mp3": [
		2742,
		7,
		1417
	],
	"./00001/00001-11/00001-11-08/0.jpg": [
		6807,
		7,
		5484
	],
	"./00001/00001-11/00001-11-08/1.jpg": [
		8245,
		7,
		8267
	],
	"./00001/00001-11/00001-11-08/2.jpg": [
		8246,
		7,
		8268
	],
	"./00001/00001-11/00001-11-08/3.jpg": [
		8247,
		7,
		8269
	],
	"./00001/00001-11/00001-11-08/4.jpg": [
		8248,
		7,
		8270
	],
	"./00001/00001-11/00001-11-08/5.jpg": [
		8249,
		7,
		8271
	],
	"./00001/00001-11/00001-11-08/6.jpg": [
		8250,
		7,
		8272
	],
	"./00001/00001-11/00001-11-08/7.jpg": [
		8251,
		7,
		8273
	],
	"./00001/00001-11/00001-11-08/can you.mp3": [
		2743,
		7,
		1418
	],
	"./00001/00001-11/00001-11-08/characters who can skate in the book.mp3": [
		2744,
		7,
		1419
	],
	"./00001/00001-11/00001-11-08/i can not skate said the bear.mp3": [
		2745,
		7,
		1420
	],
	"./00001/00001-11/00001-11-08/i can skate said the deer.mp3": [
		2746,
		7,
		1421
	],
	"./00001/00001-11/00001-11-08/i can skate said the monster.mp3": [
		2747,
		7,
		1422
	],
	"./00001/00001-11/00001-11-08/i can skate said the panda.mp3": [
		2748,
		7,
		1423
	],
	"./00001/00001-11/00001-11-08/i can skate said the penguin.mp3": [
		2749,
		7,
		1424
	],
	"./00001/00001-11/00001-11-08/intro.mp3": [
		466,
		7
	],
	"./00001/00001-11/00001-11-08/look at me.mp3": [
		2750,
		7,
		1425
	],
	"./00001/00001-11/00001-11-08/look at us.mp3": [
		2751,
		7,
		1426
	],
	"./00001/00001-11/00001-11-08/main idea.mp3": [
		847,
		7
	],
	"./00001/00001-11/00001-11-08/module": [
		1255,
		9,
		119
	],
	"./00001/00001-11/00001-11-08/module.js": [
		1255,
		9,
		119
	],
	"./00001/00001-11/00001-11-08/oh no.mp3": [
		2752,
		7,
		1427
	],
	"./00001/00001-11/00001-11-08/the bear can not skate.mp3": [
		2753,
		7,
		1428
	],
	"./00001/00001-11/00001-11-08/the deer can skate.mp3": [
		2754,
		7,
		1429
	],
	"./00001/00001-11/00001-11-08/the lions can skate.mp3": [
		2755,
		7,
		1430
	],
	"./00001/00001-11/00001-11-08/the monster can skate.mp3": [
		2756,
		7,
		1431
	],
	"./00001/00001-11/00001-11-08/the panda can skate.mp3": [
		2757,
		7,
		1432
	],
	"./00001/00001-11/00001-11-08/the penguin can skate.mp3": [
		2758,
		7,
		1433
	],
	"./00001/00001-11/00001-11-08/the rabbits can skate.mp3": [
		2759,
		7,
		1434
	],
	"./00001/00001-11/00001-11-08/we can skate said the lions.mp3": [
		2760,
		7,
		1435
	],
	"./00001/00001-11/00001-11-08/we can skate said the rabbits.mp3": [
		2761,
		7,
		1436
	],
	"./00001/00001-11/00001-11-08/who can skate.mp3": [
		2762,
		7,
		1437
	],
	"./00001/00001-11/00001-11-09/0.jpg": [
		6808,
		7,
		5485
	],
	"./00001/00001-11/00001-11-09/1.jpg": [
		8252,
		7,
		8274
	],
	"./00001/00001-11/00001-11-09/2.jpg": [
		8253,
		7,
		8275
	],
	"./00001/00001-11/00001-11-09/3.jpg": [
		8254,
		7,
		8276
	],
	"./00001/00001-11/00001-11-09/4.jpg": [
		8255,
		7,
		8277
	],
	"./00001/00001-11/00001-11-09/5.jpg": [
		8256,
		7,
		8278
	],
	"./00001/00001-11/00001-11-09/6.jpg": [
		8257,
		7,
		8279
	],
	"./00001/00001-11/00001-11-09/7.jpg": [
		8258,
		7,
		8280
	],
	"./00001/00001-11/00001-11-09/animals with four legs.mp3": [
		2763,
		7,
		1438
	],
	"./00001/00001-11/00001-11-09/balloons.mp3": [
		2764,
		7,
		1439
	],
	"./00001/00001-11/00001-11-09/cat likes the orange balloon.mp3": [
		2765,
		7,
		1440
	],
	"./00001/00001-11/00001-11-09/dinosaur likes the blue balloon.mp3": [
		2766,
		7,
		1441
	],
	"./00001/00001-11/00001-11-09/dog likes the red balloon.mp3": [
		2767,
		7,
		1442
	],
	"./00001/00001-11/00001-11-09/intro.mp3": [
		467,
		7
	],
	"./00001/00001-11/00001-11-09/lion likes the yellow balloon.mp3": [
		2768,
		7,
		1443
	],
	"./00001/00001-11/00001-11-09/main idea.mp3": [
		848,
		7
	],
	"./00001/00001-11/00001-11-09/module": [
		1256,
		9,
		120
	],
	"./00001/00001-11/00001-11-09/module.js": [
		1256,
		9,
		120
	],
	"./00001/00001-11/00001-11-09/monkey likes the green balloon.mp3": [
		2769,
		7,
		1444
	],
	"./00001/00001-11/00001-11-09/octopus likes the balloons.mp3": [
		2770,
		7,
		1445
	],
	"./00001/00001-11/00001-11-09/rabbit likes the pink balloon.mp3": [
		2771,
		7,
		1446
	],
	"./00001/00001-11/00001-11-10/0.jpg": [
		6809,
		7,
		5486
	],
	"./00001/00001-11/00001-11-10/1.jpg": [
		8259,
		7,
		8281
	],
	"./00001/00001-11/00001-11-10/2.jpg": [
		8260,
		7,
		8282
	],
	"./00001/00001-11/00001-11-10/3.jpg": [
		8261,
		7,
		8283
	],
	"./00001/00001-11/00001-11-10/4.jpg": [
		8262,
		7,
		8284
	],
	"./00001/00001-11/00001-11-10/5.jpg": [
		8263,
		7,
		8285
	],
	"./00001/00001-11/00001-11-10/6.jpg": [
		8264,
		7,
		8286
	],
	"./00001/00001-11/00001-11-10/7.jpg": [
		8265,
		7,
		8287
	],
	"./00001/00001-11/00001-11-10/ant sees the yellow flower.mp3": [
		2772,
		7,
		1447
	],
	"./00001/00001-11/00001-11-10/bee sees the orange flower.mp3": [
		2773,
		7,
		1448
	],
	"./00001/00001-11/00001-11-10/butterfly sees the red flower.mp3": [
		2774,
		7,
		1449
	],
	"./00001/00001-11/00001-11-10/grasshopper sees the pink flower.mp3": [
		2775,
		7,
		1450
	],
	"./00001/00001-11/00001-11-10/hummingbird sees the blue flower.mp3": [
		2776,
		7,
		1451
	],
	"./00001/00001-11/00001-11-10/insects.mp3": [
		2777,
		7,
		1452
	],
	"./00001/00001-11/00001-11-10/intro.mp3": [
		468,
		7
	],
	"./00001/00001-11/00001-11-10/ladybug sees the purple flower.mp3": [
		2778,
		7,
		1453
	],
	"./00001/00001-11/00001-11-10/main idea.mp3": [
		849,
		7
	],
	"./00001/00001-11/00001-11-10/module": [
		1257,
		9,
		121
	],
	"./00001/00001-11/00001-11-10/module.js": [
		1257,
		9,
		121
	],
	"./00001/00001-11/00001-11-10/we see flowers.mp3": [
		2779,
		7,
		1454
	],
	"./00001/00001-11/00001-11-10/we see the flowers.mp3": [
		2780,
		7,
		1455
	],
	"./00001/00001-11/cover.jpg": [
		6810,
		7,
		5487
	],
	"./00001/00001-11/story town.mp3": [
		2781,
		7,
		1456
	],
	"./00001/00001-11/unit": [
		1258,
		9,
		122
	],
	"./00001/00001-11/unit.js": [
		1258,
		9,
		122
	],
	"./00001/00001-12/00001-12-01/0.jpg": [
		6811,
		7,
		5488
	],
	"./00001/00001-12/00001-12-01/1.jpg": [
		8266,
		7,
		8288
	],
	"./00001/00001-12/00001-12-01/2.jpg": [
		8267,
		7,
		8289
	],
	"./00001/00001-12/00001-12-01/3.jpg": [
		8268,
		7,
		8290
	],
	"./00001/00001-12/00001-12-01/4.jpg": [
		8269,
		7,
		8291
	],
	"./00001/00001-12/00001-12-01/5.jpg": [
		8270,
		7,
		8292
	],
	"./00001/00001-12/00001-12-01/6.jpg": [
		8271,
		7,
		8293
	],
	"./00001/00001-12/00001-12-01/7.jpg": [
		8272,
		7,
		8294
	],
	"./00001/00001-12/00001-12-01/alligator wants an airplane.mp3": [
		2782,
		7,
		1457
	],
	"./00001/00001-12/00001-12-01/bear wants a bike.mp3": [
		2783,
		7,
		1458
	],
	"./00001/00001-12/00001-12-01/cat wants a car.mp3": [
		2784,
		7,
		1459
	],
	"./00001/00001-12/00001-12-01/dog wants a dinosaur.mp3": [
		2785,
		7,
		1460
	],
	"./00001/00001-12/00001-12-01/fox wants a fire truck.mp3": [
		2786,
		7,
		1461
	],
	"./00001/00001-12/00001-12-01/hippo wants a helicopter.mp3": [
		2787,
		7,
		1462
	],
	"./00001/00001-12/00001-12-01/intro.mp3": [
		469,
		7
	],
	"./00001/00001-12/00001-12-01/main idea.mp3": [
		850,
		7
	],
	"./00001/00001-12/00001-12-01/module": [
		1259,
		9,
		123
	],
	"./00001/00001-12/00001-12-01/module.js": [
		1259,
		9,
		123
	],
	"./00001/00001-12/00001-12-01/toys.mp3": [
		2788,
		7,
		1463
	],
	"./00001/00001-12/00001-12-01/vehicles.mp3": [
		2789,
		7,
		1464
	],
	"./00001/00001-12/00001-12-01/wolf wants a wagon.mp3": [
		2790,
		7,
		1465
	],
	"./00001/00001-12/00001-12-02/0.jpg": [
		6812,
		7,
		5489
	],
	"./00001/00001-12/00001-12-02/1.jpg": [
		8273,
		7,
		8295
	],
	"./00001/00001-12/00001-12-02/2.jpg": [
		8274,
		7,
		8296
	],
	"./00001/00001-12/00001-12-02/3.jpg": [
		8275,
		7,
		8297
	],
	"./00001/00001-12/00001-12-02/4.jpg": [
		8276,
		7,
		8298
	],
	"./00001/00001-12/00001-12-02/5.jpg": [
		8277,
		7,
		8299
	],
	"./00001/00001-12/00001-12-02/6.jpg": [
		8278,
		7,
		8300
	],
	"./00001/00001-12/00001-12-02/7.jpg": [
		8279,
		7,
		8301
	],
	"./00001/00001-12/00001-12-02/alligator got a saxophone.mp3": [
		2791,
		7,
		1466
	],
	"./00001/00001-12/00001-12-02/bear got a guitar.mp3": [
		2792,
		7,
		1467
	],
	"./00001/00001-12/00001-12-02/beaver got a xylophone.mp3": [
		2793,
		7,
		1468
	],
	"./00001/00001-12/00001-12-02/dog got a tambourine.mp3": [
		2794,
		7,
		1469
	],
	"./00001/00001-12/00001-12-02/fox got a fiddle.mp3": [
		2795,
		7,
		1470
	],
	"./00001/00001-12/00001-12-02/i love music.mp3": [
		2796,
		7,
		1471
	],
	"./00001/00001-12/00001-12-02/intro.mp3": [
		470,
		7
	],
	"./00001/00001-12/00001-12-02/main idea.mp3": [
		851,
		7
	],
	"./00001/00001-12/00001-12-02/module": [
		1260,
		9,
		124
	],
	"./00001/00001-12/00001-12-02/module.js": [
		1260,
		9,
		124
	],
	"./00001/00001-12/00001-12-02/monkey got a triangle.mp3": [
		2797,
		7,
		1472
	],
	"./00001/00001-12/00001-12-02/musical instruments.mp3": [
		2798,
		7,
		1473
	],
	"./00001/00001-12/00001-12-02/raccoon got a banjo.mp3": [
		2799,
		7,
		1474
	],
	"./00001/00001-12/00001-12-03/0.jpg": [
		6813,
		7,
		5490
	],
	"./00001/00001-12/00001-12-03/1.jpg": [
		8280,
		7,
		8302
	],
	"./00001/00001-12/00001-12-03/2.jpg": [
		8281,
		7,
		8303
	],
	"./00001/00001-12/00001-12-03/3.jpg": [
		8282,
		7,
		8304
	],
	"./00001/00001-12/00001-12-03/4.jpg": [
		8283,
		7,
		8305
	],
	"./00001/00001-12/00001-12-03/5.jpg": [
		8284,
		7,
		8306
	],
	"./00001/00001-12/00001-12-03/6.jpg": [
		8285,
		7,
		8307
	],
	"./00001/00001-12/00001-12-03/7.jpg": [
		8286,
		7,
		8308
	],
	"./00001/00001-12/00001-12-03/cat is going to the party.mp3": [
		2800,
		7,
		1475
	],
	"./00001/00001-12/00001-12-03/crocodile is going to the party.mp3": [
		2801,
		7,
		1476
	],
	"./00001/00001-12/00001-12-03/elephant is going to the party.mp3": [
		2802,
		7,
		1477
	],
	"./00001/00001-12/00001-12-03/going to the party.mp3": [
		2803,
		7,
		1478
	],
	"./00001/00001-12/00001-12-03/here is the party.mp3": [
		2804,
		7,
		1479
	],
	"./00001/00001-12/00001-12-03/intro.mp3": [
		471,
		7
	],
	"./00001/00001-12/00001-12-03/jaguar is going to the party.mp3": [
		2805,
		7,
		1480
	],
	"./00001/00001-12/00001-12-03/main idea.mp3": [
		852,
		7
	],
	"./00001/00001-12/00001-12-03/module": [
		1261,
		9,
		125
	],
	"./00001/00001-12/00001-12-03/module.js": [
		1261,
		9,
		125
	],
	"./00001/00001-12/00001-12-03/panda is going to the party.mp3": [
		2806,
		7,
		1481
	],
	"./00001/00001-12/00001-12-03/tiger is going to the party.mp3": [
		2807,
		7,
		1482
	],
	"./00001/00001-12/00001-12-03/wild animals.mp3": [
		2808,
		7,
		1483
	],
	"./00001/00001-12/00001-12-03/zebra is going to the party.mp3": [
		2809,
		7,
		1484
	],
	"./00001/00001-12/00001-12-04/0.jpg": [
		6814,
		7,
		5491
	],
	"./00001/00001-12/00001-12-04/1.jpg": [
		8287,
		7,
		8309
	],
	"./00001/00001-12/00001-12-04/2.jpg": [
		8288,
		7,
		8310
	],
	"./00001/00001-12/00001-12-04/3.jpg": [
		8289,
		7,
		8311
	],
	"./00001/00001-12/00001-12-04/4.jpg": [
		8290,
		7,
		8312
	],
	"./00001/00001-12/00001-12-04/5.jpg": [
		8291,
		7,
		8313
	],
	"./00001/00001-12/00001-12-04/6.jpg": [
		8292,
		7,
		8314
	],
	"./00001/00001-12/00001-12-04/7.jpg": [
		8293,
		7,
		8315
	],
	"./00001/00001-12/00001-12-04/a friend for yellow duck.mp3": [
		2810,
		7,
		1485
	],
	"./00001/00001-12/00001-12-04/animals with 4 legs.mp3": [
		2811,
		7,
		1486
	],
	"./00001/00001-12/00001-12-04/intro.mp3": [
		472,
		7
	],
	"./00001/00001-12/00001-12-04/look at the animals.mp3": [
		2812,
		7,
		1487
	],
	"./00001/00001-12/00001-12-04/look at the deer.mp3": [
		2813,
		7,
		1488
	],
	"./00001/00001-12/00001-12-04/look at the ducks.mp3": [
		2814,
		7,
		1489
	],
	"./00001/00001-12/00001-12-04/look at the fox.mp3": [
		2815,
		7,
		1490
	],
	"./00001/00001-12/00001-12-04/look at the frog.mp3": [
		2816,
		7,
		1491
	],
	"./00001/00001-12/00001-12-04/look at the sheep.mp3": [
		2817,
		7,
		1492
	],
	"./00001/00001-12/00001-12-04/look at the squirrel.mp3": [
		2818,
		7,
		1493
	],
	"./00001/00001-12/00001-12-04/main idea.mp3": [
		853,
		7
	],
	"./00001/00001-12/00001-12-04/module": [
		1262,
		9,
		126
	],
	"./00001/00001-12/00001-12-04/module.js": [
		1262,
		9,
		126
	],
	"./00001/00001-12/00001-12-04/no.mp3": [
		2819,
		7,
		1494
	],
	"./00001/00001-12/00001-12-04/will you play with me said yellow duck.mp3": [
		2820,
		7,
		1495
	],
	"./00001/00001-12/00001-12-04/yes.mp3": [
		2821,
		7,
		1496
	],
	"./00001/00001-12/00001-12-05/0.jpg": [
		6815,
		7,
		5492
	],
	"./00001/00001-12/00001-12-05/1.jpg": [
		8294,
		7,
		8316
	],
	"./00001/00001-12/00001-12-05/2.jpg": [
		8295,
		7,
		8317
	],
	"./00001/00001-12/00001-12-05/3.jpg": [
		8296,
		7,
		8318
	],
	"./00001/00001-12/00001-12-05/4.jpg": [
		8297,
		7,
		8319
	],
	"./00001/00001-12/00001-12-05/5.jpg": [
		8298,
		7,
		8320
	],
	"./00001/00001-12/00001-12-05/6.jpg": [
		8299,
		7,
		8321
	],
	"./00001/00001-12/00001-12-05/7.jpg": [
		8300,
		7,
		8322
	],
	"./00001/00001-12/00001-12-05/cat likes to play soccer.mp3": [
		2822,
		7,
		1497
	],
	"./00001/00001-12/00001-12-05/fox likes to play soccer.mp3": [
		2823,
		7,
		1498
	],
	"./00001/00001-12/00001-12-05/intro.mp3": [
		473,
		7
	],
	"./00001/00001-12/00001-12-05/lion likes to play soccer.mp3": [
		2824,
		7,
		1499
	],
	"./00001/00001-12/00001-12-05/main idea.mp3": [
		854,
		7
	],
	"./00001/00001-12/00001-12-05/module": [
		1263,
		9,
		127
	],
	"./00001/00001-12/00001-12-05/module.js": [
		1263,
		9,
		127
	],
	"./00001/00001-12/00001-12-05/rabbit likes to play soccer too.mp3": [
		2825,
		7,
		1500
	],
	"./00001/00001-12/00001-12-05/sheep likes to play soccer.mp3": [
		2826,
		7,
		1501
	],
	"./00001/00001-12/00001-12-05/skunk likes to play soccer.mp3": [
		2827,
		7,
		1502
	],
	"./00001/00001-12/00001-12-05/the soccer game.mp3": [
		2828,
		7,
		1503
	],
	"./00001/00001-12/00001-12-05/tiger likes to play soccer.mp3": [
		2829,
		7,
		1504
	],
	"./00001/00001-12/00001-12-05/wild animals.mp3": [
		2830,
		7,
		1505
	],
	"./00001/00001-12/00001-12-06/0.jpg": [
		6816,
		7,
		5493
	],
	"./00001/00001-12/00001-12-06/1.jpg": [
		8301,
		7,
		8323
	],
	"./00001/00001-12/00001-12-06/2.jpg": [
		8302,
		7,
		8324
	],
	"./00001/00001-12/00001-12-06/3.jpg": [
		8303,
		7,
		8325
	],
	"./00001/00001-12/00001-12-06/4.jpg": [
		8304,
		7,
		8326
	],
	"./00001/00001-12/00001-12-06/5.jpg": [
		8305,
		7,
		8327
	],
	"./00001/00001-12/00001-12-06/6.jpg": [
		8306,
		7,
		8328
	],
	"./00001/00001-12/00001-12-06/7.jpg": [
		8307,
		7,
		8329
	],
	"./00001/00001-12/00001-12-06/baby animals.mp3": [
		2831,
		7,
		1506
	],
	"./00001/00001-12/00001-12-06/can i be your mother.mp3": [
		2832,
		7,
		1507
	],
	"./00001/00001-12/00001-12-06/intro.mp3": [
		474,
		7
	],
	"./00001/00001-12/00001-12-06/main idea.mp3": [
		855,
		7
	],
	"./00001/00001-12/00001-12-06/module": [
		1264,
		9,
		128
	],
	"./00001/00001-12/00001-12-06/module.js": [
		1264,
		9,
		128
	],
	"./00001/00001-12/00001-12-06/no.mp3": [
		2833,
		7,
		1508
	],
	"./00001/00001-12/00001-12-06/yes.mp3": [
		2834,
		7,
		1509
	],
	"./00001/00001-12/00001-12-07/0.jpg": [
		6817,
		7,
		5494
	],
	"./00001/00001-12/00001-12-07/1.jpg": [
		8308,
		7,
		8330
	],
	"./00001/00001-12/00001-12-07/2.jpg": [
		8309,
		7,
		8331
	],
	"./00001/00001-12/00001-12-07/3.jpg": [
		8310,
		7,
		8332
	],
	"./00001/00001-12/00001-12-07/4.jpg": [
		8311,
		7,
		8333
	],
	"./00001/00001-12/00001-12-07/5.jpg": [
		8312,
		7,
		8334
	],
	"./00001/00001-12/00001-12-07/6.jpg": [
		8313,
		7,
		8335
	],
	"./00001/00001-12/00001-12-07/7.jpg": [
		8314,
		7,
		8336
	],
	"./00001/00001-12/00001-12-07/birds.mp3": [
		2835,
		7,
		1510
	],
	"./00001/00001-12/00001-12-07/characters in the book.mp3": [
		2836,
		7,
		1511
	],
	"./00001/00001-12/00001-12-07/intro.mp3": [
		475,
		7
	],
	"./00001/00001-12/00001-12-07/look at the deer.mp3": [
		2837,
		7,
		1512
	],
	"./00001/00001-12/00001-12-07/look at the elephant.mp3": [
		2838,
		7,
		1513
	],
	"./00001/00001-12/00001-12-07/look at the fox.mp3": [
		2839,
		7,
		1514
	],
	"./00001/00001-12/00001-12-07/look at the jaguar.mp3": [
		2840,
		7,
		1515
	],
	"./00001/00001-12/00001-12-07/look at the lion.mp3": [
		2841,
		7,
		1516
	],
	"./00001/00001-12/00001-12-07/look at the tiger.mp3": [
		2842,
		7,
		1517
	],
	"./00001/00001-12/00001-12-07/main idea.mp3": [
		856,
		7
	],
	"./00001/00001-12/00001-12-07/module": [
		1265,
		9,
		129
	],
	"./00001/00001-12/00001-12-07/module.js": [
		1265,
		9,
		129
	],
	"./00001/00001-12/00001-12-07/the sky is falling said chicken little.mp3": [
		2843,
		7,
		1518
	],
	"./00001/00001-12/00001-12-07/the sky is falling.mp3": [
		2844,
		7,
		1519
	],
	"./00001/00001-12/00001-12-07/the sky is not falling.mp3": [
		2845,
		7,
		1520
	],
	"./00001/00001-12/00001-12-08/0.jpg": [
		6818,
		7,
		5495
	],
	"./00001/00001-12/00001-12-08/1.jpg": [
		8315,
		7,
		8337
	],
	"./00001/00001-12/00001-12-08/2.jpg": [
		8316,
		7,
		8338
	],
	"./00001/00001-12/00001-12-08/3.jpg": [
		8317,
		7,
		8339
	],
	"./00001/00001-12/00001-12-08/4.jpg": [
		8318,
		7,
		8340
	],
	"./00001/00001-12/00001-12-08/5.jpg": [
		8319,
		7,
		8341
	],
	"./00001/00001-12/00001-12-08/6.jpg": [
		8320,
		7,
		8342
	],
	"./00001/00001-12/00001-12-08/7.jpg": [
		8321,
		7,
		8343
	],
	"./00001/00001-12/00001-12-08/intro.mp3": [
		476,
		7
	],
	"./00001/00001-12/00001-12-08/main idea.mp3": [
		857,
		7
	],
	"./00001/00001-12/00001-12-08/module": [
		1266,
		9,
		130
	],
	"./00001/00001-12/00001-12-08/module.js": [
		1266,
		9,
		130
	],
	"./00001/00001-12/00001-12-08/mother cat looked in the bathroom.mp3": [
		2846,
		7,
		1521
	],
	"./00001/00001-12/00001-12-08/mother cat looked in the bathtub.mp3": [
		2847,
		7,
		1522
	],
	"./00001/00001-12/00001-12-08/mother cat looked in the bedroom.mp3": [
		2848,
		7,
		1523
	],
	"./00001/00001-12/00001-12-08/mother cat looked in the living room.mp3": [
		2849,
		7,
		1524
	],
	"./00001/00001-12/00001-12-08/mother cat looked on the bed.mp3": [
		2850,
		7,
		1525
	],
	"./00001/00001-12/00001-12-08/mother cat looked on the couch.mp3": [
		2851,
		7,
		1526
	],
	"./00001/00001-12/00001-12-08/mother cat looked on the table.mp3": [
		2852,
		7,
		1527
	],
	"./00001/00001-12/00001-12-08/non living things.mp3": [
		2853,
		7,
		1528
	],
	"./00001/00001-12/00001-12-08/where is the kitten.mp3": [
		2854,
		7,
		1529
	],
	"./00001/00001-12/00001-12-09/0.jpg": [
		6819,
		7,
		5496
	],
	"./00001/00001-12/00001-12-09/1.jpg": [
		8322,
		7,
		8344
	],
	"./00001/00001-12/00001-12-09/2.jpg": [
		8323,
		7,
		8345
	],
	"./00001/00001-12/00001-12-09/3.jpg": [
		8324,
		7,
		8346
	],
	"./00001/00001-12/00001-12-09/4.jpg": [
		8325,
		7,
		8347
	],
	"./00001/00001-12/00001-12-09/5.jpg": [
		8326,
		7,
		8348
	],
	"./00001/00001-12/00001-12-09/6.jpg": [
		8327,
		7,
		8349
	],
	"./00001/00001-12/00001-12-09/7.jpg": [
		8328,
		7,
		8350
	],
	"./00001/00001-12/00001-12-09/i love the mountains.mp3": [
		2855,
		7,
		1530
	],
	"./00001/00001-12/00001-12-09/i love to see the bees.mp3": [
		2856,
		7,
		1531
	],
	"./00001/00001-12/00001-12-09/i love to see the boats.mp3": [
		2857,
		7,
		1532
	],
	"./00001/00001-12/00001-12-09/i love to see the dogs.mp3": [
		2858,
		7,
		1533
	],
	"./00001/00001-12/00001-12-09/i love to see the frogs.mp3": [
		2859,
		7,
		1534
	],
	"./00001/00001-12/00001-12-09/i love to see the goats.mp3": [
		2860,
		7,
		1535
	],
	"./00001/00001-12/00001-12-09/i love to see the trees.mp3": [
		2861,
		7,
		1536
	],
	"./00001/00001-12/00001-12-09/intro.mp3": [
		477,
		7
	],
	"./00001/00001-12/00001-12-09/main idea.mp3": [
		858,
		7
	],
	"./00001/00001-12/00001-12-09/module": [
		1267,
		9,
		131
	],
	"./00001/00001-12/00001-12-09/module.js": [
		1267,
		9,
		131
	],
	"./00001/00001-12/00001-12-09/things on the earth.mp3": [
		2862,
		7,
		1537
	],
	"./00001/00001-12/00001-12-10/0.jpg": [
		6820,
		7,
		5497
	],
	"./00001/00001-12/00001-12-10/1.jpg": [
		8329,
		7,
		8351
	],
	"./00001/00001-12/00001-12-10/2.jpg": [
		8330,
		7,
		8352
	],
	"./00001/00001-12/00001-12-10/3.jpg": [
		8331,
		7,
		8353
	],
	"./00001/00001-12/00001-12-10/4.jpg": [
		8332,
		7,
		8354
	],
	"./00001/00001-12/00001-12-10/5.jpg": [
		8333,
		7,
		8355
	],
	"./00001/00001-12/00001-12-10/6.jpg": [
		8334,
		7,
		8356
	],
	"./00001/00001-12/00001-12-10/7.jpg": [
		8335,
		7,
		8357
	],
	"./00001/00001-12/00001-12-10/birds.mp3": [
		2863,
		7,
		1538
	],
	"./00001/00001-12/00001-12-10/have you seen my mother.mp3": [
		2864,
		7,
		1539
	],
	"./00001/00001-12/00001-12-10/help.mp3": [
		2865,
		7,
		1540
	],
	"./00001/00001-12/00001-12-10/here is a dog.mp3": [
		2866,
		7,
		1541
	],
	"./00001/00001-12/00001-12-10/here is a duck.mp3": [
		2867,
		7,
		1542
	],
	"./00001/00001-12/00001-12-10/here is a pig.mp3": [
		2868,
		7,
		1543
	],
	"./00001/00001-12/00001-12-10/here is a rabbit.mp3": [
		2869,
		7,
		1544
	],
	"./00001/00001-12/00001-12-10/here is a snake.mp3": [
		2870,
		7,
		1545
	],
	"./00001/00001-12/00001-12-10/here is baby bird.mp3": [
		2871,
		7,
		1546
	],
	"./00001/00001-12/00001-12-10/here is mother bird.mp3": [
		2872,
		7,
		1547
	],
	"./00001/00001-12/00001-12-10/intro.mp3": [
		478,
		7
	],
	"./00001/00001-12/00001-12-10/main idea.mp3": [
		859,
		7
	],
	"./00001/00001-12/00001-12-10/module": [
		1268,
		9,
		132
	],
	"./00001/00001-12/00001-12-10/module.js": [
		1268,
		9,
		132
	],
	"./00001/00001-12/00001-12-11/0 little monkeys jumped on the bed.mp3": [
		2873,
		7,
		1548
	],
	"./00001/00001-12/00001-12-11/0.jpg": [
		6821,
		7,
		5498
	],
	"./00001/00001-12/00001-12-11/1 little monkey jumped on the bed.mp3": [
		2874,
		7,
		1549
	],
	"./00001/00001-12/00001-12-11/1.jpg": [
		8336,
		7,
		8358
	],
	"./00001/00001-12/00001-12-11/2 little monkeys jumped on the bed.mp3": [
		2875,
		7,
		1550
	],
	"./00001/00001-12/00001-12-11/2.jpg": [
		8337,
		7,
		8359
	],
	"./00001/00001-12/00001-12-11/3 little monkeys jumped on the bed.mp3": [
		2876,
		7,
		1551
	],
	"./00001/00001-12/00001-12-11/3.jpg": [
		8338,
		7,
		8360
	],
	"./00001/00001-12/00001-12-11/4 little monkeys jumped on the bed.mp3": [
		2877,
		7,
		1552
	],
	"./00001/00001-12/00001-12-11/4.jpg": [
		8339,
		7,
		8361
	],
	"./00001/00001-12/00001-12-11/5 little monkeys jumped on the bed.mp3": [
		2878,
		7,
		1553
	],
	"./00001/00001-12/00001-12-11/5 little monkeys.mp3": [
		2879,
		7,
		1554
	],
	"./00001/00001-12/00001-12-11/5.jpg": [
		8340,
		7,
		8362
	],
	"./00001/00001-12/00001-12-11/6.jpg": [
		8341,
		7,
		8363
	],
	"./00001/00001-12/00001-12-11/7.jpg": [
		8342,
		7,
		8364
	],
	"./00001/00001-12/00001-12-11/animals that live in trees.mp3": [
		2880,
		7,
		1555
	],
	"./00001/00001-12/00001-12-11/intro.mp3": [
		479,
		7
	],
	"./00001/00001-12/00001-12-11/main idea.mp3": [
		860,
		7
	],
	"./00001/00001-12/00001-12-11/module": [
		1269,
		9,
		133
	],
	"./00001/00001-12/00001-12-11/module.js": [
		1269,
		9,
		133
	],
	"./00001/00001-12/cover.jpg": [
		6822,
		7,
		5499
	],
	"./00001/00001-12/story land.mp3": [
		2881,
		7,
		1556
	],
	"./00001/00001-12/unit": [
		1270,
		9,
		134
	],
	"./00001/00001-12/unit.js": [
		1270,
		9,
		134
	],
	"./00001/course": [
		1271,
		9,
		135
	],
	"./00001/course.js": [
		1271,
		9,
		135
	],
	"./00002/00002-01/00002-01-01/0.jpg": [
		6823,
		7,
		5500
	],
	"./00002/00002-01/00002-01-01/1.jpg": [
		8343,
		7,
		8365
	],
	"./00002/00002-01/00002-01-01/2.jpg": [
		8344,
		7,
		8366
	],
	"./00002/00002-01/00002-01-01/3.jpg": [
		8345,
		7,
		8367
	],
	"./00002/00002-01/00002-01-01/4.jpg": [
		8346,
		7,
		8368
	],
	"./00002/00002-01/00002-01-01/5.jpg": [
		8347,
		7,
		8369
	],
	"./00002/00002-01/00002-01-01/6.jpg": [
		8348,
		7,
		8370
	],
	"./00002/00002-01/00002-01-01/7.jpg": [
		8349,
		7,
		8371
	],
	"./00002/00002-01/00002-01-01/blue toys.mp3": [
		2882,
		7,
		1557
	],
	"./00002/00002-01/00002-01-01/here is a blue boat.mp3": [
		2883,
		7,
		1558
	],
	"./00002/00002-01/00002-01-01/here is a blue helicopter.mp3": [
		2884,
		7,
		1559
	],
	"./00002/00002-01/00002-01-01/here is my car.mp3": [
		2885,
		7,
		1560
	],
	"./00002/00002-01/00002-01-01/here is my robot.mp3": [
		2886,
		7,
		1561
	],
	"./00002/00002-01/00002-01-01/intro.mp3": [
		480,
		7
	],
	"./00002/00002-01/00002-01-01/look at my airplane.mp3": [
		2887,
		7,
		1562
	],
	"./00002/00002-01/00002-01-01/look at my boat.mp3": [
		2888,
		7,
		1563
	],
	"./00002/00002-01/00002-01-01/look at my helicopter.mp3": [
		2889,
		7,
		1564
	],
	"./00002/00002-01/00002-01-01/look at my train.mp3": [
		2890,
		7,
		1565
	],
	"./00002/00002-01/00002-01-01/look at my truck.mp3": [
		2891,
		7,
		1566
	],
	"./00002/00002-01/00002-01-01/main idea.mp3": [
		861,
		7
	],
	"./00002/00002-01/00002-01-01/module": [
		1272,
		9,
		136
	],
	"./00002/00002-01/00002-01-01/module.js": [
		1272,
		9,
		136
	],
	"./00002/00002-01/00002-01-01/my airplane is blue.mp3": [
		2892,
		7,
		1567
	],
	"./00002/00002-01/00002-01-01/my car is blue too.mp3": [
		2893,
		7,
		1568
	],
	"./00002/00002-01/00002-01-01/my robot is blue.mp3": [
		2894,
		7,
		1569
	],
	"./00002/00002-01/00002-01-01/my train is blue.mp3": [
		2895,
		7,
		1570
	],
	"./00002/00002-01/00002-01-01/my truck is blue.mp3": [
		2896,
		7,
		1571
	],
	"./00002/00002-01/00002-01-01/vehicles.mp3": [
		2897,
		7,
		1572
	],
	"./00002/00002-01/00002-01-02/0.jpg": [
		6824,
		7,
		5501
	],
	"./00002/00002-01/00002-01-02/1.jpg": [
		8350,
		7,
		8372
	],
	"./00002/00002-01/00002-01-02/2.jpg": [
		8351,
		7,
		8373
	],
	"./00002/00002-01/00002-01-02/3.jpg": [
		8352,
		7,
		8374
	],
	"./00002/00002-01/00002-01-02/4.jpg": [
		8353,
		7,
		8375
	],
	"./00002/00002-01/00002-01-02/5.jpg": [
		8354,
		7,
		8376
	],
	"./00002/00002-01/00002-01-02/6.jpg": [
		8355,
		7,
		8377
	],
	"./00002/00002-01/00002-01-02/7.jpg": [
		8356,
		7,
		8378
	],
	"./00002/00002-01/00002-01-02/here comes the car.mp3": [
		2898,
		7,
		1573
	],
	"./00002/00002-01/00002-01-02/here comes the fire truck.mp3": [
		2899,
		7,
		1574
	],
	"./00002/00002-01/00002-01-02/here comes the helicopter.mp3": [
		2900,
		7,
		1575
	],
	"./00002/00002-01/00002-01-02/here comes the motorcycle.mp3": [
		2901,
		7,
		1576
	],
	"./00002/00002-01/00002-01-02/here comes the plane.mp3": [
		2902,
		7,
		1577
	],
	"./00002/00002-01/00002-01-02/here comes the tractor.mp3": [
		2903,
		7,
		1578
	],
	"./00002/00002-01/00002-01-02/here comes the train.mp3": [
		2904,
		7,
		1579
	],
	"./00002/00002-01/00002-01-02/intro.mp3": [
		481,
		7
	],
	"./00002/00002-01/00002-01-02/main idea.mp3": [
		862,
		7
	],
	"./00002/00002-01/00002-01-02/module": [
		1273,
		9,
		137
	],
	"./00002/00002-01/00002-01-02/module.js": [
		1273,
		9,
		137
	],
	"./00002/00002-01/00002-01-02/red vehicles.mp3": [
		2905,
		7,
		1580
	],
	"./00002/00002-01/00002-01-02/the car is red.mp3": [
		2906,
		7,
		1581
	],
	"./00002/00002-01/00002-01-02/the fire truck is red.mp3": [
		2907,
		7,
		1582
	],
	"./00002/00002-01/00002-01-02/the helicopter is red.mp3": [
		2908,
		7,
		1583
	],
	"./00002/00002-01/00002-01-02/the motorcycle is red.mp3": [
		2909,
		7,
		1584
	],
	"./00002/00002-01/00002-01-02/the plane is red.mp3": [
		2910,
		7,
		1585
	],
	"./00002/00002-01/00002-01-02/the tractor is red.mp3": [
		2911,
		7,
		1586
	],
	"./00002/00002-01/00002-01-02/the train is red.mp3": [
		2912,
		7,
		1587
	],
	"./00002/00002-01/00002-01-02/things that are red.mp3": [
		2913,
		7,
		1588
	],
	"./00002/00002-01/00002-01-03/0.jpg": [
		6825,
		7,
		5502
	],
	"./00002/00002-01/00002-01-03/1.jpg": [
		8357,
		7,
		8379
	],
	"./00002/00002-01/00002-01-03/2.jpg": [
		8358,
		7,
		8380
	],
	"./00002/00002-01/00002-01-03/3.jpg": [
		8359,
		7,
		8381
	],
	"./00002/00002-01/00002-01-03/4.jpg": [
		8360,
		7,
		8382
	],
	"./00002/00002-01/00002-01-03/5.jpg": [
		8361,
		7,
		8383
	],
	"./00002/00002-01/00002-01-03/6.jpg": [
		8362,
		7,
		8384
	],
	"./00002/00002-01/00002-01-03/7.jpg": [
		8363,
		7,
		8385
	],
	"./00002/00002-01/00002-01-03/i like the bird.mp3": [
		2914,
		7,
		1589
	],
	"./00002/00002-01/00002-01-03/i like the butterfly.mp3": [
		2915,
		7,
		1590
	],
	"./00002/00002-01/00002-01-03/i like the caterpillar.mp3": [
		2916,
		7,
		1591
	],
	"./00002/00002-01/00002-01-03/i like the crab.mp3": [
		2917,
		7,
		1592
	],
	"./00002/00002-01/00002-01-03/i like the dog.mp3": [
		2918,
		7,
		1593
	],
	"./00002/00002-01/00002-01-03/i like the ducks.mp3": [
		2919,
		7,
		1594
	],
	"./00002/00002-01/00002-01-03/i like the fish.mp3": [
		2920,
		7,
		1595
	],
	"./00002/00002-01/00002-01-03/i like the spider.mp3": [
		2921,
		7,
		1596
	],
	"./00002/00002-01/00002-01-03/intro.mp3": [
		482,
		7
	],
	"./00002/00002-01/00002-01-03/main idea.mp3": [
		863,
		7
	],
	"./00002/00002-01/00002-01-03/module": [
		1274,
		9,
		138
	],
	"./00002/00002-01/00002-01-03/module.js": [
		1274,
		9,
		138
	],
	"./00002/00002-01/00002-01-03/the bird is yellow.mp3": [
		2922,
		7,
		1597
	],
	"./00002/00002-01/00002-01-03/the butterfly is yellow.mp3": [
		2923,
		7,
		1598
	],
	"./00002/00002-01/00002-01-03/the caterpillar is yellow.mp3": [
		2924,
		7,
		1599
	],
	"./00002/00002-01/00002-01-03/the crab is yellow.mp3": [
		2925,
		7,
		1600
	],
	"./00002/00002-01/00002-01-03/the dog is yellow.mp3": [
		2926,
		7,
		1601
	],
	"./00002/00002-01/00002-01-03/the ducks are yellow too.mp3": [
		2927,
		7,
		1602
	],
	"./00002/00002-01/00002-01-03/the fish is yellow.mp3": [
		2928,
		7,
		1603
	],
	"./00002/00002-01/00002-01-03/the spider is yellow.mp3": [
		2929,
		7,
		1604
	],
	"./00002/00002-01/00002-01-03/things that are yellow.mp3": [
		2930,
		7,
		1605
	],
	"./00002/00002-01/00002-01-03/yellow animals.mp3": [
		2931,
		7,
		1606
	],
	"./00002/00002-01/00002-01-04/0.jpg": [
		6826,
		7,
		5503
	],
	"./00002/00002-01/00002-01-04/1.jpg": [
		8364,
		7,
		8386
	],
	"./00002/00002-01/00002-01-04/2.jpg": [
		8365,
		7,
		8387
	],
	"./00002/00002-01/00002-01-04/3.jpg": [
		8366,
		7,
		8388
	],
	"./00002/00002-01/00002-01-04/4.jpg": [
		8367,
		7,
		8389
	],
	"./00002/00002-01/00002-01-04/5.jpg": [
		8368,
		7,
		8390
	],
	"./00002/00002-01/00002-01-04/6.jpg": [
		8369,
		7,
		8391
	],
	"./00002/00002-01/00002-01-04/7.jpg": [
		8370,
		7,
		8392
	],
	"./00002/00002-01/00002-01-04/i can not see the orange fox.mp3": [
		2932,
		7,
		1607
	],
	"./00002/00002-01/00002-01-04/i can see the orange butterfly.mp3": [
		2933,
		7,
		1608
	],
	"./00002/00002-01/00002-01-04/i can see the orange cat.mp3": [
		2934,
		7,
		1609
	],
	"./00002/00002-01/00002-01-04/i can see the orange fish.mp3": [
		2935,
		7,
		1610
	],
	"./00002/00002-01/00002-01-04/i can see the orange fox.mp3": [
		2936,
		7,
		1611
	],
	"./00002/00002-01/00002-01-04/i can see the orange salamander.mp3": [
		2937,
		7,
		1612
	],
	"./00002/00002-01/00002-01-04/i can see the orange snake.mp3": [
		2938,
		7,
		1613
	],
	"./00002/00002-01/00002-01-04/i can see the orange tiger.mp3": [
		2939,
		7,
		1614
	],
	"./00002/00002-01/00002-01-04/intro.mp3": [
		483,
		7
	],
	"./00002/00002-01/00002-01-04/main idea.mp3": [
		864,
		7
	],
	"./00002/00002-01/00002-01-04/module": [
		1275,
		9,
		139
	],
	"./00002/00002-01/00002-01-04/module.js": [
		1275,
		9,
		139
	],
	"./00002/00002-01/00002-01-04/orange things.mp3": [
		2940,
		7,
		1615
	],
	"./00002/00002-01/00002-01-04/the orange animal book.mp3": [
		2941,
		7,
		1616
	],
	"./00002/00002-01/00002-01-04/what else can i see.mp3": [
		2942,
		7,
		1617
	],
	"./00002/00002-01/00002-01-05/0.jpg": [
		6827,
		7,
		5504
	],
	"./00002/00002-01/00002-01-05/1.jpg": [
		8371,
		7,
		8393
	],
	"./00002/00002-01/00002-01-05/2.jpg": [
		8372,
		7,
		8394
	],
	"./00002/00002-01/00002-01-05/3.jpg": [
		8373,
		7,
		8395
	],
	"./00002/00002-01/00002-01-05/4.jpg": [
		8374,
		7,
		8396
	],
	"./00002/00002-01/00002-01-05/5.jpg": [
		8375,
		7,
		8397
	],
	"./00002/00002-01/00002-01-05/6.jpg": [
		8376,
		7,
		8398
	],
	"./00002/00002-01/00002-01-05/7.jpg": [
		8377,
		7,
		8399
	],
	"./00002/00002-01/00002-01-05/i look good in purple.mp3": [
		2943,
		7,
		1618
	],
	"./00002/00002-01/00002-01-05/i love purple he said.mp3": [
		2944,
		7,
		1619
	],
	"./00002/00002-01/00002-01-05/i love purple she said.mp3": [
		2945,
		7,
		1620
	],
	"./00002/00002-01/00002-01-05/i love purple.mp3": [
		2946,
		7,
		1621
	],
	"./00002/00002-01/00002-01-05/intro.mp3": [
		484,
		7
	],
	"./00002/00002-01/00002-01-05/look at me.mp3": [
		2947,
		7,
		1622
	],
	"./00002/00002-01/00002-01-05/main idea.mp3": [
		865,
		7
	],
	"./00002/00002-01/00002-01-05/module": [
		1276,
		9,
		140
	],
	"./00002/00002-01/00002-01-05/module.js": [
		1276,
		9,
		140
	],
	"./00002/00002-01/00002-01-05/the dog has a purple jacket.mp3": [
		2948,
		7,
		1623
	],
	"./00002/00002-01/00002-01-05/the goat has a purple scarf.mp3": [
		2949,
		7,
		1624
	],
	"./00002/00002-01/00002-01-05/the lion has a purple shirt.mp3": [
		2950,
		7,
		1625
	],
	"./00002/00002-01/00002-01-05/the octopus has purple mittens.mp3": [
		2951,
		7,
		1626
	],
	"./00002/00002-01/00002-01-05/the penguin has a purple helmet.mp3": [
		2952,
		7,
		1627
	],
	"./00002/00002-01/00002-01-05/the rabbit has a purple hat.mp3": [
		2953,
		7,
		1628
	],
	"./00002/00002-01/00002-01-05/the skunk has a purple dress.mp3": [
		2954,
		7,
		1629
	],
	"./00002/00002-01/00002-01-05/things that are purple.mp3": [
		2955,
		7,
		1630
	],
	"./00002/00002-01/00002-01-06/0.jpg": [
		6828,
		7,
		5505
	],
	"./00002/00002-01/00002-01-06/1.jpg": [
		8378,
		7,
		8400
	],
	"./00002/00002-01/00002-01-06/2.jpg": [
		8379,
		7,
		8401
	],
	"./00002/00002-01/00002-01-06/3.jpg": [
		8380,
		7,
		8402
	],
	"./00002/00002-01/00002-01-06/4.jpg": [
		8381,
		7,
		8403
	],
	"./00002/00002-01/00002-01-06/5.jpg": [
		8382,
		7,
		8404
	],
	"./00002/00002-01/00002-01-06/6.jpg": [
		8383,
		7,
		8405
	],
	"./00002/00002-01/00002-01-06/7.jpg": [
		8384,
		7,
		8406
	],
	"./00002/00002-01/00002-01-06/animals that are green.mp3": [
		2956,
		7,
		1631
	],
	"./00002/00002-01/00002-01-06/i am a green alligator.mp3": [
		2957,
		7,
		1632
	],
	"./00002/00002-01/00002-01-06/i am a green frog.mp3": [
		2958,
		7,
		1633
	],
	"./00002/00002-01/00002-01-06/i am a green grasshopper.mp3": [
		2959,
		7,
		1634
	],
	"./00002/00002-01/00002-01-06/i am a green praying mantis.mp3": [
		2960,
		7,
		1635
	],
	"./00002/00002-01/00002-01-06/i am a green turtle.mp3": [
		2961,
		7,
		1636
	],
	"./00002/00002-01/00002-01-06/i can hide from the alligator.mp3": [
		2962,
		7,
		1637
	],
	"./00002/00002-01/00002-01-06/i can hide from the frog.mp3": [
		2963,
		7,
		1638
	],
	"./00002/00002-01/00002-01-06/i can hide in the leaves.mp3": [
		2964,
		7,
		1639
	],
	"./00002/00002-01/00002-01-06/intro.mp3": [
		485,
		7
	],
	"./00002/00002-01/00002-01-06/main idea.mp3": [
		866,
		7
	],
	"./00002/00002-01/00002-01-06/module": [
		1277,
		9,
		141
	],
	"./00002/00002-01/00002-01-06/module.js": [
		1277,
		9,
		141
	],
	"./00002/00002-01/00002-01-06/the green book.mp3": [
		2965,
		7,
		1640
	],
	"./00002/00002-01/00002-01-06/we are green aphids.mp3": [
		2966,
		7,
		1641
	],
	"./00002/00002-01/00002-01-06/we are green dinosaurs.mp3": [
		2967,
		7,
		1642
	],
	"./00002/00002-01/00002-01-06/we can hide in the leaves too.mp3": [
		2968,
		7,
		1643
	],
	"./00002/00002-01/00002-01-06/you can not see me.mp3": [
		2969,
		7,
		1644
	],
	"./00002/00002-01/00002-01-06/you can not see us.mp3": [
		2970,
		7,
		1645
	],
	"./00002/00002-01/00002-01-07/0.jpg": [
		6829,
		7,
		5506
	],
	"./00002/00002-01/00002-01-07/1.jpg": [
		8385,
		7,
		8407
	],
	"./00002/00002-01/00002-01-07/2.jpg": [
		8386,
		7,
		8408
	],
	"./00002/00002-01/00002-01-07/3.jpg": [
		8387,
		7,
		8409
	],
	"./00002/00002-01/00002-01-07/4.jpg": [
		8388,
		7,
		8410
	],
	"./00002/00002-01/00002-01-07/5.jpg": [
		8389,
		7,
		8411
	],
	"./00002/00002-01/00002-01-07/6.jpg": [
		8390,
		7,
		8412
	],
	"./00002/00002-01/00002-01-07/7.jpg": [
		8391,
		7,
		8413
	],
	"./00002/00002-01/00002-01-07/animals that are brown.mp3": [
		2971,
		7,
		1646
	],
	"./00002/00002-01/00002-01-07/i saw 2 brown birds.mp3": [
		2972,
		7,
		1647
	],
	"./00002/00002-01/00002-01-07/i saw 2 brown rabbits.mp3": [
		2973,
		7,
		1648
	],
	"./00002/00002-01/00002-01-07/i saw 2 little brown bears.mp3": [
		2974,
		7,
		1649
	],
	"./00002/00002-01/00002-01-07/i saw 2 little brown deer.mp3": [
		2975,
		7,
		1650
	],
	"./00002/00002-01/00002-01-07/i saw a big brown bear.mp3": [
		2976,
		7,
		1651
	],
	"./00002/00002-01/00002-01-07/i saw a big brown deer.mp3": [
		2977,
		7,
		1652
	],
	"./00002/00002-01/00002-01-07/i saw a brown hedgehog.mp3": [
		2978,
		7,
		1653
	],
	"./00002/00002-01/00002-01-07/i went to the forest.mp3": [
		2979,
		7,
		1654
	],
	"./00002/00002-01/00002-01-07/intro.mp3": [
		486,
		7
	],
	"./00002/00002-01/00002-01-07/main idea.mp3": [
		867,
		7
	],
	"./00002/00002-01/00002-01-07/module": [
		1278,
		9,
		142
	],
	"./00002/00002-01/00002-01-07/module.js": [
		1278,
		9,
		142
	],
	"./00002/00002-01/00002-01-07/the brown book.mp3": [
		2980,
		7,
		1655
	],
	"./00002/00002-01/00002-01-07/what did i see.mp3": [
		2981,
		7,
		1656
	],
	"./00002/00002-01/00002-01-08/0.jpg": [
		6830,
		7,
		5507
	],
	"./00002/00002-01/00002-01-08/1.jpg": [
		8392,
		7,
		8414
	],
	"./00002/00002-01/00002-01-08/2.jpg": [
		8393,
		7,
		8415
	],
	"./00002/00002-01/00002-01-08/3.jpg": [
		8394,
		7,
		8416
	],
	"./00002/00002-01/00002-01-08/4.jpg": [
		8395,
		7,
		8417
	],
	"./00002/00002-01/00002-01-08/5.jpg": [
		8396,
		7,
		8418
	],
	"./00002/00002-01/00002-01-08/6.jpg": [
		8397,
		7,
		8419
	],
	"./00002/00002-01/00002-01-08/7.jpg": [
		8398,
		7,
		8420
	],
	"./00002/00002-01/00002-01-08/animals.mp3": [
		2982,
		7,
		1657
	],
	"./00002/00002-01/00002-01-08/intro.mp3": [
		487,
		7
	],
	"./00002/00002-01/00002-01-08/look at the ants.mp3": [
		2983,
		7,
		1658
	],
	"./00002/00002-01/00002-01-08/look at the birds.mp3": [
		2984,
		7,
		1659
	],
	"./00002/00002-01/00002-01-08/look at the cats.mp3": [
		2985,
		7,
		1660
	],
	"./00002/00002-01/00002-01-08/look at the cows.mp3": [
		2986,
		7,
		1661
	],
	"./00002/00002-01/00002-01-08/look at the dogs.mp3": [
		2987,
		7,
		1662
	],
	"./00002/00002-01/00002-01-08/look at the horses.mp3": [
		2988,
		7,
		1663
	],
	"./00002/00002-01/00002-01-08/look at the spiders.mp3": [
		2989,
		7,
		1664
	],
	"./00002/00002-01/00002-01-08/main idea.mp3": [
		868,
		7
	],
	"./00002/00002-01/00002-01-08/module": [
		1279,
		9,
		143
	],
	"./00002/00002-01/00002-01-08/module.js": [
		1279,
		9,
		143
	],
	"./00002/00002-01/00002-01-08/one of them is black.mp3": [
		2990,
		7,
		1665
	],
	"./00002/00002-01/00002-01-08/one of them is red.mp3": [
		2991,
		7,
		1666
	],
	"./00002/00002-01/00002-01-08/one of them is white.mp3": [
		2992,
		7,
		1667
	],
	"./00002/00002-01/00002-01-08/the black book.mp3": [
		2993,
		7,
		1668
	],
	"./00002/00002-01/00002-01-09/0.jpg": [
		6831,
		7,
		5508
	],
	"./00002/00002-01/00002-01-09/1.jpg": [
		8399,
		7,
		8421
	],
	"./00002/00002-01/00002-01-09/2.jpg": [
		8400,
		7,
		8422
	],
	"./00002/00002-01/00002-01-09/3.jpg": [
		8401,
		7,
		8423
	],
	"./00002/00002-01/00002-01-09/4.jpg": [
		8402,
		7,
		8424
	],
	"./00002/00002-01/00002-01-09/5.jpg": [
		8403,
		7,
		8425
	],
	"./00002/00002-01/00002-01-09/6.jpg": [
		8404,
		7,
		8426
	],
	"./00002/00002-01/00002-01-09/7.jpg": [
		8405,
		7,
		8427
	],
	"./00002/00002-01/00002-01-09/animals that live in the snow.mp3": [
		2994,
		7,
		1669
	],
	"./00002/00002-01/00002-01-09/he is white in the winter.mp3": [
		2995,
		7,
		1670
	],
	"./00002/00002-01/00002-01-09/he is white like the snow.mp3": [
		2996,
		7,
		1671
	],
	"./00002/00002-01/00002-01-09/intro.mp3": [
		488,
		7
	],
	"./00002/00002-01/00002-01-09/main idea.mp3": [
		869,
		7
	],
	"./00002/00002-01/00002-01-09/module": [
		1280,
		9,
		144
	],
	"./00002/00002-01/00002-01-09/module.js": [
		1280,
		9,
		144
	],
	"./00002/00002-01/00002-01-09/she is white in the winter.mp3": [
		2997,
		7,
		1672
	],
	"./00002/00002-01/00002-01-09/she is white like the snow.mp3": [
		2998,
		7,
		1673
	],
	"./00002/00002-01/00002-01-09/the arctic fox is white.mp3": [
		2999,
		7,
		1674
	],
	"./00002/00002-01/00002-01-09/the arctic wolf is white.mp3": [
		3000,
		7,
		1675
	],
	"./00002/00002-01/00002-01-09/the polar bear is white.mp3": [
		3001,
		7,
		1676
	],
	"./00002/00002-01/00002-01-09/the ptarmigan is white.mp3": [
		3002,
		7,
		1677
	],
	"./00002/00002-01/00002-01-09/the seal pup is white.mp3": [
		3003,
		7,
		1678
	],
	"./00002/00002-01/00002-01-09/the snowshoe rabbit is white.mp3": [
		3004,
		7,
		1679
	],
	"./00002/00002-01/00002-01-09/the snowy owl is white.mp3": [
		3005,
		7,
		1680
	],
	"./00002/00002-01/00002-01-09/the white book.mp3": [
		3006,
		7,
		1681
	],
	"./00002/00002-01/00002-01-10/0.jpg": [
		6832,
		7,
		5509
	],
	"./00002/00002-01/00002-01-10/1.jpg": [
		8406,
		7,
		8428
	],
	"./00002/00002-01/00002-01-10/2.jpg": [
		8407,
		7,
		8429
	],
	"./00002/00002-01/00002-01-10/3.jpg": [
		8408,
		7,
		8430
	],
	"./00002/00002-01/00002-01-10/4.jpg": [
		8409,
		7,
		8431
	],
	"./00002/00002-01/00002-01-10/5.jpg": [
		8410,
		7,
		8432
	],
	"./00002/00002-01/00002-01-10/6.jpg": [
		8411,
		7,
		8433
	],
	"./00002/00002-01/00002-01-10/7.jpg": [
		8412,
		7,
		8434
	],
	"./00002/00002-01/00002-01-10/i see a pink flamingo.mp3": [
		3007,
		7,
		1682
	],
	"./00002/00002-01/00002-01-10/i see a pink hermit crab.mp3": [
		3008,
		7,
		1683
	],
	"./00002/00002-01/00002-01-10/i see a pink pig.mp3": [
		3009,
		7,
		1684
	],
	"./00002/00002-01/00002-01-10/i see a pink rabbit.mp3": [
		3010,
		7,
		1685
	],
	"./00002/00002-01/00002-01-10/i see a pink shell.mp3": [
		3011,
		7,
		1686
	],
	"./00002/00002-01/00002-01-10/i see a pink starfish.mp3": [
		3012,
		7,
		1687
	],
	"./00002/00002-01/00002-01-10/i see some pink flowers.mp3": [
		3013,
		7,
		1688
	],
	"./00002/00002-01/00002-01-10/i spy something pink.mp3": [
		3014,
		7,
		1689
	],
	"./00002/00002-01/00002-01-10/i spy with my little eye said the boy.mp3": [
		3015,
		7,
		1690
	],
	"./00002/00002-01/00002-01-10/i spy with my little eye said the girl.mp3": [
		3016,
		7,
		1691
	],
	"./00002/00002-01/00002-01-10/intro.mp3": [
		489,
		7
	],
	"./00002/00002-01/00002-01-10/main idea.mp3": [
		870,
		7
	],
	"./00002/00002-01/00002-01-10/module": [
		1281,
		9,
		145
	],
	"./00002/00002-01/00002-01-10/module.js": [
		1281,
		9,
		145
	],
	"./00002/00002-01/00002-01-10/the pig likes the flowers.mp3": [
		3017,
		7,
		1692
	],
	"./00002/00002-01/00002-01-10/the pink book.mp3": [
		3018,
		7,
		1693
	],
	"./00002/00002-01/00002-01-10/things that are pink.mp3": [
		3019,
		7,
		1694
	],
	"./00002/00002-01/color town.mp3": [
		3020,
		7,
		1695
	],
	"./00002/00002-01/colors.mp3": [
		3021,
		7,
		1696
	],
	"./00002/00002-01/cover.jpg": [
		6833,
		7,
		5510
	],
	"./00002/00002-01/unit": [
		1282,
		9,
		146
	],
	"./00002/00002-01/unit.js": [
		1282,
		9,
		146
	],
	"./00002/00002-02/00002-02-01/0.jpg": [
		6834,
		7,
		5511
	],
	"./00002/00002-02/00002-02-01/1.jpg": [
		8413,
		7,
		8435
	],
	"./00002/00002-02/00002-02-01/2.jpg": [
		8414,
		7,
		8436
	],
	"./00002/00002-02/00002-02-01/3.jpg": [
		8415,
		7,
		8437
	],
	"./00002/00002-02/00002-02-01/4.jpg": [
		8416,
		7,
		8438
	],
	"./00002/00002-02/00002-02-01/5.jpg": [
		8417,
		7,
		8439
	],
	"./00002/00002-02/00002-02-01/6.jpg": [
		8418,
		7,
		8440
	],
	"./00002/00002-02/00002-02-01/7.jpg": [
		8419,
		7,
		8441
	],
	"./00002/00002-02/00002-02-01/animals.mp3": [
		3022,
		7,
		1697
	],
	"./00002/00002-02/00002-02-01/here is a bear.mp3": [
		3023,
		7,
		1698
	],
	"./00002/00002-02/00002-02-01/here is a mitten.mp3": [
		3024,
		7,
		1699
	],
	"./00002/00002-02/00002-02-01/intro.mp3": [
		490,
		7
	],
	"./00002/00002-02/00002-02-01/look at the bear.mp3": [
		3025,
		7,
		1700
	],
	"./00002/00002-02/00002-02-01/look at the fox.mp3": [
		3026,
		7,
		1701
	],
	"./00002/00002-02/00002-02-01/look at the mitten.mp3": [
		3027,
		7,
		1702
	],
	"./00002/00002-02/00002-02-01/look at the mouse.mp3": [
		3028,
		7,
		1703
	],
	"./00002/00002-02/00002-02-01/look at the owl.mp3": [
		3029,
		7,
		1704
	],
	"./00002/00002-02/00002-02-01/look at the rabbit.mp3": [
		3030,
		7,
		1705
	],
	"./00002/00002-02/00002-02-01/main idea.mp3": [
		871,
		7
	],
	"./00002/00002-02/00002-02-01/module": [
		1283,
		9,
		147
	],
	"./00002/00002-02/00002-02-01/module.js": [
		1283,
		9,
		147
	],
	"./00002/00002-02/00002-02-01/the fox is going in the mitten.mp3": [
		3031,
		7,
		1706
	],
	"./00002/00002-02/00002-02-01/the mitten.mp3": [
		3032,
		7,
		1707
	],
	"./00002/00002-02/00002-02-01/the mouse is going in the mitten.mp3": [
		3033,
		7,
		1708
	],
	"./00002/00002-02/00002-02-01/the owl is going in the mitten.mp3": [
		3034,
		7,
		1709
	],
	"./00002/00002-02/00002-02-01/the rabbit is going in the mitten.mp3": [
		3035,
		7,
		1710
	],
	"./00002/00002-02/00002-02-02/0.jpg": [
		6835,
		7,
		5512
	],
	"./00002/00002-02/00002-02-02/1.jpg": [
		8420,
		7,
		8442
	],
	"./00002/00002-02/00002-02-02/2.jpg": [
		8421,
		7,
		8443
	],
	"./00002/00002-02/00002-02-02/3.jpg": [
		8422,
		7,
		8444
	],
	"./00002/00002-02/00002-02-02/4.jpg": [
		8423,
		7,
		8445
	],
	"./00002/00002-02/00002-02-02/5.jpg": [
		8424,
		7,
		8446
	],
	"./00002/00002-02/00002-02-02/6.jpg": [
		8425,
		7,
		8447
	],
	"./00002/00002-02/00002-02-02/7.jpg": [
		8426,
		7,
		8448
	],
	"./00002/00002-02/00002-02-02/dogs.mp3": [
		3036,
		7,
		1711
	],
	"./00002/00002-02/00002-02-02/here they are.mp3": [
		3037,
		7,
		1712
	],
	"./00002/00002-02/00002-02-02/intro.mp3": [
		491,
		7
	],
	"./00002/00002-02/00002-02-02/look in the bathroom.mp3": [
		3038,
		7,
		1713
	],
	"./00002/00002-02/00002-02-02/look in the bedroom.mp3": [
		3039,
		7,
		1714
	],
	"./00002/00002-02/00002-02-02/look in the box.mp3": [
		3040,
		7,
		1715
	],
	"./00002/00002-02/00002-02-02/look in the kitchen.mp3": [
		3041,
		7,
		1716
	],
	"./00002/00002-02/00002-02-02/look in the living room.mp3": [
		3042,
		7,
		1717
	],
	"./00002/00002-02/00002-02-02/look in the shower.mp3": [
		3043,
		7,
		1718
	],
	"./00002/00002-02/00002-02-02/look.mp3": [
		3044,
		7,
		1719
	],
	"./00002/00002-02/00002-02-02/main idea.mp3": [
		872,
		7
	],
	"./00002/00002-02/00002-02-02/module": [
		1284,
		9,
		148
	],
	"./00002/00002-02/00002-02-02/module.js": [
		1284,
		9,
		148
	],
	"./00002/00002-02/00002-02-02/where are the puppies.mp3": [
		3045,
		7,
		1720
	],
	"./00002/00002-02/00002-02-03/0.jpg": [
		6836,
		7,
		5513
	],
	"./00002/00002-02/00002-02-03/1.jpg": [
		8427,
		7,
		8449
	],
	"./00002/00002-02/00002-02-03/2.jpg": [
		8428,
		7,
		8450
	],
	"./00002/00002-02/00002-02-03/3.jpg": [
		8429,
		7,
		8451
	],
	"./00002/00002-02/00002-02-03/4.jpg": [
		8430,
		7,
		8452
	],
	"./00002/00002-02/00002-02-03/5.jpg": [
		8431,
		7,
		8453
	],
	"./00002/00002-02/00002-02-03/6.jpg": [
		8432,
		7,
		8454
	],
	"./00002/00002-02/00002-02-03/7.jpg": [
		8433,
		7,
		8455
	],
	"./00002/00002-02/00002-02-03/farm animals.mp3": [
		3046,
		7,
		1721
	],
	"./00002/00002-02/00002-02-03/intro.mp3": [
		492,
		7
	],
	"./00002/00002-02/00002-02-03/main idea.mp3": [
		873,
		7
	],
	"./00002/00002-02/00002-02-03/module": [
		1285,
		9,
		149
	],
	"./00002/00002-02/00002-02-03/module.js": [
		1285,
		9,
		149
	],
	"./00002/00002-02/00002-02-03/the animals get off the bus.mp3": [
		3047,
		7,
		1722
	],
	"./00002/00002-02/00002-02-03/the bus ride.mp3": [
		3048,
		7,
		1723
	],
	"./00002/00002-02/00002-02-03/the cats go on the bus.mp3": [
		3049,
		7,
		1724
	],
	"./00002/00002-02/00002-02-03/the cows go on the bus.mp3": [
		3050,
		7,
		1725
	],
	"./00002/00002-02/00002-02-03/the dogs go on the bus.mp3": [
		3051,
		7,
		1726
	],
	"./00002/00002-02/00002-02-03/the ducks go on the bus.mp3": [
		3052,
		7,
		1727
	],
	"./00002/00002-02/00002-02-03/the horses go on the bus.mp3": [
		3053,
		7,
		1728
	],
	"./00002/00002-02/00002-02-03/the lions go on the bus.mp3": [
		3054,
		7,
		1729
	],
	"./00002/00002-02/00002-02-03/the sheep go on the bus.mp3": [
		3055,
		7,
		1730
	],
	"./00002/00002-02/00002-02-03/then the bus goes fast.mp3": [
		3056,
		7,
		1731
	],
	"./00002/00002-02/00002-02-04/0.jpg": [
		6837,
		7,
		5514
	],
	"./00002/00002-02/00002-02-04/1.jpg": [
		8434,
		7,
		8456
	],
	"./00002/00002-02/00002-02-04/2.jpg": [
		8435,
		7,
		8457
	],
	"./00002/00002-02/00002-02-04/3.jpg": [
		8436,
		7,
		8458
	],
	"./00002/00002-02/00002-02-04/4.jpg": [
		8437,
		7,
		8459
	],
	"./00002/00002-02/00002-02-04/5.jpg": [
		8438,
		7,
		8460
	],
	"./00002/00002-02/00002-02-04/6.jpg": [
		8439,
		7,
		8461
	],
	"./00002/00002-02/00002-02-04/7.jpg": [
		8440,
		7,
		8462
	],
	"./00002/00002-02/00002-02-04/can i play with the hedgehog.mp3": [
		3057,
		7,
		1732
	],
	"./00002/00002-02/00002-02-04/can i play with the kitten.mp3": [
		3058,
		7,
		1733
	],
	"./00002/00002-02/00002-02-04/can i play with the owl.mp3": [
		3059,
		7,
		1734
	],
	"./00002/00002-02/00002-02-04/can i play with the rabbit.mp3": [
		3060,
		7,
		1735
	],
	"./00002/00002-02/00002-02-04/can i play with the skunk.mp3": [
		3061,
		7,
		1736
	],
	"./00002/00002-02/00002-02-04/can i play with the snake.mp3": [
		3062,
		7,
		1737
	],
	"./00002/00002-02/00002-02-04/can i play with the turtle.mp3": [
		3063,
		7,
		1738
	],
	"./00002/00002-02/00002-02-04/dogs.mp3": [
		3064,
		7,
		1739
	],
	"./00002/00002-02/00002-02-04/intro.mp3": [
		493,
		7
	],
	"./00002/00002-02/00002-02-04/main idea.mp3": [
		874,
		7
	],
	"./00002/00002-02/00002-02-04/module": [
		1286,
		9,
		150
	],
	"./00002/00002-02/00002-02-04/module.js": [
		1286,
		9,
		150
	],
	"./00002/00002-02/00002-02-04/no no puppy.mp3": [
		3065,
		7,
		1740
	],
	"./00002/00002-02/00002-02-04/no puppy no.mp3": [
		3066,
		7,
		1741
	],
	"./00002/00002-02/00002-02-04/no puppy.mp3": [
		3067,
		7,
		1742
	],
	"./00002/00002-02/00002-02-04/yes yes puppy.mp3": [
		3068,
		7,
		1743
	],
	"./00002/00002-02/00002-02-04/you can not play with the hedgehog.mp3": [
		3069,
		7,
		1744
	],
	"./00002/00002-02/00002-02-04/you can not play with the owl.mp3": [
		3070,
		7,
		1745
	],
	"./00002/00002-02/00002-02-04/you can not play with the rabbit.mp3": [
		3071,
		7,
		1746
	],
	"./00002/00002-02/00002-02-04/you can not play with the skunk.mp3": [
		3072,
		7,
		1747
	],
	"./00002/00002-02/00002-02-04/you can not play with the snake.mp3": [
		3073,
		7,
		1748
	],
	"./00002/00002-02/00002-02-04/you can not play with the turtle.mp3": [
		3074,
		7,
		1749
	],
	"./00002/00002-02/00002-02-04/you can play with the kitten.mp3": [
		3075,
		7,
		1750
	],
	"./00002/00002-02/00002-02-05/0.jpg": [
		6838,
		7,
		5515
	],
	"./00002/00002-02/00002-02-05/1.jpg": [
		8441,
		7,
		8463
	],
	"./00002/00002-02/00002-02-05/2.jpg": [
		8442,
		7,
		8464
	],
	"./00002/00002-02/00002-02-05/3.jpg": [
		8443,
		7,
		8465
	],
	"./00002/00002-02/00002-02-05/4.jpg": [
		8444,
		7,
		8466
	],
	"./00002/00002-02/00002-02-05/5.jpg": [
		8445,
		7,
		8467
	],
	"./00002/00002-02/00002-02-05/6.jpg": [
		8446,
		7,
		8468
	],
	"./00002/00002-02/00002-02-05/7.jpg": [
		8447,
		7,
		8469
	],
	"./00002/00002-02/00002-02-05/animals that are gray.mp3": [
		3076,
		7,
		1751
	],
	"./00002/00002-02/00002-02-05/i love black and white.mp3": [
		3077,
		7,
		1752
	],
	"./00002/00002-02/00002-02-05/i love blue.mp3": [
		3078,
		7,
		1753
	],
	"./00002/00002-02/00002-02-05/i love gray said the elephant.mp3": [
		3079,
		7,
		1754
	],
	"./00002/00002-02/00002-02-05/i love green.mp3": [
		3080,
		7,
		1755
	],
	"./00002/00002-02/00002-02-05/i love orange said the goat.mp3": [
		3081,
		7,
		1756
	],
	"./00002/00002-02/00002-02-05/i love purple said the girl.mp3": [
		3082,
		7,
		1757
	],
	"./00002/00002-02/00002-02-05/i love red.mp3": [
		3083,
		7,
		1758
	],
	"./00002/00002-02/00002-02-05/i love to paint said the boy.mp3": [
		3084,
		7,
		1759
	],
	"./00002/00002-02/00002-02-05/i love to paint said the mouse.mp3": [
		3085,
		7,
		1760
	],
	"./00002/00002-02/00002-02-05/i love to paint said the rabbit.mp3": [
		3086,
		7,
		1761
	],
	"./00002/00002-02/00002-02-05/i love to paint said the zebra.mp3": [
		3087,
		7,
		1762
	],
	"./00002/00002-02/00002-02-05/i love to paint.mp3": [
		3088,
		7,
		1763
	],
	"./00002/00002-02/00002-02-05/intro.mp3": [
		494,
		7
	],
	"./00002/00002-02/00002-02-05/main idea.mp3": [
		875,
		7
	],
	"./00002/00002-02/00002-02-05/module": [
		1287,
		9,
		151
	],
	"./00002/00002-02/00002-02-05/module.js": [
		1287,
		9,
		151
	],
	"./00002/00002-02/00002-02-06/0.jpg": [
		6839,
		7,
		5516
	],
	"./00002/00002-02/00002-02-06/1.jpg": [
		8448,
		7,
		8470
	],
	"./00002/00002-02/00002-02-06/2.jpg": [
		8449,
		7,
		8471
	],
	"./00002/00002-02/00002-02-06/3.jpg": [
		8450,
		7,
		8472
	],
	"./00002/00002-02/00002-02-06/4.jpg": [
		8451,
		7,
		8473
	],
	"./00002/00002-02/00002-02-06/5.jpg": [
		8452,
		7,
		8474
	],
	"./00002/00002-02/00002-02-06/6.jpg": [
		8453,
		7,
		8475
	],
	"./00002/00002-02/00002-02-06/7.jpg": [
		8454,
		7,
		8476
	],
	"./00002/00002-02/00002-02-06/food.mp3": [
		3089,
		7,
		1764
	],
	"./00002/00002-02/00002-02-06/intro.mp3": [
		495,
		7
	],
	"./00002/00002-02/00002-02-06/look at the alligator.mp3": [
		3090,
		7,
		1765
	],
	"./00002/00002-02/00002-02-06/look at the cow.mp3": [
		3091,
		7,
		1766
	],
	"./00002/00002-02/00002-02-06/look at the dog.mp3": [
		3092,
		7,
		1767
	],
	"./00002/00002-02/00002-02-06/look at the gingerbread man.mp3": [
		3093,
		7,
		1768
	],
	"./00002/00002-02/00002-02-06/look at the horse.mp3": [
		3094,
		7,
		1769
	],
	"./00002/00002-02/00002-02-06/look at the sheep.mp3": [
		3095,
		7,
		1770
	],
	"./00002/00002-02/00002-02-06/main idea.mp3": [
		876,
		7
	],
	"./00002/00002-02/00002-02-06/module": [
		1288,
		9,
		152
	],
	"./00002/00002-02/00002-02-06/module.js": [
		1288,
		9,
		152
	],
	"./00002/00002-02/00002-02-06/no said the gingerbread man.mp3": [
		3096,
		7,
		1771
	],
	"./00002/00002-02/00002-02-06/stop said the alligator.mp3": [
		3097,
		7,
		1772
	],
	"./00002/00002-02/00002-02-06/stop said the cow.mp3": [
		3098,
		7,
		1773
	],
	"./00002/00002-02/00002-02-06/stop said the dog.mp3": [
		3099,
		7,
		1774
	],
	"./00002/00002-02/00002-02-06/stop said the horse.mp3": [
		3100,
		7,
		1775
	],
	"./00002/00002-02/00002-02-06/stop said the sheep.mp3": [
		3101,
		7,
		1776
	],
	"./00002/00002-02/00002-02-06/the gingerbread man.mp3": [
		3102,
		7,
		1777
	],
	"./00002/00002-02/00002-02-06/you cant catch me.mp3": [
		3103,
		7,
		1778
	],
	"./00002/00002-02/00002-02-07/0 little frogs sat on a log.mp3": [
		3104,
		7,
		1779
	],
	"./00002/00002-02/00002-02-07/0.jpg": [
		6840,
		7,
		5517
	],
	"./00002/00002-02/00002-02-07/1 frog jumped into the pond.mp3": [
		3105,
		7,
		1780
	],
	"./00002/00002-02/00002-02-07/1 little frog sat on a log.mp3": [
		3106,
		7,
		1781
	],
	"./00002/00002-02/00002-02-07/1.jpg": [
		8455,
		7,
		8477
	],
	"./00002/00002-02/00002-02-07/2 little frogs sat on a log.mp3": [
		3107,
		7,
		1782
	],
	"./00002/00002-02/00002-02-07/2.jpg": [
		8456,
		7,
		8478
	],
	"./00002/00002-02/00002-02-07/3 little frogs sat on a log.mp3": [
		3108,
		7,
		1783
	],
	"./00002/00002-02/00002-02-07/3.jpg": [
		8457,
		7,
		8479
	],
	"./00002/00002-02/00002-02-07/4 little frogs sat on a log.mp3": [
		3109,
		7,
		1784
	],
	"./00002/00002-02/00002-02-07/4.jpg": [
		8458,
		7,
		8480
	],
	"./00002/00002-02/00002-02-07/5 little frogs sat in the pond.mp3": [
		3110,
		7,
		1785
	],
	"./00002/00002-02/00002-02-07/5 little frogs sat on a log.mp3": [
		3111,
		7,
		1786
	],
	"./00002/00002-02/00002-02-07/5 little frogs.mp3": [
		3112,
		7,
		1787
	],
	"./00002/00002-02/00002-02-07/5.jpg": [
		8459,
		7,
		8481
	],
	"./00002/00002-02/00002-02-07/6.jpg": [
		8460,
		7,
		8482
	],
	"./00002/00002-02/00002-02-07/7.jpg": [
		8461,
		7,
		8483
	],
	"./00002/00002-02/00002-02-07/intro.mp3": [
		496,
		7
	],
	"./00002/00002-02/00002-02-07/main idea.mp3": [
		877,
		7
	],
	"./00002/00002-02/00002-02-07/module": [
		1289,
		9,
		153
	],
	"./00002/00002-02/00002-02-07/module.js": [
		1289,
		9,
		153
	],
	"./00002/00002-02/00002-02-07/she jumped into the pond.mp3": [
		3113,
		7,
		1788
	],
	"./00002/00002-02/00002-02-07/water animals.mp3": [
		3114,
		7,
		1789
	],
	"./00002/00002-02/00002-02-07/where are the frogs.mp3": [
		3115,
		7,
		1790
	],
	"./00002/00002-02/00002-02-08/0.jpg": [
		6841,
		7,
		5518
	],
	"./00002/00002-02/00002-02-08/1.jpg": [
		8462,
		7,
		8484
	],
	"./00002/00002-02/00002-02-08/2.jpg": [
		8463,
		7,
		8485
	],
	"./00002/00002-02/00002-02-08/3.jpg": [
		8464,
		7,
		8486
	],
	"./00002/00002-02/00002-02-08/4.jpg": [
		8465,
		7,
		8487
	],
	"./00002/00002-02/00002-02-08/5.jpg": [
		8466,
		7,
		8488
	],
	"./00002/00002-02/00002-02-08/6.jpg": [
		8467,
		7,
		8489
	],
	"./00002/00002-02/00002-02-08/7.jpg": [
		8468,
		7,
		8490
	],
	"./00002/00002-02/00002-02-08/can i have a crocodile said sam.mp3": [
		3116,
		7,
		1791
	],
	"./00002/00002-02/00002-02-08/can i have a dog said sam.mp3": [
		3117,
		7,
		1792
	],
	"./00002/00002-02/00002-02-08/can i have a giraffe said sam.mp3": [
		3118,
		7,
		1793
	],
	"./00002/00002-02/00002-02-08/can i have a pet.mp3": [
		3119,
		7,
		1794
	],
	"./00002/00002-02/00002-02-08/can i have an elephant said sam.mp3": [
		3120,
		7,
		1795
	],
	"./00002/00002-02/00002-02-08/intro.mp3": [
		497,
		7
	],
	"./00002/00002-02/00002-02-08/main idea.mp3": [
		878,
		7
	],
	"./00002/00002-02/00002-02-08/module": [
		1290,
		9,
		154
	],
	"./00002/00002-02/00002-02-08/module.js": [
		1290,
		9,
		154
	],
	"./00002/00002-02/00002-02-08/no monkeys.mp3": [
		3121,
		7,
		1796
	],
	"./00002/00002-02/00002-02-08/no said dad.mp3": [
		3122,
		7,
		1797
	],
	"./00002/00002-02/00002-02-08/no said mom and dad.mp3": [
		3123,
		7,
		1798
	],
	"./00002/00002-02/00002-02-08/no said mom.mp3": [
		3124,
		7,
		1799
	],
	"./00002/00002-02/00002-02-08/pets.mp3": [
		3125,
		7,
		1800
	],
	"./00002/00002-02/00002-02-08/sam said can i have a monkey.mp3": [
		3126,
		7,
		1801
	],
	"./00002/00002-02/00002-02-08/sam said can i have a snake.mp3": [
		3127,
		7,
		1802
	],
	"./00002/00002-02/00002-02-08/sam said can i have an ostrich.mp3": [
		3128,
		7,
		1803
	],
	"./00002/00002-02/00002-02-08/yes said mom and dad.mp3": [
		3129,
		7,
		1804
	],
	"./00002/00002-02/00002-02-09/0.jpg": [
		6842,
		7,
		5519
	],
	"./00002/00002-02/00002-02-09/1.jpg": [
		8469,
		7,
		8491
	],
	"./00002/00002-02/00002-02-09/2.jpg": [
		8470,
		7,
		8492
	],
	"./00002/00002-02/00002-02-09/3.jpg": [
		8471,
		7,
		8493
	],
	"./00002/00002-02/00002-02-09/4.jpg": [
		8472,
		7,
		8494
	],
	"./00002/00002-02/00002-02-09/5.jpg": [
		8473,
		7,
		8495
	],
	"./00002/00002-02/00002-02-09/6.jpg": [
		8474,
		7,
		8496
	],
	"./00002/00002-02/00002-02-09/7.jpg": [
		8475,
		7,
		8497
	],
	"./00002/00002-02/00002-02-09/i like to play on the horse said the boy.mp3": [
		3130,
		7,
		1805
	],
	"./00002/00002-02/00002-02-09/i like to play on the horse said the monster.mp3": [
		3131,
		7,
		1806
	],
	"./00002/00002-02/00002-02-09/i like to play on the slide said the boy.mp3": [
		3132,
		7,
		1807
	],
	"./00002/00002-02/00002-02-09/i like to play on the swings said the girl.mp3": [
		3133,
		7,
		1808
	],
	"./00002/00002-02/00002-02-09/i like to play on the swings said the monster.mp3": [
		3134,
		7,
		1809
	],
	"./00002/00002-02/00002-02-09/intro.mp3": [
		498,
		7
	],
	"./00002/00002-02/00002-02-09/main idea.mp3": [
		879,
		7
	],
	"./00002/00002-02/00002-02-09/module": [
		1291,
		9,
		155
	],
	"./00002/00002-02/00002-02-09/module.js": [
		1291,
		9,
		155
	],
	"./00002/00002-02/00002-02-09/the playground.mp3": [
		3135,
		7,
		1810
	],
	"./00002/00002-02/00002-02-09/toys.mp3": [
		3136,
		7,
		1811
	],
	"./00002/00002-02/00002-02-09/we like to play on the seesaw said the kids.mp3": [
		3137,
		7,
		1812
	],
	"./00002/00002-02/00002-02-09/we like to play on the slide said the monsters.mp3": [
		3138,
		7,
		1813
	],
	"./00002/00002-02/00002-02-10/0.jpg": [
		6843,
		7,
		5520
	],
	"./00002/00002-02/00002-02-10/1.jpg": [
		8476,
		7,
		8498
	],
	"./00002/00002-02/00002-02-10/2.jpg": [
		8477,
		7,
		8499
	],
	"./00002/00002-02/00002-02-10/3.jpg": [
		8478,
		7,
		8500
	],
	"./00002/00002-02/00002-02-10/4.jpg": [
		8479,
		7,
		8501
	],
	"./00002/00002-02/00002-02-10/5.jpg": [
		8480,
		7,
		8502
	],
	"./00002/00002-02/00002-02-10/6.jpg": [
		8481,
		7,
		8503
	],
	"./00002/00002-02/00002-02-10/7.jpg": [
		8482,
		7,
		8504
	],
	"./00002/00002-02/00002-02-10/farm animals.mp3": [
		3139,
		7,
		1814
	],
	"./00002/00002-02/00002-02-10/hello cat i like your hat.mp3": [
		3140,
		7,
		1815
	],
	"./00002/00002-02/00002-02-10/hello chicken i like your hat.mp3": [
		3141,
		7,
		1816
	],
	"./00002/00002-02/00002-02-10/hello cow i like your hat.mp3": [
		3142,
		7,
		1817
	],
	"./00002/00002-02/00002-02-10/hello dog i like your hat.mp3": [
		3143,
		7,
		1818
	],
	"./00002/00002-02/00002-02-10/hello goat i like your hat.mp3": [
		3144,
		7,
		1819
	],
	"./00002/00002-02/00002-02-10/hello horse i like your hat.mp3": [
		3145,
		7,
		1820
	],
	"./00002/00002-02/00002-02-10/hello sheep i like your hat.mp3": [
		3146,
		7,
		1821
	],
	"./00002/00002-02/00002-02-10/intro.mp3": [
		499,
		7
	],
	"./00002/00002-02/00002-02-10/main idea.mp3": [
		880,
		7
	],
	"./00002/00002-02/00002-02-10/module": [
		1292,
		9,
		156
	],
	"./00002/00002-02/00002-02-10/module.js": [
		1292,
		9,
		156
	],
	"./00002/00002-02/00002-02-10/thank you.mp3": [
		3147,
		7,
		1822
	],
	"./00002/00002-02/00002-02-10/you can have it.mp3": [
		3148,
		7,
		1823
	],
	"./00002/00002-02/00002-02-11/0.jpg": [
		6844,
		7,
		5521
	],
	"./00002/00002-02/00002-02-11/1.jpg": [
		8483,
		7,
		8505
	],
	"./00002/00002-02/00002-02-11/2.jpg": [
		8484,
		7,
		8506
	],
	"./00002/00002-02/00002-02-11/3.jpg": [
		8485,
		7,
		8507
	],
	"./00002/00002-02/00002-02-11/4.jpg": [
		8486,
		7,
		8508
	],
	"./00002/00002-02/00002-02-11/5.jpg": [
		8487,
		7,
		8509
	],
	"./00002/00002-02/00002-02-11/6.jpg": [
		8488,
		7,
		8510
	],
	"./00002/00002-02/00002-02-11/7.jpg": [
		8489,
		7,
		8511
	],
	"./00002/00002-02/00002-02-11/animals.mp3": [
		3149,
		7,
		1824
	],
	"./00002/00002-02/00002-02-11/intro.mp3": [
		500,
		7
	],
	"./00002/00002-02/00002-02-11/look at the bat.mp3": [
		3150,
		7,
		1825
	],
	"./00002/00002-02/00002-02-11/look at the cat.mp3": [
		3151,
		7,
		1826
	],
	"./00002/00002-02/00002-02-11/look at the dog.mp3": [
		3152,
		7,
		1827
	],
	"./00002/00002-02/00002-02-11/look at the elephant.mp3": [
		3153,
		7,
		1828
	],
	"./00002/00002-02/00002-02-11/look at the lion.mp3": [
		3154,
		7,
		1829
	],
	"./00002/00002-02/00002-02-11/look at the octopus.mp3": [
		3155,
		7,
		1830
	],
	"./00002/00002-02/00002-02-11/look at the snake.mp3": [
		3156,
		7,
		1831
	],
	"./00002/00002-02/00002-02-11/main idea.mp3": [
		881,
		7
	],
	"./00002/00002-02/00002-02-11/module": [
		1293,
		9,
		157
	],
	"./00002/00002-02/00002-02-11/module.js": [
		1293,
		9,
		157
	],
	"./00002/00002-02/00002-02-11/the bat likes ice cream.mp3": [
		3157,
		7,
		1832
	],
	"./00002/00002-02/00002-02-11/the cat likes ice cream.mp3": [
		3158,
		7,
		1833
	],
	"./00002/00002-02/00002-02-11/the dog likes ice cream.mp3": [
		3159,
		7,
		1834
	],
	"./00002/00002-02/00002-02-11/the elephant likes ice cream.mp3": [
		3160,
		7,
		1835
	],
	"./00002/00002-02/00002-02-11/the lion likes ice cream.mp3": [
		3161,
		7,
		1836
	],
	"./00002/00002-02/00002-02-11/the octopus loves ice cream.mp3": [
		3162,
		7,
		1837
	],
	"./00002/00002-02/00002-02-11/the snake likes ice cream.mp3": [
		3163,
		7,
		1838
	],
	"./00002/00002-02/00002-02-11/we like ice cream.mp3": [
		3164,
		7,
		1839
	],
	"./00002/00002-02/cover.jpg": [
		6845,
		7,
		5522
	],
	"./00002/00002-02/story park.mp3": [
		3165,
		7,
		1840
	],
	"./00002/00002-02/unit": [
		1294,
		9,
		158
	],
	"./00002/00002-02/unit.js": [
		1294,
		9,
		158
	],
	"./00002/00002-03/00002-03-01/0.jpg": [
		6846,
		7,
		5523
	],
	"./00002/00002-03/00002-03-01/1.jpg": [
		8490,
		7,
		8512
	],
	"./00002/00002-03/00002-03-01/2.jpg": [
		8491,
		7,
		8513
	],
	"./00002/00002-03/00002-03-01/3.jpg": [
		8492,
		7,
		8514
	],
	"./00002/00002-03/00002-03-01/4.jpg": [
		8493,
		7,
		8515
	],
	"./00002/00002-03/00002-03-01/5.jpg": [
		8494,
		7,
		8516
	],
	"./00002/00002-03/00002-03-01/6.jpg": [
		8495,
		7,
		8517
	],
	"./00002/00002-03/00002-03-01/7.jpg": [
		8496,
		7,
		8518
	],
	"./00002/00002-03/00002-03-01/a sea turtle lives in the sea.mp3": [
		3166,
		7,
		1841
	],
	"./00002/00002-03/00002-03-01/a seahorse lives in the sea.mp3": [
		3167,
		7,
		1842
	],
	"./00002/00002-03/00002-03-01/a shark lives in the sea.mp3": [
		3168,
		7,
		1843
	],
	"./00002/00002-03/00002-03-01/a whale lives in the sea.mp3": [
		3169,
		7,
		1844
	],
	"./00002/00002-03/00002-03-01/here is a dolphin.mp3": [
		3170,
		7,
		1845
	],
	"./00002/00002-03/00002-03-01/here is a sea turtle.mp3": [
		3171,
		7,
		1846
	],
	"./00002/00002-03/00002-03-01/here is a seahorse.mp3": [
		3172,
		7,
		1847
	],
	"./00002/00002-03/00002-03-01/intro.mp3": [
		501,
		7
	],
	"./00002/00002-03/00002-03-01/look at the crab.mp3": [
		3173,
		7,
		1848
	],
	"./00002/00002-03/00002-03-01/look at the octopus.mp3": [
		3174,
		7,
		1849
	],
	"./00002/00002-03/00002-03-01/look at the shark.mp3": [
		3175,
		7,
		1850
	],
	"./00002/00002-03/00002-03-01/look at the whale.mp3": [
		3176,
		7,
		1851
	],
	"./00002/00002-03/00002-03-01/main idea.mp3": [
		882,
		7
	],
	"./00002/00002-03/00002-03-01/module": [
		1295,
		9,
		159
	],
	"./00002/00002-03/00002-03-01/module.js": [
		1295,
		9,
		159
	],
	"./00002/00002-03/00002-03-01/sea animals.mp3": [
		3177,
		7,
		1852
	],
	"./00002/00002-03/00002-03-01/the crab lives in the sea.mp3": [
		3178,
		7,
		1853
	],
	"./00002/00002-03/00002-03-01/the dolphin lives in the sea.mp3": [
		3179,
		7,
		1854
	],
	"./00002/00002-03/00002-03-01/the octopus lives in the sea.mp3": [
		3180,
		7,
		1855
	],
	"./00002/00002-03/00002-03-02/0.jpg": [
		6847,
		7,
		5524
	],
	"./00002/00002-03/00002-03-02/1.jpg": [
		8497,
		7,
		8519
	],
	"./00002/00002-03/00002-03-02/2.jpg": [
		8498,
		7,
		8520
	],
	"./00002/00002-03/00002-03-02/3.jpg": [
		8499,
		7,
		8521
	],
	"./00002/00002-03/00002-03-02/4.jpg": [
		8500,
		7,
		8522
	],
	"./00002/00002-03/00002-03-02/5.jpg": [
		8501,
		7,
		8523
	],
	"./00002/00002-03/00002-03-02/6.jpg": [
		8502,
		7,
		8524
	],
	"./00002/00002-03/00002-03-02/7.jpg": [
		8503,
		7,
		8525
	],
	"./00002/00002-03/00002-03-02/intro.mp3": [
		502,
		7
	],
	"./00002/00002-03/00002-03-02/look at the beaver.mp3": [
		3181,
		7,
		1856
	],
	"./00002/00002-03/00002-03-02/look at the dragonfly.mp3": [
		3182,
		7,
		1857
	],
	"./00002/00002-03/00002-03-02/look at the duck.mp3": [
		3183,
		7,
		1858
	],
	"./00002/00002-03/00002-03-02/look at the frog.mp3": [
		3184,
		7,
		1859
	],
	"./00002/00002-03/00002-03-02/look at the salamander.mp3": [
		3185,
		7,
		1860
	],
	"./00002/00002-03/00002-03-02/look at the toad.mp3": [
		3186,
		7,
		1861
	],
	"./00002/00002-03/00002-03-02/look at the turtle.mp3": [
		3187,
		7,
		1862
	],
	"./00002/00002-03/00002-03-02/main idea.mp3": [
		883,
		7
	],
	"./00002/00002-03/00002-03-02/me too said the dragonfly.mp3": [
		3188,
		7,
		1863
	],
	"./00002/00002-03/00002-03-02/module": [
		1296,
		9,
		160
	],
	"./00002/00002-03/00002-03-02/module.js": [
		1296,
		9,
		160
	],
	"./00002/00002-03/00002-03-02/pond animals.mp3": [
		3189,
		7,
		1864
	],
	"./00002/00002-03/00002-03-02/the beaver lives at the pond.mp3": [
		3190,
		7,
		1865
	],
	"./00002/00002-03/00002-03-02/the dragonfly lives at the pond.mp3": [
		3191,
		7,
		1866
	],
	"./00002/00002-03/00002-03-02/the duck lives at the pond too.mp3": [
		3192,
		7,
		1867
	],
	"./00002/00002-03/00002-03-02/the frog lives at the pond.mp3": [
		3193,
		7,
		1868
	],
	"./00002/00002-03/00002-03-02/the salamander lives at the pond.mp3": [
		3194,
		7,
		1869
	],
	"./00002/00002-03/00002-03-02/the toad lives at the pond.mp3": [
		3195,
		7,
		1870
	],
	"./00002/00002-03/00002-03-02/the turtle lives at the pond.mp3": [
		3196,
		7,
		1871
	],
	"./00002/00002-03/00002-03-03/0.jpg": [
		6848,
		7,
		5525
	],
	"./00002/00002-03/00002-03-03/1.jpg": [
		8504,
		7,
		8526
	],
	"./00002/00002-03/00002-03-03/2.jpg": [
		8505,
		7,
		8527
	],
	"./00002/00002-03/00002-03-03/3.jpg": [
		8506,
		7,
		8528
	],
	"./00002/00002-03/00002-03-03/4.jpg": [
		8507,
		7,
		8529
	],
	"./00002/00002-03/00002-03-03/5.jpg": [
		8508,
		7,
		8530
	],
	"./00002/00002-03/00002-03-03/6.jpg": [
		8509,
		7,
		8531
	],
	"./00002/00002-03/00002-03-03/7.jpg": [
		8510,
		7,
		8532
	],
	"./00002/00002-03/00002-03-03/i am a giraffe.mp3": [
		3197,
		7,
		1872
	],
	"./00002/00002-03/00002-03-03/i am a hippo.mp3": [
		3198,
		7,
		1873
	],
	"./00002/00002-03/00002-03-03/i am a lion.mp3": [
		3199,
		7,
		1874
	],
	"./00002/00002-03/00002-03-03/i am a rhino.mp3": [
		3200,
		7,
		1875
	],
	"./00002/00002-03/00002-03-03/i am a tiger.mp3": [
		3201,
		7,
		1876
	],
	"./00002/00002-03/00002-03-03/i am a wild animal.mp3": [
		3202,
		7,
		1877
	],
	"./00002/00002-03/00002-03-03/i am a zebra.mp3": [
		3203,
		7,
		1878
	],
	"./00002/00002-03/00002-03-03/intro.mp3": [
		503,
		7
	],
	"./00002/00002-03/00002-03-03/main idea.mp3": [
		884,
		7
	],
	"./00002/00002-03/00002-03-03/module": [
		1297,
		9,
		161
	],
	"./00002/00002-03/00002-03-03/module.js": [
		1297,
		9,
		161
	],
	"./00002/00002-03/00002-03-03/we are kangaroos.mp3": [
		3204,
		7,
		1879
	],
	"./00002/00002-03/00002-03-03/we are wild animals too.mp3": [
		3205,
		7,
		1880
	],
	"./00002/00002-03/00002-03-03/wild animals.mp3": [
		3206,
		7,
		1881
	],
	"./00002/00002-03/00002-03-04/0.jpg": [
		6849,
		7,
		5526
	],
	"./00002/00002-03/00002-03-04/1.jpg": [
		8511,
		7,
		8533
	],
	"./00002/00002-03/00002-03-04/2.jpg": [
		8512,
		7,
		8534
	],
	"./00002/00002-03/00002-03-04/3.jpg": [
		8513,
		7,
		8535
	],
	"./00002/00002-03/00002-03-04/4.jpg": [
		8514,
		7,
		8536
	],
	"./00002/00002-03/00002-03-04/5.jpg": [
		8515,
		7,
		8537
	],
	"./00002/00002-03/00002-03-04/6.jpg": [
		8516,
		7,
		8538
	],
	"./00002/00002-03/00002-03-04/7.jpg": [
		8517,
		7,
		8539
	],
	"./00002/00002-03/00002-03-04/here is my pet.mp3": [
		3207,
		7,
		1882
	],
	"./00002/00002-03/00002-03-04/i love my cat.mp3": [
		3208,
		7,
		1883
	],
	"./00002/00002-03/00002-03-04/i love my dinosaur.mp3": [
		3209,
		7,
		1884
	],
	"./00002/00002-03/00002-03-04/i love my dog.mp3": [
		3210,
		7,
		1885
	],
	"./00002/00002-03/00002-03-04/i love my fish.mp3": [
		3211,
		7,
		1886
	],
	"./00002/00002-03/00002-03-04/i love my rabbit.mp3": [
		3212,
		7,
		1887
	],
	"./00002/00002-03/00002-03-04/i love my snake.mp3": [
		3213,
		7,
		1888
	],
	"./00002/00002-03/00002-03-04/i love my turtle.mp3": [
		3214,
		7,
		1889
	],
	"./00002/00002-03/00002-03-04/intro.mp3": [
		504,
		7
	],
	"./00002/00002-03/00002-03-04/look at my pet.mp3": [
		3215,
		7,
		1890
	],
	"./00002/00002-03/00002-03-04/main idea.mp3": [
		885,
		7
	],
	"./00002/00002-03/00002-03-04/module": [
		1298,
		9,
		162
	],
	"./00002/00002-03/00002-03-04/module.js": [
		1298,
		9,
		162
	],
	"./00002/00002-03/00002-03-04/pets.mp3": [
		3216,
		7,
		1891
	],
	"./00002/00002-03/00002-03-05/0.jpg": [
		6850,
		7,
		5527
	],
	"./00002/00002-03/00002-03-05/1.jpg": [
		8518,
		7,
		8540
	],
	"./00002/00002-03/00002-03-05/2.jpg": [
		8519,
		7,
		8541
	],
	"./00002/00002-03/00002-03-05/3.jpg": [
		8520,
		7,
		8542
	],
	"./00002/00002-03/00002-03-05/4.jpg": [
		8521,
		7,
		8543
	],
	"./00002/00002-03/00002-03-05/5.jpg": [
		8522,
		7,
		8544
	],
	"./00002/00002-03/00002-03-05/6.jpg": [
		8523,
		7,
		8545
	],
	"./00002/00002-03/00002-03-05/7.jpg": [
		8524,
		7,
		8546
	],
	"./00002/00002-03/00002-03-05/forest animals.mp3": [
		3217,
		7,
		1892
	],
	"./00002/00002-03/00002-03-05/here is a bear.mp3": [
		3218,
		7,
		1893
	],
	"./00002/00002-03/00002-03-05/here is a deer.mp3": [
		3219,
		7,
		1894
	],
	"./00002/00002-03/00002-03-05/here is a rabbit.mp3": [
		3220,
		7,
		1895
	],
	"./00002/00002-03/00002-03-05/i see a bear.mp3": [
		3221,
		7,
		1896
	],
	"./00002/00002-03/00002-03-05/i see a bird.mp3": [
		3222,
		7,
		1897
	],
	"./00002/00002-03/00002-03-05/i see a deer.mp3": [
		3223,
		7,
		1898
	],
	"./00002/00002-03/00002-03-05/i see a fox.mp3": [
		3224,
		7,
		1899
	],
	"./00002/00002-03/00002-03-05/i see a hedgehog.mp3": [
		3225,
		7,
		1900
	],
	"./00002/00002-03/00002-03-05/i see a rabbit.mp3": [
		3226,
		7,
		1901
	],
	"./00002/00002-03/00002-03-05/i see a squirrel.mp3": [
		3227,
		7,
		1902
	],
	"./00002/00002-03/00002-03-05/intro.mp3": [
		505,
		7
	],
	"./00002/00002-03/00002-03-05/look at the bear.mp3": [
		3228,
		7,
		1903
	],
	"./00002/00002-03/00002-03-05/look at the bird.mp3": [
		3229,
		7,
		1904
	],
	"./00002/00002-03/00002-03-05/look at the deer.mp3": [
		3230,
		7,
		1905
	],
	"./00002/00002-03/00002-03-05/look at the fox.mp3": [
		3231,
		7,
		1906
	],
	"./00002/00002-03/00002-03-05/look at the hedgehog.mp3": [
		3232,
		7,
		1907
	],
	"./00002/00002-03/00002-03-05/look at the owl.mp3": [
		3233,
		7,
		1908
	],
	"./00002/00002-03/00002-03-05/look at the rabbit.mp3": [
		3234,
		7,
		1909
	],
	"./00002/00002-03/00002-03-05/look at the squirrel.mp3": [
		3235,
		7,
		1910
	],
	"./00002/00002-03/00002-03-05/main idea.mp3": [
		886,
		7
	],
	"./00002/00002-03/00002-03-05/module": [
		1299,
		9,
		163
	],
	"./00002/00002-03/00002-03-05/module.js": [
		1299,
		9,
		163
	],
	"./00002/00002-03/00002-03-06/0.jpg": [
		6851,
		7,
		5528
	],
	"./00002/00002-03/00002-03-06/1.jpg": [
		8525,
		7,
		8547
	],
	"./00002/00002-03/00002-03-06/2.jpg": [
		8526,
		7,
		8548
	],
	"./00002/00002-03/00002-03-06/3.jpg": [
		8527,
		7,
		8549
	],
	"./00002/00002-03/00002-03-06/4.jpg": [
		8528,
		7,
		8550
	],
	"./00002/00002-03/00002-03-06/5.jpg": [
		8529,
		7,
		8551
	],
	"./00002/00002-03/00002-03-06/6.jpg": [
		8530,
		7,
		8552
	],
	"./00002/00002-03/00002-03-06/7.jpg": [
		8531,
		7,
		8553
	],
	"./00002/00002-03/00002-03-06/farm animals.mp3": [
		3236,
		7,
		1911
	],
	"./00002/00002-03/00002-03-06/he lives on a farm.mp3": [
		3237,
		7,
		1912
	],
	"./00002/00002-03/00002-03-06/here is a chicken.mp3": [
		3238,
		7,
		1913
	],
	"./00002/00002-03/00002-03-06/here is a cow.mp3": [
		3239,
		7,
		1914
	],
	"./00002/00002-03/00002-03-06/here is a donkey.mp3": [
		3240,
		7,
		1915
	],
	"./00002/00002-03/00002-03-06/here is a goat.mp3": [
		3241,
		7,
		1916
	],
	"./00002/00002-03/00002-03-06/here is a horse.mp3": [
		3242,
		7,
		1917
	],
	"./00002/00002-03/00002-03-06/here is a pig.mp3": [
		3243,
		7,
		1918
	],
	"./00002/00002-03/00002-03-06/here is a sheep.mp3": [
		3244,
		7,
		1919
	],
	"./00002/00002-03/00002-03-06/intro.mp3": [
		506,
		7
	],
	"./00002/00002-03/00002-03-06/look at the cow.mp3": [
		3245,
		7,
		1920
	],
	"./00002/00002-03/00002-03-06/look at the donkey.mp3": [
		3246,
		7,
		1921
	],
	"./00002/00002-03/00002-03-06/look at the horse.mp3": [
		3247,
		7,
		1922
	],
	"./00002/00002-03/00002-03-06/main idea.mp3": [
		887,
		7
	],
	"./00002/00002-03/00002-03-06/module": [
		1300,
		9,
		164
	],
	"./00002/00002-03/00002-03-06/module.js": [
		1300,
		9,
		164
	],
	"./00002/00002-03/00002-03-06/she lives on a farm.mp3": [
		3248,
		7,
		1923
	],
	"./00002/00002-03/00002-03-07/0.jpg": [
		6852,
		7,
		5529
	],
	"./00002/00002-03/00002-03-07/1.jpg": [
		8532,
		7,
		8554
	],
	"./00002/00002-03/00002-03-07/2.jpg": [
		8533,
		7,
		8555
	],
	"./00002/00002-03/00002-03-07/3.jpg": [
		8534,
		7,
		8556
	],
	"./00002/00002-03/00002-03-07/4.jpg": [
		8535,
		7,
		8557
	],
	"./00002/00002-03/00002-03-07/5.jpg": [
		8536,
		7,
		8558
	],
	"./00002/00002-03/00002-03-07/6.jpg": [
		8537,
		7,
		8559
	],
	"./00002/00002-03/00002-03-07/7.jpg": [
		8538,
		7,
		8560
	],
	"./00002/00002-03/00002-03-07/animals that live in the snow.mp3": [
		3249,
		7,
		1924
	],
	"./00002/00002-03/00002-03-07/arctic animals.mp3": [
		3250,
		7,
		1925
	],
	"./00002/00002-03/00002-03-07/he lives in the snow.mp3": [
		3251,
		7,
		1926
	],
	"./00002/00002-03/00002-03-07/intro.mp3": [
		507,
		7
	],
	"./00002/00002-03/00002-03-07/main idea.mp3": [
		888,
		7
	],
	"./00002/00002-03/00002-03-07/module": [
		1301,
		9,
		165
	],
	"./00002/00002-03/00002-03-07/module.js": [
		1301,
		9,
		165
	],
	"./00002/00002-03/00002-03-07/she lives in the snow.mp3": [
		3252,
		7,
		1927
	],
	"./00002/00002-03/00002-03-07/the arctic fox is white.mp3": [
		3253,
		7,
		1928
	],
	"./00002/00002-03/00002-03-07/the arctic wolf is white.mp3": [
		3254,
		7,
		1929
	],
	"./00002/00002-03/00002-03-07/the bird is white.mp3": [
		3255,
		7,
		1930
	],
	"./00002/00002-03/00002-03-07/the polar bear is white.mp3": [
		3256,
		7,
		1931
	],
	"./00002/00002-03/00002-03-07/the seal is white.mp3": [
		3257,
		7,
		1932
	],
	"./00002/00002-03/00002-03-07/the snowshoe rabbit is white.mp3": [
		3258,
		7,
		1933
	],
	"./00002/00002-03/00002-03-07/the snowy owl is white.mp3": [
		3259,
		7,
		1934
	],
	"./00002/00002-03/00002-03-08/0.jpg": [
		6853,
		7,
		5530
	],
	"./00002/00002-03/00002-03-08/1.jpg": [
		8539,
		7,
		8561
	],
	"./00002/00002-03/00002-03-08/2.jpg": [
		8540,
		7,
		8562
	],
	"./00002/00002-03/00002-03-08/3.jpg": [
		8541,
		7,
		8563
	],
	"./00002/00002-03/00002-03-08/4.jpg": [
		8542,
		7,
		8564
	],
	"./00002/00002-03/00002-03-08/5.jpg": [
		8543,
		7,
		8565
	],
	"./00002/00002-03/00002-03-08/6.jpg": [
		8544,
		7,
		8566
	],
	"./00002/00002-03/00002-03-08/7.jpg": [
		8545,
		7,
		8567
	],
	"./00002/00002-03/00002-03-08/desert animals.mp3": [
		3260,
		7,
		1935
	],
	"./00002/00002-03/00002-03-08/i am a big horned sheep.mp3": [
		3261,
		7,
		1936
	],
	"./00002/00002-03/00002-03-08/i am a bighorn sheep.mp3": [
		3262,
		7,
		1937
	],
	"./00002/00002-03/00002-03-08/i am a camel.mp3": [
		3263,
		7,
		1938
	],
	"./00002/00002-03/00002-03-08/i am a fennec fox.mp3": [
		3264,
		7,
		1939
	],
	"./00002/00002-03/00002-03-08/i am a fox.mp3": [
		3265,
		7,
		1940
	],
	"./00002/00002-03/00002-03-08/i am a rabbit.mp3": [
		3266,
		7,
		1941
	],
	"./00002/00002-03/00002-03-08/i am a snake.mp3": [
		3267,
		7,
		1942
	],
	"./00002/00002-03/00002-03-08/i am a spider.mp3": [
		3268,
		7,
		1943
	],
	"./00002/00002-03/00002-03-08/i am an iguana.mp3": [
		3269,
		7,
		1944
	],
	"./00002/00002-03/00002-03-08/i live in the desert too.mp3": [
		3270,
		7,
		1945
	],
	"./00002/00002-03/00002-03-08/i live in the desert.mp3": [
		3271,
		7,
		1946
	],
	"./00002/00002-03/00002-03-08/intro.mp3": [
		508,
		7
	],
	"./00002/00002-03/00002-03-08/main idea.mp3": [
		889,
		7
	],
	"./00002/00002-03/00002-03-08/module": [
		1302,
		9,
		166
	],
	"./00002/00002-03/00002-03-08/module.js": [
		1302,
		9,
		166
	],
	"./00002/00002-03/00002-03-09/0.jpg": [
		6854,
		7,
		5531
	],
	"./00002/00002-03/00002-03-09/1.jpg": [
		8546,
		7,
		8568
	],
	"./00002/00002-03/00002-03-09/2.jpg": [
		8547,
		7,
		8569
	],
	"./00002/00002-03/00002-03-09/3.jpg": [
		8548,
		7,
		8570
	],
	"./00002/00002-03/00002-03-09/4.jpg": [
		8549,
		7,
		8571
	],
	"./00002/00002-03/00002-03-09/5.jpg": [
		8550,
		7,
		8572
	],
	"./00002/00002-03/00002-03-09/6.jpg": [
		8551,
		7,
		8573
	],
	"./00002/00002-03/00002-03-09/7.jpg": [
		8552,
		7,
		8574
	],
	"./00002/00002-03/00002-03-09/i am a butterfly.mp3": [
		3272,
		7,
		1947
	],
	"./00002/00002-03/00002-03-09/i am a frog.mp3": [
		3273,
		7,
		1948
	],
	"./00002/00002-03/00002-03-09/i am a jaguar.mp3": [
		3274,
		7,
		1949
	],
	"./00002/00002-03/00002-03-09/i am a monkey.mp3": [
		3275,
		7,
		1950
	],
	"./00002/00002-03/00002-03-09/i am a parrot.mp3": [
		3276,
		7,
		1951
	],
	"./00002/00002-03/00002-03-09/i am a snake.mp3": [
		3277,
		7,
		1952
	],
	"./00002/00002-03/00002-03-09/i am a toucan.mp3": [
		3278,
		7,
		1953
	],
	"./00002/00002-03/00002-03-09/i live in the rainforest too.mp3": [
		3279,
		7,
		1954
	],
	"./00002/00002-03/00002-03-09/i live in the rainforest.mp3": [
		3280,
		7,
		1955
	],
	"./00002/00002-03/00002-03-09/intro.mp3": [
		509,
		7
	],
	"./00002/00002-03/00002-03-09/main idea.mp3": [
		890,
		7
	],
	"./00002/00002-03/00002-03-09/module": [
		1303,
		9,
		167
	],
	"./00002/00002-03/00002-03-09/module.js": [
		1303,
		9,
		167
	],
	"./00002/00002-03/00002-03-09/rainforest animals.mp3": [
		3281,
		7,
		1956
	],
	"./00002/00002-03/00002-03-10/0.jpg": [
		6855,
		7,
		5532
	],
	"./00002/00002-03/00002-03-10/1.jpg": [
		8553,
		7,
		8575
	],
	"./00002/00002-03/00002-03-10/2.jpg": [
		8554,
		7,
		8576
	],
	"./00002/00002-03/00002-03-10/3.jpg": [
		8555,
		7,
		8577
	],
	"./00002/00002-03/00002-03-10/4.jpg": [
		8556,
		7,
		8578
	],
	"./00002/00002-03/00002-03-10/5.jpg": [
		8557,
		7,
		8579
	],
	"./00002/00002-03/00002-03-10/6.jpg": [
		8558,
		7,
		8580
	],
	"./00002/00002-03/00002-03-10/7.jpg": [
		8559,
		7,
		8581
	],
	"./00002/00002-03/00002-03-10/here is a cat.mp3": [
		3282,
		7,
		1957
	],
	"./00002/00002-03/00002-03-10/here is a dog.mp3": [
		3283,
		7,
		1958
	],
	"./00002/00002-03/00002-03-10/here is a horse.mp3": [
		3284,
		7,
		1959
	],
	"./00002/00002-03/00002-03-10/i am a dog.mp3": [
		3285,
		7,
		1960
	],
	"./00002/00002-03/00002-03-10/i am a lion.mp3": [
		3286,
		7,
		1961
	],
	"./00002/00002-03/00002-03-10/i am a parrot.mp3": [
		3287,
		7,
		1962
	],
	"./00002/00002-03/00002-03-10/i am a zebra.mp3": [
		3288,
		7,
		1963
	],
	"./00002/00002-03/00002-03-10/i am an owl.mp3": [
		3289,
		7,
		1964
	],
	"./00002/00002-03/00002-03-10/intro.mp3": [
		510,
		7
	],
	"./00002/00002-03/00002-03-10/is it tame.mp3": [
		3290,
		7,
		1965
	],
	"./00002/00002-03/00002-03-10/is it wild is it tame.mp3": [
		3291,
		7,
		1966
	],
	"./00002/00002-03/00002-03-10/is it wild.mp3": [
		3292,
		7,
		1967
	],
	"./00002/00002-03/00002-03-10/look at the lion.mp3": [
		3293,
		7,
		1968
	],
	"./00002/00002-03/00002-03-10/look at the owl.mp3": [
		3294,
		7,
		1969
	],
	"./00002/00002-03/00002-03-10/look at the parrot.mp3": [
		3295,
		7,
		1970
	],
	"./00002/00002-03/00002-03-10/look at the zebra.mp3": [
		3296,
		7,
		1971
	],
	"./00002/00002-03/00002-03-10/main idea.mp3": [
		891,
		7
	],
	"./00002/00002-03/00002-03-10/module": [
		1304,
		9,
		168
	],
	"./00002/00002-03/00002-03-10/module.js": [
		1304,
		9,
		168
	],
	"./00002/00002-03/00002-03-10/wild animals.mp3": [
		3297,
		7,
		1972
	],
	"./00002/00002-03/00002-03-10/wild or tame.mp3": [
		3298,
		7,
		1973
	],
	"./00002/00002-03/animal town.mp3": [
		3299,
		7,
		1974
	],
	"./00002/00002-03/animals.mp3": [
		3300,
		7,
		1975
	],
	"./00002/00002-03/cover.jpg": [
		6856,
		7,
		5533
	],
	"./00002/00002-03/unit": [
		1305,
		9,
		169
	],
	"./00002/00002-03/unit.js": [
		1305,
		9,
		169
	],
	"./00002/00002-04/00002-04-01/0.jpg": [
		6857,
		7,
		5534
	],
	"./00002/00002-04/00002-04-01/1.jpg": [
		8560,
		7,
		8582
	],
	"./00002/00002-04/00002-04-01/2.jpg": [
		8561,
		7,
		8583
	],
	"./00002/00002-04/00002-04-01/3.jpg": [
		8562,
		7,
		8584
	],
	"./00002/00002-04/00002-04-01/4.jpg": [
		8563,
		7,
		8585
	],
	"./00002/00002-04/00002-04-01/5.jpg": [
		8564,
		7,
		8586
	],
	"./00002/00002-04/00002-04-01/6.jpg": [
		8565,
		7,
		8587
	],
	"./00002/00002-04/00002-04-01/7.jpg": [
		8566,
		7,
		8588
	],
	"./00002/00002-04/00002-04-01/animals.mp3": [
		3301,
		7,
		1976
	],
	"./00002/00002-04/00002-04-01/i can see 1 box.mp3": [
		3302,
		7,
		1977
	],
	"./00002/00002-04/00002-04-01/i can see 1 car.mp3": [
		3303,
		7,
		1978
	],
	"./00002/00002-04/00002-04-01/i can see 1 cat.mp3": [
		3304,
		7,
		1979
	],
	"./00002/00002-04/00002-04-01/i can see 1 clock.mp3": [
		3305,
		7,
		1980
	],
	"./00002/00002-04/00002-04-01/i can see 1 dog.mp3": [
		3306,
		7,
		1981
	],
	"./00002/00002-04/00002-04-01/i can see 1 duck.mp3": [
		3307,
		7,
		1982
	],
	"./00002/00002-04/00002-04-01/i can see 1 fox.mp3": [
		3308,
		7,
		1983
	],
	"./00002/00002-04/00002-04-01/i can see 1 frog.mp3": [
		3309,
		7,
		1984
	],
	"./00002/00002-04/00002-04-01/i can see 1 hat.mp3": [
		3310,
		7,
		1985
	],
	"./00002/00002-04/00002-04-01/i can see 1 house.mp3": [
		3311,
		7,
		1986
	],
	"./00002/00002-04/00002-04-01/i can see 1 mouse.mp3": [
		3312,
		7,
		1987
	],
	"./00002/00002-04/00002-04-01/i can see 1 sock.mp3": [
		3313,
		7,
		1988
	],
	"./00002/00002-04/00002-04-01/i can see 1 star.mp3": [
		3314,
		7,
		1989
	],
	"./00002/00002-04/00002-04-01/i can see 1 truck.mp3": [
		3315,
		7,
		1990
	],
	"./00002/00002-04/00002-04-01/intro.mp3": [
		511,
		7
	],
	"./00002/00002-04/00002-04-01/main idea.mp3": [
		892,
		7
	],
	"./00002/00002-04/00002-04-01/module": [
		1306,
		9,
		170
	],
	"./00002/00002-04/00002-04-01/module.js": [
		1306,
		9,
		170
	],
	"./00002/00002-04/00002-04-01/my book of one.mp3": [
		3316,
		7,
		1991
	],
	"./00002/00002-04/00002-04-02/0.jpg": [
		6858,
		7,
		5535
	],
	"./00002/00002-04/00002-04-02/1.jpg": [
		8567,
		7,
		8589
	],
	"./00002/00002-04/00002-04-02/2.jpg": [
		8568,
		7,
		8590
	],
	"./00002/00002-04/00002-04-02/3.jpg": [
		8569,
		7,
		8591
	],
	"./00002/00002-04/00002-04-02/4.jpg": [
		8570,
		7,
		8592
	],
	"./00002/00002-04/00002-04-02/5.jpg": [
		8571,
		7,
		8593
	],
	"./00002/00002-04/00002-04-02/6.jpg": [
		8572,
		7,
		8594
	],
	"./00002/00002-04/00002-04-02/7.jpg": [
		8573,
		7,
		8595
	],
	"./00002/00002-04/00002-04-02/animals with two legs.mp3": [
		3317,
		7,
		1992
	],
	"./00002/00002-04/00002-04-02/i have two ears.mp3": [
		3318,
		7,
		1993
	],
	"./00002/00002-04/00002-04-02/i have two eyes.mp3": [
		3319,
		7,
		1994
	],
	"./00002/00002-04/00002-04-02/i have two horns.mp3": [
		3320,
		7,
		1995
	],
	"./00002/00002-04/00002-04-02/i have two humps.mp3": [
		3321,
		7,
		1996
	],
	"./00002/00002-04/00002-04-02/i have two legs.mp3": [
		3322,
		7,
		1997
	],
	"./00002/00002-04/00002-04-02/i have two tusks.mp3": [
		3323,
		7,
		1998
	],
	"./00002/00002-04/00002-04-02/i have two wings.mp3": [
		3324,
		7,
		1999
	],
	"./00002/00002-04/00002-04-02/intro.mp3": [
		512,
		7
	],
	"./00002/00002-04/00002-04-02/look at my ears said the rabbit.mp3": [
		3325,
		7,
		2000
	],
	"./00002/00002-04/00002-04-02/look at my humps said the camel.mp3": [
		3326,
		7,
		2001
	],
	"./00002/00002-04/00002-04-02/look at my tusks said the elephant.mp3": [
		3327,
		7,
		2002
	],
	"./00002/00002-04/00002-04-02/look at my wings said the bat.mp3": [
		3328,
		7,
		2003
	],
	"./00002/00002-04/00002-04-02/look said the ostrich.mp3": [
		3329,
		7,
		2004
	],
	"./00002/00002-04/00002-04-02/look said the owl.mp3": [
		3330,
		7,
		2005
	],
	"./00002/00002-04/00002-04-02/look said the rhino.mp3": [
		3331,
		7,
		2006
	],
	"./00002/00002-04/00002-04-02/main idea.mp3": [
		893,
		7
	],
	"./00002/00002-04/00002-04-02/module": [
		1307,
		9,
		171
	],
	"./00002/00002-04/00002-04-02/module.js": [
		1307,
		9,
		171
	],
	"./00002/00002-04/00002-04-02/my book of two.mp3": [
		3332,
		7,
		2007
	],
	"./00002/00002-04/00002-04-03/0.jpg": [
		6859,
		7,
		5536
	],
	"./00002/00002-04/00002-04-03/1.jpg": [
		8574,
		7,
		8596
	],
	"./00002/00002-04/00002-04-03/2.jpg": [
		8575,
		7,
		8597
	],
	"./00002/00002-04/00002-04-03/3.jpg": [
		8576,
		7,
		8598
	],
	"./00002/00002-04/00002-04-03/4.jpg": [
		8577,
		7,
		8599
	],
	"./00002/00002-04/00002-04-03/5.jpg": [
		8578,
		7,
		8600
	],
	"./00002/00002-04/00002-04-03/6.jpg": [
		8579,
		7,
		8601
	],
	"./00002/00002-04/00002-04-03/7.jpg": [
		8580,
		7,
		8602
	],
	"./00002/00002-04/00002-04-03/animals with four legs.mp3": [
		3333,
		7,
		2008
	],
	"./00002/00002-04/00002-04-03/can you see 3 boats.mp3": [
		3334,
		7,
		2009
	],
	"./00002/00002-04/00002-04-03/can you see 3 boxes.mp3": [
		3335,
		7,
		2010
	],
	"./00002/00002-04/00002-04-03/can you see 3 cakes.mp3": [
		3336,
		7,
		2011
	],
	"./00002/00002-04/00002-04-03/can you see 3 dogs.mp3": [
		3337,
		7,
		2012
	],
	"./00002/00002-04/00002-04-03/can you see 3 foxes.mp3": [
		3338,
		7,
		2013
	],
	"./00002/00002-04/00002-04-03/can you see 3 frogs.mp3": [
		3339,
		7,
		2014
	],
	"./00002/00002-04/00002-04-03/can you see 3 goats.mp3": [
		3340,
		7,
		2015
	],
	"./00002/00002-04/00002-04-03/can you see 3 hats.mp3": [
		3341,
		7,
		2016
	],
	"./00002/00002-04/00002-04-03/can you see 3 kittens.mp3": [
		3342,
		7,
		2017
	],
	"./00002/00002-04/00002-04-03/can you see 3 mittens.mp3": [
		3343,
		7,
		2018
	],
	"./00002/00002-04/00002-04-03/can you see 3 rats.mp3": [
		3344,
		7,
		2019
	],
	"./00002/00002-04/00002-04-03/can you see 3 snails.mp3": [
		3345,
		7,
		2020
	],
	"./00002/00002-04/00002-04-03/can you see 3 snakes.mp3": [
		3346,
		7,
		2021
	],
	"./00002/00002-04/00002-04-03/can you see 3 whales.mp3": [
		3347,
		7,
		2022
	],
	"./00002/00002-04/00002-04-03/intro.mp3": [
		513,
		7
	],
	"./00002/00002-04/00002-04-03/main idea.mp3": [
		894,
		7
	],
	"./00002/00002-04/00002-04-03/module": [
		1308,
		9,
		172
	],
	"./00002/00002-04/00002-04-03/module.js": [
		1308,
		9,
		172
	],
	"./00002/00002-04/00002-04-03/my book of three.mp3": [
		3348,
		7,
		2023
	],
	"./00002/00002-04/00002-04-04/0.jpg": [
		6860,
		7,
		5537
	],
	"./00002/00002-04/00002-04-04/1.jpg": [
		8581,
		7,
		8603
	],
	"./00002/00002-04/00002-04-04/2.jpg": [
		8582,
		7,
		8604
	],
	"./00002/00002-04/00002-04-04/3.jpg": [
		8583,
		7,
		8605
	],
	"./00002/00002-04/00002-04-04/4.jpg": [
		8584,
		7,
		8606
	],
	"./00002/00002-04/00002-04-04/5.jpg": [
		8585,
		7,
		8607
	],
	"./00002/00002-04/00002-04-04/6.jpg": [
		8586,
		7,
		8608
	],
	"./00002/00002-04/00002-04-04/7.jpg": [
		8587,
		7,
		8609
	],
	"./00002/00002-04/00002-04-04/here come three cars.mp3": [
		3349,
		7,
		2024
	],
	"./00002/00002-04/00002-04-04/here come three rockets.mp3": [
		3350,
		7,
		2025
	],
	"./00002/00002-04/00002-04-04/here come two boats.mp3": [
		3351,
		7,
		2026
	],
	"./00002/00002-04/00002-04-04/here come two cars.mp3": [
		3352,
		7,
		2027
	],
	"./00002/00002-04/00002-04-04/here come two helicopters.mp3": [
		3353,
		7,
		2028
	],
	"./00002/00002-04/00002-04-04/here come two planes.mp3": [
		3354,
		7,
		2029
	],
	"./00002/00002-04/00002-04-04/here come two trucks.mp3": [
		3355,
		7,
		2030
	],
	"./00002/00002-04/00002-04-04/here comes one fire truck.mp3": [
		3356,
		7,
		2031
	],
	"./00002/00002-04/00002-04-04/here comes one spaceship.mp3": [
		3357,
		7,
		2032
	],
	"./00002/00002-04/00002-04-04/intro.mp3": [
		514,
		7
	],
	"./00002/00002-04/00002-04-04/main idea.mp3": [
		895,
		7
	],
	"./00002/00002-04/00002-04-04/module": [
		1309,
		9,
		173
	],
	"./00002/00002-04/00002-04-04/module.js": [
		1309,
		9,
		173
	],
	"./00002/00002-04/00002-04-04/my book of four.mp3": [
		3358,
		7,
		2033
	],
	"./00002/00002-04/00002-04-04/vehicles.mp3": [
		3359,
		7,
		2034
	],
	"./00002/00002-04/00002-04-05/0.jpg": [
		6861,
		7,
		5538
	],
	"./00002/00002-04/00002-04-05/1.jpg": [
		8588,
		7,
		8610
	],
	"./00002/00002-04/00002-04-05/2.jpg": [
		8589,
		7,
		8611
	],
	"./00002/00002-04/00002-04-05/3.jpg": [
		8590,
		7,
		8612
	],
	"./00002/00002-04/00002-04-05/4.jpg": [
		8591,
		7,
		8613
	],
	"./00002/00002-04/00002-04-05/5.jpg": [
		8592,
		7,
		8614
	],
	"./00002/00002-04/00002-04-05/6.jpg": [
		8593,
		7,
		8615
	],
	"./00002/00002-04/00002-04-05/7.jpg": [
		8594,
		7,
		8616
	],
	"./00002/00002-04/00002-04-05/farm animals.mp3": [
		3360,
		7,
		2035
	],
	"./00002/00002-04/00002-04-05/four and one is five.mp3": [
		3361,
		7,
		2036
	],
	"./00002/00002-04/00002-04-05/i can see five farm animals.mp3": [
		3362,
		7,
		2037
	],
	"./00002/00002-04/00002-04-05/i can see four chicks.mp3": [
		3363,
		7,
		2038
	],
	"./00002/00002-04/00002-04-05/i can see four cows.mp3": [
		3364,
		7,
		2039
	],
	"./00002/00002-04/00002-04-05/i can see four ducklings.mp3": [
		3365,
		7,
		2040
	],
	"./00002/00002-04/00002-04-05/i can see one chicken.mp3": [
		3366,
		7,
		2041
	],
	"./00002/00002-04/00002-04-05/i can see one duck.mp3": [
		3367,
		7,
		2042
	],
	"./00002/00002-04/00002-04-05/i can see three goats.mp3": [
		3368,
		7,
		2043
	],
	"./00002/00002-04/00002-04-05/i can see three sheep.mp3": [
		3369,
		7,
		2044
	],
	"./00002/00002-04/00002-04-05/i can see two dogs.mp3": [
		3370,
		7,
		2045
	],
	"./00002/00002-04/00002-04-05/i can see two horses.mp3": [
		3371,
		7,
		2046
	],
	"./00002/00002-04/00002-04-05/intro.mp3": [
		515,
		7
	],
	"./00002/00002-04/00002-04-05/main idea.mp3": [
		896,
		7
	],
	"./00002/00002-04/00002-04-05/module": [
		1310,
		9,
		174
	],
	"./00002/00002-04/00002-04-05/module.js": [
		1310,
		9,
		174
	],
	"./00002/00002-04/00002-04-05/my book of five.mp3": [
		3372,
		7,
		2047
	],
	"./00002/00002-04/00002-04-06/0.jpg": [
		6862,
		7,
		5539
	],
	"./00002/00002-04/00002-04-06/1.jpg": [
		8595,
		7,
		8617
	],
	"./00002/00002-04/00002-04-06/2.jpg": [
		8596,
		7,
		8618
	],
	"./00002/00002-04/00002-04-06/3.jpg": [
		8597,
		7,
		8619
	],
	"./00002/00002-04/00002-04-06/4.jpg": [
		8598,
		7,
		8620
	],
	"./00002/00002-04/00002-04-06/5.jpg": [
		8599,
		7,
		8621
	],
	"./00002/00002-04/00002-04-06/6.jpg": [
		8600,
		7,
		8622
	],
	"./00002/00002-04/00002-04-06/7.jpg": [
		8601,
		7,
		8623
	],
	"./00002/00002-04/00002-04-06/can you see five dogs.mp3": [
		3373,
		7,
		2048
	],
	"./00002/00002-04/00002-04-06/can you see five fish.mp3": [
		3374,
		7,
		2049
	],
	"./00002/00002-04/00002-04-06/can you see four birds.mp3": [
		3375,
		7,
		2050
	],
	"./00002/00002-04/00002-04-06/can you see four brids.mp3": [
		3376,
		7,
		2051
	],
	"./00002/00002-04/00002-04-06/can you see four fish.mp3": [
		3377,
		7,
		2052
	],
	"./00002/00002-04/00002-04-06/can you see one cat.mp3": [
		3378,
		7,
		2053
	],
	"./00002/00002-04/00002-04-06/can you see three cats.mp3": [
		3379,
		7,
		2054
	],
	"./00002/00002-04/00002-04-06/can you see three rabbits.mp3": [
		3380,
		7,
		2055
	],
	"./00002/00002-04/00002-04-06/can you see two snakes.mp3": [
		3381,
		7,
		2056
	],
	"./00002/00002-04/00002-04-06/can you see two turtles.mp3": [
		3382,
		7,
		2057
	],
	"./00002/00002-04/00002-04-06/intro.mp3": [
		516,
		7
	],
	"./00002/00002-04/00002-04-06/main idea.mp3": [
		897,
		7
	],
	"./00002/00002-04/00002-04-06/module": [
		1311,
		9,
		175
	],
	"./00002/00002-04/00002-04-06/module.js": [
		1311,
		9,
		175
	],
	"./00002/00002-04/00002-04-06/my book of six.mp3": [
		3383,
		7,
		2058
	],
	"./00002/00002-04/00002-04-06/pet animals.mp3": [
		3384,
		7,
		2059
	],
	"./00002/00002-04/00002-04-07/0.jpg": [
		6863,
		7,
		5540
	],
	"./00002/00002-04/00002-04-07/1.jpg": [
		8602,
		7,
		8624
	],
	"./00002/00002-04/00002-04-07/2.jpg": [
		8603,
		7,
		8625
	],
	"./00002/00002-04/00002-04-07/3.jpg": [
		8604,
		7,
		8626
	],
	"./00002/00002-04/00002-04-07/4.jpg": [
		8605,
		7,
		8627
	],
	"./00002/00002-04/00002-04-07/5.jpg": [
		8606,
		7,
		8628
	],
	"./00002/00002-04/00002-04-07/6.jpg": [
		8607,
		7,
		8629
	],
	"./00002/00002-04/00002-04-07/7.jpg": [
		8608,
		7,
		8630
	],
	"./00002/00002-04/00002-04-07/can you see five little fish.mp3": [
		3385,
		7,
		2060
	],
	"./00002/00002-04/00002-04-07/can you see four little penguins.mp3": [
		3386,
		7,
		2061
	],
	"./00002/00002-04/00002-04-07/can you see four little starfish.mp3": [
		3387,
		7,
		2062
	],
	"./00002/00002-04/00002-04-07/can you see one little seahorse.mp3": [
		3388,
		7,
		2063
	],
	"./00002/00002-04/00002-04-07/can you see three little crabs.mp3": [
		3389,
		7,
		2064
	],
	"./00002/00002-04/00002-04-07/intro.mp3": [
		517,
		7
	],
	"./00002/00002-04/00002-04-07/main idea.mp3": [
		898,
		7
	],
	"./00002/00002-04/00002-04-07/module": [
		1312,
		9,
		176
	],
	"./00002/00002-04/00002-04-07/module.js": [
		1312,
		9,
		176
	],
	"./00002/00002-04/00002-04-07/my book of seven.mp3": [
		3390,
		7,
		2065
	],
	"./00002/00002-04/00002-04-07/sea animals.mp3": [
		3391,
		7,
		2066
	],
	"./00002/00002-04/00002-04-07/you can see five sea turtles.mp3": [
		3392,
		7,
		2067
	],
	"./00002/00002-04/00002-04-07/you can see six big seahorses.mp3": [
		3393,
		7,
		2068
	],
	"./00002/00002-04/00002-04-07/you can see three big penguins.mp3": [
		3394,
		7,
		2069
	],
	"./00002/00002-04/00002-04-07/you can see two big sharks.mp3": [
		3395,
		7,
		2070
	],
	"./00002/00002-04/00002-04-07/you can see two whales.mp3": [
		3396,
		7,
		2071
	],
	"./00002/00002-04/00002-04-08/0.jpg": [
		6864,
		7,
		5541
	],
	"./00002/00002-04/00002-04-08/1.jpg": [
		8609,
		7,
		8631
	],
	"./00002/00002-04/00002-04-08/2.jpg": [
		8610,
		7,
		8632
	],
	"./00002/00002-04/00002-04-08/3.jpg": [
		8611,
		7,
		8633
	],
	"./00002/00002-04/00002-04-08/4.jpg": [
		8612,
		7,
		8634
	],
	"./00002/00002-04/00002-04-08/5.jpg": [
		8613,
		7,
		8635
	],
	"./00002/00002-04/00002-04-08/6.jpg": [
		8614,
		7,
		8636
	],
	"./00002/00002-04/00002-04-08/7.jpg": [
		8615,
		7,
		8637
	],
	"./00002/00002-04/00002-04-08/can you count eight things up in space.mp3": [
		3397,
		7,
		2072
	],
	"./00002/00002-04/00002-04-08/can you count five little planets.mp3": [
		3398,
		7,
		2073
	],
	"./00002/00002-04/00002-04-08/can you count four astronauts.mp3": [
		3399,
		7,
		2074
	],
	"./00002/00002-04/00002-04-08/can you count four rockets.mp3": [
		3400,
		7,
		2075
	],
	"./00002/00002-04/00002-04-08/can you count four spaceships.mp3": [
		3401,
		7,
		2076
	],
	"./00002/00002-04/00002-04-08/can you count to 8.mp3": [
		3402,
		7,
		2077
	],
	"./00002/00002-04/00002-04-08/can you see six little stars.mp3": [
		3403,
		7,
		2078
	],
	"./00002/00002-04/00002-04-08/can you see two big stars.mp3": [
		3404,
		7,
		2079
	],
	"./00002/00002-04/00002-04-08/intro.mp3": [
		518,
		7
	],
	"./00002/00002-04/00002-04-08/main idea.mp3": [
		899,
		7
	],
	"./00002/00002-04/00002-04-08/module": [
		1313,
		9,
		177
	],
	"./00002/00002-04/00002-04-08/module.js": [
		1313,
		9,
		177
	],
	"./00002/00002-04/00002-04-08/my book of eight.mp3": [
		3405,
		7,
		2080
	],
	"./00002/00002-04/00002-04-08/things in space.mp3": [
		3406,
		7,
		2081
	],
	"./00002/00002-04/00002-04-08/you can count seven satellites.mp3": [
		3407,
		7,
		2082
	],
	"./00002/00002-04/00002-04-08/you can see one planet.mp3": [
		3408,
		7,
		2083
	],
	"./00002/00002-04/00002-04-08/you can see three big planets.mp3": [
		3409,
		7,
		2084
	],
	"./00002/00002-04/00002-04-09/0.jpg": [
		6865,
		7,
		5542
	],
	"./00002/00002-04/00002-04-09/1.jpg": [
		8616,
		7,
		8638
	],
	"./00002/00002-04/00002-04-09/2.jpg": [
		8617,
		7,
		8639
	],
	"./00002/00002-04/00002-04-09/3.jpg": [
		8618,
		7,
		8640
	],
	"./00002/00002-04/00002-04-09/4.jpg": [
		8619,
		7,
		8641
	],
	"./00002/00002-04/00002-04-09/5.jpg": [
		8620,
		7,
		8642
	],
	"./00002/00002-04/00002-04-09/6.jpg": [
		8621,
		7,
		8643
	],
	"./00002/00002-04/00002-04-09/7.jpg": [
		8622,
		7,
		8644
	],
	"./00002/00002-04/00002-04-09/eight and one makes nine.mp3": [
		3410,
		7,
		2085
	],
	"./00002/00002-04/00002-04-09/five and four makes nine.mp3": [
		3411,
		7,
		2086
	],
	"./00002/00002-04/00002-04-09/four and five makes nine.mp3": [
		3412,
		7,
		2087
	],
	"./00002/00002-04/00002-04-09/i see elephants and zebras.mp3": [
		3413,
		7,
		2088
	],
	"./00002/00002-04/00002-04-09/i see hippos and rhinos.mp3": [
		3414,
		7,
		2089
	],
	"./00002/00002-04/00002-04-09/i see hippos rhinos and alligators.mp3": [
		3415,
		7,
		2090
	],
	"./00002/00002-04/00002-04-09/i see nine animals in all.mp3": [
		3416,
		7,
		2091
	],
	"./00002/00002-04/00002-04-09/i see nine baby animals.mp3": [
		3417,
		7,
		2092
	],
	"./00002/00002-04/00002-04-09/i see tigers and lions.mp3": [
		3418,
		7,
		2093
	],
	"./00002/00002-04/00002-04-09/intro.mp3": [
		519,
		7
	],
	"./00002/00002-04/00002-04-09/lets count the animals.mp3": [
		3419,
		7,
		2094
	],
	"./00002/00002-04/00002-04-09/main idea.mp3": [
		900,
		7
	],
	"./00002/00002-04/00002-04-09/module": [
		1314,
		9,
		178
	],
	"./00002/00002-04/00002-04-09/module.js": [
		1314,
		9,
		178
	],
	"./00002/00002-04/00002-04-09/my book of nine.mp3": [
		3420,
		7,
		2095
	],
	"./00002/00002-04/00002-04-09/seven and two makes nine.mp3": [
		3421,
		7,
		2096
	],
	"./00002/00002-04/00002-04-09/six and three makes nine.mp3": [
		3422,
		7,
		2097
	],
	"./00002/00002-04/00002-04-09/three and three and three makes nine.mp3": [
		3423,
		7,
		2098
	],
	"./00002/00002-04/00002-04-09/wild animals.mp3": [
		3424,
		7,
		2099
	],
	"./00002/00002-04/00002-04-10/0.jpg": [
		6866,
		7,
		5543
	],
	"./00002/00002-04/00002-04-10/1.jpg": [
		8623,
		7,
		8645
	],
	"./00002/00002-04/00002-04-10/2.jpg": [
		8624,
		7,
		8646
	],
	"./00002/00002-04/00002-04-10/3.jpg": [
		8625,
		7,
		8647
	],
	"./00002/00002-04/00002-04-10/4.jpg": [
		8626,
		7,
		8648
	],
	"./00002/00002-04/00002-04-10/5.jpg": [
		8627,
		7,
		8649
	],
	"./00002/00002-04/00002-04-10/6.jpg": [
		8628,
		7,
		8650
	],
	"./00002/00002-04/00002-04-10/7.jpg": [
		8629,
		7,
		8651
	],
	"./00002/00002-04/00002-04-10/brown animals.mp3": [
		3425,
		7,
		2100
	],
	"./00002/00002-04/00002-04-10/can you see five green dragons.mp3": [
		3426,
		7,
		2101
	],
	"./00002/00002-04/00002-04-10/can you see five green turtles.mp3": [
		3427,
		7,
		2102
	],
	"./00002/00002-04/00002-04-10/can you see six yellow giraffes.mp3": [
		3428,
		7,
		2103
	],
	"./00002/00002-04/00002-04-10/can you see three brown deer.mp3": [
		3429,
		7,
		2104
	],
	"./00002/00002-04/00002-04-10/eight and two equals ten.mp3": [
		3430,
		7,
		2105
	],
	"./00002/00002-04/00002-04-10/five and five equals ten.mp3": [
		3431,
		7,
		2106
	],
	"./00002/00002-04/00002-04-10/four and six equals ten.mp3": [
		3432,
		7,
		2107
	],
	"./00002/00002-04/00002-04-10/intro.mp3": [
		520,
		7
	],
	"./00002/00002-04/00002-04-10/main idea.mp3": [
		901,
		7
	],
	"./00002/00002-04/00002-04-10/module": [
		1315,
		9,
		179
	],
	"./00002/00002-04/00002-04-10/module.js": [
		1315,
		9,
		179
	],
	"./00002/00002-04/00002-04-10/my book of ten.mp3": [
		3433,
		7,
		2108
	],
	"./00002/00002-04/00002-04-10/one and nine equals ten.mp3": [
		3434,
		7,
		2109
	],
	"./00002/00002-04/00002-04-10/seven and three equals ten.mp3": [
		3435,
		7,
		2110
	],
	"./00002/00002-04/00002-04-10/ten and zero equals ten.mp3": [
		3436,
		7,
		2111
	],
	"./00002/00002-04/00002-04-10/you can see eight gray hippos.mp3": [
		3437,
		7,
		2112
	],
	"./00002/00002-04/00002-04-10/you can see five green alligators.mp3": [
		3438,
		7,
		2113
	],
	"./00002/00002-04/00002-04-10/you can see four yellow chicks.mp3": [
		3439,
		7,
		2114
	],
	"./00002/00002-04/00002-04-10/you can see nine white unicorns.mp3": [
		3440,
		7,
		2115
	],
	"./00002/00002-04/00002-04-10/you can see one white sheep.mp3": [
		3441,
		7,
		2116
	],
	"./00002/00002-04/00002-04-10/you can see seven brown monkeys.mp3": [
		3442,
		7,
		2117
	],
	"./00002/00002-04/00002-04-10/you can see ten pink dinosaurs.mp3": [
		3443,
		7,
		2118
	],
	"./00002/00002-04/00002-04-10/you can see two gray elephants.mp3": [
		3444,
		7,
		2119
	],
	"./00002/00002-04/00002-04-10/you can see zero pink cats.mp3": [
		3445,
		7,
		2120
	],
	"./00002/00002-04/cover.jpg": [
		6867,
		7,
		5544
	],
	"./00002/00002-04/number town.mp3": [
		3446,
		7,
		2121
	],
	"./00002/00002-04/numbers.mp3": [
		3447,
		7,
		2122
	],
	"./00002/00002-04/unit": [
		1316,
		9,
		180
	],
	"./00002/00002-04/unit.js": [
		1316,
		9,
		180
	],
	"./00002/00002-05/00002-05-01/0.jpg": [
		6868,
		7,
		5545
	],
	"./00002/00002-05/00002-05-01/1.jpg": [
		8630,
		7,
		8652
	],
	"./00002/00002-05/00002-05-01/2.jpg": [
		8631,
		7,
		8653
	],
	"./00002/00002-05/00002-05-01/3.jpg": [
		8632,
		7,
		8654
	],
	"./00002/00002-05/00002-05-01/4.jpg": [
		8633,
		7,
		8655
	],
	"./00002/00002-05/00002-05-01/5.jpg": [
		8634,
		7,
		8656
	],
	"./00002/00002-05/00002-05-01/6.jpg": [
		8635,
		7,
		8657
	],
	"./00002/00002-05/00002-05-01/7.jpg": [
		8636,
		7,
		8658
	],
	"./00002/00002-05/00002-05-01/all circles are round.mp3": [
		3448,
		7,
		2123
	],
	"./00002/00002-05/00002-05-01/circles are round.mp3": [
		3449,
		7,
		2124
	],
	"./00002/00002-05/00002-05-01/i can see big circles.mp3": [
		3450,
		7,
		2125
	],
	"./00002/00002-05/00002-05-01/i can see little circles.mp3": [
		3451,
		7,
		2126
	],
	"./00002/00002-05/00002-05-01/intro.mp3": [
		521,
		7
	],
	"./00002/00002-05/00002-05-01/main idea.mp3": [
		902,
		7
	],
	"./00002/00002-05/00002-05-01/module": [
		1317,
		9,
		181
	],
	"./00002/00002-05/00002-05-01/module.js": [
		1317,
		9,
		181
	],
	"./00002/00002-05/00002-05-01/some circles are black.mp3": [
		3452,
		7,
		2127
	],
	"./00002/00002-05/00002-05-01/some circles are blue.mp3": [
		3453,
		7,
		2128
	],
	"./00002/00002-05/00002-05-01/some circles are green.mp3": [
		3454,
		7,
		2129
	],
	"./00002/00002-05/00002-05-01/some circles are orange.mp3": [
		3455,
		7,
		2130
	],
	"./00002/00002-05/00002-05-01/some circles are purple.mp3": [
		3456,
		7,
		2131
	],
	"./00002/00002-05/00002-05-01/some circles are red.mp3": [
		3457,
		7,
		2132
	],
	"./00002/00002-05/00002-05-01/some circles are white.mp3": [
		3458,
		7,
		2133
	],
	"./00002/00002-05/00002-05-01/some circles are yellow.mp3": [
		3459,
		7,
		2134
	],
	"./00002/00002-05/00002-05-01/things that are round.mp3": [
		3460,
		7,
		2135
	],
	"./00002/00002-05/00002-05-02/0.jpg": [
		6869,
		7,
		5546
	],
	"./00002/00002-05/00002-05-02/1.jpg": [
		8637,
		7,
		8659
	],
	"./00002/00002-05/00002-05-02/2.jpg": [
		8638,
		7,
		8660
	],
	"./00002/00002-05/00002-05-02/3.jpg": [
		8639,
		7,
		8661
	],
	"./00002/00002-05/00002-05-02/4.jpg": [
		8640,
		7,
		8662
	],
	"./00002/00002-05/00002-05-02/5.jpg": [
		8641,
		7,
		8663
	],
	"./00002/00002-05/00002-05-02/6.jpg": [
		8642,
		7,
		8664
	],
	"./00002/00002-05/00002-05-02/7.jpg": [
		8643,
		7,
		8665
	],
	"./00002/00002-05/00002-05-02/can you count the corners.mp3": [
		3461,
		7,
		2136
	],
	"./00002/00002-05/00002-05-02/can you count the sides.mp3": [
		3462,
		7,
		2137
	],
	"./00002/00002-05/00002-05-02/intro.mp3": [
		522,
		7
	],
	"./00002/00002-05/00002-05-02/main idea.mp3": [
		903,
		7
	],
	"./00002/00002-05/00002-05-02/module": [
		1318,
		9,
		182
	],
	"./00002/00002-05/00002-05-02/module.js": [
		1318,
		9,
		182
	],
	"./00002/00002-05/00002-05-02/my square is black.mp3": [
		3463,
		7,
		2138
	],
	"./00002/00002-05/00002-05-02/my square is blue.mp3": [
		3464,
		7,
		2139
	],
	"./00002/00002-05/00002-05-02/my square is orange.mp3": [
		3465,
		7,
		2140
	],
	"./00002/00002-05/00002-05-02/my square is red.mp3": [
		3466,
		7,
		2141
	],
	"./00002/00002-05/00002-05-02/my square is yellow.mp3": [
		3467,
		7,
		2142
	],
	"./00002/00002-05/00002-05-02/my squares are green.mp3": [
		3468,
		7,
		2143
	],
	"./00002/00002-05/00002-05-02/my squares are pink.mp3": [
		3469,
		7,
		2144
	],
	"./00002/00002-05/00002-05-02/shapes.mp3": [
		3470,
		7,
		2145
	],
	"./00002/00002-05/00002-05-02/squares have four corners.mp3": [
		3471,
		7,
		2146
	],
	"./00002/00002-05/00002-05-02/squares have four sides.mp3": [
		3472,
		7,
		2147
	],
	"./00002/00002-05/00002-05-03/0.jpg": [
		6870,
		7,
		5547
	],
	"./00002/00002-05/00002-05-03/1.jpg": [
		8644,
		7,
		8666
	],
	"./00002/00002-05/00002-05-03/2.jpg": [
		8645,
		7,
		8667
	],
	"./00002/00002-05/00002-05-03/3.jpg": [
		8646,
		7,
		8668
	],
	"./00002/00002-05/00002-05-03/4.jpg": [
		8647,
		7,
		8669
	],
	"./00002/00002-05/00002-05-03/5.jpg": [
		8648,
		7,
		8670
	],
	"./00002/00002-05/00002-05-03/6.jpg": [
		8649,
		7,
		8671
	],
	"./00002/00002-05/00002-05-03/7.jpg": [
		8650,
		7,
		8672
	],
	"./00002/00002-05/00002-05-03/elephant likes the gray triangle.mp3": [
		3473,
		7,
		2148
	],
	"./00002/00002-05/00002-05-03/goat likes the orange triangle.mp3": [
		3474,
		7,
		2149
	],
	"./00002/00002-05/00002-05-03/intro.mp3": [
		523,
		7
	],
	"./00002/00002-05/00002-05-03/main idea.mp3": [
		904,
		7
	],
	"./00002/00002-05/00002-05-03/module": [
		1319,
		9,
		183
	],
	"./00002/00002-05/00002-05-03/module.js": [
		1319,
		9,
		183
	],
	"./00002/00002-05/00002-05-03/monkey likes the triangle.mp3": [
		3475,
		7,
		2150
	],
	"./00002/00002-05/00002-05-03/mouse likes the blue triangle.mp3": [
		3476,
		7,
		2151
	],
	"./00002/00002-05/00002-05-03/musical instruments.mp3": [
		3477,
		7,
		2152
	],
	"./00002/00002-05/00002-05-03/rabbit likes the red triangle.mp3": [
		3478,
		7,
		2153
	],
	"./00002/00002-05/00002-05-03/the boy likes the purple triangle.mp3": [
		3479,
		7,
		2154
	],
	"./00002/00002-05/00002-05-03/the girl likes the green triangle.mp3": [
		3480,
		7,
		2155
	],
	"./00002/00002-05/00002-05-03/this triangle is big.mp3": [
		3481,
		7,
		2156
	],
	"./00002/00002-05/00002-05-03/this triangle is little.mp3": [
		3482,
		7,
		2157
	],
	"./00002/00002-05/00002-05-03/triangles have three sides.mp3": [
		3483,
		7,
		2158
	],
	"./00002/00002-05/00002-05-04/0.jpg": [
		6871,
		7,
		5548
	],
	"./00002/00002-05/00002-05-04/1.jpg": [
		8651,
		7,
		8673
	],
	"./00002/00002-05/00002-05-04/2.jpg": [
		8652,
		7,
		8674
	],
	"./00002/00002-05/00002-05-04/3.jpg": [
		8653,
		7,
		8675
	],
	"./00002/00002-05/00002-05-04/4.jpg": [
		8654,
		7,
		8676
	],
	"./00002/00002-05/00002-05-04/5.jpg": [
		8655,
		7,
		8677
	],
	"./00002/00002-05/00002-05-04/6.jpg": [
		8656,
		7,
		8678
	],
	"./00002/00002-05/00002-05-04/7.jpg": [
		8657,
		7,
		8679
	],
	"./00002/00002-05/00002-05-04/animals with four legs.mp3": [
		3484,
		7,
		2159
	],
	"./00002/00002-05/00002-05-04/crocodile can see a long rectangle.mp3": [
		3485,
		7,
		2160
	],
	"./00002/00002-05/00002-05-04/giraffe can see a long rectangle.mp3": [
		3486,
		7,
		2161
	],
	"./00002/00002-05/00002-05-04/hedgehog can see a short rectangle.mp3": [
		3487,
		7,
		2162
	],
	"./00002/00002-05/00002-05-04/intro.mp3": [
		524,
		7
	],
	"./00002/00002-05/00002-05-04/main idea.mp3": [
		905,
		7
	],
	"./00002/00002-05/00002-05-04/module": [
		1320,
		9,
		184
	],
	"./00002/00002-05/00002-05-04/module.js": [
		1320,
		9,
		184
	],
	"./00002/00002-05/00002-05-04/pig can see a fat rectangle.mp3": [
		3488,
		7,
		2163
	],
	"./00002/00002-05/00002-05-04/rectangles have four corners.mp3": [
		3489,
		7,
		2164
	],
	"./00002/00002-05/00002-05-04/rectangles have four sides.mp3": [
		3490,
		7,
		2165
	],
	"./00002/00002-05/00002-05-04/sheep can see a fat rectangle.mp3": [
		3491,
		7,
		2166
	],
	"./00002/00002-05/00002-05-04/snake can see a thin rectangle.mp3": [
		3492,
		7,
		2167
	],
	"./00002/00002-05/00002-05-04/turtle can see a short rectangle.mp3": [
		3493,
		7,
		2168
	],
	"./00002/00002-05/00002-05-05/0.jpg": [
		6872,
		7,
		5549
	],
	"./00002/00002-05/00002-05-05/1.jpg": [
		8658,
		7,
		8680
	],
	"./00002/00002-05/00002-05-05/2.jpg": [
		8659,
		7,
		8681
	],
	"./00002/00002-05/00002-05-05/3.jpg": [
		8660,
		7,
		8682
	],
	"./00002/00002-05/00002-05-05/4.jpg": [
		8661,
		7,
		8683
	],
	"./00002/00002-05/00002-05-05/5.jpg": [
		8662,
		7,
		8684
	],
	"./00002/00002-05/00002-05-05/6.jpg": [
		8663,
		7,
		8685
	],
	"./00002/00002-05/00002-05-05/7.jpg": [
		8664,
		7,
		8686
	],
	"./00002/00002-05/00002-05-05/can you see it too.mp3": [
		3494,
		7,
		2169
	],
	"./00002/00002-05/00002-05-05/i can see a hexagon.mp3": [
		3495,
		7,
		2170
	],
	"./00002/00002-05/00002-05-05/i can see a pentagon.mp3": [
		3496,
		7,
		2171
	],
	"./00002/00002-05/00002-05-05/i can see a rectangle.mp3": [
		3497,
		7,
		2172
	],
	"./00002/00002-05/00002-05-05/i can see a square.mp3": [
		3498,
		7,
		2173
	],
	"./00002/00002-05/00002-05-05/i can see a triangle.mp3": [
		3499,
		7,
		2174
	],
	"./00002/00002-05/00002-05-05/i can see an octagon.mp3": [
		3500,
		7,
		2175
	],
	"./00002/00002-05/00002-05-05/i can see circles.mp3": [
		3501,
		7,
		2176
	],
	"./00002/00002-05/00002-05-05/i can see hexagons.mp3": [
		3502,
		7,
		2177
	],
	"./00002/00002-05/00002-05-05/intro.mp3": [
		525,
		7
	],
	"./00002/00002-05/00002-05-05/lets go look for shapes.mp3": [
		3503,
		7,
		2178
	],
	"./00002/00002-05/00002-05-05/main idea.mp3": [
		906,
		7
	],
	"./00002/00002-05/00002-05-05/module": [
		1321,
		9,
		185
	],
	"./00002/00002-05/00002-05-05/module.js": [
		1321,
		9,
		185
	],
	"./00002/00002-05/00002-05-05/shapes.mp3": [
		3504,
		7,
		2179
	],
	"./00002/00002-05/00002-05-05/what can you see.mp3": [
		3505,
		7,
		2180
	],
	"./00002/00002-05/00002-05-06/0.jpg": [
		6873,
		7,
		5550
	],
	"./00002/00002-05/00002-05-06/1.jpg": [
		8665,
		7,
		8687
	],
	"./00002/00002-05/00002-05-06/2.jpg": [
		8666,
		7,
		8688
	],
	"./00002/00002-05/00002-05-06/3.jpg": [
		8667,
		7,
		8689
	],
	"./00002/00002-05/00002-05-06/4.jpg": [
		8668,
		7,
		8690
	],
	"./00002/00002-05/00002-05-06/5.jpg": [
		8669,
		7,
		8691
	],
	"./00002/00002-05/00002-05-06/6.jpg": [
		8670,
		7,
		8692
	],
	"./00002/00002-05/00002-05-06/7.jpg": [
		8671,
		7,
		8693
	],
	"./00002/00002-05/00002-05-06/balls are solid.mp3": [
		3506,
		7,
		2181
	],
	"./00002/00002-05/00002-05-06/boxes are solid.mp3": [
		3507,
		7,
		2182
	],
	"./00002/00002-05/00002-05-06/cones are solid.mp3": [
		3508,
		7,
		2183
	],
	"./00002/00002-05/00002-05-06/cubes are solid.mp3": [
		3509,
		7,
		2184
	],
	"./00002/00002-05/00002-05-06/cylinders are solid.mp3": [
		3510,
		7,
		2185
	],
	"./00002/00002-05/00002-05-06/intro.mp3": [
		526,
		7
	],
	"./00002/00002-05/00002-05-06/main idea.mp3": [
		907,
		7
	],
	"./00002/00002-05/00002-05-06/module": [
		1322,
		9,
		186
	],
	"./00002/00002-05/00002-05-06/module.js": [
		1322,
		9,
		186
	],
	"./00002/00002-05/00002-05-06/pyramids are solid.mp3": [
		3511,
		7,
		2186
	],
	"./00002/00002-05/00002-05-06/solid shapes.mp3": [
		3512,
		7,
		2187
	],
	"./00002/00002-05/00002-05-06/spheres are solid.mp3": [
		3513,
		7,
		2188
	],
	"./00002/00002-05/00002-05-06/they have four faces.mp3": [
		3514,
		7,
		2189
	],
	"./00002/00002-05/00002-05-06/they have one face.mp3": [
		3515,
		7,
		2190
	],
	"./00002/00002-05/00002-05-06/they have six faces.mp3": [
		3516,
		7,
		2191
	],
	"./00002/00002-05/00002-05-06/they have two faces.mp3": [
		3517,
		7,
		2192
	],
	"./00002/00002-05/00002-05-06/they have zero faces.mp3": [
		3518,
		7,
		2193
	],
	"./00002/00002-05/00002-05-07/0.jpg": [
		6874,
		7,
		5551
	],
	"./00002/00002-05/00002-05-07/1.jpg": [
		8672,
		7,
		8694
	],
	"./00002/00002-05/00002-05-07/2.jpg": [
		8673,
		7,
		8695
	],
	"./00002/00002-05/00002-05-07/3.jpg": [
		8674,
		7,
		8696
	],
	"./00002/00002-05/00002-05-07/4.jpg": [
		8675,
		7,
		8697
	],
	"./00002/00002-05/00002-05-07/5.jpg": [
		8676,
		7,
		8698
	],
	"./00002/00002-05/00002-05-07/6.jpg": [
		8677,
		7,
		8699
	],
	"./00002/00002-05/00002-05-07/7.jpg": [
		8678,
		7,
		8700
	],
	"./00002/00002-05/00002-05-07/cubes have six faces.mp3": [
		3519,
		7,
		2194
	],
	"./00002/00002-05/00002-05-07/forest animals.mp3": [
		3520,
		7,
		2195
	],
	"./00002/00002-05/00002-05-07/intro.mp3": [
		527,
		7
	],
	"./00002/00002-05/00002-05-07/look at the bear face.mp3": [
		3521,
		7,
		2196
	],
	"./00002/00002-05/00002-05-07/look at the deer face.mp3": [
		3522,
		7,
		2197
	],
	"./00002/00002-05/00002-05-07/look at the elephant face.mp3": [
		3523,
		7,
		2198
	],
	"./00002/00002-05/00002-05-07/look at the faces.mp3": [
		3524,
		7,
		2199
	],
	"./00002/00002-05/00002-05-07/look at the fox face.mp3": [
		3525,
		7,
		2200
	],
	"./00002/00002-05/00002-05-07/look at the panda face.mp3": [
		3526,
		7,
		2201
	],
	"./00002/00002-05/00002-05-07/look at the rabbit face.mp3": [
		3527,
		7,
		2202
	],
	"./00002/00002-05/00002-05-07/main idea.mp3": [
		908,
		7
	],
	"./00002/00002-05/00002-05-07/module": [
		1323,
		9,
		187
	],
	"./00002/00002-05/00002-05-07/module.js": [
		1323,
		9,
		187
	],
	"./00002/00002-05/00002-05-08/0.jpg": [
		6875,
		7,
		5552
	],
	"./00002/00002-05/00002-05-08/1.jpg": [
		8679,
		7,
		8701
	],
	"./00002/00002-05/00002-05-08/2.jpg": [
		8680,
		7,
		8702
	],
	"./00002/00002-05/00002-05-08/3.jpg": [
		8681,
		7,
		8703
	],
	"./00002/00002-05/00002-05-08/4.jpg": [
		8682,
		7,
		8704
	],
	"./00002/00002-05/00002-05-08/5.jpg": [
		8683,
		7,
		8705
	],
	"./00002/00002-05/00002-05-08/6.jpg": [
		8684,
		7,
		8706
	],
	"./00002/00002-05/00002-05-08/7.jpg": [
		8685,
		7,
		8707
	],
	"./00002/00002-05/00002-05-08/intro.mp3": [
		528,
		7
	],
	"./00002/00002-05/00002-05-08/look at the circles.mp3": [
		3528,
		7,
		2203
	],
	"./00002/00002-05/00002-05-08/look at the hexagons.mp3": [
		3529,
		7,
		2204
	],
	"./00002/00002-05/00002-05-08/look at the octagons.mp3": [
		3530,
		7,
		2205
	],
	"./00002/00002-05/00002-05-08/look at the pentagons.mp3": [
		3531,
		7,
		2206
	],
	"./00002/00002-05/00002-05-08/look at the rectangles.mp3": [
		3532,
		7,
		2207
	],
	"./00002/00002-05/00002-05-08/look at the squares.mp3": [
		3533,
		7,
		2208
	],
	"./00002/00002-05/00002-05-08/look at the triangles.mp3": [
		3534,
		7,
		2209
	],
	"./00002/00002-05/00002-05-08/main idea.mp3": [
		909,
		7
	],
	"./00002/00002-05/00002-05-08/module": [
		1324,
		9,
		188
	],
	"./00002/00002-05/00002-05-08/module.js": [
		1324,
		9,
		188
	],
	"./00002/00002-05/00002-05-08/non living things.mp3": [
		3535,
		7,
		2210
	],
	"./00002/00002-05/00002-05-08/there are shapes on the quilt.mp3": [
		3536,
		7,
		2211
	],
	"./00002/00002-05/00002-05-09/0.jpg": [
		6876,
		7,
		5553
	],
	"./00002/00002-05/00002-05-09/1.jpg": [
		8686,
		7,
		8708
	],
	"./00002/00002-05/00002-05-09/2.jpg": [
		8687,
		7,
		8709
	],
	"./00002/00002-05/00002-05-09/3.jpg": [
		8688,
		7,
		8710
	],
	"./00002/00002-05/00002-05-09/4.jpg": [
		8689,
		7,
		8711
	],
	"./00002/00002-05/00002-05-09/5.jpg": [
		8690,
		7,
		8712
	],
	"./00002/00002-05/00002-05-09/6.jpg": [
		8691,
		7,
		8713
	],
	"./00002/00002-05/00002-05-09/7.jpg": [
		8692,
		7,
		8714
	],
	"./00002/00002-05/00002-05-09/i can make a circle.mp3": [
		3537,
		7,
		2212
	],
	"./00002/00002-05/00002-05-09/i can make a fox.mp3": [
		3538,
		7,
		2213
	],
	"./00002/00002-05/00002-05-09/i can make a hexagon.mp3": [
		3539,
		7,
		2214
	],
	"./00002/00002-05/00002-05-09/i can make a new shape.mp3": [
		3540,
		7,
		2215
	],
	"./00002/00002-05/00002-05-09/i can make a pentagon.mp3": [
		3541,
		7,
		2216
	],
	"./00002/00002-05/00002-05-09/i can make a rectangle.mp3": [
		3542,
		7,
		2217
	],
	"./00002/00002-05/00002-05-09/i can make a square.mp3": [
		3543,
		7,
		2218
	],
	"./00002/00002-05/00002-05-09/i can make an octagon.mp3": [
		3544,
		7,
		2219
	],
	"./00002/00002-05/00002-05-09/intro.mp3": [
		529,
		7
	],
	"./00002/00002-05/00002-05-09/main idea.mp3": [
		910,
		7
	],
	"./00002/00002-05/00002-05-09/module": [
		1325,
		9,
		189
	],
	"./00002/00002-05/00002-05-09/module.js": [
		1325,
		9,
		189
	],
	"./00002/00002-05/00002-05-09/shapes.mp3": [
		3545,
		7,
		2220
	],
	"./00002/00002-05/00002-05-09/what can i make.mp3": [
		3546,
		7,
		2221
	],
	"./00002/00002-05/00002-05-10/0.jpg": [
		6877,
		7,
		5554
	],
	"./00002/00002-05/00002-05-10/1.jpg": [
		8693,
		7,
		8715
	],
	"./00002/00002-05/00002-05-10/2.jpg": [
		8694,
		7,
		8716
	],
	"./00002/00002-05/00002-05-10/3.jpg": [
		8695,
		7,
		8717
	],
	"./00002/00002-05/00002-05-10/4.jpg": [
		8696,
		7,
		8718
	],
	"./00002/00002-05/00002-05-10/5.jpg": [
		8697,
		7,
		8719
	],
	"./00002/00002-05/00002-05-10/6.jpg": [
		8698,
		7,
		8720
	],
	"./00002/00002-05/00002-05-10/7.jpg": [
		8699,
		7,
		8721
	],
	"./00002/00002-05/00002-05-10/intro.mp3": [
		530,
		7
	],
	"./00002/00002-05/00002-05-10/main idea.mp3": [
		911,
		7
	],
	"./00002/00002-05/00002-05-10/module": [
		1326,
		9,
		190
	],
	"./00002/00002-05/00002-05-10/module.js": [
		1326,
		9,
		190
	],
	"./00002/00002-05/00002-05-10/places.mp3": [
		3547,
		7,
		2222
	],
	"./00002/00002-05/00002-05-10/shapes are all around us.mp3": [
		3548,
		7,
		2223
	],
	"./00002/00002-05/00002-05-10/we can see circles.mp3": [
		3549,
		7,
		2224
	],
	"./00002/00002-05/00002-05-10/we can see cones.mp3": [
		3550,
		7,
		2225
	],
	"./00002/00002-05/00002-05-10/we can see cubes.mp3": [
		3551,
		7,
		2226
	],
	"./00002/00002-05/00002-05-10/we can see cylinders.mp3": [
		3552,
		7,
		2227
	],
	"./00002/00002-05/00002-05-10/we can see rectangles.mp3": [
		3553,
		7,
		2228
	],
	"./00002/00002-05/00002-05-10/we can see squares.mp3": [
		3554,
		7,
		2229
	],
	"./00002/00002-05/00002-05-10/we can see triangles.mp3": [
		3555,
		7,
		2230
	],
	"./00002/00002-05/cover.jpg": [
		6878,
		7,
		5555
	],
	"./00002/00002-05/shapes town.mp3": [
		3556,
		7,
		2231
	],
	"./00002/00002-05/shapes.mp3": [
		3557,
		7,
		2232
	],
	"./00002/00002-05/unit": [
		1327,
		9,
		191
	],
	"./00002/00002-05/unit.js": [
		1327,
		9,
		191
	],
	"./00002/00002-06/00002-06-01/0.jpg": [
		6879,
		7,
		5556
	],
	"./00002/00002-06/00002-06-01/1.jpg": [
		8700,
		7,
		8722
	],
	"./00002/00002-06/00002-06-01/2.jpg": [
		8701,
		7,
		8723
	],
	"./00002/00002-06/00002-06-01/3.jpg": [
		8702,
		7,
		8724
	],
	"./00002/00002-06/00002-06-01/4.jpg": [
		8703,
		7,
		8725
	],
	"./00002/00002-06/00002-06-01/5.jpg": [
		8704,
		7,
		8726
	],
	"./00002/00002-06/00002-06-01/6.jpg": [
		8705,
		7,
		8727
	],
	"./00002/00002-06/00002-06-01/7.jpg": [
		8706,
		7,
		8728
	],
	"./00002/00002-06/00002-06-01/i do not need air said the octopus.mp3": [
		3558,
		7,
		2233
	],
	"./00002/00002-06/00002-06-01/i need air said the astronaut.mp3": [
		3559,
		7,
		2234
	],
	"./00002/00002-06/00002-06-01/i need air said the cat.mp3": [
		3560,
		7,
		2235
	],
	"./00002/00002-06/00002-06-01/i need air said the dolphin.mp3": [
		3561,
		7,
		2236
	],
	"./00002/00002-06/00002-06-01/intro.mp3": [
		531,
		7
	],
	"./00002/00002-06/00002-06-01/main idea.mp3": [
		912,
		7
	],
	"./00002/00002-06/00002-06-01/me too said the eagle.mp3": [
		3562,
		7,
		2237
	],
	"./00002/00002-06/00002-06-01/me too said the scuba diver.mp3": [
		3563,
		7,
		2238
	],
	"./00002/00002-06/00002-06-01/me too said the whale.mp3": [
		3564,
		7,
		2239
	],
	"./00002/00002-06/00002-06-01/module": [
		1328,
		9,
		192
	],
	"./00002/00002-06/00002-06-01/module.js": [
		1328,
		9,
		192
	],
	"./00002/00002-06/00002-06-01/water animals.mp3": [
		3565,
		7,
		2240
	],
	"./00002/00002-06/00002-06-01/we need air.mp3": [
		3566,
		7,
		2241
	],
	"./00002/00002-06/00002-06-02/0.jpg": [
		6880,
		7,
		5557
	],
	"./00002/00002-06/00002-06-02/1.jpg": [
		8707,
		7,
		8729
	],
	"./00002/00002-06/00002-06-02/2.jpg": [
		8708,
		7,
		8730
	],
	"./00002/00002-06/00002-06-02/3.jpg": [
		8709,
		7,
		8731
	],
	"./00002/00002-06/00002-06-02/4.jpg": [
		8710,
		7,
		8732
	],
	"./00002/00002-06/00002-06-02/5.jpg": [
		8711,
		7,
		8733
	],
	"./00002/00002-06/00002-06-02/6.jpg": [
		8712,
		7,
		8734
	],
	"./00002/00002-06/00002-06-02/7.jpg": [
		8713,
		7,
		8735
	],
	"./00002/00002-06/00002-06-02/farm animals.mp3": [
		3567,
		7,
		2242
	],
	"./00002/00002-06/00002-06-02/intro.mp3": [
		532,
		7
	],
	"./00002/00002-06/00002-06-02/look at the cow.mp3": [
		3568,
		7,
		2243
	],
	"./00002/00002-06/00002-06-02/look at the duck.mp3": [
		3569,
		7,
		2244
	],
	"./00002/00002-06/00002-06-02/look at the frog.mp3": [
		3570,
		7,
		2245
	],
	"./00002/00002-06/00002-06-02/look at the monkey.mp3": [
		3571,
		7,
		2246
	],
	"./00002/00002-06/00002-06-02/look at the shark.mp3": [
		3572,
		7,
		2247
	],
	"./00002/00002-06/00002-06-02/look at the sheep.mp3": [
		3573,
		7,
		2248
	],
	"./00002/00002-06/00002-06-02/look at the whale.mp3": [
		3574,
		7,
		2249
	],
	"./00002/00002-06/00002-06-02/main idea.mp3": [
		913,
		7
	],
	"./00002/00002-06/00002-06-02/module": [
		1329,
		9,
		193
	],
	"./00002/00002-06/00002-06-02/module.js": [
		1329,
		9,
		193
	],
	"./00002/00002-06/00002-06-02/the cow lives on the farm.mp3": [
		3575,
		7,
		2250
	],
	"./00002/00002-06/00002-06-02/the duck lives at the pond too.mp3": [
		3576,
		7,
		2251
	],
	"./00002/00002-06/00002-06-02/the frog lives at the pond.mp3": [
		3577,
		7,
		2252
	],
	"./00002/00002-06/00002-06-02/the monkey lives in a tree.mp3": [
		3578,
		7,
		2253
	],
	"./00002/00002-06/00002-06-02/the shark lives in the sea too.mp3": [
		3579,
		7,
		2254
	],
	"./00002/00002-06/00002-06-02/the sheep lives on the farm too.mp3": [
		3580,
		7,
		2255
	],
	"./00002/00002-06/00002-06-02/the whale lives in the sea.mp3": [
		3581,
		7,
		2256
	],
	"./00002/00002-06/00002-06-02/we need homes.mp3": [
		3582,
		7,
		2257
	],
	"./00002/00002-06/00002-06-03/0.jpg": [
		6881,
		7,
		5558
	],
	"./00002/00002-06/00002-06-03/1.jpg": [
		8714,
		7,
		8736
	],
	"./00002/00002-06/00002-06-03/2.jpg": [
		8715,
		7,
		8737
	],
	"./00002/00002-06/00002-06-03/3.jpg": [
		8716,
		7,
		8738
	],
	"./00002/00002-06/00002-06-03/4.jpg": [
		8717,
		7,
		8739
	],
	"./00002/00002-06/00002-06-03/5.jpg": [
		8718,
		7,
		8740
	],
	"./00002/00002-06/00002-06-03/6.jpg": [
		8719,
		7,
		8741
	],
	"./00002/00002-06/00002-06-03/7.jpg": [
		8720,
		7,
		8742
	],
	"./00002/00002-06/00002-06-03/animals that eat plants.mp3": [
		3583,
		7,
		2258
	],
	"./00002/00002-06/00002-06-03/do you.mp3": [
		3584,
		7,
		2259
	],
	"./00002/00002-06/00002-06-03/i like bananas.mp3": [
		3585,
		7,
		2260
	],
	"./00002/00002-06/00002-06-03/i like fish.mp3": [
		3586,
		7,
		2261
	],
	"./00002/00002-06/00002-06-03/i like grass said the zebra.mp3": [
		3587,
		7,
		2262
	],
	"./00002/00002-06/00002-06-03/i like insects said the bat.mp3": [
		3588,
		7,
		2263
	],
	"./00002/00002-06/00002-06-03/i like leaves too.mp3": [
		3589,
		7,
		2264
	],
	"./00002/00002-06/00002-06-03/i like leaves.mp3": [
		3590,
		7,
		2265
	],
	"./00002/00002-06/00002-06-03/i like nuts said the squirrel.mp3": [
		3591,
		7,
		2266
	],
	"./00002/00002-06/00002-06-03/intro.mp3": [
		533,
		7
	],
	"./00002/00002-06/00002-06-03/main idea.mp3": [
		914,
		7
	],
	"./00002/00002-06/00002-06-03/me too said the dinosaur.mp3": [
		3592,
		7,
		2267
	],
	"./00002/00002-06/00002-06-03/module": [
		1330,
		9,
		194
	],
	"./00002/00002-06/00002-06-03/module.js": [
		1330,
		9,
		194
	],
	"./00002/00002-06/00002-06-03/not me said the giraffe.mp3": [
		3593,
		7,
		2268
	],
	"./00002/00002-06/00002-06-03/not me said the monkey.mp3": [
		3594,
		7,
		2269
	],
	"./00002/00002-06/00002-06-03/not me said the shark.mp3": [
		3595,
		7,
		2270
	],
	"./00002/00002-06/00002-06-03/water animals.mp3": [
		3596,
		7,
		2271
	],
	"./00002/00002-06/00002-06-03/we need to eat.mp3": [
		3597,
		7,
		2272
	],
	"./00002/00002-06/00002-06-04/0.jpg": [
		6882,
		7,
		5559
	],
	"./00002/00002-06/00002-06-04/1.jpg": [
		8721,
		7,
		8743
	],
	"./00002/00002-06/00002-06-04/2.jpg": [
		8722,
		7,
		8744
	],
	"./00002/00002-06/00002-06-04/3.jpg": [
		8723,
		7,
		8745
	],
	"./00002/00002-06/00002-06-04/4.jpg": [
		8724,
		7,
		8746
	],
	"./00002/00002-06/00002-06-04/5.jpg": [
		8725,
		7,
		8747
	],
	"./00002/00002-06/00002-06-04/6.jpg": [
		8726,
		7,
		8748
	],
	"./00002/00002-06/00002-06-04/7.jpg": [
		8727,
		7,
		8749
	],
	"./00002/00002-06/00002-06-04/animals that live in the snow.mp3": [
		3598,
		7,
		2273
	],
	"./00002/00002-06/00002-06-04/he is out in the snow.mp3": [
		3599,
		7,
		2274
	],
	"./00002/00002-06/00002-06-04/i am out in the snow too.mp3": [
		3600,
		7,
		2275
	],
	"./00002/00002-06/00002-06-04/intro.mp3": [
		534,
		7
	],
	"./00002/00002-06/00002-06-04/it is snowing.mp3": [
		3601,
		7,
		2276
	],
	"./00002/00002-06/00002-06-04/it is winter.mp3": [
		3602,
		7,
		2277
	],
	"./00002/00002-06/00002-06-04/look at me.mp3": [
		3603,
		7,
		2278
	],
	"./00002/00002-06/00002-06-04/look at the deer.mp3": [
		3604,
		7,
		2279
	],
	"./00002/00002-06/00002-06-04/look at the dog.mp3": [
		3605,
		7,
		2280
	],
	"./00002/00002-06/00002-06-04/look at the fox.mp3": [
		3606,
		7,
		2281
	],
	"./00002/00002-06/00002-06-04/look at the owl.mp3": [
		3607,
		7,
		2282
	],
	"./00002/00002-06/00002-06-04/look at the rabbit.mp3": [
		3608,
		7,
		2283
	],
	"./00002/00002-06/00002-06-04/look at the squirrel.mp3": [
		3609,
		7,
		2284
	],
	"./00002/00002-06/00002-06-04/main idea.mp3": [
		915,
		7
	],
	"./00002/00002-06/00002-06-04/module": [
		1331,
		9,
		195
	],
	"./00002/00002-06/00002-06-04/module.js": [
		1331,
		9,
		195
	],
	"./00002/00002-06/00002-06-04/out in the snow.mp3": [
		3610,
		7,
		2285
	],
	"./00002/00002-06/00002-06-04/she is out in the snow.mp3": [
		3611,
		7,
		2286
	],
	"./00002/00002-06/00002-06-05/0.jpg": [
		6883,
		7,
		5560
	],
	"./00002/00002-06/00002-06-05/1.jpg": [
		8728,
		7,
		8750
	],
	"./00002/00002-06/00002-06-05/2.jpg": [
		8729,
		7,
		8751
	],
	"./00002/00002-06/00002-06-05/3.jpg": [
		8730,
		7,
		8752
	],
	"./00002/00002-06/00002-06-05/4.jpg": [
		8731,
		7,
		8753
	],
	"./00002/00002-06/00002-06-05/5.jpg": [
		8732,
		7,
		8754
	],
	"./00002/00002-06/00002-06-05/6.jpg": [
		8733,
		7,
		8755
	],
	"./00002/00002-06/00002-06-05/7.jpg": [
		8734,
		7,
		8756
	],
	"./00002/00002-06/00002-06-05/are they alive.mp3": [
		3612,
		7,
		2287
	],
	"./00002/00002-06/00002-06-05/i can see a log.mp3": [
		3613,
		7,
		2288
	],
	"./00002/00002-06/00002-06-05/i can see a seal.mp3": [
		3614,
		7,
		2289
	],
	"./00002/00002-06/00002-06-05/i can see a wheel.mp3": [
		3615,
		7,
		2290
	],
	"./00002/00002-06/00002-06-05/i can see one box.mp3": [
		3616,
		7,
		2291
	],
	"./00002/00002-06/00002-06-05/i can see one cat.mp3": [
		3617,
		7,
		2292
	],
	"./00002/00002-06/00002-06-05/i can see one duck.mp3": [
		3618,
		7,
		2293
	],
	"./00002/00002-06/00002-06-05/i can see one fox.mp3": [
		3619,
		7,
		2294
	],
	"./00002/00002-06/00002-06-05/i can see one frog.mp3": [
		3620,
		7,
		2295
	],
	"./00002/00002-06/00002-06-05/i can see one hat.mp3": [
		3621,
		7,
		2296
	],
	"./00002/00002-06/00002-06-05/i can see one house.mp3": [
		3622,
		7,
		2297
	],
	"./00002/00002-06/00002-06-05/i can see one mouse.mp3": [
		3623,
		7,
		2298
	],
	"./00002/00002-06/00002-06-05/i can see one truck.mp3": [
		3624,
		7,
		2299
	],
	"./00002/00002-06/00002-06-05/intro.mp3": [
		535,
		7
	],
	"./00002/00002-06/00002-06-05/living things.mp3": [
		3625,
		7,
		2300
	],
	"./00002/00002-06/00002-06-05/look at the jeep.mp3": [
		3626,
		7,
		2301
	],
	"./00002/00002-06/00002-06-05/look at the sheep.mp3": [
		3627,
		7,
		2302
	],
	"./00002/00002-06/00002-06-05/main idea.mp3": [
		916,
		7
	],
	"./00002/00002-06/00002-06-05/module": [
		1332,
		9,
		196
	],
	"./00002/00002-06/00002-06-05/module.js": [
		1332,
		9,
		196
	],
	"./00002/00002-06/00002-06-05/the cat is alive.mp3": [
		3628,
		7,
		2303
	],
	"./00002/00002-06/00002-06-05/the duck is alive.mp3": [
		3629,
		7,
		2304
	],
	"./00002/00002-06/00002-06-05/the fox is alive.mp3": [
		3630,
		7,
		2305
	],
	"./00002/00002-06/00002-06-05/the frog is alive.mp3": [
		3631,
		7,
		2306
	],
	"./00002/00002-06/00002-06-05/the mouse is alive.mp3": [
		3632,
		7,
		2307
	],
	"./00002/00002-06/00002-06-05/the seal is alive.mp3": [
		3633,
		7,
		2308
	],
	"./00002/00002-06/00002-06-05/the sheep is alive.mp3": [
		3634,
		7,
		2309
	],
	"./00002/00002-06/00002-06-05/which one is alive.mp3": [
		3635,
		7,
		2310
	],
	"./00002/00002-06/00002-06-06/0.jpg": [
		6884,
		7,
		5561
	],
	"./00002/00002-06/00002-06-06/1.jpg": [
		8735,
		7,
		8757
	],
	"./00002/00002-06/00002-06-06/2.jpg": [
		8736,
		7,
		8758
	],
	"./00002/00002-06/00002-06-06/3.jpg": [
		8737,
		7,
		8759
	],
	"./00002/00002-06/00002-06-06/4.jpg": [
		8738,
		7,
		8760
	],
	"./00002/00002-06/00002-06-06/5.jpg": [
		8739,
		7,
		8761
	],
	"./00002/00002-06/00002-06-06/6.jpg": [
		8740,
		7,
		8762
	],
	"./00002/00002-06/00002-06-06/7.jpg": [
		8741,
		7,
		8763
	],
	"./00002/00002-06/00002-06-06/baby animals.mp3": [
		3636,
		7,
		2311
	],
	"./00002/00002-06/00002-06-06/here is my mother.mp3": [
		3637,
		7,
		2312
	],
	"./00002/00002-06/00002-06-06/i am a puppy.mp3": [
		3638,
		7,
		2313
	],
	"./00002/00002-06/00002-06-06/i love my mother.mp3": [
		3639,
		7,
		2314
	],
	"./00002/00002-06/00002-06-06/intro.mp3": [
		536,
		7
	],
	"./00002/00002-06/00002-06-06/main idea.mp3": [
		917,
		7
	],
	"./00002/00002-06/00002-06-06/mammals.mp3": [
		3640,
		7,
		2315
	],
	"./00002/00002-06/00002-06-06/module": [
		1333,
		9,
		197
	],
	"./00002/00002-06/00002-06-06/module.js": [
		1333,
		9,
		197
	],
	"./00002/00002-06/00002-06-06/mother.mp3": [
		3641,
		7,
		2316
	],
	"./00002/00002-06/00002-06-06/my mother is a bear.mp3": [
		3642,
		7,
		2317
	],
	"./00002/00002-06/00002-06-06/my mother is a cow.mp3": [
		3643,
		7,
		2318
	],
	"./00002/00002-06/00002-06-06/my mother is a dolphin.mp3": [
		3644,
		7,
		2319
	],
	"./00002/00002-06/00002-06-06/my mother is a duck.mp3": [
		3645,
		7,
		2320
	],
	"./00002/00002-06/00002-06-06/my mother is a kangaroo.mp3": [
		3646,
		7,
		2321
	],
	"./00002/00002-06/00002-06-06/my mother is a rabbit.mp3": [
		3647,
		7,
		2322
	],
	"./00002/00002-06/00002-06-06/my mother is a sheep.mp3": [
		3648,
		7,
		2323
	],
	"./00002/00002-06/00002-06-07/0.jpg": [
		6885,
		7,
		5562
	],
	"./00002/00002-06/00002-06-07/1.jpg": [
		8742,
		7,
		8764
	],
	"./00002/00002-06/00002-06-07/2.jpg": [
		8743,
		7,
		8765
	],
	"./00002/00002-06/00002-06-07/3.jpg": [
		8744,
		7,
		8766
	],
	"./00002/00002-06/00002-06-07/4.jpg": [
		8745,
		7,
		8767
	],
	"./00002/00002-06/00002-06-07/5.jpg": [
		8746,
		7,
		8768
	],
	"./00002/00002-06/00002-06-07/6.jpg": [
		8747,
		7,
		8769
	],
	"./00002/00002-06/00002-06-07/7.jpg": [
		8748,
		7,
		8770
	],
	"./00002/00002-06/00002-06-07/birds need water.mp3": [
		3649,
		7,
		2324
	],
	"./00002/00002-06/00002-06-07/deer need water.mp3": [
		3650,
		7,
		2325
	],
	"./00002/00002-06/00002-06-07/dogs need water too.mp3": [
		3651,
		7,
		2326
	],
	"./00002/00002-06/00002-06-07/dolphins need water.mp3": [
		3652,
		7,
		2327
	],
	"./00002/00002-06/00002-06-07/ducks need water.mp3": [
		3653,
		7,
		2328
	],
	"./00002/00002-06/00002-06-07/everyone needs water.mp3": [
		3654,
		7,
		2329
	],
	"./00002/00002-06/00002-06-07/flowers need water.mp3": [
		3655,
		7,
		2330
	],
	"./00002/00002-06/00002-06-07/frogs need water.mp3": [
		3656,
		7,
		2331
	],
	"./00002/00002-06/00002-06-07/intro.mp3": [
		537,
		7
	],
	"./00002/00002-06/00002-06-07/look at the birds.mp3": [
		3657,
		7,
		2332
	],
	"./00002/00002-06/00002-06-07/look at the deer.mp3": [
		3658,
		7,
		2333
	],
	"./00002/00002-06/00002-06-07/look at the dog.mp3": [
		3659,
		7,
		2334
	],
	"./00002/00002-06/00002-06-07/look at the dolphins.mp3": [
		3660,
		7,
		2335
	],
	"./00002/00002-06/00002-06-07/look at the ducks.mp3": [
		3661,
		7,
		2336
	],
	"./00002/00002-06/00002-06-07/look at the flowers.mp3": [
		3662,
		7,
		2337
	],
	"./00002/00002-06/00002-06-07/look at the frogs.mp3": [
		3663,
		7,
		2338
	],
	"./00002/00002-06/00002-06-07/main idea.mp3": [
		918,
		7
	],
	"./00002/00002-06/00002-06-07/module": [
		1334,
		9,
		198
	],
	"./00002/00002-06/00002-06-07/module.js": [
		1334,
		9,
		198
	],
	"./00002/00002-06/00002-06-07/water.mp3": [
		3664,
		7,
		2339
	],
	"./00002/00002-06/00002-06-08/0.jpg": [
		6886,
		7,
		5563
	],
	"./00002/00002-06/00002-06-08/1.jpg": [
		8749,
		7,
		8771
	],
	"./00002/00002-06/00002-06-08/2.jpg": [
		8750,
		7,
		8772
	],
	"./00002/00002-06/00002-06-08/3.jpg": [
		8751,
		7,
		8773
	],
	"./00002/00002-06/00002-06-08/4.jpg": [
		8752,
		7,
		8774
	],
	"./00002/00002-06/00002-06-08/5.jpg": [
		8753,
		7,
		8775
	],
	"./00002/00002-06/00002-06-08/6.jpg": [
		8754,
		7,
		8776
	],
	"./00002/00002-06/00002-06-08/7.jpg": [
		8755,
		7,
		8777
	],
	"./00002/00002-06/00002-06-08/grow seeds grow.mp3": [
		3665,
		7,
		2340
	],
	"./00002/00002-06/00002-06-08/i can see the apples.mp3": [
		3666,
		7,
		2341
	],
	"./00002/00002-06/00002-06-08/i can see the branch.mp3": [
		3667,
		7,
		2342
	],
	"./00002/00002-06/00002-06-08/i can see the flowers.mp3": [
		3668,
		7,
		2343
	],
	"./00002/00002-06/00002-06-08/i can see the leaves.mp3": [
		3669,
		7,
		2344
	],
	"./00002/00002-06/00002-06-08/i can see the roots.mp3": [
		3670,
		7,
		2345
	],
	"./00002/00002-06/00002-06-08/i can see the seeds.mp3": [
		3671,
		7,
		2346
	],
	"./00002/00002-06/00002-06-08/i can see the stem.mp3": [
		3672,
		7,
		2347
	],
	"./00002/00002-06/00002-06-08/intro.mp3": [
		538,
		7
	],
	"./00002/00002-06/00002-06-08/look at the apples.mp3": [
		3673,
		7,
		2348
	],
	"./00002/00002-06/00002-06-08/look at the branch.mp3": [
		3674,
		7,
		2349
	],
	"./00002/00002-06/00002-06-08/look at the flowers.mp3": [
		3675,
		7,
		2350
	],
	"./00002/00002-06/00002-06-08/look at the leaves.mp3": [
		3676,
		7,
		2351
	],
	"./00002/00002-06/00002-06-08/look at the roots.mp3": [
		3677,
		7,
		2352
	],
	"./00002/00002-06/00002-06-08/look at the seeds.mp3": [
		3678,
		7,
		2353
	],
	"./00002/00002-06/00002-06-08/look at the stem.mp3": [
		3679,
		7,
		2354
	],
	"./00002/00002-06/00002-06-08/main idea.mp3": [
		919,
		7
	],
	"./00002/00002-06/00002-06-08/module": [
		1335,
		9,
		199
	],
	"./00002/00002-06/00002-06-08/module.js": [
		1335,
		9,
		199
	],
	"./00002/00002-06/00002-06-08/things that grow on trees.mp3": [
		3680,
		7,
		2355
	],
	"./00002/00002-06/00002-06-09/0.jpg": [
		6887,
		7,
		5564
	],
	"./00002/00002-06/00002-06-09/1.jpg": [
		8756,
		7,
		8778
	],
	"./00002/00002-06/00002-06-09/2.jpg": [
		8757,
		7,
		8779
	],
	"./00002/00002-06/00002-06-09/3.jpg": [
		8758,
		7,
		8780
	],
	"./00002/00002-06/00002-06-09/4.jpg": [
		8759,
		7,
		8781
	],
	"./00002/00002-06/00002-06-09/5.jpg": [
		8760,
		7,
		8782
	],
	"./00002/00002-06/00002-06-09/6.jpg": [
		8761,
		7,
		8783
	],
	"./00002/00002-06/00002-06-09/7.jpg": [
		8762,
		7,
		8784
	],
	"./00002/00002-06/00002-06-09/baby animals.mp3": [
		3681,
		7,
		2356
	],
	"./00002/00002-06/00002-06-09/i love my dad.mp3": [
		3682,
		7,
		2357
	],
	"./00002/00002-06/00002-06-09/intro.mp3": [
		539,
		7
	],
	"./00002/00002-06/00002-06-09/look at my dad.mp3": [
		3683,
		7,
		2358
	],
	"./00002/00002-06/00002-06-09/look at us.mp3": [
		3684,
		7,
		2359
	],
	"./00002/00002-06/00002-06-09/main idea.mp3": [
		920,
		7
	],
	"./00002/00002-06/00002-06-09/module": [
		1336,
		9,
		200
	],
	"./00002/00002-06/00002-06-09/module.js": [
		1336,
		9,
		200
	],
	"./00002/00002-06/00002-06-09/my dad is a deer.mp3": [
		3685,
		7,
		2360
	],
	"./00002/00002-06/00002-06-09/my dad is a dinosaur.mp3": [
		3686,
		7,
		2361
	],
	"./00002/00002-06/00002-06-09/my dad is a dog.mp3": [
		3687,
		7,
		2362
	],
	"./00002/00002-06/00002-06-09/my dad is a pig.mp3": [
		3688,
		7,
		2363
	],
	"./00002/00002-06/00002-06-09/my dad is a rooster.mp3": [
		3689,
		7,
		2364
	],
	"./00002/00002-06/00002-06-09/my dad is a seahorse.mp3": [
		3690,
		7,
		2365
	],
	"./00002/00002-06/00002-06-09/my dad is an elephant.mp3": [
		3691,
		7,
		2366
	],
	"./00002/00002-06/00002-06-10/0.jpg": [
		6888,
		7,
		5565
	],
	"./00002/00002-06/00002-06-10/1.jpg": [
		8763,
		7,
		8785
	],
	"./00002/00002-06/00002-06-10/2.jpg": [
		8764,
		7,
		8786
	],
	"./00002/00002-06/00002-06-10/3.jpg": [
		8765,
		7,
		8787
	],
	"./00002/00002-06/00002-06-10/4.jpg": [
		8766,
		7,
		8788
	],
	"./00002/00002-06/00002-06-10/5.jpg": [
		8767,
		7,
		8789
	],
	"./00002/00002-06/00002-06-10/6.jpg": [
		8768,
		7,
		8790
	],
	"./00002/00002-06/00002-06-10/7.jpg": [
		8769,
		7,
		8791
	],
	"./00002/00002-06/00002-06-10/can you see 3 boats.mp3": [
		3692,
		7,
		2367
	],
	"./00002/00002-06/00002-06-10/can you see 3 boxes.mp3": [
		3693,
		7,
		2368
	],
	"./00002/00002-06/00002-06-10/can you see 3 cakes.mp3": [
		3694,
		7,
		2369
	],
	"./00002/00002-06/00002-06-10/can you see 3 foxes.mp3": [
		3695,
		7,
		2370
	],
	"./00002/00002-06/00002-06-10/can you see 3 frogs.mp3": [
		3696,
		7,
		2371
	],
	"./00002/00002-06/00002-06-10/can you see 3 goats.mp3": [
		3697,
		7,
		2372
	],
	"./00002/00002-06/00002-06-10/can you see 3 hats.mp3": [
		3698,
		7,
		2373
	],
	"./00002/00002-06/00002-06-10/can you see 3 kittens.mp3": [
		3699,
		7,
		2374
	],
	"./00002/00002-06/00002-06-10/can you see 3 logs.mp3": [
		3700,
		7,
		2375
	],
	"./00002/00002-06/00002-06-10/can you see 3 mittens.mp3": [
		3701,
		7,
		2376
	],
	"./00002/00002-06/00002-06-10/can you see 3 nails.mp3": [
		3702,
		7,
		2377
	],
	"./00002/00002-06/00002-06-10/can you see 3 rats.mp3": [
		3703,
		7,
		2378
	],
	"./00002/00002-06/00002-06-10/can you see 3 snails.mp3": [
		3704,
		7,
		2379
	],
	"./00002/00002-06/00002-06-10/can you see 3 snakes.mp3": [
		3705,
		7,
		2380
	],
	"./00002/00002-06/00002-06-10/do they grow.mp3": [
		3706,
		7,
		2381
	],
	"./00002/00002-06/00002-06-10/intro.mp3": [
		540,
		7
	],
	"./00002/00002-06/00002-06-10/living things.mp3": [
		3707,
		7,
		2382
	],
	"./00002/00002-06/00002-06-10/main idea.mp3": [
		921,
		7
	],
	"./00002/00002-06/00002-06-10/module": [
		1337,
		9,
		201
	],
	"./00002/00002-06/00002-06-10/module.js": [
		1337,
		9,
		201
	],
	"./00002/00002-06/00002-06-10/non living things.mp3": [
		3708,
		7,
		2383
	],
	"./00002/00002-06/00002-06-10/the foxes grow.mp3": [
		3709,
		7,
		2384
	],
	"./00002/00002-06/00002-06-10/the frogs grow.mp3": [
		3710,
		7,
		2385
	],
	"./00002/00002-06/00002-06-10/the goats grow.mp3": [
		3711,
		7,
		2386
	],
	"./00002/00002-06/00002-06-10/the kittens grow.mp3": [
		3712,
		7,
		2387
	],
	"./00002/00002-06/00002-06-10/the rats grow.mp3": [
		3713,
		7,
		2388
	],
	"./00002/00002-06/00002-06-10/the snails grow.mp3": [
		3714,
		7,
		2389
	],
	"./00002/00002-06/00002-06-10/the snakes grow.mp3": [
		3715,
		7,
		2390
	],
	"./00002/00002-06/cover.jpg": [
		6889,
		7,
		5566
	],
	"./00002/00002-06/life science.mp3": [
		3716,
		7,
		2391
	],
	"./00002/00002-06/unit": [
		1338,
		9,
		202
	],
	"./00002/00002-06/unit.js": [
		1338,
		9,
		202
	],
	"./00002/00002-07/00002-07-01/0.jpg": [
		6890,
		7,
		5567
	],
	"./00002/00002-07/00002-07-01/1.jpg": [
		8770,
		7,
		8792
	],
	"./00002/00002-07/00002-07-01/2.jpg": [
		8771,
		7,
		8793
	],
	"./00002/00002-07/00002-07-01/3.jpg": [
		8772,
		7,
		8794
	],
	"./00002/00002-07/00002-07-01/4.jpg": [
		8773,
		7,
		8795
	],
	"./00002/00002-07/00002-07-01/5.jpg": [
		8774,
		7,
		8796
	],
	"./00002/00002-07/00002-07-01/6.jpg": [
		8775,
		7,
		8797
	],
	"./00002/00002-07/00002-07-01/7.jpg": [
		8776,
		7,
		8798
	],
	"./00002/00002-07/00002-07-01/big and little.mp3": [
		3717,
		7,
		2392
	],
	"./00002/00002-07/00002-07-01/intro.mp3": [
		541,
		7
	],
	"./00002/00002-07/00002-07-01/main idea.mp3": [
		922,
		7
	],
	"./00002/00002-07/00002-07-01/module": [
		1339,
		9,
		203
	],
	"./00002/00002-07/00002-07-01/module.js": [
		1339,
		9,
		203
	],
	"./00002/00002-07/00002-07-01/my bus is little.mp3": [
		3718,
		7,
		2393
	],
	"./00002/00002-07/00002-07-01/my car is little.mp3": [
		3719,
		7,
		2394
	],
	"./00002/00002-07/00002-07-01/my dump truck is little.mp3": [
		3720,
		7,
		2395
	],
	"./00002/00002-07/00002-07-01/my fire truck is little.mp3": [
		3721,
		7,
		2396
	],
	"./00002/00002-07/00002-07-01/my green monster is little.mp3": [
		3722,
		7,
		2397
	],
	"./00002/00002-07/00002-07-01/my helicopter is little.mp3": [
		3723,
		7,
		2398
	],
	"./00002/00002-07/00002-07-01/my plane is little.mp3": [
		3724,
		7,
		2399
	],
	"./00002/00002-07/00002-07-01/my red monster is big.mp3": [
		3725,
		7,
		2400
	],
	"./00002/00002-07/00002-07-01/this bus is big.mp3": [
		3726,
		7,
		2401
	],
	"./00002/00002-07/00002-07-01/this car is big.mp3": [
		3727,
		7,
		2402
	],
	"./00002/00002-07/00002-07-01/this dump truck is big.mp3": [
		3728,
		7,
		2403
	],
	"./00002/00002-07/00002-07-01/this fire truck is big.mp3": [
		3729,
		7,
		2404
	],
	"./00002/00002-07/00002-07-01/this helicopter is big.mp3": [
		3730,
		7,
		2405
	],
	"./00002/00002-07/00002-07-01/this plane is big.mp3": [
		3731,
		7,
		2406
	],
	"./00002/00002-07/00002-07-01/vehicles.mp3": [
		3732,
		7,
		2407
	],
	"./00002/00002-07/00002-07-02/0.jpg": [
		6891,
		7,
		5568
	],
	"./00002/00002-07/00002-07-02/1.jpg": [
		8777,
		7,
		8799
	],
	"./00002/00002-07/00002-07-02/2.jpg": [
		8778,
		7,
		8800
	],
	"./00002/00002-07/00002-07-02/3.jpg": [
		8779,
		7,
		8801
	],
	"./00002/00002-07/00002-07-02/4.jpg": [
		8780,
		7,
		8802
	],
	"./00002/00002-07/00002-07-02/5.jpg": [
		8781,
		7,
		8803
	],
	"./00002/00002-07/00002-07-02/6.jpg": [
		8782,
		7,
		8804
	],
	"./00002/00002-07/00002-07-02/7.jpg": [
		8783,
		7,
		8805
	],
	"./00002/00002-07/00002-07-02/electricity.mp3": [
		3733,
		7,
		2408
	],
	"./00002/00002-07/00002-07-02/intro.mp3": [
		542,
		7
	],
	"./00002/00002-07/00002-07-02/look at the computer.mp3": [
		3734,
		7,
		2409
	],
	"./00002/00002-07/00002-07-02/look at the fan.mp3": [
		3735,
		7,
		2410
	],
	"./00002/00002-07/00002-07-02/look at the fridge.mp3": [
		3736,
		7,
		2411
	],
	"./00002/00002-07/00002-07-02/look at the guitar.mp3": [
		3737,
		7,
		2412
	],
	"./00002/00002-07/00002-07-02/look at the light.mp3": [
		3738,
		7,
		2413
	],
	"./00002/00002-07/00002-07-02/look at the stove.mp3": [
		3739,
		7,
		2414
	],
	"./00002/00002-07/00002-07-02/look at the television.mp3": [
		3740,
		7,
		2415
	],
	"./00002/00002-07/00002-07-02/main idea.mp3": [
		923,
		7
	],
	"./00002/00002-07/00002-07-02/module": [
		1340,
		9,
		204
	],
	"./00002/00002-07/00002-07-02/module.js": [
		1340,
		9,
		204
	],
	"./00002/00002-07/00002-07-02/the computer uses electricity.mp3": [
		3741,
		7,
		2416
	],
	"./00002/00002-07/00002-07-02/the fan uses electricity.mp3": [
		3742,
		7,
		2417
	],
	"./00002/00002-07/00002-07-02/the fridge uses electricity.mp3": [
		3743,
		7,
		2418
	],
	"./00002/00002-07/00002-07-02/the guitar uses electricity.mp3": [
		3744,
		7,
		2419
	],
	"./00002/00002-07/00002-07-02/the light uses electricity.mp3": [
		3745,
		7,
		2420
	],
	"./00002/00002-07/00002-07-02/the stove uses electricity.mp3": [
		3746,
		7,
		2421
	],
	"./00002/00002-07/00002-07-02/the television uses electricity.mp3": [
		3747,
		7,
		2422
	],
	"./00002/00002-07/00002-07-02/things that use electricity.mp3": [
		3748,
		7,
		2423
	],
	"./00002/00002-07/00002-07-03/0.jpg": [
		6892,
		7,
		5569
	],
	"./00002/00002-07/00002-07-03/1.jpg": [
		8784,
		7,
		8806
	],
	"./00002/00002-07/00002-07-03/2.jpg": [
		8785,
		7,
		8807
	],
	"./00002/00002-07/00002-07-03/3.jpg": [
		8786,
		7,
		8808
	],
	"./00002/00002-07/00002-07-03/4.jpg": [
		8787,
		7,
		8809
	],
	"./00002/00002-07/00002-07-03/5.jpg": [
		8788,
		7,
		8810
	],
	"./00002/00002-07/00002-07-03/6.jpg": [
		8789,
		7,
		8811
	],
	"./00002/00002-07/00002-07-03/7.jpg": [
		8790,
		7,
		8812
	],
	"./00002/00002-07/00002-07-03/bear is playing the guitar.mp3": [
		3749,
		7,
		2424
	],
	"./00002/00002-07/00002-07-03/beaver is playing the xylophone.mp3": [
		3750,
		7,
		2425
	],
	"./00002/00002-07/00002-07-03/donkey is playing the harp.mp3": [
		3751,
		7,
		2426
	],
	"./00002/00002-07/00002-07-03/elephant is playing the cymbals.mp3": [
		3752,
		7,
		2427
	],
	"./00002/00002-07/00002-07-03/giraffe is playing the piano.mp3": [
		3753,
		7,
		2428
	],
	"./00002/00002-07/00002-07-03/intro.mp3": [
		543,
		7
	],
	"./00002/00002-07/00002-07-03/loud and soft.mp3": [
		3754,
		7,
		2429
	],
	"./00002/00002-07/00002-07-03/main idea.mp3": [
		924,
		7
	],
	"./00002/00002-07/00002-07-03/module": [
		1341,
		9,
		205
	],
	"./00002/00002-07/00002-07-03/module.js": [
		1341,
		9,
		205
	],
	"./00002/00002-07/00002-07-03/monkey is playing the triangle.mp3": [
		3755,
		7,
		2430
	],
	"./00002/00002-07/00002-07-03/musical instruments.mp3": [
		3756,
		7,
		2431
	],
	"./00002/00002-07/00002-07-03/rabbit is playing the drum.mp3": [
		3757,
		7,
		2432
	],
	"./00002/00002-07/00002-07-03/the cymbals are loud.mp3": [
		3758,
		7,
		2433
	],
	"./00002/00002-07/00002-07-03/the drum is loud.mp3": [
		3759,
		7,
		2434
	],
	"./00002/00002-07/00002-07-03/the guitar is loud.mp3": [
		3760,
		7,
		2435
	],
	"./00002/00002-07/00002-07-03/the harp is soft.mp3": [
		3761,
		7,
		2436
	],
	"./00002/00002-07/00002-07-03/the piano is loud.mp3": [
		3762,
		7,
		2437
	],
	"./00002/00002-07/00002-07-03/the triangle is soft.mp3": [
		3763,
		7,
		2438
	],
	"./00002/00002-07/00002-07-03/the xylophone is soft.mp3": [
		3764,
		7,
		2439
	],
	"./00002/00002-07/00002-07-04/0.jpg": [
		6893,
		7,
		5570
	],
	"./00002/00002-07/00002-07-04/1.jpg": [
		8791,
		7,
		8813
	],
	"./00002/00002-07/00002-07-04/2.jpg": [
		8792,
		7,
		8814
	],
	"./00002/00002-07/00002-07-04/3.jpg": [
		8793,
		7,
		8815
	],
	"./00002/00002-07/00002-07-04/4.jpg": [
		8794,
		7,
		8816
	],
	"./00002/00002-07/00002-07-04/5.jpg": [
		8795,
		7,
		8817
	],
	"./00002/00002-07/00002-07-04/6.jpg": [
		8796,
		7,
		8818
	],
	"./00002/00002-07/00002-07-04/7.jpg": [
		8797,
		7,
		8819
	],
	"./00002/00002-07/00002-07-04/deer goes up in the pulley.mp3": [
		3765,
		7,
		2440
	],
	"./00002/00002-07/00002-07-04/elephant goes down in the pulley.mp3": [
		3766,
		7,
		2441
	],
	"./00002/00002-07/00002-07-04/elephant goes up in the pulley.mp3": [
		3767,
		7,
		2442
	],
	"./00002/00002-07/00002-07-04/intro.mp3": [
		544,
		7
	],
	"./00002/00002-07/00002-07-04/lion goes up in the pulley.mp3": [
		3768,
		7,
		2443
	],
	"./00002/00002-07/00002-07-04/main idea.mp3": [
		925,
		7
	],
	"./00002/00002-07/00002-07-04/module": [
		1342,
		9,
		206
	],
	"./00002/00002-07/00002-07-04/module.js": [
		1342,
		9,
		206
	],
	"./00002/00002-07/00002-07-04/panda goes up in the pulley.mp3": [
		3769,
		7,
		2444
	],
	"./00002/00002-07/00002-07-04/skunk goes up in the pulley.mp3": [
		3770,
		7,
		2445
	],
	"./00002/00002-07/00002-07-04/squirrel lets go.mp3": [
		3771,
		7,
		2446
	],
	"./00002/00002-07/00002-07-04/squirrel pulls hard.mp3": [
		3772,
		7,
		2447
	],
	"./00002/00002-07/00002-07-04/tiger goes up in the pulley.mp3": [
		3773,
		7,
		2448
	],
	"./00002/00002-07/00002-07-04/up in the pulley.mp3": [
		3774,
		7,
		2449
	],
	"./00002/00002-07/00002-07-04/wild animals.mp3": [
		3775,
		7,
		2450
	],
	"./00002/00002-07/00002-07-05/0.jpg": [
		6894,
		7,
		5571
	],
	"./00002/00002-07/00002-07-05/1.jpg": [
		8798,
		7,
		8820
	],
	"./00002/00002-07/00002-07-05/2.jpg": [
		8799,
		7,
		8821
	],
	"./00002/00002-07/00002-07-05/3.jpg": [
		8800,
		7,
		8822
	],
	"./00002/00002-07/00002-07-05/4.jpg": [
		8801,
		7,
		8823
	],
	"./00002/00002-07/00002-07-05/5.jpg": [
		8802,
		7,
		8824
	],
	"./00002/00002-07/00002-07-05/6.jpg": [
		8803,
		7,
		8825
	],
	"./00002/00002-07/00002-07-05/7.jpg": [
		8804,
		7,
		8826
	],
	"./00002/00002-07/00002-07-05/intro.mp3": [
		545,
		7
	],
	"./00002/00002-07/00002-07-05/main idea.mp3": [
		926,
		7
	],
	"./00002/00002-07/00002-07-05/module": [
		1343,
		9,
		207
	],
	"./00002/00002-07/00002-07-05/module.js": [
		1343,
		9,
		207
	],
	"./00002/00002-07/00002-07-05/no.mp3": [
		3776,
		7,
		2451
	],
	"./00002/00002-07/00002-07-05/the ball will move.mp3": [
		3777,
		7,
		2452
	],
	"./00002/00002-07/00002-07-05/the car will move.mp3": [
		3778,
		7,
		2453
	],
	"./00002/00002-07/00002-07-05/the swing will move.mp3": [
		3779,
		7,
		2454
	],
	"./00002/00002-07/00002-07-05/the swing will not move.mp3": [
		3780,
		7,
		2455
	],
	"./00002/00002-07/00002-07-05/the truck will move.mp3": [
		3781,
		7,
		2456
	],
	"./00002/00002-07/00002-07-05/the truck will not move.mp3": [
		3782,
		7,
		2457
	],
	"./00002/00002-07/00002-07-05/toys.mp3": [
		3783,
		7,
		2458
	],
	"./00002/00002-07/00002-07-05/will it move.mp3": [
		3784,
		7,
		2459
	],
	"./00002/00002-07/00002-07-05/yes.mp3": [
		3785,
		7,
		2460
	],
	"./00002/00002-07/00002-07-06/0.jpg": [
		6895,
		7,
		5572
	],
	"./00002/00002-07/00002-07-06/1.jpg": [
		8805,
		7,
		8827
	],
	"./00002/00002-07/00002-07-06/2.jpg": [
		8806,
		7,
		8828
	],
	"./00002/00002-07/00002-07-06/3.jpg": [
		8807,
		7,
		8829
	],
	"./00002/00002-07/00002-07-06/4.jpg": [
		8808,
		7,
		8830
	],
	"./00002/00002-07/00002-07-06/5.jpg": [
		8809,
		7,
		8831
	],
	"./00002/00002-07/00002-07-06/6.jpg": [
		8810,
		7,
		8832
	],
	"./00002/00002-07/00002-07-06/7.jpg": [
		8811,
		7,
		8833
	],
	"./00002/00002-07/00002-07-06/i can see the nail.mp3": [
		3786,
		7,
		2461
	],
	"./00002/00002-07/00002-07-06/intro.mp3": [
		546,
		7
	],
	"./00002/00002-07/00002-07-06/look at the apple.mp3": [
		3787,
		7,
		2462
	],
	"./00002/00002-07/00002-07-06/look at the ball.mp3": [
		3788,
		7,
		2463
	],
	"./00002/00002-07/00002-07-06/look at the boat.mp3": [
		3789,
		7,
		2464
	],
	"./00002/00002-07/00002-07-06/look at the cube.mp3": [
		3790,
		7,
		2465
	],
	"./00002/00002-07/00002-07-06/look at the duck.mp3": [
		3791,
		7,
		2466
	],
	"./00002/00002-07/00002-07-06/look at the key.mp3": [
		3792,
		7,
		2467
	],
	"./00002/00002-07/00002-07-06/look.mp3": [
		3793,
		7,
		2468
	],
	"./00002/00002-07/00002-07-06/main idea.mp3": [
		927,
		7
	],
	"./00002/00002-07/00002-07-06/module": [
		1344,
		9,
		208
	],
	"./00002/00002-07/00002-07-06/module.js": [
		1344,
		9,
		208
	],
	"./00002/00002-07/00002-07-06/the apple floats.mp3": [
		3794,
		7,
		2469
	],
	"./00002/00002-07/00002-07-06/the ball floats.mp3": [
		3795,
		7,
		2470
	],
	"./00002/00002-07/00002-07-06/the boat floats.mp3": [
		3796,
		7,
		2471
	],
	"./00002/00002-07/00002-07-06/the cube floats.mp3": [
		3797,
		7,
		2472
	],
	"./00002/00002-07/00002-07-06/the duck floats too.mp3": [
		3798,
		7,
		2473
	],
	"./00002/00002-07/00002-07-06/the key sinks.mp3": [
		3799,
		7,
		2474
	],
	"./00002/00002-07/00002-07-06/the nail sinks.mp3": [
		3800,
		7,
		2475
	],
	"./00002/00002-07/00002-07-06/things that float.mp3": [
		3801,
		7,
		2476
	],
	"./00002/00002-07/00002-07-06/will it float.mp3": [
		3802,
		7,
		2477
	],
	"./00002/00002-07/00002-07-06/will it sink.mp3": [
		3803,
		7,
		2478
	],
	"./00002/00002-07/00002-07-07/0.jpg": [
		6896,
		7,
		5573
	],
	"./00002/00002-07/00002-07-07/1.jpg": [
		8812,
		7,
		8834
	],
	"./00002/00002-07/00002-07-07/2.jpg": [
		8813,
		7,
		8835
	],
	"./00002/00002-07/00002-07-07/3.jpg": [
		8814,
		7,
		8836
	],
	"./00002/00002-07/00002-07-07/4.jpg": [
		8815,
		7,
		8837
	],
	"./00002/00002-07/00002-07-07/5.jpg": [
		8816,
		7,
		8838
	],
	"./00002/00002-07/00002-07-07/6.jpg": [
		8817,
		7,
		8839
	],
	"./00002/00002-07/00002-07-07/7.jpg": [
		8818,
		7,
		8840
	],
	"./00002/00002-07/00002-07-07/fishing with a magnet.mp3": [
		3804,
		7,
		2479
	],
	"./00002/00002-07/00002-07-07/intro.mp3": [
		547,
		7
	],
	"./00002/00002-07/00002-07-07/look at the chipmunk.mp3": [
		3805,
		7,
		2480
	],
	"./00002/00002-07/00002-07-07/look at the deer.mp3": [
		3806,
		7,
		2481
	],
	"./00002/00002-07/00002-07-07/look at the fox.mp3": [
		3807,
		7,
		2482
	],
	"./00002/00002-07/00002-07-07/look at the lion.mp3": [
		3808,
		7,
		2483
	],
	"./00002/00002-07/00002-07-07/look at the sheep.mp3": [
		3809,
		7,
		2484
	],
	"./00002/00002-07/00002-07-07/look at the squirrel.mp3": [
		3810,
		7,
		2485
	],
	"./00002/00002-07/00002-07-07/look at the tiger.mp3": [
		3811,
		7,
		2486
	],
	"./00002/00002-07/00002-07-07/made.mp3": [
		3812,
		7,
		2487
	],
	"./00002/00002-07/00002-07-07/magnet.mp3": [
		3813,
		7,
		2488
	],
	"./00002/00002-07/00002-07-07/magnets.mp3": [
		3814,
		7,
		2489
	],
	"./00002/00002-07/00002-07-07/main idea.mp3": [
		928,
		7
	],
	"./00002/00002-07/00002-07-07/metal.mp3": [
		3815,
		7,
		2490
	],
	"./00002/00002-07/00002-07-07/module": [
		1345,
		9,
		209
	],
	"./00002/00002-07/00002-07-07/module.js": [
		1345,
		9,
		209
	],
	"./00002/00002-07/00002-07-07/the chipmunk got a nail.mp3": [
		3816,
		7,
		2491
	],
	"./00002/00002-07/00002-07-07/the deer got a helicopter.mp3": [
		3817,
		7,
		2492
	],
	"./00002/00002-07/00002-07-07/the fox got a magnet.mp3": [
		3818,
		7,
		2493
	],
	"./00002/00002-07/00002-07-07/the lion got a rocket.mp3": [
		3819,
		7,
		2494
	],
	"./00002/00002-07/00002-07-07/the sheep got an anchor.mp3": [
		3820,
		7,
		2495
	],
	"./00002/00002-07/00002-07-07/the squirrel got a ball.mp3": [
		3821,
		7,
		2496
	],
	"./00002/00002-07/00002-07-07/the tiger got a car.mp3": [
		3822,
		7,
		2497
	],
	"./00002/00002-07/00002-07-07/things made of metal.mp3": [
		3823,
		7,
		2498
	],
	"./00002/00002-07/00002-07-08/0.jpg": [
		6897,
		7,
		5574
	],
	"./00002/00002-07/00002-07-08/1.jpg": [
		8819,
		7,
		8841
	],
	"./00002/00002-07/00002-07-08/2.jpg": [
		8820,
		7,
		8842
	],
	"./00002/00002-07/00002-07-08/3.jpg": [
		8821,
		7,
		8843
	],
	"./00002/00002-07/00002-07-08/4.jpg": [
		8822,
		7,
		8844
	],
	"./00002/00002-07/00002-07-08/5.jpg": [
		8823,
		7,
		8845
	],
	"./00002/00002-07/00002-07-08/6.jpg": [
		8824,
		7,
		8846
	],
	"./00002/00002-07/00002-07-08/7.jpg": [
		8825,
		7,
		8847
	],
	"./00002/00002-07/00002-07-08/intro.mp3": [
		548,
		7
	],
	"./00002/00002-07/00002-07-08/main idea.mp3": [
		929,
		7
	],
	"./00002/00002-07/00002-07-08/module": [
		1346,
		9,
		210
	],
	"./00002/00002-07/00002-07-08/module.js": [
		1346,
		9,
		210
	],
	"./00002/00002-07/00002-07-08/the bus has 6 wheels.mp3": [
		3824,
		7,
		2499
	],
	"./00002/00002-07/00002-07-08/the car has 4 wheels.mp3": [
		3825,
		7,
		2500
	],
	"./00002/00002-07/00002-07-08/the car truck has 4 wheels.mp3": [
		3826,
		7,
		2501
	],
	"./00002/00002-07/00002-07-08/the dump truck has 4 wheels.mp3": [
		3827,
		7,
		2502
	],
	"./00002/00002-07/00002-07-08/the motorcycle has 2 wheels.mp3": [
		3828,
		7,
		2503
	],
	"./00002/00002-07/00002-07-08/the plane has 3 wheels.mp3": [
		3829,
		7,
		2504
	],
	"./00002/00002-07/00002-07-08/the train has 8 wheels.mp3": [
		3830,
		7,
		2505
	],
	"./00002/00002-07/00002-07-08/the unicycle has 1 wheel.mp3": [
		3831,
		7,
		2506
	],
	"./00002/00002-07/00002-07-08/vehicles.mp3": [
		3832,
		7,
		2507
	],
	"./00002/00002-07/00002-07-08/wheels make things go.mp3": [
		3833,
		7,
		2508
	],
	"./00002/00002-07/00002-07-08/wheels.mp3": [
		3834,
		7,
		2509
	],
	"./00002/00002-07/00002-07-09/0.jpg": [
		6898,
		7,
		5575
	],
	"./00002/00002-07/00002-07-09/1.jpg": [
		8826,
		7,
		8848
	],
	"./00002/00002-07/00002-07-09/2.jpg": [
		8827,
		7,
		8849
	],
	"./00002/00002-07/00002-07-09/3.jpg": [
		8828,
		7,
		8850
	],
	"./00002/00002-07/00002-07-09/4.jpg": [
		8829,
		7,
		8851
	],
	"./00002/00002-07/00002-07-09/5.jpg": [
		8830,
		7,
		8852
	],
	"./00002/00002-07/00002-07-09/6.jpg": [
		8831,
		7,
		8853
	],
	"./00002/00002-07/00002-07-09/7.jpg": [
		8832,
		7,
		8854
	],
	"./00002/00002-07/00002-07-09/intro.mp3": [
		549,
		7
	],
	"./00002/00002-07/00002-07-09/is it cold.mp3": [
		3835,
		7,
		2510
	],
	"./00002/00002-07/00002-07-09/is it hot is it cold.mp3": [
		3836,
		7,
		2511
	],
	"./00002/00002-07/00002-07-09/is it hot or cold.mp3": [
		3837,
		7,
		2512
	],
	"./00002/00002-07/00002-07-09/is it hot.mp3": [
		3838,
		7,
		2513
	],
	"./00002/00002-07/00002-07-09/main idea.mp3": [
		930,
		7
	],
	"./00002/00002-07/00002-07-09/module": [
		1347,
		9,
		211
	],
	"./00002/00002-07/00002-07-09/module.js": [
		1347,
		9,
		211
	],
	"./00002/00002-07/00002-07-09/non living things.mp3": [
		3839,
		7,
		2514
	],
	"./00002/00002-07/00002-07-09/saturn is cold.mp3": [
		3840,
		7,
		2515
	],
	"./00002/00002-07/00002-07-09/the fire is hot.mp3": [
		3841,
		7,
		2516
	],
	"./00002/00002-07/00002-07-09/the fridge is cold.mp3": [
		3842,
		7,
		2517
	],
	"./00002/00002-07/00002-07-09/the iceberg is cold.mp3": [
		3843,
		7,
		2518
	],
	"./00002/00002-07/00002-07-09/the stove is hot.mp3": [
		3844,
		7,
		2519
	],
	"./00002/00002-07/00002-07-09/the sun is hot.mp3": [
		3845,
		7,
		2520
	],
	"./00002/00002-07/00002-07-09/the volcano is hot.mp3": [
		3846,
		7,
		2521
	],
	"./00002/00002-07/00002-07-10/0.jpg": [
		6899,
		7,
		5576
	],
	"./00002/00002-07/00002-07-10/1.jpg": [
		8833,
		7,
		8855
	],
	"./00002/00002-07/00002-07-10/2.jpg": [
		8834,
		7,
		8856
	],
	"./00002/00002-07/00002-07-10/3.jpg": [
		8835,
		7,
		8857
	],
	"./00002/00002-07/00002-07-10/4.jpg": [
		8836,
		7,
		8858
	],
	"./00002/00002-07/00002-07-10/5.jpg": [
		8837,
		7,
		8859
	],
	"./00002/00002-07/00002-07-10/6.jpg": [
		8838,
		7,
		8860
	],
	"./00002/00002-07/00002-07-10/7.jpg": [
		8839,
		7,
		8861
	],
	"./00002/00002-07/00002-07-10/big things.mp3": [
		3847,
		7,
		2522
	],
	"./00002/00002-07/00002-07-10/here comes the fire truck.mp3": [
		3848,
		7,
		2523
	],
	"./00002/00002-07/00002-07-10/here comes the plane.mp3": [
		3849,
		7,
		2524
	],
	"./00002/00002-07/00002-07-10/here is a dump truck.mp3": [
		3850,
		7,
		2525
	],
	"./00002/00002-07/00002-07-10/here is a helicopter.mp3": [
		3851,
		7,
		2526
	],
	"./00002/00002-07/00002-07-10/here is a monster.mp3": [
		3852,
		7,
		2527
	],
	"./00002/00002-07/00002-07-10/intro.mp3": [
		550,
		7
	],
	"./00002/00002-07/00002-07-10/main idea.mp3": [
		931,
		7
	],
	"./00002/00002-07/00002-07-10/module": [
		1348,
		9,
		212
	],
	"./00002/00002-07/00002-07-10/module.js": [
		1348,
		9,
		212
	],
	"./00002/00002-07/00002-07-10/this bus is big.mp3": [
		3853,
		7,
		2528
	],
	"./00002/00002-07/00002-07-10/this car is big.mp3": [
		3854,
		7,
		2529
	],
	"./00002/00002-07/00002-07-10/this dinosaur is huge.mp3": [
		3855,
		7,
		2530
	],
	"./00002/00002-07/00002-07-10/this dump truck is big.mp3": [
		3856,
		7,
		2531
	],
	"./00002/00002-07/00002-07-10/this fire truck is big.mp3": [
		3857,
		7,
		2532
	],
	"./00002/00002-07/00002-07-10/this giraffe is big.mp3": [
		3858,
		7,
		2533
	],
	"./00002/00002-07/00002-07-10/this helicopter is big.mp3": [
		3859,
		7,
		2534
	],
	"./00002/00002-07/00002-07-10/this monster is big.mp3": [
		3860,
		7,
		2535
	],
	"./00002/00002-07/00002-07-10/this plane is big.mp3": [
		3861,
		7,
		2536
	],
	"./00002/00002-07/00002-07-10/this whale is big.mp3": [
		3862,
		7,
		2537
	],
	"./00002/00002-07/00002-07-10/vehicles.mp3": [
		3863,
		7,
		2538
	],
	"./00002/00002-07/cover.jpg": [
		6900,
		7,
		5577
	],
	"./00002/00002-07/physical science.mp3": [
		3864,
		7,
		2539
	],
	"./00002/00002-07/unit": [
		1349,
		9,
		213
	],
	"./00002/00002-07/unit.js": [
		1349,
		9,
		213
	],
	"./00002/00002-08/00002-08-01/0.jpg": [
		6901,
		7,
		5578
	],
	"./00002/00002-08/00002-08-01/1.jpg": [
		8840,
		7,
		8862
	],
	"./00002/00002-08/00002-08-01/2.jpg": [
		8841,
		7,
		8863
	],
	"./00002/00002-08/00002-08-01/3.jpg": [
		8842,
		7,
		8864
	],
	"./00002/00002-08/00002-08-01/4.jpg": [
		8843,
		7,
		8865
	],
	"./00002/00002-08/00002-08-01/5.jpg": [
		8844,
		7,
		8866
	],
	"./00002/00002-08/00002-08-01/6.jpg": [
		8845,
		7,
		8867
	],
	"./00002/00002-08/00002-08-01/7.jpg": [
		8846,
		7,
		8868
	],
	"./00002/00002-08/00002-08-01/intro.mp3": [
		551,
		7
	],
	"./00002/00002-08/00002-08-01/main idea.mp3": [
		932,
		7
	],
	"./00002/00002-08/00002-08-01/module": [
		1350,
		9,
		214
	],
	"./00002/00002-08/00002-08-01/module.js": [
		1350,
		9,
		214
	],
	"./00002/00002-08/00002-08-01/the animals are on the earth.mp3": [
		3865,
		7,
		2540
	],
	"./00002/00002-08/00002-08-01/the forests are on the earth.mp3": [
		3866,
		7,
		2541
	],
	"./00002/00002-08/00002-08-01/the lakes are on the earth.mp3": [
		3867,
		7,
		2542
	],
	"./00002/00002-08/00002-08-01/the mountains are on the earth.mp3": [
		3868,
		7,
		2543
	],
	"./00002/00002-08/00002-08-01/the rivers are on the earth.mp3": [
		3869,
		7,
		2544
	],
	"./00002/00002-08/00002-08-01/the sea is on the earth.mp3": [
		3870,
		7,
		2545
	],
	"./00002/00002-08/00002-08-01/things on the earth.mp3": [
		3871,
		7,
		2546
	],
	"./00002/00002-08/00002-08-01/we are on the earth too.mp3": [
		3872,
		7,
		2547
	],
	"./00002/00002-08/00002-08-01/we love the animals.mp3": [
		3873,
		7,
		2548
	],
	"./00002/00002-08/00002-08-01/we love the earth.mp3": [
		3874,
		7,
		2549
	],
	"./00002/00002-08/00002-08-01/we love the forests.mp3": [
		3875,
		7,
		2550
	],
	"./00002/00002-08/00002-08-01/we love the lakes.mp3": [
		3876,
		7,
		2551
	],
	"./00002/00002-08/00002-08-01/we love the mountains.mp3": [
		3877,
		7,
		2552
	],
	"./00002/00002-08/00002-08-01/we love the rivers.mp3": [
		3878,
		7,
		2553
	],
	"./00002/00002-08/00002-08-01/we love the sea.mp3": [
		3879,
		7,
		2554
	],
	"./00002/00002-08/00002-08-02/0.jpg": [
		6902,
		7,
		5579
	],
	"./00002/00002-08/00002-08-02/1.jpg": [
		8847,
		7,
		8869
	],
	"./00002/00002-08/00002-08-02/2.jpg": [
		8848,
		7,
		8870
	],
	"./00002/00002-08/00002-08-02/3.jpg": [
		8849,
		7,
		8871
	],
	"./00002/00002-08/00002-08-02/4.jpg": [
		8850,
		7,
		8872
	],
	"./00002/00002-08/00002-08-02/5.jpg": [
		8851,
		7,
		8873
	],
	"./00002/00002-08/00002-08-02/6.jpg": [
		8852,
		7,
		8874
	],
	"./00002/00002-08/00002-08-02/7.jpg": [
		8853,
		7,
		8875
	],
	"./00002/00002-08/00002-08-02/earth is the 3rd planet.mp3": [
		3880,
		7,
		2555
	],
	"./00002/00002-08/00002-08-02/here is jupiter.mp3": [
		3881,
		7,
		2556
	],
	"./00002/00002-08/00002-08-02/here is mars.mp3": [
		3882,
		7,
		2557
	],
	"./00002/00002-08/00002-08-02/here is mercury.mp3": [
		3883,
		7,
		2558
	],
	"./00002/00002-08/00002-08-02/here is saturn.mp3": [
		3884,
		7,
		2559
	],
	"./00002/00002-08/00002-08-02/here is the earth.mp3": [
		3885,
		7,
		2560
	],
	"./00002/00002-08/00002-08-02/here is venus.mp3": [
		3886,
		7,
		2561
	],
	"./00002/00002-08/00002-08-02/intro.mp3": [
		552,
		7
	],
	"./00002/00002-08/00002-08-02/jupiter is the 5th planet.mp3": [
		3887,
		7,
		2562
	],
	"./00002/00002-08/00002-08-02/main idea.mp3": [
		933,
		7
	],
	"./00002/00002-08/00002-08-02/mars is the 4th planet.mp3": [
		3888,
		7,
		2563
	],
	"./00002/00002-08/00002-08-02/mercury is the 1st planet.mp3": [
		3889,
		7,
		2564
	],
	"./00002/00002-08/00002-08-02/module": [
		1351,
		9,
		215
	],
	"./00002/00002-08/00002-08-02/module.js": [
		1351,
		9,
		215
	],
	"./00002/00002-08/00002-08-02/neptune is the 8th planet.mp3": [
		3890,
		7,
		2565
	],
	"./00002/00002-08/00002-08-02/saturn is the 6th planet.mp3": [
		3891,
		7,
		2566
	],
	"./00002/00002-08/00002-08-02/the planets.mp3": [
		3892,
		7,
		2567
	],
	"./00002/00002-08/00002-08-02/things in space.mp3": [
		3893,
		7,
		2568
	],
	"./00002/00002-08/00002-08-02/uranus is the 7th planet.mp3": [
		3894,
		7,
		2569
	],
	"./00002/00002-08/00002-08-02/venus is the 2nd planet.mp3": [
		3895,
		7,
		2570
	],
	"./00002/00002-08/00002-08-02/venus is the second planet.mp3": [
		3896,
		7,
		2571
	],
	"./00002/00002-08/00002-08-03/0.jpg": [
		6903,
		7,
		5580
	],
	"./00002/00002-08/00002-08-03/1.jpg": [
		8854,
		7,
		8876
	],
	"./00002/00002-08/00002-08-03/2.jpg": [
		8855,
		7,
		8877
	],
	"./00002/00002-08/00002-08-03/3.jpg": [
		8856,
		7,
		8878
	],
	"./00002/00002-08/00002-08-03/4.jpg": [
		8857,
		7,
		8879
	],
	"./00002/00002-08/00002-08-03/5.jpg": [
		8858,
		7,
		8880
	],
	"./00002/00002-08/00002-08-03/6.jpg": [
		8859,
		7,
		8881
	],
	"./00002/00002-08/00002-08-03/7.jpg": [
		8860,
		7,
		8882
	],
	"./00002/00002-08/00002-08-03/animals that live in the snow.mp3": [
		3897,
		7,
		2572
	],
	"./00002/00002-08/00002-08-03/in the winter.mp3": [
		3898,
		7,
		2573
	],
	"./00002/00002-08/00002-08-03/intro.mp3": [
		553,
		7
	],
	"./00002/00002-08/00002-08-03/it is winter.mp3": [
		3899,
		7,
		2574
	],
	"./00002/00002-08/00002-08-03/look at the bear.mp3": [
		3900,
		7,
		2575
	],
	"./00002/00002-08/00002-08-03/look at the frost.mp3": [
		3901,
		7,
		2576
	],
	"./00002/00002-08/00002-08-03/look at the ice.mp3": [
		3902,
		7,
		2577
	],
	"./00002/00002-08/00002-08-03/look at the mountains.mp3": [
		3903,
		7,
		2578
	],
	"./00002/00002-08/00002-08-03/look at the pond.mp3": [
		3904,
		7,
		2579
	],
	"./00002/00002-08/00002-08-03/look at the river.mp3": [
		3905,
		7,
		2580
	],
	"./00002/00002-08/00002-08-03/look at the trees.mp3": [
		3906,
		7,
		2581
	],
	"./00002/00002-08/00002-08-03/main idea.mp3": [
		934,
		7
	],
	"./00002/00002-08/00002-08-03/module": [
		1352,
		9,
		216
	],
	"./00002/00002-08/00002-08-03/module.js": [
		1352,
		9,
		216
	],
	"./00002/00002-08/00002-08-04/0.jpg": [
		6904,
		7,
		5581
	],
	"./00002/00002-08/00002-08-04/1.jpg": [
		8861,
		7,
		8883
	],
	"./00002/00002-08/00002-08-04/2.jpg": [
		8862,
		7,
		8884
	],
	"./00002/00002-08/00002-08-04/3.jpg": [
		8863,
		7,
		8885
	],
	"./00002/00002-08/00002-08-04/4.jpg": [
		8864,
		7,
		8886
	],
	"./00002/00002-08/00002-08-04/5.jpg": [
		8865,
		7,
		8887
	],
	"./00002/00002-08/00002-08-04/6.jpg": [
		8866,
		7,
		8888
	],
	"./00002/00002-08/00002-08-04/7.jpg": [
		8867,
		7,
		8889
	],
	"./00002/00002-08/00002-08-04/i can see 2 lambs.mp3": [
		3907,
		7,
		2582
	],
	"./00002/00002-08/00002-08-04/i can see 3 frogs.mp3": [
		3908,
		7,
		2583
	],
	"./00002/00002-08/00002-08-04/i can see 4 chicks.mp3": [
		3909,
		7,
		2584
	],
	"./00002/00002-08/00002-08-04/i can see 5 ducklings.mp3": [
		3910,
		7,
		2585
	],
	"./00002/00002-08/00002-08-04/i can see 6 butterflies.mp3": [
		3911,
		7,
		2586
	],
	"./00002/00002-08/00002-08-04/i can see 7 flowers.mp3": [
		3912,
		7,
		2587
	],
	"./00002/00002-08/00002-08-04/i can see the rain.mp3": [
		3913,
		7,
		2588
	],
	"./00002/00002-08/00002-08-04/intro.mp3": [
		554,
		7
	],
	"./00002/00002-08/00002-08-04/main idea.mp3": [
		935,
		7
	],
	"./00002/00002-08/00002-08-04/module": [
		1353,
		9,
		217
	],
	"./00002/00002-08/00002-08-04/module.js": [
		1353,
		9,
		217
	],
	"./00002/00002-08/00002-08-04/signs of spring.mp3": [
		3914,
		7,
		2589
	],
	"./00002/00002-08/00002-08-04/spring is here.mp3": [
		3915,
		7,
		2590
	],
	"./00002/00002-08/00002-08-04/spring is on the way.mp3": [
		3916,
		7,
		2591
	],
	"./00002/00002-08/00002-08-04/what can i see.mp3": [
		3917,
		7,
		2592
	],
	"./00002/00002-08/00002-08-05/0.jpg": [
		6905,
		7,
		5582
	],
	"./00002/00002-08/00002-08-05/1.jpg": [
		8868,
		7,
		8890
	],
	"./00002/00002-08/00002-08-05/2.jpg": [
		8869,
		7,
		8891
	],
	"./00002/00002-08/00002-08-05/3.jpg": [
		8870,
		7,
		8892
	],
	"./00002/00002-08/00002-08-05/4.jpg": [
		8871,
		7,
		8893
	],
	"./00002/00002-08/00002-08-05/5.jpg": [
		8872,
		7,
		8894
	],
	"./00002/00002-08/00002-08-05/6.jpg": [
		8873,
		7,
		8895
	],
	"./00002/00002-08/00002-08-05/7.jpg": [
		8874,
		7,
		8896
	],
	"./00002/00002-08/00002-08-05/i like summer.mp3": [
		3918,
		7,
		2593
	],
	"./00002/00002-08/00002-08-05/i like the hermit crab.mp3": [
		3919,
		7,
		2594
	],
	"./00002/00002-08/00002-08-05/i like the sandcastle.mp3": [
		3920,
		7,
		2595
	],
	"./00002/00002-08/00002-08-05/i like the sea.mp3": [
		3921,
		7,
		2596
	],
	"./00002/00002-08/00002-08-05/i like the seagull.mp3": [
		3922,
		7,
		2597
	],
	"./00002/00002-08/00002-08-05/i like the shell.mp3": [
		3923,
		7,
		2598
	],
	"./00002/00002-08/00002-08-05/i like the starfish.mp3": [
		3924,
		7,
		2599
	],
	"./00002/00002-08/00002-08-05/i like the sun.mp3": [
		3925,
		7,
		2600
	],
	"./00002/00002-08/00002-08-05/intro.mp3": [
		555,
		7
	],
	"./00002/00002-08/00002-08-05/main idea.mp3": [
		936,
		7
	],
	"./00002/00002-08/00002-08-05/module": [
		1354,
		9,
		218
	],
	"./00002/00002-08/00002-08-05/module.js": [
		1354,
		9,
		218
	],
	"./00002/00002-08/00002-08-05/sea animals.mp3": [
		3926,
		7,
		2601
	],
	"./00002/00002-08/00002-08-06/0.jpg": [
		6906,
		7,
		5583
	],
	"./00002/00002-08/00002-08-06/1.jpg": [
		8875,
		7,
		8897
	],
	"./00002/00002-08/00002-08-06/2.jpg": [
		8876,
		7,
		8898
	],
	"./00002/00002-08/00002-08-06/3.jpg": [
		8877,
		7,
		8899
	],
	"./00002/00002-08/00002-08-06/4.jpg": [
		8878,
		7,
		8900
	],
	"./00002/00002-08/00002-08-06/5.jpg": [
		8879,
		7,
		8901
	],
	"./00002/00002-08/00002-08-06/6.jpg": [
		8880,
		7,
		8902
	],
	"./00002/00002-08/00002-08-06/7.jpg": [
		8881,
		7,
		8903
	],
	"./00002/00002-08/00002-08-06/colors in the fall.mp3": [
		3927,
		7,
		2602
	],
	"./00002/00002-08/00002-08-06/intro.mp3": [
		556,
		7
	],
	"./00002/00002-08/00002-08-06/look at the ant.mp3": [
		3928,
		7,
		2603
	],
	"./00002/00002-08/00002-08-06/look at the bear.mp3": [
		3929,
		7,
		2604
	],
	"./00002/00002-08/00002-08-06/look at the bird.mp3": [
		3930,
		7,
		2605
	],
	"./00002/00002-08/00002-08-06/look at the brown nuts.mp3": [
		3931,
		7,
		2606
	],
	"./00002/00002-08/00002-08-06/look at the cow.mp3": [
		3932,
		7,
		2607
	],
	"./00002/00002-08/00002-08-06/look at the gray geese.mp3": [
		3933,
		7,
		2608
	],
	"./00002/00002-08/00002-08-06/look at the green apples.mp3": [
		3934,
		7,
		2609
	],
	"./00002/00002-08/00002-08-06/look at the horse.mp3": [
		3935,
		7,
		2610
	],
	"./00002/00002-08/00002-08-06/look at the orange pumpkin.mp3": [
		3936,
		7,
		2611
	],
	"./00002/00002-08/00002-08-06/look at the purple grapes.mp3": [
		3937,
		7,
		2612
	],
	"./00002/00002-08/00002-08-06/look at the red leaves.mp3": [
		3938,
		7,
		2613
	],
	"./00002/00002-08/00002-08-06/look at the squirrel.mp3": [
		3939,
		7,
		2614
	],
	"./00002/00002-08/00002-08-06/look at the trees.mp3": [
		3940,
		7,
		2615
	],
	"./00002/00002-08/00002-08-06/look at the yellow hay.mp3": [
		3941,
		7,
		2616
	],
	"./00002/00002-08/00002-08-06/main idea.mp3": [
		937,
		7
	],
	"./00002/00002-08/00002-08-06/module": [
		1355,
		9,
		219
	],
	"./00002/00002-08/00002-08-06/module.js": [
		1355,
		9,
		219
	],
	"./00002/00002-08/00002-08-06/things we see in the fall.mp3": [
		3942,
		7,
		2617
	],
	"./00002/00002-08/00002-08-07/0.jpg": [
		6907,
		7,
		5584
	],
	"./00002/00002-08/00002-08-07/1.jpg": [
		8882,
		7,
		8904
	],
	"./00002/00002-08/00002-08-07/2.jpg": [
		8883,
		7,
		8905
	],
	"./00002/00002-08/00002-08-07/3.jpg": [
		8884,
		7,
		8906
	],
	"./00002/00002-08/00002-08-07/4.jpg": [
		8885,
		7,
		8907
	],
	"./00002/00002-08/00002-08-07/5.jpg": [
		8886,
		7,
		8908
	],
	"./00002/00002-08/00002-08-07/6.jpg": [
		8887,
		7,
		8909
	],
	"./00002/00002-08/00002-08-07/7.jpg": [
		8888,
		7,
		8910
	],
	"./00002/00002-08/00002-08-07/intro.mp3": [
		557,
		7
	],
	"./00002/00002-08/00002-08-07/main idea.mp3": [
		938,
		7
	],
	"./00002/00002-08/00002-08-07/module": [
		1356,
		9,
		220
	],
	"./00002/00002-08/00002-08-07/module.js": [
		1356,
		9,
		220
	],
	"./00002/00002-08/00002-08-07/things we see in the soil.mp3": [
		3943,
		7,
		2618
	],
	"./00002/00002-08/00002-08-07/we can see ants.mp3": [
		3944,
		7,
		2619
	],
	"./00002/00002-08/00002-08-07/we can see bones.mp3": [
		3945,
		7,
		2620
	],
	"./00002/00002-08/00002-08-07/we can see leaves.mp3": [
		3946,
		7,
		2621
	],
	"./00002/00002-08/00002-08-07/we can see rocks.mp3": [
		3947,
		7,
		2622
	],
	"./00002/00002-08/00002-08-07/we can see roots.mp3": [
		3948,
		7,
		2623
	],
	"./00002/00002-08/00002-08-07/we can see shells.mp3": [
		3949,
		7,
		2624
	],
	"./00002/00002-08/00002-08-07/we can see worms.mp3": [
		3950,
		7,
		2625
	],
	"./00002/00002-08/00002-08-07/what is in the soil.mp3": [
		3951,
		7,
		2626
	],
	"./00002/00002-08/00002-08-08/0.jpg": [
		6908,
		7,
		5585
	],
	"./00002/00002-08/00002-08-08/1.jpg": [
		8889,
		7,
		8911
	],
	"./00002/00002-08/00002-08-08/2.jpg": [
		8890,
		7,
		8912
	],
	"./00002/00002-08/00002-08-08/3.jpg": [
		8891,
		7,
		8913
	],
	"./00002/00002-08/00002-08-08/4.jpg": [
		8892,
		7,
		8914
	],
	"./00002/00002-08/00002-08-08/5.jpg": [
		8893,
		7,
		8915
	],
	"./00002/00002-08/00002-08-08/6.jpg": [
		8894,
		7,
		8916
	],
	"./00002/00002-08/00002-08-08/7.jpg": [
		8895,
		7,
		8917
	],
	"./00002/00002-08/00002-08-08/alligator likes the green rock.mp3": [
		3952,
		7,
		2627
	],
	"./00002/00002-08/00002-08-08/cheetah likes the yellow rock.mp3": [
		3953,
		7,
		2628
	],
	"./00002/00002-08/00002-08-08/chipmunk likes the brown rock.mp3": [
		3954,
		7,
		2629
	],
	"./00002/00002-08/00002-08-08/elephant likes the gray rock.mp3": [
		3955,
		7,
		2630
	],
	"./00002/00002-08/00002-08-08/fox likes the red rock.mp3": [
		3956,
		7,
		2631
	],
	"./00002/00002-08/00002-08-08/intro.mp3": [
		558,
		7
	],
	"./00002/00002-08/00002-08-08/look at my rock he said.mp3": [
		3957,
		7,
		2632
	],
	"./00002/00002-08/00002-08-08/look at my rock she said.mp3": [
		3958,
		7,
		2633
	],
	"./00002/00002-08/00002-08-08/main idea.mp3": [
		939,
		7
	],
	"./00002/00002-08/00002-08-08/module": [
		1357,
		9,
		221
	],
	"./00002/00002-08/00002-08-08/module.js": [
		1357,
		9,
		221
	],
	"./00002/00002-08/00002-08-08/non living things.mp3": [
		3959,
		7,
		2634
	],
	"./00002/00002-08/00002-08-08/rocks.mp3": [
		3960,
		7,
		2635
	],
	"./00002/00002-08/00002-08-08/skunk likes the black rock.mp3": [
		3961,
		7,
		2636
	],
	"./00002/00002-08/00002-08-08/tiger likes the orange rock.mp3": [
		3962,
		7,
		2637
	],
	"./00002/00002-08/00002-08-09/0.jpg": [
		6909,
		7,
		5586
	],
	"./00002/00002-08/00002-08-09/1.jpg": [
		8896,
		7,
		8918
	],
	"./00002/00002-08/00002-08-09/2.jpg": [
		8897,
		7,
		8919
	],
	"./00002/00002-08/00002-08-09/3.jpg": [
		8898,
		7,
		8920
	],
	"./00002/00002-08/00002-08-09/4.jpg": [
		8899,
		7,
		8921
	],
	"./00002/00002-08/00002-08-09/5.jpg": [
		8900,
		7,
		8922
	],
	"./00002/00002-08/00002-08-09/6.jpg": [
		8901,
		7,
		8923
	],
	"./00002/00002-08/00002-08-09/7.jpg": [
		8902,
		7,
		8924
	],
	"./00002/00002-08/00002-08-09/intro.mp3": [
		559,
		7
	],
	"./00002/00002-08/00002-08-09/look up in the sky.mp3": [
		3963,
		7,
		2638
	],
	"./00002/00002-08/00002-08-09/main idea.mp3": [
		940,
		7
	],
	"./00002/00002-08/00002-08-09/module": [
		1358,
		9,
		222
	],
	"./00002/00002-08/00002-08-09/module.js": [
		1358,
		9,
		222
	],
	"./00002/00002-08/00002-08-09/things in the sky.mp3": [
		3964,
		7,
		2639
	],
	"./00002/00002-08/00002-08-09/what can you see in the sky.mp3": [
		3965,
		7,
		2640
	],
	"./00002/00002-08/00002-08-09/you can see a dragon.mp3": [
		3966,
		7,
		2641
	],
	"./00002/00002-08/00002-08-09/you can see the clouds.mp3": [
		3967,
		7,
		2642
	],
	"./00002/00002-08/00002-08-09/you can see the moon.mp3": [
		3968,
		7,
		2643
	],
	"./00002/00002-08/00002-08-09/you can see the rain.mp3": [
		3969,
		7,
		2644
	],
	"./00002/00002-08/00002-08-09/you can see the rainbow.mp3": [
		3970,
		7,
		2645
	],
	"./00002/00002-08/00002-08-09/you can see the stars.mp3": [
		3971,
		7,
		2646
	],
	"./00002/00002-08/00002-08-09/you can see the sun.mp3": [
		3972,
		7,
		2647
	],
	"./00002/00002-08/00002-08-10/0.jpg": [
		6910,
		7,
		5587
	],
	"./00002/00002-08/00002-08-10/1.jpg": [
		8903,
		7,
		8925
	],
	"./00002/00002-08/00002-08-10/2.jpg": [
		8904,
		7,
		8926
	],
	"./00002/00002-08/00002-08-10/3.jpg": [
		8905,
		7,
		8927
	],
	"./00002/00002-08/00002-08-10/4.jpg": [
		8906,
		7,
		8928
	],
	"./00002/00002-08/00002-08-10/5.jpg": [
		8907,
		7,
		8929
	],
	"./00002/00002-08/00002-08-10/6.jpg": [
		8908,
		7,
		8930
	],
	"./00002/00002-08/00002-08-10/7.jpg": [
		8909,
		7,
		8931
	],
	"./00002/00002-08/00002-08-10/intro.mp3": [
		560,
		7
	],
	"./00002/00002-08/00002-08-10/it is a cloudy day.mp3": [
		3973,
		7,
		2648
	],
	"./00002/00002-08/00002-08-10/it is a rainy day.mp3": [
		3974,
		7,
		2649
	],
	"./00002/00002-08/00002-08-10/it is a rainy night.mp3": [
		3975,
		7,
		2650
	],
	"./00002/00002-08/00002-08-10/it is a snowy day.mp3": [
		3976,
		7,
		2651
	],
	"./00002/00002-08/00002-08-10/it is a snowy night.mp3": [
		3977,
		7,
		2652
	],
	"./00002/00002-08/00002-08-10/it is a sunny day.mp3": [
		3978,
		7,
		2653
	],
	"./00002/00002-08/00002-08-10/it is a windy day.mp3": [
		3979,
		7,
		2654
	],
	"./00002/00002-08/00002-08-10/look at me.mp3": [
		3980,
		7,
		2655
	],
	"./00002/00002-08/00002-08-10/look at us.mp3": [
		3981,
		7,
		2656
	],
	"./00002/00002-08/00002-08-10/main idea.mp3": [
		941,
		7
	],
	"./00002/00002-08/00002-08-10/module": [
		1359,
		9,
		223
	],
	"./00002/00002-08/00002-08-10/module.js": [
		1359,
		9,
		223
	],
	"./00002/00002-08/00002-08-10/weather.mp3": [
		3982,
		7,
		2657
	],
	"./00002/00002-08/cover.jpg": [
		6911,
		7,
		5588
	],
	"./00002/00002-08/earth and space.mp3": [
		3983,
		7,
		2658
	],
	"./00002/00002-08/unit": [
		1360,
		9,
		224
	],
	"./00002/00002-08/unit.js": [
		1360,
		9,
		224
	],
	"./00002/00002-09/00002-09-01/0.jpg": [
		6912,
		7,
		5589
	],
	"./00002/00002-09/00002-09-01/1.jpg": [
		8910,
		7,
		8932
	],
	"./00002/00002-09/00002-09-01/2.jpg": [
		8911,
		7,
		8933
	],
	"./00002/00002-09/00002-09-01/3.jpg": [
		8912,
		7,
		8934
	],
	"./00002/00002-09/00002-09-01/4.jpg": [
		8913,
		7,
		8935
	],
	"./00002/00002-09/00002-09-01/5.jpg": [
		8914,
		7,
		8936
	],
	"./00002/00002-09/00002-09-01/6.jpg": [
		8915,
		7,
		8937
	],
	"./00002/00002-09/00002-09-01/7.jpg": [
		8916,
		7,
		8938
	],
	"./00002/00002-09/00002-09-01/fish.mp3": [
		3984,
		7,
		2659
	],
	"./00002/00002-09/00002-09-01/i am a dolphin.mp3": [
		3985,
		7,
		2660
	],
	"./00002/00002-09/00002-09-01/i am a fish.mp3": [
		3986,
		7,
		2661
	],
	"./00002/00002-09/00002-09-01/i am a flying fish.mp3": [
		3987,
		7,
		2662
	],
	"./00002/00002-09/00002-09-01/i am a hammerhead shark.mp3": [
		3988,
		7,
		2663
	],
	"./00002/00002-09/00002-09-01/i am a seahorse.mp3": [
		3989,
		7,
		2664
	],
	"./00002/00002-09/00002-09-01/i am a shark.mp3": [
		3990,
		7,
		2665
	],
	"./00002/00002-09/00002-09-01/i am a swordfish.mp3": [
		3991,
		7,
		2666
	],
	"./00002/00002-09/00002-09-01/i am an eel.mp3": [
		3992,
		7,
		2667
	],
	"./00002/00002-09/00002-09-01/i am not a fish.mp3": [
		3993,
		7,
		2668
	],
	"./00002/00002-09/00002-09-01/i live in the water.mp3": [
		3994,
		7,
		2669
	],
	"./00002/00002-09/00002-09-01/intro.mp3": [
		561,
		7
	],
	"./00002/00002-09/00002-09-01/main idea.mp3": [
		942,
		7
	],
	"./00002/00002-09/00002-09-01/module": [
		1361,
		9,
		225
	],
	"./00002/00002-09/00002-09-01/module.js": [
		1361,
		9,
		225
	],
	"./00002/00002-09/00002-09-02/0.jpg": [
		6913,
		7,
		5590
	],
	"./00002/00002-09/00002-09-02/1.jpg": [
		8917,
		7,
		8939
	],
	"./00002/00002-09/00002-09-02/2.jpg": [
		8918,
		7,
		8940
	],
	"./00002/00002-09/00002-09-02/3.jpg": [
		8919,
		7,
		8941
	],
	"./00002/00002-09/00002-09-02/4.jpg": [
		8920,
		7,
		8942
	],
	"./00002/00002-09/00002-09-02/5.jpg": [
		8921,
		7,
		8943
	],
	"./00002/00002-09/00002-09-02/6.jpg": [
		8922,
		7,
		8944
	],
	"./00002/00002-09/00002-09-02/7.jpg": [
		8923,
		7,
		8945
	],
	"./00002/00002-09/00002-09-02/here is a skunk.mp3": [
		3995,
		7,
		2670
	],
	"./00002/00002-09/00002-09-02/i am a fox.mp3": [
		3996,
		7,
		2671
	],
	"./00002/00002-09/00002-09-02/i am a mammal.mp3": [
		3997,
		7,
		2672
	],
	"./00002/00002-09/00002-09-02/i am a panda.mp3": [
		3998,
		7,
		2673
	],
	"./00002/00002-09/00002-09-02/i am a shark.mp3": [
		3999,
		7,
		2674
	],
	"./00002/00002-09/00002-09-02/i am a zebra.mp3": [
		4000,
		7,
		2675
	],
	"./00002/00002-09/00002-09-02/i am not a mammal.mp3": [
		4001,
		7,
		2676
	],
	"./00002/00002-09/00002-09-02/i like the bat.mp3": [
		4002,
		7,
		2677
	],
	"./00002/00002-09/00002-09-02/i like the skunk.mp3": [
		4003,
		7,
		2678
	],
	"./00002/00002-09/00002-09-02/i like the whale.mp3": [
		4004,
		7,
		2679
	],
	"./00002/00002-09/00002-09-02/i see a whale.mp3": [
		4005,
		7,
		2680
	],
	"./00002/00002-09/00002-09-02/intro.mp3": [
		562,
		7
	],
	"./00002/00002-09/00002-09-02/look at the bat.mp3": [
		4006,
		7,
		2681
	],
	"./00002/00002-09/00002-09-02/main idea.mp3": [
		943,
		7
	],
	"./00002/00002-09/00002-09-02/mammals.mp3": [
		4007,
		7,
		2682
	],
	"./00002/00002-09/00002-09-02/module": [
		1362,
		9,
		226
	],
	"./00002/00002-09/00002-09-02/module.js": [
		1362,
		9,
		226
	],
	"./00002/00002-09/00002-09-03/0.jpg": [
		6914,
		7,
		5591
	],
	"./00002/00002-09/00002-09-03/1.jpg": [
		8924,
		7,
		8946
	],
	"./00002/00002-09/00002-09-03/2.jpg": [
		8925,
		7,
		8947
	],
	"./00002/00002-09/00002-09-03/3.jpg": [
		8926,
		7,
		8948
	],
	"./00002/00002-09/00002-09-03/4.jpg": [
		8927,
		7,
		8949
	],
	"./00002/00002-09/00002-09-03/5.jpg": [
		8928,
		7,
		8950
	],
	"./00002/00002-09/00002-09-03/6.jpg": [
		8929,
		7,
		8951
	],
	"./00002/00002-09/00002-09-03/7.jpg": [
		8930,
		7,
		8952
	],
	"./00002/00002-09/00002-09-03/alligators are reptiles.mp3": [
		4008,
		7,
		2683
	],
	"./00002/00002-09/00002-09-03/here is a sea turtle.mp3": [
		4009,
		7,
		2684
	],
	"./00002/00002-09/00002-09-03/intro.mp3": [
		563,
		7
	],
	"./00002/00002-09/00002-09-03/lizards are reptiles.mp3": [
		4010,
		7,
		2685
	],
	"./00002/00002-09/00002-09-03/look at the alligator.mp3": [
		4011,
		7,
		2686
	],
	"./00002/00002-09/00002-09-03/look at the crocodile.mp3": [
		4012,
		7,
		2687
	],
	"./00002/00002-09/00002-09-03/look at the iguana.mp3": [
		4013,
		7,
		2688
	],
	"./00002/00002-09/00002-09-03/look at the lizard.mp3": [
		4014,
		7,
		2689
	],
	"./00002/00002-09/00002-09-03/look at the reptiles.mp3": [
		4015,
		7,
		2690
	],
	"./00002/00002-09/00002-09-03/look at the sea turtle.mp3": [
		4016,
		7,
		2691
	],
	"./00002/00002-09/00002-09-03/look at the snake.mp3": [
		4017,
		7,
		2692
	],
	"./00002/00002-09/00002-09-03/look at the turtle.mp3": [
		4018,
		7,
		2693
	],
	"./00002/00002-09/00002-09-03/main idea.mp3": [
		944,
		7
	],
	"./00002/00002-09/00002-09-03/module": [
		1363,
		9,
		227
	],
	"./00002/00002-09/00002-09-03/module.js": [
		1363,
		9,
		227
	],
	"./00002/00002-09/00002-09-03/reptiles.mp3": [
		4019,
		7,
		2694
	],
	"./00002/00002-09/00002-09-03/snakes are reptiles.mp3": [
		4020,
		7,
		2695
	],
	"./00002/00002-09/00002-09-03/the crocodile is a reptile.mp3": [
		4021,
		7,
		2696
	],
	"./00002/00002-09/00002-09-03/turtles are reptiles.mp3": [
		4022,
		7,
		2697
	],
	"./00002/00002-09/00002-09-04/0.jpg": [
		6915,
		7,
		5592
	],
	"./00002/00002-09/00002-09-04/1.jpg": [
		8931,
		7,
		8953
	],
	"./00002/00002-09/00002-09-04/2.jpg": [
		8932,
		7,
		8954
	],
	"./00002/00002-09/00002-09-04/3.jpg": [
		8933,
		7,
		8955
	],
	"./00002/00002-09/00002-09-04/4.jpg": [
		8934,
		7,
		8956
	],
	"./00002/00002-09/00002-09-04/5.jpg": [
		8935,
		7,
		8957
	],
	"./00002/00002-09/00002-09-04/6.jpg": [
		8936,
		7,
		8958
	],
	"./00002/00002-09/00002-09-04/7.jpg": [
		8937,
		7,
		8959
	],
	"./00002/00002-09/00002-09-04/amphibians.mp3": [
		4023,
		7,
		2698
	],
	"./00002/00002-09/00002-09-04/i am a shark.mp3": [
		4024,
		7,
		2699
	],
	"./00002/00002-09/00002-09-04/i am an amphibian said the frog.mp3": [
		4025,
		7,
		2700
	],
	"./00002/00002-09/00002-09-04/i am an amphibian said the salamander.mp3": [
		4026,
		7,
		2701
	],
	"./00002/00002-09/00002-09-04/i am an amphibian said the toad.mp3": [
		4027,
		7,
		2702
	],
	"./00002/00002-09/00002-09-04/i am not an amphibian.mp3": [
		4028,
		7,
		2703
	],
	"./00002/00002-09/00002-09-04/i can see 1 frog.mp3": [
		4029,
		7,
		2704
	],
	"./00002/00002-09/00002-09-04/i can see 1 salamander.mp3": [
		4030,
		7,
		2705
	],
	"./00002/00002-09/00002-09-04/i can see 1 toad.mp3": [
		4031,
		7,
		2706
	],
	"./00002/00002-09/00002-09-04/i can see 2 frogs.mp3": [
		4032,
		7,
		2707
	],
	"./00002/00002-09/00002-09-04/i can see 2 salamanders.mp3": [
		4033,
		7,
		2708
	],
	"./00002/00002-09/00002-09-04/i can see 2 toads.mp3": [
		4034,
		7,
		2709
	],
	"./00002/00002-09/00002-09-04/i can see 6 amphibians.mp3": [
		4035,
		7,
		2710
	],
	"./00002/00002-09/00002-09-04/intro.mp3": [
		564,
		7
	],
	"./00002/00002-09/00002-09-04/look at the frog.mp3": [
		4036,
		7,
		2711
	],
	"./00002/00002-09/00002-09-04/look at the salamander.mp3": [
		4037,
		7,
		2712
	],
	"./00002/00002-09/00002-09-04/look at the toad.mp3": [
		4038,
		7,
		2713
	],
	"./00002/00002-09/00002-09-04/main idea.mp3": [
		945,
		7
	],
	"./00002/00002-09/00002-09-04/module": [
		1364,
		9,
		228
	],
	"./00002/00002-09/00002-09-04/module.js": [
		1364,
		9,
		228
	],
	"./00002/00002-09/00002-09-05/0.jpg": [
		6916,
		7,
		5593
	],
	"./00002/00002-09/00002-09-05/1.jpg": [
		8938,
		7,
		8960
	],
	"./00002/00002-09/00002-09-05/2.jpg": [
		8939,
		7,
		8961
	],
	"./00002/00002-09/00002-09-05/3.jpg": [
		8940,
		7,
		8962
	],
	"./00002/00002-09/00002-09-05/4.jpg": [
		8941,
		7,
		8963
	],
	"./00002/00002-09/00002-09-05/5.jpg": [
		8942,
		7,
		8964
	],
	"./00002/00002-09/00002-09-05/6.jpg": [
		8943,
		7,
		8965
	],
	"./00002/00002-09/00002-09-05/7.jpg": [
		8944,
		7,
		8966
	],
	"./00002/00002-09/00002-09-05/birds.mp3": [
		4039,
		7,
		2714
	],
	"./00002/00002-09/00002-09-05/here is a duck.mp3": [
		4040,
		7,
		2715
	],
	"./00002/00002-09/00002-09-05/i am a bird.mp3": [
		4041,
		7,
		2716
	],
	"./00002/00002-09/00002-09-05/i am a parrot.mp3": [
		4042,
		7,
		2717
	],
	"./00002/00002-09/00002-09-05/i am a penguin.mp3": [
		4043,
		7,
		2718
	],
	"./00002/00002-09/00002-09-05/i see a flamingo.mp3": [
		4044,
		7,
		2719
	],
	"./00002/00002-09/00002-09-05/i see the ostrich.mp3": [
		4045,
		7,
		2720
	],
	"./00002/00002-09/00002-09-05/intro.mp3": [
		565,
		7
	],
	"./00002/00002-09/00002-09-05/look at the bat.mp3": [
		4046,
		7,
		2721
	],
	"./00002/00002-09/00002-09-05/look at the eagle.mp3": [
		4047,
		7,
		2722
	],
	"./00002/00002-09/00002-09-05/main idea.mp3": [
		946,
		7
	],
	"./00002/00002-09/00002-09-05/module": [
		1365,
		9,
		229
	],
	"./00002/00002-09/00002-09-05/module.js": [
		1365,
		9,
		229
	],
	"./00002/00002-09/00002-09-05/the bat is not a bird.mp3": [
		4048,
		7,
		2723
	],
	"./00002/00002-09/00002-09-05/the duck is a bird.mp3": [
		4049,
		7,
		2724
	],
	"./00002/00002-09/00002-09-05/the eagle is a bird.mp3": [
		4050,
		7,
		2725
	],
	"./00002/00002-09/00002-09-05/the flamingo is a bird.mp3": [
		4051,
		7,
		2726
	],
	"./00002/00002-09/00002-09-05/the ostrich is a bird.mp3": [
		4052,
		7,
		2727
	],
	"./00002/00002-09/00002-09-05/the penguin is a bird.mp3": [
		4053,
		7,
		2728
	],
	"./00002/00002-09/00002-09-05/the rooster is a bird.mp3": [
		4054,
		7,
		2729
	],
	"./00002/00002-09/00002-09-06/0.jpg": [
		6917,
		7,
		5594
	],
	"./00002/00002-09/00002-09-06/1.jpg": [
		8945,
		7,
		8967
	],
	"./00002/00002-09/00002-09-06/2.jpg": [
		8946,
		7,
		8968
	],
	"./00002/00002-09/00002-09-06/3.jpg": [
		8947,
		7,
		8969
	],
	"./00002/00002-09/00002-09-06/4.jpg": [
		8948,
		7,
		8970
	],
	"./00002/00002-09/00002-09-06/5.jpg": [
		8949,
		7,
		8971
	],
	"./00002/00002-09/00002-09-06/6.jpg": [
		8950,
		7,
		8972
	],
	"./00002/00002-09/00002-09-06/7.jpg": [
		8951,
		7,
		8973
	],
	"./00002/00002-09/00002-09-06/a crab has no backbone.mp3": [
		4055,
		7,
		2730
	],
	"./00002/00002-09/00002-09-06/a jellyfish has no backbone.mp3": [
		4056,
		7,
		2731
	],
	"./00002/00002-09/00002-09-06/a ladybug has no backbone.mp3": [
		4057,
		7,
		2732
	],
	"./00002/00002-09/00002-09-06/a spider has no backbone.mp3": [
		4058,
		7,
		2733
	],
	"./00002/00002-09/00002-09-06/a worm has no backbone.mp3": [
		4059,
		7,
		2734
	],
	"./00002/00002-09/00002-09-06/animals without backbones.mp3": [
		4060,
		7,
		2735
	],
	"./00002/00002-09/00002-09-06/here is a butterfly.mp3": [
		4061,
		7,
		2736
	],
	"./00002/00002-09/00002-09-06/here is a jellyfish.mp3": [
		4062,
		7,
		2737
	],
	"./00002/00002-09/00002-09-06/here is a ladybug.mp3": [
		4063,
		7,
		2738
	],
	"./00002/00002-09/00002-09-06/here is a lobster.mp3": [
		4064,
		7,
		2739
	],
	"./00002/00002-09/00002-09-06/here is a slug.mp3": [
		4065,
		7,
		2740
	],
	"./00002/00002-09/00002-09-06/here is a squid.mp3": [
		4066,
		7,
		2741
	],
	"./00002/00002-09/00002-09-06/i see a worm.mp3": [
		4067,
		7,
		2742
	],
	"./00002/00002-09/00002-09-06/i see the spider.mp3": [
		4068,
		7,
		2743
	],
	"./00002/00002-09/00002-09-06/intro.mp3": [
		566,
		7
	],
	"./00002/00002-09/00002-09-06/look at the crab.mp3": [
		4069,
		7,
		2744
	],
	"./00002/00002-09/00002-09-06/look at the octopus.mp3": [
		4070,
		7,
		2745
	],
	"./00002/00002-09/00002-09-06/main idea.mp3": [
		947,
		7
	],
	"./00002/00002-09/00002-09-06/module": [
		1366,
		9,
		230
	],
	"./00002/00002-09/00002-09-06/module.js": [
		1366,
		9,
		230
	],
	"./00002/00002-09/00002-09-06/the octopus has no backbone.mp3": [
		4071,
		7,
		2746
	],
	"./00002/00002-09/00002-09-07/0.jpg": [
		6918,
		7,
		5595
	],
	"./00002/00002-09/00002-09-07/1.jpg": [
		8952,
		7,
		8974
	],
	"./00002/00002-09/00002-09-07/2.jpg": [
		8953,
		7,
		8975
	],
	"./00002/00002-09/00002-09-07/3.jpg": [
		8954,
		7,
		8976
	],
	"./00002/00002-09/00002-09-07/4.jpg": [
		8955,
		7,
		8977
	],
	"./00002/00002-09/00002-09-07/5.jpg": [
		8956,
		7,
		8978
	],
	"./00002/00002-09/00002-09-07/6.jpg": [
		8957,
		7,
		8979
	],
	"./00002/00002-09/00002-09-07/7.jpg": [
		8958,
		7,
		8980
	],
	"./00002/00002-09/00002-09-07/i am an insect said the ant.mp3": [
		4072,
		7,
		2747
	],
	"./00002/00002-09/00002-09-07/i am an insect said the butterfly.mp3": [
		4073,
		7,
		2748
	],
	"./00002/00002-09/00002-09-07/i am an insect said the grasshopper.mp3": [
		4074,
		7,
		2749
	],
	"./00002/00002-09/00002-09-07/i am an insect.mp3": [
		4075,
		7,
		2750
	],
	"./00002/00002-09/00002-09-07/i am not an insect.mp3": [
		4076,
		7,
		2751
	],
	"./00002/00002-09/00002-09-07/i have 6 legs said the bee.mp3": [
		4077,
		7,
		2752
	],
	"./00002/00002-09/00002-09-07/i have 6 legs said the dragonfly.mp3": [
		4078,
		7,
		2753
	],
	"./00002/00002-09/00002-09-07/i have 6 legs said the ladybug.mp3": [
		4079,
		7,
		2754
	],
	"./00002/00002-09/00002-09-07/i have 6 legs.mp3": [
		4080,
		7,
		2755
	],
	"./00002/00002-09/00002-09-07/i have 8 legs said the spider.mp3": [
		4081,
		7,
		2756
	],
	"./00002/00002-09/00002-09-07/insects.mp3": [
		4082,
		7,
		2757
	],
	"./00002/00002-09/00002-09-07/intro.mp3": [
		567,
		7
	],
	"./00002/00002-09/00002-09-07/main idea.mp3": [
		948,
		7
	],
	"./00002/00002-09/00002-09-07/module": [
		1367,
		9,
		231
	],
	"./00002/00002-09/00002-09-07/module.js": [
		1367,
		9,
		231
	],
	"./00002/00002-09/00002-09-08/0.jpg": [
		6919,
		7,
		5596
	],
	"./00002/00002-09/00002-09-08/1.jpg": [
		8959,
		7,
		8981
	],
	"./00002/00002-09/00002-09-08/2.jpg": [
		8960,
		7,
		8982
	],
	"./00002/00002-09/00002-09-08/3.jpg": [
		8961,
		7,
		8983
	],
	"./00002/00002-09/00002-09-08/4.jpg": [
		8962,
		7,
		8984
	],
	"./00002/00002-09/00002-09-08/5.jpg": [
		8963,
		7,
		8985
	],
	"./00002/00002-09/00002-09-08/6.jpg": [
		8964,
		7,
		8986
	],
	"./00002/00002-09/00002-09-08/7.jpg": [
		8965,
		7,
		8987
	],
	"./00002/00002-09/00002-09-08/big animals.mp3": [
		4083,
		7,
		2758
	],
	"./00002/00002-09/00002-09-08/here is a dinosaur.mp3": [
		4084,
		7,
		2759
	],
	"./00002/00002-09/00002-09-08/here is a squid.mp3": [
		4085,
		7,
		2760
	],
	"./00002/00002-09/00002-09-08/i can see a giraffe.mp3": [
		4086,
		7,
		2761
	],
	"./00002/00002-09/00002-09-08/i can see an ostrich.mp3": [
		4087,
		7,
		2762
	],
	"./00002/00002-09/00002-09-08/i see a shark.mp3": [
		4088,
		7,
		2763
	],
	"./00002/00002-09/00002-09-08/i see a whale.mp3": [
		4089,
		7,
		2764
	],
	"./00002/00002-09/00002-09-08/intro.mp3": [
		568,
		7
	],
	"./00002/00002-09/00002-09-08/look at the elephant.mp3": [
		4090,
		7,
		2765
	],
	"./00002/00002-09/00002-09-08/main idea.mp3": [
		949,
		7
	],
	"./00002/00002-09/00002-09-08/module": [
		1368,
		9,
		232
	],
	"./00002/00002-09/00002-09-08/module.js": [
		1368,
		9,
		232
	],
	"./00002/00002-09/00002-09-08/this dinosaur is huge.mp3": [
		4091,
		7,
		2766
	],
	"./00002/00002-09/00002-09-08/this elephant is big.mp3": [
		4092,
		7,
		2767
	],
	"./00002/00002-09/00002-09-08/this giraffe is big.mp3": [
		4093,
		7,
		2768
	],
	"./00002/00002-09/00002-09-08/this ostrich is big.mp3": [
		4094,
		7,
		2769
	],
	"./00002/00002-09/00002-09-08/this squid is big.mp3": [
		4095,
		7,
		2770
	],
	"./00002/00002-09/00002-09-08/this whale is big.mp3": [
		4096,
		7,
		2771
	],
	"./00002/00002-09/00002-09-08/this whale shark is big.mp3": [
		4097,
		7,
		2772
	],
	"./00002/00002-09/00002-09-09/0.jpg": [
		6920,
		7,
		5597
	],
	"./00002/00002-09/00002-09-09/1.jpg": [
		8966,
		7,
		8988
	],
	"./00002/00002-09/00002-09-09/2.jpg": [
		8967,
		7,
		8989
	],
	"./00002/00002-09/00002-09-09/3.jpg": [
		8968,
		7,
		8990
	],
	"./00002/00002-09/00002-09-09/4.jpg": [
		8969,
		7,
		8991
	],
	"./00002/00002-09/00002-09-09/5.jpg": [
		8970,
		7,
		8992
	],
	"./00002/00002-09/00002-09-09/6.jpg": [
		8971,
		7,
		8993
	],
	"./00002/00002-09/00002-09-09/7.jpg": [
		8972,
		7,
		8994
	],
	"./00002/00002-09/00002-09-09/animals we saw in the book.mp3": [
		4098,
		7,
		2773
	],
	"./00002/00002-09/00002-09-09/here is a frog.mp3": [
		4099,
		7,
		2774
	],
	"./00002/00002-09/00002-09-09/intro.mp3": [
		569,
		7
	],
	"./00002/00002-09/00002-09-09/look at the ladybug.mp3": [
		4100,
		7,
		2775
	],
	"./00002/00002-09/00002-09-09/main idea.mp3": [
		950,
		7
	],
	"./00002/00002-09/00002-09-09/module": [
		1369,
		9,
		233
	],
	"./00002/00002-09/00002-09-09/module.js": [
		1369,
		9,
		233
	],
	"./00002/00002-09/00002-09-09/the alligator is a reptile.mp3": [
		4101,
		7,
		2776
	],
	"./00002/00002-09/00002-09-09/the animal book.mp3": [
		4102,
		7,
		2777
	],
	"./00002/00002-09/00002-09-09/the cat is a mammal.mp3": [
		4103,
		7,
		2778
	],
	"./00002/00002-09/00002-09-09/the dolphin is a mammal.mp3": [
		4104,
		7,
		2779
	],
	"./00002/00002-09/00002-09-09/the eagle is a bird.mp3": [
		4105,
		7,
		2780
	],
	"./00002/00002-09/00002-09-09/the frog is an amphibian.mp3": [
		4106,
		7,
		2781
	],
	"./00002/00002-09/00002-09-09/the ladybug is an insect.mp3": [
		4107,
		7,
		2782
	],
	"./00002/00002-09/00002-09-09/the penguin is a bird.mp3": [
		4108,
		7,
		2783
	],
	"./00002/00002-09/00002-09-09/the seahorse is a fish.mp3": [
		4109,
		7,
		2784
	],
	"./00002/00002-09/00002-09-09/the shark is a fish.mp3": [
		4110,
		7,
		2785
	],
	"./00002/00002-09/00002-09-09/the skunk is a mammal.mp3": [
		4111,
		7,
		2786
	],
	"./00002/00002-09/00002-09-09/the turtle is a reptile.mp3": [
		4112,
		7,
		2787
	],
	"./00002/00002-09/00002-09-09/the whale is a mammal.mp3": [
		4113,
		7,
		2788
	],
	"./00002/00002-09/00002-09-10/0.jpg": [
		6921,
		7,
		5598
	],
	"./00002/00002-09/00002-09-10/1.jpg": [
		8973,
		7,
		8995
	],
	"./00002/00002-09/00002-09-10/2.jpg": [
		8974,
		7,
		8996
	],
	"./00002/00002-09/00002-09-10/3.jpg": [
		8975,
		7,
		8997
	],
	"./00002/00002-09/00002-09-10/4.jpg": [
		8976,
		7,
		8998
	],
	"./00002/00002-09/00002-09-10/5.jpg": [
		8977,
		7,
		8999
	],
	"./00002/00002-09/00002-09-10/6.jpg": [
		8978,
		7,
		9000
	],
	"./00002/00002-09/00002-09-10/7.jpg": [
		8979,
		7,
		9001
	],
	"./00002/00002-09/00002-09-10/dinosaurs.mp3": [
		4114,
		7,
		2789
	],
	"./00002/00002-09/00002-09-10/i am a long neck dinosaur.mp3": [
		4115,
		7,
		2790
	],
	"./00002/00002-09/00002-09-10/i am a pterosaur.mp3": [
		4116,
		7,
		2791
	],
	"./00002/00002-09/00002-09-10/i am a raptor.mp3": [
		4117,
		7,
		2792
	],
	"./00002/00002-09/00002-09-10/i am a stegosaurus.mp3": [
		4118,
		7,
		2793
	],
	"./00002/00002-09/00002-09-10/i am a swimming dinosaur.mp3": [
		4119,
		7,
		2794
	],
	"./00002/00002-09/00002-09-10/i am a t rex.mp3": [
		4120,
		7,
		2795
	],
	"./00002/00002-09/00002-09-10/i am a triceratops.mp3": [
		4121,
		7,
		2796
	],
	"./00002/00002-09/00002-09-10/intro.mp3": [
		570,
		7
	],
	"./00002/00002-09/00002-09-10/look at me.mp3": [
		4122,
		7,
		2797
	],
	"./00002/00002-09/00002-09-10/main idea.mp3": [
		951,
		7
	],
	"./00002/00002-09/00002-09-10/module": [
		1370,
		9,
		234
	],
	"./00002/00002-09/00002-09-10/module.js": [
		1370,
		9,
		234
	],
	"./00002/00002-09/animal groups.mp3": [
		4123,
		7,
		2798
	],
	"./00002/00002-09/cover.jpg": [
		6922,
		7,
		5599
	],
	"./00002/00002-09/unit": [
		1371,
		9,
		235
	],
	"./00002/00002-09/unit.js": [
		1371,
		9,
		235
	],
	"./00002/00002-10/00002-10-01/0.jpg": [
		6923,
		7,
		5600
	],
	"./00002/00002-10/00002-10-01/1.jpg": [
		8980,
		7,
		9002
	],
	"./00002/00002-10/00002-10-01/2.jpg": [
		8981,
		7,
		9003
	],
	"./00002/00002-10/00002-10-01/3.jpg": [
		8982,
		7,
		9004
	],
	"./00002/00002-10/00002-10-01/4.jpg": [
		8983,
		7,
		9005
	],
	"./00002/00002-10/00002-10-01/5.jpg": [
		8984,
		7,
		9006
	],
	"./00002/00002-10/00002-10-01/6.jpg": [
		8985,
		7,
		9007
	],
	"./00002/00002-10/00002-10-01/7.jpg": [
		8986,
		7,
		9008
	],
	"./00002/00002-10/00002-10-01/animals with 4 legs.mp3": [
		4124,
		7,
		2799
	],
	"./00002/00002-10/00002-10-01/i am a dog.mp3": [
		4125,
		7,
		2800
	],
	"./00002/00002-10/00002-10-01/i am a ladybug.mp3": [
		4126,
		7,
		2801
	],
	"./00002/00002-10/00002-10-01/i am a monster.mp3": [
		4127,
		7,
		2802
	],
	"./00002/00002-10/00002-10-01/i am a parrot.mp3": [
		4128,
		7,
		2803
	],
	"./00002/00002-10/00002-10-01/i am a spider.mp3": [
		4129,
		7,
		2804
	],
	"./00002/00002-10/00002-10-01/i am a squid.mp3": [
		4130,
		7,
		2805
	],
	"./00002/00002-10/00002-10-01/i am a tiger.mp3": [
		4131,
		7,
		2806
	],
	"./00002/00002-10/00002-10-01/i have 10 legs.mp3": [
		4132,
		7,
		2807
	],
	"./00002/00002-10/00002-10-01/i have 12 legs.mp3": [
		4133,
		7,
		2808
	],
	"./00002/00002-10/00002-10-01/i have 2 legs.mp3": [
		4134,
		7,
		2809
	],
	"./00002/00002-10/00002-10-01/i have 3 legs.mp3": [
		4135,
		7,
		2810
	],
	"./00002/00002-10/00002-10-01/i have 4 legs.mp3": [
		4136,
		7,
		2811
	],
	"./00002/00002-10/00002-10-01/i have 6 legs.mp3": [
		4137,
		7,
		2812
	],
	"./00002/00002-10/00002-10-01/i have 8 legs.mp3": [
		4138,
		7,
		2813
	],
	"./00002/00002-10/00002-10-01/intro.mp3": [
		571,
		7
	],
	"./00002/00002-10/00002-10-01/legs.mp3": [
		4139,
		7,
		2814
	],
	"./00002/00002-10/00002-10-01/main idea.mp3": [
		952,
		7
	],
	"./00002/00002-10/00002-10-01/module": [
		1372,
		9,
		236
	],
	"./00002/00002-10/00002-10-01/module.js": [
		1372,
		9,
		236
	],
	"./00002/00002-10/00002-10-02/0.jpg": [
		6924,
		7,
		5601
	],
	"./00002/00002-10/00002-10-02/1.jpg": [
		8987,
		7,
		9009
	],
	"./00002/00002-10/00002-10-02/2.jpg": [
		8988,
		7,
		9010
	],
	"./00002/00002-10/00002-10-02/3.jpg": [
		8989,
		7,
		9011
	],
	"./00002/00002-10/00002-10-02/4.jpg": [
		8990,
		7,
		9012
	],
	"./00002/00002-10/00002-10-02/5.jpg": [
		8991,
		7,
		9013
	],
	"./00002/00002-10/00002-10-02/6.jpg": [
		8992,
		7,
		9014
	],
	"./00002/00002-10/00002-10-02/7.jpg": [
		8993,
		7,
		9015
	],
	"./00002/00002-10/00002-10-02/animals with spots.mp3": [
		4140,
		7,
		2815
	],
	"./00002/00002-10/00002-10-02/intro.mp3": [
		572,
		7
	],
	"./00002/00002-10/00002-10-02/look at the deer.mp3": [
		4141,
		7,
		2816
	],
	"./00002/00002-10/00002-10-02/look at the dinosaur.mp3": [
		4142,
		7,
		2817
	],
	"./00002/00002-10/00002-10-02/look at the giraffe.mp3": [
		4143,
		7,
		2818
	],
	"./00002/00002-10/00002-10-02/look at the ladybug.mp3": [
		4144,
		7,
		2819
	],
	"./00002/00002-10/00002-10-02/look at the raccoon.mp3": [
		4145,
		7,
		2820
	],
	"./00002/00002-10/00002-10-02/look at the tiger.mp3": [
		4146,
		7,
		2821
	],
	"./00002/00002-10/00002-10-02/look at the zebra.mp3": [
		4147,
		7,
		2822
	],
	"./00002/00002-10/00002-10-02/main idea.mp3": [
		953,
		7
	],
	"./00002/00002-10/00002-10-02/module": [
		1373,
		9,
		237
	],
	"./00002/00002-10/00002-10-02/module.js": [
		1373,
		9,
		237
	],
	"./00002/00002-10/00002-10-02/stripes and spots.mp3": [
		4148,
		7,
		2823
	],
	"./00002/00002-10/00002-10-02/the deer has spots.mp3": [
		4149,
		7,
		2824
	],
	"./00002/00002-10/00002-10-02/the dinosaur has spots too.mp3": [
		4150,
		7,
		2825
	],
	"./00002/00002-10/00002-10-02/the giraffe has spots.mp3": [
		4151,
		7,
		2826
	],
	"./00002/00002-10/00002-10-02/the ladybug has spots.mp3": [
		4152,
		7,
		2827
	],
	"./00002/00002-10/00002-10-02/the raccoon has stripes.mp3": [
		4153,
		7,
		2828
	],
	"./00002/00002-10/00002-10-02/the tiger has stripes.mp3": [
		4154,
		7,
		2829
	],
	"./00002/00002-10/00002-10-02/the zebra has stripes.mp3": [
		4155,
		7,
		2830
	],
	"./00002/00002-10/00002-10-03/0.jpg": [
		6925,
		7,
		5602
	],
	"./00002/00002-10/00002-10-03/1.jpg": [
		8994,
		7,
		9016
	],
	"./00002/00002-10/00002-10-03/2.jpg": [
		8995,
		7,
		9017
	],
	"./00002/00002-10/00002-10-03/3.jpg": [
		8996,
		7,
		9018
	],
	"./00002/00002-10/00002-10-03/4.jpg": [
		8997,
		7,
		9019
	],
	"./00002/00002-10/00002-10-03/5.jpg": [
		8998,
		7,
		9020
	],
	"./00002/00002-10/00002-10-03/6.jpg": [
		8999,
		7,
		9021
	],
	"./00002/00002-10/00002-10-03/7.jpg": [
		9000,
		7,
		9022
	],
	"./00002/00002-10/00002-10-03/animals with 2 eyes.mp3": [
		4156,
		7,
		2831
	],
	"./00002/00002-10/00002-10-03/eyes.mp3": [
		4157,
		7,
		2832
	],
	"./00002/00002-10/00002-10-03/i am a frog.mp3": [
		4158,
		7,
		2833
	],
	"./00002/00002-10/00002-10-03/i am a grasshopper.mp3": [
		4159,
		7,
		2834
	],
	"./00002/00002-10/00002-10-03/i am a hammerhead shark.mp3": [
		4160,
		7,
		2835
	],
	"./00002/00002-10/00002-10-03/i am a monster.mp3": [
		4161,
		7,
		2836
	],
	"./00002/00002-10/00002-10-03/i am a spider.mp3": [
		4162,
		7,
		2837
	],
	"./00002/00002-10/00002-10-03/i am a starfish.mp3": [
		4163,
		7,
		2838
	],
	"./00002/00002-10/00002-10-03/i am an owl.mp3": [
		4164,
		7,
		2839
	],
	"./00002/00002-10/00002-10-03/i have 10 eyes.mp3": [
		4165,
		7,
		2840
	],
	"./00002/00002-10/00002-10-03/i have 2 eyes.mp3": [
		4166,
		7,
		2841
	],
	"./00002/00002-10/00002-10-03/i have 5 eyes.mp3": [
		4167,
		7,
		2842
	],
	"./00002/00002-10/00002-10-03/i have 8 eyes.mp3": [
		4168,
		7,
		2843
	],
	"./00002/00002-10/00002-10-03/intro.mp3": [
		573,
		7
	],
	"./00002/00002-10/00002-10-03/main idea.mp3": [
		954,
		7
	],
	"./00002/00002-10/00002-10-03/module": [
		1374,
		9,
		238
	],
	"./00002/00002-10/00002-10-03/module.js": [
		1374,
		9,
		238
	],
	"./00002/00002-10/00002-10-04/0.jpg": [
		6926,
		7,
		5603
	],
	"./00002/00002-10/00002-10-04/1.jpg": [
		9001,
		7,
		9023
	],
	"./00002/00002-10/00002-10-04/2.jpg": [
		9002,
		7,
		9024
	],
	"./00002/00002-10/00002-10-04/3.jpg": [
		9003,
		7,
		9025
	],
	"./00002/00002-10/00002-10-04/4.jpg": [
		9004,
		7,
		9026
	],
	"./00002/00002-10/00002-10-04/5.jpg": [
		9005,
		7,
		9027
	],
	"./00002/00002-10/00002-10-04/6.jpg": [
		9006,
		7,
		9028
	],
	"./00002/00002-10/00002-10-04/7.jpg": [
		9007,
		7,
		9029
	],
	"./00002/00002-10/00002-10-04/animals with 2 horns.mp3": [
		4169,
		7,
		2844
	],
	"./00002/00002-10/00002-10-04/here is a cow.mp3": [
		4170,
		7,
		2845
	],
	"./00002/00002-10/00002-10-04/here is a dinosaur.mp3": [
		4171,
		7,
		2846
	],
	"./00002/00002-10/00002-10-04/here is a giraffe.mp3": [
		4172,
		7,
		2847
	],
	"./00002/00002-10/00002-10-04/here is a goat.mp3": [
		4173,
		7,
		2848
	],
	"./00002/00002-10/00002-10-04/here is a monster.mp3": [
		4174,
		7,
		2849
	],
	"./00002/00002-10/00002-10-04/here is a rhino.mp3": [
		4175,
		7,
		2850
	],
	"./00002/00002-10/00002-10-04/here is a unicorn.mp3": [
		4176,
		7,
		2851
	],
	"./00002/00002-10/00002-10-04/horns.mp3": [
		4177,
		7,
		2852
	],
	"./00002/00002-10/00002-10-04/intro.mp3": [
		574,
		7
	],
	"./00002/00002-10/00002-10-04/main idea.mp3": [
		955,
		7
	],
	"./00002/00002-10/00002-10-04/module": [
		1375,
		9,
		239
	],
	"./00002/00002-10/00002-10-04/module.js": [
		1375,
		9,
		239
	],
	"./00002/00002-10/00002-10-04/the cow has 2 horns.mp3": [
		4178,
		7,
		2853
	],
	"./00002/00002-10/00002-10-04/the dinosaur has 3 horns.mp3": [
		4179,
		7,
		2854
	],
	"./00002/00002-10/00002-10-04/the giraffe has 2 horns.mp3": [
		4180,
		7,
		2855
	],
	"./00002/00002-10/00002-10-04/the goat has 2 horns.mp3": [
		4181,
		7,
		2856
	],
	"./00002/00002-10/00002-10-04/the monster has horns too.mp3": [
		4182,
		7,
		2857
	],
	"./00002/00002-10/00002-10-04/the rhino has 2 horns.mp3": [
		4183,
		7,
		2858
	],
	"./00002/00002-10/00002-10-04/the unicorn has 1 horn.mp3": [
		4184,
		7,
		2859
	],
	"./00002/00002-10/00002-10-05/0.jpg": [
		6927,
		7,
		5604
	],
	"./00002/00002-10/00002-10-05/1.jpg": [
		9008,
		7,
		9030
	],
	"./00002/00002-10/00002-10-05/2.jpg": [
		9009,
		7,
		9031
	],
	"./00002/00002-10/00002-10-05/3.jpg": [
		9010,
		7,
		9032
	],
	"./00002/00002-10/00002-10-05/4.jpg": [
		9011,
		7,
		9033
	],
	"./00002/00002-10/00002-10-05/5.jpg": [
		9012,
		7,
		9034
	],
	"./00002/00002-10/00002-10-05/6.jpg": [
		9013,
		7,
		9035
	],
	"./00002/00002-10/00002-10-05/7.jpg": [
		9014,
		7,
		9036
	],
	"./00002/00002-10/00002-10-05/animals with long necks.mp3": [
		4185,
		7,
		2860
	],
	"./00002/00002-10/00002-10-05/i can see a camel.mp3": [
		4186,
		7,
		2861
	],
	"./00002/00002-10/00002-10-05/i can see a dinosaur.mp3": [
		4187,
		7,
		2862
	],
	"./00002/00002-10/00002-10-05/i can see a flamingo.mp3": [
		4188,
		7,
		2863
	],
	"./00002/00002-10/00002-10-05/i can see a giraffe.mp3": [
		4189,
		7,
		2864
	],
	"./00002/00002-10/00002-10-05/i can see a goose.mp3": [
		4190,
		7,
		2865
	],
	"./00002/00002-10/00002-10-05/i can see a pig.mp3": [
		4191,
		7,
		2866
	],
	"./00002/00002-10/00002-10-05/i can see a rhino.mp3": [
		4192,
		7,
		2867
	],
	"./00002/00002-10/00002-10-05/i can see a seal.mp3": [
		4193,
		7,
		2868
	],
	"./00002/00002-10/00002-10-05/i can see a snake.mp3": [
		4194,
		7,
		2869
	],
	"./00002/00002-10/00002-10-05/i can see an ostrich.mp3": [
		4195,
		7,
		2870
	],
	"./00002/00002-10/00002-10-05/intro.mp3": [
		575,
		7
	],
	"./00002/00002-10/00002-10-05/main idea.mp3": [
		956,
		7
	],
	"./00002/00002-10/00002-10-05/module": [
		1376,
		9,
		240
	],
	"./00002/00002-10/00002-10-05/module.js": [
		1376,
		9,
		240
	],
	"./00002/00002-10/00002-10-05/necks.mp3": [
		4196,
		7,
		2871
	],
	"./00002/00002-10/00002-10-05/the dinosaur has a long neck too.mp3": [
		4197,
		7,
		2872
	],
	"./00002/00002-10/00002-10-05/the giraffe has a long neck.mp3": [
		4198,
		7,
		2873
	],
	"./00002/00002-10/00002-10-05/the goose has a long neck.mp3": [
		4199,
		7,
		2874
	],
	"./00002/00002-10/00002-10-05/the ostrich has a long neck.mp3": [
		4200,
		7,
		2875
	],
	"./00002/00002-10/00002-10-05/the pig has a short neck.mp3": [
		4201,
		7,
		2876
	],
	"./00002/00002-10/00002-10-05/the rhino has a short neck.mp3": [
		4202,
		7,
		2877
	],
	"./00002/00002-10/00002-10-05/the seal has a short neck.mp3": [
		4203,
		7,
		2878
	],
	"./00002/00002-10/00002-10-06/0.jpg": [
		6928,
		7,
		5605
	],
	"./00002/00002-10/00002-10-06/1.jpg": [
		9015,
		7,
		9037
	],
	"./00002/00002-10/00002-10-06/2.jpg": [
		9016,
		7,
		9038
	],
	"./00002/00002-10/00002-10-06/3.jpg": [
		9017,
		7,
		9039
	],
	"./00002/00002-10/00002-10-06/4.jpg": [
		9018,
		7,
		9040
	],
	"./00002/00002-10/00002-10-06/5.jpg": [
		9019,
		7,
		9041
	],
	"./00002/00002-10/00002-10-06/6.jpg": [
		9020,
		7,
		9042
	],
	"./00002/00002-10/00002-10-06/7.jpg": [
		9021,
		7,
		9043
	],
	"./00002/00002-10/00002-10-06/animals we saw in the book.mp3": [
		4204,
		7,
		2879
	],
	"./00002/00002-10/00002-10-06/animals with long teeth.mp3": [
		4205,
		7,
		2880
	],
	"./00002/00002-10/00002-10-06/intro.mp3": [
		576,
		7
	],
	"./00002/00002-10/00002-10-06/look at the alligator.mp3": [
		4206,
		7,
		2881
	],
	"./00002/00002-10/00002-10-06/look at the bat.mp3": [
		4207,
		7,
		2882
	],
	"./00002/00002-10/00002-10-06/look at the beaver.mp3": [
		4208,
		7,
		2883
	],
	"./00002/00002-10/00002-10-06/look at the dinosaur.mp3": [
		4209,
		7,
		2884
	],
	"./00002/00002-10/00002-10-06/look at the eel.mp3": [
		4210,
		7,
		2885
	],
	"./00002/00002-10/00002-10-06/look at the elephant.mp3": [
		4211,
		7,
		2886
	],
	"./00002/00002-10/00002-10-06/look at the walrus.mp3": [
		4212,
		7,
		2887
	],
	"./00002/00002-10/00002-10-06/main idea.mp3": [
		957,
		7
	],
	"./00002/00002-10/00002-10-06/module": [
		1377,
		9,
		241
	],
	"./00002/00002-10/00002-10-06/module.js": [
		1377,
		9,
		241
	],
	"./00002/00002-10/00002-10-06/teeth.mp3": [
		4213,
		7,
		2888
	],
	"./00002/00002-10/00002-10-06/the alligator has sharp teeth.mp3": [
		4214,
		7,
		2889
	],
	"./00002/00002-10/00002-10-06/the bat has sharp teeth.mp3": [
		4215,
		7,
		2890
	],
	"./00002/00002-10/00002-10-06/the beaver has long teeth.mp3": [
		4216,
		7,
		2891
	],
	"./00002/00002-10/00002-10-06/the bird has no teeth.mp3": [
		4217,
		7,
		2892
	],
	"./00002/00002-10/00002-10-06/the dinosaur has sharp teeth.mp3": [
		4218,
		7,
		2893
	],
	"./00002/00002-10/00002-10-06/the eel has sharp teeth.mp3": [
		4219,
		7,
		2894
	],
	"./00002/00002-10/00002-10-06/the elephant has long teeth.mp3": [
		4220,
		7,
		2895
	],
	"./00002/00002-10/00002-10-06/the shark has sharp teeth.mp3": [
		4221,
		7,
		2896
	],
	"./00002/00002-10/00002-10-06/the walrus has long teeth.mp3": [
		4222,
		7,
		2897
	],
	"./00002/00002-10/00002-10-07/0.jpg": [
		6929,
		7,
		5606
	],
	"./00002/00002-10/00002-10-07/1.jpg": [
		9022,
		7,
		9044
	],
	"./00002/00002-10/00002-10-07/2.jpg": [
		9023,
		7,
		9045
	],
	"./00002/00002-10/00002-10-07/3.jpg": [
		9024,
		7,
		9046
	],
	"./00002/00002-10/00002-10-07/4.jpg": [
		9025,
		7,
		9047
	],
	"./00002/00002-10/00002-10-07/5.jpg": [
		9026,
		7,
		9048
	],
	"./00002/00002-10/00002-10-07/6.jpg": [
		9027,
		7,
		9049
	],
	"./00002/00002-10/00002-10-07/7.jpg": [
		9028,
		7,
		9050
	],
	"./00002/00002-10/00002-10-07/animals with 2 feet.mp3": [
		4223,
		7,
		2898
	],
	"./00002/00002-10/00002-10-07/feet.mp3": [
		4224,
		7,
		2899
	],
	"./00002/00002-10/00002-10-07/i have 1 foot said the slug.mp3": [
		4225,
		7,
		2900
	],
	"./00002/00002-10/00002-10-07/i have 1 foot said the snail.mp3": [
		4226,
		7,
		2901
	],
	"./00002/00002-10/00002-10-07/i have 2 feet said the bird.mp3": [
		4227,
		7,
		2902
	],
	"./00002/00002-10/00002-10-07/i have 2 feet said the duck.mp3": [
		4228,
		7,
		2903
	],
	"./00002/00002-10/00002-10-07/i have 4 feet said the frog.mp3": [
		4229,
		7,
		2904
	],
	"./00002/00002-10/00002-10-07/i have 4 feet said the raccoon.mp3": [
		4230,
		7,
		2905
	],
	"./00002/00002-10/00002-10-07/i have no feet said the whale.mp3": [
		4231,
		7,
		2906
	],
	"./00002/00002-10/00002-10-07/intro.mp3": [
		577,
		7
	],
	"./00002/00002-10/00002-10-07/look at me.mp3": [
		4232,
		7,
		2907
	],
	"./00002/00002-10/00002-10-07/main idea.mp3": [
		958,
		7
	],
	"./00002/00002-10/00002-10-07/module": [
		1378,
		9,
		242
	],
	"./00002/00002-10/00002-10-07/module.js": [
		1378,
		9,
		242
	],
	"./00002/00002-10/00002-10-08/0.jpg": [
		6930,
		7,
		5607
	],
	"./00002/00002-10/00002-10-08/1.jpg": [
		9029,
		7,
		9051
	],
	"./00002/00002-10/00002-10-08/2.jpg": [
		9030,
		7,
		9052
	],
	"./00002/00002-10/00002-10-08/3.jpg": [
		9031,
		7,
		9053
	],
	"./00002/00002-10/00002-10-08/4.jpg": [
		9032,
		7,
		9054
	],
	"./00002/00002-10/00002-10-08/5.jpg": [
		9033,
		7,
		9055
	],
	"./00002/00002-10/00002-10-08/6.jpg": [
		9034,
		7,
		9056
	],
	"./00002/00002-10/00002-10-08/7.jpg": [
		9035,
		7,
		9057
	],
	"./00002/00002-10/00002-10-08/animals with shells.mp3": [
		4233,
		7,
		2908
	],
	"./00002/00002-10/00002-10-08/i am a crab.mp3": [
		4234,
		7,
		2909
	],
	"./00002/00002-10/00002-10-08/i am a hermit crab.mp3": [
		4235,
		7,
		2910
	],
	"./00002/00002-10/00002-10-08/i am a lobster.mp3": [
		4236,
		7,
		2911
	],
	"./00002/00002-10/00002-10-08/i am a sea turtle.mp3": [
		4237,
		7,
		2912
	],
	"./00002/00002-10/00002-10-08/i am a shrimp.mp3": [
		4238,
		7,
		2913
	],
	"./00002/00002-10/00002-10-08/i am a slug.mp3": [
		4239,
		7,
		2914
	],
	"./00002/00002-10/00002-10-08/i am a snail.mp3": [
		4240,
		7,
		2915
	],
	"./00002/00002-10/00002-10-08/i am a turtle.mp3": [
		4241,
		7,
		2916
	],
	"./00002/00002-10/00002-10-08/i do not have a shell.mp3": [
		4242,
		7,
		2917
	],
	"./00002/00002-10/00002-10-08/intro.mp3": [
		578,
		7
	],
	"./00002/00002-10/00002-10-08/look at my shell.mp3": [
		4243,
		7,
		2918
	],
	"./00002/00002-10/00002-10-08/main idea.mp3": [
		959,
		7
	],
	"./00002/00002-10/00002-10-08/module": [
		1379,
		9,
		243
	],
	"./00002/00002-10/00002-10-08/module.js": [
		1379,
		9,
		243
	],
	"./00002/00002-10/00002-10-08/shells.mp3": [
		4244,
		7,
		2919
	],
	"./00002/00002-10/00002-10-09/0.jpg": [
		6931,
		7,
		5608
	],
	"./00002/00002-10/00002-10-09/1.jpg": [
		9036,
		7,
		9058
	],
	"./00002/00002-10/00002-10-09/2.jpg": [
		9037,
		7,
		9059
	],
	"./00002/00002-10/00002-10-09/3.jpg": [
		9038,
		7,
		9060
	],
	"./00002/00002-10/00002-10-09/4.jpg": [
		9039,
		7,
		9061
	],
	"./00002/00002-10/00002-10-09/5.jpg": [
		9040,
		7,
		9062
	],
	"./00002/00002-10/00002-10-09/6.jpg": [
		9041,
		7,
		9063
	],
	"./00002/00002-10/00002-10-09/7.jpg": [
		9042,
		7,
		9064
	],
	"./00002/00002-10/00002-10-09/animals with long noses.mp3": [
		4245,
		7,
		2920
	],
	"./00002/00002-10/00002-10-09/he has a long nose.mp3": [
		4246,
		7,
		2921
	],
	"./00002/00002-10/00002-10-09/i see the alligator.mp3": [
		4247,
		7,
		2922
	],
	"./00002/00002-10/00002-10-09/i see the anteater.mp3": [
		4248,
		7,
		2923
	],
	"./00002/00002-10/00002-10-09/i see the dog.mp3": [
		4249,
		7,
		2924
	],
	"./00002/00002-10/00002-10-09/i see the elephant.mp3": [
		4250,
		7,
		2925
	],
	"./00002/00002-10/00002-10-09/i see the monster.mp3": [
		4251,
		7,
		2926
	],
	"./00002/00002-10/00002-10-09/i see the seahorse.mp3": [
		4252,
		7,
		2927
	],
	"./00002/00002-10/00002-10-09/i see the swordfish.mp3": [
		4253,
		7,
		2928
	],
	"./00002/00002-10/00002-10-09/intro.mp3": [
		579,
		7
	],
	"./00002/00002-10/00002-10-09/main idea.mp3": [
		960,
		7
	],
	"./00002/00002-10/00002-10-09/module": [
		1380,
		9,
		244
	],
	"./00002/00002-10/00002-10-09/module.js": [
		1380,
		9,
		244
	],
	"./00002/00002-10/00002-10-09/noses.mp3": [
		4254,
		7,
		2929
	],
	"./00002/00002-10/00002-10-09/she has a long nose.mp3": [
		4255,
		7,
		2930
	],
	"./00002/00002-10/00002-10-10/0.jpg": [
		6932,
		7,
		5609
	],
	"./00002/00002-10/00002-10-10/1.jpg": [
		9043,
		7,
		9065
	],
	"./00002/00002-10/00002-10-10/2.jpg": [
		9044,
		7,
		9066
	],
	"./00002/00002-10/00002-10-10/3.jpg": [
		9045,
		7,
		9067
	],
	"./00002/00002-10/00002-10-10/4.jpg": [
		9046,
		7,
		9068
	],
	"./00002/00002-10/00002-10-10/5.jpg": [
		9047,
		7,
		9069
	],
	"./00002/00002-10/00002-10-10/6.jpg": [
		9048,
		7,
		9070
	],
	"./00002/00002-10/00002-10-10/7.jpg": [
		9049,
		7,
		9071
	],
	"./00002/00002-10/00002-10-10/animals with big ears.mp3": [
		4256,
		7,
		2931
	],
	"./00002/00002-10/00002-10-10/ears.mp3": [
		4257,
		7,
		2932
	],
	"./00002/00002-10/00002-10-10/intro.mp3": [
		580,
		7
	],
	"./00002/00002-10/00002-10-10/main idea.mp3": [
		961,
		7
	],
	"./00002/00002-10/00002-10-10/module": [
		1381,
		9,
		245
	],
	"./00002/00002-10/00002-10-10/module.js": [
		1381,
		9,
		245
	],
	"./00002/00002-10/00002-10-10/the bear has little ears too.mp3": [
		4258,
		7,
		2933
	],
	"./00002/00002-10/00002-10-10/the donkey has big ears too.mp3": [
		4259,
		7,
		2934
	],
	"./00002/00002-10/00002-10-10/the elephant has big ears.mp3": [
		4260,
		7,
		2935
	],
	"./00002/00002-10/00002-10-10/the kangaroo has big ears too.mp3": [
		4261,
		7,
		2936
	],
	"./00002/00002-10/00002-10-10/the rabbit has big ears.mp3": [
		4262,
		7,
		2937
	],
	"./00002/00002-10/00002-10-10/the seal has no ears.mp3": [
		4263,
		7,
		2938
	],
	"./00002/00002-10/00002-10-10/the tiger has little ears.mp3": [
		4264,
		7,
		2939
	],
	"./00002/00002-10/cover.jpg": [
		6933,
		7,
		5610
	],
	"./00002/00002-10/creature features.mp3": [
		4265,
		7,
		2940
	],
	"./00002/00002-10/unit": [
		1382,
		9,
		246
	],
	"./00002/00002-10/unit.js": [
		1382,
		9,
		246
	],
	"./00002/00002-11/00002-11-01/0.jpg": [
		6934,
		7,
		5611
	],
	"./00002/00002-11/00002-11-01/1.jpg": [
		9050,
		7,
		9072
	],
	"./00002/00002-11/00002-11-01/2.jpg": [
		9051,
		7,
		9073
	],
	"./00002/00002-11/00002-11-01/3.jpg": [
		9052,
		7,
		9074
	],
	"./00002/00002-11/00002-11-01/4.jpg": [
		9053,
		7,
		9075
	],
	"./00002/00002-11/00002-11-01/5.jpg": [
		9054,
		7,
		9076
	],
	"./00002/00002-11/00002-11-01/6.jpg": [
		9055,
		7,
		9077
	],
	"./00002/00002-11/00002-11-01/7.jpg": [
		9056,
		7,
		9078
	],
	"./00002/00002-11/00002-11-01/flying animals.mp3": [
		4266,
		7,
		2941
	],
	"./00002/00002-11/00002-11-01/intro.mp3": [
		581,
		7
	],
	"./00002/00002-11/00002-11-01/look up in the sky.mp3": [
		4267,
		7,
		2942
	],
	"./00002/00002-11/00002-11-01/main idea.mp3": [
		962,
		7
	],
	"./00002/00002-11/00002-11-01/module": [
		1383,
		9,
		247
	],
	"./00002/00002-11/00002-11-01/module.js": [
		1383,
		9,
		247
	],
	"./00002/00002-11/00002-11-01/the dragon can fly.mp3": [
		4268,
		7,
		2943
	],
	"./00002/00002-11/00002-11-01/the eagle can fly.mp3": [
		4269,
		7,
		2944
	],
	"./00002/00002-11/00002-11-01/the pig can fly.mp3": [
		4270,
		7,
		2945
	],
	"./00002/00002-11/00002-11-01/the rabbit can fly.mp3": [
		4271,
		7,
		2946
	],
	"./00002/00002-11/00002-11-01/the spaceship can fly.mp3": [
		4272,
		7,
		2947
	],
	"./00002/00002-11/00002-11-01/the tiger can fly.mp3": [
		4273,
		7,
		2948
	],
	"./00002/00002-11/00002-11-01/the unicorn can fly.mp3": [
		4274,
		7,
		2949
	],
	"./00002/00002-11/00002-11-01/what can fly.mp3": [
		4275,
		7,
		2950
	],
	"./00002/00002-11/00002-11-02/0.jpg": [
		6935,
		7,
		5612
	],
	"./00002/00002-11/00002-11-02/1.jpg": [
		9057,
		7,
		9079
	],
	"./00002/00002-11/00002-11-02/2.jpg": [
		9058,
		7,
		9080
	],
	"./00002/00002-11/00002-11-02/3.jpg": [
		9059,
		7,
		9081
	],
	"./00002/00002-11/00002-11-02/4.jpg": [
		9060,
		7,
		9082
	],
	"./00002/00002-11/00002-11-02/5 little dinosaurs.mp3": [
		4276,
		7,
		2951
	],
	"./00002/00002-11/00002-11-02/5.jpg": [
		9061,
		7,
		9083
	],
	"./00002/00002-11/00002-11-02/6.jpg": [
		9062,
		7,
		9084
	],
	"./00002/00002-11/00002-11-02/7.jpg": [
		9063,
		7,
		9085
	],
	"./00002/00002-11/00002-11-02/dinosaurs.mp3": [
		4277,
		7,
		2952
	],
	"./00002/00002-11/00002-11-02/here comes 1 more.mp3": [
		4278,
		7,
		2953
	],
	"./00002/00002-11/00002-11-02/i see 0 little dinosaurs.mp3": [
		4279,
		7,
		2954
	],
	"./00002/00002-11/00002-11-02/i see 1 big dinosaur.mp3": [
		4280,
		7,
		2955
	],
	"./00002/00002-11/00002-11-02/i see 1 little dinosaur.mp3": [
		4281,
		7,
		2956
	],
	"./00002/00002-11/00002-11-02/i see 2 little dinosaurs.mp3": [
		4282,
		7,
		2957
	],
	"./00002/00002-11/00002-11-02/i see 3 little dinosaurs.mp3": [
		4283,
		7,
		2958
	],
	"./00002/00002-11/00002-11-02/i see 4 little dinosaurs.mp3": [
		4284,
		7,
		2959
	],
	"./00002/00002-11/00002-11-02/i see 5 little dinosaurs.mp3": [
		4285,
		7,
		2960
	],
	"./00002/00002-11/00002-11-02/intro.mp3": [
		582,
		7
	],
	"./00002/00002-11/00002-11-02/look at the dinosaur.mp3": [
		4286,
		7,
		2961
	],
	"./00002/00002-11/00002-11-02/main idea.mp3": [
		963,
		7
	],
	"./00002/00002-11/00002-11-02/module": [
		1384,
		9,
		248
	],
	"./00002/00002-11/00002-11-02/module.js": [
		1384,
		9,
		248
	],
	"./00002/00002-11/00002-11-03/0.jpg": [
		6936,
		7,
		5613
	],
	"./00002/00002-11/00002-11-03/1.jpg": [
		9064,
		7,
		9086
	],
	"./00002/00002-11/00002-11-03/2.jpg": [
		9065,
		7,
		9087
	],
	"./00002/00002-11/00002-11-03/3.jpg": [
		9066,
		7,
		9088
	],
	"./00002/00002-11/00002-11-03/4.jpg": [
		9067,
		7,
		9089
	],
	"./00002/00002-11/00002-11-03/5.jpg": [
		9068,
		7,
		9090
	],
	"./00002/00002-11/00002-11-03/6.jpg": [
		9069,
		7,
		9091
	],
	"./00002/00002-11/00002-11-03/7.jpg": [
		9070,
		7,
		9092
	],
	"./00002/00002-11/00002-11-03/i am flying.mp3": [
		4287,
		7,
		2962
	],
	"./00002/00002-11/00002-11-03/i am running.mp3": [
		4288,
		7,
		2963
	],
	"./00002/00002-11/00002-11-03/i am skating.mp3": [
		4289,
		7,
		2964
	],
	"./00002/00002-11/00002-11-03/i am sleeping.mp3": [
		4290,
		7,
		2965
	],
	"./00002/00002-11/00002-11-03/i am sliding.mp3": [
		4291,
		7,
		2966
	],
	"./00002/00002-11/00002-11-03/i am swimming.mp3": [
		4292,
		7,
		2967
	],
	"./00002/00002-11/00002-11-03/intro.mp3": [
		583,
		7
	],
	"./00002/00002-11/00002-11-03/look at me.mp3": [
		4293,
		7,
		2968
	],
	"./00002/00002-11/00002-11-03/look at us.mp3": [
		4294,
		7,
		2969
	],
	"./00002/00002-11/00002-11-03/main idea.mp3": [
		964,
		7
	],
	"./00002/00002-11/00002-11-03/module": [
		1385,
		9,
		249
	],
	"./00002/00002-11/00002-11-03/module.js": [
		1385,
		9,
		249
	],
	"./00002/00002-11/00002-11-03/swimming animals.mp3": [
		4295,
		7,
		2970
	],
	"./00002/00002-11/00002-11-03/we are jumping.mp3": [
		4296,
		7,
		2971
	],
	"./00002/00002-11/00002-11-04/0.jpg": [
		6937,
		7,
		5614
	],
	"./00002/00002-11/00002-11-04/1.jpg": [
		9071,
		7,
		9093
	],
	"./00002/00002-11/00002-11-04/2.jpg": [
		9072,
		7,
		9094
	],
	"./00002/00002-11/00002-11-04/3.jpg": [
		9073,
		7,
		9095
	],
	"./00002/00002-11/00002-11-04/4.jpg": [
		9074,
		7,
		9096
	],
	"./00002/00002-11/00002-11-04/5.jpg": [
		9075,
		7,
		9097
	],
	"./00002/00002-11/00002-11-04/6.jpg": [
		9076,
		7,
		9098
	],
	"./00002/00002-11/00002-11-04/7.jpg": [
		9077,
		7,
		9099
	],
	"./00002/00002-11/00002-11-04/here is a hat for the snowman.mp3": [
		4297,
		7,
		2972
	],
	"./00002/00002-11/00002-11-04/here is a scarf for the snowman.mp3": [
		4298,
		7,
		2973
	],
	"./00002/00002-11/00002-11-04/intro.mp3": [
		584,
		7
	],
	"./00002/00002-11/00002-11-04/look at the big rocks.mp3": [
		4299,
		7,
		2974
	],
	"./00002/00002-11/00002-11-04/look at the big snowball.mp3": [
		4300,
		7,
		2975
	],
	"./00002/00002-11/00002-11-04/look at the big snowman.mp3": [
		4301,
		7,
		2976
	],
	"./00002/00002-11/00002-11-04/look at the carrot.mp3": [
		4302,
		7,
		2977
	],
	"./00002/00002-11/00002-11-04/look at the hat.mp3": [
		4303,
		7,
		2978
	],
	"./00002/00002-11/00002-11-04/look at the little rocks.mp3": [
		4304,
		7,
		2979
	],
	"./00002/00002-11/00002-11-04/look at the little snowball.mp3": [
		4305,
		7,
		2980
	],
	"./00002/00002-11/00002-11-04/look at the rocks.mp3": [
		4306,
		7,
		2981
	],
	"./00002/00002-11/00002-11-04/look at the scarf.mp3": [
		4307,
		7,
		2982
	],
	"./00002/00002-11/00002-11-04/look at the snowman.mp3": [
		4308,
		7,
		2983
	],
	"./00002/00002-11/00002-11-04/look at the snowmans eyes.mp3": [
		4309,
		7,
		2984
	],
	"./00002/00002-11/00002-11-04/look at the snowmans mouth.mp3": [
		4310,
		7,
		2985
	],
	"./00002/00002-11/00002-11-04/look at the snowmans nose.mp3": [
		4311,
		7,
		2986
	],
	"./00002/00002-11/00002-11-04/look said the cat.mp3": [
		4312,
		7,
		2987
	],
	"./00002/00002-11/00002-11-04/main idea.mp3": [
		965,
		7
	],
	"./00002/00002-11/00002-11-04/making a snowman.mp3": [
		4313,
		7,
		2988
	],
	"./00002/00002-11/00002-11-04/module": [
		1386,
		9,
		250
	],
	"./00002/00002-11/00002-11-04/module.js": [
		1386,
		9,
		250
	],
	"./00002/00002-11/00002-11-04/things you need to make a snowman.mp3": [
		4314,
		7,
		2989
	],
	"./00002/00002-11/00002-11-05/0.jpg": [
		6938,
		7,
		5615
	],
	"./00002/00002-11/00002-11-05/1.jpg": [
		9078,
		7,
		9100
	],
	"./00002/00002-11/00002-11-05/2.jpg": [
		9079,
		7,
		9101
	],
	"./00002/00002-11/00002-11-05/3.jpg": [
		9080,
		7,
		9102
	],
	"./00002/00002-11/00002-11-05/4.jpg": [
		9081,
		7,
		9103
	],
	"./00002/00002-11/00002-11-05/5.jpg": [
		9082,
		7,
		9104
	],
	"./00002/00002-11/00002-11-05/6.jpg": [
		9083,
		7,
		9105
	],
	"./00002/00002-11/00002-11-05/7.jpg": [
		9084,
		7,
		9106
	],
	"./00002/00002-11/00002-11-05/going up and down.mp3": [
		4315,
		7,
		2990
	],
	"./00002/00002-11/00002-11-05/intro.mp3": [
		585,
		7
	],
	"./00002/00002-11/00002-11-05/look at the cat.mp3": [
		4316,
		7,
		2991
	],
	"./00002/00002-11/00002-11-05/look at the dog.mp3": [
		4317,
		7,
		2992
	],
	"./00002/00002-11/00002-11-05/look at the mouse.mp3": [
		4318,
		7,
		2993
	],
	"./00002/00002-11/00002-11-05/main idea.mp3": [
		966,
		7
	],
	"./00002/00002-11/00002-11-05/module": [
		1387,
		9,
		251
	],
	"./00002/00002-11/00002-11-05/module.js": [
		1387,
		9,
		251
	],
	"./00002/00002-11/00002-11-05/the cat is going down.mp3": [
		4319,
		7,
		2994
	],
	"./00002/00002-11/00002-11-05/the cat is going up.mp3": [
		4320,
		7,
		2995
	],
	"./00002/00002-11/00002-11-05/the dog is going down.mp3": [
		4321,
		7,
		2996
	],
	"./00002/00002-11/00002-11-05/the dog is going up.mp3": [
		4322,
		7,
		2997
	],
	"./00002/00002-11/00002-11-05/the mouse is going down.mp3": [
		4323,
		7,
		2998
	],
	"./00002/00002-11/00002-11-05/the mouse is going up.mp3": [
		4324,
		7,
		2999
	],
	"./00002/00002-11/00002-11-05/things you can see up in the sky.mp3": [
		4325,
		7,
		3000
	],
	"./00002/00002-11/00002-11-06/0.jpg": [
		6939,
		7,
		5616
	],
	"./00002/00002-11/00002-11-06/1.jpg": [
		9085,
		7,
		9107
	],
	"./00002/00002-11/00002-11-06/2.jpg": [
		9086,
		7,
		9108
	],
	"./00002/00002-11/00002-11-06/3.jpg": [
		9087,
		7,
		9109
	],
	"./00002/00002-11/00002-11-06/4.jpg": [
		9088,
		7,
		9110
	],
	"./00002/00002-11/00002-11-06/5.jpg": [
		9089,
		7,
		9111
	],
	"./00002/00002-11/00002-11-06/6.jpg": [
		9090,
		7,
		9112
	],
	"./00002/00002-11/00002-11-06/7.jpg": [
		9091,
		7,
		9113
	],
	"./00002/00002-11/00002-11-06/here comes the cheetah.mp3": [
		4326,
		7,
		3001
	],
	"./00002/00002-11/00002-11-06/here comes the elephant.mp3": [
		4327,
		7,
		3002
	],
	"./00002/00002-11/00002-11-06/here comes the fox.mp3": [
		4328,
		7,
		3003
	],
	"./00002/00002-11/00002-11-06/here comes the giraffe.mp3": [
		4329,
		7,
		3004
	],
	"./00002/00002-11/00002-11-06/here comes the lion.mp3": [
		4330,
		7,
		3005
	],
	"./00002/00002-11/00002-11-06/here comes the ostrich.mp3": [
		4331,
		7,
		3006
	],
	"./00002/00002-11/00002-11-06/here comes the zebra.mp3": [
		4332,
		7,
		3007
	],
	"./00002/00002-11/00002-11-06/intro.mp3": [
		586,
		7
	],
	"./00002/00002-11/00002-11-06/look at the elephant.mp3": [
		4333,
		7,
		3008
	],
	"./00002/00002-11/00002-11-06/look at the fox.mp3": [
		4334,
		7,
		3009
	],
	"./00002/00002-11/00002-11-06/look at the giraffe.mp3": [
		4335,
		7,
		3010
	],
	"./00002/00002-11/00002-11-06/look at the lion.mp3": [
		4336,
		7,
		3011
	],
	"./00002/00002-11/00002-11-06/look at the zebra.mp3": [
		4337,
		7,
		3012
	],
	"./00002/00002-11/00002-11-06/look.mp3": [
		4338,
		7,
		3013
	],
	"./00002/00002-11/00002-11-06/main idea.mp3": [
		967,
		7
	],
	"./00002/00002-11/00002-11-06/module": [
		1388,
		9,
		252
	],
	"./00002/00002-11/00002-11-06/module.js": [
		1388,
		9,
		252
	],
	"./00002/00002-11/00002-11-06/the animal race.mp3": [
		4339,
		7,
		3014
	],
	"./00002/00002-11/00002-11-06/wild animals.mp3": [
		4340,
		7,
		3015
	],
	"./00002/00002-11/00002-11-07/0.jpg": [
		6940,
		7,
		5617
	],
	"./00002/00002-11/00002-11-07/1.jpg": [
		9092,
		7,
		9114
	],
	"./00002/00002-11/00002-11-07/2.jpg": [
		9093,
		7,
		9115
	],
	"./00002/00002-11/00002-11-07/3.jpg": [
		9094,
		7,
		9116
	],
	"./00002/00002-11/00002-11-07/4.jpg": [
		9095,
		7,
		9117
	],
	"./00002/00002-11/00002-11-07/5.jpg": [
		9096,
		7,
		9118
	],
	"./00002/00002-11/00002-11-07/6.jpg": [
		9097,
		7,
		9119
	],
	"./00002/00002-11/00002-11-07/7.jpg": [
		9098,
		7,
		9120
	],
	"./00002/00002-11/00002-11-07/here is my bird said the dinosaur.mp3": [
		4341,
		7,
		3016
	],
	"./00002/00002-11/00002-11-07/here is my bird said the girl.mp3": [
		4342,
		7,
		3017
	],
	"./00002/00002-11/00002-11-07/here is my bird said the monster.mp3": [
		4343,
		7,
		3018
	],
	"./00002/00002-11/00002-11-07/here is my cat said the boy.mp3": [
		4344,
		7,
		3019
	],
	"./00002/00002-11/00002-11-07/here is my cat said the monster.mp3": [
		4345,
		7,
		3020
	],
	"./00002/00002-11/00002-11-07/here is my dog said the girl.mp3": [
		4346,
		7,
		3021
	],
	"./00002/00002-11/00002-11-07/here is my dog said the monster.mp3": [
		4347,
		7,
		3022
	],
	"./00002/00002-11/00002-11-07/here is my pet.mp3": [
		4348,
		7,
		3023
	],
	"./00002/00002-11/00002-11-07/i love my bird too.mp3": [
		4349,
		7,
		3024
	],
	"./00002/00002-11/00002-11-07/i love my bird.mp3": [
		4350,
		7,
		3025
	],
	"./00002/00002-11/00002-11-07/i love my cat.mp3": [
		4351,
		7,
		3026
	],
	"./00002/00002-11/00002-11-07/i love my dog.mp3": [
		4352,
		7,
		3027
	],
	"./00002/00002-11/00002-11-07/intro.mp3": [
		587,
		7
	],
	"./00002/00002-11/00002-11-07/look at my cat.mp3": [
		4353,
		7,
		3028
	],
	"./00002/00002-11/00002-11-07/look at my dog.mp3": [
		4354,
		7,
		3029
	],
	"./00002/00002-11/00002-11-07/main idea.mp3": [
		968,
		7
	],
	"./00002/00002-11/00002-11-07/module": [
		1389,
		9,
		253
	],
	"./00002/00002-11/00002-11-07/module.js": [
		1389,
		9,
		253
	],
	"./00002/00002-11/00002-11-07/pets.mp3": [
		4355,
		7,
		3030
	],
	"./00002/00002-11/00002-11-08/0.jpg": [
		6941,
		7,
		5618
	],
	"./00002/00002-11/00002-11-08/1.jpg": [
		9099,
		7,
		9121
	],
	"./00002/00002-11/00002-11-08/2.jpg": [
		9100,
		7,
		9122
	],
	"./00002/00002-11/00002-11-08/3.jpg": [
		9101,
		7,
		9123
	],
	"./00002/00002-11/00002-11-08/4.jpg": [
		9102,
		7,
		9124
	],
	"./00002/00002-11/00002-11-08/5.jpg": [
		9103,
		7,
		9125
	],
	"./00002/00002-11/00002-11-08/6.jpg": [
		9104,
		7,
		9126
	],
	"./00002/00002-11/00002-11-08/7.jpg": [
		9105,
		7,
		9127
	],
	"./00002/00002-11/00002-11-08/can you.mp3": [
		4356,
		7,
		3031
	],
	"./00002/00002-11/00002-11-08/characters who can skate in the book.mp3": [
		4357,
		7,
		3032
	],
	"./00002/00002-11/00002-11-08/i can not skate said the bear.mp3": [
		4358,
		7,
		3033
	],
	"./00002/00002-11/00002-11-08/i can skate said the deer.mp3": [
		4359,
		7,
		3034
	],
	"./00002/00002-11/00002-11-08/i can skate said the monster.mp3": [
		4360,
		7,
		3035
	],
	"./00002/00002-11/00002-11-08/i can skate said the panda.mp3": [
		4361,
		7,
		3036
	],
	"./00002/00002-11/00002-11-08/i can skate said the penguin.mp3": [
		4362,
		7,
		3037
	],
	"./00002/00002-11/00002-11-08/intro.mp3": [
		588,
		7
	],
	"./00002/00002-11/00002-11-08/look at me.mp3": [
		4363,
		7,
		3038
	],
	"./00002/00002-11/00002-11-08/look at us.mp3": [
		4364,
		7,
		3039
	],
	"./00002/00002-11/00002-11-08/main idea.mp3": [
		969,
		7
	],
	"./00002/00002-11/00002-11-08/module": [
		1390,
		9,
		254
	],
	"./00002/00002-11/00002-11-08/module.js": [
		1390,
		9,
		254
	],
	"./00002/00002-11/00002-11-08/oh no.mp3": [
		4365,
		7,
		3040
	],
	"./00002/00002-11/00002-11-08/we can skate said the lions.mp3": [
		4366,
		7,
		3041
	],
	"./00002/00002-11/00002-11-08/we can skate said the rabbits.mp3": [
		4367,
		7,
		3042
	],
	"./00002/00002-11/00002-11-08/who can skate.mp3": [
		4368,
		7,
		3043
	],
	"./00002/00002-11/00002-11-09/0.jpg": [
		6942,
		7,
		5619
	],
	"./00002/00002-11/00002-11-09/1.jpg": [
		9106,
		7,
		9128
	],
	"./00002/00002-11/00002-11-09/2.jpg": [
		9107,
		7,
		9129
	],
	"./00002/00002-11/00002-11-09/3.jpg": [
		9108,
		7,
		9130
	],
	"./00002/00002-11/00002-11-09/4.jpg": [
		9109,
		7,
		9131
	],
	"./00002/00002-11/00002-11-09/5.jpg": [
		9110,
		7,
		9132
	],
	"./00002/00002-11/00002-11-09/6.jpg": [
		9111,
		7,
		9133
	],
	"./00002/00002-11/00002-11-09/7.jpg": [
		9112,
		7,
		9134
	],
	"./00002/00002-11/00002-11-09/animals with four legs.mp3": [
		4369,
		7,
		3044
	],
	"./00002/00002-11/00002-11-09/balloons.mp3": [
		4370,
		7,
		3045
	],
	"./00002/00002-11/00002-11-09/cat likes the orange balloon.mp3": [
		4371,
		7,
		3046
	],
	"./00002/00002-11/00002-11-09/dinosaur likes the blue balloon.mp3": [
		4372,
		7,
		3047
	],
	"./00002/00002-11/00002-11-09/dog likes the red balloon.mp3": [
		4373,
		7,
		3048
	],
	"./00002/00002-11/00002-11-09/intro.mp3": [
		589,
		7
	],
	"./00002/00002-11/00002-11-09/lion likes the yellow balloon.mp3": [
		4374,
		7,
		3049
	],
	"./00002/00002-11/00002-11-09/look at cat.mp3": [
		4375,
		7,
		3050
	],
	"./00002/00002-11/00002-11-09/look at dog.mp3": [
		4376,
		7,
		3051
	],
	"./00002/00002-11/00002-11-09/look at the dinosaur.mp3": [
		4377,
		7,
		3052
	],
	"./00002/00002-11/00002-11-09/look at the lion.mp3": [
		4378,
		7,
		3053
	],
	"./00002/00002-11/00002-11-09/look at the monkey.mp3": [
		4379,
		7,
		3054
	],
	"./00002/00002-11/00002-11-09/look at the octopus.mp3": [
		4380,
		7,
		3055
	],
	"./00002/00002-11/00002-11-09/look at the rabbit.mp3": [
		4381,
		7,
		3056
	],
	"./00002/00002-11/00002-11-09/main idea.mp3": [
		970,
		7
	],
	"./00002/00002-11/00002-11-09/module": [
		1391,
		9,
		255
	],
	"./00002/00002-11/00002-11-09/module.js": [
		1391,
		9,
		255
	],
	"./00002/00002-11/00002-11-09/monkey likes the green balloon.mp3": [
		4382,
		7,
		3057
	],
	"./00002/00002-11/00002-11-09/octopus likes the balloons.mp3": [
		4383,
		7,
		3058
	],
	"./00002/00002-11/00002-11-09/rabbit likes the pink balloon.mp3": [
		4384,
		7,
		3059
	],
	"./00002/00002-11/00002-11-10/0.jpg": [
		6943,
		7,
		5620
	],
	"./00002/00002-11/00002-11-10/1.jpg": [
		9113,
		7,
		9135
	],
	"./00002/00002-11/00002-11-10/2.jpg": [
		9114,
		7,
		9136
	],
	"./00002/00002-11/00002-11-10/3.jpg": [
		9115,
		7,
		9137
	],
	"./00002/00002-11/00002-11-10/4.jpg": [
		9116,
		7,
		9138
	],
	"./00002/00002-11/00002-11-10/5.jpg": [
		9117,
		7,
		9139
	],
	"./00002/00002-11/00002-11-10/6.jpg": [
		9118,
		7,
		9140
	],
	"./00002/00002-11/00002-11-10/7.jpg": [
		9119,
		7,
		9141
	],
	"./00002/00002-11/00002-11-10/ant sees the yellow flower.mp3": [
		4385,
		7,
		3060
	],
	"./00002/00002-11/00002-11-10/bee sees the orange flower.mp3": [
		4386,
		7,
		3061
	],
	"./00002/00002-11/00002-11-10/butterfly sees the red flower.mp3": [
		4387,
		7,
		3062
	],
	"./00002/00002-11/00002-11-10/grasshopper sees the pink flower.mp3": [
		4388,
		7,
		3063
	],
	"./00002/00002-11/00002-11-10/he likes flowers.mp3": [
		4389,
		7,
		3064
	],
	"./00002/00002-11/00002-11-10/hummingbird sees the blue flower.mp3": [
		4390,
		7,
		3065
	],
	"./00002/00002-11/00002-11-10/insects.mp3": [
		4391,
		7,
		3066
	],
	"./00002/00002-11/00002-11-10/intro.mp3": [
		590,
		7
	],
	"./00002/00002-11/00002-11-10/ladybug sees the purple flower.mp3": [
		4392,
		7,
		3067
	],
	"./00002/00002-11/00002-11-10/look at the flowers.mp3": [
		4393,
		7,
		3068
	],
	"./00002/00002-11/00002-11-10/main idea.mp3": [
		971,
		7
	],
	"./00002/00002-11/00002-11-10/module": [
		1392,
		9,
		256
	],
	"./00002/00002-11/00002-11-10/module.js": [
		1392,
		9,
		256
	],
	"./00002/00002-11/00002-11-10/she likes flowers.mp3": [
		4394,
		7,
		3069
	],
	"./00002/00002-11/00002-11-10/we see flowers.mp3": [
		4395,
		7,
		3070
	],
	"./00002/00002-11/00002-11-10/we see the flowers.mp3": [
		4396,
		7,
		3071
	],
	"./00002/00002-11/cover.jpg": [
		6944,
		7,
		5621
	],
	"./00002/00002-11/story town.mp3": [
		4397,
		7,
		3072
	],
	"./00002/00002-11/unit": [
		1393,
		9,
		257
	],
	"./00002/00002-11/unit.js": [
		1393,
		9,
		257
	],
	"./00002/00002-12/00002-12-01/0.jpg": [
		6945,
		7,
		5622
	],
	"./00002/00002-12/00002-12-01/1.jpg": [
		9120,
		7,
		9142
	],
	"./00002/00002-12/00002-12-01/2.jpg": [
		9121,
		7,
		9143
	],
	"./00002/00002-12/00002-12-01/3.jpg": [
		9122,
		7,
		9144
	],
	"./00002/00002-12/00002-12-01/4.jpg": [
		9123,
		7,
		9145
	],
	"./00002/00002-12/00002-12-01/5.jpg": [
		9124,
		7,
		9146
	],
	"./00002/00002-12/00002-12-01/6.jpg": [
		9125,
		7,
		9147
	],
	"./00002/00002-12/00002-12-01/7.jpg": [
		9126,
		7,
		9148
	],
	"./00002/00002-12/00002-12-01/alligator wants an airplane.mp3": [
		4398,
		7,
		3073
	],
	"./00002/00002-12/00002-12-01/bear wants a bike.mp3": [
		4399,
		7,
		3074
	],
	"./00002/00002-12/00002-12-01/cat wants a car.mp3": [
		4400,
		7,
		3075
	],
	"./00002/00002-12/00002-12-01/dog wants a dinosaur.mp3": [
		4401,
		7,
		3076
	],
	"./00002/00002-12/00002-12-01/fox wants a fire truck.mp3": [
		4402,
		7,
		3077
	],
	"./00002/00002-12/00002-12-01/hippo wants a helicopter.mp3": [
		4403,
		7,
		3078
	],
	"./00002/00002-12/00002-12-01/i see a wolf.mp3": [
		4404,
		7,
		3079
	],
	"./00002/00002-12/00002-12-01/intro.mp3": [
		591,
		7
	],
	"./00002/00002-12/00002-12-01/look at cat.mp3": [
		4405,
		7,
		3080
	],
	"./00002/00002-12/00002-12-01/look at dog.mp3": [
		4406,
		7,
		3081
	],
	"./00002/00002-12/00002-12-01/look at the airplane.mp3": [
		4407,
		7,
		3082
	],
	"./00002/00002-12/00002-12-01/look at the bear.mp3": [
		4408,
		7,
		3083
	],
	"./00002/00002-12/00002-12-01/look at the bike.mp3": [
		4409,
		7,
		3084
	],
	"./00002/00002-12/00002-12-01/look at the car.mp3": [
		4410,
		7,
		3085
	],
	"./00002/00002-12/00002-12-01/look at the dinosaur.mp3": [
		4411,
		7,
		3086
	],
	"./00002/00002-12/00002-12-01/look at the fox.mp3": [
		4412,
		7,
		3087
	],
	"./00002/00002-12/00002-12-01/look at the helicopter.mp3": [
		4413,
		7,
		3088
	],
	"./00002/00002-12/00002-12-01/main idea.mp3": [
		972,
		7
	],
	"./00002/00002-12/00002-12-01/module": [
		1394,
		9,
		258
	],
	"./00002/00002-12/00002-12-01/module.js": [
		1394,
		9,
		258
	],
	"./00002/00002-12/00002-12-01/toys.mp3": [
		4414,
		7,
		3089
	],
	"./00002/00002-12/00002-12-01/vehicles.mp3": [
		4415,
		7,
		3090
	],
	"./00002/00002-12/00002-12-01/wolf wants a wagon.mp3": [
		4416,
		7,
		3091
	],
	"./00002/00002-12/00002-12-02/0.jpg": [
		6946,
		7,
		5623
	],
	"./00002/00002-12/00002-12-02/1.jpg": [
		9127,
		7,
		9149
	],
	"./00002/00002-12/00002-12-02/2.jpg": [
		9128,
		7,
		9150
	],
	"./00002/00002-12/00002-12-02/3.jpg": [
		9129,
		7,
		9151
	],
	"./00002/00002-12/00002-12-02/4.jpg": [
		9130,
		7,
		9152
	],
	"./00002/00002-12/00002-12-02/5.jpg": [
		9131,
		7,
		9153
	],
	"./00002/00002-12/00002-12-02/6.jpg": [
		9132,
		7,
		9154
	],
	"./00002/00002-12/00002-12-02/7.jpg": [
		9133,
		7,
		9155
	],
	"./00002/00002-12/00002-12-02/alligator got a saxophone.mp3": [
		4417,
		7,
		3092
	],
	"./00002/00002-12/00002-12-02/bear got a guitar.mp3": [
		4418,
		7,
		3093
	],
	"./00002/00002-12/00002-12-02/beaver got a xylophone.mp3": [
		4419,
		7,
		3094
	],
	"./00002/00002-12/00002-12-02/dog got a tambourine.mp3": [
		4420,
		7,
		3095
	],
	"./00002/00002-12/00002-12-02/fox got a fiddle.mp3": [
		4421,
		7,
		3096
	],
	"./00002/00002-12/00002-12-02/i love music.mp3": [
		4422,
		7,
		3097
	],
	"./00002/00002-12/00002-12-02/intro.mp3": [
		592,
		7
	],
	"./00002/00002-12/00002-12-02/look at the banjo.mp3": [
		4423,
		7,
		3098
	],
	"./00002/00002-12/00002-12-02/look at the fiddle.mp3": [
		4424,
		7,
		3099
	],
	"./00002/00002-12/00002-12-02/look at the guitar.mp3": [
		4425,
		7,
		3100
	],
	"./00002/00002-12/00002-12-02/look at the saxophone.mp3": [
		4426,
		7,
		3101
	],
	"./00002/00002-12/00002-12-02/look at the tambourine.mp3": [
		4427,
		7,
		3102
	],
	"./00002/00002-12/00002-12-02/look at the triangle.mp3": [
		4428,
		7,
		3103
	],
	"./00002/00002-12/00002-12-02/look at the xylophone.mp3": [
		4429,
		7,
		3104
	],
	"./00002/00002-12/00002-12-02/main idea.mp3": [
		973,
		7
	],
	"./00002/00002-12/00002-12-02/module": [
		1395,
		9,
		259
	],
	"./00002/00002-12/00002-12-02/module.js": [
		1395,
		9,
		259
	],
	"./00002/00002-12/00002-12-02/monkey got a triangle.mp3": [
		4430,
		7,
		3105
	],
	"./00002/00002-12/00002-12-02/musical instruments.mp3": [
		4431,
		7,
		3106
	],
	"./00002/00002-12/00002-12-02/raccoon got a banjo.mp3": [
		4432,
		7,
		3107
	],
	"./00002/00002-12/00002-12-03/0.jpg": [
		6947,
		7,
		5624
	],
	"./00002/00002-12/00002-12-03/1.jpg": [
		9134,
		7,
		9156
	],
	"./00002/00002-12/00002-12-03/2.jpg": [
		9135,
		7,
		9157
	],
	"./00002/00002-12/00002-12-03/3.jpg": [
		9136,
		7,
		9158
	],
	"./00002/00002-12/00002-12-03/4.jpg": [
		9137,
		7,
		9159
	],
	"./00002/00002-12/00002-12-03/5.jpg": [
		9138,
		7,
		9160
	],
	"./00002/00002-12/00002-12-03/6.jpg": [
		9139,
		7,
		9161
	],
	"./00002/00002-12/00002-12-03/7.jpg": [
		9140,
		7,
		9162
	],
	"./00002/00002-12/00002-12-03/alligator is going to the party.mp3": [
		4433,
		7,
		3108
	],
	"./00002/00002-12/00002-12-03/cat is going to the party.mp3": [
		4434,
		7,
		3109
	],
	"./00002/00002-12/00002-12-03/crocodile is going to the party.mp3": [
		4435,
		7,
		3110
	],
	"./00002/00002-12/00002-12-03/elephant is going to the party.mp3": [
		4436,
		7,
		3111
	],
	"./00002/00002-12/00002-12-03/going to the party.mp3": [
		4437,
		7,
		3112
	],
	"./00002/00002-12/00002-12-03/here is the party.mp3": [
		4438,
		7,
		3113
	],
	"./00002/00002-12/00002-12-03/intro.mp3": [
		593,
		7
	],
	"./00002/00002-12/00002-12-03/jaguar is going to the party.mp3": [
		4439,
		7,
		3114
	],
	"./00002/00002-12/00002-12-03/look at alligator.mp3": [
		4440,
		7,
		3115
	],
	"./00002/00002-12/00002-12-03/look at cat.mp3": [
		4441,
		7,
		3116
	],
	"./00002/00002-12/00002-12-03/look at dog.mp3": [
		4442,
		7,
		3117
	],
	"./00002/00002-12/00002-12-03/look at elephant.mp3": [
		4443,
		7,
		3118
	],
	"./00002/00002-12/00002-12-03/look at the jaguar.mp3": [
		4444,
		7,
		3119
	],
	"./00002/00002-12/00002-12-03/look at the tiger.mp3": [
		4445,
		7,
		3120
	],
	"./00002/00002-12/00002-12-03/look at the zebra.mp3": [
		4446,
		7,
		3121
	],
	"./00002/00002-12/00002-12-03/main idea.mp3": [
		974,
		7
	],
	"./00002/00002-12/00002-12-03/module": [
		1396,
		9,
		260
	],
	"./00002/00002-12/00002-12-03/module.js": [
		1396,
		9,
		260
	],
	"./00002/00002-12/00002-12-03/panda is going to the party.mp3": [
		4447,
		7,
		3122
	],
	"./00002/00002-12/00002-12-03/tiger is going to the party.mp3": [
		4448,
		7,
		3123
	],
	"./00002/00002-12/00002-12-03/wild animals.mp3": [
		4449,
		7,
		3124
	],
	"./00002/00002-12/00002-12-03/zebra is going to the party.mp3": [
		4450,
		7,
		3125
	],
	"./00002/00002-12/00002-12-04/0.jpg": [
		6948,
		7,
		5625
	],
	"./00002/00002-12/00002-12-04/1.jpg": [
		9141,
		7,
		9163
	],
	"./00002/00002-12/00002-12-04/2.jpg": [
		9142,
		7,
		9164
	],
	"./00002/00002-12/00002-12-04/3.jpg": [
		9143,
		7,
		9165
	],
	"./00002/00002-12/00002-12-04/4.jpg": [
		9144,
		7,
		9166
	],
	"./00002/00002-12/00002-12-04/5.jpg": [
		9145,
		7,
		9167
	],
	"./00002/00002-12/00002-12-04/6.jpg": [
		9146,
		7,
		9168
	],
	"./00002/00002-12/00002-12-04/7.jpg": [
		9147,
		7,
		9169
	],
	"./00002/00002-12/00002-12-04/a friend for yellow duck.mp3": [
		4451,
		7,
		3126
	],
	"./00002/00002-12/00002-12-04/animals with 4 legs.mp3": [
		4452,
		7,
		3127
	],
	"./00002/00002-12/00002-12-04/intro.mp3": [
		594,
		7
	],
	"./00002/00002-12/00002-12-04/main idea.mp3": [
		975,
		7
	],
	"./00002/00002-12/00002-12-04/module": [
		1397,
		9,
		261
	],
	"./00002/00002-12/00002-12-04/module.js": [
		1397,
		9,
		261
	],
	"./00002/00002-12/00002-12-04/no i will not said skunk.mp3": [
		4453,
		7,
		3128
	],
	"./00002/00002-12/00002-12-04/no no no said sheep.mp3": [
		4454,
		7,
		3129
	],
	"./00002/00002-12/00002-12-04/no said fox.mp3": [
		4455,
		7,
		3130
	],
	"./00002/00002-12/00002-12-04/no said squirrel.mp3": [
		4456,
		7,
		3131
	],
	"./00002/00002-12/00002-12-04/no said the frog.mp3": [
		4457,
		7,
		3132
	],
	"./00002/00002-12/00002-12-04/not me said deer.mp3": [
		4458,
		7,
		3133
	],
	"./00002/00002-12/00002-12-04/will you play with me said yellow duck.mp3": [
		4459,
		7,
		3134
	],
	"./00002/00002-12/00002-12-04/yes said brown duck.mp3": [
		4460,
		7,
		3135
	],
	"./00002/00002-12/00002-12-05/0.jpg": [
		6949,
		7,
		5626
	],
	"./00002/00002-12/00002-12-05/1.jpg": [
		9148,
		7,
		9170
	],
	"./00002/00002-12/00002-12-05/2.jpg": [
		9149,
		7,
		9171
	],
	"./00002/00002-12/00002-12-05/3.jpg": [
		9150,
		7,
		9172
	],
	"./00002/00002-12/00002-12-05/4.jpg": [
		9151,
		7,
		9173
	],
	"./00002/00002-12/00002-12-05/5.jpg": [
		9152,
		7,
		9174
	],
	"./00002/00002-12/00002-12-05/6.jpg": [
		9153,
		7,
		9175
	],
	"./00002/00002-12/00002-12-05/7.jpg": [
		9154,
		7,
		9176
	],
	"./00002/00002-12/00002-12-05/cat likes to play soccer.mp3": [
		4461,
		7,
		3136
	],
	"./00002/00002-12/00002-12-05/fox likes to play soccer.mp3": [
		4462,
		7,
		3137
	],
	"./00002/00002-12/00002-12-05/goal said snake.mp3": [
		4463,
		7,
		3138
	],
	"./00002/00002-12/00002-12-05/intro.mp3": [
		595,
		7
	],
	"./00002/00002-12/00002-12-05/lion kicks the ball to skunk.mp3": [
		4464,
		7,
		3139
	],
	"./00002/00002-12/00002-12-05/lion likes to play soccer.mp3": [
		4465,
		7,
		3140
	],
	"./00002/00002-12/00002-12-05/main idea.mp3": [
		976,
		7
	],
	"./00002/00002-12/00002-12-05/module": [
		1398,
		9,
		262
	],
	"./00002/00002-12/00002-12-05/module.js": [
		1398,
		9,
		262
	],
	"./00002/00002-12/00002-12-05/rabbit kicks the ball at the goal.mp3": [
		4466,
		7,
		3141
	],
	"./00002/00002-12/00002-12-05/rabbit kicks the ball to lion.mp3": [
		4467,
		7,
		3142
	],
	"./00002/00002-12/00002-12-05/rabbit likes to play soccer too.mp3": [
		4468,
		7,
		3143
	],
	"./00002/00002-12/00002-12-05/sheep likes to play soccer.mp3": [
		4469,
		7,
		3144
	],
	"./00002/00002-12/00002-12-05/skunk kicks the ball to rabbit.mp3": [
		4470,
		7,
		3145
	],
	"./00002/00002-12/00002-12-05/skunk likes to play soccer.mp3": [
		4471,
		7,
		3146
	],
	"./00002/00002-12/00002-12-05/the ball goes in the goal.mp3": [
		4472,
		7,
		3147
	],
	"./00002/00002-12/00002-12-05/the soccer game.mp3": [
		4473,
		7,
		3148
	],
	"./00002/00002-12/00002-12-05/tiger likes to play soccer.mp3": [
		4474,
		7,
		3149
	],
	"./00002/00002-12/00002-12-05/wild animals.mp3": [
		4475,
		7,
		3150
	],
	"./00002/00002-12/00002-12-06/0.jpg": [
		6950,
		7,
		5627
	],
	"./00002/00002-12/00002-12-06/1.jpg": [
		9155,
		7,
		9177
	],
	"./00002/00002-12/00002-12-06/2.jpg": [
		9156,
		7,
		9178
	],
	"./00002/00002-12/00002-12-06/3.jpg": [
		9157,
		7,
		9179
	],
	"./00002/00002-12/00002-12-06/4.jpg": [
		9158,
		7,
		9180
	],
	"./00002/00002-12/00002-12-06/5.jpg": [
		9159,
		7,
		9181
	],
	"./00002/00002-12/00002-12-06/6.jpg": [
		9160,
		7,
		9182
	],
	"./00002/00002-12/00002-12-06/7.jpg": [
		9161,
		7,
		9183
	],
	"./00002/00002-12/00002-12-06/baby animals.mp3": [
		4476,
		7,
		3151
	],
	"./00002/00002-12/00002-12-06/can i be your mother said the rabbit.mp3": [
		4477,
		7,
		3152
	],
	"./00002/00002-12/00002-12-06/can i be your mother.mp3": [
		4478,
		7,
		3153
	],
	"./00002/00002-12/00002-12-06/intro.mp3": [
		596,
		7
	],
	"./00002/00002-12/00002-12-06/main idea.mp3": [
		977,
		7
	],
	"./00002/00002-12/00002-12-06/module": [
		1399,
		9,
		263
	],
	"./00002/00002-12/00002-12-06/module.js": [
		1399,
		9,
		263
	],
	"./00002/00002-12/00002-12-06/my mother is a cat.mp3": [
		4479,
		7,
		3154
	],
	"./00002/00002-12/00002-12-06/my mother is a chicken.mp3": [
		4480,
		7,
		3155
	],
	"./00002/00002-12/00002-12-06/my mother is a dog.mp3": [
		4481,
		7,
		3156
	],
	"./00002/00002-12/00002-12-06/my mother is a fox.mp3": [
		4482,
		7,
		3157
	],
	"./00002/00002-12/00002-12-06/my mother is a goat.mp3": [
		4483,
		7,
		3158
	],
	"./00002/00002-12/00002-12-06/my mother is a sheep.mp3": [
		4484,
		7,
		3159
	],
	"./00002/00002-12/00002-12-06/no.mp3": [
		4485,
		7,
		3160
	],
	"./00002/00002-12/00002-12-06/yes.mp3": [
		4486,
		7,
		3161
	],
	"./00002/00002-12/00002-12-06/you can be my mother.mp3": [
		4487,
		7,
		3162
	],
	"./00002/00002-12/00002-12-07/0.jpg": [
		6951,
		7,
		5628
	],
	"./00002/00002-12/00002-12-07/1.jpg": [
		9162,
		7,
		9184
	],
	"./00002/00002-12/00002-12-07/2.jpg": [
		9163,
		7,
		9185
	],
	"./00002/00002-12/00002-12-07/3.jpg": [
		9164,
		7,
		9186
	],
	"./00002/00002-12/00002-12-07/4.jpg": [
		9165,
		7,
		9187
	],
	"./00002/00002-12/00002-12-07/5.jpg": [
		9166,
		7,
		9188
	],
	"./00002/00002-12/00002-12-07/6.jpg": [
		9167,
		7,
		9189
	],
	"./00002/00002-12/00002-12-07/7.jpg": [
		9168,
		7,
		9190
	],
	"./00002/00002-12/00002-12-07/an apple fell on her head.mp3": [
		4488,
		7,
		3163
	],
	"./00002/00002-12/00002-12-07/an apple fell on your head.mp3": [
		4489,
		7,
		3164
	],
	"./00002/00002-12/00002-12-07/birds.mp3": [
		4490,
		7,
		3165
	],
	"./00002/00002-12/00002-12-07/characters in the book.mp3": [
		4491,
		7,
		3166
	],
	"./00002/00002-12/00002-12-07/chicken little was sitting under a tree.mp3": [
		4492,
		7,
		3167
	],
	"./00002/00002-12/00002-12-07/i am the king said the lion.mp3": [
		4493,
		7,
		3168
	],
	"./00002/00002-12/00002-12-07/i must tell the king.mp3": [
		4494,
		7,
		3169
	],
	"./00002/00002-12/00002-12-07/intro.mp3": [
		597,
		7
	],
	"./00002/00002-12/00002-12-07/look at the deer.mp3": [
		4495,
		7,
		3170
	],
	"./00002/00002-12/00002-12-07/look at the elephant.mp3": [
		4496,
		7,
		3171
	],
	"./00002/00002-12/00002-12-07/look at the fox.mp3": [
		4497,
		7,
		3172
	],
	"./00002/00002-12/00002-12-07/look at the jaguar.mp3": [
		4498,
		7,
		3173
	],
	"./00002/00002-12/00002-12-07/look at the lion.mp3": [
		4499,
		7,
		3174
	],
	"./00002/00002-12/00002-12-07/look at the tiger.mp3": [
		4500,
		7,
		3175
	],
	"./00002/00002-12/00002-12-07/main idea.mp3": [
		978,
		7
	],
	"./00002/00002-12/00002-12-07/module": [
		1400,
		9,
		264
	],
	"./00002/00002-12/00002-12-07/module.js": [
		1400,
		9,
		264
	],
	"./00002/00002-12/00002-12-07/the sky is falling said chicken little.mp3": [
		4501,
		7,
		3176
	],
	"./00002/00002-12/00002-12-07/the sky is falling said elephant.mp3": [
		4502,
		7,
		3177
	],
	"./00002/00002-12/00002-12-07/the sky is falling said jaguar.mp3": [
		4503,
		7,
		3178
	],
	"./00002/00002-12/00002-12-07/the sky is falling.mp3": [
		4504,
		7,
		3179
	],
	"./00002/00002-12/00002-12-07/the sky is not falling.mp3": [
		4505,
		7,
		3180
	],
	"./00002/00002-12/00002-12-07/we must tell the king.mp3": [
		4506,
		7,
		3181
	],
	"./00002/00002-12/00002-12-07/where are you going said elephant.mp3": [
		4507,
		7,
		3182
	],
	"./00002/00002-12/00002-12-07/where are you going said jaguar.mp3": [
		4508,
		7,
		3183
	],
	"./00002/00002-12/00002-12-07/where are you going said tiger.mp3": [
		4509,
		7,
		3184
	],
	"./00002/00002-12/00002-12-07/where are you going said wolf.mp3": [
		4510,
		7,
		3185
	],
	"./00002/00002-12/00002-12-08/0.jpg": [
		6952,
		7,
		5629
	],
	"./00002/00002-12/00002-12-08/1.jpg": [
		9169,
		7,
		9191
	],
	"./00002/00002-12/00002-12-08/2.jpg": [
		9170,
		7,
		9192
	],
	"./00002/00002-12/00002-12-08/3.jpg": [
		9171,
		7,
		9193
	],
	"./00002/00002-12/00002-12-08/4.jpg": [
		9172,
		7,
		9194
	],
	"./00002/00002-12/00002-12-08/5.jpg": [
		9173,
		7,
		9195
	],
	"./00002/00002-12/00002-12-08/6.jpg": [
		9174,
		7,
		9196
	],
	"./00002/00002-12/00002-12-08/7.jpg": [
		9175,
		7,
		9197
	],
	"./00002/00002-12/00002-12-08/here i am said the kitten.mp3": [
		4511,
		7,
		3186
	],
	"./00002/00002-12/00002-12-08/intro.mp3": [
		598,
		7
	],
	"./00002/00002-12/00002-12-08/main idea.mp3": [
		979,
		7
	],
	"./00002/00002-12/00002-12-08/module": [
		1401,
		9,
		265
	],
	"./00002/00002-12/00002-12-08/module.js": [
		1401,
		9,
		265
	],
	"./00002/00002-12/00002-12-08/mother cat looked in the bathroom.mp3": [
		4512,
		7,
		3187
	],
	"./00002/00002-12/00002-12-08/mother cat looked in the bathtub.mp3": [
		4513,
		7,
		3188
	],
	"./00002/00002-12/00002-12-08/mother cat looked in the bedroom.mp3": [
		4514,
		7,
		3189
	],
	"./00002/00002-12/00002-12-08/mother cat looked in the living room.mp3": [
		4515,
		7,
		3190
	],
	"./00002/00002-12/00002-12-08/mother cat looked on the bed.mp3": [
		4516,
		7,
		3191
	],
	"./00002/00002-12/00002-12-08/mother cat looked on the couch.mp3": [
		4517,
		7,
		3192
	],
	"./00002/00002-12/00002-12-08/mother cat looked on the table.mp3": [
		4518,
		7,
		3193
	],
	"./00002/00002-12/00002-12-08/no kittens here she said.mp3": [
		4519,
		7,
		3194
	],
	"./00002/00002-12/00002-12-08/non living things.mp3": [
		4520,
		7,
		3195
	],
	"./00002/00002-12/00002-12-08/where is the kitten.mp3": [
		4521,
		7,
		3196
	],
	"./00002/00002-12/00002-12-09/0.jpg": [
		6953,
		7,
		5630
	],
	"./00002/00002-12/00002-12-09/1.jpg": [
		9176,
		7,
		9198
	],
	"./00002/00002-12/00002-12-09/2.jpg": [
		9177,
		7,
		9199
	],
	"./00002/00002-12/00002-12-09/3.jpg": [
		9178,
		7,
		9200
	],
	"./00002/00002-12/00002-12-09/4.jpg": [
		9179,
		7,
		9201
	],
	"./00002/00002-12/00002-12-09/5.jpg": [
		9180,
		7,
		9202
	],
	"./00002/00002-12/00002-12-09/6.jpg": [
		9181,
		7,
		9203
	],
	"./00002/00002-12/00002-12-09/7.jpg": [
		9182,
		7,
		9204
	],
	"./00002/00002-12/00002-12-09/i love the butterflies.mp3": [
		4522,
		7,
		3197
	],
	"./00002/00002-12/00002-12-09/i love the dragonflies.mp3": [
		4523,
		7,
		3198
	],
	"./00002/00002-12/00002-12-09/i love the farms.mp3": [
		4524,
		7,
		3199
	],
	"./00002/00002-12/00002-12-09/i love the mountains.mp3": [
		4525,
		7,
		3200
	],
	"./00002/00002-12/00002-12-09/i love the ocean.mp3": [
		4526,
		7,
		3201
	],
	"./00002/00002-12/00002-12-09/i love the ponds.mp3": [
		4527,
		7,
		3202
	],
	"./00002/00002-12/00002-12-09/i love to see the bees.mp3": [
		4528,
		7,
		3203
	],
	"./00002/00002-12/00002-12-09/i love to see the boats.mp3": [
		4529,
		7,
		3204
	],
	"./00002/00002-12/00002-12-09/i love to see the dogs.mp3": [
		4530,
		7,
		3205
	],
	"./00002/00002-12/00002-12-09/i love to see the frogs.mp3": [
		4531,
		7,
		3206
	],
	"./00002/00002-12/00002-12-09/i love to see the goats.mp3": [
		4532,
		7,
		3207
	],
	"./00002/00002-12/00002-12-09/i love to see the trees.mp3": [
		4533,
		7,
		3208
	],
	"./00002/00002-12/00002-12-09/intro.mp3": [
		599,
		7
	],
	"./00002/00002-12/00002-12-09/main idea.mp3": [
		980,
		7
	],
	"./00002/00002-12/00002-12-09/module": [
		1402,
		9,
		266
	],
	"./00002/00002-12/00002-12-09/module.js": [
		1402,
		9,
		266
	],
	"./00002/00002-12/00002-12-10/0.jpg": [
		6954,
		7,
		5631
	],
	"./00002/00002-12/00002-12-10/1.jpg": [
		9183,
		7,
		9205
	],
	"./00002/00002-12/00002-12-10/2.jpg": [
		9184,
		7,
		9206
	],
	"./00002/00002-12/00002-12-10/3.jpg": [
		9185,
		7,
		9207
	],
	"./00002/00002-12/00002-12-10/4.jpg": [
		9186,
		7,
		9208
	],
	"./00002/00002-12/00002-12-10/5.jpg": [
		9187,
		7,
		9209
	],
	"./00002/00002-12/00002-12-10/6.jpg": [
		9188,
		7,
		9210
	],
	"./00002/00002-12/00002-12-10/7.jpg": [
		9189,
		7,
		9211
	],
	"./00002/00002-12/00002-12-10/birds.mp3": [
		4534,
		7,
		3209
	],
	"./00002/00002-12/00002-12-10/have you seen my mother said baby bird.mp3": [
		4535,
		7,
		3210
	],
	"./00002/00002-12/00002-12-10/have you seen my mother.mp3": [
		4536,
		7,
		3211
	],
	"./00002/00002-12/00002-12-10/help mother said baby bird.mp3": [
		4537,
		7,
		3212
	],
	"./00002/00002-12/00002-12-10/here is a dog.mp3": [
		4538,
		7,
		3213
	],
	"./00002/00002-12/00002-12-10/here is a duck.mp3": [
		4539,
		7,
		3214
	],
	"./00002/00002-12/00002-12-10/here is a pig.mp3": [
		4540,
		7,
		3215
	],
	"./00002/00002-12/00002-12-10/here is a rabbit.mp3": [
		4541,
		7,
		3216
	],
	"./00002/00002-12/00002-12-10/here is a snake.mp3": [
		4542,
		7,
		3217
	],
	"./00002/00002-12/00002-12-10/here is a worm said mother bird.mp3": [
		4543,
		7,
		3218
	],
	"./00002/00002-12/00002-12-10/here is baby bird.mp3": [
		4544,
		7,
		3219
	],
	"./00002/00002-12/00002-12-10/here is mother bird.mp3": [
		4545,
		7,
		3220
	],
	"./00002/00002-12/00002-12-10/intro.mp3": [
		600,
		7
	],
	"./00002/00002-12/00002-12-10/main idea.mp3": [
		981,
		7
	],
	"./00002/00002-12/00002-12-10/module": [
		1403,
		9,
		267
	],
	"./00002/00002-12/00002-12-10/module.js": [
		1403,
		9,
		267
	],
	"./00002/00002-12/cover.jpg": [
		6955,
		7,
		5632
	],
	"./00002/00002-12/story land.mp3": [
		4546,
		7,
		3221
	],
	"./00002/00002-12/unit": [
		1404,
		9,
		268
	],
	"./00002/00002-12/unit.js": [
		1404,
		9,
		268
	],
	"./00002/course": [
		1405,
		9,
		269
	],
	"./00002/course.js": [
		1405,
		9,
		269
	],
	"./00003/00003-01/00003-01-01/0.jpg": [
		6956,
		7,
		5633
	],
	"./00003/00003-01/00003-01-01/1.jpg": [
		9190,
		7,
		9212
	],
	"./00003/00003-01/00003-01-01/2.jpg": [
		9191,
		7,
		9213
	],
	"./00003/00003-01/00003-01-01/3.jpg": [
		9192,
		7,
		9214
	],
	"./00003/00003-01/00003-01-01/4.jpg": [
		9193,
		7,
		9215
	],
	"./00003/00003-01/00003-01-01/5.jpg": [
		9194,
		7,
		9216
	],
	"./00003/00003-01/00003-01-01/6.jpg": [
		9195,
		7,
		9217
	],
	"./00003/00003-01/00003-01-01/7.jpg": [
		9196,
		7,
		9218
	],
	"./00003/00003-01/00003-01-01/a bus goes on the road.mp3": [
		4547,
		7,
		3222
	],
	"./00003/00003-01/00003-01-01/a car goes on the road.mp3": [
		4548,
		7,
		3223
	],
	"./00003/00003-01/00003-01-01/a helicopter goes in the sky.mp3": [
		4549,
		7,
		3224
	],
	"./00003/00003-01/00003-01-01/blue vehicles.mp3": [
		4550,
		7,
		3225
	],
	"./00003/00003-01/00003-01-01/here is a blue bus.mp3": [
		4551,
		7,
		3226
	],
	"./00003/00003-01/00003-01-01/here is a blue helicopter.mp3": [
		4552,
		7,
		3227
	],
	"./00003/00003-01/00003-01-01/here is a car.mp3": [
		4553,
		7,
		3228
	],
	"./00003/00003-01/00003-01-01/intro.mp3": [
		601,
		7
	],
	"./00003/00003-01/00003-01-01/look at the airplane.mp3": [
		4554,
		7,
		3229
	],
	"./00003/00003-01/00003-01-01/look at the bus.mp3": [
		4555,
		7,
		3230
	],
	"./00003/00003-01/00003-01-01/look at the helicopter.mp3": [
		4556,
		7,
		3231
	],
	"./00003/00003-01/00003-01-01/look at the rocket.mp3": [
		4557,
		7,
		3232
	],
	"./00003/00003-01/00003-01-01/look at the truck.mp3": [
		4558,
		7,
		3233
	],
	"./00003/00003-01/00003-01-01/look at the van.mp3": [
		4559,
		7,
		3234
	],
	"./00003/00003-01/00003-01-01/main idea.mp3": [
		982,
		7
	],
	"./00003/00003-01/00003-01-01/module": [
		1406,
		9,
		270
	],
	"./00003/00003-01/00003-01-01/module.js": [
		1406,
		9,
		270
	],
	"./00003/00003-01/00003-01-01/the airplane is blue.mp3": [
		4560,
		7,
		3235
	],
	"./00003/00003-01/00003-01-01/the airplane is in the sky.mp3": [
		4561,
		7,
		3236
	],
	"./00003/00003-01/00003-01-01/the car is blue.mp3": [
		4562,
		7,
		3237
	],
	"./00003/00003-01/00003-01-01/the rocket is blue too.mp3": [
		4563,
		7,
		3238
	],
	"./00003/00003-01/00003-01-01/the rocket is up in space.mp3": [
		4564,
		7,
		3239
	],
	"./00003/00003-01/00003-01-01/the truck is blue.mp3": [
		4565,
		7,
		3240
	],
	"./00003/00003-01/00003-01-01/the truck is on the road.mp3": [
		4566,
		7,
		3241
	],
	"./00003/00003-01/00003-01-01/the van is blue.mp3": [
		4567,
		7,
		3242
	],
	"./00003/00003-01/00003-01-01/the van is on the road.mp3": [
		4568,
		7,
		3243
	],
	"./00003/00003-01/00003-01-01/vehicles.mp3": [
		4569,
		7,
		3244
	],
	"./00003/00003-01/00003-01-02/0.jpg": [
		6957,
		7,
		5634
	],
	"./00003/00003-01/00003-01-02/1.jpg": [
		9197,
		7,
		9219
	],
	"./00003/00003-01/00003-01-02/2.jpg": [
		9198,
		7,
		9220
	],
	"./00003/00003-01/00003-01-02/3.jpg": [
		9199,
		7,
		9221
	],
	"./00003/00003-01/00003-01-02/4.jpg": [
		9200,
		7,
		9222
	],
	"./00003/00003-01/00003-01-02/5.jpg": [
		9201,
		7,
		9223
	],
	"./00003/00003-01/00003-01-02/6.jpg": [
		9202,
		7,
		9224
	],
	"./00003/00003-01/00003-01-02/7.jpg": [
		9203,
		7,
		9225
	],
	"./00003/00003-01/00003-01-02/here come the cars.mp3": [
		4570,
		7,
		3245
	],
	"./00003/00003-01/00003-01-02/here come the fire trucks.mp3": [
		4571,
		7,
		3246
	],
	"./00003/00003-01/00003-01-02/here come the helicopters.mp3": [
		4572,
		7,
		3247
	],
	"./00003/00003-01/00003-01-02/here come the planes.mp3": [
		4573,
		7,
		3248
	],
	"./00003/00003-01/00003-01-02/here comes the motorcycle.mp3": [
		4574,
		7,
		3249
	],
	"./00003/00003-01/00003-01-02/here comes the tractor.mp3": [
		4575,
		7,
		3250
	],
	"./00003/00003-01/00003-01-02/here comes the train.mp3": [
		4576,
		7,
		3251
	],
	"./00003/00003-01/00003-01-02/i can see a motorcycle.mp3": [
		4577,
		7,
		3252
	],
	"./00003/00003-01/00003-01-02/i can see a tractor.mp3": [
		4578,
		7,
		3253
	],
	"./00003/00003-01/00003-01-02/i can see a train.mp3": [
		4579,
		7,
		3254
	],
	"./00003/00003-01/00003-01-02/i can see four fire trucks.mp3": [
		4580,
		7,
		3255
	],
	"./00003/00003-01/00003-01-02/i can see four planes.mp3": [
		4581,
		7,
		3256
	],
	"./00003/00003-01/00003-01-02/i can see three red helicopters.mp3": [
		4582,
		7,
		3257
	],
	"./00003/00003-01/00003-01-02/i can see two red cars.mp3": [
		4583,
		7,
		3258
	],
	"./00003/00003-01/00003-01-02/intro.mp3": [
		602,
		7
	],
	"./00003/00003-01/00003-01-02/main idea.mp3": [
		983,
		7
	],
	"./00003/00003-01/00003-01-02/module": [
		1407,
		9,
		271
	],
	"./00003/00003-01/00003-01-02/module.js": [
		1407,
		9,
		271
	],
	"./00003/00003-01/00003-01-02/red vehicles.mp3": [
		4584,
		7,
		3259
	],
	"./00003/00003-01/00003-01-02/the cars are red.mp3": [
		4585,
		7,
		3260
	],
	"./00003/00003-01/00003-01-02/the fire trucks are red.mp3": [
		4586,
		7,
		3261
	],
	"./00003/00003-01/00003-01-02/the helicopters are red.mp3": [
		4587,
		7,
		3262
	],
	"./00003/00003-01/00003-01-02/the motorcycle is red.mp3": [
		4588,
		7,
		3263
	],
	"./00003/00003-01/00003-01-02/the planes are red.mp3": [
		4589,
		7,
		3264
	],
	"./00003/00003-01/00003-01-02/the tractor is red.mp3": [
		4590,
		7,
		3265
	],
	"./00003/00003-01/00003-01-02/the train is red.mp3": [
		4591,
		7,
		3266
	],
	"./00003/00003-01/00003-01-02/things that are red.mp3": [
		4592,
		7,
		3267
	],
	"./00003/00003-01/00003-01-03/0.jpg": [
		6958,
		7,
		5635
	],
	"./00003/00003-01/00003-01-03/1.jpg": [
		9204,
		7,
		9226
	],
	"./00003/00003-01/00003-01-03/2.jpg": [
		9205,
		7,
		9227
	],
	"./00003/00003-01/00003-01-03/3.jpg": [
		9206,
		7,
		9228
	],
	"./00003/00003-01/00003-01-03/4.jpg": [
		9207,
		7,
		9229
	],
	"./00003/00003-01/00003-01-03/5.jpg": [
		9208,
		7,
		9230
	],
	"./00003/00003-01/00003-01-03/6.jpg": [
		9209,
		7,
		9231
	],
	"./00003/00003-01/00003-01-03/7.jpg": [
		9210,
		7,
		9232
	],
	"./00003/00003-01/00003-01-03/butterflies have 6 legs.mp3": [
		4593,
		7,
		3268
	],
	"./00003/00003-01/00003-01-03/crabs have 10 legs.mp3": [
		4594,
		7,
		3269
	],
	"./00003/00003-01/00003-01-03/dogs have 4 legs.mp3": [
		4595,
		7,
		3270
	],
	"./00003/00003-01/00003-01-03/ducks have 2 legs.mp3": [
		4596,
		7,
		3271
	],
	"./00003/00003-01/00003-01-03/fish have no legs.mp3": [
		4597,
		7,
		3272
	],
	"./00003/00003-01/00003-01-03/i like the bird.mp3": [
		4598,
		7,
		3273
	],
	"./00003/00003-01/00003-01-03/i like the butterfly.mp3": [
		4599,
		7,
		3274
	],
	"./00003/00003-01/00003-01-03/i like the caterpillar.mp3": [
		4600,
		7,
		3275
	],
	"./00003/00003-01/00003-01-03/i like the crab.mp3": [
		4601,
		7,
		3276
	],
	"./00003/00003-01/00003-01-03/i like the dog.mp3": [
		4602,
		7,
		3277
	],
	"./00003/00003-01/00003-01-03/i like the ducks.mp3": [
		4603,
		7,
		3278
	],
	"./00003/00003-01/00003-01-03/i like the fish.mp3": [
		4604,
		7,
		3279
	],
	"./00003/00003-01/00003-01-03/i like the parrot.mp3": [
		4605,
		7,
		3280
	],
	"./00003/00003-01/00003-01-03/i like the spider.mp3": [
		4606,
		7,
		3281
	],
	"./00003/00003-01/00003-01-03/intro.mp3": [
		603,
		7
	],
	"./00003/00003-01/00003-01-03/main idea.mp3": [
		984,
		7
	],
	"./00003/00003-01/00003-01-03/module": [
		1408,
		9,
		272
	],
	"./00003/00003-01/00003-01-03/module.js": [
		1408,
		9,
		272
	],
	"./00003/00003-01/00003-01-03/parrots have 2 legs.mp3": [
		4607,
		7,
		3282
	],
	"./00003/00003-01/00003-01-03/spiders have 8 legs.mp3": [
		4608,
		7,
		3283
	],
	"./00003/00003-01/00003-01-03/the bird is yellow.mp3": [
		4609,
		7,
		3284
	],
	"./00003/00003-01/00003-01-03/the butterfly is yellow.mp3": [
		4610,
		7,
		3285
	],
	"./00003/00003-01/00003-01-03/the caterpillar is yellow.mp3": [
		4611,
		7,
		3286
	],
	"./00003/00003-01/00003-01-03/the crab is yellow.mp3": [
		4612,
		7,
		3287
	],
	"./00003/00003-01/00003-01-03/the dog is yellow.mp3": [
		4613,
		7,
		3288
	],
	"./00003/00003-01/00003-01-03/the ducks are yellow too.mp3": [
		4614,
		7,
		3289
	],
	"./00003/00003-01/00003-01-03/the fish is yellow.mp3": [
		4615,
		7,
		3290
	],
	"./00003/00003-01/00003-01-03/the parrot is yellow.mp3": [
		4616,
		7,
		3291
	],
	"./00003/00003-01/00003-01-03/the spider is yellow.mp3": [
		4617,
		7,
		3292
	],
	"./00003/00003-01/00003-01-03/things that are yellow.mp3": [
		4618,
		7,
		3293
	],
	"./00003/00003-01/00003-01-03/yellow animals.mp3": [
		4619,
		7,
		3294
	],
	"./00003/00003-01/00003-01-04/0.jpg": [
		6959,
		7,
		5636
	],
	"./00003/00003-01/00003-01-04/1.jpg": [
		9211,
		7,
		9233
	],
	"./00003/00003-01/00003-01-04/2.jpg": [
		9212,
		7,
		9234
	],
	"./00003/00003-01/00003-01-04/3.jpg": [
		9213,
		7,
		9235
	],
	"./00003/00003-01/00003-01-04/4.jpg": [
		9214,
		7,
		9236
	],
	"./00003/00003-01/00003-01-04/5.jpg": [
		9215,
		7,
		9237
	],
	"./00003/00003-01/00003-01-04/6.jpg": [
		9216,
		7,
		9238
	],
	"./00003/00003-01/00003-01-04/7.jpg": [
		9217,
		7,
		9239
	],
	"./00003/00003-01/00003-01-04/i can not see the orange fox.mp3": [
		4620,
		7,
		3295
	],
	"./00003/00003-01/00003-01-04/i can see the orange butterfly.mp3": [
		4621,
		7,
		3296
	],
	"./00003/00003-01/00003-01-04/i can see the orange cat.mp3": [
		4622,
		7,
		3297
	],
	"./00003/00003-01/00003-01-04/i can see the orange fish.mp3": [
		4623,
		7,
		3298
	],
	"./00003/00003-01/00003-01-04/i can see the orange fox.mp3": [
		4624,
		7,
		3299
	],
	"./00003/00003-01/00003-01-04/i can see the orange salamander.mp3": [
		4625,
		7,
		3300
	],
	"./00003/00003-01/00003-01-04/i can see the orange snake.mp3": [
		4626,
		7,
		3301
	],
	"./00003/00003-01/00003-01-04/i can see the orange tiger.mp3": [
		4627,
		7,
		3302
	],
	"./00003/00003-01/00003-01-04/intro.mp3": [
		604,
		7
	],
	"./00003/00003-01/00003-01-04/main idea.mp3": [
		985,
		7
	],
	"./00003/00003-01/00003-01-04/module": [
		1409,
		9,
		273
	],
	"./00003/00003-01/00003-01-04/module.js": [
		1409,
		9,
		273
	],
	"./00003/00003-01/00003-01-04/orange things.mp3": [
		4628,
		7,
		3303
	],
	"./00003/00003-01/00003-01-04/the orange animal book.mp3": [
		4629,
		7,
		3304
	],
	"./00003/00003-01/00003-01-04/what else can i see.mp3": [
		4630,
		7,
		3305
	],
	"./00003/00003-01/00003-01-05/0.jpg": [
		6960,
		7,
		5637
	],
	"./00003/00003-01/00003-01-05/1.jpg": [
		9218,
		7,
		9240
	],
	"./00003/00003-01/00003-01-05/2.jpg": [
		9219,
		7,
		9241
	],
	"./00003/00003-01/00003-01-05/3.jpg": [
		9220,
		7,
		9242
	],
	"./00003/00003-01/00003-01-05/4.jpg": [
		9221,
		7,
		9243
	],
	"./00003/00003-01/00003-01-05/5.jpg": [
		9222,
		7,
		9244
	],
	"./00003/00003-01/00003-01-05/6.jpg": [
		9223,
		7,
		9245
	],
	"./00003/00003-01/00003-01-05/7.jpg": [
		9224,
		7,
		9246
	],
	"./00003/00003-01/00003-01-05/i look good in purple.mp3": [
		4631,
		7,
		3306
	],
	"./00003/00003-01/00003-01-05/i love purple he said.mp3": [
		4632,
		7,
		3307
	],
	"./00003/00003-01/00003-01-05/i love purple she said.mp3": [
		4633,
		7,
		3308
	],
	"./00003/00003-01/00003-01-05/i love purple.mp3": [
		4634,
		7,
		3309
	],
	"./00003/00003-01/00003-01-05/intro.mp3": [
		605,
		7
	],
	"./00003/00003-01/00003-01-05/look at me.mp3": [
		4635,
		7,
		3310
	],
	"./00003/00003-01/00003-01-05/main idea.mp3": [
		986,
		7
	],
	"./00003/00003-01/00003-01-05/module": [
		1410,
		9,
		274
	],
	"./00003/00003-01/00003-01-05/module.js": [
		1410,
		9,
		274
	],
	"./00003/00003-01/00003-01-05/the dog has a purple jacket.mp3": [
		4636,
		7,
		3311
	],
	"./00003/00003-01/00003-01-05/the goat has a purple scarf.mp3": [
		4637,
		7,
		3312
	],
	"./00003/00003-01/00003-01-05/the lion has a purple shirt.mp3": [
		4638,
		7,
		3313
	],
	"./00003/00003-01/00003-01-05/the octopus has purple mittens.mp3": [
		4639,
		7,
		3314
	],
	"./00003/00003-01/00003-01-05/the penguin has a purple helmet.mp3": [
		4640,
		7,
		3315
	],
	"./00003/00003-01/00003-01-05/the rabbit has a purple hat.mp3": [
		4641,
		7,
		3316
	],
	"./00003/00003-01/00003-01-05/the skunk has a purple dress.mp3": [
		4642,
		7,
		3317
	],
	"./00003/00003-01/00003-01-05/things that are purple.mp3": [
		4643,
		7,
		3318
	],
	"./00003/00003-01/00003-01-06/0.jpg": [
		6961,
		7,
		5638
	],
	"./00003/00003-01/00003-01-06/1.jpg": [
		9225,
		7,
		9247
	],
	"./00003/00003-01/00003-01-06/2.jpg": [
		9226,
		7,
		9248
	],
	"./00003/00003-01/00003-01-06/3.jpg": [
		9227,
		7,
		9249
	],
	"./00003/00003-01/00003-01-06/4.jpg": [
		9228,
		7,
		9250
	],
	"./00003/00003-01/00003-01-06/5.jpg": [
		9229,
		7,
		9251
	],
	"./00003/00003-01/00003-01-06/6.jpg": [
		9230,
		7,
		9252
	],
	"./00003/00003-01/00003-01-06/7.jpg": [
		9231,
		7,
		9253
	],
	"./00003/00003-01/00003-01-06/animals that are green.mp3": [
		4644,
		7,
		3319
	],
	"./00003/00003-01/00003-01-06/i am a green alligator.mp3": [
		4645,
		7,
		3320
	],
	"./00003/00003-01/00003-01-06/i am a green frog.mp3": [
		4646,
		7,
		3321
	],
	"./00003/00003-01/00003-01-06/i am a green grasshopper.mp3": [
		4647,
		7,
		3322
	],
	"./00003/00003-01/00003-01-06/i am a green praying mantis.mp3": [
		4648,
		7,
		3323
	],
	"./00003/00003-01/00003-01-06/i am a green turtle.mp3": [
		4649,
		7,
		3324
	],
	"./00003/00003-01/00003-01-06/i can hide from the alligator.mp3": [
		4650,
		7,
		3325
	],
	"./00003/00003-01/00003-01-06/i can hide from the frog.mp3": [
		4651,
		7,
		3326
	],
	"./00003/00003-01/00003-01-06/i can hide in the leaves.mp3": [
		4652,
		7,
		3327
	],
	"./00003/00003-01/00003-01-06/intro.mp3": [
		606,
		7
	],
	"./00003/00003-01/00003-01-06/main idea.mp3": [
		987,
		7
	],
	"./00003/00003-01/00003-01-06/module": [
		1411,
		9,
		275
	],
	"./00003/00003-01/00003-01-06/module.js": [
		1411,
		9,
		275
	],
	"./00003/00003-01/00003-01-06/the green book.mp3": [
		4653,
		7,
		3328
	],
	"./00003/00003-01/00003-01-06/we are green aphids.mp3": [
		4654,
		7,
		3329
	],
	"./00003/00003-01/00003-01-06/we are green dinosaurs.mp3": [
		4655,
		7,
		3330
	],
	"./00003/00003-01/00003-01-06/we can hide in the leaves too.mp3": [
		4656,
		7,
		3331
	],
	"./00003/00003-01/00003-01-06/you can not see me.mp3": [
		4657,
		7,
		3332
	],
	"./00003/00003-01/00003-01-06/you can not see us.mp3": [
		4658,
		7,
		3333
	],
	"./00003/00003-01/00003-01-07/0.jpg": [
		6962,
		7,
		5639
	],
	"./00003/00003-01/00003-01-07/1.jpg": [
		9232,
		7,
		9254
	],
	"./00003/00003-01/00003-01-07/2.jpg": [
		9233,
		7,
		9255
	],
	"./00003/00003-01/00003-01-07/3.jpg": [
		9234,
		7,
		9256
	],
	"./00003/00003-01/00003-01-07/4.jpg": [
		9235,
		7,
		9257
	],
	"./00003/00003-01/00003-01-07/5.jpg": [
		9236,
		7,
		9258
	],
	"./00003/00003-01/00003-01-07/6.jpg": [
		9237,
		7,
		9259
	],
	"./00003/00003-01/00003-01-07/7.jpg": [
		9238,
		7,
		9260
	],
	"./00003/00003-01/00003-01-07/animals that are brown.mp3": [
		4659,
		7,
		3334
	],
	"./00003/00003-01/00003-01-07/i saw 2 brown birds.mp3": [
		4660,
		7,
		3335
	],
	"./00003/00003-01/00003-01-07/i saw 2 brown rabbits.mp3": [
		4661,
		7,
		3336
	],
	"./00003/00003-01/00003-01-07/i saw 2 little brown bears.mp3": [
		4662,
		7,
		3337
	],
	"./00003/00003-01/00003-01-07/i saw 2 little brown deer.mp3": [
		4663,
		7,
		3338
	],
	"./00003/00003-01/00003-01-07/i saw a big brown bear.mp3": [
		4664,
		7,
		3339
	],
	"./00003/00003-01/00003-01-07/i saw a big brown deer.mp3": [
		4665,
		7,
		3340
	],
	"./00003/00003-01/00003-01-07/i saw a brown hedgehog.mp3": [
		4666,
		7,
		3341
	],
	"./00003/00003-01/00003-01-07/i went to the forest.mp3": [
		4667,
		7,
		3342
	],
	"./00003/00003-01/00003-01-07/intro.mp3": [
		607,
		7
	],
	"./00003/00003-01/00003-01-07/main idea.mp3": [
		988,
		7
	],
	"./00003/00003-01/00003-01-07/module": [
		1412,
		9,
		276
	],
	"./00003/00003-01/00003-01-07/module.js": [
		1412,
		9,
		276
	],
	"./00003/00003-01/00003-01-07/the brown book.mp3": [
		4668,
		7,
		3343
	],
	"./00003/00003-01/00003-01-07/what did i see.mp3": [
		4669,
		7,
		3344
	],
	"./00003/00003-01/00003-01-08/0.jpg": [
		6963,
		7,
		5640
	],
	"./00003/00003-01/00003-01-08/1.jpg": [
		9239,
		7,
		9261
	],
	"./00003/00003-01/00003-01-08/2.jpg": [
		9240,
		7,
		9262
	],
	"./00003/00003-01/00003-01-08/3.jpg": [
		9241,
		7,
		9263
	],
	"./00003/00003-01/00003-01-08/4.jpg": [
		9242,
		7,
		9264
	],
	"./00003/00003-01/00003-01-08/5.jpg": [
		9243,
		7,
		9265
	],
	"./00003/00003-01/00003-01-08/6.jpg": [
		9244,
		7,
		9266
	],
	"./00003/00003-01/00003-01-08/7.jpg": [
		9245,
		7,
		9267
	],
	"./00003/00003-01/00003-01-08/animals.mp3": [
		4670,
		7,
		3345
	],
	"./00003/00003-01/00003-01-08/intro.mp3": [
		608,
		7
	],
	"./00003/00003-01/00003-01-08/look at the ants.mp3": [
		4671,
		7,
		3346
	],
	"./00003/00003-01/00003-01-08/look at the birds.mp3": [
		4672,
		7,
		3347
	],
	"./00003/00003-01/00003-01-08/look at the cats.mp3": [
		4673,
		7,
		3348
	],
	"./00003/00003-01/00003-01-08/look at the cows.mp3": [
		4674,
		7,
		3349
	],
	"./00003/00003-01/00003-01-08/look at the dogs.mp3": [
		4675,
		7,
		3350
	],
	"./00003/00003-01/00003-01-08/look at the horses.mp3": [
		4676,
		7,
		3351
	],
	"./00003/00003-01/00003-01-08/look at the spiders.mp3": [
		4677,
		7,
		3352
	],
	"./00003/00003-01/00003-01-08/main idea.mp3": [
		989,
		7
	],
	"./00003/00003-01/00003-01-08/module": [
		1413,
		9,
		277
	],
	"./00003/00003-01/00003-01-08/module.js": [
		1413,
		9,
		277
	],
	"./00003/00003-01/00003-01-08/one of them is black and white.mp3": [
		4678,
		7,
		3353
	],
	"./00003/00003-01/00003-01-08/one of them is black.mp3": [
		4679,
		7,
		3354
	],
	"./00003/00003-01/00003-01-08/one of them is red and black.mp3": [
		4680,
		7,
		3355
	],
	"./00003/00003-01/00003-01-08/one of them is red.mp3": [
		4681,
		7,
		3356
	],
	"./00003/00003-01/00003-01-08/one of them is white.mp3": [
		4682,
		7,
		3357
	],
	"./00003/00003-01/00003-01-08/the black book.mp3": [
		4683,
		7,
		3358
	],
	"./00003/00003-01/00003-01-09/0.jpg": [
		6964,
		7,
		5641
	],
	"./00003/00003-01/00003-01-09/1.jpg": [
		9246,
		7,
		9268
	],
	"./00003/00003-01/00003-01-09/2.jpg": [
		9247,
		7,
		9269
	],
	"./00003/00003-01/00003-01-09/3.jpg": [
		9248,
		7,
		9270
	],
	"./00003/00003-01/00003-01-09/4.jpg": [
		9249,
		7,
		9271
	],
	"./00003/00003-01/00003-01-09/5.jpg": [
		9250,
		7,
		9272
	],
	"./00003/00003-01/00003-01-09/6.jpg": [
		9251,
		7,
		9273
	],
	"./00003/00003-01/00003-01-09/7.jpg": [
		9252,
		7,
		9274
	],
	"./00003/00003-01/00003-01-09/animals that live in the snow.mp3": [
		4684,
		7,
		3359
	],
	"./00003/00003-01/00003-01-09/he can hide in the snow.mp3": [
		4685,
		7,
		3360
	],
	"./00003/00003-01/00003-01-09/he is white in the winter.mp3": [
		4686,
		7,
		3361
	],
	"./00003/00003-01/00003-01-09/he is white like the snow.mp3": [
		4687,
		7,
		3362
	],
	"./00003/00003-01/00003-01-09/intro.mp3": [
		609,
		7
	],
	"./00003/00003-01/00003-01-09/main idea.mp3": [
		990,
		7
	],
	"./00003/00003-01/00003-01-09/module": [
		1414,
		9,
		278
	],
	"./00003/00003-01/00003-01-09/module.js": [
		1414,
		9,
		278
	],
	"./00003/00003-01/00003-01-09/she can hide in the snow.mp3": [
		4688,
		7,
		3363
	],
	"./00003/00003-01/00003-01-09/she is white in the winter.mp3": [
		4689,
		7,
		3364
	],
	"./00003/00003-01/00003-01-09/she is white like the snow.mp3": [
		4690,
		7,
		3365
	],
	"./00003/00003-01/00003-01-09/the arctic fox is white.mp3": [
		4691,
		7,
		3366
	],
	"./00003/00003-01/00003-01-09/the arctic wolf is white.mp3": [
		4692,
		7,
		3367
	],
	"./00003/00003-01/00003-01-09/the polar bear is white.mp3": [
		4693,
		7,
		3368
	],
	"./00003/00003-01/00003-01-09/the ptarmigan is white.mp3": [
		4694,
		7,
		3369
	],
	"./00003/00003-01/00003-01-09/the seal pup is white.mp3": [
		4695,
		7,
		3370
	],
	"./00003/00003-01/00003-01-09/the snowshoe rabbit is white.mp3": [
		4696,
		7,
		3371
	],
	"./00003/00003-01/00003-01-09/the snowy owl is white.mp3": [
		4697,
		7,
		3372
	],
	"./00003/00003-01/00003-01-09/the white book.mp3": [
		4698,
		7,
		3373
	],
	"./00003/00003-01/00003-01-10/0.jpg": [
		6965,
		7,
		5642
	],
	"./00003/00003-01/00003-01-10/1.jpg": [
		9253,
		7,
		9275
	],
	"./00003/00003-01/00003-01-10/2.jpg": [
		9254,
		7,
		9276
	],
	"./00003/00003-01/00003-01-10/3.jpg": [
		9255,
		7,
		9277
	],
	"./00003/00003-01/00003-01-10/4.jpg": [
		9256,
		7,
		9278
	],
	"./00003/00003-01/00003-01-10/5.jpg": [
		9257,
		7,
		9279
	],
	"./00003/00003-01/00003-01-10/6.jpg": [
		9258,
		7,
		9280
	],
	"./00003/00003-01/00003-01-10/7.jpg": [
		9259,
		7,
		9281
	],
	"./00003/00003-01/00003-01-10/i see a pink elephant too.mp3": [
		4699,
		7,
		3374
	],
	"./00003/00003-01/00003-01-10/i see a pink flamingo.mp3": [
		4700,
		7,
		3375
	],
	"./00003/00003-01/00003-01-10/i see a pink hermit crab.mp3": [
		4701,
		7,
		3376
	],
	"./00003/00003-01/00003-01-10/i see a pink pig.mp3": [
		4702,
		7,
		3377
	],
	"./00003/00003-01/00003-01-10/i see a pink rabbit.mp3": [
		4703,
		7,
		3378
	],
	"./00003/00003-01/00003-01-10/i see a pink shell.mp3": [
		4704,
		7,
		3379
	],
	"./00003/00003-01/00003-01-10/i see a pink starfish.mp3": [
		4705,
		7,
		3380
	],
	"./00003/00003-01/00003-01-10/i see some pink flowers.mp3": [
		4706,
		7,
		3381
	],
	"./00003/00003-01/00003-01-10/i spy something pink.mp3": [
		4707,
		7,
		3382
	],
	"./00003/00003-01/00003-01-10/i spy with my little eye said the boy.mp3": [
		4708,
		7,
		3383
	],
	"./00003/00003-01/00003-01-10/i spy with my little eye said the girl.mp3": [
		4709,
		7,
		3384
	],
	"./00003/00003-01/00003-01-10/intro.mp3": [
		610,
		7
	],
	"./00003/00003-01/00003-01-10/main idea.mp3": [
		991,
		7
	],
	"./00003/00003-01/00003-01-10/module": [
		1415,
		9,
		279
	],
	"./00003/00003-01/00003-01-10/module.js": [
		1415,
		9,
		279
	],
	"./00003/00003-01/00003-01-10/the pig likes the flowers.mp3": [
		4710,
		7,
		3385
	],
	"./00003/00003-01/00003-01-10/the pink book.mp3": [
		4711,
		7,
		3386
	],
	"./00003/00003-01/00003-01-10/things that are pink.mp3": [
		4712,
		7,
		3387
	],
	"./00003/00003-01/color land.mp3": [
		4713,
		7,
		3388
	],
	"./00003/00003-01/colors.mp3": [
		4714,
		7,
		3389
	],
	"./00003/00003-01/cover.jpg": [
		6966,
		7,
		5643
	],
	"./00003/00003-01/unit": [
		1416,
		9,
		280
	],
	"./00003/00003-01/unit.js": [
		1416,
		9,
		280
	],
	"./00003/00003-02/00003-02-01/0.jpg": [
		6967,
		7,
		5644
	],
	"./00003/00003-02/00003-02-01/1.jpg": [
		9260,
		7,
		9282
	],
	"./00003/00003-02/00003-02-01/2.jpg": [
		9261,
		7,
		9283
	],
	"./00003/00003-02/00003-02-01/3.jpg": [
		9262,
		7,
		9284
	],
	"./00003/00003-02/00003-02-01/4.jpg": [
		9263,
		7,
		9285
	],
	"./00003/00003-02/00003-02-01/5.jpg": [
		9264,
		7,
		9286
	],
	"./00003/00003-02/00003-02-01/6.jpg": [
		9265,
		7,
		9287
	],
	"./00003/00003-02/00003-02-01/7.jpg": [
		9266,
		7,
		9288
	],
	"./00003/00003-02/00003-02-01/animals.mp3": [
		4715,
		7,
		3390
	],
	"./00003/00003-02/00003-02-01/can i come in he said.mp3": [
		4716,
		7,
		3391
	],
	"./00003/00003-02/00003-02-01/can i come in said the owl.mp3": [
		4717,
		7,
		3392
	],
	"./00003/00003-02/00003-02-01/can i come in she said.mp3": [
		4718,
		7,
		3393
	],
	"./00003/00003-02/00003-02-01/here is a bear.mp3": [
		4719,
		7,
		3394
	],
	"./00003/00003-02/00003-02-01/here is a mitten.mp3": [
		4720,
		7,
		3395
	],
	"./00003/00003-02/00003-02-01/here is a rabbit.mp3": [
		4721,
		7,
		3396
	],
	"./00003/00003-02/00003-02-01/intro.mp3": [
		611,
		7
	],
	"./00003/00003-02/00003-02-01/look at the bear.mp3": [
		4722,
		7,
		3397
	],
	"./00003/00003-02/00003-02-01/look at the fox.mp3": [
		4723,
		7,
		3398
	],
	"./00003/00003-02/00003-02-01/look at the mitten.mp3": [
		4724,
		7,
		3399
	],
	"./00003/00003-02/00003-02-01/look at the mouse.mp3": [
		4725,
		7,
		3400
	],
	"./00003/00003-02/00003-02-01/look at the owl.mp3": [
		4726,
		7,
		3401
	],
	"./00003/00003-02/00003-02-01/look at the rabbit.mp3": [
		4727,
		7,
		3402
	],
	"./00003/00003-02/00003-02-01/main idea.mp3": [
		992,
		7
	],
	"./00003/00003-02/00003-02-01/module": [
		1417,
		9,
		281
	],
	"./00003/00003-02/00003-02-01/module.js": [
		1417,
		9,
		281
	],
	"./00003/00003-02/00003-02-01/no said the mouse.mp3": [
		4728,
		7,
		3403
	],
	"./00003/00003-02/00003-02-01/oh no.mp3": [
		4729,
		7,
		3404
	],
	"./00003/00003-02/00003-02-01/the bear is too big.mp3": [
		4730,
		7,
		3405
	],
	"./00003/00003-02/00003-02-01/the fox is going in the mitten.mp3": [
		4731,
		7,
		3406
	],
	"./00003/00003-02/00003-02-01/the mitten is in the snow.mp3": [
		4732,
		7,
		3407
	],
	"./00003/00003-02/00003-02-01/the mitten.mp3": [
		4733,
		7,
		3408
	],
	"./00003/00003-02/00003-02-01/the mouse is going in the mitten.mp3": [
		4734,
		7,
		3409
	],
	"./00003/00003-02/00003-02-01/the owl is going in the mitten.mp3": [
		4735,
		7,
		3410
	],
	"./00003/00003-02/00003-02-01/the rabbit is going in the mitten.mp3": [
		4736,
		7,
		3411
	],
	"./00003/00003-02/00003-02-02/0.jpg": [
		6968,
		7,
		5645
	],
	"./00003/00003-02/00003-02-02/1.jpg": [
		9267,
		7,
		9289
	],
	"./00003/00003-02/00003-02-02/2.jpg": [
		9268,
		7,
		9290
	],
	"./00003/00003-02/00003-02-02/3.jpg": [
		9269,
		7,
		9291
	],
	"./00003/00003-02/00003-02-02/4.jpg": [
		9270,
		7,
		9292
	],
	"./00003/00003-02/00003-02-02/5.jpg": [
		9271,
		7,
		9293
	],
	"./00003/00003-02/00003-02-02/6.jpg": [
		9272,
		7,
		9294
	],
	"./00003/00003-02/00003-02-02/7.jpg": [
		9273,
		7,
		9295
	],
	"./00003/00003-02/00003-02-02/dogs.mp3": [
		4737,
		7,
		3412
	],
	"./00003/00003-02/00003-02-02/here they are.mp3": [
		4738,
		7,
		3413
	],
	"./00003/00003-02/00003-02-02/intro.mp3": [
		612,
		7
	],
	"./00003/00003-02/00003-02-02/look in the bathroom.mp3": [
		4739,
		7,
		3414
	],
	"./00003/00003-02/00003-02-02/look in the bedroom.mp3": [
		4740,
		7,
		3415
	],
	"./00003/00003-02/00003-02-02/look in the box.mp3": [
		4741,
		7,
		3416
	],
	"./00003/00003-02/00003-02-02/look in the kitchen.mp3": [
		4742,
		7,
		3417
	],
	"./00003/00003-02/00003-02-02/look in the living room.mp3": [
		4743,
		7,
		3418
	],
	"./00003/00003-02/00003-02-02/look in the shower.mp3": [
		4744,
		7,
		3419
	],
	"./00003/00003-02/00003-02-02/look.mp3": [
		4745,
		7,
		3420
	],
	"./00003/00003-02/00003-02-02/main idea.mp3": [
		993,
		7
	],
	"./00003/00003-02/00003-02-02/module": [
		1418,
		9,
		282
	],
	"./00003/00003-02/00003-02-02/module.js": [
		1418,
		9,
		282
	],
	"./00003/00003-02/00003-02-02/no puppies here.mp3": [
		4746,
		7,
		3421
	],
	"./00003/00003-02/00003-02-02/where are the puppies.mp3": [
		4747,
		7,
		3422
	],
	"./00003/00003-02/00003-02-03/0.jpg": [
		6969,
		7,
		5646
	],
	"./00003/00003-02/00003-02-03/1.jpg": [
		9274,
		7,
		9296
	],
	"./00003/00003-02/00003-02-03/2.jpg": [
		9275,
		7,
		9297
	],
	"./00003/00003-02/00003-02-03/3.jpg": [
		9276,
		7,
		9298
	],
	"./00003/00003-02/00003-02-03/4.jpg": [
		9277,
		7,
		9299
	],
	"./00003/00003-02/00003-02-03/5.jpg": [
		9278,
		7,
		9300
	],
	"./00003/00003-02/00003-02-03/6.jpg": [
		9279,
		7,
		9301
	],
	"./00003/00003-02/00003-02-03/7.jpg": [
		9280,
		7,
		9302
	],
	"./00003/00003-02/00003-02-03/farm animals.mp3": [
		4748,
		7,
		3423
	],
	"./00003/00003-02/00003-02-03/intro.mp3": [
		613,
		7
	],
	"./00003/00003-02/00003-02-03/main idea.mp3": [
		994,
		7
	],
	"./00003/00003-02/00003-02-03/module": [
		1419,
		9,
		283
	],
	"./00003/00003-02/00003-02-03/module.js": [
		1419,
		9,
		283
	],
	"./00003/00003-02/00003-02-03/the animals get off the bus.mp3": [
		4749,
		7,
		3424
	],
	"./00003/00003-02/00003-02-03/the bus ride.mp3": [
		4750,
		7,
		3425
	],
	"./00003/00003-02/00003-02-03/the bus stops.mp3": [
		4751,
		7,
		3426
	],
	"./00003/00003-02/00003-02-03/the cats go on the bus.mp3": [
		4752,
		7,
		3427
	],
	"./00003/00003-02/00003-02-03/the cows go on the bus.mp3": [
		4753,
		7,
		3428
	],
	"./00003/00003-02/00003-02-03/the dogs go on the bus.mp3": [
		4754,
		7,
		3429
	],
	"./00003/00003-02/00003-02-03/the ducks go on the bus.mp3": [
		4755,
		7,
		3430
	],
	"./00003/00003-02/00003-02-03/the horses go on the bus.mp3": [
		4756,
		7,
		3431
	],
	"./00003/00003-02/00003-02-03/the lions go on the bus.mp3": [
		4757,
		7,
		3432
	],
	"./00003/00003-02/00003-02-03/the sheep go on the bus.mp3": [
		4758,
		7,
		3433
	],
	"./00003/00003-02/00003-02-03/then the bus goes fast.mp3": [
		4759,
		7,
		3434
	],
	"./00003/00003-02/00003-02-03/who will get on next.mp3": [
		4760,
		7,
		3435
	],
	"./00003/00003-02/00003-02-04/0.jpg": [
		6970,
		7,
		5647
	],
	"./00003/00003-02/00003-02-04/1.jpg": [
		9281,
		7,
		9303
	],
	"./00003/00003-02/00003-02-04/2.jpg": [
		9282,
		7,
		9304
	],
	"./00003/00003-02/00003-02-04/3.jpg": [
		9283,
		7,
		9305
	],
	"./00003/00003-02/00003-02-04/4.jpg": [
		9284,
		7,
		9306
	],
	"./00003/00003-02/00003-02-04/5.jpg": [
		9285,
		7,
		9307
	],
	"./00003/00003-02/00003-02-04/6.jpg": [
		9286,
		7,
		9308
	],
	"./00003/00003-02/00003-02-04/7.jpg": [
		9287,
		7,
		9309
	],
	"./00003/00003-02/00003-02-04/can i play with the hedgehog.mp3": [
		4761,
		7,
		3436
	],
	"./00003/00003-02/00003-02-04/can i play with the kitten.mp3": [
		4762,
		7,
		3437
	],
	"./00003/00003-02/00003-02-04/can i play with the owl.mp3": [
		4763,
		7,
		3438
	],
	"./00003/00003-02/00003-02-04/can i play with the rabbit.mp3": [
		4764,
		7,
		3439
	],
	"./00003/00003-02/00003-02-04/can i play with the skunk.mp3": [
		4765,
		7,
		3440
	],
	"./00003/00003-02/00003-02-04/can i play with the snake.mp3": [
		4766,
		7,
		3441
	],
	"./00003/00003-02/00003-02-04/can i play with the turtle.mp3": [
		4767,
		7,
		3442
	],
	"./00003/00003-02/00003-02-04/dogs.mp3": [
		4768,
		7,
		3443
	],
	"./00003/00003-02/00003-02-04/intro.mp3": [
		614,
		7
	],
	"./00003/00003-02/00003-02-04/main idea.mp3": [
		995,
		7
	],
	"./00003/00003-02/00003-02-04/module": [
		1420,
		9,
		284
	],
	"./00003/00003-02/00003-02-04/module.js": [
		1420,
		9,
		284
	],
	"./00003/00003-02/00003-02-04/no no puppy.mp3": [
		4769,
		7,
		3444
	],
	"./00003/00003-02/00003-02-04/no puppy no.mp3": [
		4770,
		7,
		3445
	],
	"./00003/00003-02/00003-02-04/no puppy.mp3": [
		4771,
		7,
		3446
	],
	"./00003/00003-02/00003-02-04/yes yes puppy.mp3": [
		4772,
		7,
		3447
	],
	"./00003/00003-02/00003-02-04/you can not play with the hedgehog.mp3": [
		4773,
		7,
		3448
	],
	"./00003/00003-02/00003-02-04/you can not play with the owl.mp3": [
		4774,
		7,
		3449
	],
	"./00003/00003-02/00003-02-04/you can not play with the rabbit.mp3": [
		4775,
		7,
		3450
	],
	"./00003/00003-02/00003-02-04/you can not play with the skunk.mp3": [
		4776,
		7,
		3451
	],
	"./00003/00003-02/00003-02-04/you can not play with the snake.mp3": [
		4777,
		7,
		3452
	],
	"./00003/00003-02/00003-02-04/you can not play with the turtle.mp3": [
		4778,
		7,
		3453
	],
	"./00003/00003-02/00003-02-04/you can play with the kitten.mp3": [
		4779,
		7,
		3454
	],
	"./00003/00003-02/00003-02-05/0.jpg": [
		6971,
		7,
		5648
	],
	"./00003/00003-02/00003-02-05/1.jpg": [
		9288,
		7,
		9310
	],
	"./00003/00003-02/00003-02-05/2.jpg": [
		9289,
		7,
		9311
	],
	"./00003/00003-02/00003-02-05/3.jpg": [
		9290,
		7,
		9312
	],
	"./00003/00003-02/00003-02-05/4.jpg": [
		9291,
		7,
		9313
	],
	"./00003/00003-02/00003-02-05/5.jpg": [
		9292,
		7,
		9314
	],
	"./00003/00003-02/00003-02-05/6.jpg": [
		9293,
		7,
		9315
	],
	"./00003/00003-02/00003-02-05/7.jpg": [
		9294,
		7,
		9316
	],
	"./00003/00003-02/00003-02-05/animals that are gray.mp3": [
		4780,
		7,
		3455
	],
	"./00003/00003-02/00003-02-05/i love black and white.mp3": [
		4781,
		7,
		3456
	],
	"./00003/00003-02/00003-02-05/i love blue.mp3": [
		4782,
		7,
		3457
	],
	"./00003/00003-02/00003-02-05/i love gray said the elephant.mp3": [
		4783,
		7,
		3458
	],
	"./00003/00003-02/00003-02-05/i love gray.mp3": [
		4784,
		7,
		3459
	],
	"./00003/00003-02/00003-02-05/i love green.mp3": [
		4785,
		7,
		3460
	],
	"./00003/00003-02/00003-02-05/i love orange said the goat.mp3": [
		4786,
		7,
		3461
	],
	"./00003/00003-02/00003-02-05/i love orange.mp3": [
		4787,
		7,
		3462
	],
	"./00003/00003-02/00003-02-05/i love purple said the girl.mp3": [
		4788,
		7,
		3463
	],
	"./00003/00003-02/00003-02-05/i love purple.mp3": [
		4789,
		7,
		3464
	],
	"./00003/00003-02/00003-02-05/i love red.mp3": [
		4790,
		7,
		3465
	],
	"./00003/00003-02/00003-02-05/i love to paint said the boy.mp3": [
		4791,
		7,
		3466
	],
	"./00003/00003-02/00003-02-05/i love to paint said the mouse.mp3": [
		4792,
		7,
		3467
	],
	"./00003/00003-02/00003-02-05/i love to paint said the rabbit.mp3": [
		4793,
		7,
		3468
	],
	"./00003/00003-02/00003-02-05/i love to paint said the zebra.mp3": [
		4794,
		7,
		3469
	],
	"./00003/00003-02/00003-02-05/i love to paint.mp3": [
		4795,
		7,
		3470
	],
	"./00003/00003-02/00003-02-05/intro.mp3": [
		615,
		7
	],
	"./00003/00003-02/00003-02-05/look at me.mp3": [
		4796,
		7,
		3471
	],
	"./00003/00003-02/00003-02-05/main idea.mp3": [
		996,
		7
	],
	"./00003/00003-02/00003-02-05/module": [
		1421,
		9,
		285
	],
	"./00003/00003-02/00003-02-05/module.js": [
		1421,
		9,
		285
	],
	"./00003/00003-02/00003-02-06/0.jpg": [
		6972,
		7,
		5649
	],
	"./00003/00003-02/00003-02-06/1.jpg": [
		9295,
		7,
		9317
	],
	"./00003/00003-02/00003-02-06/2.jpg": [
		9296,
		7,
		9318
	],
	"./00003/00003-02/00003-02-06/3.jpg": [
		9297,
		7,
		9319
	],
	"./00003/00003-02/00003-02-06/4.jpg": [
		9298,
		7,
		9320
	],
	"./00003/00003-02/00003-02-06/5.jpg": [
		9299,
		7,
		9321
	],
	"./00003/00003-02/00003-02-06/6.jpg": [
		9300,
		7,
		9322
	],
	"./00003/00003-02/00003-02-06/7.jpg": [
		9301,
		7,
		9323
	],
	"./00003/00003-02/00003-02-06/food.mp3": [
		4797,
		7,
		3472
	],
	"./00003/00003-02/00003-02-06/im the gingerbread man.mp3": [
		4798,
		7,
		3473
	],
	"./00003/00003-02/00003-02-06/intro.mp3": [
		616,
		7
	],
	"./00003/00003-02/00003-02-06/look at the alligator.mp3": [
		4799,
		7,
		3474
	],
	"./00003/00003-02/00003-02-06/look at the cow.mp3": [
		4800,
		7,
		3475
	],
	"./00003/00003-02/00003-02-06/look at the dog.mp3": [
		4801,
		7,
		3476
	],
	"./00003/00003-02/00003-02-06/look at the gingerbread man.mp3": [
		4802,
		7,
		3477
	],
	"./00003/00003-02/00003-02-06/look at the horse.mp3": [
		4803,
		7,
		3478
	],
	"./00003/00003-02/00003-02-06/look at the sheep.mp3": [
		4804,
		7,
		3479
	],
	"./00003/00003-02/00003-02-06/main idea.mp3": [
		997,
		7
	],
	"./00003/00003-02/00003-02-06/module": [
		1422,
		9,
		286
	],
	"./00003/00003-02/00003-02-06/module.js": [
		1422,
		9,
		286
	],
	"./00003/00003-02/00003-02-06/no said the gingerbread man.mp3": [
		4805,
		7,
		3480
	],
	"./00003/00003-02/00003-02-06/oh no.mp3": [
		4806,
		7,
		3481
	],
	"./00003/00003-02/00003-02-06/run run as fast as you can.mp3": [
		4807,
		7,
		3482
	],
	"./00003/00003-02/00003-02-06/stop said the alligator.mp3": [
		4808,
		7,
		3483
	],
	"./00003/00003-02/00003-02-06/stop said the cow.mp3": [
		4809,
		7,
		3484
	],
	"./00003/00003-02/00003-02-06/stop said the dog.mp3": [
		4810,
		7,
		3485
	],
	"./00003/00003-02/00003-02-06/stop said the horse.mp3": [
		4811,
		7,
		3486
	],
	"./00003/00003-02/00003-02-06/stop said the sheep.mp3": [
		4812,
		7,
		3487
	],
	"./00003/00003-02/00003-02-06/the gingerbread man.mp3": [
		4813,
		7,
		3488
	],
	"./00003/00003-02/00003-02-06/you cant catch me.mp3": [
		4814,
		7,
		3489
	],
	"./00003/00003-02/00003-02-07/0 little frogs sat on a log.mp3": [
		4815,
		7,
		3490
	],
	"./00003/00003-02/00003-02-07/0.jpg": [
		6973,
		7,
		5650
	],
	"./00003/00003-02/00003-02-07/1 frog jumped into the pond.mp3": [
		4816,
		7,
		3491
	],
	"./00003/00003-02/00003-02-07/1 jumped into the pond.mp3": [
		4817,
		7,
		3492
	],
	"./00003/00003-02/00003-02-07/1 little frog sat on a log.mp3": [
		4818,
		7,
		3493
	],
	"./00003/00003-02/00003-02-07/1.jpg": [
		9302,
		7,
		9324
	],
	"./00003/00003-02/00003-02-07/2 little frogs sat on a log.mp3": [
		4819,
		7,
		3494
	],
	"./00003/00003-02/00003-02-07/2.jpg": [
		9303,
		7,
		9325
	],
	"./00003/00003-02/00003-02-07/3 little frogs sat on a log.mp3": [
		4820,
		7,
		3495
	],
	"./00003/00003-02/00003-02-07/3.jpg": [
		9304,
		7,
		9326
	],
	"./00003/00003-02/00003-02-07/4 little frogs sat on a log.mp3": [
		4821,
		7,
		3496
	],
	"./00003/00003-02/00003-02-07/4.jpg": [
		9305,
		7,
		9327
	],
	"./00003/00003-02/00003-02-07/5 little frogs sat in the pond.mp3": [
		4822,
		7,
		3497
	],
	"./00003/00003-02/00003-02-07/5 little frogs sat on a log.mp3": [
		4823,
		7,
		3498
	],
	"./00003/00003-02/00003-02-07/5 little frogs.mp3": [
		4824,
		7,
		3499
	],
	"./00003/00003-02/00003-02-07/5.jpg": [
		9306,
		7,
		9328
	],
	"./00003/00003-02/00003-02-07/6.jpg": [
		9307,
		7,
		9329
	],
	"./00003/00003-02/00003-02-07/7.jpg": [
		9308,
		7,
		9330
	],
	"./00003/00003-02/00003-02-07/intro.mp3": [
		617,
		7
	],
	"./00003/00003-02/00003-02-07/it is hot on the log they said.mp3": [
		4825,
		7,
		3500
	],
	"./00003/00003-02/00003-02-07/main idea.mp3": [
		998,
		7
	],
	"./00003/00003-02/00003-02-07/module": [
		1423,
		9,
		287
	],
	"./00003/00003-02/00003-02-07/module.js": [
		1423,
		9,
		287
	],
	"./00003/00003-02/00003-02-07/now there are 2 little frogs on a log.mp3": [
		4826,
		7,
		3501
	],
	"./00003/00003-02/00003-02-07/now there are 3 little frogs on a log.mp3": [
		4827,
		7,
		3502
	],
	"./00003/00003-02/00003-02-07/now there are 4 little frogs on a log.mp3": [
		4828,
		7,
		3503
	],
	"./00003/00003-02/00003-02-07/now there are 5 little frogs in the pond.mp3": [
		4829,
		7,
		3504
	],
	"./00003/00003-02/00003-02-07/now there are no little frogs on a log.mp3": [
		4830,
		7,
		3505
	],
	"./00003/00003-02/00003-02-07/now there is 1 little frog on a log.mp3": [
		4831,
		7,
		3506
	],
	"./00003/00003-02/00003-02-07/she jumped into the pond.mp3": [
		4832,
		7,
		3507
	],
	"./00003/00003-02/00003-02-07/water animals.mp3": [
		4833,
		7,
		3508
	],
	"./00003/00003-02/00003-02-07/we like the pond they said.mp3": [
		4834,
		7,
		3509
	],
	"./00003/00003-02/00003-02-07/where are the frogs.mp3": [
		4835,
		7,
		3510
	],
	"./00003/00003-02/00003-02-08/0.jpg": [
		6974,
		7,
		5651
	],
	"./00003/00003-02/00003-02-08/1.jpg": [
		9309,
		7,
		9331
	],
	"./00003/00003-02/00003-02-08/2.jpg": [
		9310,
		7,
		9332
	],
	"./00003/00003-02/00003-02-08/3.jpg": [
		9311,
		7,
		9333
	],
	"./00003/00003-02/00003-02-08/4.jpg": [
		9312,
		7,
		9334
	],
	"./00003/00003-02/00003-02-08/5.jpg": [
		9313,
		7,
		9335
	],
	"./00003/00003-02/00003-02-08/6.jpg": [
		9314,
		7,
		9336
	],
	"./00003/00003-02/00003-02-08/7.jpg": [
		9315,
		7,
		9337
	],
	"./00003/00003-02/00003-02-08/a giraffe is too big.mp3": [
		4836,
		7,
		3511
	],
	"./00003/00003-02/00003-02-08/an elephant is too big.mp3": [
		4837,
		7,
		3512
	],
	"./00003/00003-02/00003-02-08/can i have a crocodile said sam.mp3": [
		4838,
		7,
		3513
	],
	"./00003/00003-02/00003-02-08/can i have a dog said sam.mp3": [
		4839,
		7,
		3514
	],
	"./00003/00003-02/00003-02-08/can i have a giraffe said sam.mp3": [
		4840,
		7,
		3515
	],
	"./00003/00003-02/00003-02-08/can i have a pet.mp3": [
		4841,
		7,
		3516
	],
	"./00003/00003-02/00003-02-08/can i have an elephant said sam.mp3": [
		4842,
		7,
		3517
	],
	"./00003/00003-02/00003-02-08/intro.mp3": [
		618,
		7
	],
	"./00003/00003-02/00003-02-08/main idea.mp3": [
		999,
		7
	],
	"./00003/00003-02/00003-02-08/module": [
		1424,
		9,
		288
	],
	"./00003/00003-02/00003-02-08/module.js": [
		1424,
		9,
		288
	],
	"./00003/00003-02/00003-02-08/no monkeys.mp3": [
		4843,
		7,
		3518
	],
	"./00003/00003-02/00003-02-08/no said dad.mp3": [
		4844,
		7,
		3519
	],
	"./00003/00003-02/00003-02-08/no said mom and dad.mp3": [
		4845,
		7,
		3520
	],
	"./00003/00003-02/00003-02-08/no said mom.mp3": [
		4846,
		7,
		3521
	],
	"./00003/00003-02/00003-02-08/pets.mp3": [
		4847,
		7,
		3522
	],
	"./00003/00003-02/00003-02-08/sam said can i have a monkey.mp3": [
		4848,
		7,
		3523
	],
	"./00003/00003-02/00003-02-08/sam said can i have a snake.mp3": [
		4849,
		7,
		3524
	],
	"./00003/00003-02/00003-02-08/sam said can i have an ostrich.mp3": [
		4850,
		7,
		3525
	],
	"./00003/00003-02/00003-02-08/we do not like snakes.mp3": [
		4851,
		7,
		3526
	],
	"./00003/00003-02/00003-02-08/yes said mom and dad.mp3": [
		4852,
		7,
		3527
	],
	"./00003/00003-02/00003-02-08/you can have a dog.mp3": [
		4853,
		7,
		3528
	],
	"./00003/00003-02/00003-02-08/you can not have a crocodile.mp3": [
		4854,
		7,
		3529
	],
	"./00003/00003-02/00003-02-08/you can not have a giraffe.mp3": [
		4855,
		7,
		3530
	],
	"./00003/00003-02/00003-02-08/you can not have a monkey.mp3": [
		4856,
		7,
		3531
	],
	"./00003/00003-02/00003-02-08/you can not have a snake.mp3": [
		4857,
		7,
		3532
	],
	"./00003/00003-02/00003-02-08/you can not have an elephant.mp3": [
		4858,
		7,
		3533
	],
	"./00003/00003-02/00003-02-08/you can not have an ostrich.mp3": [
		4859,
		7,
		3534
	],
	"./00003/00003-02/00003-02-09/0.jpg": [
		6975,
		7,
		5652
	],
	"./00003/00003-02/00003-02-09/1.jpg": [
		9316,
		7,
		9338
	],
	"./00003/00003-02/00003-02-09/2.jpg": [
		9317,
		7,
		9339
	],
	"./00003/00003-02/00003-02-09/3.jpg": [
		9318,
		7,
		9340
	],
	"./00003/00003-02/00003-02-09/4.jpg": [
		9319,
		7,
		9341
	],
	"./00003/00003-02/00003-02-09/5.jpg": [
		9320,
		7,
		9342
	],
	"./00003/00003-02/00003-02-09/6.jpg": [
		9321,
		7,
		9343
	],
	"./00003/00003-02/00003-02-09/7.jpg": [
		9322,
		7,
		9344
	],
	"./00003/00003-02/00003-02-09/do you.mp3": [
		4860,
		7,
		3535
	],
	"./00003/00003-02/00003-02-09/i like the horse.mp3": [
		4861,
		7,
		3536
	],
	"./00003/00003-02/00003-02-09/i like the slide.mp3": [
		4862,
		7,
		3537
	],
	"./00003/00003-02/00003-02-09/i like the swings.mp3": [
		4863,
		7,
		3538
	],
	"./00003/00003-02/00003-02-09/i like to play on the horse said the boy.mp3": [
		4864,
		7,
		3539
	],
	"./00003/00003-02/00003-02-09/i like to play on the horse said the monster.mp3": [
		4865,
		7,
		3540
	],
	"./00003/00003-02/00003-02-09/i like to play on the slide said the boy.mp3": [
		4866,
		7,
		3541
	],
	"./00003/00003-02/00003-02-09/i like to play on the swings said the girl.mp3": [
		4867,
		7,
		3542
	],
	"./00003/00003-02/00003-02-09/i like to play on the swings said the monster.mp3": [
		4868,
		7,
		3543
	],
	"./00003/00003-02/00003-02-09/intro.mp3": [
		619,
		7
	],
	"./00003/00003-02/00003-02-09/look at me said the boy.mp3": [
		4869,
		7,
		3544
	],
	"./00003/00003-02/00003-02-09/look at me said the girl.mp3": [
		4870,
		7,
		3545
	],
	"./00003/00003-02/00003-02-09/look at me said the monster.mp3": [
		4871,
		7,
		3546
	],
	"./00003/00003-02/00003-02-09/look at me.mp3": [
		4872,
		7,
		3547
	],
	"./00003/00003-02/00003-02-09/main idea.mp3": [
		1000,
		7
	],
	"./00003/00003-02/00003-02-09/module": [
		1425,
		9,
		289
	],
	"./00003/00003-02/00003-02-09/module.js": [
		1425,
		9,
		289
	],
	"./00003/00003-02/00003-02-09/the playground.mp3": [
		4873,
		7,
		3548
	],
	"./00003/00003-02/00003-02-09/toys.mp3": [
		4874,
		7,
		3549
	],
	"./00003/00003-02/00003-02-09/we like the seesaw.mp3": [
		4875,
		7,
		3550
	],
	"./00003/00003-02/00003-02-09/we like to play on the seesaw said the kids.mp3": [
		4876,
		7,
		3551
	],
	"./00003/00003-02/00003-02-09/we like to play on the slide said the monsters.mp3": [
		4877,
		7,
		3552
	],
	"./00003/00003-02/00003-02-10/0.jpg": [
		6976,
		7,
		5653
	],
	"./00003/00003-02/00003-02-10/1.jpg": [
		9323,
		7,
		9345
	],
	"./00003/00003-02/00003-02-10/2.jpg": [
		9324,
		7,
		9346
	],
	"./00003/00003-02/00003-02-10/3.jpg": [
		9325,
		7,
		9347
	],
	"./00003/00003-02/00003-02-10/4.jpg": [
		9326,
		7,
		9348
	],
	"./00003/00003-02/00003-02-10/5.jpg": [
		9327,
		7,
		9349
	],
	"./00003/00003-02/00003-02-10/6.jpg": [
		9328,
		7,
		9350
	],
	"./00003/00003-02/00003-02-10/7.jpg": [
		9329,
		7,
		9351
	],
	"./00003/00003-02/00003-02-10/farm animals.mp3": [
		4878,
		7,
		3553
	],
	"./00003/00003-02/00003-02-10/hello cat i like your hat.mp3": [
		4879,
		7,
		3554
	],
	"./00003/00003-02/00003-02-10/hello chicken i like your hat.mp3": [
		4880,
		7,
		3555
	],
	"./00003/00003-02/00003-02-10/hello cow i like your hat.mp3": [
		4881,
		7,
		3556
	],
	"./00003/00003-02/00003-02-10/hello dog can i have your hat.mp3": [
		4882,
		7,
		3557
	],
	"./00003/00003-02/00003-02-10/hello dog i like your hat.mp3": [
		4883,
		7,
		3558
	],
	"./00003/00003-02/00003-02-10/hello goat i like your hat.mp3": [
		4884,
		7,
		3559
	],
	"./00003/00003-02/00003-02-10/hello horse can i have your hat.mp3": [
		4885,
		7,
		3560
	],
	"./00003/00003-02/00003-02-10/hello horse i like your hat.mp3": [
		4886,
		7,
		3561
	],
	"./00003/00003-02/00003-02-10/hello sheep can i have your hat.mp3": [
		4887,
		7,
		3562
	],
	"./00003/00003-02/00003-02-10/hello sheep i like your hat.mp3": [
		4888,
		7,
		3563
	],
	"./00003/00003-02/00003-02-10/intro.mp3": [
		620,
		7
	],
	"./00003/00003-02/00003-02-10/main idea.mp3": [
		1001,
		7
	],
	"./00003/00003-02/00003-02-10/module": [
		1426,
		9,
		290
	],
	"./00003/00003-02/00003-02-10/module.js": [
		1426,
		9,
		290
	],
	"./00003/00003-02/00003-02-10/thank you.mp3": [
		4889,
		7,
		3564
	],
	"./00003/00003-02/00003-02-10/yes you can have it.mp3": [
		4890,
		7,
		3565
	],
	"./00003/00003-02/00003-02-10/you can have it.mp3": [
		4891,
		7,
		3566
	],
	"./00003/00003-02/00003-02-11/0.jpg": [
		6977,
		7,
		5654
	],
	"./00003/00003-02/00003-02-11/1.jpg": [
		9330,
		7,
		9352
	],
	"./00003/00003-02/00003-02-11/2.jpg": [
		9331,
		7,
		9353
	],
	"./00003/00003-02/00003-02-11/3.jpg": [
		9332,
		7,
		9354
	],
	"./00003/00003-02/00003-02-11/4.jpg": [
		9333,
		7,
		9355
	],
	"./00003/00003-02/00003-02-11/5.jpg": [
		9334,
		7,
		9356
	],
	"./00003/00003-02/00003-02-11/6.jpg": [
		9335,
		7,
		9357
	],
	"./00003/00003-02/00003-02-11/7.jpg": [
		9336,
		7,
		9358
	],
	"./00003/00003-02/00003-02-11/animals.mp3": [
		4892,
		7,
		3567
	],
	"./00003/00003-02/00003-02-11/here is a cat.mp3": [
		4893,
		7,
		3568
	],
	"./00003/00003-02/00003-02-11/here is a dog.mp3": [
		4894,
		7,
		3569
	],
	"./00003/00003-02/00003-02-11/i like ice cream he said.mp3": [
		4895,
		7,
		3570
	],
	"./00003/00003-02/00003-02-11/i like ice cream she said.mp3": [
		4896,
		7,
		3571
	],
	"./00003/00003-02/00003-02-11/i love ice cream she said.mp3": [
		4897,
		7,
		3572
	],
	"./00003/00003-02/00003-02-11/i see the octopus.mp3": [
		4898,
		7,
		3573
	],
	"./00003/00003-02/00003-02-11/i see the snake.mp3": [
		4899,
		7,
		3574
	],
	"./00003/00003-02/00003-02-11/intro.mp3": [
		621,
		7
	],
	"./00003/00003-02/00003-02-11/look at the bat.mp3": [
		4900,
		7,
		3575
	],
	"./00003/00003-02/00003-02-11/look at the elephant.mp3": [
		4901,
		7,
		3576
	],
	"./00003/00003-02/00003-02-11/look at the lion.mp3": [
		4902,
		7,
		3577
	],
	"./00003/00003-02/00003-02-11/main idea.mp3": [
		1002,
		7
	],
	"./00003/00003-02/00003-02-11/module": [
		1427,
		9,
		291
	],
	"./00003/00003-02/00003-02-11/module.js": [
		1427,
		9,
		291
	],
	"./00003/00003-02/00003-02-11/we like ice cream.mp3": [
		4903,
		7,
		3578
	],
	"./00003/00003-02/cover.jpg": [
		6978,
		7,
		5655
	],
	"./00003/00003-02/story park.mp3": [
		4904,
		7,
		3579
	],
	"./00003/00003-02/unit": [
		1428,
		9,
		292
	],
	"./00003/00003-02/unit.js": [
		1428,
		9,
		292
	],
	"./00003/00003-03/00003-03-01/0.jpg": [
		6979,
		7,
		5656
	],
	"./00003/00003-03/00003-03-01/1.jpg": [
		9337,
		7,
		9359
	],
	"./00003/00003-03/00003-03-01/2.jpg": [
		9338,
		7,
		9360
	],
	"./00003/00003-03/00003-03-01/3.jpg": [
		9339,
		7,
		9361
	],
	"./00003/00003-03/00003-03-01/4.jpg": [
		9340,
		7,
		9362
	],
	"./00003/00003-03/00003-03-01/5.jpg": [
		9341,
		7,
		9363
	],
	"./00003/00003-03/00003-03-01/6.jpg": [
		9342,
		7,
		9364
	],
	"./00003/00003-03/00003-03-01/7.jpg": [
		9343,
		7,
		9365
	],
	"./00003/00003-03/00003-03-01/a sea turtle lives in the sea.mp3": [
		4905,
		7,
		3580
	],
	"./00003/00003-03/00003-03-01/a seahorse lives in the sea.mp3": [
		4906,
		7,
		3581
	],
	"./00003/00003-03/00003-03-01/a shark lives in the sea.mp3": [
		4907,
		7,
		3582
	],
	"./00003/00003-03/00003-03-01/a whale lives in the sea.mp3": [
		4908,
		7,
		3583
	],
	"./00003/00003-03/00003-03-01/here comes the gray whale.mp3": [
		4909,
		7,
		3584
	],
	"./00003/00003-03/00003-03-01/here is a dolphin.mp3": [
		4910,
		7,
		3585
	],
	"./00003/00003-03/00003-03-01/here is a sea turtle.mp3": [
		4911,
		7,
		3586
	],
	"./00003/00003-03/00003-03-01/here is a seahorse.mp3": [
		4912,
		7,
		3587
	],
	"./00003/00003-03/00003-03-01/i like the crab.mp3": [
		4913,
		7,
		3588
	],
	"./00003/00003-03/00003-03-01/i see the octopus.mp3": [
		4914,
		7,
		3589
	],
	"./00003/00003-03/00003-03-01/intro.mp3": [
		622,
		7
	],
	"./00003/00003-03/00003-03-01/look at the crab.mp3": [
		4915,
		7,
		3590
	],
	"./00003/00003-03/00003-03-01/look at the octopus.mp3": [
		4916,
		7,
		3591
	],
	"./00003/00003-03/00003-03-01/look at the shark.mp3": [
		4917,
		7,
		3592
	],
	"./00003/00003-03/00003-03-01/look at the whale.mp3": [
		4918,
		7,
		3593
	],
	"./00003/00003-03/00003-03-01/main idea.mp3": [
		1003,
		7
	],
	"./00003/00003-03/00003-03-01/module": [
		1429,
		9,
		293
	],
	"./00003/00003-03/00003-03-01/module.js": [
		1429,
		9,
		293
	],
	"./00003/00003-03/00003-03-01/sea animals.mp3": [
		4919,
		7,
		3594
	],
	"./00003/00003-03/00003-03-01/the crab lives in the sea.mp3": [
		4920,
		7,
		3595
	],
	"./00003/00003-03/00003-03-01/the dolphin is a mammal.mp3": [
		4921,
		7,
		3596
	],
	"./00003/00003-03/00003-03-01/the dolphin lives in the sea.mp3": [
		4922,
		7,
		3597
	],
	"./00003/00003-03/00003-03-01/the octopus lives in the sea.mp3": [
		4923,
		7,
		3598
	],
	"./00003/00003-03/00003-03-01/the seahorse is a fish.mp3": [
		4924,
		7,
		3599
	],
	"./00003/00003-03/00003-03-01/the shark is a fish.mp3": [
		4925,
		7,
		3600
	],
	"./00003/00003-03/00003-03-01/the turtle is a reptile.mp3": [
		4926,
		7,
		3601
	],
	"./00003/00003-03/00003-03-02/0.jpg": [
		6980,
		7,
		5657
	],
	"./00003/00003-03/00003-03-02/1.jpg": [
		9344,
		7,
		9366
	],
	"./00003/00003-03/00003-03-02/2.jpg": [
		9345,
		7,
		9367
	],
	"./00003/00003-03/00003-03-02/3.jpg": [
		9346,
		7,
		9368
	],
	"./00003/00003-03/00003-03-02/4.jpg": [
		9347,
		7,
		9369
	],
	"./00003/00003-03/00003-03-02/5.jpg": [
		9348,
		7,
		9370
	],
	"./00003/00003-03/00003-03-02/6.jpg": [
		9349,
		7,
		9371
	],
	"./00003/00003-03/00003-03-02/7.jpg": [
		9350,
		7,
		9372
	],
	"./00003/00003-03/00003-03-02/intro.mp3": [
		623,
		7
	],
	"./00003/00003-03/00003-03-02/look at the beaver.mp3": [
		4927,
		7,
		3602
	],
	"./00003/00003-03/00003-03-02/look at the dragonfly.mp3": [
		4928,
		7,
		3603
	],
	"./00003/00003-03/00003-03-02/look at the duck.mp3": [
		4929,
		7,
		3604
	],
	"./00003/00003-03/00003-03-02/look at the frog.mp3": [
		4930,
		7,
		3605
	],
	"./00003/00003-03/00003-03-02/look at the salamander.mp3": [
		4931,
		7,
		3606
	],
	"./00003/00003-03/00003-03-02/look at the toad.mp3": [
		4932,
		7,
		3607
	],
	"./00003/00003-03/00003-03-02/look at the turtle.mp3": [
		4933,
		7,
		3608
	],
	"./00003/00003-03/00003-03-02/main idea.mp3": [
		1004,
		7
	],
	"./00003/00003-03/00003-03-02/me too said the dragonfly.mp3": [
		4934,
		7,
		3609
	],
	"./00003/00003-03/00003-03-02/module": [
		1430,
		9,
		294
	],
	"./00003/00003-03/00003-03-02/module.js": [
		1430,
		9,
		294
	],
	"./00003/00003-03/00003-03-02/pond animals.mp3": [
		4935,
		7,
		3610
	],
	"./00003/00003-03/00003-03-02/the beaver lives at the pond.mp3": [
		4936,
		7,
		3611
	],
	"./00003/00003-03/00003-03-02/the dragonfly lives at the pond.mp3": [
		4937,
		7,
		3612
	],
	"./00003/00003-03/00003-03-02/the duck lives at the pond too.mp3": [
		4938,
		7,
		3613
	],
	"./00003/00003-03/00003-03-02/the frog lives at the pond.mp3": [
		4939,
		7,
		3614
	],
	"./00003/00003-03/00003-03-02/the salamander lives at the pond.mp3": [
		4940,
		7,
		3615
	],
	"./00003/00003-03/00003-03-02/the toad lives at the pond.mp3": [
		4941,
		7,
		3616
	],
	"./00003/00003-03/00003-03-02/the turtle lives at the pond.mp3": [
		4942,
		7,
		3617
	],
	"./00003/00003-03/00003-03-02/who else lives at the pond.mp3": [
		4943,
		7,
		3618
	],
	"./00003/00003-03/00003-03-02/who lives at the pond.mp3": [
		4944,
		7,
		3619
	],
	"./00003/00003-03/00003-03-03/0.jpg": [
		6981,
		7,
		5658
	],
	"./00003/00003-03/00003-03-03/1.jpg": [
		9351,
		7,
		9373
	],
	"./00003/00003-03/00003-03-03/2.jpg": [
		9352,
		7,
		9374
	],
	"./00003/00003-03/00003-03-03/3.jpg": [
		9353,
		7,
		9375
	],
	"./00003/00003-03/00003-03-03/4.jpg": [
		9354,
		7,
		9376
	],
	"./00003/00003-03/00003-03-03/5.jpg": [
		9355,
		7,
		9377
	],
	"./00003/00003-03/00003-03-03/6.jpg": [
		9356,
		7,
		9378
	],
	"./00003/00003-03/00003-03-03/7.jpg": [
		9357,
		7,
		9379
	],
	"./00003/00003-03/00003-03-03/giraffes like to eat leaves.mp3": [
		4945,
		7,
		3620
	],
	"./00003/00003-03/00003-03-03/i am a cat.mp3": [
		4946,
		7,
		3621
	],
	"./00003/00003-03/00003-03-03/i am a giraffe.mp3": [
		4947,
		7,
		3622
	],
	"./00003/00003-03/00003-03-03/i am a hippo.mp3": [
		4948,
		7,
		3623
	],
	"./00003/00003-03/00003-03-03/i am a lion.mp3": [
		4949,
		7,
		3624
	],
	"./00003/00003-03/00003-03-03/i am a mammal.mp3": [
		4950,
		7,
		3625
	],
	"./00003/00003-03/00003-03-03/i am a rhino.mp3": [
		4951,
		7,
		3626
	],
	"./00003/00003-03/00003-03-03/i am a tiger.mp3": [
		4952,
		7,
		3627
	],
	"./00003/00003-03/00003-03-03/i am a wild animal.mp3": [
		4953,
		7,
		3628
	],
	"./00003/00003-03/00003-03-03/i am a zebra.mp3": [
		4954,
		7,
		3629
	],
	"./00003/00003-03/00003-03-03/i have 2 horns.mp3": [
		4955,
		7,
		3630
	],
	"./00003/00003-03/00003-03-03/i live in the wild.mp3": [
		4956,
		7,
		3631
	],
	"./00003/00003-03/00003-03-03/intro.mp3": [
		624,
		7
	],
	"./00003/00003-03/00003-03-03/look at me.mp3": [
		4957,
		7,
		3632
	],
	"./00003/00003-03/00003-03-03/look at us.mp3": [
		4958,
		7,
		3633
	],
	"./00003/00003-03/00003-03-03/main idea.mp3": [
		1005,
		7
	],
	"./00003/00003-03/00003-03-03/module": [
		1431,
		9,
		295
	],
	"./00003/00003-03/00003-03-03/module.js": [
		1431,
		9,
		295
	],
	"./00003/00003-03/00003-03-03/we are kangaroos.mp3": [
		4959,
		7,
		3634
	],
	"./00003/00003-03/00003-03-03/we are mammals.mp3": [
		4960,
		7,
		3635
	],
	"./00003/00003-03/00003-03-03/we are wild animals too.mp3": [
		4961,
		7,
		3636
	],
	"./00003/00003-03/00003-03-03/wild animals.mp3": [
		4962,
		7,
		3637
	],
	"./00003/00003-03/00003-03-03/zebras like to eat grass.mp3": [
		4963,
		7,
		3638
	],
	"./00003/00003-03/00003-03-04/0.jpg": [
		6982,
		7,
		5659
	],
	"./00003/00003-03/00003-03-04/1.jpg": [
		9358,
		7,
		9380
	],
	"./00003/00003-03/00003-03-04/2.jpg": [
		9359,
		7,
		9381
	],
	"./00003/00003-03/00003-03-04/3.jpg": [
		9360,
		7,
		9382
	],
	"./00003/00003-03/00003-03-04/4.jpg": [
		9361,
		7,
		9383
	],
	"./00003/00003-03/00003-03-04/5.jpg": [
		9362,
		7,
		9384
	],
	"./00003/00003-03/00003-03-04/6.jpg": [
		9363,
		7,
		9385
	],
	"./00003/00003-03/00003-03-04/7.jpg": [
		9364,
		7,
		9386
	],
	"./00003/00003-03/00003-03-04/he lives with me.mp3": [
		4964,
		7,
		3639
	],
	"./00003/00003-03/00003-03-04/here is my cat said the boy.mp3": [
		4965,
		7,
		3640
	],
	"./00003/00003-03/00003-03-04/here is my dog said the girl.mp3": [
		4966,
		7,
		3641
	],
	"./00003/00003-03/00003-03-04/here is my pet said the boy.mp3": [
		4967,
		7,
		3642
	],
	"./00003/00003-03/00003-03-04/here is my pet said the girl.mp3": [
		4968,
		7,
		3643
	],
	"./00003/00003-03/00003-03-04/here is my pet.mp3": [
		4969,
		7,
		3644
	],
	"./00003/00003-03/00003-03-04/i love my cat.mp3": [
		4970,
		7,
		3645
	],
	"./00003/00003-03/00003-03-04/i love my dinosaur.mp3": [
		4971,
		7,
		3646
	],
	"./00003/00003-03/00003-03-04/i love my dog.mp3": [
		4972,
		7,
		3647
	],
	"./00003/00003-03/00003-03-04/i love my fish.mp3": [
		4973,
		7,
		3648
	],
	"./00003/00003-03/00003-03-04/i love my rabbit.mp3": [
		4974,
		7,
		3649
	],
	"./00003/00003-03/00003-03-04/i love my snake.mp3": [
		4975,
		7,
		3650
	],
	"./00003/00003-03/00003-03-04/i love my turtle.mp3": [
		4976,
		7,
		3651
	],
	"./00003/00003-03/00003-03-04/intro.mp3": [
		625,
		7
	],
	"./00003/00003-03/00003-03-04/look at my pet.mp3": [
		4977,
		7,
		3652
	],
	"./00003/00003-03/00003-03-04/main idea.mp3": [
		1006,
		7
	],
	"./00003/00003-03/00003-03-04/module": [
		1432,
		9,
		296
	],
	"./00003/00003-03/00003-03-04/module.js": [
		1432,
		9,
		296
	],
	"./00003/00003-03/00003-03-04/my pet is a turtle.mp3": [
		4978,
		7,
		3653
	],
	"./00003/00003-03/00003-03-04/pets.mp3": [
		4979,
		7,
		3654
	],
	"./00003/00003-03/00003-03-04/she lives with me.mp3": [
		4980,
		7,
		3655
	],
	"./00003/00003-03/00003-03-05/0.jpg": [
		6983,
		7,
		5660
	],
	"./00003/00003-03/00003-03-05/1.jpg": [
		9365,
		7,
		9387
	],
	"./00003/00003-03/00003-03-05/2.jpg": [
		9366,
		7,
		9388
	],
	"./00003/00003-03/00003-03-05/3.jpg": [
		9367,
		7,
		9389
	],
	"./00003/00003-03/00003-03-05/4.jpg": [
		9368,
		7,
		9390
	],
	"./00003/00003-03/00003-03-05/5.jpg": [
		9369,
		7,
		9391
	],
	"./00003/00003-03/00003-03-05/6.jpg": [
		9370,
		7,
		9392
	],
	"./00003/00003-03/00003-03-05/7.jpg": [
		9371,
		7,
		9393
	],
	"./00003/00003-03/00003-03-05/forest animals.mp3": [
		4981,
		7,
		3656
	],
	"./00003/00003-03/00003-03-05/he lives in the forest.mp3": [
		4982,
		7,
		3657
	],
	"./00003/00003-03/00003-03-05/here is a bear.mp3": [
		4983,
		7,
		3658
	],
	"./00003/00003-03/00003-03-05/here is a deer.mp3": [
		4984,
		7,
		3659
	],
	"./00003/00003-03/00003-03-05/here is a rabbit.mp3": [
		4985,
		7,
		3660
	],
	"./00003/00003-03/00003-03-05/i see a bird.mp3": [
		4986,
		7,
		3661
	],
	"./00003/00003-03/00003-03-05/i see a fox.mp3": [
		4987,
		7,
		3662
	],
	"./00003/00003-03/00003-03-05/i see a hedgehog.mp3": [
		4988,
		7,
		3663
	],
	"./00003/00003-03/00003-03-05/i see a squirrel.mp3": [
		4989,
		7,
		3664
	],
	"./00003/00003-03/00003-03-05/intro.mp3": [
		626,
		7
	],
	"./00003/00003-03/00003-03-05/look at the bear.mp3": [
		4990,
		7,
		3665
	],
	"./00003/00003-03/00003-03-05/look at the bird.mp3": [
		4991,
		7,
		3666
	],
	"./00003/00003-03/00003-03-05/look at the deer.mp3": [
		4992,
		7,
		3667
	],
	"./00003/00003-03/00003-03-05/look at the fox.mp3": [
		4993,
		7,
		3668
	],
	"./00003/00003-03/00003-03-05/look at the hedgehog.mp3": [
		4994,
		7,
		3669
	],
	"./00003/00003-03/00003-03-05/look at the owl.mp3": [
		4995,
		7,
		3670
	],
	"./00003/00003-03/00003-03-05/look at the rabbit.mp3": [
		4996,
		7,
		3671
	],
	"./00003/00003-03/00003-03-05/look at the squirrel.mp3": [
		4997,
		7,
		3672
	],
	"./00003/00003-03/00003-03-05/main idea.mp3": [
		1007,
		7
	],
	"./00003/00003-03/00003-03-05/module": [
		1433,
		9,
		297
	],
	"./00003/00003-03/00003-03-05/module.js": [
		1433,
		9,
		297
	],
	"./00003/00003-03/00003-03-05/she lives in the forest.mp3": [
		4998,
		7,
		3673
	],
	"./00003/00003-03/00003-03-05/the deer is in the forest.mp3": [
		4999,
		7,
		3674
	],
	"./00003/00003-03/00003-03-05/the fox is in the forest.mp3": [
		5000,
		7,
		3675
	],
	"./00003/00003-03/00003-03-05/the squirrel is up in the tree.mp3": [
		5001,
		7,
		3676
	],
	"./00003/00003-03/00003-03-06/0.jpg": [
		6984,
		7,
		5661
	],
	"./00003/00003-03/00003-03-06/1.jpg": [
		9372,
		7,
		9394
	],
	"./00003/00003-03/00003-03-06/2.jpg": [
		9373,
		7,
		9395
	],
	"./00003/00003-03/00003-03-06/3.jpg": [
		9374,
		7,
		9396
	],
	"./00003/00003-03/00003-03-06/4.jpg": [
		9375,
		7,
		9397
	],
	"./00003/00003-03/00003-03-06/5.jpg": [
		9376,
		7,
		9398
	],
	"./00003/00003-03/00003-03-06/6.jpg": [
		9377,
		7,
		9399
	],
	"./00003/00003-03/00003-03-06/7.jpg": [
		9378,
		7,
		9400
	],
	"./00003/00003-03/00003-03-06/do you.mp3": [
		5002,
		7,
		3677
	],
	"./00003/00003-03/00003-03-06/farm animals.mp3": [
		5003,
		7,
		3678
	],
	"./00003/00003-03/00003-03-06/he lives on a farm.mp3": [
		5004,
		7,
		3679
	],
	"./00003/00003-03/00003-03-06/here is a chicken.mp3": [
		5005,
		7,
		3680
	],
	"./00003/00003-03/00003-03-06/here is a cow.mp3": [
		5006,
		7,
		3681
	],
	"./00003/00003-03/00003-03-06/here is a donkey.mp3": [
		5007,
		7,
		3682
	],
	"./00003/00003-03/00003-03-06/here is a goat.mp3": [
		5008,
		7,
		3683
	],
	"./00003/00003-03/00003-03-06/here is a horse.mp3": [
		5009,
		7,
		3684
	],
	"./00003/00003-03/00003-03-06/here is a pig.mp3": [
		5010,
		7,
		3685
	],
	"./00003/00003-03/00003-03-06/here is a sheep.mp3": [
		5011,
		7,
		3686
	],
	"./00003/00003-03/00003-03-06/i am a farm animal.mp3": [
		5012,
		7,
		3687
	],
	"./00003/00003-03/00003-03-06/i live in a tree.mp3": [
		5013,
		7,
		3688
	],
	"./00003/00003-03/00003-03-06/i live on a farm said the goat.mp3": [
		5014,
		7,
		3689
	],
	"./00003/00003-03/00003-03-06/i live on a farm said the horse.mp3": [
		5015,
		7,
		3690
	],
	"./00003/00003-03/00003-03-06/i live on a farm said the sheep.mp3": [
		5016,
		7,
		3691
	],
	"./00003/00003-03/00003-03-06/i live on a farm too.mp3": [
		5017,
		7,
		3692
	],
	"./00003/00003-03/00003-03-06/intro.mp3": [
		627,
		7
	],
	"./00003/00003-03/00003-03-06/look at the cow.mp3": [
		5018,
		7,
		3693
	],
	"./00003/00003-03/00003-03-06/look at the donkey.mp3": [
		5019,
		7,
		3694
	],
	"./00003/00003-03/00003-03-06/look at the horse.mp3": [
		5020,
		7,
		3695
	],
	"./00003/00003-03/00003-03-06/main idea.mp3": [
		1008,
		7
	],
	"./00003/00003-03/00003-03-06/module": [
		1434,
		9,
		298
	],
	"./00003/00003-03/00003-03-06/module.js": [
		1434,
		9,
		298
	],
	"./00003/00003-03/00003-03-06/not me said the owl - copy.mp3": [
		5021,
		7,
		3696
	],
	"./00003/00003-03/00003-03-06/not me said the owl.mp3": [
		5022,
		7,
		3697
	],
	"./00003/00003-03/00003-03-06/she lives on a farm.mp3": [
		5023,
		7,
		3698
	],
	"./00003/00003-03/00003-03-06/yes said the chicken.mp3": [
		5024,
		7,
		3699
	],
	"./00003/00003-03/00003-03-06/yes said the cow.mp3": [
		5025,
		7,
		3700
	],
	"./00003/00003-03/00003-03-06/yes said the pig.mp3": [
		5026,
		7,
		3701
	],
	"./00003/00003-03/00003-03-07/0.jpg": [
		6985,
		7,
		5662
	],
	"./00003/00003-03/00003-03-07/1.jpg": [
		9379,
		7,
		9401
	],
	"./00003/00003-03/00003-03-07/2.jpg": [
		9380,
		7,
		9402
	],
	"./00003/00003-03/00003-03-07/3.jpg": [
		9381,
		7,
		9403
	],
	"./00003/00003-03/00003-03-07/4.jpg": [
		9382,
		7,
		9404
	],
	"./00003/00003-03/00003-03-07/5.jpg": [
		9383,
		7,
		9405
	],
	"./00003/00003-03/00003-03-07/6.jpg": [
		9384,
		7,
		9406
	],
	"./00003/00003-03/00003-03-07/7.jpg": [
		9385,
		7,
		9407
	],
	"./00003/00003-03/00003-03-07/animals that live in the snow.mp3": [
		5027,
		7,
		3702
	],
	"./00003/00003-03/00003-03-07/arctic animals.mp3": [
		5028,
		7,
		3703
	],
	"./00003/00003-03/00003-03-07/he can hide in the snow.mp3": [
		5029,
		7,
		3704
	],
	"./00003/00003-03/00003-03-07/he lives in the snow.mp3": [
		5030,
		7,
		3705
	],
	"./00003/00003-03/00003-03-07/intro.mp3": [
		628,
		7
	],
	"./00003/00003-03/00003-03-07/main idea.mp3": [
		1009,
		7
	],
	"./00003/00003-03/00003-03-07/module": [
		1435,
		9,
		299
	],
	"./00003/00003-03/00003-03-07/module.js": [
		1435,
		9,
		299
	],
	"./00003/00003-03/00003-03-07/she can hide from the fox.mp3": [
		5031,
		7,
		3706
	],
	"./00003/00003-03/00003-03-07/she can hide from the polar bear.mp3": [
		5032,
		7,
		3707
	],
	"./00003/00003-03/00003-03-07/she can hide in the snow.mp3": [
		5033,
		7,
		3708
	],
	"./00003/00003-03/00003-03-07/she lives in the snow.mp3": [
		5034,
		7,
		3709
	],
	"./00003/00003-03/00003-03-07/the arctic fox is white.mp3": [
		5035,
		7,
		3710
	],
	"./00003/00003-03/00003-03-07/the arctic wolf is white.mp3": [
		5036,
		7,
		3711
	],
	"./00003/00003-03/00003-03-07/the owl is white.mp3": [
		5037,
		7,
		3712
	],
	"./00003/00003-03/00003-03-07/the polar bear is white.mp3": [
		5038,
		7,
		3713
	],
	"./00003/00003-03/00003-03-07/the ptarmigan is white.mp3": [
		5039,
		7,
		3714
	],
	"./00003/00003-03/00003-03-07/the seal pup is white.mp3": [
		5040,
		7,
		3715
	],
	"./00003/00003-03/00003-03-07/the snowshoe rabbit is white.mp3": [
		5041,
		7,
		3716
	],
	"./00003/00003-03/00003-03-07/the snowy owl is white.mp3": [
		5042,
		7,
		3717
	],
	"./00003/00003-03/00003-03-07/the wolf is white.mp3": [
		5043,
		7,
		3718
	],
	"./00003/00003-03/00003-03-08/0.jpg": [
		6986,
		7,
		5663
	],
	"./00003/00003-03/00003-03-08/1.jpg": [
		9386,
		7,
		9408
	],
	"./00003/00003-03/00003-03-08/2.jpg": [
		9387,
		7,
		9409
	],
	"./00003/00003-03/00003-03-08/3.jpg": [
		9388,
		7,
		9410
	],
	"./00003/00003-03/00003-03-08/4.jpg": [
		9389,
		7,
		9411
	],
	"./00003/00003-03/00003-03-08/5.jpg": [
		9390,
		7,
		9412
	],
	"./00003/00003-03/00003-03-08/6.jpg": [
		9391,
		7,
		9413
	],
	"./00003/00003-03/00003-03-08/7.jpg": [
		9392,
		7,
		9414
	],
	"./00003/00003-03/00003-03-08/desert animals.mp3": [
		5044,
		7,
		3719
	],
	"./00003/00003-03/00003-03-08/i am a big horned sheep.mp3": [
		5045,
		7,
		3720
	],
	"./00003/00003-03/00003-03-08/i am a bighorn sheep.mp3": [
		5046,
		7,
		3721
	],
	"./00003/00003-03/00003-03-08/i am a camel.mp3": [
		5047,
		7,
		3722
	],
	"./00003/00003-03/00003-03-08/i am a fennec fox.mp3": [
		5048,
		7,
		3723
	],
	"./00003/00003-03/00003-03-08/i am a fox.mp3": [
		5049,
		7,
		3724
	],
	"./00003/00003-03/00003-03-08/i am a rabbit.mp3": [
		5050,
		7,
		3725
	],
	"./00003/00003-03/00003-03-08/i am a snake.mp3": [
		5051,
		7,
		3726
	],
	"./00003/00003-03/00003-03-08/i am a spider.mp3": [
		5052,
		7,
		3727
	],
	"./00003/00003-03/00003-03-08/i am an iguana.mp3": [
		5053,
		7,
		3728
	],
	"./00003/00003-03/00003-03-08/i live in the desert too.mp3": [
		5054,
		7,
		3729
	],
	"./00003/00003-03/00003-03-08/i live in the desert.mp3": [
		5055,
		7,
		3730
	],
	"./00003/00003-03/00003-03-08/intro.mp3": [
		629,
		7
	],
	"./00003/00003-03/00003-03-08/main idea.mp3": [
		1010,
		7
	],
	"./00003/00003-03/00003-03-08/module": [
		1436,
		9,
		300
	],
	"./00003/00003-03/00003-03-08/module.js": [
		1436,
		9,
		300
	],
	"./00003/00003-03/00003-03-08/my home is dry.mp3": [
		5056,
		7,
		3731
	],
	"./00003/00003-03/00003-03-08/my home is hot.mp3": [
		5057,
		7,
		3732
	],
	"./00003/00003-03/00003-03-09/0.jpg": [
		6987,
		7,
		5664
	],
	"./00003/00003-03/00003-03-09/1.jpg": [
		9393,
		7,
		9415
	],
	"./00003/00003-03/00003-03-09/2.jpg": [
		9394,
		7,
		9416
	],
	"./00003/00003-03/00003-03-09/3.jpg": [
		9395,
		7,
		9417
	],
	"./00003/00003-03/00003-03-09/4.jpg": [
		9396,
		7,
		9418
	],
	"./00003/00003-03/00003-03-09/5.jpg": [
		9397,
		7,
		9419
	],
	"./00003/00003-03/00003-03-09/6.jpg": [
		9398,
		7,
		9420
	],
	"./00003/00003-03/00003-03-09/7.jpg": [
		9399,
		7,
		9421
	],
	"./00003/00003-03/00003-03-09/i am a butterfly.mp3": [
		5058,
		7,
		3733
	],
	"./00003/00003-03/00003-03-09/i am a frog.mp3": [
		5059,
		7,
		3734
	],
	"./00003/00003-03/00003-03-09/i am a jaguar.mp3": [
		5060,
		7,
		3735
	],
	"./00003/00003-03/00003-03-09/i am a monkey.mp3": [
		5061,
		7,
		3736
	],
	"./00003/00003-03/00003-03-09/i am a parrot.mp3": [
		5062,
		7,
		3737
	],
	"./00003/00003-03/00003-03-09/i am a snake.mp3": [
		5063,
		7,
		3738
	],
	"./00003/00003-03/00003-03-09/i am a toucan.mp3": [
		5064,
		7,
		3739
	],
	"./00003/00003-03/00003-03-09/i live in the rainforest too.mp3": [
		5065,
		7,
		3740
	],
	"./00003/00003-03/00003-03-09/i live in the rainforest.mp3": [
		5066,
		7,
		3741
	],
	"./00003/00003-03/00003-03-09/intro.mp3": [
		630,
		7
	],
	"./00003/00003-03/00003-03-09/main idea.mp3": [
		1011,
		7
	],
	"./00003/00003-03/00003-03-09/module": [
		1437,
		9,
		301
	],
	"./00003/00003-03/00003-03-09/module.js": [
		1437,
		9,
		301
	],
	"./00003/00003-03/00003-03-09/my home is hot.mp3": [
		5067,
		7,
		3742
	],
	"./00003/00003-03/00003-03-09/my home is wet.mp3": [
		5068,
		7,
		3743
	],
	"./00003/00003-03/00003-03-09/rainforest animals.mp3": [
		5069,
		7,
		3744
	],
	"./00003/00003-03/00003-03-10/0.jpg": [
		6988,
		7,
		5665
	],
	"./00003/00003-03/00003-03-10/1.jpg": [
		9400,
		7,
		9422
	],
	"./00003/00003-03/00003-03-10/2.jpg": [
		9401,
		7,
		9423
	],
	"./00003/00003-03/00003-03-10/3.jpg": [
		9402,
		7,
		9424
	],
	"./00003/00003-03/00003-03-10/4.jpg": [
		9403,
		7,
		9425
	],
	"./00003/00003-03/00003-03-10/5.jpg": [
		9404,
		7,
		9426
	],
	"./00003/00003-03/00003-03-10/6.jpg": [
		9405,
		7,
		9427
	],
	"./00003/00003-03/00003-03-10/7.jpg": [
		9406,
		7,
		9428
	],
	"./00003/00003-03/00003-03-10/he is a wild animal.mp3": [
		5070,
		7,
		3745
	],
	"./00003/00003-03/00003-03-10/he lives in a tree.mp3": [
		5071,
		7,
		3746
	],
	"./00003/00003-03/00003-03-10/he lives on a farm.mp3": [
		5072,
		7,
		3747
	],
	"./00003/00003-03/00003-03-10/he lives with me.mp3": [
		5073,
		7,
		3748
	],
	"./00003/00003-03/00003-03-10/i am a dog.mp3": [
		5074,
		7,
		3749
	],
	"./00003/00003-03/00003-03-10/i am a lion.mp3": [
		5075,
		7,
		3750
	],
	"./00003/00003-03/00003-03-10/i am a parrot.mp3": [
		5076,
		7,
		3751
	],
	"./00003/00003-03/00003-03-10/i am a zebra.mp3": [
		5077,
		7,
		3752
	],
	"./00003/00003-03/00003-03-10/i am an owl.mp3": [
		5078,
		7,
		3753
	],
	"./00003/00003-03/00003-03-10/intro.mp3": [
		631,
		7
	],
	"./00003/00003-03/00003-03-10/is it tame.mp3": [
		5079,
		7,
		3754
	],
	"./00003/00003-03/00003-03-10/is it wild is it tame.mp3": [
		5080,
		7,
		3755
	],
	"./00003/00003-03/00003-03-10/is it wild.mp3": [
		5081,
		7,
		3756
	],
	"./00003/00003-03/00003-03-10/look at the bird.mp3": [
		5082,
		7,
		3757
	],
	"./00003/00003-03/00003-03-10/look at the parrot.mp3": [
		5083,
		7,
		3758
	],
	"./00003/00003-03/00003-03-10/main idea.mp3": [
		1012,
		7
	],
	"./00003/00003-03/00003-03-10/module": [
		1438,
		9,
		302
	],
	"./00003/00003-03/00003-03-10/module.js": [
		1438,
		9,
		302
	],
	"./00003/00003-03/00003-03-10/she is a wild animal.mp3": [
		5084,
		7,
		3759
	],
	"./00003/00003-03/00003-03-10/she lives in a cage.mp3": [
		5085,
		7,
		3760
	],
	"./00003/00003-03/00003-03-10/she lives in a house.mp3": [
		5086,
		7,
		3761
	],
	"./00003/00003-03/00003-03-10/this cat is a pet animal.mp3": [
		5087,
		7,
		3762
	],
	"./00003/00003-03/00003-03-10/this dog is my pet.mp3": [
		5088,
		7,
		3763
	],
	"./00003/00003-03/00003-03-10/this horse is a farm animal.mp3": [
		5089,
		7,
		3764
	],
	"./00003/00003-03/00003-03-10/this lion is not a pet.mp3": [
		5090,
		7,
		3765
	],
	"./00003/00003-03/00003-03-10/this owl is a wild bird.mp3": [
		5091,
		7,
		3766
	],
	"./00003/00003-03/00003-03-10/this parrot is a pet bird.mp3": [
		5092,
		7,
		3767
	],
	"./00003/00003-03/00003-03-10/this zebra is not a farm animal.mp3": [
		5093,
		7,
		3768
	],
	"./00003/00003-03/00003-03-10/wild animals.mp3": [
		5094,
		7,
		3769
	],
	"./00003/00003-03/00003-03-10/wild or tame.mp3": [
		5095,
		7,
		3770
	],
	"./00003/00003-03/animal land.mp3": [
		5096,
		7,
		3771
	],
	"./00003/00003-03/animals.mp3": [
		5097,
		7,
		3772
	],
	"./00003/00003-03/cover.jpg": [
		6989,
		7,
		5666
	],
	"./00003/00003-03/unit": [
		1439,
		9,
		303
	],
	"./00003/00003-03/unit.js": [
		1439,
		9,
		303
	],
	"./00003/00003-04/00003-04-01/0.jpg": [
		6990,
		7,
		5667
	],
	"./00003/00003-04/00003-04-01/1.jpg": [
		9407,
		7,
		9429
	],
	"./00003/00003-04/00003-04-01/2.jpg": [
		9408,
		7,
		9430
	],
	"./00003/00003-04/00003-04-01/3.jpg": [
		9409,
		7,
		9431
	],
	"./00003/00003-04/00003-04-01/4.jpg": [
		9410,
		7,
		9432
	],
	"./00003/00003-04/00003-04-01/5.jpg": [
		9411,
		7,
		9433
	],
	"./00003/00003-04/00003-04-01/6.jpg": [
		9412,
		7,
		9434
	],
	"./00003/00003-04/00003-04-01/7.jpg": [
		9413,
		7,
		9435
	],
	"./00003/00003-04/00003-04-01/animals.mp3": [
		5098,
		7,
		3773
	],
	"./00003/00003-04/00003-04-01/i can see one box.mp3": [
		5099,
		7,
		3774
	],
	"./00003/00003-04/00003-04-01/i can see one car.mp3": [
		5100,
		7,
		3775
	],
	"./00003/00003-04/00003-04-01/i can see one cat.mp3": [
		5101,
		7,
		3776
	],
	"./00003/00003-04/00003-04-01/i can see one clock.mp3": [
		5102,
		7,
		3777
	],
	"./00003/00003-04/00003-04-01/i can see one dog.mp3": [
		5103,
		7,
		3778
	],
	"./00003/00003-04/00003-04-01/i can see one duck.mp3": [
		5104,
		7,
		3779
	],
	"./00003/00003-04/00003-04-01/i can see one fox.mp3": [
		5105,
		7,
		3780
	],
	"./00003/00003-04/00003-04-01/i can see one frog.mp3": [
		5106,
		7,
		3781
	],
	"./00003/00003-04/00003-04-01/i can see one hat.mp3": [
		5107,
		7,
		3782
	],
	"./00003/00003-04/00003-04-01/i can see one house.mp3": [
		5108,
		7,
		3783
	],
	"./00003/00003-04/00003-04-01/i can see one mouse.mp3": [
		5109,
		7,
		3784
	],
	"./00003/00003-04/00003-04-01/i can see one sock.mp3": [
		5110,
		7,
		3785
	],
	"./00003/00003-04/00003-04-01/i can see one star.mp3": [
		5111,
		7,
		3786
	],
	"./00003/00003-04/00003-04-01/i can see one truck.mp3": [
		5112,
		7,
		3787
	],
	"./00003/00003-04/00003-04-01/intro.mp3": [
		632,
		7
	],
	"./00003/00003-04/00003-04-01/main idea.mp3": [
		1013,
		7
	],
	"./00003/00003-04/00003-04-01/module": [
		1440,
		9,
		304
	],
	"./00003/00003-04/00003-04-01/module.js": [
		1440,
		9,
		304
	],
	"./00003/00003-04/00003-04-01/my book of one.mp3": [
		5113,
		7,
		3788
	],
	"./00003/00003-04/00003-04-01/the clock is on the sock.mp3": [
		5114,
		7,
		3789
	],
	"./00003/00003-04/00003-04-01/the duck is on the truck.mp3": [
		5115,
		7,
		3790
	],
	"./00003/00003-04/00003-04-01/the fox is in the box.mp3": [
		5116,
		7,
		3791
	],
	"./00003/00003-04/00003-04-01/the frog is on the dog.mp3": [
		5117,
		7,
		3792
	],
	"./00003/00003-04/00003-04-01/the hat is on the cat.mp3": [
		5118,
		7,
		3793
	],
	"./00003/00003-04/00003-04-01/the mouse is in the house.mp3": [
		5119,
		7,
		3794
	],
	"./00003/00003-04/00003-04-01/the star is on the car.mp3": [
		5120,
		7,
		3795
	],
	"./00003/00003-04/00003-04-02/0.jpg": [
		6991,
		7,
		5668
	],
	"./00003/00003-04/00003-04-02/1.jpg": [
		9414,
		7,
		9436
	],
	"./00003/00003-04/00003-04-02/2.jpg": [
		9415,
		7,
		9437
	],
	"./00003/00003-04/00003-04-02/3.jpg": [
		9416,
		7,
		9438
	],
	"./00003/00003-04/00003-04-02/4.jpg": [
		9417,
		7,
		9439
	],
	"./00003/00003-04/00003-04-02/5.jpg": [
		9418,
		7,
		9440
	],
	"./00003/00003-04/00003-04-02/6.jpg": [
		9419,
		7,
		9441
	],
	"./00003/00003-04/00003-04-02/7.jpg": [
		9420,
		7,
		9442
	],
	"./00003/00003-04/00003-04-02/i have two big ears said the monster.mp3": [
		5121,
		7,
		3796
	],
	"./00003/00003-04/00003-04-02/i have two big ears.mp3": [
		5122,
		7,
		3797
	],
	"./00003/00003-04/00003-04-02/i have two eyes said the monster.mp3": [
		5123,
		7,
		3798
	],
	"./00003/00003-04/00003-04-02/i have two eyes.mp3": [
		5124,
		7,
		3799
	],
	"./00003/00003-04/00003-04-02/i have two heads said the monster.mp3": [
		5125,
		7,
		3800
	],
	"./00003/00003-04/00003-04-02/i have two wings said the eagle.mp3": [
		5126,
		7,
		3801
	],
	"./00003/00003-04/00003-04-02/i have two wings said the monster.mp3": [
		5127,
		7,
		3802
	],
	"./00003/00003-04/00003-04-02/intro.mp3": [
		633,
		7
	],
	"./00003/00003-04/00003-04-02/look at my ears said the fox.mp3": [
		5128,
		7,
		3803
	],
	"./00003/00003-04/00003-04-02/look at my ears.mp3": [
		5129,
		7,
		3804
	],
	"./00003/00003-04/00003-04-02/look at my eyes said the hammerhead shark.mp3": [
		5130,
		7,
		3805
	],
	"./00003/00003-04/00003-04-02/look at my eyes.mp3": [
		5131,
		7,
		3806
	],
	"./00003/00003-04/00003-04-02/look at my heads.mp3": [
		5132,
		7,
		3807
	],
	"./00003/00003-04/00003-04-02/look at my wings.mp3": [
		5133,
		7,
		3808
	],
	"./00003/00003-04/00003-04-02/main idea.mp3": [
		1014,
		7
	],
	"./00003/00003-04/00003-04-02/module": [
		1441,
		9,
		305
	],
	"./00003/00003-04/00003-04-02/module.js": [
		1441,
		9,
		305
	],
	"./00003/00003-04/00003-04-02/parts of the body.mp3": [
		5134,
		7,
		3809
	],
	"./00003/00003-04/00003-04-02/what comes in 2s.mp3": [
		5135,
		7,
		3810
	],
	"./00003/00003-04/00003-04-03/0.jpg": [
		6992,
		7,
		5669
	],
	"./00003/00003-04/00003-04-03/1.jpg": [
		9421,
		7,
		9443
	],
	"./00003/00003-04/00003-04-03/2.jpg": [
		9422,
		7,
		9444
	],
	"./00003/00003-04/00003-04-03/3.jpg": [
		9423,
		7,
		9445
	],
	"./00003/00003-04/00003-04-03/4.jpg": [
		9424,
		7,
		9446
	],
	"./00003/00003-04/00003-04-03/5.jpg": [
		9425,
		7,
		9447
	],
	"./00003/00003-04/00003-04-03/6.jpg": [
		9426,
		7,
		9448
	],
	"./00003/00003-04/00003-04-03/7.jpg": [
		9427,
		7,
		9449
	],
	"./00003/00003-04/00003-04-03/animals with four legs.mp3": [
		5136,
		7,
		3811
	],
	"./00003/00003-04/00003-04-03/can you see 3 boats.mp3": [
		5137,
		7,
		3812
	],
	"./00003/00003-04/00003-04-03/can you see 3 boxes.mp3": [
		5138,
		7,
		3813
	],
	"./00003/00003-04/00003-04-03/can you see 3 cakes.mp3": [
		5139,
		7,
		3814
	],
	"./00003/00003-04/00003-04-03/can you see 3 dogs.mp3": [
		5140,
		7,
		3815
	],
	"./00003/00003-04/00003-04-03/can you see 3 foxes.mp3": [
		5141,
		7,
		3816
	],
	"./00003/00003-04/00003-04-03/can you see 3 frogs.mp3": [
		5142,
		7,
		3817
	],
	"./00003/00003-04/00003-04-03/can you see 3 goats.mp3": [
		5143,
		7,
		3818
	],
	"./00003/00003-04/00003-04-03/can you see 3 hats.mp3": [
		5144,
		7,
		3819
	],
	"./00003/00003-04/00003-04-03/can you see 3 kittens.mp3": [
		5145,
		7,
		3820
	],
	"./00003/00003-04/00003-04-03/can you see 3 mittens.mp3": [
		5146,
		7,
		3821
	],
	"./00003/00003-04/00003-04-03/can you see 3 rats.mp3": [
		5147,
		7,
		3822
	],
	"./00003/00003-04/00003-04-03/can you see 3 snails.mp3": [
		5148,
		7,
		3823
	],
	"./00003/00003-04/00003-04-03/can you see 3 snakes.mp3": [
		5149,
		7,
		3824
	],
	"./00003/00003-04/00003-04-03/can you see 3 whales.mp3": [
		5150,
		7,
		3825
	],
	"./00003/00003-04/00003-04-03/intro.mp3": [
		634,
		7
	],
	"./00003/00003-04/00003-04-03/main idea.mp3": [
		1015,
		7
	],
	"./00003/00003-04/00003-04-03/module": [
		1442,
		9,
		306
	],
	"./00003/00003-04/00003-04-03/module.js": [
		1442,
		9,
		306
	],
	"./00003/00003-04/00003-04-03/my book of three.mp3": [
		5151,
		7,
		3826
	],
	"./00003/00003-04/00003-04-03/the foxes are in the boxes.mp3": [
		5152,
		7,
		3827
	],
	"./00003/00003-04/00003-04-03/the frogs are on the dogs.mp3": [
		5153,
		7,
		3828
	],
	"./00003/00003-04/00003-04-03/the goats are in the boats.mp3": [
		5154,
		7,
		3829
	],
	"./00003/00003-04/00003-04-03/the hats are on the rats.mp3": [
		5155,
		7,
		3830
	],
	"./00003/00003-04/00003-04-03/the mittens are on the kittens.mp3": [
		5156,
		7,
		3831
	],
	"./00003/00003-04/00003-04-03/the snails are on the whales.mp3": [
		5157,
		7,
		3832
	],
	"./00003/00003-04/00003-04-03/the snakes are on the cakes.mp3": [
		5158,
		7,
		3833
	],
	"./00003/00003-04/00003-04-04/0.jpg": [
		6993,
		7,
		5670
	],
	"./00003/00003-04/00003-04-04/1.jpg": [
		9428,
		7,
		9450
	],
	"./00003/00003-04/00003-04-04/2.jpg": [
		9429,
		7,
		9451
	],
	"./00003/00003-04/00003-04-04/3.jpg": [
		9430,
		7,
		9452
	],
	"./00003/00003-04/00003-04-04/4.jpg": [
		9431,
		7,
		9453
	],
	"./00003/00003-04/00003-04-04/5.jpg": [
		9432,
		7,
		9454
	],
	"./00003/00003-04/00003-04-04/6.jpg": [
		9433,
		7,
		9455
	],
	"./00003/00003-04/00003-04-04/7.jpg": [
		9434,
		7,
		9456
	],
	"./00003/00003-04/00003-04-04/here come three cars.mp3": [
		5159,
		7,
		3834
	],
	"./00003/00003-04/00003-04-04/here come three rockets.mp3": [
		5160,
		7,
		3835
	],
	"./00003/00003-04/00003-04-04/here come two boats.mp3": [
		5161,
		7,
		3836
	],
	"./00003/00003-04/00003-04-04/here come two cars.mp3": [
		5162,
		7,
		3837
	],
	"./00003/00003-04/00003-04-04/here come two helicopters.mp3": [
		5163,
		7,
		3838
	],
	"./00003/00003-04/00003-04-04/here come two planes.mp3": [
		5164,
		7,
		3839
	],
	"./00003/00003-04/00003-04-04/here come two trucks.mp3": [
		5165,
		7,
		3840
	],
	"./00003/00003-04/00003-04-04/here comes one fire truck.mp3": [
		5166,
		7,
		3841
	],
	"./00003/00003-04/00003-04-04/here comes one spaceship.mp3": [
		5167,
		7,
		3842
	],
	"./00003/00003-04/00003-04-04/intro.mp3": [
		635,
		7
	],
	"./00003/00003-04/00003-04-04/main idea.mp3": [
		1016,
		7
	],
	"./00003/00003-04/00003-04-04/module": [
		1443,
		9,
		307
	],
	"./00003/00003-04/00003-04-04/module.js": [
		1443,
		9,
		307
	],
	"./00003/00003-04/00003-04-04/my book of four.mp3": [
		5168,
		7,
		3843
	],
	"./00003/00003-04/00003-04-04/one and three is four.mp3": [
		5169,
		7,
		3844
	],
	"./00003/00003-04/00003-04-04/three and one is four.mp3": [
		5170,
		7,
		3845
	],
	"./00003/00003-04/00003-04-04/two and two is four.mp3": [
		5171,
		7,
		3846
	],
	"./00003/00003-04/00003-04-04/vehicles.mp3": [
		5172,
		7,
		3847
	],
	"./00003/00003-04/00003-04-05/0.jpg": [
		6994,
		7,
		5671
	],
	"./00003/00003-04/00003-04-05/1.jpg": [
		9435,
		7,
		9457
	],
	"./00003/00003-04/00003-04-05/2.jpg": [
		9436,
		7,
		9458
	],
	"./00003/00003-04/00003-04-05/3.jpg": [
		9437,
		7,
		9459
	],
	"./00003/00003-04/00003-04-05/4.jpg": [
		9438,
		7,
		9460
	],
	"./00003/00003-04/00003-04-05/5.jpg": [
		9439,
		7,
		9461
	],
	"./00003/00003-04/00003-04-05/6.jpg": [
		9440,
		7,
		9462
	],
	"./00003/00003-04/00003-04-05/7.jpg": [
		9441,
		7,
		9463
	],
	"./00003/00003-04/00003-04-05/farm animals.mp3": [
		5173,
		7,
		3848
	],
	"./00003/00003-04/00003-04-05/four and one is five.mp3": [
		5174,
		7,
		3849
	],
	"./00003/00003-04/00003-04-05/i can see five farm animals.mp3": [
		5175,
		7,
		3850
	],
	"./00003/00003-04/00003-04-05/i can see four chicks.mp3": [
		5176,
		7,
		3851
	],
	"./00003/00003-04/00003-04-05/i can see four cows.mp3": [
		5177,
		7,
		3852
	],
	"./00003/00003-04/00003-04-05/i can see four ducklings.mp3": [
		5178,
		7,
		3853
	],
	"./00003/00003-04/00003-04-05/i can see one chicken.mp3": [
		5179,
		7,
		3854
	],
	"./00003/00003-04/00003-04-05/i can see one duck.mp3": [
		5180,
		7,
		3855
	],
	"./00003/00003-04/00003-04-05/i can see three goats.mp3": [
		5181,
		7,
		3856
	],
	"./00003/00003-04/00003-04-05/i can see three sheep.mp3": [
		5182,
		7,
		3857
	],
	"./00003/00003-04/00003-04-05/i can see two dogs.mp3": [
		5183,
		7,
		3858
	],
	"./00003/00003-04/00003-04-05/i can see two horses.mp3": [
		5184,
		7,
		3859
	],
	"./00003/00003-04/00003-04-05/intro.mp3": [
		636,
		7
	],
	"./00003/00003-04/00003-04-05/main idea.mp3": [
		1017,
		7
	],
	"./00003/00003-04/00003-04-05/module": [
		1444,
		9,
		308
	],
	"./00003/00003-04/00003-04-05/module.js": [
		1444,
		9,
		308
	],
	"./00003/00003-04/00003-04-05/my book of five.mp3": [
		5185,
		7,
		3860
	],
	"./00003/00003-04/00003-04-05/one and four is five.mp3": [
		5186,
		7,
		3861
	],
	"./00003/00003-04/00003-04-05/three and two is fiv.mp3": [
		5187,
		7,
		3862
	],
	"./00003/00003-04/00003-04-05/three and two is five.mp3": [
		5188,
		7,
		3863
	],
	"./00003/00003-04/00003-04-05/two and three is five.mp3": [
		5189,
		7,
		3864
	],
	"./00003/00003-04/00003-04-06/0.jpg": [
		6995,
		7,
		5672
	],
	"./00003/00003-04/00003-04-06/1.jpg": [
		9442,
		7,
		9464
	],
	"./00003/00003-04/00003-04-06/2.jpg": [
		9443,
		7,
		9465
	],
	"./00003/00003-04/00003-04-06/3.jpg": [
		9444,
		7,
		9466
	],
	"./00003/00003-04/00003-04-06/4.jpg": [
		9445,
		7,
		9467
	],
	"./00003/00003-04/00003-04-06/5.jpg": [
		9446,
		7,
		9468
	],
	"./00003/00003-04/00003-04-06/6.jpg": [
		9447,
		7,
		9469
	],
	"./00003/00003-04/00003-04-06/7.jpg": [
		9448,
		7,
		9470
	],
	"./00003/00003-04/00003-04-06/can you see five dogs.mp3": [
		5190,
		7,
		3865
	],
	"./00003/00003-04/00003-04-06/can you see five fish.mp3": [
		5191,
		7,
		3866
	],
	"./00003/00003-04/00003-04-06/can you see four birds.mp3": [
		5192,
		7,
		3867
	],
	"./00003/00003-04/00003-04-06/can you see four brids.mp3": [
		5193,
		7,
		3868
	],
	"./00003/00003-04/00003-04-06/can you see four fish.mp3": [
		5194,
		7,
		3869
	],
	"./00003/00003-04/00003-04-06/can you see one cat.mp3": [
		5195,
		7,
		3870
	],
	"./00003/00003-04/00003-04-06/can you see three cats.mp3": [
		5196,
		7,
		3871
	],
	"./00003/00003-04/00003-04-06/can you see three rabbits.mp3": [
		5197,
		7,
		3872
	],
	"./00003/00003-04/00003-04-06/can you see two snakes.mp3": [
		5198,
		7,
		3873
	],
	"./00003/00003-04/00003-04-06/can you see two turtles.mp3": [
		5199,
		7,
		3874
	],
	"./00003/00003-04/00003-04-06/five and one is six.mp3": [
		5200,
		7,
		3875
	],
	"./00003/00003-04/00003-04-06/four and two is six.mp3": [
		5201,
		7,
		3876
	],
	"./00003/00003-04/00003-04-06/intro.mp3": [
		637,
		7
	],
	"./00003/00003-04/00003-04-06/main idea.mp3": [
		1018,
		7
	],
	"./00003/00003-04/00003-04-06/module": [
		1445,
		9,
		309
	],
	"./00003/00003-04/00003-04-06/module.js": [
		1445,
		9,
		309
	],
	"./00003/00003-04/00003-04-06/my book of six.mp3": [
		5202,
		7,
		3877
	],
	"./00003/00003-04/00003-04-06/one and five is six.mp3": [
		5203,
		7,
		3878
	],
	"./00003/00003-04/00003-04-06/pet animals.mp3": [
		5204,
		7,
		3879
	],
	"./00003/00003-04/00003-04-06/three and three is six.mp3": [
		5205,
		7,
		3880
	],
	"./00003/00003-04/00003-04-06/two and four is six.mp3": [
		5206,
		7,
		3881
	],
	"./00003/00003-04/00003-04-07/0.jpg": [
		6996,
		7,
		5673
	],
	"./00003/00003-04/00003-04-07/1.jpg": [
		9449,
		7,
		9471
	],
	"./00003/00003-04/00003-04-07/2.jpg": [
		9450,
		7,
		9472
	],
	"./00003/00003-04/00003-04-07/3.jpg": [
		9451,
		7,
		9473
	],
	"./00003/00003-04/00003-04-07/4.jpg": [
		9452,
		7,
		9474
	],
	"./00003/00003-04/00003-04-07/5.jpg": [
		9453,
		7,
		9475
	],
	"./00003/00003-04/00003-04-07/6.jpg": [
		9454,
		7,
		9476
	],
	"./00003/00003-04/00003-04-07/7.jpg": [
		9455,
		7,
		9477
	],
	"./00003/00003-04/00003-04-07/can you see five little fish.mp3": [
		5207,
		7,
		3882
	],
	"./00003/00003-04/00003-04-07/can you see four little penguins.mp3": [
		5208,
		7,
		3883
	],
	"./00003/00003-04/00003-04-07/can you see four little starfish.mp3": [
		5209,
		7,
		3884
	],
	"./00003/00003-04/00003-04-07/can you see one little seahorse.mp3": [
		5210,
		7,
		3885
	],
	"./00003/00003-04/00003-04-07/can you see three little crabs.mp3": [
		5211,
		7,
		3886
	],
	"./00003/00003-04/00003-04-07/intro.mp3": [
		638,
		7
	],
	"./00003/00003-04/00003-04-07/main idea.mp3": [
		1019,
		7
	],
	"./00003/00003-04/00003-04-07/module": [
		1446,
		9,
		310
	],
	"./00003/00003-04/00003-04-07/module.js": [
		1446,
		9,
		310
	],
	"./00003/00003-04/00003-04-07/my book of seven.mp3": [
		5212,
		7,
		3887
	],
	"./00003/00003-04/00003-04-07/sea animals.mp3": [
		5213,
		7,
		3888
	],
	"./00003/00003-04/00003-04-07/you can count seven animals in the sea.mp3": [
		5214,
		7,
		3889
	],
	"./00003/00003-04/00003-04-07/you can count to seven.mp3": [
		5215,
		7,
		3890
	],
	"./00003/00003-04/00003-04-07/you can see five sea turtles.mp3": [
		5216,
		7,
		3891
	],
	"./00003/00003-04/00003-04-07/you can see six big seahorses.mp3": [
		5217,
		7,
		3892
	],
	"./00003/00003-04/00003-04-07/you can see three big penguins.mp3": [
		5218,
		7,
		3893
	],
	"./00003/00003-04/00003-04-07/you can see two big sharks.mp3": [
		5219,
		7,
		3894
	],
	"./00003/00003-04/00003-04-07/you can see two whales.mp3": [
		5220,
		7,
		3895
	],
	"./00003/00003-04/00003-04-08/0.jpg": [
		6997,
		7,
		5674
	],
	"./00003/00003-04/00003-04-08/1.jpg": [
		9456,
		7,
		9478
	],
	"./00003/00003-04/00003-04-08/2.jpg": [
		9457,
		7,
		9479
	],
	"./00003/00003-04/00003-04-08/3.jpg": [
		9458,
		7,
		9480
	],
	"./00003/00003-04/00003-04-08/4.jpg": [
		9459,
		7,
		9481
	],
	"./00003/00003-04/00003-04-08/5.jpg": [
		9460,
		7,
		9482
	],
	"./00003/00003-04/00003-04-08/6.jpg": [
		9461,
		7,
		9483
	],
	"./00003/00003-04/00003-04-08/7.jpg": [
		9462,
		7,
		9484
	],
	"./00003/00003-04/00003-04-08/can you count eight things up in space.mp3": [
		5221,
		7,
		3896
	],
	"./00003/00003-04/00003-04-08/can you count five little planets.mp3": [
		5222,
		7,
		3897
	],
	"./00003/00003-04/00003-04-08/can you count four astronauts.mp3": [
		5223,
		7,
		3898
	],
	"./00003/00003-04/00003-04-08/can you count four rockets.mp3": [
		5224,
		7,
		3899
	],
	"./00003/00003-04/00003-04-08/can you count four spaceships.mp3": [
		5225,
		7,
		3900
	],
	"./00003/00003-04/00003-04-08/can you count to eight.mp3": [
		5226,
		7,
		3901
	],
	"./00003/00003-04/00003-04-08/can you see six little stars.mp3": [
		5227,
		7,
		3902
	],
	"./00003/00003-04/00003-04-08/can you see two big stars.mp3": [
		5228,
		7,
		3903
	],
	"./00003/00003-04/00003-04-08/intro.mp3": [
		639,
		7
	],
	"./00003/00003-04/00003-04-08/main idea.mp3": [
		1020,
		7
	],
	"./00003/00003-04/00003-04-08/module": [
		1447,
		9,
		311
	],
	"./00003/00003-04/00003-04-08/module.js": [
		1447,
		9,
		311
	],
	"./00003/00003-04/00003-04-08/my book of eight.mp3": [
		5229,
		7,
		3904
	],
	"./00003/00003-04/00003-04-08/things in space.mp3": [
		5230,
		7,
		3905
	],
	"./00003/00003-04/00003-04-08/you can count seven satellites.mp3": [
		5231,
		7,
		3906
	],
	"./00003/00003-04/00003-04-08/you can see one planet.mp3": [
		5232,
		7,
		3907
	],
	"./00003/00003-04/00003-04-08/you can see three big planets.mp3": [
		5233,
		7,
		3908
	],
	"./00003/00003-04/00003-04-09/0.jpg": [
		6998,
		7,
		5675
	],
	"./00003/00003-04/00003-04-09/1.jpg": [
		9463,
		7,
		9485
	],
	"./00003/00003-04/00003-04-09/2.jpg": [
		9464,
		7,
		9486
	],
	"./00003/00003-04/00003-04-09/3.jpg": [
		9465,
		7,
		9487
	],
	"./00003/00003-04/00003-04-09/4.jpg": [
		9466,
		7,
		9488
	],
	"./00003/00003-04/00003-04-09/5.jpg": [
		9467,
		7,
		9489
	],
	"./00003/00003-04/00003-04-09/6.jpg": [
		9468,
		7,
		9490
	],
	"./00003/00003-04/00003-04-09/7.jpg": [
		9469,
		7,
		9491
	],
	"./00003/00003-04/00003-04-09/eight and one makes nine.mp3": [
		5234,
		7,
		3909
	],
	"./00003/00003-04/00003-04-09/five and four makes nine.mp3": [
		5235,
		7,
		3910
	],
	"./00003/00003-04/00003-04-09/four and five makes nine.mp3": [
		5236,
		7,
		3911
	],
	"./00003/00003-04/00003-04-09/i see elephants and zebras.mp3": [
		5237,
		7,
		3912
	],
	"./00003/00003-04/00003-04-09/i see hippos and rhinos.mp3": [
		5238,
		7,
		3913
	],
	"./00003/00003-04/00003-04-09/i see hippos rhinos and alligators.mp3": [
		5239,
		7,
		3914
	],
	"./00003/00003-04/00003-04-09/i see nine animals in all.mp3": [
		5240,
		7,
		3915
	],
	"./00003/00003-04/00003-04-09/i see nine baby animals.mp3": [
		5241,
		7,
		3916
	],
	"./00003/00003-04/00003-04-09/i see tigers and lions.mp3": [
		5242,
		7,
		3917
	],
	"./00003/00003-04/00003-04-09/intro.mp3": [
		640,
		7
	],
	"./00003/00003-04/00003-04-09/lets count the animals.mp3": [
		5243,
		7,
		3918
	],
	"./00003/00003-04/00003-04-09/main idea.mp3": [
		1021,
		7
	],
	"./00003/00003-04/00003-04-09/module": [
		1448,
		9,
		312
	],
	"./00003/00003-04/00003-04-09/module.js": [
		1448,
		9,
		312
	],
	"./00003/00003-04/00003-04-09/my book of nine.mp3": [
		5244,
		7,
		3919
	],
	"./00003/00003-04/00003-04-09/seven and two makes nine.mp3": [
		5245,
		7,
		3920
	],
	"./00003/00003-04/00003-04-09/six and three makes nine.mp3": [
		5246,
		7,
		3921
	],
	"./00003/00003-04/00003-04-09/three and three and three makes nine.mp3": [
		5247,
		7,
		3922
	],
	"./00003/00003-04/00003-04-09/wild animals.mp3": [
		5248,
		7,
		3923
	],
	"./00003/00003-04/00003-04-10/0.jpg": [
		6999,
		7,
		5676
	],
	"./00003/00003-04/00003-04-10/1.jpg": [
		9470,
		7,
		9492
	],
	"./00003/00003-04/00003-04-10/2.jpg": [
		9471,
		7,
		9493
	],
	"./00003/00003-04/00003-04-10/3.jpg": [
		9472,
		7,
		9494
	],
	"./00003/00003-04/00003-04-10/4.jpg": [
		9473,
		7,
		9495
	],
	"./00003/00003-04/00003-04-10/5.jpg": [
		9474,
		7,
		9496
	],
	"./00003/00003-04/00003-04-10/6.jpg": [
		9475,
		7,
		9497
	],
	"./00003/00003-04/00003-04-10/7.jpg": [
		9476,
		7,
		9498
	],
	"./00003/00003-04/00003-04-10/brown animals.mp3": [
		5249,
		7,
		3924
	],
	"./00003/00003-04/00003-04-10/can you see five green dragons.mp3": [
		5250,
		7,
		3925
	],
	"./00003/00003-04/00003-04-10/can you see five green turtles.mp3": [
		5251,
		7,
		3926
	],
	"./00003/00003-04/00003-04-10/can you see six yellow giraffes.mp3": [
		5252,
		7,
		3927
	],
	"./00003/00003-04/00003-04-10/can you see three brown deer.mp3": [
		5253,
		7,
		3928
	],
	"./00003/00003-04/00003-04-10/eight and two equals ten.mp3": [
		5254,
		7,
		3929
	],
	"./00003/00003-04/00003-04-10/five and five equals ten.mp3": [
		5255,
		7,
		3930
	],
	"./00003/00003-04/00003-04-10/four and six equals ten.mp3": [
		5256,
		7,
		3931
	],
	"./00003/00003-04/00003-04-10/intro.mp3": [
		641,
		7
	],
	"./00003/00003-04/00003-04-10/main idea.mp3": [
		1022,
		7
	],
	"./00003/00003-04/00003-04-10/module": [
		1449,
		9,
		313
	],
	"./00003/00003-04/00003-04-10/module.js": [
		1449,
		9,
		313
	],
	"./00003/00003-04/00003-04-10/my book of ten.mp3": [
		5257,
		7,
		3932
	],
	"./00003/00003-04/00003-04-10/one and nine equals ten.mp3": [
		5258,
		7,
		3933
	],
	"./00003/00003-04/00003-04-10/seven and three equals ten.mp3": [
		5259,
		7,
		3934
	],
	"./00003/00003-04/00003-04-10/ten and zero equals ten.mp3": [
		5260,
		7,
		3935
	],
	"./00003/00003-04/00003-04-10/you can see eight gray hippos.mp3": [
		5261,
		7,
		3936
	],
	"./00003/00003-04/00003-04-10/you can see five green alligators.mp3": [
		5262,
		7,
		3937
	],
	"./00003/00003-04/00003-04-10/you can see four yellow chicks.mp3": [
		5263,
		7,
		3938
	],
	"./00003/00003-04/00003-04-10/you can see nine white unicorns.mp3": [
		5264,
		7,
		3939
	],
	"./00003/00003-04/00003-04-10/you can see one white sheep.mp3": [
		5265,
		7,
		3940
	],
	"./00003/00003-04/00003-04-10/you can see seven brown monkeys.mp3": [
		5266,
		7,
		3941
	],
	"./00003/00003-04/00003-04-10/you can see ten pink dinosaurs.mp3": [
		5267,
		7,
		3942
	],
	"./00003/00003-04/00003-04-10/you can see two gray elephants.mp3": [
		5268,
		7,
		3943
	],
	"./00003/00003-04/00003-04-10/you can see zero pink cats.mp3": [
		5269,
		7,
		3944
	],
	"./00003/00003-04/cover.jpg": [
		7000,
		7,
		5677
	],
	"./00003/00003-04/number land.mp3": [
		5270,
		7,
		3945
	],
	"./00003/00003-04/numbers.mp3": [
		5271,
		7,
		3946
	],
	"./00003/00003-04/unit": [
		1450,
		9,
		314
	],
	"./00003/00003-04/unit.js": [
		1450,
		9,
		314
	],
	"./00003/00003-05/00003-05-01/0.jpg": [
		7001,
		7,
		5678
	],
	"./00003/00003-05/00003-05-01/1.jpg": [
		9477,
		7,
		9499
	],
	"./00003/00003-05/00003-05-01/2.jpg": [
		9478,
		7,
		9500
	],
	"./00003/00003-05/00003-05-01/3.jpg": [
		9479,
		7,
		9501
	],
	"./00003/00003-05/00003-05-01/4.jpg": [
		9480,
		7,
		9502
	],
	"./00003/00003-05/00003-05-01/5.jpg": [
		9481,
		7,
		9503
	],
	"./00003/00003-05/00003-05-01/6.jpg": [
		9482,
		7,
		9504
	],
	"./00003/00003-05/00003-05-01/7.jpg": [
		9483,
		7,
		9505
	],
	"./00003/00003-05/00003-05-01/all circles are round.mp3": [
		5272,
		7,
		3947
	],
	"./00003/00003-05/00003-05-01/circles are round.mp3": [
		5273,
		7,
		3948
	],
	"./00003/00003-05/00003-05-01/i can see big circles.mp3": [
		5274,
		7,
		3949
	],
	"./00003/00003-05/00003-05-01/i can see little circles.mp3": [
		5275,
		7,
		3950
	],
	"./00003/00003-05/00003-05-01/intro.mp3": [
		642,
		7
	],
	"./00003/00003-05/00003-05-01/main idea.mp3": [
		1023,
		7
	],
	"./00003/00003-05/00003-05-01/module": [
		1451,
		9,
		315
	],
	"./00003/00003-05/00003-05-01/module.js": [
		1451,
		9,
		315
	],
	"./00003/00003-05/00003-05-01/some circles are black.mp3": [
		5276,
		7,
		3951
	],
	"./00003/00003-05/00003-05-01/some circles are blue.mp3": [
		5277,
		7,
		3952
	],
	"./00003/00003-05/00003-05-01/some circles are green.mp3": [
		5278,
		7,
		3953
	],
	"./00003/00003-05/00003-05-01/some circles are orange.mp3": [
		5279,
		7,
		3954
	],
	"./00003/00003-05/00003-05-01/some circles are purple.mp3": [
		5280,
		7,
		3955
	],
	"./00003/00003-05/00003-05-01/some circles are red.mp3": [
		5281,
		7,
		3956
	],
	"./00003/00003-05/00003-05-01/some circles are white.mp3": [
		5282,
		7,
		3957
	],
	"./00003/00003-05/00003-05-01/some circles are yellow.mp3": [
		5283,
		7,
		3958
	],
	"./00003/00003-05/00003-05-01/things that are round.mp3": [
		5284,
		7,
		3959
	],
	"./00003/00003-05/00003-05-02/0.jpg": [
		7002,
		7,
		5679
	],
	"./00003/00003-05/00003-05-02/1.jpg": [
		9484,
		7,
		9506
	],
	"./00003/00003-05/00003-05-02/2.jpg": [
		9485,
		7,
		9507
	],
	"./00003/00003-05/00003-05-02/3.jpg": [
		9486,
		7,
		9508
	],
	"./00003/00003-05/00003-05-02/4.jpg": [
		9487,
		7,
		9509
	],
	"./00003/00003-05/00003-05-02/5.jpg": [
		9488,
		7,
		9510
	],
	"./00003/00003-05/00003-05-02/6.jpg": [
		9489,
		7,
		9511
	],
	"./00003/00003-05/00003-05-02/7.jpg": [
		9490,
		7,
		9512
	],
	"./00003/00003-05/00003-05-02/can you count the corners.mp3": [
		5285,
		7,
		3960
	],
	"./00003/00003-05/00003-05-02/can you count the sides.mp3": [
		5286,
		7,
		3961
	],
	"./00003/00003-05/00003-05-02/intro.mp3": [
		643,
		7
	],
	"./00003/00003-05/00003-05-02/main idea.mp3": [
		1024,
		7
	],
	"./00003/00003-05/00003-05-02/module": [
		1452,
		9,
		316
	],
	"./00003/00003-05/00003-05-02/module.js": [
		1452,
		9,
		316
	],
	"./00003/00003-05/00003-05-02/my square is black.mp3": [
		5287,
		7,
		3962
	],
	"./00003/00003-05/00003-05-02/my square is blue.mp3": [
		5288,
		7,
		3963
	],
	"./00003/00003-05/00003-05-02/my square is orange.mp3": [
		5289,
		7,
		3964
	],
	"./00003/00003-05/00003-05-02/my square is red.mp3": [
		5290,
		7,
		3965
	],
	"./00003/00003-05/00003-05-02/my square is yellow.mp3": [
		5291,
		7,
		3966
	],
	"./00003/00003-05/00003-05-02/my squares are green.mp3": [
		5292,
		7,
		3967
	],
	"./00003/00003-05/00003-05-02/my squares are pink.mp3": [
		5293,
		7,
		3968
	],
	"./00003/00003-05/00003-05-02/shapes.mp3": [
		5294,
		7,
		3969
	],
	"./00003/00003-05/00003-05-02/squares have four corners.mp3": [
		5295,
		7,
		3970
	],
	"./00003/00003-05/00003-05-02/squares have four sides.mp3": [
		5296,
		7,
		3971
	],
	"./00003/00003-05/00003-05-03/0.jpg": [
		7003,
		7,
		5680
	],
	"./00003/00003-05/00003-05-03/1.jpg": [
		9491,
		7,
		9513
	],
	"./00003/00003-05/00003-05-03/2.jpg": [
		9492,
		7,
		9514
	],
	"./00003/00003-05/00003-05-03/3.jpg": [
		9493,
		7,
		9515
	],
	"./00003/00003-05/00003-05-03/4.jpg": [
		9494,
		7,
		9516
	],
	"./00003/00003-05/00003-05-03/5.jpg": [
		9495,
		7,
		9517
	],
	"./00003/00003-05/00003-05-03/6.jpg": [
		9496,
		7,
		9518
	],
	"./00003/00003-05/00003-05-03/7.jpg": [
		9497,
		7,
		9519
	],
	"./00003/00003-05/00003-05-03/elephant likes the gray triangle.mp3": [
		5297,
		7,
		3972
	],
	"./00003/00003-05/00003-05-03/goat likes the orange triangle.mp3": [
		5298,
		7,
		3973
	],
	"./00003/00003-05/00003-05-03/intro.mp3": [
		644,
		7
	],
	"./00003/00003-05/00003-05-03/main idea.mp3": [
		1025,
		7
	],
	"./00003/00003-05/00003-05-03/module": [
		1453,
		9,
		317
	],
	"./00003/00003-05/00003-05-03/module.js": [
		1453,
		9,
		317
	],
	"./00003/00003-05/00003-05-03/monkey likes the triangle.mp3": [
		5299,
		7,
		3974
	],
	"./00003/00003-05/00003-05-03/mouse likes the blue triangle.mp3": [
		5300,
		7,
		3975
	],
	"./00003/00003-05/00003-05-03/musical instruments.mp3": [
		5301,
		7,
		3976
	],
	"./00003/00003-05/00003-05-03/rabbit likes the red triangle.mp3": [
		5302,
		7,
		3977
	],
	"./00003/00003-05/00003-05-03/the boy likes the purple triangle.mp3": [
		5303,
		7,
		3978
	],
	"./00003/00003-05/00003-05-03/the girl likes the green triangle.mp3": [
		5304,
		7,
		3979
	],
	"./00003/00003-05/00003-05-03/this triangle is big.mp3": [
		5305,
		7,
		3980
	],
	"./00003/00003-05/00003-05-03/this triangle is little.mp3": [
		5306,
		7,
		3981
	],
	"./00003/00003-05/00003-05-03/triangles have three corners.mp3": [
		5307,
		7,
		3982
	],
	"./00003/00003-05/00003-05-03/triangles have three sides.mp3": [
		5308,
		7,
		3983
	],
	"./00003/00003-05/00003-05-04/0.jpg": [
		7004,
		7,
		5681
	],
	"./00003/00003-05/00003-05-04/1.jpg": [
		9498,
		7,
		9520
	],
	"./00003/00003-05/00003-05-04/2.jpg": [
		9499,
		7,
		9521
	],
	"./00003/00003-05/00003-05-04/3.jpg": [
		9500,
		7,
		9522
	],
	"./00003/00003-05/00003-05-04/4.jpg": [
		9501,
		7,
		9523
	],
	"./00003/00003-05/00003-05-04/5.jpg": [
		9502,
		7,
		9524
	],
	"./00003/00003-05/00003-05-04/6.jpg": [
		9503,
		7,
		9525
	],
	"./00003/00003-05/00003-05-04/7.jpg": [
		9504,
		7,
		9526
	],
	"./00003/00003-05/00003-05-04/animals with four legs.mp3": [
		5309,
		7,
		3984
	],
	"./00003/00003-05/00003-05-04/crocodile can see a long rectangle.mp3": [
		5310,
		7,
		3985
	],
	"./00003/00003-05/00003-05-04/giraffe can see a long rectangle.mp3": [
		5311,
		7,
		3986
	],
	"./00003/00003-05/00003-05-04/hedgehog can see a short rectangle.mp3": [
		5312,
		7,
		3987
	],
	"./00003/00003-05/00003-05-04/intro.mp3": [
		645,
		7
	],
	"./00003/00003-05/00003-05-04/it has two long sides.mp3": [
		5313,
		7,
		3988
	],
	"./00003/00003-05/00003-05-04/it has two short sides.mp3": [
		5314,
		7,
		3989
	],
	"./00003/00003-05/00003-05-04/main idea.mp3": [
		1026,
		7
	],
	"./00003/00003-05/00003-05-04/module": [
		1454,
		9,
		318
	],
	"./00003/00003-05/00003-05-04/module.js": [
		1454,
		9,
		318
	],
	"./00003/00003-05/00003-05-04/pig can see a fat rectangle.mp3": [
		5315,
		7,
		3990
	],
	"./00003/00003-05/00003-05-04/rectangles have four corners.mp3": [
		5316,
		7,
		3991
	],
	"./00003/00003-05/00003-05-04/rectangles have four sides.mp3": [
		5317,
		7,
		3992
	],
	"./00003/00003-05/00003-05-04/sheep can see a fat rectangle.mp3": [
		5318,
		7,
		3993
	],
	"./00003/00003-05/00003-05-04/snake can see a thin rectangle.mp3": [
		5319,
		7,
		3994
	],
	"./00003/00003-05/00003-05-04/turtle can see a short rectangle.mp3": [
		5320,
		7,
		3995
	],
	"./00003/00003-05/00003-05-05/0.jpg": [
		7005,
		7,
		5682
	],
	"./00003/00003-05/00003-05-05/1.jpg": [
		9505,
		7,
		9527
	],
	"./00003/00003-05/00003-05-05/2.jpg": [
		9506,
		7,
		9528
	],
	"./00003/00003-05/00003-05-05/3.jpg": [
		9507,
		7,
		9529
	],
	"./00003/00003-05/00003-05-05/4.jpg": [
		9508,
		7,
		9530
	],
	"./00003/00003-05/00003-05-05/5.jpg": [
		9509,
		7,
		9531
	],
	"./00003/00003-05/00003-05-05/6.jpg": [
		9510,
		7,
		9532
	],
	"./00003/00003-05/00003-05-05/7.jpg": [
		9511,
		7,
		9533
	],
	"./00003/00003-05/00003-05-05/can you see it too.mp3": [
		5321,
		7,
		3996
	],
	"./00003/00003-05/00003-05-05/come with me.mp3": [
		5322,
		7,
		3997
	],
	"./00003/00003-05/00003-05-05/i can go with you.mp3": [
		5323,
		7,
		3998
	],
	"./00003/00003-05/00003-05-05/i can see a hexagon.mp3": [
		5324,
		7,
		3999
	],
	"./00003/00003-05/00003-05-05/i can see a pentagon.mp3": [
		5325,
		7,
		4000
	],
	"./00003/00003-05/00003-05-05/i can see a rectangle.mp3": [
		5326,
		7,
		4001
	],
	"./00003/00003-05/00003-05-05/i can see a square.mp3": [
		5327,
		7,
		4002
	],
	"./00003/00003-05/00003-05-05/i can see a triangle.mp3": [
		5328,
		7,
		4003
	],
	"./00003/00003-05/00003-05-05/i can see an octagon.mp3": [
		5329,
		7,
		4004
	],
	"./00003/00003-05/00003-05-05/i can see circles.mp3": [
		5330,
		7,
		4005
	],
	"./00003/00003-05/00003-05-05/i can see hexagons.mp3": [
		5331,
		7,
		4006
	],
	"./00003/00003-05/00003-05-05/intro.mp3": [
		646,
		7
	],
	"./00003/00003-05/00003-05-05/let's go look for shapes.mp3": [
		5332,
		7,
		4007
	],
	"./00003/00003-05/00003-05-05/lets go look for shapes.mp3": [
		5333,
		7,
		4008
	],
	"./00003/00003-05/00003-05-05/main idea.mp3": [
		1027,
		7
	],
	"./00003/00003-05/00003-05-05/module": [
		1455,
		9,
		319
	],
	"./00003/00003-05/00003-05-05/module.js": [
		1455,
		9,
		319
	],
	"./00003/00003-05/00003-05-05/rectangles have four sides.mp3": [
		5334,
		7,
		4009
	],
	"./00003/00003-05/00003-05-05/shapes.mp3": [
		5335,
		7,
		4010
	],
	"./00003/00003-05/00003-05-05/what can you see.mp3": [
		5336,
		7,
		4011
	],
	"./00003/00003-05/00003-05-06/0.jpg": [
		7006,
		7,
		5683
	],
	"./00003/00003-05/00003-05-06/1.jpg": [
		9512,
		7,
		9534
	],
	"./00003/00003-05/00003-05-06/2.jpg": [
		9513,
		7,
		9535
	],
	"./00003/00003-05/00003-05-06/3.jpg": [
		9514,
		7,
		9536
	],
	"./00003/00003-05/00003-05-06/4.jpg": [
		9515,
		7,
		9537
	],
	"./00003/00003-05/00003-05-06/5.jpg": [
		9516,
		7,
		9538
	],
	"./00003/00003-05/00003-05-06/6.jpg": [
		9517,
		7,
		9539
	],
	"./00003/00003-05/00003-05-06/7.jpg": [
		9518,
		7,
		9540
	],
	"./00003/00003-05/00003-05-06/balls are solid.mp3": [
		5337,
		7,
		4012
	],
	"./00003/00003-05/00003-05-06/boxes are solid.mp3": [
		5338,
		7,
		4013
	],
	"./00003/00003-05/00003-05-06/camels are solid too.mp3": [
		5339,
		7,
		4014
	],
	"./00003/00003-05/00003-05-06/cones are solid.mp3": [
		5340,
		7,
		4015
	],
	"./00003/00003-05/00003-05-06/cubes are solid.mp3": [
		5341,
		7,
		4016
	],
	"./00003/00003-05/00003-05-06/cylinders are solid.mp3": [
		5342,
		7,
		4017
	],
	"./00003/00003-05/00003-05-06/faces are flat.mp3": [
		5343,
		7,
		4018
	],
	"./00003/00003-05/00003-05-06/intro.mp3": [
		647,
		7
	],
	"./00003/00003-05/00003-05-06/main idea.mp3": [
		1028,
		7
	],
	"./00003/00003-05/00003-05-06/module": [
		1456,
		9,
		320
	],
	"./00003/00003-05/00003-05-06/module.js": [
		1456,
		9,
		320
	],
	"./00003/00003-05/00003-05-06/pyramids are solid.mp3": [
		5344,
		7,
		4019
	],
	"./00003/00003-05/00003-05-06/solid shapes.mp3": [
		5345,
		7,
		4020
	],
	"./00003/00003-05/00003-05-06/spheres are solid.mp3": [
		5346,
		7,
		4021
	],
	"./00003/00003-05/00003-05-06/they are round.mp3": [
		5347,
		7,
		4022
	],
	"./00003/00003-05/00003-05-06/they have four faces.mp3": [
		5348,
		7,
		4023
	],
	"./00003/00003-05/00003-05-06/they have funny faces.mp3": [
		5349,
		7,
		4024
	],
	"./00003/00003-05/00003-05-06/they have one face.mp3": [
		5350,
		7,
		4025
	],
	"./00003/00003-05/00003-05-06/they have six faces.mp3": [
		5351,
		7,
		4026
	],
	"./00003/00003-05/00003-05-06/they have two faces.mp3": [
		5352,
		7,
		4027
	],
	"./00003/00003-05/00003-05-06/they have zero faces.mp3": [
		5353,
		7,
		4028
	],
	"./00003/00003-05/00003-05-07/0.jpg": [
		7007,
		7,
		5684
	],
	"./00003/00003-05/00003-05-07/1.jpg": [
		9519,
		7,
		9541
	],
	"./00003/00003-05/00003-05-07/2.jpg": [
		9520,
		7,
		9542
	],
	"./00003/00003-05/00003-05-07/3.jpg": [
		9521,
		7,
		9543
	],
	"./00003/00003-05/00003-05-07/4.jpg": [
		9522,
		7,
		9544
	],
	"./00003/00003-05/00003-05-07/5.jpg": [
		9523,
		7,
		9545
	],
	"./00003/00003-05/00003-05-07/6.jpg": [
		9524,
		7,
		9546
	],
	"./00003/00003-05/00003-05-07/7.jpg": [
		9525,
		7,
		9547
	],
	"./00003/00003-05/00003-05-07/all the faces are square.mp3": [
		5354,
		7,
		4029
	],
	"./00003/00003-05/00003-05-07/cubes have six faces.mp3": [
		5355,
		7,
		4030
	],
	"./00003/00003-05/00003-05-07/faces are flat.mp3": [
		5356,
		7,
		4031
	],
	"./00003/00003-05/00003-05-07/forest animals.mp3": [
		5357,
		7,
		4032
	],
	"./00003/00003-05/00003-05-07/intro.mp3": [
		648,
		7
	],
	"./00003/00003-05/00003-05-07/look at the bear face.mp3": [
		5358,
		7,
		4033
	],
	"./00003/00003-05/00003-05-07/look at the cube.mp3": [
		5359,
		7,
		4034
	],
	"./00003/00003-05/00003-05-07/look at the deer face.mp3": [
		5360,
		7,
		4035
	],
	"./00003/00003-05/00003-05-07/look at the elephant face.mp3": [
		5361,
		7,
		4036
	],
	"./00003/00003-05/00003-05-07/look at the faces.mp3": [
		5362,
		7,
		4037
	],
	"./00003/00003-05/00003-05-07/look at the fox face.mp3": [
		5363,
		7,
		4038
	],
	"./00003/00003-05/00003-05-07/look at the panda face.mp3": [
		5364,
		7,
		4039
	],
	"./00003/00003-05/00003-05-07/look at the rabbit face.mp3": [
		5365,
		7,
		4040
	],
	"./00003/00003-05/00003-05-07/main idea.mp3": [
		1029,
		7
	],
	"./00003/00003-05/00003-05-07/module": [
		1457,
		9,
		321
	],
	"./00003/00003-05/00003-05-07/module.js": [
		1457,
		9,
		321
	],
	"./00003/00003-05/00003-05-08/0.jpg": [
		7008,
		7,
		5685
	],
	"./00003/00003-05/00003-05-08/1.jpg": [
		9526,
		7,
		9548
	],
	"./00003/00003-05/00003-05-08/2.jpg": [
		9527,
		7,
		9549
	],
	"./00003/00003-05/00003-05-08/3.jpg": [
		9528,
		7,
		9550
	],
	"./00003/00003-05/00003-05-08/4.jpg": [
		9529,
		7,
		9551
	],
	"./00003/00003-05/00003-05-08/5.jpg": [
		9530,
		7,
		9552
	],
	"./00003/00003-05/00003-05-08/6.jpg": [
		9531,
		7,
		9553
	],
	"./00003/00003-05/00003-05-08/7.jpg": [
		9532,
		7,
		9554
	],
	"./00003/00003-05/00003-05-08/how many can you see.mp3": [
		5366,
		7,
		4041
	],
	"./00003/00003-05/00003-05-08/how many shapes can you see.mp3": [
		5367,
		7,
		4042
	],
	"./00003/00003-05/00003-05-08/intro.mp3": [
		649,
		7
	],
	"./00003/00003-05/00003-05-08/look at the circles.mp3": [
		5368,
		7,
		4043
	],
	"./00003/00003-05/00003-05-08/look at the hexagons.mp3": [
		5369,
		7,
		4044
	],
	"./00003/00003-05/00003-05-08/look at the octagons.mp3": [
		5370,
		7,
		4045
	],
	"./00003/00003-05/00003-05-08/look at the pentagons.mp3": [
		5371,
		7,
		4046
	],
	"./00003/00003-05/00003-05-08/look at the rectangles.mp3": [
		5372,
		7,
		4047
	],
	"./00003/00003-05/00003-05-08/look at the squares.mp3": [
		5373,
		7,
		4048
	],
	"./00003/00003-05/00003-05-08/look at the triangles.mp3": [
		5374,
		7,
		4049
	],
	"./00003/00003-05/00003-05-08/main idea.mp3": [
		1030,
		7
	],
	"./00003/00003-05/00003-05-08/module": [
		1458,
		9,
		322
	],
	"./00003/00003-05/00003-05-08/module.js": [
		1458,
		9,
		322
	],
	"./00003/00003-05/00003-05-08/non living things.mp3": [
		5375,
		7,
		4050
	],
	"./00003/00003-05/00003-05-08/there are shapes on the quilt.mp3": [
		5376,
		7,
		4051
	],
	"./00003/00003-05/00003-05-09/0.jpg": [
		7009,
		7,
		5686
	],
	"./00003/00003-05/00003-05-09/1.jpg": [
		9533,
		7,
		9555
	],
	"./00003/00003-05/00003-05-09/2.jpg": [
		9534,
		7,
		9556
	],
	"./00003/00003-05/00003-05-09/3.jpg": [
		9535,
		7,
		9557
	],
	"./00003/00003-05/00003-05-09/4.jpg": [
		9536,
		7,
		9558
	],
	"./00003/00003-05/00003-05-09/5.jpg": [
		9537,
		7,
		9559
	],
	"./00003/00003-05/00003-05-09/6.jpg": [
		9538,
		7,
		9560
	],
	"./00003/00003-05/00003-05-09/7.jpg": [
		9539,
		7,
		9561
	],
	"./00003/00003-05/00003-05-09/i can make a circle.mp3": [
		5377,
		7,
		4052
	],
	"./00003/00003-05/00003-05-09/i can make a fox.mp3": [
		5378,
		7,
		4053
	],
	"./00003/00003-05/00003-05-09/i can make a hexagon.mp3": [
		5379,
		7,
		4054
	],
	"./00003/00003-05/00003-05-09/i can make a new shape.mp3": [
		5380,
		7,
		4055
	],
	"./00003/00003-05/00003-05-09/i can make a pentagon.mp3": [
		5381,
		7,
		4056
	],
	"./00003/00003-05/00003-05-09/i can make a rectangle.mp3": [
		5382,
		7,
		4057
	],
	"./00003/00003-05/00003-05-09/i can make a square.mp3": [
		5383,
		7,
		4058
	],
	"./00003/00003-05/00003-05-09/i can make an octagon.mp3": [
		5384,
		7,
		4059
	],
	"./00003/00003-05/00003-05-09/i have a square.mp3": [
		5385,
		7,
		4060
	],
	"./00003/00003-05/00003-05-09/i have a triangle.mp3": [
		5386,
		7,
		4061
	],
	"./00003/00003-05/00003-05-09/i have four quarter circles.mp3": [
		5387,
		7,
		4062
	],
	"./00003/00003-05/00003-05-09/i have some triangles.mp3": [
		5388,
		7,
		4063
	],
	"./00003/00003-05/00003-05-09/intro.mp3": [
		650,
		7
	],
	"./00003/00003-05/00003-05-09/main idea.mp3": [
		1031,
		7
	],
	"./00003/00003-05/00003-05-09/module": [
		1459,
		9,
		323
	],
	"./00003/00003-05/00003-05-09/module.js": [
		1459,
		9,
		323
	],
	"./00003/00003-05/00003-05-09/shapes.mp3": [
		5389,
		7,
		4064
	],
	"./00003/00003-05/00003-05-09/what can i make.mp3": [
		5390,
		7,
		4065
	],
	"./00003/00003-05/00003-05-10/0.jpg": [
		7010,
		7,
		5687
	],
	"./00003/00003-05/00003-05-10/1.jpg": [
		9540,
		7,
		9562
	],
	"./00003/00003-05/00003-05-10/2.jpg": [
		9541,
		7,
		9563
	],
	"./00003/00003-05/00003-05-10/3.jpg": [
		9542,
		7,
		9564
	],
	"./00003/00003-05/00003-05-10/4.jpg": [
		9543,
		7,
		9565
	],
	"./00003/00003-05/00003-05-10/5.jpg": [
		9544,
		7,
		9566
	],
	"./00003/00003-05/00003-05-10/6.jpg": [
		9545,
		7,
		9567
	],
	"./00003/00003-05/00003-05-10/7.jpg": [
		9546,
		7,
		9568
	],
	"./00003/00003-05/00003-05-10/intro.mp3": [
		651,
		7
	],
	"./00003/00003-05/00003-05-10/look around.mp3": [
		5391,
		7,
		4066
	],
	"./00003/00003-05/00003-05-10/main idea.mp3": [
		1032,
		7
	],
	"./00003/00003-05/00003-05-10/module": [
		1460,
		9,
		324
	],
	"./00003/00003-05/00003-05-10/module.js": [
		1460,
		9,
		324
	],
	"./00003/00003-05/00003-05-10/places.mp3": [
		5392,
		7,
		4067
	],
	"./00003/00003-05/00003-05-10/shapes are all around us.mp3": [
		5393,
		7,
		4068
	],
	"./00003/00003-05/00003-05-10/we can see circles.mp3": [
		5394,
		7,
		4069
	],
	"./00003/00003-05/00003-05-10/we can see cones.mp3": [
		5395,
		7,
		4070
	],
	"./00003/00003-05/00003-05-10/we can see cubes.mp3": [
		5396,
		7,
		4071
	],
	"./00003/00003-05/00003-05-10/we can see cylinders.mp3": [
		5397,
		7,
		4072
	],
	"./00003/00003-05/00003-05-10/we can see flat shapes.mp3": [
		5398,
		7,
		4073
	],
	"./00003/00003-05/00003-05-10/we can see rectangles.mp3": [
		5399,
		7,
		4074
	],
	"./00003/00003-05/00003-05-10/we can see solid shapes.mp3": [
		5400,
		7,
		4075
	],
	"./00003/00003-05/00003-05-10/we can see squares.mp3": [
		5401,
		7,
		4076
	],
	"./00003/00003-05/00003-05-10/we can see triangles.mp3": [
		5402,
		7,
		4077
	],
	"./00003/00003-05/00003-05-10/what shapes can we see.mp3": [
		5403,
		7,
		4078
	],
	"./00003/00003-05/cover.jpg": [
		7011,
		7,
		5688
	],
	"./00003/00003-05/shapes land.mp3": [
		5404,
		7,
		4079
	],
	"./00003/00003-05/shapes.mp3": [
		5405,
		7,
		4080
	],
	"./00003/00003-05/unit": [
		1461,
		9,
		325
	],
	"./00003/00003-05/unit.js": [
		1461,
		9,
		325
	],
	"./00003/00003-06/00003-06-01/0.jpg": [
		7012,
		7,
		5689
	],
	"./00003/00003-06/00003-06-01/1.jpg": [
		9547,
		7,
		9569
	],
	"./00003/00003-06/00003-06-01/2.jpg": [
		9548,
		7,
		9570
	],
	"./00003/00003-06/00003-06-01/3.jpg": [
		9549,
		7,
		9571
	],
	"./00003/00003-06/00003-06-01/4.jpg": [
		9550,
		7,
		9572
	],
	"./00003/00003-06/00003-06-01/5.jpg": [
		9551,
		7,
		9573
	],
	"./00003/00003-06/00003-06-01/6.jpg": [
		9552,
		7,
		9574
	],
	"./00003/00003-06/00003-06-01/7.jpg": [
		9553,
		7,
		9575
	],
	"./00003/00003-06/00003-06-01/i do not need air said the fish.mp3": [
		5406,
		7,
		4081
	],
	"./00003/00003-06/00003-06-01/i do not need air said the octopus.mp3": [
		5407,
		7,
		4082
	],
	"./00003/00003-06/00003-06-01/i have a tank for air too.mp3": [
		5408,
		7,
		4083
	],
	"./00003/00003-06/00003-06-01/i have a tank for air.mp3": [
		5409,
		7,
		4084
	],
	"./00003/00003-06/00003-06-01/i have to come up for air too.mp3": [
		5410,
		7,
		4085
	],
	"./00003/00003-06/00003-06-01/i have to come up for air.mp3": [
		5411,
		7,
		4086
	],
	"./00003/00003-06/00003-06-01/i need air said the astronaut.mp3": [
		5412,
		7,
		4087
	],
	"./00003/00003-06/00003-06-01/i need air said the cat.mp3": [
		5413,
		7,
		4088
	],
	"./00003/00003-06/00003-06-01/i need air said the sea turtle.mp3": [
		5414,
		7,
		4089
	],
	"./00003/00003-06/00003-06-01/intro.mp3": [
		652,
		7
	],
	"./00003/00003-06/00003-06-01/main idea.mp3": [
		1033,
		7
	],
	"./00003/00003-06/00003-06-01/me too said the eagle.mp3": [
		5415,
		7,
		4090
	],
	"./00003/00003-06/00003-06-01/me too said the scuba diver.mp3": [
		5416,
		7,
		4091
	],
	"./00003/00003-06/00003-06-01/me too said the whale.mp3": [
		5417,
		7,
		4092
	],
	"./00003/00003-06/00003-06-01/module": [
		1462,
		9,
		326
	],
	"./00003/00003-06/00003-06-01/module.js": [
		1462,
		9,
		326
	],
	"./00003/00003-06/00003-06-01/the air goes in my lungs too.mp3": [
		5418,
		7,
		4093
	],
	"./00003/00003-06/00003-06-01/the air goes in my lungs.mp3": [
		5419,
		7,
		4094
	],
	"./00003/00003-06/00003-06-01/water animals.mp3": [
		5420,
		7,
		4095
	],
	"./00003/00003-06/00003-06-01/we need air.mp3": [
		5421,
		7,
		4096
	],
	"./00003/00003-06/00003-06-02/0.jpg": [
		7013,
		7,
		5690
	],
	"./00003/00003-06/00003-06-02/1.jpg": [
		9554,
		7,
		9576
	],
	"./00003/00003-06/00003-06-02/2.jpg": [
		9555,
		7,
		9577
	],
	"./00003/00003-06/00003-06-02/3.jpg": [
		9556,
		7,
		9578
	],
	"./00003/00003-06/00003-06-02/4.jpg": [
		9557,
		7,
		9579
	],
	"./00003/00003-06/00003-06-02/5.jpg": [
		9558,
		7,
		9580
	],
	"./00003/00003-06/00003-06-02/6.jpg": [
		9559,
		7,
		9581
	],
	"./00003/00003-06/00003-06-02/7.jpg": [
		9560,
		7,
		9582
	],
	"./00003/00003-06/00003-06-02/animals that live in trees.mp3": [
		5422,
		7,
		4097
	],
	"./00003/00003-06/00003-06-02/i live in a cave said the bear.mp3": [
		5423,
		7,
		4098
	],
	"./00003/00003-06/00003-06-02/i live in a cave too said the bat.mp3": [
		5424,
		7,
		4099
	],
	"./00003/00003-06/00003-06-02/i live in a tree said the monkey.mp3": [
		5425,
		7,
		4100
	],
	"./00003/00003-06/00003-06-02/i live in a tree too said the owl.mp3": [
		5426,
		7,
		4101
	],
	"./00003/00003-06/00003-06-02/i live in the sea.mp3": [
		5427,
		7,
		4102
	],
	"./00003/00003-06/00003-06-02/i live on a farm said the cow.mp3": [
		5428,
		7,
		4103
	],
	"./00003/00003-06/00003-06-02/i live on a farm too said the pig.mp3": [
		5429,
		7,
		4104
	],
	"./00003/00003-06/00003-06-02/intro.mp3": [
		653,
		7
	],
	"./00003/00003-06/00003-06-02/little bat where do you live.mp3": [
		5430,
		7,
		4105
	],
	"./00003/00003-06/00003-06-02/little bear where do you live.mp3": [
		5431,
		7,
		4106
	],
	"./00003/00003-06/00003-06-02/little cow where do you live.mp3": [
		5432,
		7,
		4107
	],
	"./00003/00003-06/00003-06-02/little monkey where do you live.mp3": [
		5433,
		7,
		4108
	],
	"./00003/00003-06/00003-06-02/little owl where do you live.mp3": [
		5434,
		7,
		4109
	],
	"./00003/00003-06/00003-06-02/little pig where do you live.mp3": [
		5435,
		7,
		4110
	],
	"./00003/00003-06/00003-06-02/main idea.mp3": [
		1034,
		7
	],
	"./00003/00003-06/00003-06-02/module": [
		1463,
		9,
		327
	],
	"./00003/00003-06/00003-06-02/module.js": [
		1463,
		9,
		327
	],
	"./00003/00003-06/00003-06-02/not me said the fish.mp3": [
		5436,
		7,
		4111
	],
	"./00003/00003-06/00003-06-02/we need homes.mp3": [
		5437,
		7,
		4112
	],
	"./00003/00003-06/00003-06-03/0.jpg": [
		7014,
		7,
		5691
	],
	"./00003/00003-06/00003-06-03/1.jpg": [
		9561,
		7,
		9583
	],
	"./00003/00003-06/00003-06-03/2.jpg": [
		9562,
		7,
		9584
	],
	"./00003/00003-06/00003-06-03/3.jpg": [
		9563,
		7,
		9585
	],
	"./00003/00003-06/00003-06-03/4.jpg": [
		9564,
		7,
		9586
	],
	"./00003/00003-06/00003-06-03/5.jpg": [
		9565,
		7,
		9587
	],
	"./00003/00003-06/00003-06-03/6.jpg": [
		9566,
		7,
		9588
	],
	"./00003/00003-06/00003-06-03/7.jpg": [
		9567,
		7,
		9589
	],
	"./00003/00003-06/00003-06-03/all animals need to eat.mp3": [
		5438,
		7,
		4113
	],
	"./00003/00003-06/00003-06-03/animals that eat plants.mp3": [
		5439,
		7,
		4114
	],
	"./00003/00003-06/00003-06-03/bats like to eat insects.mp3": [
		5440,
		7,
		4115
	],
	"./00003/00003-06/00003-06-03/do you like bananas.mp3": [
		5441,
		7,
		4116
	],
	"./00003/00003-06/00003-06-03/do you like fish.mp3": [
		5442,
		7,
		4117
	],
	"./00003/00003-06/00003-06-03/giraffes do not eat fish.mp3": [
		5443,
		7,
		4118
	],
	"./00003/00003-06/00003-06-03/giraffes like to eat leaves.mp3": [
		5444,
		7,
		4119
	],
	"./00003/00003-06/00003-06-03/intro.mp3": [
		654,
		7
	],
	"./00003/00003-06/00003-06-03/main idea.mp3": [
		1035,
		7
	],
	"./00003/00003-06/00003-06-03/module": [
		1464,
		9,
		328
	],
	"./00003/00003-06/00003-06-03/module.js": [
		1464,
		9,
		328
	],
	"./00003/00003-06/00003-06-03/monkeys like to eat bananas.mp3": [
		5445,
		7,
		4120
	],
	"./00003/00003-06/00003-06-03/pelicans like to eat fish too.mp3": [
		5446,
		7,
		4121
	],
	"./00003/00003-06/00003-06-03/sharks do not eat insects.mp3": [
		5447,
		7,
		4122
	],
	"./00003/00003-06/00003-06-03/sharks like to eat fish.mp3": [
		5448,
		7,
		4123
	],
	"./00003/00003-06/00003-06-03/some animals eat grass.mp3": [
		5449,
		7,
		4124
	],
	"./00003/00003-06/00003-06-03/some animals like to eat insects.mp3": [
		5450,
		7,
		4125
	],
	"./00003/00003-06/00003-06-03/some dinosaurs liked to eat leaves.mp3": [
		5451,
		7,
		4126
	],
	"./00003/00003-06/00003-06-03/some dinosaurs liked to eat meat.mp3": [
		5452,
		7,
		4127
	],
	"./00003/00003-06/00003-06-03/we need to eat.mp3": [
		5453,
		7,
		4128
	],
	"./00003/00003-06/00003-06-03/zebras like to eat grass.mp3": [
		5454,
		7,
		4129
	],
	"./00003/00003-06/00003-06-04/0.jpg": [
		7015,
		7,
		5692
	],
	"./00003/00003-06/00003-06-04/1.jpg": [
		9568,
		7,
		9590
	],
	"./00003/00003-06/00003-06-04/2.jpg": [
		9569,
		7,
		9591
	],
	"./00003/00003-06/00003-06-04/3.jpg": [
		9570,
		7,
		9592
	],
	"./00003/00003-06/00003-06-04/4.jpg": [
		9571,
		7,
		9593
	],
	"./00003/00003-06/00003-06-04/5.jpg": [
		9572,
		7,
		9594
	],
	"./00003/00003-06/00003-06-04/6.jpg": [
		9573,
		7,
		9595
	],
	"./00003/00003-06/00003-06-04/7.jpg": [
		9574,
		7,
		9596
	],
	"./00003/00003-06/00003-06-04/animals that live in the snow.mp3": [
		5455,
		7,
		4130
	],
	"./00003/00003-06/00003-06-04/he is out in the snow.mp3": [
		5456,
		7,
		4131
	],
	"./00003/00003-06/00003-06-04/i am out in the snow too.mp3": [
		5457,
		7,
		4132
	],
	"./00003/00003-06/00003-06-04/intro.mp3": [
		655,
		7
	],
	"./00003/00003-06/00003-06-04/it is snowing.mp3": [
		5458,
		7,
		4133
	],
	"./00003/00003-06/00003-06-04/it is winter.mp3": [
		5459,
		7,
		4134
	],
	"./00003/00003-06/00003-06-04/look at me.mp3": [
		5460,
		7,
		4135
	],
	"./00003/00003-06/00003-06-04/look at the deer.mp3": [
		5461,
		7,
		4136
	],
	"./00003/00003-06/00003-06-04/look at the dog.mp3": [
		5462,
		7,
		4137
	],
	"./00003/00003-06/00003-06-04/look at the fox.mp3": [
		5463,
		7,
		4138
	],
	"./00003/00003-06/00003-06-04/look at the owl.mp3": [
		5464,
		7,
		4139
	],
	"./00003/00003-06/00003-06-04/look at the rabbit.mp3": [
		5465,
		7,
		4140
	],
	"./00003/00003-06/00003-06-04/look at the squirrel.mp3": [
		5466,
		7,
		4141
	],
	"./00003/00003-06/00003-06-04/main idea.mp3": [
		1036,
		7
	],
	"./00003/00003-06/00003-06-04/module": [
		1465,
		9,
		329
	],
	"./00003/00003-06/00003-06-04/module.js": [
		1465,
		9,
		329
	],
	"./00003/00003-06/00003-06-04/out in the snow.mp3": [
		5467,
		7,
		4142
	],
	"./00003/00003-06/00003-06-04/she is out in the snow.mp3": [
		5468,
		7,
		4143
	],
	"./00003/00003-06/00003-06-05/0.jpg": [
		7016,
		7,
		5693
	],
	"./00003/00003-06/00003-06-05/1.jpg": [
		9575,
		7,
		9597
	],
	"./00003/00003-06/00003-06-05/2.jpg": [
		9576,
		7,
		9598
	],
	"./00003/00003-06/00003-06-05/3.jpg": [
		9577,
		7,
		9599
	],
	"./00003/00003-06/00003-06-05/4.jpg": [
		9578,
		7,
		9600
	],
	"./00003/00003-06/00003-06-05/5.jpg": [
		9579,
		7,
		9601
	],
	"./00003/00003-06/00003-06-05/6.jpg": [
		9580,
		7,
		9602
	],
	"./00003/00003-06/00003-06-05/7.jpg": [
		9581,
		7,
		9603
	],
	"./00003/00003-06/00003-06-05/are they alive.mp3": [
		5469,
		7,
		4144
	],
	"./00003/00003-06/00003-06-05/i can see a log.mp3": [
		5470,
		7,
		4145
	],
	"./00003/00003-06/00003-06-05/i can see a seal.mp3": [
		5471,
		7,
		4146
	],
	"./00003/00003-06/00003-06-05/i can see a wheel.mp3": [
		5472,
		7,
		4147
	],
	"./00003/00003-06/00003-06-05/i can see one box.mp3": [
		5473,
		7,
		4148
	],
	"./00003/00003-06/00003-06-05/i can see one cat.mp3": [
		5474,
		7,
		4149
	],
	"./00003/00003-06/00003-06-05/i can see one duck.mp3": [
		5475,
		7,
		4150
	],
	"./00003/00003-06/00003-06-05/i can see one fox.mp3": [
		5476,
		7,
		4151
	],
	"./00003/00003-06/00003-06-05/i can see one frog.mp3": [
		5477,
		7,
		4152
	],
	"./00003/00003-06/00003-06-05/i can see one hat.mp3": [
		5478,
		7,
		4153
	],
	"./00003/00003-06/00003-06-05/i can see one house.mp3": [
		5479,
		7,
		4154
	],
	"./00003/00003-06/00003-06-05/i can see one mouse.mp3": [
		5480,
		7,
		4155
	],
	"./00003/00003-06/00003-06-05/i can see one truck.mp3": [
		5481,
		7,
		4156
	],
	"./00003/00003-06/00003-06-05/intro.mp3": [
		656,
		7
	],
	"./00003/00003-06/00003-06-05/living things.mp3": [
		5482,
		7,
		4157
	],
	"./00003/00003-06/00003-06-05/look at the jeep.mp3": [
		5483,
		7,
		4158
	],
	"./00003/00003-06/00003-06-05/look at the sheep.mp3": [
		5484,
		7,
		4159
	],
	"./00003/00003-06/00003-06-05/main idea.mp3": [
		1037,
		7
	],
	"./00003/00003-06/00003-06-05/module": [
		1466,
		9,
		330
	],
	"./00003/00003-06/00003-06-05/module.js": [
		1466,
		9,
		330
	],
	"./00003/00003-06/00003-06-05/the cat is alive.mp3": [
		5485,
		7,
		4160
	],
	"./00003/00003-06/00003-06-05/the duck is alive.mp3": [
		5486,
		7,
		4161
	],
	"./00003/00003-06/00003-06-05/the fox is alive.mp3": [
		5487,
		7,
		4162
	],
	"./00003/00003-06/00003-06-05/the frog is alive.mp3": [
		5488,
		7,
		4163
	],
	"./00003/00003-06/00003-06-05/the mouse is alive.mp3": [
		5489,
		7,
		4164
	],
	"./00003/00003-06/00003-06-05/the seal is alive.mp3": [
		5490,
		7,
		4165
	],
	"./00003/00003-06/00003-06-05/the sheep is alive.mp3": [
		5491,
		7,
		4166
	],
	"./00003/00003-06/00003-06-05/which one is alive.mp3": [
		5492,
		7,
		4167
	],
	"./00003/00003-06/00003-06-06/0.jpg": [
		7017,
		7,
		5694
	],
	"./00003/00003-06/00003-06-06/1.jpg": [
		9582,
		7,
		9604
	],
	"./00003/00003-06/00003-06-06/2.jpg": [
		9583,
		7,
		9605
	],
	"./00003/00003-06/00003-06-06/3.jpg": [
		9584,
		7,
		9606
	],
	"./00003/00003-06/00003-06-06/4.jpg": [
		9585,
		7,
		9607
	],
	"./00003/00003-06/00003-06-06/5.jpg": [
		9586,
		7,
		9608
	],
	"./00003/00003-06/00003-06-06/6.jpg": [
		9587,
		7,
		9609
	],
	"./00003/00003-06/00003-06-06/7.jpg": [
		9588,
		7,
		9610
	],
	"./00003/00003-06/00003-06-06/baby animals.mp3": [
		5493,
		7,
		4168
	],
	"./00003/00003-06/00003-06-06/here is my mother.mp3": [
		5494,
		7,
		4169
	],
	"./00003/00003-06/00003-06-06/i am a duckling.mp3": [
		5495,
		7,
		4170
	],
	"./00003/00003-06/00003-06-06/i am a lamb.mp3": [
		5496,
		7,
		4171
	],
	"./00003/00003-06/00003-06-06/i am a puppy.mp3": [
		5497,
		7,
		4172
	],
	"./00003/00003-06/00003-06-06/i love my mother.mp3": [
		5498,
		7,
		4173
	],
	"./00003/00003-06/00003-06-06/intro.mp3": [
		657,
		7
	],
	"./00003/00003-06/00003-06-06/main idea.mp3": [
		1038,
		7
	],
	"./00003/00003-06/00003-06-06/mammals.mp3": [
		5499,
		7,
		4174
	],
	"./00003/00003-06/00003-06-06/module": [
		1467,
		9,
		331
	],
	"./00003/00003-06/00003-06-06/module.js": [
		1467,
		9,
		331
	],
	"./00003/00003-06/00003-06-06/mom.mp3": [
		5500,
		7,
		4175
	],
	"./00003/00003-06/00003-06-06/mother.mp3": [
		5501,
		7,
		4176
	],
	"./00003/00003-06/00003-06-06/my mother is a bear.mp3": [
		5502,
		7,
		4177
	],
	"./00003/00003-06/00003-06-06/my mother is a cow.mp3": [
		5503,
		7,
		4178
	],
	"./00003/00003-06/00003-06-06/my mother is a dolphin.mp3": [
		5504,
		7,
		4179
	],
	"./00003/00003-06/00003-06-06/my mother is a duck.mp3": [
		5505,
		7,
		4180
	],
	"./00003/00003-06/00003-06-06/my mother is a kangaroo.mp3": [
		5506,
		7,
		4181
	],
	"./00003/00003-06/00003-06-06/my mother is a rabbit.mp3": [
		5507,
		7,
		4182
	],
	"./00003/00003-06/00003-06-06/my mother is a sheep.mp3": [
		5508,
		7,
		4183
	],
	"./00003/00003-06/00003-06-07/0.jpg": [
		7018,
		7,
		5695
	],
	"./00003/00003-06/00003-06-07/1.jpg": [
		9589,
		7,
		9611
	],
	"./00003/00003-06/00003-06-07/2.jpg": [
		9590,
		7,
		9612
	],
	"./00003/00003-06/00003-06-07/3.jpg": [
		9591,
		7,
		9613
	],
	"./00003/00003-06/00003-06-07/4.jpg": [
		9592,
		7,
		9614
	],
	"./00003/00003-06/00003-06-07/5.jpg": [
		9593,
		7,
		9615
	],
	"./00003/00003-06/00003-06-07/6.jpg": [
		9594,
		7,
		9616
	],
	"./00003/00003-06/00003-06-07/7.jpg": [
		9595,
		7,
		9617
	],
	"./00003/00003-06/00003-06-07/birds need water.mp3": [
		5509,
		7,
		4184
	],
	"./00003/00003-06/00003-06-07/deer need water.mp3": [
		5510,
		7,
		4185
	],
	"./00003/00003-06/00003-06-07/dogs need water too.mp3": [
		5511,
		7,
		4186
	],
	"./00003/00003-06/00003-06-07/dolphins need water.mp3": [
		5512,
		7,
		4187
	],
	"./00003/00003-06/00003-06-07/ducks need water.mp3": [
		5513,
		7,
		4188
	],
	"./00003/00003-06/00003-06-07/everyone needs water.mp3": [
		5514,
		7,
		4189
	],
	"./00003/00003-06/00003-06-07/flowers need water.mp3": [
		5515,
		7,
		4190
	],
	"./00003/00003-06/00003-06-07/frogs need water.mp3": [
		5516,
		7,
		4191
	],
	"./00003/00003-06/00003-06-07/intro.mp3": [
		658,
		7
	],
	"./00003/00003-06/00003-06-07/look at the birds.mp3": [
		5517,
		7,
		4192
	],
	"./00003/00003-06/00003-06-07/look at the deer.mp3": [
		5518,
		7,
		4193
	],
	"./00003/00003-06/00003-06-07/look at the dog.mp3": [
		5519,
		7,
		4194
	],
	"./00003/00003-06/00003-06-07/look at the dolphins.mp3": [
		5520,
		7,
		4195
	],
	"./00003/00003-06/00003-06-07/look at the ducks.mp3": [
		5521,
		7,
		4196
	],
	"./00003/00003-06/00003-06-07/look at the flowers.mp3": [
		5522,
		7,
		4197
	],
	"./00003/00003-06/00003-06-07/look at the frogs.mp3": [
		5523,
		7,
		4198
	],
	"./00003/00003-06/00003-06-07/main idea.mp3": [
		1039,
		7
	],
	"./00003/00003-06/00003-06-07/module": [
		1468,
		9,
		332
	],
	"./00003/00003-06/00003-06-07/module.js": [
		1468,
		9,
		332
	],
	"./00003/00003-06/00003-06-07/they need water to drink.mp3": [
		5524,
		7,
		4199
	],
	"./00003/00003-06/00003-06-07/they need water to grow.mp3": [
		5525,
		7,
		4200
	],
	"./00003/00003-06/00003-06-07/they need water to swim.mp3": [
		5526,
		7,
		4201
	],
	"./00003/00003-06/00003-06-07/water.mp3": [
		5527,
		7,
		4202
	],
	"./00003/00003-06/00003-06-07/we all need water to live.mp3": [
		5528,
		7,
		4203
	],
	"./00003/00003-06/00003-06-08/0.jpg": [
		7019,
		7,
		5696
	],
	"./00003/00003-06/00003-06-08/1.jpg": [
		9596,
		7,
		9618
	],
	"./00003/00003-06/00003-06-08/2.jpg": [
		9597,
		7,
		9619
	],
	"./00003/00003-06/00003-06-08/3.jpg": [
		9598,
		7,
		9620
	],
	"./00003/00003-06/00003-06-08/4.jpg": [
		9599,
		7,
		9621
	],
	"./00003/00003-06/00003-06-08/5.jpg": [
		9600,
		7,
		9622
	],
	"./00003/00003-06/00003-06-08/6.jpg": [
		9601,
		7,
		9623
	],
	"./00003/00003-06/00003-06-08/7.jpg": [
		9602,
		7,
		9624
	],
	"./00003/00003-06/00003-06-08/grow seeds grow.mp3": [
		5529,
		7,
		4204
	],
	"./00003/00003-06/00003-06-08/i can see the apples.mp3": [
		5530,
		7,
		4205
	],
	"./00003/00003-06/00003-06-08/i can see the branch.mp3": [
		5531,
		7,
		4206
	],
	"./00003/00003-06/00003-06-08/i can see the flowers.mp3": [
		5532,
		7,
		4207
	],
	"./00003/00003-06/00003-06-08/i can see the leaves.mp3": [
		5533,
		7,
		4208
	],
	"./00003/00003-06/00003-06-08/i can see the roots.mp3": [
		5534,
		7,
		4209
	],
	"./00003/00003-06/00003-06-08/i can see the seeds.mp3": [
		5535,
		7,
		4210
	],
	"./00003/00003-06/00003-06-08/i can see the stem.mp3": [
		5536,
		7,
		4211
	],
	"./00003/00003-06/00003-06-08/i like apples he said.mp3": [
		5537,
		7,
		4212
	],
	"./00003/00003-06/00003-06-08/i see some pink flowers.mp3": [
		5538,
		7,
		4213
	],
	"./00003/00003-06/00003-06-08/intro.mp3": [
		659,
		7
	],
	"./00003/00003-06/00003-06-08/look at the apples.mp3": [
		5539,
		7,
		4214
	],
	"./00003/00003-06/00003-06-08/look at the branch.mp3": [
		5540,
		7,
		4215
	],
	"./00003/00003-06/00003-06-08/look at the flowers.mp3": [
		5541,
		7,
		4216
	],
	"./00003/00003-06/00003-06-08/look at the green apples.mp3": [
		5542,
		7,
		4217
	],
	"./00003/00003-06/00003-06-08/look at the horse.mp3": [
		5543,
		7,
		4218
	],
	"./00003/00003-06/00003-06-08/look at the leaves.mp3": [
		5544,
		7,
		4219
	],
	"./00003/00003-06/00003-06-08/look at the roots.mp3": [
		5545,
		7,
		4220
	],
	"./00003/00003-06/00003-06-08/look at the seeds.mp3": [
		5546,
		7,
		4221
	],
	"./00003/00003-06/00003-06-08/look at the stem.mp3": [
		5547,
		7,
		4222
	],
	"./00003/00003-06/00003-06-08/main idea.mp3": [
		1040,
		7
	],
	"./00003/00003-06/00003-06-08/module": [
		1469,
		9,
		333
	],
	"./00003/00003-06/00003-06-08/module.js": [
		1469,
		9,
		333
	],
	"./00003/00003-06/00003-06-08/the plant grows and grows.mp3": [
		5548,
		7,
		4223
	],
	"./00003/00003-06/00003-06-08/the plant grows.mp3": [
		5549,
		7,
		4224
	],
	"./00003/00003-06/00003-06-08/things that grow on trees.mp3": [
		5550,
		7,
		4225
	],
	"./00003/00003-06/00003-06-09/0.jpg": [
		7020,
		7,
		5697
	],
	"./00003/00003-06/00003-06-09/1.jpg": [
		9603,
		7,
		9625
	],
	"./00003/00003-06/00003-06-09/2.jpg": [
		9604,
		7,
		9626
	],
	"./00003/00003-06/00003-06-09/3.jpg": [
		9605,
		7,
		9627
	],
	"./00003/00003-06/00003-06-09/4.jpg": [
		9606,
		7,
		9628
	],
	"./00003/00003-06/00003-06-09/5.jpg": [
		9607,
		7,
		9629
	],
	"./00003/00003-06/00003-06-09/6.jpg": [
		9608,
		7,
		9630
	],
	"./00003/00003-06/00003-06-09/7.jpg": [
		9609,
		7,
		9631
	],
	"./00003/00003-06/00003-06-09/baby animals.mp3": [
		5551,
		7,
		4226
	],
	"./00003/00003-06/00003-06-09/here is my dad.mp3": [
		5552,
		7,
		4227
	],
	"./00003/00003-06/00003-06-09/i am a chick.mp3": [
		5553,
		7,
		4228
	],
	"./00003/00003-06/00003-06-09/i am a puppy.mp3": [
		5554,
		7,
		4229
	],
	"./00003/00003-06/00003-06-09/i love my dad.mp3": [
		5555,
		7,
		4230
	],
	"./00003/00003-06/00003-06-09/intro.mp3": [
		660,
		7
	],
	"./00003/00003-06/00003-06-09/look at me.mp3": [
		5556,
		7,
		4231
	],
	"./00003/00003-06/00003-06-09/look at my dad.mp3": [
		5557,
		7,
		4232
	],
	"./00003/00003-06/00003-06-09/main idea.mp3": [
		1041,
		7
	],
	"./00003/00003-06/00003-06-09/mammals.mp3": [
		5558,
		7,
		4233
	],
	"./00003/00003-06/00003-06-09/module": [
		1470,
		9,
		334
	],
	"./00003/00003-06/00003-06-09/module.js": [
		1470,
		9,
		334
	],
	"./00003/00003-06/00003-06-09/my dad is a deer.mp3": [
		5559,
		7,
		4234
	],
	"./00003/00003-06/00003-06-09/my dad is a dinosaur.mp3": [
		5560,
		7,
		4235
	],
	"./00003/00003-06/00003-06-09/my dad is a dog.mp3": [
		5561,
		7,
		4236
	],
	"./00003/00003-06/00003-06-09/my dad is a pig.mp3": [
		5562,
		7,
		4237
	],
	"./00003/00003-06/00003-06-09/my dad is a rooster.mp3": [
		5563,
		7,
		4238
	],
	"./00003/00003-06/00003-06-09/my dad is a seahorse.mp3": [
		5564,
		7,
		4239
	],
	"./00003/00003-06/00003-06-09/my dad is an elephant.mp3": [
		5565,
		7,
		4240
	],
	"./00003/00003-06/00003-06-09/we are dinosaurs.mp3": [
		5566,
		7,
		4241
	],
	"./00003/00003-06/00003-06-09/we are pigs.mp3": [
		5567,
		7,
		4242
	],
	"./00003/00003-06/00003-06-10/0.jpg": [
		7021,
		7,
		5698
	],
	"./00003/00003-06/00003-06-10/1.jpg": [
		9610,
		7,
		9632
	],
	"./00003/00003-06/00003-06-10/2.jpg": [
		9611,
		7,
		9633
	],
	"./00003/00003-06/00003-06-10/3.jpg": [
		9612,
		7,
		9634
	],
	"./00003/00003-06/00003-06-10/4.jpg": [
		9613,
		7,
		9635
	],
	"./00003/00003-06/00003-06-10/5.jpg": [
		9614,
		7,
		9636
	],
	"./00003/00003-06/00003-06-10/6.jpg": [
		9615,
		7,
		9637
	],
	"./00003/00003-06/00003-06-10/7.jpg": [
		9616,
		7,
		9638
	],
	"./00003/00003-06/00003-06-10/can you see 3 boats.mp3": [
		5568,
		7,
		4243
	],
	"./00003/00003-06/00003-06-10/can you see 3 boxes.mp3": [
		5569,
		7,
		4244
	],
	"./00003/00003-06/00003-06-10/can you see 3 cakes.mp3": [
		5570,
		7,
		4245
	],
	"./00003/00003-06/00003-06-10/can you see 3 foxes.mp3": [
		5571,
		7,
		4246
	],
	"./00003/00003-06/00003-06-10/can you see 3 frogs.mp3": [
		5572,
		7,
		4247
	],
	"./00003/00003-06/00003-06-10/can you see 3 goats.mp3": [
		5573,
		7,
		4248
	],
	"./00003/00003-06/00003-06-10/can you see 3 hats.mp3": [
		5574,
		7,
		4249
	],
	"./00003/00003-06/00003-06-10/can you see 3 kittens.mp3": [
		5575,
		7,
		4250
	],
	"./00003/00003-06/00003-06-10/can you see 3 logs.mp3": [
		5576,
		7,
		4251
	],
	"./00003/00003-06/00003-06-10/can you see 3 mittens.mp3": [
		5577,
		7,
		4252
	],
	"./00003/00003-06/00003-06-10/can you see 3 nails.mp3": [
		5578,
		7,
		4253
	],
	"./00003/00003-06/00003-06-10/can you see 3 rats.mp3": [
		5579,
		7,
		4254
	],
	"./00003/00003-06/00003-06-10/can you see 3 snails.mp3": [
		5580,
		7,
		4255
	],
	"./00003/00003-06/00003-06-10/can you see 3 snakes.mp3": [
		5581,
		7,
		4256
	],
	"./00003/00003-06/00003-06-10/do they grow yes or no.mp3": [
		5582,
		7,
		4257
	],
	"./00003/00003-06/00003-06-10/do they grow.mp3": [
		5583,
		7,
		4258
	],
	"./00003/00003-06/00003-06-10/intro.mp3": [
		661,
		7
	],
	"./00003/00003-06/00003-06-10/living things.mp3": [
		5584,
		7,
		4259
	],
	"./00003/00003-06/00003-06-10/main idea.mp3": [
		1042,
		7
	],
	"./00003/00003-06/00003-06-10/module": [
		1471,
		9,
		335
	],
	"./00003/00003-06/00003-06-10/module.js": [
		1471,
		9,
		335
	],
	"./00003/00003-06/00003-06-10/non living things.mp3": [
		5585,
		7,
		4260
	],
	"./00003/00003-06/00003-06-10/the foxes grow.mp3": [
		5586,
		7,
		4261
	],
	"./00003/00003-06/00003-06-10/the frogs grow.mp3": [
		5587,
		7,
		4262
	],
	"./00003/00003-06/00003-06-10/the goats grow.mp3": [
		5588,
		7,
		4263
	],
	"./00003/00003-06/00003-06-10/the kittens grow.mp3": [
		5589,
		7,
		4264
	],
	"./00003/00003-06/00003-06-10/the rats grow.mp3": [
		5590,
		7,
		4265
	],
	"./00003/00003-06/00003-06-10/the snails grow.mp3": [
		5591,
		7,
		4266
	],
	"./00003/00003-06/00003-06-10/the snakes grow.mp3": [
		5592,
		7,
		4267
	],
	"./00003/00003-06/cover.jpg": [
		7022,
		7,
		5699
	],
	"./00003/00003-06/life science.mp3": [
		5593,
		7,
		4268
	],
	"./00003/00003-06/unit": [
		1472,
		9,
		336
	],
	"./00003/00003-06/unit.js": [
		1472,
		9,
		336
	],
	"./00003/00003-07/00003-07-01/0.jpg": [
		7023,
		7,
		5700
	],
	"./00003/00003-07/00003-07-01/1.jpg": [
		9617,
		7,
		9639
	],
	"./00003/00003-07/00003-07-01/2.jpg": [
		9618,
		7,
		9640
	],
	"./00003/00003-07/00003-07-01/3.jpg": [
		9619,
		7,
		9641
	],
	"./00003/00003-07/00003-07-01/4.jpg": [
		9620,
		7,
		9642
	],
	"./00003/00003-07/00003-07-01/5.jpg": [
		9621,
		7,
		9643
	],
	"./00003/00003-07/00003-07-01/6.jpg": [
		9622,
		7,
		9644
	],
	"./00003/00003-07/00003-07-01/7.jpg": [
		9623,
		7,
		9645
	],
	"./00003/00003-07/00003-07-01/big and little.mp3": [
		5594,
		7,
		4269
	],
	"./00003/00003-07/00003-07-01/big cars and buses go on the road.mp3": [
		5595,
		7,
		4270
	],
	"./00003/00003-07/00003-07-01/big planes and helicopters go up in the sky.mp3": [
		5596,
		7,
		4271
	],
	"./00003/00003-07/00003-07-01/i play with my car and my bus.mp3": [
		5597,
		7,
		4272
	],
	"./00003/00003-07/00003-07-01/i play with my helicopter and my plane.mp3": [
		5598,
		7,
		4273
	],
	"./00003/00003-07/00003-07-01/i play with my little trucks.mp3": [
		5599,
		7,
		4274
	],
	"./00003/00003-07/00003-07-01/i play with my monsters.mp3": [
		5600,
		7,
		4275
	],
	"./00003/00003-07/00003-07-01/intro.mp3": [
		662,
		7
	],
	"./00003/00003-07/00003-07-01/main idea.mp3": [
		1043,
		7
	],
	"./00003/00003-07/00003-07-01/module": [
		1473,
		9,
		337
	],
	"./00003/00003-07/00003-07-01/module.js": [
		1473,
		9,
		337
	],
	"./00003/00003-07/00003-07-01/my bus is little.mp3": [
		5601,
		7,
		4276
	],
	"./00003/00003-07/00003-07-01/my car is little.mp3": [
		5602,
		7,
		4277
	],
	"./00003/00003-07/00003-07-01/my dump truck is little.mp3": [
		5603,
		7,
		4278
	],
	"./00003/00003-07/00003-07-01/my fire truck is little.mp3": [
		5604,
		7,
		4279
	],
	"./00003/00003-07/00003-07-01/my green monster is little.mp3": [
		5605,
		7,
		4280
	],
	"./00003/00003-07/00003-07-01/my helicopter is little.mp3": [
		5606,
		7,
		4281
	],
	"./00003/00003-07/00003-07-01/my plane is little.mp3": [
		5607,
		7,
		4282
	],
	"./00003/00003-07/00003-07-01/my red monster is big.mp3": [
		5608,
		7,
		4283
	],
	"./00003/00003-07/00003-07-01/the big trucks go on the road.mp3": [
		5609,
		7,
		4284
	],
	"./00003/00003-07/00003-07-01/this bus is big.mp3": [
		5610,
		7,
		4285
	],
	"./00003/00003-07/00003-07-01/this car is big.mp3": [
		5611,
		7,
		4286
	],
	"./00003/00003-07/00003-07-01/this dump truck is big.mp3": [
		5612,
		7,
		4287
	],
	"./00003/00003-07/00003-07-01/this fire truck is big.mp3": [
		5613,
		7,
		4288
	],
	"./00003/00003-07/00003-07-01/this helicopter is big.mp3": [
		5614,
		7,
		4289
	],
	"./00003/00003-07/00003-07-01/this plane is big.mp3": [
		5615,
		7,
		4290
	],
	"./00003/00003-07/00003-07-01/vehicles.mp3": [
		5616,
		7,
		4291
	],
	"./00003/00003-07/00003-07-02/0.jpg": [
		7024,
		7,
		5701
	],
	"./00003/00003-07/00003-07-02/1.jpg": [
		9624,
		7,
		9646
	],
	"./00003/00003-07/00003-07-02/2.jpg": [
		9625,
		7,
		9647
	],
	"./00003/00003-07/00003-07-02/3.jpg": [
		9626,
		7,
		9648
	],
	"./00003/00003-07/00003-07-02/4.jpg": [
		9627,
		7,
		9649
	],
	"./00003/00003-07/00003-07-02/5.jpg": [
		9628,
		7,
		9650
	],
	"./00003/00003-07/00003-07-02/6.jpg": [
		9629,
		7,
		9651
	],
	"./00003/00003-07/00003-07-02/7.jpg": [
		9630,
		7,
		9652
	],
	"./00003/00003-07/00003-07-02/electricity.mp3": [
		5617,
		7,
		4292
	],
	"./00003/00003-07/00003-07-02/intro.mp3": [
		663,
		7
	],
	"./00003/00003-07/00003-07-02/look at the computer.mp3": [
		5618,
		7,
		4293
	],
	"./00003/00003-07/00003-07-02/look at the fan.mp3": [
		5619,
		7,
		4294
	],
	"./00003/00003-07/00003-07-02/look at the fridge.mp3": [
		5620,
		7,
		4295
	],
	"./00003/00003-07/00003-07-02/look at the guitar.mp3": [
		5621,
		7,
		4296
	],
	"./00003/00003-07/00003-07-02/look at the light.mp3": [
		5622,
		7,
		4297
	],
	"./00003/00003-07/00003-07-02/look at the stove.mp3": [
		5623,
		7,
		4298
	],
	"./00003/00003-07/00003-07-02/look at the television.mp3": [
		5624,
		7,
		4299
	],
	"./00003/00003-07/00003-07-02/main idea.mp3": [
		1044,
		7
	],
	"./00003/00003-07/00003-07-02/module": [
		1474,
		9,
		338
	],
	"./00003/00003-07/00003-07-02/module.js": [
		1474,
		9,
		338
	],
	"./00003/00003-07/00003-07-02/the computer is on.mp3": [
		5625,
		7,
		4300
	],
	"./00003/00003-07/00003-07-02/the computer uses electricity.mp3": [
		5626,
		7,
		4301
	],
	"./00003/00003-07/00003-07-02/the fan is not on.mp3": [
		5627,
		7,
		4302
	],
	"./00003/00003-07/00003-07-02/the fan uses electricity.mp3": [
		5628,
		7,
		4303
	],
	"./00003/00003-07/00003-07-02/the fridge is not on.mp3": [
		5629,
		7,
		4304
	],
	"./00003/00003-07/00003-07-02/the fridge uses electricity.mp3": [
		5630,
		7,
		4305
	],
	"./00003/00003-07/00003-07-02/the guitar is rocking on.mp3": [
		5631,
		7,
		4306
	],
	"./00003/00003-07/00003-07-02/the guitar uses electricity.mp3": [
		5632,
		7,
		4307
	],
	"./00003/00003-07/00003-07-02/the light is on.mp3": [
		5633,
		7,
		4308
	],
	"./00003/00003-07/00003-07-02/the light uses electricity.mp3": [
		5634,
		7,
		4309
	],
	"./00003/00003-07/00003-07-02/the stove is not on.mp3": [
		5635,
		7,
		4310
	],
	"./00003/00003-07/00003-07-02/the stove uses electricity.mp3": [
		5636,
		7,
		4311
	],
	"./00003/00003-07/00003-07-02/the television is on.mp3": [
		5637,
		7,
		4312
	],
	"./00003/00003-07/00003-07-02/the television uses electricity.mp3": [
		5638,
		7,
		4313
	],
	"./00003/00003-07/00003-07-02/things that use electricity.mp3": [
		5639,
		7,
		4314
	],
	"./00003/00003-07/00003-07-03/0.jpg": [
		7025,
		7,
		5702
	],
	"./00003/00003-07/00003-07-03/1.jpg": [
		9631,
		7,
		9653
	],
	"./00003/00003-07/00003-07-03/2.jpg": [
		9632,
		7,
		9654
	],
	"./00003/00003-07/00003-07-03/3.jpg": [
		9633,
		7,
		9655
	],
	"./00003/00003-07/00003-07-03/4.jpg": [
		9634,
		7,
		9656
	],
	"./00003/00003-07/00003-07-03/5.jpg": [
		9635,
		7,
		9657
	],
	"./00003/00003-07/00003-07-03/6.jpg": [
		9636,
		7,
		9658
	],
	"./00003/00003-07/00003-07-03/7.jpg": [
		9637,
		7,
		9659
	],
	"./00003/00003-07/00003-07-03/bear is playing the guitar.mp3": [
		5640,
		7,
		4315
	],
	"./00003/00003-07/00003-07-03/dog is playing the tambourine.mp3": [
		5641,
		7,
		4316
	],
	"./00003/00003-07/00003-07-03/donkey is playing the harp.mp3": [
		5642,
		7,
		4317
	],
	"./00003/00003-07/00003-07-03/elephant is playing the cymbals.mp3": [
		5643,
		7,
		4318
	],
	"./00003/00003-07/00003-07-03/intro.mp3": [
		664,
		7
	],
	"./00003/00003-07/00003-07-03/listen to the music.mp3": [
		5644,
		7,
		4319
	],
	"./00003/00003-07/00003-07-03/loud and soft.mp3": [
		5645,
		7,
		4320
	],
	"./00003/00003-07/00003-07-03/main idea.mp3": [
		1045,
		7
	],
	"./00003/00003-07/00003-07-03/module": [
		1475,
		9,
		339
	],
	"./00003/00003-07/00003-07-03/module.js": [
		1475,
		9,
		339
	],
	"./00003/00003-07/00003-07-03/monkey is playing the triangle.mp3": [
		5646,
		7,
		4321
	],
	"./00003/00003-07/00003-07-03/musical instruments.mp3": [
		5647,
		7,
		4322
	],
	"./00003/00003-07/00003-07-03/rabbit is playing the drum.mp3": [
		5648,
		7,
		4323
	],
	"./00003/00003-07/00003-07-03/raccoon is playing the banjo.mp3": [
		5649,
		7,
		4324
	],
	"./00003/00003-07/00003-07-03/racoon is playing the banjo.mp3": [
		5650,
		7,
		4325
	],
	"./00003/00003-07/00003-07-03/the banjo is loud.mp3": [
		5651,
		7,
		4326
	],
	"./00003/00003-07/00003-07-03/the cymbals are loud.mp3": [
		5652,
		7,
		4327
	],
	"./00003/00003-07/00003-07-03/the drum is loud.mp3": [
		5653,
		7,
		4328
	],
	"./00003/00003-07/00003-07-03/the guitar is loud.mp3": [
		5654,
		7,
		4329
	],
	"./00003/00003-07/00003-07-03/the harp is soft.mp3": [
		5655,
		7,
		4330
	],
	"./00003/00003-07/00003-07-03/the tambourine is soft.mp3": [
		5656,
		7,
		4331
	],
	"./00003/00003-07/00003-07-03/the triangle is soft.mp3": [
		5657,
		7,
		4332
	],
	"./00003/00003-07/00003-07-04/0.jpg": [
		7026,
		7,
		5703
	],
	"./00003/00003-07/00003-07-04/1.jpg": [
		9638,
		7,
		9660
	],
	"./00003/00003-07/00003-07-04/2.jpg": [
		9639,
		7,
		9661
	],
	"./00003/00003-07/00003-07-04/3.jpg": [
		9640,
		7,
		9662
	],
	"./00003/00003-07/00003-07-04/4.jpg": [
		9641,
		7,
		9663
	],
	"./00003/00003-07/00003-07-04/5.jpg": [
		9642,
		7,
		9664
	],
	"./00003/00003-07/00003-07-04/6.jpg": [
		9643,
		7,
		9665
	],
	"./00003/00003-07/00003-07-04/7.jpg": [
		9644,
		7,
		9666
	],
	"./00003/00003-07/00003-07-04/deer goes up in the pulley.mp3": [
		5658,
		7,
		4333
	],
	"./00003/00003-07/00003-07-04/elephant goes down in the pulley.mp3": [
		5659,
		7,
		4334
	],
	"./00003/00003-07/00003-07-04/elephant goes up in the pulley.mp3": [
		5660,
		7,
		4335
	],
	"./00003/00003-07/00003-07-04/he goes up and up.mp3": [
		5661,
		7,
		4336
	],
	"./00003/00003-07/00003-07-04/intro.mp3": [
		665,
		7
	],
	"./00003/00003-07/00003-07-04/lion goes up in the pulley.mp3": [
		5662,
		7,
		4337
	],
	"./00003/00003-07/00003-07-04/main idea.mp3": [
		1046,
		7
	],
	"./00003/00003-07/00003-07-04/module": [
		1476,
		9,
		340
	],
	"./00003/00003-07/00003-07-04/module.js": [
		1476,
		9,
		340
	],
	"./00003/00003-07/00003-07-04/oh no.mp3": [
		5663,
		7,
		4338
	],
	"./00003/00003-07/00003-07-04/panda and skunk go up.mp3": [
		5664,
		7,
		4339
	],
	"./00003/00003-07/00003-07-04/panda goes up in the pulley.mp3": [
		5665,
		7,
		4340
	],
	"./00003/00003-07/00003-07-04/she pulls and pulls and pulls.mp3": [
		5666,
		7,
		4341
	],
	"./00003/00003-07/00003-07-04/she pulls and pulls.mp3": [
		5667,
		7,
		4342
	],
	"./00003/00003-07/00003-07-04/skunk goes up in the pulley.mp3": [
		5668,
		7,
		4343
	],
	"./00003/00003-07/00003-07-04/squirrel lets go.mp3": [
		5669,
		7,
		4344
	],
	"./00003/00003-07/00003-07-04/squirrel pulls hard.mp3": [
		5670,
		7,
		4345
	],
	"./00003/00003-07/00003-07-04/squirrel pulls the animals up in the pulley.mp3": [
		5671,
		7,
		4346
	],
	"./00003/00003-07/00003-07-04/tiger goes up in the pulley.mp3": [
		5672,
		7,
		4347
	],
	"./00003/00003-07/00003-07-04/up in the pulley.mp3": [
		5673,
		7,
		4348
	],
	"./00003/00003-07/00003-07-04/who else goes up in the pulley.mp3": [
		5674,
		7,
		4349
	],
	"./00003/00003-07/00003-07-04/wild animals.mp3": [
		5675,
		7,
		4350
	],
	"./00003/00003-07/00003-07-05/0.jpg": [
		7027,
		7,
		5704
	],
	"./00003/00003-07/00003-07-05/1.jpg": [
		9645,
		7,
		9667
	],
	"./00003/00003-07/00003-07-05/2.jpg": [
		9646,
		7,
		9668
	],
	"./00003/00003-07/00003-07-05/3.jpg": [
		9647,
		7,
		9669
	],
	"./00003/00003-07/00003-07-05/4.jpg": [
		9648,
		7,
		9670
	],
	"./00003/00003-07/00003-07-05/5.jpg": [
		9649,
		7,
		9671
	],
	"./00003/00003-07/00003-07-05/6.jpg": [
		9650,
		7,
		9672
	],
	"./00003/00003-07/00003-07-05/7.jpg": [
		9651,
		7,
		9673
	],
	"./00003/00003-07/00003-07-05/intro.mp3": [
		666,
		7
	],
	"./00003/00003-07/00003-07-05/it will go down.mp3": [
		5676,
		7,
		4351
	],
	"./00003/00003-07/00003-07-05/it will go go go.mp3": [
		5677,
		7,
		4352
	],
	"./00003/00003-07/00003-07-05/it will go up.mp3": [
		5678,
		7,
		4353
	],
	"./00003/00003-07/00003-07-05/main idea.mp3": [
		1047,
		7
	],
	"./00003/00003-07/00003-07-05/module": [
		1477,
		9,
		341
	],
	"./00003/00003-07/00003-07-05/module.js": [
		1477,
		9,
		341
	],
	"./00003/00003-07/00003-07-05/the ball will move.mp3": [
		5679,
		7,
		4354
	],
	"./00003/00003-07/00003-07-05/the car will move.mp3": [
		5680,
		7,
		4355
	],
	"./00003/00003-07/00003-07-05/the swing will move.mp3": [
		5681,
		7,
		4356
	],
	"./00003/00003-07/00003-07-05/the swing will not move.mp3": [
		5682,
		7,
		4357
	],
	"./00003/00003-07/00003-07-05/the truck will move.mp3": [
		5683,
		7,
		4358
	],
	"./00003/00003-07/00003-07-05/the truck will not move.mp3": [
		5684,
		7,
		4359
	],
	"./00003/00003-07/00003-07-05/toys.mp3": [
		5685,
		7,
		4360
	],
	"./00003/00003-07/00003-07-05/what will make it move.mp3": [
		5686,
		7,
		4361
	],
	"./00003/00003-07/00003-07-05/will it move.mp3": [
		5687,
		7,
		4362
	],
	"./00003/00003-07/00003-07-06/0.jpg": [
		7028,
		7,
		5705
	],
	"./00003/00003-07/00003-07-06/1.jpg": [
		9652,
		7,
		9674
	],
	"./00003/00003-07/00003-07-06/2.jpg": [
		9653,
		7,
		9675
	],
	"./00003/00003-07/00003-07-06/3.jpg": [
		9654,
		7,
		9676
	],
	"./00003/00003-07/00003-07-06/4.jpg": [
		9655,
		7,
		9677
	],
	"./00003/00003-07/00003-07-06/5.jpg": [
		9656,
		7,
		9678
	],
	"./00003/00003-07/00003-07-06/6.jpg": [
		9657,
		7,
		9679
	],
	"./00003/00003-07/00003-07-06/7.jpg": [
		9658,
		7,
		9680
	],
	"./00003/00003-07/00003-07-06/i can see the nail.mp3": [
		5688,
		7,
		4363
	],
	"./00003/00003-07/00003-07-06/intro.mp3": [
		667,
		7
	],
	"./00003/00003-07/00003-07-06/look at the apple.mp3": [
		5689,
		7,
		4364
	],
	"./00003/00003-07/00003-07-06/look at the ball.mp3": [
		5690,
		7,
		4365
	],
	"./00003/00003-07/00003-07-06/look at the boat.mp3": [
		5691,
		7,
		4366
	],
	"./00003/00003-07/00003-07-06/look at the cube.mp3": [
		5692,
		7,
		4367
	],
	"./00003/00003-07/00003-07-06/look at the duck.mp3": [
		5693,
		7,
		4368
	],
	"./00003/00003-07/00003-07-06/look at the key.mp3": [
		5694,
		7,
		4369
	],
	"./00003/00003-07/00003-07-06/look.mp3": [
		5695,
		7,
		4370
	],
	"./00003/00003-07/00003-07-06/main idea.mp3": [
		1048,
		7
	],
	"./00003/00003-07/00003-07-06/module": [
		1478,
		9,
		342
	],
	"./00003/00003-07/00003-07-06/module.js": [
		1478,
		9,
		342
	],
	"./00003/00003-07/00003-07-06/no.mp3": [
		5696,
		7,
		4371
	],
	"./00003/00003-07/00003-07-06/the apple floats.mp3": [
		5697,
		7,
		4372
	],
	"./00003/00003-07/00003-07-06/the ball floats.mp3": [
		5698,
		7,
		4373
	],
	"./00003/00003-07/00003-07-06/the boat floats.mp3": [
		5699,
		7,
		4374
	],
	"./00003/00003-07/00003-07-06/the cube floats.mp3": [
		5700,
		7,
		4375
	],
	"./00003/00003-07/00003-07-06/the duck floats too.mp3": [
		5701,
		7,
		4376
	],
	"./00003/00003-07/00003-07-06/the key sinks.mp3": [
		5702,
		7,
		4377
	],
	"./00003/00003-07/00003-07-06/the nail sinks.mp3": [
		5703,
		7,
		4378
	],
	"./00003/00003-07/00003-07-06/things that float.mp3": [
		5704,
		7,
		4379
	],
	"./00003/00003-07/00003-07-06/things that sink.mp3": [
		5705,
		7,
		4380
	],
	"./00003/00003-07/00003-07-06/will it float.mp3": [
		5706,
		7,
		4381
	],
	"./00003/00003-07/00003-07-06/will it sink.mp3": [
		5707,
		7,
		4382
	],
	"./00003/00003-07/00003-07-06/yes.mp3": [
		5708,
		7,
		4383
	],
	"./00003/00003-07/00003-07-07/0.jpg": [
		7029,
		7,
		5706
	],
	"./00003/00003-07/00003-07-07/1.jpg": [
		9659,
		7,
		9681
	],
	"./00003/00003-07/00003-07-07/2.jpg": [
		9660,
		7,
		9682
	],
	"./00003/00003-07/00003-07-07/3.jpg": [
		9661,
		7,
		9683
	],
	"./00003/00003-07/00003-07-07/4.jpg": [
		9662,
		7,
		9684
	],
	"./00003/00003-07/00003-07-07/5.jpg": [
		9663,
		7,
		9685
	],
	"./00003/00003-07/00003-07-07/6.jpg": [
		9664,
		7,
		9686
	],
	"./00003/00003-07/00003-07-07/7.jpg": [
		9665,
		7,
		9687
	],
	"./00003/00003-07/00003-07-07/fishing with a magnet.mp3": [
		5709,
		7,
		4384
	],
	"./00003/00003-07/00003-07-07/intro.mp3": [
		668,
		7
	],
	"./00003/00003-07/00003-07-07/it is made of metal.mp3": [
		5710,
		7,
		4385
	],
	"./00003/00003-07/00003-07-07/look at the anchor.mp3": [
		5711,
		7,
		4386
	],
	"./00003/00003-07/00003-07-07/look at the ball.mp3": [
		5712,
		7,
		4387
	],
	"./00003/00003-07/00003-07-07/look at the car.mp3": [
		5713,
		7,
		4388
	],
	"./00003/00003-07/00003-07-07/look at the chipmunk.mp3": [
		5714,
		7,
		4389
	],
	"./00003/00003-07/00003-07-07/look at the deer.mp3": [
		5715,
		7,
		4390
	],
	"./00003/00003-07/00003-07-07/look at the fox.mp3": [
		5716,
		7,
		4391
	],
	"./00003/00003-07/00003-07-07/look at the helicopter.mp3": [
		5717,
		7,
		4392
	],
	"./00003/00003-07/00003-07-07/look at the lion.mp3": [
		5718,
		7,
		4393
	],
	"./00003/00003-07/00003-07-07/look at the rocket.mp3": [
		5719,
		7,
		4394
	],
	"./00003/00003-07/00003-07-07/look at the sheep.mp3": [
		5720,
		7,
		4395
	],
	"./00003/00003-07/00003-07-07/look at the squirrel.mp3": [
		5721,
		7,
		4396
	],
	"./00003/00003-07/00003-07-07/look at the tiger.mp3": [
		5722,
		7,
		4397
	],
	"./00003/00003-07/00003-07-07/made.mp3": [
		5723,
		7,
		4398
	],
	"./00003/00003-07/00003-07-07/magnet.mp3": [
		5724,
		7,
		4399
	],
	"./00003/00003-07/00003-07-07/magnets.mp3": [
		5725,
		7,
		4400
	],
	"./00003/00003-07/00003-07-07/main idea.mp3": [
		1049,
		7
	],
	"./00003/00003-07/00003-07-07/metal.mp3": [
		5726,
		7,
		4401
	],
	"./00003/00003-07/00003-07-07/module": [
		1479,
		9,
		343
	],
	"./00003/00003-07/00003-07-07/module.js": [
		1479,
		9,
		343
	],
	"./00003/00003-07/00003-07-07/the chipmunk got a nail.mp3": [
		5727,
		7,
		4402
	],
	"./00003/00003-07/00003-07-07/the deer got a helicopter.mp3": [
		5728,
		7,
		4403
	],
	"./00003/00003-07/00003-07-07/the fox got a magnet.mp3": [
		5729,
		7,
		4404
	],
	"./00003/00003-07/00003-07-07/the lion got a rocket.mp3": [
		5730,
		7,
		4405
	],
	"./00003/00003-07/00003-07-07/the sheep got an anchor.mp3": [
		5731,
		7,
		4406
	],
	"./00003/00003-07/00003-07-07/the squirrel got a ball.mp3": [
		5732,
		7,
		4407
	],
	"./00003/00003-07/00003-07-07/the tiger got a car.mp3": [
		5733,
		7,
		4408
	],
	"./00003/00003-07/00003-07-07/things made of metal.mp3": [
		5734,
		7,
		4409
	],
	"./00003/00003-07/00003-07-08/0.jpg": [
		7030,
		7,
		5707
	],
	"./00003/00003-07/00003-07-08/1.jpg": [
		9666,
		7,
		9688
	],
	"./00003/00003-07/00003-07-08/2.jpg": [
		9667,
		7,
		9689
	],
	"./00003/00003-07/00003-07-08/3.jpg": [
		9668,
		7,
		9690
	],
	"./00003/00003-07/00003-07-08/4.jpg": [
		9669,
		7,
		9691
	],
	"./00003/00003-07/00003-07-08/5.jpg": [
		9670,
		7,
		9692
	],
	"./00003/00003-07/00003-07-08/6.jpg": [
		9671,
		7,
		9693
	],
	"./00003/00003-07/00003-07-08/7.jpg": [
		9672,
		7,
		9694
	],
	"./00003/00003-07/00003-07-08/here comes the motorcycle.mp3": [
		5735,
		7,
		4410
	],
	"./00003/00003-07/00003-07-08/here comes the plane.mp3": [
		5736,
		7,
		4411
	],
	"./00003/00003-07/00003-07-08/here comes the train.mp3": [
		5737,
		7,
		4412
	],
	"./00003/00003-07/00003-07-08/here is a car.mp3": [
		5738,
		7,
		4413
	],
	"./00003/00003-07/00003-07-08/here is a dump truck.mp3": [
		5739,
		7,
		4414
	],
	"./00003/00003-07/00003-07-08/intro.mp3": [
		669,
		7
	],
	"./00003/00003-07/00003-07-08/look at the bus.mp3": [
		5740,
		7,
		4415
	],
	"./00003/00003-07/00003-07-08/look at the unicycle.mp3": [
		5741,
		7,
		4416
	],
	"./00003/00003-07/00003-07-08/main idea.mp3": [
		1050,
		7
	],
	"./00003/00003-07/00003-07-08/module": [
		1480,
		9,
		344
	],
	"./00003/00003-07/00003-07-08/module.js": [
		1480,
		9,
		344
	],
	"./00003/00003-07/00003-07-08/the bus has six wheels.mp3": [
		5742,
		7,
		4417
	],
	"./00003/00003-07/00003-07-08/the car has four wheels.mp3": [
		5743,
		7,
		4418
	],
	"./00003/00003-07/00003-07-08/the car truck has four wheels.mp3": [
		5744,
		7,
		4419
	],
	"./00003/00003-07/00003-07-08/the dump truck has four wheels.mp3": [
		5745,
		7,
		4420
	],
	"./00003/00003-07/00003-07-08/the motorcycle has two wheels.mp3": [
		5746,
		7,
		4421
	],
	"./00003/00003-07/00003-07-08/the plane has three wheels.mp3": [
		5747,
		7,
		4422
	],
	"./00003/00003-07/00003-07-08/the train has eight wheels.mp3": [
		5748,
		7,
		4423
	],
	"./00003/00003-07/00003-07-08/the unicycle has one wheel.mp3": [
		5749,
		7,
		4424
	],
	"./00003/00003-07/00003-07-08/vehicles.mp3": [
		5750,
		7,
		4425
	],
	"./00003/00003-07/00003-07-08/wheels make things go.mp3": [
		5751,
		7,
		4426
	],
	"./00003/00003-07/00003-07-08/wheels.mp3": [
		5752,
		7,
		4427
	],
	"./00003/00003-07/00003-07-09/0.jpg": [
		7031,
		7,
		5708
	],
	"./00003/00003-07/00003-07-09/1.jpg": [
		9673,
		7,
		9695
	],
	"./00003/00003-07/00003-07-09/2.jpg": [
		9674,
		7,
		9696
	],
	"./00003/00003-07/00003-07-09/3.jpg": [
		9675,
		7,
		9697
	],
	"./00003/00003-07/00003-07-09/4.jpg": [
		9676,
		7,
		9698
	],
	"./00003/00003-07/00003-07-09/5.jpg": [
		9677,
		7,
		9699
	],
	"./00003/00003-07/00003-07-09/6.jpg": [
		9678,
		7,
		9700
	],
	"./00003/00003-07/00003-07-09/7.jpg": [
		9679,
		7,
		9701
	],
	"./00003/00003-07/00003-07-09/here is saturn.mp3": [
		5753,
		7,
		4428
	],
	"./00003/00003-07/00003-07-09/i can see the iceberg.mp3": [
		5754,
		7,
		4429
	],
	"./00003/00003-07/00003-07-09/i see a fire.mp3": [
		5755,
		7,
		4430
	],
	"./00003/00003-07/00003-07-09/i see a fox.mp3": [
		5756,
		7,
		4431
	],
	"./00003/00003-07/00003-07-09/i see the sun.mp3": [
		5757,
		7,
		4432
	],
	"./00003/00003-07/00003-07-09/i see the volcano.mp3": [
		5758,
		7,
		4433
	],
	"./00003/00003-07/00003-07-09/intro.mp3": [
		670,
		7
	],
	"./00003/00003-07/00003-07-09/is it cold.mp3": [
		5759,
		7,
		4434
	],
	"./00003/00003-07/00003-07-09/is it hot is it cold.mp3": [
		5760,
		7,
		4435
	],
	"./00003/00003-07/00003-07-09/is it hot or cold.mp3": [
		5761,
		7,
		4436
	],
	"./00003/00003-07/00003-07-09/is it hot.mp3": [
		5762,
		7,
		4437
	],
	"./00003/00003-07/00003-07-09/look at the fridge.mp3": [
		5763,
		7,
		4438
	],
	"./00003/00003-07/00003-07-09/look at the stove.mp3": [
		5764,
		7,
		4439
	],
	"./00003/00003-07/00003-07-09/main idea.mp3": [
		1051,
		7
	],
	"./00003/00003-07/00003-07-09/module": [
		1481,
		9,
		345
	],
	"./00003/00003-07/00003-07-09/module.js": [
		1481,
		9,
		345
	],
	"./00003/00003-07/00003-07-09/non living things.mp3": [
		5765,
		7,
		4440
	],
	"./00003/00003-07/00003-07-09/saturn is cold.mp3": [
		5766,
		7,
		4441
	],
	"./00003/00003-07/00003-07-09/the fire is hot.mp3": [
		5767,
		7,
		4442
	],
	"./00003/00003-07/00003-07-09/the fridge is cold.mp3": [
		5768,
		7,
		4443
	],
	"./00003/00003-07/00003-07-09/the iceberg is cold.mp3": [
		5769,
		7,
		4444
	],
	"./00003/00003-07/00003-07-09/the stove is hot.mp3": [
		5770,
		7,
		4445
	],
	"./00003/00003-07/00003-07-09/the sun is hot.mp3": [
		5771,
		7,
		4446
	],
	"./00003/00003-07/00003-07-09/the volcano is hot.mp3": [
		5772,
		7,
		4447
	],
	"./00003/00003-07/00003-07-10/0.jpg": [
		7032,
		7,
		5709
	],
	"./00003/00003-07/00003-07-10/1.jpg": [
		9680,
		7,
		9702
	],
	"./00003/00003-07/00003-07-10/2.jpg": [
		9681,
		7,
		9703
	],
	"./00003/00003-07/00003-07-10/3.jpg": [
		9682,
		7,
		9704
	],
	"./00003/00003-07/00003-07-10/4.jpg": [
		9683,
		7,
		9705
	],
	"./00003/00003-07/00003-07-10/5.jpg": [
		9684,
		7,
		9706
	],
	"./00003/00003-07/00003-07-10/6.jpg": [
		9685,
		7,
		9707
	],
	"./00003/00003-07/00003-07-10/7.jpg": [
		9686,
		7,
		9708
	],
	"./00003/00003-07/00003-07-10/big things.mp3": [
		5773,
		7,
		4448
	],
	"./00003/00003-07/00003-07-10/here comes the car.mp3": [
		5774,
		7,
		4449
	],
	"./00003/00003-07/00003-07-10/here comes the fire truck.mp3": [
		5775,
		7,
		4450
	],
	"./00003/00003-07/00003-07-10/here comes the plane.mp3": [
		5776,
		7,
		4451
	],
	"./00003/00003-07/00003-07-10/here is a car.mp3": [
		5777,
		7,
		4452
	],
	"./00003/00003-07/00003-07-10/here is a dump truck.mp3": [
		5778,
		7,
		4453
	],
	"./00003/00003-07/00003-07-10/here is a helicopter.mp3": [
		5779,
		7,
		4454
	],
	"./00003/00003-07/00003-07-10/here is a monster.mp3": [
		5780,
		7,
		4455
	],
	"./00003/00003-07/00003-07-10/i like the monster.mp3": [
		5781,
		7,
		4456
	],
	"./00003/00003-07/00003-07-10/intro.mp3": [
		671,
		7
	],
	"./00003/00003-07/00003-07-10/look at the bus.mp3": [
		5782,
		7,
		4457
	],
	"./00003/00003-07/00003-07-10/main idea.mp3": [
		1052,
		7
	],
	"./00003/00003-07/00003-07-10/module": [
		1482,
		9,
		346
	],
	"./00003/00003-07/00003-07-10/module.js": [
		1482,
		9,
		346
	],
	"./00003/00003-07/00003-07-10/my red monster is big.mp3": [
		5783,
		7,
		4458
	],
	"./00003/00003-07/00003-07-10/the fire truck is red.mp3": [
		5784,
		7,
		4459
	],
	"./00003/00003-07/00003-07-10/the helicopter is red.mp3": [
		5785,
		7,
		4460
	],
	"./00003/00003-07/00003-07-10/the plane is red.mp3": [
		5786,
		7,
		4461
	],
	"./00003/00003-07/00003-07-10/this bus is big.mp3": [
		5787,
		7,
		4462
	],
	"./00003/00003-07/00003-07-10/this car is big.mp3": [
		5788,
		7,
		4463
	],
	"./00003/00003-07/00003-07-10/this dinosaur is huge.mp3": [
		5789,
		7,
		4464
	],
	"./00003/00003-07/00003-07-10/this dump truck is big.mp3": [
		5790,
		7,
		4465
	],
	"./00003/00003-07/00003-07-10/this fire truck is big.mp3": [
		5791,
		7,
		4466
	],
	"./00003/00003-07/00003-07-10/this giraffe is big.mp3": [
		5792,
		7,
		4467
	],
	"./00003/00003-07/00003-07-10/this helicopter is big.mp3": [
		5793,
		7,
		4468
	],
	"./00003/00003-07/00003-07-10/this monster is big.mp3": [
		5794,
		7,
		4469
	],
	"./00003/00003-07/00003-07-10/this plane is big.mp3": [
		5795,
		7,
		4470
	],
	"./00003/00003-07/00003-07-10/this whale is big.mp3": [
		5796,
		7,
		4471
	],
	"./00003/00003-07/00003-07-10/this whale shark is big.mp3": [
		5797,
		7,
		4472
	],
	"./00003/00003-07/00003-07-10/vehicles.mp3": [
		5798,
		7,
		4473
	],
	"./00003/00003-07/cover.jpg": [
		7033,
		7,
		5710
	],
	"./00003/00003-07/physical science.mp3": [
		5799,
		7,
		4474
	],
	"./00003/00003-07/unit": [
		1483,
		9,
		347
	],
	"./00003/00003-07/unit.js": [
		1483,
		9,
		347
	],
	"./00003/00003-08/00003-08-01/0.jpg": [
		7034,
		7,
		5711
	],
	"./00003/00003-08/00003-08-01/1.jpg": [
		9687,
		7,
		9709
	],
	"./00003/00003-08/00003-08-01/2.jpg": [
		9688,
		7,
		9710
	],
	"./00003/00003-08/00003-08-01/3.jpg": [
		9689,
		7,
		9711
	],
	"./00003/00003-08/00003-08-01/4.jpg": [
		9690,
		7,
		9712
	],
	"./00003/00003-08/00003-08-01/5.jpg": [
		9691,
		7,
		9713
	],
	"./00003/00003-08/00003-08-01/6.jpg": [
		9692,
		7,
		9714
	],
	"./00003/00003-08/00003-08-01/7.jpg": [
		9693,
		7,
		9715
	],
	"./00003/00003-08/00003-08-01/i love the mountains said the goat.mp3": [
		5800,
		7,
		4475
	],
	"./00003/00003-08/00003-08-01/i love the sea said the whale.mp3": [
		5801,
		7,
		4476
	],
	"./00003/00003-08/00003-08-01/intro.mp3": [
		672,
		7
	],
	"./00003/00003-08/00003-08-01/main idea.mp3": [
		1053,
		7
	],
	"./00003/00003-08/00003-08-01/module": [
		1484,
		9,
		348
	],
	"./00003/00003-08/00003-08-01/module.js": [
		1484,
		9,
		348
	],
	"./00003/00003-08/00003-08-01/the earth is our home too said the kids.mp3": [
		5802,
		7,
		4477
	],
	"./00003/00003-08/00003-08-01/the earth is our home.mp3": [
		5803,
		7,
		4478
	],
	"./00003/00003-08/00003-08-01/the forest is our home said the foxes.mp3": [
		5804,
		7,
		4479
	],
	"./00003/00003-08/00003-08-01/the lake is our home said the birds.mp3": [
		5805,
		7,
		4480
	],
	"./00003/00003-08/00003-08-01/the mountains are my home.mp3": [
		5806,
		7,
		4481
	],
	"./00003/00003-08/00003-08-01/the river is our home.mp3": [
		5807,
		7,
		4482
	],
	"./00003/00003-08/00003-08-01/the sea is my home.mp3": [
		5808,
		7,
		4483
	],
	"./00003/00003-08/00003-08-01/things on the earth.mp3": [
		5809,
		7,
		4484
	],
	"./00003/00003-08/00003-08-01/we love the earth said the animals.mp3": [
		5810,
		7,
		4485
	],
	"./00003/00003-08/00003-08-01/we love the earth.mp3": [
		5811,
		7,
		4486
	],
	"./00003/00003-08/00003-08-01/we love the forest.mp3": [
		5812,
		7,
		4487
	],
	"./00003/00003-08/00003-08-01/we love the lake.mp3": [
		5813,
		7,
		4488
	],
	"./00003/00003-08/00003-08-01/we love the river said the ducks.mp3": [
		5814,
		7,
		4489
	],
	"./00003/00003-08/00003-08-02/0.jpg": [
		7035,
		7,
		5712
	],
	"./00003/00003-08/00003-08-02/1.jpg": [
		9694,
		7,
		9716
	],
	"./00003/00003-08/00003-08-02/2.jpg": [
		9695,
		7,
		9717
	],
	"./00003/00003-08/00003-08-02/3.jpg": [
		9696,
		7,
		9718
	],
	"./00003/00003-08/00003-08-02/4.jpg": [
		9697,
		7,
		9719
	],
	"./00003/00003-08/00003-08-02/5.jpg": [
		9698,
		7,
		9720
	],
	"./00003/00003-08/00003-08-02/6.jpg": [
		9699,
		7,
		9721
	],
	"./00003/00003-08/00003-08-02/7.jpg": [
		9700,
		7,
		9722
	],
	"./00003/00003-08/00003-08-02/earth goes around the sun.mp3": [
		5815,
		7,
		4490
	],
	"./00003/00003-08/00003-08-02/earth is a small planet.mp3": [
		5816,
		7,
		4491
	],
	"./00003/00003-08/00003-08-02/here is earth.mp3": [
		5817,
		7,
		4492
	],
	"./00003/00003-08/00003-08-02/here is jupiter.mp3": [
		5818,
		7,
		4493
	],
	"./00003/00003-08/00003-08-02/here is mars.mp3": [
		5819,
		7,
		4494
	],
	"./00003/00003-08/00003-08-02/here is mercury.mp3": [
		5820,
		7,
		4495
	],
	"./00003/00003-08/00003-08-02/here is the moon.mp3": [
		5821,
		7,
		4496
	],
	"./00003/00003-08/00003-08-02/here is venus.mp3": [
		5822,
		7,
		4497
	],
	"./00003/00003-08/00003-08-02/intro.mp3": [
		673,
		7
	],
	"./00003/00003-08/00003-08-02/jupiter goes around the sun too.mp3": [
		5823,
		7,
		4498
	],
	"./00003/00003-08/00003-08-02/jupiter is a big planet.mp3": [
		5824,
		7,
		4499
	],
	"./00003/00003-08/00003-08-02/main idea.mp3": [
		1054,
		7
	],
	"./00003/00003-08/00003-08-02/mars goes around the sun.mp3": [
		5825,
		7,
		4500
	],
	"./00003/00003-08/00003-08-02/mars is a small planet.mp3": [
		5826,
		7,
		4501
	],
	"./00003/00003-08/00003-08-02/mercury goes around the sun.mp3": [
		5827,
		7,
		4502
	],
	"./00003/00003-08/00003-08-02/mercury is a small planet.mp3": [
		5828,
		7,
		4503
	],
	"./00003/00003-08/00003-08-02/module": [
		1485,
		9,
		349
	],
	"./00003/00003-08/00003-08-02/module.js": [
		1485,
		9,
		349
	],
	"./00003/00003-08/00003-08-02/planets.mp3": [
		5829,
		7,
		4504
	],
	"./00003/00003-08/00003-08-02/saturn uranus and neptune are big planets.mp3": [
		5830,
		7,
		4505
	],
	"./00003/00003-08/00003-08-02/the moon goes around the earth.mp3": [
		5831,
		7,
		4506
	],
	"./00003/00003-08/00003-08-02/the moon is not a planet.mp3": [
		5832,
		7,
		4507
	],
	"./00003/00003-08/00003-08-02/the planets.mp3": [
		5833,
		7,
		4508
	],
	"./00003/00003-08/00003-08-02/they go around the sun.mp3": [
		5834,
		7,
		4509
	],
	"./00003/00003-08/00003-08-02/things in space.mp3": [
		5835,
		7,
		4510
	],
	"./00003/00003-08/00003-08-02/venus goes around the sun.mp3": [
		5836,
		7,
		4511
	],
	"./00003/00003-08/00003-08-02/venus is a small planet.mp3": [
		5837,
		7,
		4512
	],
	"./00003/00003-08/00003-08-03/0.jpg": [
		7036,
		7,
		5713
	],
	"./00003/00003-08/00003-08-03/1.jpg": [
		9701,
		7,
		9723
	],
	"./00003/00003-08/00003-08-03/2.jpg": [
		9702,
		7,
		9724
	],
	"./00003/00003-08/00003-08-03/3.jpg": [
		9703,
		7,
		9725
	],
	"./00003/00003-08/00003-08-03/4.jpg": [
		9704,
		7,
		9726
	],
	"./00003/00003-08/00003-08-03/5.jpg": [
		9705,
		7,
		9727
	],
	"./00003/00003-08/00003-08-03/6.jpg": [
		9706,
		7,
		9728
	],
	"./00003/00003-08/00003-08-03/7.jpg": [
		9707,
		7,
		9729
	],
	"./00003/00003-08/00003-08-03/animals that live in the snow.mp3": [
		5838,
		7,
		4513
	],
	"./00003/00003-08/00003-08-03/in the winter.mp3": [
		5839,
		7,
		4514
	],
	"./00003/00003-08/00003-08-03/intro.mp3": [
		674,
		7
	],
	"./00003/00003-08/00003-08-03/it is cold.mp3": [
		5840,
		7,
		4515
	],
	"./00003/00003-08/00003-08-03/it is winter.mp3": [
		5841,
		7,
		4516
	],
	"./00003/00003-08/00003-08-03/look at the bear.mp3": [
		5842,
		7,
		4517
	],
	"./00003/00003-08/00003-08-03/look at the frost.mp3": [
		5843,
		7,
		4518
	],
	"./00003/00003-08/00003-08-03/look at the ice.mp3": [
		5844,
		7,
		4519
	],
	"./00003/00003-08/00003-08-03/look at the mountains.mp3": [
		5845,
		7,
		4520
	],
	"./00003/00003-08/00003-08-03/look at the pond.mp3": [
		5846,
		7,
		4521
	],
	"./00003/00003-08/00003-08-03/look at the river.mp3": [
		5847,
		7,
		4522
	],
	"./00003/00003-08/00003-08-03/look at the trees.mp3": [
		5848,
		7,
		4523
	],
	"./00003/00003-08/00003-08-03/main idea.mp3": [
		1055,
		7
	],
	"./00003/00003-08/00003-08-03/module": [
		1486,
		9,
		350
	],
	"./00003/00003-08/00003-08-03/module.js": [
		1486,
		9,
		350
	],
	"./00003/00003-08/00003-08-03/the bear is sleeping.mp3": [
		5849,
		7,
		4524
	],
	"./00003/00003-08/00003-08-04/0.jpg": [
		7037,
		7,
		5714
	],
	"./00003/00003-08/00003-08-04/1.jpg": [
		9708,
		7,
		9730
	],
	"./00003/00003-08/00003-08-04/2.jpg": [
		9709,
		7,
		9731
	],
	"./00003/00003-08/00003-08-04/3.jpg": [
		9710,
		7,
		9732
	],
	"./00003/00003-08/00003-08-04/4.jpg": [
		9711,
		7,
		9733
	],
	"./00003/00003-08/00003-08-04/5.jpg": [
		9712,
		7,
		9734
	],
	"./00003/00003-08/00003-08-04/6.jpg": [
		9713,
		7,
		9735
	],
	"./00003/00003-08/00003-08-04/7.jpg": [
		9714,
		7,
		9736
	],
	"./00003/00003-08/00003-08-04/i can see five ducklings.mp3": [
		5850,
		7,
		4525
	],
	"./00003/00003-08/00003-08-04/i can see four chicks.mp3": [
		5851,
		7,
		4526
	],
	"./00003/00003-08/00003-08-04/i can see seven flowers.mp3": [
		5852,
		7,
		4527
	],
	"./00003/00003-08/00003-08-04/i can see six butterflies.mp3": [
		5853,
		7,
		4528
	],
	"./00003/00003-08/00003-08-04/i can see the rain.mp3": [
		5854,
		7,
		4529
	],
	"./00003/00003-08/00003-08-04/i can see three frogs.mp3": [
		5855,
		7,
		4530
	],
	"./00003/00003-08/00003-08-04/i can see two lambs.mp3": [
		5856,
		7,
		4531
	],
	"./00003/00003-08/00003-08-04/intro.mp3": [
		675,
		7
	],
	"./00003/00003-08/00003-08-04/main idea.mp3": [
		1056,
		7
	],
	"./00003/00003-08/00003-08-04/module": [
		1487,
		9,
		351
	],
	"./00003/00003-08/00003-08-04/module.js": [
		1487,
		9,
		351
	],
	"./00003/00003-08/00003-08-04/signs of spring.mp3": [
		5857,
		7,
		4532
	],
	"./00003/00003-08/00003-08-04/spring is here.mp3": [
		5858,
		7,
		4533
	],
	"./00003/00003-08/00003-08-04/spring is on the way.mp3": [
		5859,
		7,
		4534
	],
	"./00003/00003-08/00003-08-04/what can i see.mp3": [
		5860,
		7,
		4535
	],
	"./00003/00003-08/00003-08-05/0.jpg": [
		7038,
		7,
		5715
	],
	"./00003/00003-08/00003-08-05/1.jpg": [
		9715,
		7,
		9737
	],
	"./00003/00003-08/00003-08-05/2.jpg": [
		9716,
		7,
		9738
	],
	"./00003/00003-08/00003-08-05/3.jpg": [
		9717,
		7,
		9739
	],
	"./00003/00003-08/00003-08-05/4.jpg": [
		9718,
		7,
		9740
	],
	"./00003/00003-08/00003-08-05/5.jpg": [
		9719,
		7,
		9741
	],
	"./00003/00003-08/00003-08-05/6.jpg": [
		9720,
		7,
		9742
	],
	"./00003/00003-08/00003-08-05/7.jpg": [
		9721,
		7,
		9743
	],
	"./00003/00003-08/00003-08-05/i have fun in the sun.mp3": [
		5861,
		7,
		4536
	],
	"./00003/00003-08/00003-08-05/i like summer.mp3": [
		5862,
		7,
		4537
	],
	"./00003/00003-08/00003-08-05/i like the hermit crab.mp3": [
		5863,
		7,
		4538
	],
	"./00003/00003-08/00003-08-05/i like the sandcastle.mp3": [
		5864,
		7,
		4539
	],
	"./00003/00003-08/00003-08-05/i like the sea.mp3": [
		5865,
		7,
		4540
	],
	"./00003/00003-08/00003-08-05/i like the seagull.mp3": [
		5866,
		7,
		4541
	],
	"./00003/00003-08/00003-08-05/i like the shell.mp3": [
		5867,
		7,
		4542
	],
	"./00003/00003-08/00003-08-05/i like the starfish.mp3": [
		5868,
		7,
		4543
	],
	"./00003/00003-08/00003-08-05/i like the sun.mp3": [
		5869,
		7,
		4544
	],
	"./00003/00003-08/00003-08-05/intro.mp3": [
		676,
		7
	],
	"./00003/00003-08/00003-08-05/main idea.mp3": [
		1057,
		7
	],
	"./00003/00003-08/00003-08-05/module": [
		1488,
		9,
		352
	],
	"./00003/00003-08/00003-08-05/module.js": [
		1488,
		9,
		352
	],
	"./00003/00003-08/00003-08-05/sea animals.mp3": [
		5870,
		7,
		4545
	],
	"./00003/00003-08/00003-08-06/0.jpg": [
		7039,
		7,
		5716
	],
	"./00003/00003-08/00003-08-06/1.jpg": [
		9722,
		7,
		9744
	],
	"./00003/00003-08/00003-08-06/2.jpg": [
		9723,
		7,
		9745
	],
	"./00003/00003-08/00003-08-06/3.jpg": [
		9724,
		7,
		9746
	],
	"./00003/00003-08/00003-08-06/4.jpg": [
		9725,
		7,
		9747
	],
	"./00003/00003-08/00003-08-06/5.jpg": [
		9726,
		7,
		9748
	],
	"./00003/00003-08/00003-08-06/6.jpg": [
		9727,
		7,
		9749
	],
	"./00003/00003-08/00003-08-06/7.jpg": [
		9728,
		7,
		9750
	],
	"./00003/00003-08/00003-08-06/colors in the fall.mp3": [
		5871,
		7,
		4546
	],
	"./00003/00003-08/00003-08-06/i like apples he said.mp3": [
		5872,
		7,
		4547
	],
	"./00003/00003-08/00003-08-06/i like grapes she said.mp3": [
		5873,
		7,
		4548
	],
	"./00003/00003-08/00003-08-06/i like hay she said.mp3": [
		5874,
		7,
		4549
	],
	"./00003/00003-08/00003-08-06/i like leaves he said.mp3": [
		5875,
		7,
		4550
	],
	"./00003/00003-08/00003-08-06/i like nuts said the squirrel.mp3": [
		5876,
		7,
		4551
	],
	"./00003/00003-08/00003-08-06/i like pumpkins he said.mp3": [
		5877,
		7,
		4552
	],
	"./00003/00003-08/00003-08-06/intro.mp3": [
		677,
		7
	],
	"./00003/00003-08/00003-08-06/look at the ant.mp3": [
		5878,
		7,
		4553
	],
	"./00003/00003-08/00003-08-06/look at the bear.mp3": [
		5879,
		7,
		4554
	],
	"./00003/00003-08/00003-08-06/look at the bird.mp3": [
		5880,
		7,
		4555
	],
	"./00003/00003-08/00003-08-06/look at the brown nuts.mp3": [
		5881,
		7,
		4556
	],
	"./00003/00003-08/00003-08-06/look at the cow.mp3": [
		5882,
		7,
		4557
	],
	"./00003/00003-08/00003-08-06/look at the gray geese.mp3": [
		5883,
		7,
		4558
	],
	"./00003/00003-08/00003-08-06/look at the green apples.mp3": [
		5884,
		7,
		4559
	],
	"./00003/00003-08/00003-08-06/look at the horse.mp3": [
		5885,
		7,
		4560
	],
	"./00003/00003-08/00003-08-06/look at the orange pumpkin.mp3": [
		5886,
		7,
		4561
	],
	"./00003/00003-08/00003-08-06/look at the purple grapes.mp3": [
		5887,
		7,
		4562
	],
	"./00003/00003-08/00003-08-06/look at the red leaves.mp3": [
		5888,
		7,
		4563
	],
	"./00003/00003-08/00003-08-06/look at the squirrel.mp3": [
		5889,
		7,
		4564
	],
	"./00003/00003-08/00003-08-06/look at the trees.mp3": [
		5890,
		7,
		4565
	],
	"./00003/00003-08/00003-08-06/look at the yellow hay.mp3": [
		5891,
		7,
		4566
	],
	"./00003/00003-08/00003-08-06/main idea.mp3": [
		1058,
		7
	],
	"./00003/00003-08/00003-08-06/module": [
		1489,
		9,
		353
	],
	"./00003/00003-08/00003-08-06/module.js": [
		1489,
		9,
		353
	],
	"./00003/00003-08/00003-08-06/pumpkins.mp3": [
		5892,
		7,
		4567
	],
	"./00003/00003-08/00003-08-06/things we see in the fall.mp3": [
		5893,
		7,
		4568
	],
	"./00003/00003-08/00003-08-06/we like fall they said.mp3": [
		5894,
		7,
		4569
	],
	"./00003/00003-08/00003-08-07/0.jpg": [
		7040,
		7,
		5717
	],
	"./00003/00003-08/00003-08-07/1.jpg": [
		9729,
		7,
		9751
	],
	"./00003/00003-08/00003-08-07/2.jpg": [
		9730,
		7,
		9752
	],
	"./00003/00003-08/00003-08-07/3.jpg": [
		9731,
		7,
		9753
	],
	"./00003/00003-08/00003-08-07/4.jpg": [
		9732,
		7,
		9754
	],
	"./00003/00003-08/00003-08-07/5.jpg": [
		9733,
		7,
		9755
	],
	"./00003/00003-08/00003-08-07/6.jpg": [
		9734,
		7,
		9756
	],
	"./00003/00003-08/00003-08-07/7.jpg": [
		9735,
		7,
		9757
	],
	"./00003/00003-08/00003-08-07/intro.mp3": [
		678,
		7
	],
	"./00003/00003-08/00003-08-07/look at the soil.mp3": [
		5895,
		7,
		4570
	],
	"./00003/00003-08/00003-08-07/main idea.mp3": [
		1059,
		7
	],
	"./00003/00003-08/00003-08-07/module": [
		1490,
		9,
		354
	],
	"./00003/00003-08/00003-08-07/module.js": [
		1490,
		9,
		354
	],
	"./00003/00003-08/00003-08-07/they eat the leaves.mp3": [
		5896,
		7,
		4571
	],
	"./00003/00003-08/00003-08-07/things we see in the soil.mp3": [
		5897,
		7,
		4572
	],
	"./00003/00003-08/00003-08-07/we can see ants.mp3": [
		5898,
		7,
		4573
	],
	"./00003/00003-08/00003-08-07/we can see bones.mp3": [
		5899,
		7,
		4574
	],
	"./00003/00003-08/00003-08-07/we can see leaves.mp3": [
		5900,
		7,
		4575
	],
	"./00003/00003-08/00003-08-07/we can see rocks.mp3": [
		5901,
		7,
		4576
	],
	"./00003/00003-08/00003-08-07/we can see roots.mp3": [
		5902,
		7,
		4577
	],
	"./00003/00003-08/00003-08-07/we can see shells.mp3": [
		5903,
		7,
		4578
	],
	"./00003/00003-08/00003-08-07/we can see worms.mp3": [
		5904,
		7,
		4579
	],
	"./00003/00003-08/00003-08-07/what else can we see.mp3": [
		5905,
		7,
		4580
	],
	"./00003/00003-08/00003-08-07/what is in the soil.mp3": [
		5906,
		7,
		4581
	],
	"./00003/00003-08/00003-08-08/0.jpg": [
		7041,
		7,
		5718
	],
	"./00003/00003-08/00003-08-08/1.jpg": [
		9736,
		7,
		9758
	],
	"./00003/00003-08/00003-08-08/2.jpg": [
		9737,
		7,
		9759
	],
	"./00003/00003-08/00003-08-08/3.jpg": [
		9738,
		7,
		9760
	],
	"./00003/00003-08/00003-08-08/4.jpg": [
		9739,
		7,
		9761
	],
	"./00003/00003-08/00003-08-08/5.jpg": [
		9740,
		7,
		9762
	],
	"./00003/00003-08/00003-08-08/6.jpg": [
		9741,
		7,
		9763
	],
	"./00003/00003-08/00003-08-08/7.jpg": [
		9742,
		7,
		9764
	],
	"./00003/00003-08/00003-08-08/alligator likes the green rock.mp3": [
		5907,
		7,
		4582
	],
	"./00003/00003-08/00003-08-08/cheetah likes the yellow rock.mp3": [
		5908,
		7,
		4583
	],
	"./00003/00003-08/00003-08-08/chipmunk likes the brown rock.mp3": [
		5909,
		7,
		4584
	],
	"./00003/00003-08/00003-08-08/elephant likes the gray rock.mp3": [
		5910,
		7,
		4585
	],
	"./00003/00003-08/00003-08-08/fox likes the red rock.mp3": [
		5911,
		7,
		4586
	],
	"./00003/00003-08/00003-08-08/intro.mp3": [
		679,
		7
	],
	"./00003/00003-08/00003-08-08/look at my rock he said.mp3": [
		5912,
		7,
		4587
	],
	"./00003/00003-08/00003-08-08/look at my rock she said.mp3": [
		5913,
		7,
		4588
	],
	"./00003/00003-08/00003-08-08/main idea.mp3": [
		1060,
		7
	],
	"./00003/00003-08/00003-08-08/module": [
		1491,
		9,
		355
	],
	"./00003/00003-08/00003-08-08/module.js": [
		1491,
		9,
		355
	],
	"./00003/00003-08/00003-08-08/my rock has spots.mp3": [
		5914,
		7,
		4589
	],
	"./00003/00003-08/00003-08-08/my rock has stripes.mp3": [
		5915,
		7,
		4590
	],
	"./00003/00003-08/00003-08-08/my rock is big.mp3": [
		5916,
		7,
		4591
	],
	"./00003/00003-08/00003-08-08/my rock is little.mp3": [
		5917,
		7,
		4592
	],
	"./00003/00003-08/00003-08-08/non living things.mp3": [
		5918,
		7,
		4593
	],
	"./00003/00003-08/00003-08-08/rocks.mp3": [
		5919,
		7,
		4594
	],
	"./00003/00003-08/00003-08-08/skunk likes the black rock.mp3": [
		5920,
		7,
		4595
	],
	"./00003/00003-08/00003-08-08/tiger likes the orange rock.mp3": [
		5921,
		7,
		4596
	],
	"./00003/00003-08/00003-08-09/0.jpg": [
		7042,
		7,
		5719
	],
	"./00003/00003-08/00003-08-09/1.jpg": [
		9743,
		7,
		9765
	],
	"./00003/00003-08/00003-08-09/2.jpg": [
		9744,
		7,
		9766
	],
	"./00003/00003-08/00003-08-09/3.jpg": [
		9745,
		7,
		9767
	],
	"./00003/00003-08/00003-08-09/4.jpg": [
		9746,
		7,
		9768
	],
	"./00003/00003-08/00003-08-09/5.jpg": [
		9747,
		7,
		9769
	],
	"./00003/00003-08/00003-08-09/6.jpg": [
		9748,
		7,
		9770
	],
	"./00003/00003-08/00003-08-09/7.jpg": [
		9749,
		7,
		9771
	],
	"./00003/00003-08/00003-08-09/intro.mp3": [
		680,
		7
	],
	"./00003/00003-08/00003-08-09/it is night.mp3": [
		5922,
		7,
		4597
	],
	"./00003/00003-08/00003-08-09/look up in the sky.mp3": [
		5923,
		7,
		4598
	],
	"./00003/00003-08/00003-08-09/look up.mp3": [
		5924,
		7,
		4599
	],
	"./00003/00003-08/00003-08-09/main idea.mp3": [
		1061,
		7
	],
	"./00003/00003-08/00003-08-09/module": [
		1492,
		9,
		356
	],
	"./00003/00003-08/00003-08-09/module.js": [
		1492,
		9,
		356
	],
	"./00003/00003-08/00003-08-09/things in the sky.mp3": [
		5925,
		7,
		4600
	],
	"./00003/00003-08/00003-08-09/things you can see up in the sky.mp3": [
		5926,
		7,
		4601
	],
	"./00003/00003-08/00003-08-09/what can you see in the sky.mp3": [
		5927,
		7,
		4602
	],
	"./00003/00003-08/00003-08-09/what can you see.mp3": [
		5928,
		7,
		4603
	],
	"./00003/00003-08/00003-08-09/you can see a dragon.mp3": [
		5929,
		7,
		4604
	],
	"./00003/00003-08/00003-08-09/you can see the clouds.mp3": [
		5930,
		7,
		4605
	],
	"./00003/00003-08/00003-08-09/you can see the moon.mp3": [
		5931,
		7,
		4606
	],
	"./00003/00003-08/00003-08-09/you can see the rain.mp3": [
		5932,
		7,
		4607
	],
	"./00003/00003-08/00003-08-09/you can see the rainbow.mp3": [
		5933,
		7,
		4608
	],
	"./00003/00003-08/00003-08-09/you can see the stars.mp3": [
		5934,
		7,
		4609
	],
	"./00003/00003-08/00003-08-09/you can see the sun.mp3": [
		5935,
		7,
		4610
	],
	"./00003/00003-08/00003-08-10/0.jpg": [
		7043,
		7,
		5720
	],
	"./00003/00003-08/00003-08-10/1.jpg": [
		9750,
		7,
		9772
	],
	"./00003/00003-08/00003-08-10/2.jpg": [
		9751,
		7,
		9773
	],
	"./00003/00003-08/00003-08-10/3.jpg": [
		9752,
		7,
		9774
	],
	"./00003/00003-08/00003-08-10/4.jpg": [
		9753,
		7,
		9775
	],
	"./00003/00003-08/00003-08-10/5.jpg": [
		9754,
		7,
		9776
	],
	"./00003/00003-08/00003-08-10/6.jpg": [
		9755,
		7,
		9777
	],
	"./00003/00003-08/00003-08-10/7.jpg": [
		9756,
		7,
		9778
	],
	"./00003/00003-08/00003-08-10/intro.mp3": [
		681,
		7
	],
	"./00003/00003-08/00003-08-10/it is a cloudy day.mp3": [
		5936,
		7,
		4611
	],
	"./00003/00003-08/00003-08-10/it is a rainy day.mp3": [
		5937,
		7,
		4612
	],
	"./00003/00003-08/00003-08-10/it is a rainy night.mp3": [
		5938,
		7,
		4613
	],
	"./00003/00003-08/00003-08-10/it is a snowy day.mp3": [
		5939,
		7,
		4614
	],
	"./00003/00003-08/00003-08-10/it is a snowy night.mp3": [
		5940,
		7,
		4615
	],
	"./00003/00003-08/00003-08-10/it is a sunny day.mp3": [
		5941,
		7,
		4616
	],
	"./00003/00003-08/00003-08-10/it is a windy day.mp3": [
		5942,
		7,
		4617
	],
	"./00003/00003-08/00003-08-10/look at me said the boy.mp3": [
		5943,
		7,
		4618
	],
	"./00003/00003-08/00003-08-10/look at me said the cat.mp3": [
		5944,
		7,
		4619
	],
	"./00003/00003-08/00003-08-10/look at me said the fox.mp3": [
		5945,
		7,
		4620
	],
	"./00003/00003-08/00003-08-10/look at me said the girl.mp3": [
		5946,
		7,
		4621
	],
	"./00003/00003-08/00003-08-10/look at me.mp3": [
		5947,
		7,
		4622
	],
	"./00003/00003-08/00003-08-10/look at us said the animals.mp3": [
		5948,
		7,
		4623
	],
	"./00003/00003-08/00003-08-10/look at us.mp3": [
		5949,
		7,
		4624
	],
	"./00003/00003-08/00003-08-10/main idea.mp3": [
		1062,
		7
	],
	"./00003/00003-08/00003-08-10/module": [
		1493,
		9,
		357
	],
	"./00003/00003-08/00003-08-10/module.js": [
		1493,
		9,
		357
	],
	"./00003/00003-08/00003-08-10/weather.mp3": [
		5950,
		7,
		4625
	],
	"./00003/00003-08/cover.jpg": [
		7044,
		7,
		5721
	],
	"./00003/00003-08/earth and space.mp3": [
		5951,
		7,
		4626
	],
	"./00003/00003-08/unit": [
		1494,
		9,
		358
	],
	"./00003/00003-08/unit.js": [
		1494,
		9,
		358
	],
	"./00003/00003-09/00003-09-01/0.jpg": [
		7045,
		7,
		5722
	],
	"./00003/00003-09/00003-09-01/1.jpg": [
		9757,
		7,
		9779
	],
	"./00003/00003-09/00003-09-01/2.jpg": [
		9758,
		7,
		9780
	],
	"./00003/00003-09/00003-09-01/3.jpg": [
		9759,
		7,
		9781
	],
	"./00003/00003-09/00003-09-01/4.jpg": [
		9760,
		7,
		9782
	],
	"./00003/00003-09/00003-09-01/5.jpg": [
		9761,
		7,
		9783
	],
	"./00003/00003-09/00003-09-01/6.jpg": [
		9762,
		7,
		9784
	],
	"./00003/00003-09/00003-09-01/7.jpg": [
		9763,
		7,
		9785
	],
	"./00003/00003-09/00003-09-01/fish.mp3": [
		5952,
		7,
		4627
	],
	"./00003/00003-09/00003-09-01/i am a dolphin.mp3": [
		5953,
		7,
		4628
	],
	"./00003/00003-09/00003-09-01/i am a fish.mp3": [
		5954,
		7,
		4629
	],
	"./00003/00003-09/00003-09-01/i am a flying fish.mp3": [
		5955,
		7,
		4630
	],
	"./00003/00003-09/00003-09-01/i am a hammerhead shark.mp3": [
		5956,
		7,
		4631
	],
	"./00003/00003-09/00003-09-01/i am a seahorse.mp3": [
		5957,
		7,
		4632
	],
	"./00003/00003-09/00003-09-01/i am a shark.mp3": [
		5958,
		7,
		4633
	],
	"./00003/00003-09/00003-09-01/i am a swordfish.mp3": [
		5959,
		7,
		4634
	],
	"./00003/00003-09/00003-09-01/i am an eel.mp3": [
		5960,
		7,
		4635
	],
	"./00003/00003-09/00003-09-01/i am not a fish.mp3": [
		5961,
		7,
		4636
	],
	"./00003/00003-09/00003-09-01/i breathe with my gills.mp3": [
		5962,
		7,
		4637
	],
	"./00003/00003-09/00003-09-01/i breathe with my lungs.mp3": [
		5963,
		7,
		4638
	],
	"./00003/00003-09/00003-09-01/i live in the water.mp3": [
		5964,
		7,
		4639
	],
	"./00003/00003-09/00003-09-01/intro.mp3": [
		682,
		7
	],
	"./00003/00003-09/00003-09-01/main idea.mp3": [
		1063,
		7
	],
	"./00003/00003-09/00003-09-01/module": [
		1495,
		9,
		359
	],
	"./00003/00003-09/00003-09-01/module.js": [
		1495,
		9,
		359
	],
	"./00003/00003-09/00003-09-02/0.jpg": [
		7046,
		7,
		5723
	],
	"./00003/00003-09/00003-09-02/1.jpg": [
		9764,
		7,
		9786
	],
	"./00003/00003-09/00003-09-02/2.jpg": [
		9765,
		7,
		9787
	],
	"./00003/00003-09/00003-09-02/3.jpg": [
		9766,
		7,
		9788
	],
	"./00003/00003-09/00003-09-02/4.jpg": [
		9767,
		7,
		9789
	],
	"./00003/00003-09/00003-09-02/5.jpg": [
		9768,
		7,
		9790
	],
	"./00003/00003-09/00003-09-02/6.jpg": [
		9769,
		7,
		9791
	],
	"./00003/00003-09/00003-09-02/7.jpg": [
		9770,
		7,
		9792
	],
	"./00003/00003-09/00003-09-02/i am a mammal.mp3": [
		5965,
		7,
		4640
	],
	"./00003/00003-09/00003-09-02/i am not a mammal.mp3": [
		5966,
		7,
		4641
	],
	"./00003/00003-09/00003-09-02/i do not have fur said the duck.mp3": [
		5967,
		7,
		4642
	],
	"./00003/00003-09/00003-09-02/i do not have hair said the shark.mp3": [
		5968,
		7,
		4643
	],
	"./00003/00003-09/00003-09-02/i have fur said the panda.mp3": [
		5969,
		7,
		4644
	],
	"./00003/00003-09/00003-09-02/i have fur said the skunk.mp3": [
		5970,
		7,
		4645
	],
	"./00003/00003-09/00003-09-02/i have hair said the whale.mp3": [
		5971,
		7,
		4646
	],
	"./00003/00003-09/00003-09-02/i have hair said the zebra.mp3": [
		5972,
		7,
		4647
	],
	"./00003/00003-09/00003-09-02/intro.mp3": [
		683,
		7
	],
	"./00003/00003-09/00003-09-02/main idea.mp3": [
		1064,
		7
	],
	"./00003/00003-09/00003-09-02/mammals are furry.mp3": [
		5973,
		7,
		4648
	],
	"./00003/00003-09/00003-09-02/mammals.mp3": [
		5974,
		7,
		4649
	],
	"./00003/00003-09/00003-09-02/module": [
		1496,
		9,
		360
	],
	"./00003/00003-09/00003-09-02/module.js": [
		1496,
		9,
		360
	],
	"./00003/00003-09/00003-09-02/so i am a mammal too.mp3": [
		5975,
		7,
		4650
	],
	"./00003/00003-09/00003-09-02/so we are mammals too.mp3": [
		5976,
		7,
		4651
	],
	"./00003/00003-09/00003-09-02/we have hair said the kids.mp3": [
		5977,
		7,
		4652
	],
	"./00003/00003-09/00003-09-03/0.jpg": [
		7047,
		7,
		5724
	],
	"./00003/00003-09/00003-09-03/1.jpg": [
		9771,
		7,
		9793
	],
	"./00003/00003-09/00003-09-03/2.jpg": [
		9772,
		7,
		9794
	],
	"./00003/00003-09/00003-09-03/3.jpg": [
		9773,
		7,
		9795
	],
	"./00003/00003-09/00003-09-03/4.jpg": [
		9774,
		7,
		9796
	],
	"./00003/00003-09/00003-09-03/5.jpg": [
		9775,
		7,
		9797
	],
	"./00003/00003-09/00003-09-03/6.jpg": [
		9776,
		7,
		9798
	],
	"./00003/00003-09/00003-09-03/7.jpg": [
		9777,
		7,
		9799
	],
	"./00003/00003-09/00003-09-03/cold blooded reptiles.mp3": [
		5978,
		7,
		4653
	],
	"./00003/00003-09/00003-09-03/i am a crocodile.mp3": [
		5979,
		7,
		4654
	],
	"./00003/00003-09/00003-09-03/i am a reptile.mp3": [
		5980,
		7,
		4655
	],
	"./00003/00003-09/00003-09-03/i am a snake.mp3": [
		5981,
		7,
		4656
	],
	"./00003/00003-09/00003-09-03/i am a turtle.mp3": [
		5982,
		7,
		4657
	],
	"./00003/00003-09/00003-09-03/i sit in the sun to get warm.mp3": [
		5983,
		7,
		4658
	],
	"./00003/00003-09/00003-09-03/intro.mp3": [
		684,
		7
	],
	"./00003/00003-09/00003-09-03/look at the alligator.mp3": [
		5984,
		7,
		4659
	],
	"./00003/00003-09/00003-09-03/look at the lizard.mp3": [
		5985,
		7,
		4660
	],
	"./00003/00003-09/00003-09-03/main idea.mp3": [
		1065,
		7
	],
	"./00003/00003-09/00003-09-03/mammals are warm blooded.mp3": [
		5986,
		7,
		4661
	],
	"./00003/00003-09/00003-09-03/module": [
		1497,
		9,
		361
	],
	"./00003/00003-09/00003-09-03/module.js": [
		1497,
		9,
		361
	],
	"./00003/00003-09/00003-09-03/reptiles are cold blooded.mp3": [
		5987,
		7,
		4662
	],
	"./00003/00003-09/00003-09-03/reptiles.mp3": [
		5988,
		7,
		4663
	],
	"./00003/00003-09/00003-09-03/the alligator is a reptile.mp3": [
		5989,
		7,
		4664
	],
	"./00003/00003-09/00003-09-03/the alligator is sitting in the sun.mp3": [
		5990,
		7,
		4665
	],
	"./00003/00003-09/00003-09-03/the lion is a mammal.mp3": [
		5991,
		7,
		4666
	],
	"./00003/00003-09/00003-09-03/the lizard is a reptile.mp3": [
		5992,
		7,
		4667
	],
	"./00003/00003-09/00003-09-03/the lizard is sitting in the sun.mp3": [
		5993,
		7,
		4668
	],
	"./00003/00003-09/00003-09-03/they sit in the sun for fun.mp3": [
		5994,
		7,
		4669
	],
	"./00003/00003-09/00003-09-03/they sit in the sun to get warm.mp3": [
		5995,
		7,
		4670
	],
	"./00003/00003-09/00003-09-04/0.jpg": [
		7048,
		7,
		5725
	],
	"./00003/00003-09/00003-09-04/1.jpg": [
		9778,
		7,
		9800
	],
	"./00003/00003-09/00003-09-04/2.jpg": [
		9779,
		7,
		9801
	],
	"./00003/00003-09/00003-09-04/3.jpg": [
		9780,
		7,
		9802
	],
	"./00003/00003-09/00003-09-04/4.jpg": [
		9781,
		7,
		9803
	],
	"./00003/00003-09/00003-09-04/5.jpg": [
		9782,
		7,
		9804
	],
	"./00003/00003-09/00003-09-04/6.jpg": [
		9783,
		7,
		9805
	],
	"./00003/00003-09/00003-09-04/7.jpg": [
		9784,
		7,
		9806
	],
	"./00003/00003-09/00003-09-04/amphibians.mp3": [
		5996,
		7,
		4671
	],
	"./00003/00003-09/00003-09-04/i am an amphibian said the frog.mp3": [
		5997,
		7,
		4672
	],
	"./00003/00003-09/00003-09-04/i am an amphibian said the salamander.mp3": [
		5998,
		7,
		4673
	],
	"./00003/00003-09/00003-09-04/i am an amphibian said the toad.mp3": [
		5999,
		7,
		4674
	],
	"./00003/00003-09/00003-09-04/i am an amphibian.mp3": [
		6000,
		7,
		4675
	],
	"./00003/00003-09/00003-09-04/i am not an amphibian.mp3": [
		6001,
		7,
		4676
	],
	"./00003/00003-09/00003-09-04/i can live on land said the frog.mp3": [
		6002,
		7,
		4677
	],
	"./00003/00003-09/00003-09-04/i can live on land said the salamander.mp3": [
		6003,
		7,
		4678
	],
	"./00003/00003-09/00003-09-04/i can live on land said the toad.mp3": [
		6004,
		7,
		4679
	],
	"./00003/00003-09/00003-09-04/i can not live on land said the shark.mp3": [
		6005,
		7,
		4680
	],
	"./00003/00003-09/00003-09-04/i was born in the water.mp3": [
		6006,
		7,
		4681
	],
	"./00003/00003-09/00003-09-04/intro.mp3": [
		685,
		7
	],
	"./00003/00003-09/00003-09-04/main idea.mp3": [
		1066,
		7
	],
	"./00003/00003-09/00003-09-04/module": [
		1498,
		9,
		362
	],
	"./00003/00003-09/00003-09-04/module.js": [
		1498,
		9,
		362
	],
	"./00003/00003-09/00003-09-05/0.jpg": [
		7049,
		7,
		5726
	],
	"./00003/00003-09/00003-09-05/1.jpg": [
		9785,
		7,
		9807
	],
	"./00003/00003-09/00003-09-05/2.jpg": [
		9786,
		7,
		9808
	],
	"./00003/00003-09/00003-09-05/3.jpg": [
		9787,
		7,
		9809
	],
	"./00003/00003-09/00003-09-05/4.jpg": [
		9788,
		7,
		9810
	],
	"./00003/00003-09/00003-09-05/5.jpg": [
		9789,
		7,
		9811
	],
	"./00003/00003-09/00003-09-05/6.jpg": [
		9790,
		7,
		9812
	],
	"./00003/00003-09/00003-09-05/7.jpg": [
		9791,
		7,
		9813
	],
	"./00003/00003-09/00003-09-05/are you a bird duck.mp3": [
		6007,
		7,
		4682
	],
	"./00003/00003-09/00003-09-05/are you a bird eagle.mp3": [
		6008,
		7,
		4683
	],
	"./00003/00003-09/00003-09-05/are you a bird.mp3": [
		6009,
		7,
		4684
	],
	"./00003/00003-09/00003-09-05/birds.mp3": [
		6010,
		7,
		4685
	],
	"./00003/00003-09/00003-09-05/hello bat.mp3": [
		6011,
		7,
		4686
	],
	"./00003/00003-09/00003-09-05/hello birds.mp3": [
		6012,
		7,
		4687
	],
	"./00003/00003-09/00003-09-05/hello ostrich.mp3": [
		6013,
		7,
		4688
	],
	"./00003/00003-09/00003-09-05/hello owl.mp3": [
		6014,
		7,
		4689
	],
	"./00003/00003-09/00003-09-05/hello parrot.mp3": [
		6015,
		7,
		4690
	],
	"./00003/00003-09/00003-09-05/hello penguin.mp3": [
		6016,
		7,
		4691
	],
	"./00003/00003-09/00003-09-05/i am a bird.mp3": [
		6017,
		7,
		4692
	],
	"./00003/00003-09/00003-09-05/i am not a bird.mp3": [
		6018,
		7,
		4693
	],
	"./00003/00003-09/00003-09-05/i can fly but i have no feathers.mp3": [
		6019,
		7,
		4694
	],
	"./00003/00003-09/00003-09-05/i can not fly but i am a bird.mp3": [
		6020,
		7,
		4695
	],
	"./00003/00003-09/00003-09-05/i have feathers.mp3": [
		6021,
		7,
		4696
	],
	"./00003/00003-09/00003-09-05/intro.mp3": [
		686,
		7
	],
	"./00003/00003-09/00003-09-05/main idea.mp3": [
		1067,
		7
	],
	"./00003/00003-09/00003-09-05/module": [
		1499,
		9,
		363
	],
	"./00003/00003-09/00003-09-05/module.js": [
		1499,
		9,
		363
	],
	"./00003/00003-09/00003-09-05/no i can fly but i have no feathers.mp3": [
		6022,
		7,
		4697
	],
	"./00003/00003-09/00003-09-05/no.mp3": [
		6023,
		7,
		4698
	],
	"./00003/00003-09/00003-09-05/yes i am a bird.mp3": [
		6024,
		7,
		4699
	],
	"./00003/00003-09/00003-09-05/yes.mp3": [
		6025,
		7,
		4700
	],
	"./00003/00003-09/00003-09-06/0.jpg": [
		7050,
		7,
		5727
	],
	"./00003/00003-09/00003-09-06/1.jpg": [
		9792,
		7,
		9814
	],
	"./00003/00003-09/00003-09-06/2.jpg": [
		9793,
		7,
		9815
	],
	"./00003/00003-09/00003-09-06/3.jpg": [
		9794,
		7,
		9816
	],
	"./00003/00003-09/00003-09-06/4.jpg": [
		9795,
		7,
		9817
	],
	"./00003/00003-09/00003-09-06/5.jpg": [
		9796,
		7,
		9818
	],
	"./00003/00003-09/00003-09-06/6.jpg": [
		9797,
		7,
		9819
	],
	"./00003/00003-09/00003-09-06/7.jpg": [
		9798,
		7,
		9820
	],
	"./00003/00003-09/00003-09-06/a crab has a hard body.mp3": [
		6026,
		7,
		4701
	],
	"./00003/00003-09/00003-09-06/a crab has no backbone.mp3": [
		6027,
		7,
		4702
	],
	"./00003/00003-09/00003-09-06/a jellyfish has a soft body.mp3": [
		6028,
		7,
		4703
	],
	"./00003/00003-09/00003-09-06/a jellyfish has no backbone.mp3": [
		6029,
		7,
		4704
	],
	"./00003/00003-09/00003-09-06/a ladybug has a hard body.mp3": [
		6030,
		7,
		4705
	],
	"./00003/00003-09/00003-09-06/a ladybug has no backbone.mp3": [
		6031,
		7,
		4706
	],
	"./00003/00003-09/00003-09-06/a snail has a hard shell.mp3": [
		6032,
		7,
		4707
	],
	"./00003/00003-09/00003-09-06/a spider has a hard body.mp3": [
		6033,
		7,
		4708
	],
	"./00003/00003-09/00003-09-06/a spider has no backbone.mp3": [
		6034,
		7,
		4709
	],
	"./00003/00003-09/00003-09-06/a worm has a soft body.mp3": [
		6035,
		7,
		4710
	],
	"./00003/00003-09/00003-09-06/a worm has no backbone.mp3": [
		6036,
		7,
		4711
	],
	"./00003/00003-09/00003-09-06/animals without backbones.mp3": [
		6037,
		7,
		4712
	],
	"./00003/00003-09/00003-09-06/dinosaurs had backbones.mp3": [
		6038,
		7,
		4713
	],
	"./00003/00003-09/00003-09-06/intro.mp3": [
		687,
		7
	],
	"./00003/00003-09/00003-09-06/lions and tigers have backbones.mp3": [
		6039,
		7,
		4714
	],
	"./00003/00003-09/00003-09-06/main idea.mp3": [
		1068,
		7
	],
	"./00003/00003-09/00003-09-06/module": [
		1500,
		9,
		364
	],
	"./00003/00003-09/00003-09-06/module.js": [
		1500,
		9,
		364
	],
	"./00003/00003-09/00003-09-06/slugs and snails have soft bodies.mp3": [
		6040,
		7,
		4715
	],
	"./00003/00003-09/00003-09-06/the octopus has a soft body.mp3": [
		6041,
		7,
		4716
	],
	"./00003/00003-09/00003-09-06/the octopus has no backbone.mp3": [
		6042,
		7,
		4717
	],
	"./00003/00003-09/00003-09-06/we have backbones too.mp3": [
		6043,
		7,
		4718
	],
	"./00003/00003-09/00003-09-07/0.jpg": [
		7051,
		7,
		5728
	],
	"./00003/00003-09/00003-09-07/1.jpg": [
		9799,
		7,
		9821
	],
	"./00003/00003-09/00003-09-07/2.jpg": [
		9800,
		7,
		9822
	],
	"./00003/00003-09/00003-09-07/3.jpg": [
		9801,
		7,
		9823
	],
	"./00003/00003-09/00003-09-07/4.jpg": [
		9802,
		7,
		9824
	],
	"./00003/00003-09/00003-09-07/5.jpg": [
		9803,
		7,
		9825
	],
	"./00003/00003-09/00003-09-07/6.jpg": [
		9804,
		7,
		9826
	],
	"./00003/00003-09/00003-09-07/7.jpg": [
		9805,
		7,
		9827
	],
	"./00003/00003-09/00003-09-07/ants are insects.mp3": [
		6044,
		7,
		4719
	],
	"./00003/00003-09/00003-09-07/bees are insects.mp3": [
		6045,
		7,
		4720
	],
	"./00003/00003-09/00003-09-07/but i am not an insect.mp3": [
		6046,
		7,
		4721
	],
	"./00003/00003-09/00003-09-07/i am an insect said the ant.mp3": [
		6047,
		7,
		4722
	],
	"./00003/00003-09/00003-09-07/i am an insect said the butterfly.mp3": [
		6048,
		7,
		4723
	],
	"./00003/00003-09/00003-09-07/i am an insect said the grasshopper.mp3": [
		6049,
		7,
		4724
	],
	"./00003/00003-09/00003-09-07/i am an insect.mp3": [
		6050,
		7,
		4725
	],
	"./00003/00003-09/00003-09-07/i am not an insect.mp3": [
		6051,
		7,
		4726
	],
	"./00003/00003-09/00003-09-07/i have 2 antennas and 6 legs.mp3": [
		6052,
		7,
		4727
	],
	"./00003/00003-09/00003-09-07/i have 2 antennas.mp3": [
		6053,
		7,
		4728
	],
	"./00003/00003-09/00003-09-07/i have 6 legs and 2 antennas said the butterfly.mp3": [
		6054,
		7,
		4729
	],
	"./00003/00003-09/00003-09-07/i have 6 legs and 2 antennas said the monster.mp3": [
		6055,
		7,
		4730
	],
	"./00003/00003-09/00003-09-07/i have 6 legs and 2 antennas.mp3": [
		6056,
		7,
		4731
	],
	"./00003/00003-09/00003-09-07/i have 6 legs said the dragonfly.mp3": [
		6057,
		7,
		4732
	],
	"./00003/00003-09/00003-09-07/i have 6 legs said the ladybug.mp3": [
		6058,
		7,
		4733
	],
	"./00003/00003-09/00003-09-07/i have 6 legs.mp3": [
		6059,
		7,
		4734
	],
	"./00003/00003-09/00003-09-07/i have 8 legs said the spider.mp3": [
		6060,
		7,
		4735
	],
	"./00003/00003-09/00003-09-07/insects.mp3": [
		6061,
		7,
		4736
	],
	"./00003/00003-09/00003-09-07/intro.mp3": [
		688,
		7
	],
	"./00003/00003-09/00003-09-07/ladybugs are insects.mp3": [
		6062,
		7,
		4737
	],
	"./00003/00003-09/00003-09-07/main idea.mp3": [
		1069,
		7
	],
	"./00003/00003-09/00003-09-07/me too said the dragonfly.mp3": [
		6063,
		7,
		4738
	],
	"./00003/00003-09/00003-09-07/me too said the grasshopper.mp3": [
		6064,
		7,
		4739
	],
	"./00003/00003-09/00003-09-07/module": [
		1501,
		9,
		365
	],
	"./00003/00003-09/00003-09-07/module.js": [
		1501,
		9,
		365
	],
	"./00003/00003-09/00003-09-07/spiders are not insects.mp3": [
		6065,
		7,
		4740
	],
	"./00003/00003-09/00003-09-08/0.jpg": [
		7052,
		7,
		5729
	],
	"./00003/00003-09/00003-09-08/1.jpg": [
		9806,
		7,
		9828
	],
	"./00003/00003-09/00003-09-08/2.jpg": [
		9807,
		7,
		9829
	],
	"./00003/00003-09/00003-09-08/3.jpg": [
		9808,
		7,
		9830
	],
	"./00003/00003-09/00003-09-08/4.jpg": [
		9809,
		7,
		9831
	],
	"./00003/00003-09/00003-09-08/5.jpg": [
		9810,
		7,
		9832
	],
	"./00003/00003-09/00003-09-08/6.jpg": [
		9811,
		7,
		9833
	],
	"./00003/00003-09/00003-09-08/7.jpg": [
		9812,
		7,
		9834
	],
	"./00003/00003-09/00003-09-08/big animals.mp3": [
		6066,
		7,
		4741
	],
	"./00003/00003-09/00003-09-08/he is as big as 2 kids.mp3": [
		6067,
		7,
		4742
	],
	"./00003/00003-09/00003-09-08/he is as big as 25 kids.mp3": [
		6068,
		7,
		4743
	],
	"./00003/00003-09/00003-09-08/he is as big as 5 kids.mp3": [
		6069,
		7,
		4744
	],
	"./00003/00003-09/00003-09-08/he is as big as 6 kids.mp3": [
		6070,
		7,
		4745
	],
	"./00003/00003-09/00003-09-08/here is a dinosaur.mp3": [
		6071,
		7,
		4746
	],
	"./00003/00003-09/00003-09-08/here is a squid.mp3": [
		6072,
		7,
		4747
	],
	"./00003/00003-09/00003-09-08/i can see a giraffe.mp3": [
		6073,
		7,
		4748
	],
	"./00003/00003-09/00003-09-08/i can see an ostrich.mp3": [
		6074,
		7,
		4749
	],
	"./00003/00003-09/00003-09-08/i see a whale.mp3": [
		6075,
		7,
		4750
	],
	"./00003/00003-09/00003-09-08/intro.mp3": [
		689,
		7
	],
	"./00003/00003-09/00003-09-08/look at the elephant.mp3": [
		6076,
		7,
		4751
	],
	"./00003/00003-09/00003-09-08/main idea.mp3": [
		1070,
		7
	],
	"./00003/00003-09/00003-09-08/module": [
		1502,
		9,
		366
	],
	"./00003/00003-09/00003-09-08/module.js": [
		1502,
		9,
		366
	],
	"./00003/00003-09/00003-09-08/she is as big as 10 kids.mp3": [
		6077,
		7,
		4752
	],
	"./00003/00003-09/00003-09-08/she is as big as 15 kids.mp3": [
		6078,
		7,
		4753
	],
	"./00003/00003-09/00003-09-08/she is as big as 30 kids.mp3": [
		6079,
		7,
		4754
	],
	"./00003/00003-09/00003-09-08/this dinosaur is huge.mp3": [
		6080,
		7,
		4755
	],
	"./00003/00003-09/00003-09-08/this elephant is big.mp3": [
		6081,
		7,
		4756
	],
	"./00003/00003-09/00003-09-08/this giraffe is big.mp3": [
		6082,
		7,
		4757
	],
	"./00003/00003-09/00003-09-08/this ostrich is big.mp3": [
		6083,
		7,
		4758
	],
	"./00003/00003-09/00003-09-08/this squid is big.mp3": [
		6084,
		7,
		4759
	],
	"./00003/00003-09/00003-09-08/this whale is big.mp3": [
		6085,
		7,
		4760
	],
	"./00003/00003-09/00003-09-08/this whale shark is big.mp3": [
		6086,
		7,
		4761
	],
	"./00003/00003-09/00003-09-09/0.jpg": [
		7053,
		7,
		5730
	],
	"./00003/00003-09/00003-09-09/1.jpg": [
		9813,
		7,
		9835
	],
	"./00003/00003-09/00003-09-09/2.jpg": [
		9814,
		7,
		9836
	],
	"./00003/00003-09/00003-09-09/3.jpg": [
		9815,
		7,
		9837
	],
	"./00003/00003-09/00003-09-09/4.jpg": [
		9816,
		7,
		9838
	],
	"./00003/00003-09/00003-09-09/5.jpg": [
		9817,
		7,
		9839
	],
	"./00003/00003-09/00003-09-09/6.jpg": [
		9818,
		7,
		9840
	],
	"./00003/00003-09/00003-09-09/7.jpg": [
		9819,
		7,
		9841
	],
	"./00003/00003-09/00003-09-09/animals we saw in the book.mp3": [
		6087,
		7,
		4762
	],
	"./00003/00003-09/00003-09-09/here is a cat.mp3": [
		6088,
		7,
		4763
	],
	"./00003/00003-09/00003-09-09/here is a frog.mp3": [
		6089,
		7,
		4764
	],
	"./00003/00003-09/00003-09-09/here is a shark.mp3": [
		6090,
		7,
		4765
	],
	"./00003/00003-09/00003-09-09/here is a skunk.mp3": [
		6091,
		7,
		4766
	],
	"./00003/00003-09/00003-09-09/intro.mp3": [
		690,
		7
	],
	"./00003/00003-09/00003-09-09/look at the dinosaurs.mp3": [
		6092,
		7,
		4767
	],
	"./00003/00003-09/00003-09-09/look at the eagle.mp3": [
		6093,
		7,
		4768
	],
	"./00003/00003-09/00003-09-09/look at the ladybug.mp3": [
		6094,
		7,
		4769
	],
	"./00003/00003-09/00003-09-09/look at the turtle.mp3": [
		6095,
		7,
		4770
	],
	"./00003/00003-09/00003-09-09/main idea.mp3": [
		1071,
		7
	],
	"./00003/00003-09/00003-09-09/module": [
		1503,
		9,
		367
	],
	"./00003/00003-09/00003-09-09/module.js": [
		1503,
		9,
		367
	],
	"./00003/00003-09/00003-09-09/the alligator is a reptile.mp3": [
		6096,
		7,
		4771
	],
	"./00003/00003-09/00003-09-09/the animal book.mp3": [
		6097,
		7,
		4772
	],
	"./00003/00003-09/00003-09-09/the cat is a mammal.mp3": [
		6098,
		7,
		4773
	],
	"./00003/00003-09/00003-09-09/the cat is in the book.mp3": [
		6099,
		7,
		4774
	],
	"./00003/00003-09/00003-09-09/the dinosaurs are in the book too.mp3": [
		6100,
		7,
		4775
	],
	"./00003/00003-09/00003-09-09/the dolphin is a mammal.mp3": [
		6101,
		7,
		4776
	],
	"./00003/00003-09/00003-09-09/the eagle is a bird.mp3": [
		6102,
		7,
		4777
	],
	"./00003/00003-09/00003-09-09/the eagle is in the book.mp3": [
		6103,
		7,
		4778
	],
	"./00003/00003-09/00003-09-09/the frog is an amphibian.mp3": [
		6104,
		7,
		4779
	],
	"./00003/00003-09/00003-09-09/the frog is in the book.mp3": [
		6105,
		7,
		4780
	],
	"./00003/00003-09/00003-09-09/the ladybug is an insect.mp3": [
		6106,
		7,
		4781
	],
	"./00003/00003-09/00003-09-09/the ladybug is in the book.mp3": [
		6107,
		7,
		4782
	],
	"./00003/00003-09/00003-09-09/the penguin is a bird.mp3": [
		6108,
		7,
		4783
	],
	"./00003/00003-09/00003-09-09/the seahorse is a fish.mp3": [
		6109,
		7,
		4784
	],
	"./00003/00003-09/00003-09-09/the shark is a fish.mp3": [
		6110,
		7,
		4785
	],
	"./00003/00003-09/00003-09-09/the shark is in the book.mp3": [
		6111,
		7,
		4786
	],
	"./00003/00003-09/00003-09-09/the skunk is a mammal.mp3": [
		6112,
		7,
		4787
	],
	"./00003/00003-09/00003-09-09/the skunk is in the book.mp3": [
		6113,
		7,
		4788
	],
	"./00003/00003-09/00003-09-09/the turtle is a reptile.mp3": [
		6114,
		7,
		4789
	],
	"./00003/00003-09/00003-09-09/the turtle is in the book.mp3": [
		6115,
		7,
		4790
	],
	"./00003/00003-09/00003-09-09/the whale is a mammal.mp3": [
		6116,
		7,
		4791
	],
	"./00003/00003-09/00003-09-10/0.jpg": [
		7054,
		7,
		5731
	],
	"./00003/00003-09/00003-09-10/1.jpg": [
		9820,
		7,
		9842
	],
	"./00003/00003-09/00003-09-10/2.jpg": [
		9821,
		7,
		9843
	],
	"./00003/00003-09/00003-09-10/3.jpg": [
		9822,
		7,
		9844
	],
	"./00003/00003-09/00003-09-10/4.jpg": [
		9823,
		7,
		9845
	],
	"./00003/00003-09/00003-09-10/5.jpg": [
		9824,
		7,
		9846
	],
	"./00003/00003-09/00003-09-10/6.jpg": [
		9825,
		7,
		9847
	],
	"./00003/00003-09/00003-09-10/7.jpg": [
		9826,
		7,
		9848
	],
	"./00003/00003-09/00003-09-10/dinosaurs.mp3": [
		6117,
		7,
		4792
	],
	"./00003/00003-09/00003-09-10/i am a long neck dinosaur.mp3": [
		6118,
		7,
		4793
	],
	"./00003/00003-09/00003-09-10/i am a pterosaur.mp3": [
		6119,
		7,
		4794
	],
	"./00003/00003-09/00003-09-10/i am a raptor.mp3": [
		6120,
		7,
		4795
	],
	"./00003/00003-09/00003-09-10/i am a stegosaurus.mp3": [
		6121,
		7,
		4796
	],
	"./00003/00003-09/00003-09-10/i am a swimming dinosaur.mp3": [
		6122,
		7,
		4797
	],
	"./00003/00003-09/00003-09-10/i am a t rex.mp3": [
		6123,
		7,
		4798
	],
	"./00003/00003-09/00003-09-10/i am a triceratops.mp3": [
		6124,
		7,
		4799
	],
	"./00003/00003-09/00003-09-10/i can fly.mp3": [
		6125,
		7,
		4800
	],
	"./00003/00003-09/00003-09-10/i can swim.mp3": [
		6126,
		7,
		4801
	],
	"./00003/00003-09/00003-09-10/i eat meat too.mp3": [
		6127,
		7,
		4802
	],
	"./00003/00003-09/00003-09-10/i eat meat.mp3": [
		6128,
		7,
		4803
	],
	"./00003/00003-09/00003-09-10/i eat plants too.mp3": [
		6129,
		7,
		4804
	],
	"./00003/00003-09/00003-09-10/i eat plants.mp3": [
		6130,
		7,
		4805
	],
	"./00003/00003-09/00003-09-10/i have 3 horns.mp3": [
		6131,
		7,
		4806
	],
	"./00003/00003-09/00003-09-10/intro.mp3": [
		691,
		7
	],
	"./00003/00003-09/00003-09-10/look at me.mp3": [
		6132,
		7,
		4807
	],
	"./00003/00003-09/00003-09-10/main idea.mp3": [
		1072,
		7
	],
	"./00003/00003-09/00003-09-10/module": [
		1504,
		9,
		368
	],
	"./00003/00003-09/00003-09-10/module.js": [
		1504,
		9,
		368
	],
	"./00003/00003-09/animal groups.mp3": [
		6133,
		7,
		4808
	],
	"./00003/00003-09/cover.jpg": [
		7055,
		7,
		5732
	],
	"./00003/00003-09/unit": [
		1505,
		9,
		369
	],
	"./00003/00003-09/unit.js": [
		1505,
		9,
		369
	],
	"./00003/00003-10/00003-10-01/0.jpg": [
		7056,
		7,
		5733
	],
	"./00003/00003-10/00003-10-01/1.jpg": [
		9827,
		7,
		9849
	],
	"./00003/00003-10/00003-10-01/2.jpg": [
		9828,
		7,
		9850
	],
	"./00003/00003-10/00003-10-01/3.jpg": [
		9829,
		7,
		9851
	],
	"./00003/00003-10/00003-10-01/4.jpg": [
		9830,
		7,
		9852
	],
	"./00003/00003-10/00003-10-01/5.jpg": [
		9831,
		7,
		9853
	],
	"./00003/00003-10/00003-10-01/6.jpg": [
		9832,
		7,
		9854
	],
	"./00003/00003-10/00003-10-01/7.jpg": [
		9833,
		7,
		9855
	],
	"./00003/00003-10/00003-10-01/animals with 4 legs.mp3": [
		6134,
		7,
		4809
	],
	"./00003/00003-10/00003-10-01/butterflies are insects.mp3": [
		6135,
		7,
		4810
	],
	"./00003/00003-10/00003-10-01/butterflies have 6 legs.mp3": [
		6136,
		7,
		4811
	],
	"./00003/00003-10/00003-10-01/fish have no legs.mp3": [
		6137,
		7,
		4812
	],
	"./00003/00003-10/00003-10-01/i am a bird.mp3": [
		6138,
		7,
		4813
	],
	"./00003/00003-10/00003-10-01/i am a butterfly.mp3": [
		6139,
		7,
		4814
	],
	"./00003/00003-10/00003-10-01/i am a dog.mp3": [
		6140,
		7,
		4815
	],
	"./00003/00003-10/00003-10-01/i am a fish.mp3": [
		6141,
		7,
		4816
	],
	"./00003/00003-10/00003-10-01/i am a ladybug.mp3": [
		6142,
		7,
		4817
	],
	"./00003/00003-10/00003-10-01/i am a monster.mp3": [
		6143,
		7,
		4818
	],
	"./00003/00003-10/00003-10-01/i am a parrot.mp3": [
		6144,
		7,
		4819
	],
	"./00003/00003-10/00003-10-01/i am a spider.mp3": [
		6145,
		7,
		4820
	],
	"./00003/00003-10/00003-10-01/i am a squid.mp3": [
		6146,
		7,
		4821
	],
	"./00003/00003-10/00003-10-01/i am an insect.mp3": [
		6147,
		7,
		4822
	],
	"./00003/00003-10/00003-10-01/i have 10 legs.mp3": [
		6148,
		7,
		4823
	],
	"./00003/00003-10/00003-10-01/i have 12 legs.mp3": [
		6149,
		7,
		4824
	],
	"./00003/00003-10/00003-10-01/i have 2 legs.mp3": [
		6150,
		7,
		4825
	],
	"./00003/00003-10/00003-10-01/i have 3 legs.mp3": [
		6151,
		7,
		4826
	],
	"./00003/00003-10/00003-10-01/i have 4 legs.mp3": [
		6152,
		7,
		4827
	],
	"./00003/00003-10/00003-10-01/i have 6 legs.mp3": [
		6153,
		7,
		4828
	],
	"./00003/00003-10/00003-10-01/i have 8 legs.mp3": [
		6154,
		7,
		4829
	],
	"./00003/00003-10/00003-10-01/intro.mp3": [
		692,
		7
	],
	"./00003/00003-10/00003-10-01/legs.mp3": [
		6155,
		7,
		4830
	],
	"./00003/00003-10/00003-10-01/main idea.mp3": [
		1073,
		7
	],
	"./00003/00003-10/00003-10-01/module": [
		1506,
		9,
		370
	],
	"./00003/00003-10/00003-10-01/module.js": [
		1506,
		9,
		370
	],
	"./00003/00003-10/00003-10-01/parrots have 2 legs.mp3": [
		6156,
		7,
		4831
	],
	"./00003/00003-10/00003-10-01/spiders are not insects.mp3": [
		6157,
		7,
		4832
	],
	"./00003/00003-10/00003-10-01/spiders have 8 legs.mp3": [
		6158,
		7,
		4833
	],
	"./00003/00003-10/00003-10-02/0.jpg": [
		7057,
		7,
		5734
	],
	"./00003/00003-10/00003-10-02/1.jpg": [
		9834,
		7,
		9856
	],
	"./00003/00003-10/00003-10-02/2.jpg": [
		9835,
		7,
		9857
	],
	"./00003/00003-10/00003-10-02/3.jpg": [
		9836,
		7,
		9858
	],
	"./00003/00003-10/00003-10-02/4.jpg": [
		9837,
		7,
		9859
	],
	"./00003/00003-10/00003-10-02/5.jpg": [
		9838,
		7,
		9860
	],
	"./00003/00003-10/00003-10-02/6.jpg": [
		9839,
		7,
		9861
	],
	"./00003/00003-10/00003-10-02/7.jpg": [
		9840,
		7,
		9862
	],
	"./00003/00003-10/00003-10-02/animals with spots.mp3": [
		6159,
		7,
		4834
	],
	"./00003/00003-10/00003-10-02/here is a dinosaur.mp3": [
		6160,
		7,
		4835
	],
	"./00003/00003-10/00003-10-02/here is a raccoon.mp3": [
		6161,
		7,
		4836
	],
	"./00003/00003-10/00003-10-02/i can see a giraffe.mp3": [
		6162,
		7,
		4837
	],
	"./00003/00003-10/00003-10-02/i like the tiger.mp3": [
		6163,
		7,
		4838
	],
	"./00003/00003-10/00003-10-02/i like the zebra.mp3": [
		6164,
		7,
		4839
	],
	"./00003/00003-10/00003-10-02/i see a deer.mp3": [
		6165,
		7,
		4840
	],
	"./00003/00003-10/00003-10-02/intro.mp3": [
		693,
		7
	],
	"./00003/00003-10/00003-10-02/look at the ladybug.mp3": [
		6166,
		7,
		4841
	],
	"./00003/00003-10/00003-10-02/main idea.mp3": [
		1074,
		7
	],
	"./00003/00003-10/00003-10-02/module": [
		1507,
		9,
		371
	],
	"./00003/00003-10/00003-10-02/module.js": [
		1507,
		9,
		371
	],
	"./00003/00003-10/00003-10-02/stripes and spots.mp3": [
		6167,
		7,
		4842
	],
	"./00003/00003-10/00003-10-02/the deer has spots.mp3": [
		6168,
		7,
		4843
	],
	"./00003/00003-10/00003-10-02/the dinosaur has spots too.mp3": [
		6169,
		7,
		4844
	],
	"./00003/00003-10/00003-10-02/the giraffe has spots.mp3": [
		6170,
		7,
		4845
	],
	"./00003/00003-10/00003-10-02/the ladybug has spots.mp3": [
		6171,
		7,
		4846
	],
	"./00003/00003-10/00003-10-02/the raccoon has stripes.mp3": [
		6172,
		7,
		4847
	],
	"./00003/00003-10/00003-10-02/the tiger has stripes.mp3": [
		6173,
		7,
		4848
	],
	"./00003/00003-10/00003-10-02/the zebra has stripes.mp3": [
		6174,
		7,
		4849
	],
	"./00003/00003-10/00003-10-03/0.jpg": [
		7058,
		7,
		5735
	],
	"./00003/00003-10/00003-10-03/1.jpg": [
		9841,
		7,
		9863
	],
	"./00003/00003-10/00003-10-03/2.jpg": [
		9842,
		7,
		9864
	],
	"./00003/00003-10/00003-10-03/3.jpg": [
		9843,
		7,
		9865
	],
	"./00003/00003-10/00003-10-03/4.jpg": [
		9844,
		7,
		9866
	],
	"./00003/00003-10/00003-10-03/5.jpg": [
		9845,
		7,
		9867
	],
	"./00003/00003-10/00003-10-03/6.jpg": [
		9846,
		7,
		9868
	],
	"./00003/00003-10/00003-10-03/7.jpg": [
		9847,
		7,
		9869
	],
	"./00003/00003-10/00003-10-03/animals with 2 eyes.mp3": [
		6175,
		7,
		4850
	],
	"./00003/00003-10/00003-10-03/eyes.mp3": [
		6176,
		7,
		4851
	],
	"./00003/00003-10/00003-10-03/i am a bird.mp3": [
		6177,
		7,
		4852
	],
	"./00003/00003-10/00003-10-03/i am a fish.mp3": [
		6178,
		7,
		4853
	],
	"./00003/00003-10/00003-10-03/i am a green frog.mp3": [
		6179,
		7,
		4854
	],
	"./00003/00003-10/00003-10-03/i am a green grasshopper.mp3": [
		6180,
		7,
		4855
	],
	"./00003/00003-10/00003-10-03/i am a hammerhead shark.mp3": [
		6181,
		7,
		4856
	],
	"./00003/00003-10/00003-10-03/i am a monster.mp3": [
		6182,
		7,
		4857
	],
	"./00003/00003-10/00003-10-03/i am a spider.mp3": [
		6183,
		7,
		4858
	],
	"./00003/00003-10/00003-10-03/i am a starfish.mp3": [
		6184,
		7,
		4859
	],
	"./00003/00003-10/00003-10-03/i am an amphibian.mp3": [
		6185,
		7,
		4860
	],
	"./00003/00003-10/00003-10-03/i am an insect.mp3": [
		6186,
		7,
		4861
	],
	"./00003/00003-10/00003-10-03/i am an owl.mp3": [
		6187,
		7,
		4862
	],
	"./00003/00003-10/00003-10-03/i am not a fish.mp3": [
		6188,
		7,
		4863
	],
	"./00003/00003-10/00003-10-03/i have 10 eyes.mp3": [
		6189,
		7,
		4864
	],
	"./00003/00003-10/00003-10-03/i have 2 eyes.mp3": [
		6190,
		7,
		4865
	],
	"./00003/00003-10/00003-10-03/i have 5 eyes.mp3": [
		6191,
		7,
		4866
	],
	"./00003/00003-10/00003-10-03/i have 8 eyes.mp3": [
		6192,
		7,
		4867
	],
	"./00003/00003-10/00003-10-03/i have 8 legs.mp3": [
		6193,
		7,
		4868
	],
	"./00003/00003-10/00003-10-03/intro.mp3": [
		694,
		7
	],
	"./00003/00003-10/00003-10-03/look at my eyes.mp3": [
		6194,
		7,
		4869
	],
	"./00003/00003-10/00003-10-03/main idea.mp3": [
		1075,
		7
	],
	"./00003/00003-10/00003-10-03/module": [
		1508,
		9,
		372
	],
	"./00003/00003-10/00003-10-03/module.js": [
		1508,
		9,
		372
	],
	"./00003/00003-10/00003-10-04/0.jpg": [
		7059,
		7,
		5736
	],
	"./00003/00003-10/00003-10-04/1.jpg": [
		9848,
		7,
		9870
	],
	"./00003/00003-10/00003-10-04/2.jpg": [
		9849,
		7,
		9871
	],
	"./00003/00003-10/00003-10-04/3.jpg": [
		9850,
		7,
		9872
	],
	"./00003/00003-10/00003-10-04/4.jpg": [
		9851,
		7,
		9873
	],
	"./00003/00003-10/00003-10-04/5.jpg": [
		9852,
		7,
		9874
	],
	"./00003/00003-10/00003-10-04/6.jpg": [
		9853,
		7,
		9875
	],
	"./00003/00003-10/00003-10-04/7.jpg": [
		9854,
		7,
		9876
	],
	"./00003/00003-10/00003-10-04/animals with 2 horns.mp3": [
		6195,
		7,
		4870
	],
	"./00003/00003-10/00003-10-04/here is a dinosaur.mp3": [
		6196,
		7,
		4871
	],
	"./00003/00003-10/00003-10-04/here is a goat.mp3": [
		6197,
		7,
		4872
	],
	"./00003/00003-10/00003-10-04/here is a monster.mp3": [
		6198,
		7,
		4873
	],
	"./00003/00003-10/00003-10-04/horns.mp3": [
		6199,
		7,
		4874
	],
	"./00003/00003-10/00003-10-04/i can see a giraffe.mp3": [
		6200,
		7,
		4875
	],
	"./00003/00003-10/00003-10-04/i can see a rhino.mp3": [
		6201,
		7,
		4876
	],
	"./00003/00003-10/00003-10-04/i see the unicorn.mp3": [
		6202,
		7,
		4877
	],
	"./00003/00003-10/00003-10-04/intro.mp3": [
		695,
		7
	],
	"./00003/00003-10/00003-10-04/look at the cow.mp3": [
		6203,
		7,
		4878
	],
	"./00003/00003-10/00003-10-04/main idea.mp3": [
		1076,
		7
	],
	"./00003/00003-10/00003-10-04/module": [
		1509,
		9,
		373
	],
	"./00003/00003-10/00003-10-04/module.js": [
		1509,
		9,
		373
	],
	"./00003/00003-10/00003-10-04/the cow has 2 horns.mp3": [
		6204,
		7,
		4879
	],
	"./00003/00003-10/00003-10-04/the dinosaur has 3 horns.mp3": [
		6205,
		7,
		4880
	],
	"./00003/00003-10/00003-10-04/the giraffe has 2 horns.mp3": [
		6206,
		7,
		4881
	],
	"./00003/00003-10/00003-10-04/the goat has 2 horns.mp3": [
		6207,
		7,
		4882
	],
	"./00003/00003-10/00003-10-04/the monster has horns too.mp3": [
		6208,
		7,
		4883
	],
	"./00003/00003-10/00003-10-04/the rhino has 2 horns.mp3": [
		6209,
		7,
		4884
	],
	"./00003/00003-10/00003-10-04/the unicorn has 1 horn.mp3": [
		6210,
		7,
		4885
	],
	"./00003/00003-10/00003-10-05/0.jpg": [
		7060,
		7,
		5737
	],
	"./00003/00003-10/00003-10-05/1.jpg": [
		9855,
		7,
		9877
	],
	"./00003/00003-10/00003-10-05/2.jpg": [
		9856,
		7,
		9878
	],
	"./00003/00003-10/00003-10-05/3.jpg": [
		9857,
		7,
		9879
	],
	"./00003/00003-10/00003-10-05/4.jpg": [
		9858,
		7,
		9880
	],
	"./00003/00003-10/00003-10-05/5.jpg": [
		9859,
		7,
		9881
	],
	"./00003/00003-10/00003-10-05/6.jpg": [
		9860,
		7,
		9882
	],
	"./00003/00003-10/00003-10-05/7.jpg": [
		9861,
		7,
		9883
	],
	"./00003/00003-10/00003-10-05/animals with long necks.mp3": [
		6211,
		7,
		4886
	],
	"./00003/00003-10/00003-10-05/here comes the ostrich.mp3": [
		6212,
		7,
		4887
	],
	"./00003/00003-10/00003-10-05/here is a rhino.mp3": [
		6213,
		7,
		4888
	],
	"./00003/00003-10/00003-10-05/i can see a flamingo.mp3": [
		6214,
		7,
		4889
	],
	"./00003/00003-10/00003-10-05/i can see a goose.mp3": [
		6215,
		7,
		4890
	],
	"./00003/00003-10/00003-10-05/i can see a seal.mp3": [
		6216,
		7,
		4891
	],
	"./00003/00003-10/00003-10-05/i can see a snake.mp3": [
		6217,
		7,
		4892
	],
	"./00003/00003-10/00003-10-05/i see a pink pig.mp3": [
		6218,
		7,
		4893
	],
	"./00003/00003-10/00003-10-05/intro.mp3": [
		696,
		7
	],
	"./00003/00003-10/00003-10-05/look at the dinosaur.mp3": [
		6219,
		7,
		4894
	],
	"./00003/00003-10/00003-10-05/look at the giraffe.mp3": [
		6220,
		7,
		4895
	],
	"./00003/00003-10/00003-10-05/main idea.mp3": [
		1077,
		7
	],
	"./00003/00003-10/00003-10-05/module": [
		1510,
		9,
		374
	],
	"./00003/00003-10/00003-10-05/module.js": [
		1510,
		9,
		374
	],
	"./00003/00003-10/00003-10-05/necks.mp3": [
		6221,
		7,
		4896
	],
	"./00003/00003-10/00003-10-05/the dinosaur has a long neck too.mp3": [
		6222,
		7,
		4897
	],
	"./00003/00003-10/00003-10-05/the giraffe has a long neck.mp3": [
		6223,
		7,
		4898
	],
	"./00003/00003-10/00003-10-05/the goose has a long neck.mp3": [
		6224,
		7,
		4899
	],
	"./00003/00003-10/00003-10-05/the ostrich has a long neck.mp3": [
		6225,
		7,
		4900
	],
	"./00003/00003-10/00003-10-05/the pig has a short neck.mp3": [
		6226,
		7,
		4901
	],
	"./00003/00003-10/00003-10-05/the rhino has a short neck.mp3": [
		6227,
		7,
		4902
	],
	"./00003/00003-10/00003-10-05/the seal has a short neck.mp3": [
		6228,
		7,
		4903
	],
	"./00003/00003-10/00003-10-05/this giraffe is big.mp3": [
		6229,
		7,
		4904
	],
	"./00003/00003-10/00003-10-05/this ostrich is big.mp3": [
		6230,
		7,
		4905
	],
	"./00003/00003-10/00003-10-06/0.jpg": [
		7061,
		7,
		5738
	],
	"./00003/00003-10/00003-10-06/1.jpg": [
		9862,
		7,
		9884
	],
	"./00003/00003-10/00003-10-06/2.jpg": [
		9863,
		7,
		9885
	],
	"./00003/00003-10/00003-10-06/3.jpg": [
		9864,
		7,
		9886
	],
	"./00003/00003-10/00003-10-06/4.jpg": [
		9865,
		7,
		9887
	],
	"./00003/00003-10/00003-10-06/5.jpg": [
		9866,
		7,
		9888
	],
	"./00003/00003-10/00003-10-06/6.jpg": [
		9867,
		7,
		9889
	],
	"./00003/00003-10/00003-10-06/7.jpg": [
		9868,
		7,
		9890
	],
	"./00003/00003-10/00003-10-06/animals we saw in the book.mp3": [
		6231,
		7,
		4906
	],
	"./00003/00003-10/00003-10-06/here is a dinosaur.mp3": [
		6232,
		7,
		4907
	],
	"./00003/00003-10/00003-10-06/i see a beaver.mp3": [
		6233,
		7,
		4908
	],
	"./00003/00003-10/00003-10-06/i see a bird.mp3": [
		6234,
		7,
		4909
	],
	"./00003/00003-10/00003-10-06/i see a walrus.mp3": [
		6235,
		7,
		4910
	],
	"./00003/00003-10/00003-10-06/intro.mp3": [
		697,
		7
	],
	"./00003/00003-10/00003-10-06/look at the bat.mp3": [
		6236,
		7,
		4911
	],
	"./00003/00003-10/00003-10-06/look at the eel.mp3": [
		6237,
		7,
		4912
	],
	"./00003/00003-10/00003-10-06/look at the elephant.mp3": [
		6238,
		7,
		4913
	],
	"./00003/00003-10/00003-10-06/main idea.mp3": [
		1078,
		7
	],
	"./00003/00003-10/00003-10-06/module": [
		1511,
		9,
		375
	],
	"./00003/00003-10/00003-10-06/module.js": [
		1511,
		9,
		375
	],
	"./00003/00003-10/00003-10-06/teeth.mp3": [
		6239,
		7,
		4914
	],
	"./00003/00003-10/00003-10-06/the alligator has sharp teeth.mp3": [
		6240,
		7,
		4915
	],
	"./00003/00003-10/00003-10-06/the bat has sharp teeth.mp3": [
		6241,
		7,
		4916
	],
	"./00003/00003-10/00003-10-06/the bat likes insects.mp3": [
		6242,
		7,
		4917
	],
	"./00003/00003-10/00003-10-06/the beaver has long teeth.mp3": [
		6243,
		7,
		4918
	],
	"./00003/00003-10/00003-10-06/the beaver lives at the pond.mp3": [
		6244,
		7,
		4919
	],
	"./00003/00003-10/00003-10-06/the bird has no teeth.mp3": [
		6245,
		7,
		4920
	],
	"./00003/00003-10/00003-10-06/the dinosaur has sharp teeth.mp3": [
		6246,
		7,
		4921
	],
	"./00003/00003-10/00003-10-06/the eel has sharp teeth.mp3": [
		6247,
		7,
		4922
	],
	"./00003/00003-10/00003-10-06/the elephant has big ears.mp3": [
		6248,
		7,
		4923
	],
	"./00003/00003-10/00003-10-06/the elephant has long teeth.mp3": [
		6249,
		7,
		4924
	],
	"./00003/00003-10/00003-10-06/the shark has sharp teeth.mp3": [
		6250,
		7,
		4925
	],
	"./00003/00003-10/00003-10-06/the walrus has long teeth.mp3": [
		6251,
		7,
		4926
	],
	"./00003/00003-10/00003-10-07/0.jpg": [
		7062,
		7,
		5739
	],
	"./00003/00003-10/00003-10-07/1.jpg": [
		9869,
		7,
		9891
	],
	"./00003/00003-10/00003-10-07/2.jpg": [
		9870,
		7,
		9892
	],
	"./00003/00003-10/00003-10-07/3.jpg": [
		9871,
		7,
		9893
	],
	"./00003/00003-10/00003-10-07/4.jpg": [
		9872,
		7,
		9894
	],
	"./00003/00003-10/00003-10-07/5.jpg": [
		9873,
		7,
		9895
	],
	"./00003/00003-10/00003-10-07/6.jpg": [
		9874,
		7,
		9896
	],
	"./00003/00003-10/00003-10-07/7.jpg": [
		9875,
		7,
		9897
	],
	"./00003/00003-10/00003-10-07/animals with 2 feet.mp3": [
		6252,
		7,
		4927
	],
	"./00003/00003-10/00003-10-07/feet.mp3": [
		6253,
		7,
		4928
	],
	"./00003/00003-10/00003-10-07/i have 1 foot said the slug.mp3": [
		6254,
		7,
		4929
	],
	"./00003/00003-10/00003-10-07/i have 1 foot said the snail.mp3": [
		6255,
		7,
		4930
	],
	"./00003/00003-10/00003-10-07/i have 2 feet said the duck.mp3": [
		6256,
		7,
		4931
	],
	"./00003/00003-10/00003-10-07/i have 2 feet.mp3": [
		6257,
		7,
		4932
	],
	"./00003/00003-10/00003-10-07/i have 4 feet said the frog.mp3": [
		6258,
		7,
		4933
	],
	"./00003/00003-10/00003-10-07/i have 4 feet.mp3": [
		6259,
		7,
		4934
	],
	"./00003/00003-10/00003-10-07/i have no feet said the whale.mp3": [
		6260,
		7,
		4935
	],
	"./00003/00003-10/00003-10-07/intro.mp3": [
		698,
		7
	],
	"./00003/00003-10/00003-10-07/look at me.mp3": [
		6261,
		7,
		4936
	],
	"./00003/00003-10/00003-10-07/look at my feet said the bird (2).mp3": [
		6262,
		7,
		4937
	],
	"./00003/00003-10/00003-10-07/look at my feet said the bird.mp3": [
		6263,
		7,
		4938
	],
	"./00003/00003-10/00003-10-07/look at my feet said the raccoon.mp3": [
		6264,
		7,
		4939
	],
	"./00003/00003-10/00003-10-07/look at my feet.mp3": [
		6265,
		7,
		4940
	],
	"./00003/00003-10/00003-10-07/look at my foot.mp3": [
		6266,
		7,
		4941
	],
	"./00003/00003-10/00003-10-07/main idea.mp3": [
		1079,
		7
	],
	"./00003/00003-10/00003-10-07/module": [
		1512,
		9,
		376
	],
	"./00003/00003-10/00003-10-07/module.js": [
		1512,
		9,
		376
	],
	"./00003/00003-10/00003-10-08/0.jpg": [
		7063,
		7,
		5740
	],
	"./00003/00003-10/00003-10-08/1.jpg": [
		9876,
		7,
		9898
	],
	"./00003/00003-10/00003-10-08/2.jpg": [
		9877,
		7,
		9899
	],
	"./00003/00003-10/00003-10-08/3.jpg": [
		9878,
		7,
		9900
	],
	"./00003/00003-10/00003-10-08/4.jpg": [
		9879,
		7,
		9901
	],
	"./00003/00003-10/00003-10-08/5.jpg": [
		9880,
		7,
		9902
	],
	"./00003/00003-10/00003-10-08/6.jpg": [
		9881,
		7,
		9903
	],
	"./00003/00003-10/00003-10-08/7.jpg": [
		9882,
		7,
		9904
	],
	"./00003/00003-10/00003-10-08/animals with shells.mp3": [
		6267,
		7,
		4942
	],
	"./00003/00003-10/00003-10-08/do you.mp3": [
		6268,
		7,
		4943
	],
	"./00003/00003-10/00003-10-08/i do not have a shell.mp3": [
		6269,
		7,
		4944
	],
	"./00003/00003-10/00003-10-08/i have a shell said the hermit crab.mp3": [
		6270,
		7,
		4945
	],
	"./00003/00003-10/00003-10-08/i have a shell said the lobster.mp3": [
		6271,
		7,
		4946
	],
	"./00003/00003-10/00003-10-08/i have a shell said the snail.mp3": [
		6272,
		7,
		4947
	],
	"./00003/00003-10/00003-10-08/i have a shell said the turtle.mp3": [
		6273,
		7,
		4948
	],
	"./00003/00003-10/00003-10-08/intro.mp3": [
		699,
		7
	],
	"./00003/00003-10/00003-10-08/look at my shell.mp3": [
		6274,
		7,
		4949
	],
	"./00003/00003-10/00003-10-08/main idea.mp3": [
		1080,
		7
	],
	"./00003/00003-10/00003-10-08/module": [
		1513,
		9,
		377
	],
	"./00003/00003-10/00003-10-08/module.js": [
		1513,
		9,
		377
	],
	"./00003/00003-10/00003-10-08/no said the fish.mp3": [
		6275,
		7,
		4950
	],
	"./00003/00003-10/00003-10-08/no said the frog.mp3": [
		6276,
		7,
		4951
	],
	"./00003/00003-10/00003-10-08/no said the slug.mp3": [
		6277,
		7,
		4952
	],
	"./00003/00003-10/00003-10-08/shells.mp3": [
		6278,
		7,
		4953
	],
	"./00003/00003-10/00003-10-09/0.jpg": [
		7064,
		7,
		5741
	],
	"./00003/00003-10/00003-10-09/1.jpg": [
		9883,
		7,
		9905
	],
	"./00003/00003-10/00003-10-09/2.jpg": [
		9884,
		7,
		9906
	],
	"./00003/00003-10/00003-10-09/3.jpg": [
		9885,
		7,
		9907
	],
	"./00003/00003-10/00003-10-09/4.jpg": [
		9886,
		7,
		9908
	],
	"./00003/00003-10/00003-10-09/5.jpg": [
		9887,
		7,
		9909
	],
	"./00003/00003-10/00003-10-09/6.jpg": [
		9888,
		7,
		9910
	],
	"./00003/00003-10/00003-10-09/7.jpg": [
		9889,
		7,
		9911
	],
	"./00003/00003-10/00003-10-09/animals with long noses.mp3": [
		6279,
		7,
		4954
	],
	"./00003/00003-10/00003-10-09/animals with short noses.mp3": [
		6280,
		7,
		4955
	],
	"./00003/00003-10/00003-10-09/he has a long nose.mp3": [
		6281,
		7,
		4956
	],
	"./00003/00003-10/00003-10-09/i have a long nose said the alligator.mp3": [
		6282,
		7,
		4957
	],
	"./00003/00003-10/00003-10-09/i have a long nose said the dog.mp3": [
		6283,
		7,
		4958
	],
	"./00003/00003-10/00003-10-09/i have a long nose said the elephant.mp3": [
		6284,
		7,
		4959
	],
	"./00003/00003-10/00003-10-09/i have a long nose said the monster.mp3": [
		6285,
		7,
		4960
	],
	"./00003/00003-10/00003-10-09/i have a short nose said the cat.mp3": [
		6286,
		7,
		4961
	],
	"./00003/00003-10/00003-10-09/i have a short nose said the dog.mp3": [
		6287,
		7,
		4962
	],
	"./00003/00003-10/00003-10-09/i have a short nose said the pig.mp3": [
		6288,
		7,
		4963
	],
	"./00003/00003-10/00003-10-09/i see the alligator.mp3": [
		6289,
		7,
		4964
	],
	"./00003/00003-10/00003-10-09/i see the dog.mp3": [
		6290,
		7,
		4965
	],
	"./00003/00003-10/00003-10-09/i see the elephant.mp3": [
		6291,
		7,
		4966
	],
	"./00003/00003-10/00003-10-09/i see the monster.mp3": [
		6292,
		7,
		4967
	],
	"./00003/00003-10/00003-10-09/i see the seahorse.mp3": [
		6293,
		7,
		4968
	],
	"./00003/00003-10/00003-10-09/i see the swordfish.mp3": [
		6294,
		7,
		4969
	],
	"./00003/00003-10/00003-10-09/intro.mp3": [
		700,
		7
	],
	"./00003/00003-10/00003-10-09/look at my nose.mp3": [
		6295,
		7,
		4970
	],
	"./00003/00003-10/00003-10-09/look at the anteater.mp3": [
		6296,
		7,
		4971
	],
	"./00003/00003-10/00003-10-09/main idea.mp3": [
		1081,
		7
	],
	"./00003/00003-10/00003-10-09/module": [
		1514,
		9,
		378
	],
	"./00003/00003-10/00003-10-09/module.js": [
		1514,
		9,
		378
	],
	"./00003/00003-10/00003-10-09/noses.mp3": [
		6297,
		7,
		4972
	],
	"./00003/00003-10/00003-10-09/not me.mp3": [
		6298,
		7,
		4973
	],
	"./00003/00003-10/00003-10-09/she has a long nose.mp3": [
		6299,
		7,
		4974
	],
	"./00003/00003-10/00003-10-10/0.jpg": [
		7065,
		7,
		5742
	],
	"./00003/00003-10/00003-10-10/1.jpg": [
		9890,
		7,
		9912
	],
	"./00003/00003-10/00003-10-10/2.jpg": [
		9891,
		7,
		9913
	],
	"./00003/00003-10/00003-10-10/3.jpg": [
		9892,
		7,
		9914
	],
	"./00003/00003-10/00003-10-10/4.jpg": [
		9893,
		7,
		9915
	],
	"./00003/00003-10/00003-10-10/5.jpg": [
		9894,
		7,
		9916
	],
	"./00003/00003-10/00003-10-10/6.jpg": [
		9895,
		7,
		9917
	],
	"./00003/00003-10/00003-10-10/7.jpg": [
		9896,
		7,
		9918
	],
	"./00003/00003-10/00003-10-10/animals with big ears.mp3": [
		6300,
		7,
		4975
	],
	"./00003/00003-10/00003-10-10/ears.mp3": [
		6301,
		7,
		4976
	],
	"./00003/00003-10/00003-10-10/here is a donkey.mp3": [
		6302,
		7,
		4977
	],
	"./00003/00003-10/00003-10-10/i can see the orange tiger.mp3": [
		6303,
		7,
		4978
	],
	"./00003/00003-10/00003-10-10/i like the elephant.mp3": [
		6304,
		7,
		4979
	],
	"./00003/00003-10/00003-10-10/i like the rabbit.mp3": [
		6305,
		7,
		4980
	],
	"./00003/00003-10/00003-10-10/i see the seal.mp3": [
		6306,
		7,
		4981
	],
	"./00003/00003-10/00003-10-10/intro.mp3": [
		701,
		7
	],
	"./00003/00003-10/00003-10-10/look at the bear.mp3": [
		6307,
		7,
		4982
	],
	"./00003/00003-10/00003-10-10/look at the kangaroo.mp3": [
		6308,
		7,
		4983
	],
	"./00003/00003-10/00003-10-10/main idea.mp3": [
		1082,
		7
	],
	"./00003/00003-10/00003-10-10/module": [
		1515,
		9,
		379
	],
	"./00003/00003-10/00003-10-10/module.js": [
		1515,
		9,
		379
	],
	"./00003/00003-10/00003-10-10/the bear has little ears too.mp3": [
		6309,
		7,
		4984
	],
	"./00003/00003-10/00003-10-10/the donkey has big ears too.mp3": [
		6310,
		7,
		4985
	],
	"./00003/00003-10/00003-10-10/the elephant has big ears.mp3": [
		6311,
		7,
		4986
	],
	"./00003/00003-10/00003-10-10/the kangaroo has big ears too.mp3": [
		6312,
		7,
		4987
	],
	"./00003/00003-10/00003-10-10/the rabbit has big ears.mp3": [
		6313,
		7,
		4988
	],
	"./00003/00003-10/00003-10-10/the seal has no ears.mp3": [
		6314,
		7,
		4989
	],
	"./00003/00003-10/00003-10-10/the tiger has little ears.mp3": [
		6315,
		7,
		4990
	],
	"./00003/00003-10/cover.jpg": [
		7066,
		7,
		5743
	],
	"./00003/00003-10/creature features.mp3": [
		6316,
		7,
		4991
	],
	"./00003/00003-10/unit": [
		1516,
		9,
		380
	],
	"./00003/00003-10/unit.js": [
		1516,
		9,
		380
	],
	"./00003/00003-11/00003-11-01/0.jpg": [
		7067,
		7,
		5744
	],
	"./00003/00003-11/00003-11-01/1.jpg": [
		9897,
		7,
		9919
	],
	"./00003/00003-11/00003-11-01/2.jpg": [
		9898,
		7,
		9920
	],
	"./00003/00003-11/00003-11-01/3.jpg": [
		9899,
		7,
		9921
	],
	"./00003/00003-11/00003-11-01/4.jpg": [
		9900,
		7,
		9922
	],
	"./00003/00003-11/00003-11-01/5.jpg": [
		9901,
		7,
		9923
	],
	"./00003/00003-11/00003-11-01/6.jpg": [
		9902,
		7,
		9924
	],
	"./00003/00003-11/00003-11-01/7.jpg": [
		9903,
		7,
		9925
	],
	"./00003/00003-11/00003-11-01/flying animals.mp3": [
		6317,
		7,
		4992
	],
	"./00003/00003-11/00003-11-01/intro.mp3": [
		702,
		7
	],
	"./00003/00003-11/00003-11-01/look at the eagle.mp3": [
		6318,
		7,
		4993
	],
	"./00003/00003-11/00003-11-01/look at the rabbit.mp3": [
		6319,
		7,
		4994
	],
	"./00003/00003-11/00003-11-01/look at the tiger.mp3": [
		6320,
		7,
		4995
	],
	"./00003/00003-11/00003-11-01/look up in the sky.mp3": [
		6321,
		7,
		4996
	],
	"./00003/00003-11/00003-11-01/look up.mp3": [
		6322,
		7,
		4997
	],
	"./00003/00003-11/00003-11-01/main idea.mp3": [
		1083,
		7
	],
	"./00003/00003-11/00003-11-01/module": [
		1517,
		9,
		381
	],
	"./00003/00003-11/00003-11-01/module.js": [
		1517,
		9,
		381
	],
	"./00003/00003-11/00003-11-01/the dragon can fly.mp3": [
		6323,
		7,
		4998
	],
	"./00003/00003-11/00003-11-01/the eagle can fly.mp3": [
		6324,
		7,
		4999
	],
	"./00003/00003-11/00003-11-01/the pig can fly.mp3": [
		6325,
		7,
		5000
	],
	"./00003/00003-11/00003-11-01/the rabbit can fly.mp3": [
		6326,
		7,
		5001
	],
	"./00003/00003-11/00003-11-01/the spaceship can fly.mp3": [
		6327,
		7,
		5002
	],
	"./00003/00003-11/00003-11-01/the tiger can fly.mp3": [
		6328,
		7,
		5003
	],
	"./00003/00003-11/00003-11-01/the unicorn can fly.mp3": [
		6329,
		7,
		5004
	],
	"./00003/00003-11/00003-11-01/what can fly.mp3": [
		6330,
		7,
		5005
	],
	"./00003/00003-11/00003-11-01/you can see a dragon.mp3": [
		6331,
		7,
		5006
	],
	"./00003/00003-11/00003-11-02/0.jpg": [
		7068,
		7,
		5745
	],
	"./00003/00003-11/00003-11-02/1 more dinosaur comes to play.mp3": [
		6332,
		7,
		5007
	],
	"./00003/00003-11/00003-11-02/1.jpg": [
		9904,
		7,
		9926
	],
	"./00003/00003-11/00003-11-02/2.jpg": [
		9905,
		7,
		9927
	],
	"./00003/00003-11/00003-11-02/3.jpg": [
		9906,
		7,
		9928
	],
	"./00003/00003-11/00003-11-02/4.jpg": [
		9907,
		7,
		9929
	],
	"./00003/00003-11/00003-11-02/5 little dinosaurs.mp3": [
		6333,
		7,
		5008
	],
	"./00003/00003-11/00003-11-02/5.jpg": [
		9908,
		7,
		9930
	],
	"./00003/00003-11/00003-11-02/6.jpg": [
		9909,
		7,
		9931
	],
	"./00003/00003-11/00003-11-02/7.jpg": [
		9910,
		7,
		9932
	],
	"./00003/00003-11/00003-11-02/dinosaurs.mp3": [
		6334,
		7,
		5009
	],
	"./00003/00003-11/00003-11-02/i see 0 little dinosaurs.mp3": [
		6335,
		7,
		5010
	],
	"./00003/00003-11/00003-11-02/i see 1 big dinosaur.mp3": [
		6336,
		7,
		5011
	],
	"./00003/00003-11/00003-11-02/i see 1 little dinosaur.mp3": [
		6337,
		7,
		5012
	],
	"./00003/00003-11/00003-11-02/i see 2 little dinosaurs.mp3": [
		6338,
		7,
		5013
	],
	"./00003/00003-11/00003-11-02/i see 3 little dinosaurs.mp3": [
		6339,
		7,
		5014
	],
	"./00003/00003-11/00003-11-02/i see 4 little dinosaurs.mp3": [
		6340,
		7,
		5015
	],
	"./00003/00003-11/00003-11-02/i see 5 little dinosaurs.mp3": [
		6341,
		7,
		5016
	],
	"./00003/00003-11/00003-11-02/intro.mp3": [
		703,
		7
	],
	"./00003/00003-11/00003-11-02/little dinosaurs play and play.mp3": [
		6342,
		7,
		5017
	],
	"./00003/00003-11/00003-11-02/little dinosaurs run away.mp3": [
		6343,
		7,
		5018
	],
	"./00003/00003-11/00003-11-02/look at the dinosaur.mp3": [
		6344,
		7,
		5019
	],
	"./00003/00003-11/00003-11-02/look out.mp3": [
		6345,
		7,
		5020
	],
	"./00003/00003-11/00003-11-02/main idea.mp3": [
		1084,
		7
	],
	"./00003/00003-11/00003-11-02/module": [
		1518,
		9,
		382
	],
	"./00003/00003-11/00003-11-02/module.js": [
		1518,
		9,
		382
	],
	"./00003/00003-11/00003-11-02/one and four is five.mp3": [
		6346,
		7,
		5021
	],
	"./00003/00003-11/00003-11-02/one and three is four.mp3": [
		6347,
		7,
		5022
	],
	"./00003/00003-11/00003-11-03/0.jpg": [
		7069,
		7,
		5746
	],
	"./00003/00003-11/00003-11-03/1.jpg": [
		9911,
		7,
		9933
	],
	"./00003/00003-11/00003-11-03/2.jpg": [
		9912,
		7,
		9934
	],
	"./00003/00003-11/00003-11-03/3.jpg": [
		9913,
		7,
		9935
	],
	"./00003/00003-11/00003-11-03/4.jpg": [
		9914,
		7,
		9936
	],
	"./00003/00003-11/00003-11-03/5.jpg": [
		9915,
		7,
		9937
	],
	"./00003/00003-11/00003-11-03/6.jpg": [
		9916,
		7,
		9938
	],
	"./00003/00003-11/00003-11-03/7.jpg": [
		9917,
		7,
		9939
	],
	"./00003/00003-11/00003-11-03/i am a brown bear.mp3": [
		6348,
		7,
		5023
	],
	"./00003/00003-11/00003-11-03/i am a crocodile.mp3": [
		6349,
		7,
		5024
	],
	"./00003/00003-11/00003-11-03/i am a dinosaur.mp3": [
		6350,
		7,
		5025
	],
	"./00003/00003-11/00003-11-03/i am a panda.mp3": [
		6351,
		7,
		5026
	],
	"./00003/00003-11/00003-11-03/i am a penguin.mp3": [
		6352,
		7,
		5027
	],
	"./00003/00003-11/00003-11-03/i am a shark.mp3": [
		6353,
		7,
		5028
	],
	"./00003/00003-11/00003-11-03/i am flying.mp3": [
		6354,
		7,
		5029
	],
	"./00003/00003-11/00003-11-03/i am running.mp3": [
		6355,
		7,
		5030
	],
	"./00003/00003-11/00003-11-03/i am skating.mp3": [
		6356,
		7,
		5031
	],
	"./00003/00003-11/00003-11-03/i am sleeping.mp3": [
		6357,
		7,
		5032
	],
	"./00003/00003-11/00003-11-03/i am sliding.mp3": [
		6358,
		7,
		5033
	],
	"./00003/00003-11/00003-11-03/i am swimming.mp3": [
		6359,
		7,
		5034
	],
	"./00003/00003-11/00003-11-03/intro.mp3": [
		704,
		7
	],
	"./00003/00003-11/00003-11-03/look at me.mp3": [
		6360,
		7,
		5035
	],
	"./00003/00003-11/00003-11-03/look at us.mp3": [
		6361,
		7,
		5036
	],
	"./00003/00003-11/00003-11-03/main idea.mp3": [
		1085,
		7
	],
	"./00003/00003-11/00003-11-03/module": [
		1519,
		9,
		383
	],
	"./00003/00003-11/00003-11-03/module.js": [
		1519,
		9,
		383
	],
	"./00003/00003-11/00003-11-03/swimming animals.mp3": [
		6362,
		7,
		5037
	],
	"./00003/00003-11/00003-11-03/we are jumping.mp3": [
		6363,
		7,
		5038
	],
	"./00003/00003-11/00003-11-03/we are kangaroos.mp3": [
		6364,
		7,
		5039
	],
	"./00003/00003-11/00003-11-04/0.jpg": [
		7070,
		7,
		5747
	],
	"./00003/00003-11/00003-11-04/1.jpg": [
		9918,
		7,
		9940
	],
	"./00003/00003-11/00003-11-04/2.jpg": [
		9919,
		7,
		9941
	],
	"./00003/00003-11/00003-11-04/3.jpg": [
		9920,
		7,
		9942
	],
	"./00003/00003-11/00003-11-04/4.jpg": [
		9921,
		7,
		9943
	],
	"./00003/00003-11/00003-11-04/5.jpg": [
		9922,
		7,
		9944
	],
	"./00003/00003-11/00003-11-04/6.jpg": [
		9923,
		7,
		9945
	],
	"./00003/00003-11/00003-11-04/7.jpg": [
		9924,
		7,
		9946
	],
	"./00003/00003-11/00003-11-04/here are 2 big rocks said the dog.mp3": [
		6365,
		7,
		5040
	],
	"./00003/00003-11/00003-11-04/here are 6 little rocks said the goose.mp3": [
		6366,
		7,
		5041
	],
	"./00003/00003-11/00003-11-04/here is a big snowball said the elephant.mp3": [
		6367,
		7,
		5042
	],
	"./00003/00003-11/00003-11-04/here is a carrot said the deer.mp3": [
		6368,
		7,
		5043
	],
	"./00003/00003-11/00003-11-04/here is a hat for the snowman.mp3": [
		6369,
		7,
		5044
	],
	"./00003/00003-11/00003-11-04/here is a hat said the penguin.mp3": [
		6370,
		7,
		5045
	],
	"./00003/00003-11/00003-11-04/here is a little snowball too.mp3": [
		6371,
		7,
		5046
	],
	"./00003/00003-11/00003-11-04/here is a scarf for the snowman.mp3": [
		6372,
		7,
		5047
	],
	"./00003/00003-11/00003-11-04/here is a scarf said the alligator.mp3": [
		6373,
		7,
		5048
	],
	"./00003/00003-11/00003-11-04/intro.mp3": [
		705,
		7
	],
	"./00003/00003-11/00003-11-04/look at the big rocks.mp3": [
		6374,
		7,
		5049
	],
	"./00003/00003-11/00003-11-04/look at the big snowman.mp3": [
		6375,
		7,
		5050
	],
	"./00003/00003-11/00003-11-04/look at the little rocks.mp3": [
		6376,
		7,
		5051
	],
	"./00003/00003-11/00003-11-04/look at the snowmans eyes.mp3": [
		6377,
		7,
		5052
	],
	"./00003/00003-11/00003-11-04/look at the snowmans mouth.mp3": [
		6378,
		7,
		5053
	],
	"./00003/00003-11/00003-11-04/look at the snowmans nose.mp3": [
		6379,
		7,
		5054
	],
	"./00003/00003-11/00003-11-04/look said the cat.mp3": [
		6380,
		7,
		5055
	],
	"./00003/00003-11/00003-11-04/main idea.mp3": [
		1086,
		7
	],
	"./00003/00003-11/00003-11-04/making a snowman.mp3": [
		6381,
		7,
		5056
	],
	"./00003/00003-11/00003-11-04/module": [
		1520,
		9,
		384
	],
	"./00003/00003-11/00003-11-04/module.js": [
		1520,
		9,
		384
	],
	"./00003/00003-11/00003-11-04/the big rocks are for the snowmans eyes.mp3": [
		6382,
		7,
		5057
	],
	"./00003/00003-11/00003-11-04/the carrot is for the snowmans nose.mp3": [
		6383,
		7,
		5058
	],
	"./00003/00003-11/00003-11-04/the little rocks are for the snowmans mouth.mp3": [
		6384,
		7,
		5059
	],
	"./00003/00003-11/00003-11-04/things you need to make a snowman.mp3": [
		6385,
		7,
		5060
	],
	"./00003/00003-11/00003-11-05/0.jpg": [
		7071,
		7,
		5748
	],
	"./00003/00003-11/00003-11-05/1.jpg": [
		9925,
		7,
		9947
	],
	"./00003/00003-11/00003-11-05/2.jpg": [
		9926,
		7,
		9948
	],
	"./00003/00003-11/00003-11-05/3.jpg": [
		9927,
		7,
		9949
	],
	"./00003/00003-11/00003-11-05/4.jpg": [
		9928,
		7,
		9950
	],
	"./00003/00003-11/00003-11-05/5.jpg": [
		9929,
		7,
		9951
	],
	"./00003/00003-11/00003-11-05/6.jpg": [
		9930,
		7,
		9952
	],
	"./00003/00003-11/00003-11-05/7.jpg": [
		9931,
		7,
		9953
	],
	"./00003/00003-11/00003-11-05/going up and down.mp3": [
		6386,
		7,
		5061
	],
	"./00003/00003-11/00003-11-05/intro.mp3": [
		706,
		7
	],
	"./00003/00003-11/00003-11-05/look at the cat.mp3": [
		6387,
		7,
		5062
	],
	"./00003/00003-11/00003-11-05/look at the dog.mp3": [
		6388,
		7,
		5063
	],
	"./00003/00003-11/00003-11-05/look at the mouse.mp3": [
		6389,
		7,
		5064
	],
	"./00003/00003-11/00003-11-05/main idea.mp3": [
		1087,
		7
	],
	"./00003/00003-11/00003-11-05/module": [
		1521,
		9,
		385
	],
	"./00003/00003-11/00003-11-05/module.js": [
		1521,
		9,
		385
	],
	"./00003/00003-11/00003-11-05/the cat is going down.mp3": [
		6390,
		7,
		5065
	],
	"./00003/00003-11/00003-11-05/the cat is going up.mp3": [
		6391,
		7,
		5066
	],
	"./00003/00003-11/00003-11-05/the dog is going down.mp3": [
		6392,
		7,
		5067
	],
	"./00003/00003-11/00003-11-05/the dog is going up.mp3": [
		6393,
		7,
		5068
	],
	"./00003/00003-11/00003-11-05/the mouse is going down.mp3": [
		6394,
		7,
		5069
	],
	"./00003/00003-11/00003-11-05/the mouse is going up.mp3": [
		6395,
		7,
		5070
	],
	"./00003/00003-11/00003-11-05/things you can see up in the sky.mp3": [
		6396,
		7,
		5071
	],
	"./00003/00003-11/00003-11-06/0.jpg": [
		7072,
		7,
		5749
	],
	"./00003/00003-11/00003-11-06/1.jpg": [
		9932,
		7,
		9954
	],
	"./00003/00003-11/00003-11-06/2.jpg": [
		9933,
		7,
		9955
	],
	"./00003/00003-11/00003-11-06/3.jpg": [
		9934,
		7,
		9956
	],
	"./00003/00003-11/00003-11-06/4.jpg": [
		9935,
		7,
		9957
	],
	"./00003/00003-11/00003-11-06/5.jpg": [
		9936,
		7,
		9958
	],
	"./00003/00003-11/00003-11-06/6.jpg": [
		9937,
		7,
		9959
	],
	"./00003/00003-11/00003-11-06/7.jpg": [
		9938,
		7,
		9960
	],
	"./00003/00003-11/00003-11-06/here comes the cheetah.mp3": [
		6397,
		7,
		5072
	],
	"./00003/00003-11/00003-11-06/here comes the elephant.mp3": [
		6398,
		7,
		5073
	],
	"./00003/00003-11/00003-11-06/here comes the fox.mp3": [
		6399,
		7,
		5074
	],
	"./00003/00003-11/00003-11-06/here comes the giraffe.mp3": [
		6400,
		7,
		5075
	],
	"./00003/00003-11/00003-11-06/here comes the lion.mp3": [
		6401,
		7,
		5076
	],
	"./00003/00003-11/00003-11-06/here comes the ostrich.mp3": [
		6402,
		7,
		5077
	],
	"./00003/00003-11/00003-11-06/here comes the zebra.mp3": [
		6403,
		7,
		5078
	],
	"./00003/00003-11/00003-11-06/intro.mp3": [
		707,
		7
	],
	"./00003/00003-11/00003-11-06/main idea.mp3": [
		1088,
		7
	],
	"./00003/00003-11/00003-11-06/module": [
		1522,
		9,
		386
	],
	"./00003/00003-11/00003-11-06/module.js": [
		1522,
		9,
		386
	],
	"./00003/00003-11/00003-11-06/the animal race.mp3": [
		6404,
		7,
		5079
	],
	"./00003/00003-11/00003-11-06/the cheetah runs the fastest.mp3": [
		6405,
		7,
		5080
	],
	"./00003/00003-11/00003-11-06/the elephant runs fast.mp3": [
		6406,
		7,
		5081
	],
	"./00003/00003-11/00003-11-06/the fox runs faster.mp3": [
		6407,
		7,
		5082
	],
	"./00003/00003-11/00003-11-06/the giraffe runs faster.mp3": [
		6408,
		7,
		5083
	],
	"./00003/00003-11/00003-11-06/the lion runs faster.mp3": [
		6409,
		7,
		5084
	],
	"./00003/00003-11/00003-11-06/the ostrich runs faster.mp3": [
		6410,
		7,
		5085
	],
	"./00003/00003-11/00003-11-06/the zebra runs faster.mp3": [
		6411,
		7,
		5086
	],
	"./00003/00003-11/00003-11-06/wild animals.mp3": [
		6412,
		7,
		5087
	],
	"./00003/00003-11/00003-11-07/0.jpg": [
		7073,
		7,
		5750
	],
	"./00003/00003-11/00003-11-07/1.jpg": [
		9939,
		7,
		9961
	],
	"./00003/00003-11/00003-11-07/2.jpg": [
		9940,
		7,
		9962
	],
	"./00003/00003-11/00003-11-07/3.jpg": [
		9941,
		7,
		9963
	],
	"./00003/00003-11/00003-11-07/4.jpg": [
		9942,
		7,
		9964
	],
	"./00003/00003-11/00003-11-07/5.jpg": [
		9943,
		7,
		9965
	],
	"./00003/00003-11/00003-11-07/6.jpg": [
		9944,
		7,
		9966
	],
	"./00003/00003-11/00003-11-07/7.jpg": [
		9945,
		7,
		9967
	],
	"./00003/00003-11/00003-11-07/he lives with me.mp3": [
		6413,
		7,
		5088
	],
	"./00003/00003-11/00003-11-07/here is my bird said the dinosaur.mp3": [
		6414,
		7,
		5089
	],
	"./00003/00003-11/00003-11-07/here is my bird said the girl.mp3": [
		6415,
		7,
		5090
	],
	"./00003/00003-11/00003-11-07/here is my bird said the monster.mp3": [
		6416,
		7,
		5091
	],
	"./00003/00003-11/00003-11-07/here is my cat said the boy.mp3": [
		6417,
		7,
		5092
	],
	"./00003/00003-11/00003-11-07/here is my cat said the monster.mp3": [
		6418,
		7,
		5093
	],
	"./00003/00003-11/00003-11-07/here is my dog said the girl.mp3": [
		6419,
		7,
		5094
	],
	"./00003/00003-11/00003-11-07/here is my dog said the monster.mp3": [
		6420,
		7,
		5095
	],
	"./00003/00003-11/00003-11-07/here is my pet said the boy.mp3": [
		6421,
		7,
		5096
	],
	"./00003/00003-11/00003-11-07/here is my pet said the girl.mp3": [
		6422,
		7,
		5097
	],
	"./00003/00003-11/00003-11-07/here is my pet.mp3": [
		6423,
		7,
		5098
	],
	"./00003/00003-11/00003-11-07/i love my bird too.mp3": [
		6424,
		7,
		5099
	],
	"./00003/00003-11/00003-11-07/i love my bird.mp3": [
		6425,
		7,
		5100
	],
	"./00003/00003-11/00003-11-07/i love my cat.mp3": [
		6426,
		7,
		5101
	],
	"./00003/00003-11/00003-11-07/i love my dog.mp3": [
		6427,
		7,
		5102
	],
	"./00003/00003-11/00003-11-07/intro.mp3": [
		708,
		7
	],
	"./00003/00003-11/00003-11-07/look at my pet.mp3": [
		6428,
		7,
		5103
	],
	"./00003/00003-11/00003-11-07/main idea.mp3": [
		1089,
		7
	],
	"./00003/00003-11/00003-11-07/me too said the dinosaur.mp3": [
		6429,
		7,
		5104
	],
	"./00003/00003-11/00003-11-07/module": [
		1523,
		9,
		387
	],
	"./00003/00003-11/00003-11-07/module.js": [
		1523,
		9,
		387
	],
	"./00003/00003-11/00003-11-07/pets.mp3": [
		6430,
		7,
		5105
	],
	"./00003/00003-11/00003-11-07/she lives with me.mp3": [
		6431,
		7,
		5106
	],
	"./00003/00003-11/00003-11-08/0.jpg": [
		7074,
		7,
		5751
	],
	"./00003/00003-11/00003-11-08/1.jpg": [
		9946,
		7,
		9968
	],
	"./00003/00003-11/00003-11-08/2.jpg": [
		9947,
		7,
		9969
	],
	"./00003/00003-11/00003-11-08/3.jpg": [
		9948,
		7,
		9970
	],
	"./00003/00003-11/00003-11-08/4.jpg": [
		9949,
		7,
		9971
	],
	"./00003/00003-11/00003-11-08/5.jpg": [
		9950,
		7,
		9972
	],
	"./00003/00003-11/00003-11-08/6.jpg": [
		9951,
		7,
		9973
	],
	"./00003/00003-11/00003-11-08/7.jpg": [
		9952,
		7,
		9974
	],
	"./00003/00003-11/00003-11-08/can you.mp3": [
		6432,
		7,
		5107
	],
	"./00003/00003-11/00003-11-08/characters who can skate in the book.mp3": [
		6433,
		7,
		5108
	],
	"./00003/00003-11/00003-11-08/i can not skate said the bear.mp3": [
		6434,
		7,
		5109
	],
	"./00003/00003-11/00003-11-08/i can skate said the deer.mp3": [
		6435,
		7,
		5110
	],
	"./00003/00003-11/00003-11-08/i can skate said the monster.mp3": [
		6436,
		7,
		5111
	],
	"./00003/00003-11/00003-11-08/i can skate said the panda.mp3": [
		6437,
		7,
		5112
	],
	"./00003/00003-11/00003-11-08/i can skate said the penguin.mp3": [
		6438,
		7,
		5113
	],
	"./00003/00003-11/00003-11-08/intro.mp3": [
		709,
		7
	],
	"./00003/00003-11/00003-11-08/look at me.mp3": [
		6439,
		7,
		5114
	],
	"./00003/00003-11/00003-11-08/look at us.mp3": [
		6440,
		7,
		5115
	],
	"./00003/00003-11/00003-11-08/main idea.mp3": [
		1090,
		7
	],
	"./00003/00003-11/00003-11-08/module": [
		1524,
		9,
		388
	],
	"./00003/00003-11/00003-11-08/module.js": [
		1524,
		9,
		388
	],
	"./00003/00003-11/00003-11-08/oh no.mp3": [
		6441,
		7,
		5116
	],
	"./00003/00003-11/00003-11-08/we can skate said the lions.mp3": [
		6442,
		7,
		5117
	],
	"./00003/00003-11/00003-11-08/we can skate said the rabbits.mp3": [
		6443,
		7,
		5118
	],
	"./00003/00003-11/00003-11-08/who can skate.mp3": [
		6444,
		7,
		5119
	],
	"./00003/00003-11/00003-11-09/0.jpg": [
		7075,
		7,
		5752
	],
	"./00003/00003-11/00003-11-09/1.jpg": [
		9953,
		7,
		9975
	],
	"./00003/00003-11/00003-11-09/2.jpg": [
		9954,
		7,
		9976
	],
	"./00003/00003-11/00003-11-09/3.jpg": [
		9955,
		7,
		9977
	],
	"./00003/00003-11/00003-11-09/4.jpg": [
		9956,
		7,
		9978
	],
	"./00003/00003-11/00003-11-09/5.jpg": [
		9957,
		7,
		9979
	],
	"./00003/00003-11/00003-11-09/6.jpg": [
		9958,
		7,
		9980
	],
	"./00003/00003-11/00003-11-09/7.jpg": [
		9959,
		7,
		9981
	],
	"./00003/00003-11/00003-11-09/animals with four legs.mp3": [
		6445,
		7,
		5120
	],
	"./00003/00003-11/00003-11-09/balloons.mp3": [
		6446,
		7,
		5121
	],
	"./00003/00003-11/00003-11-09/cat likes the orange balloon.mp3": [
		6447,
		7,
		5122
	],
	"./00003/00003-11/00003-11-09/dinosaur likes the blue balloon.mp3": [
		6448,
		7,
		5123
	],
	"./00003/00003-11/00003-11-09/dog likes the red balloon.mp3": [
		6449,
		7,
		5124
	],
	"./00003/00003-11/00003-11-09/here is a cat.mp3": [
		6450,
		7,
		5125
	],
	"./00003/00003-11/00003-11-09/here is a dog.mp3": [
		6451,
		7,
		5126
	],
	"./00003/00003-11/00003-11-09/here is a rabbit.mp3": [
		6452,
		7,
		5127
	],
	"./00003/00003-11/00003-11-09/i can see a dinosaur.mp3": [
		6453,
		7,
		5128
	],
	"./00003/00003-11/00003-11-09/i like the monkey.mp3": [
		6454,
		7,
		5129
	],
	"./00003/00003-11/00003-11-09/i see the octopus.mp3": [
		6455,
		7,
		5130
	],
	"./00003/00003-11/00003-11-09/i see the yellow lion.mp3": [
		6456,
		7,
		5131
	],
	"./00003/00003-11/00003-11-09/intro.mp3": [
		710,
		7
	],
	"./00003/00003-11/00003-11-09/lion likes the yellow balloon.mp3": [
		6457,
		7,
		5132
	],
	"./00003/00003-11/00003-11-09/look at the cat.mp3": [
		6458,
		7,
		5133
	],
	"./00003/00003-11/00003-11-09/look at the dinosaur.mp3": [
		6459,
		7,
		5134
	],
	"./00003/00003-11/00003-11-09/look at the dog.mp3": [
		6460,
		7,
		5135
	],
	"./00003/00003-11/00003-11-09/look at the lion.mp3": [
		6461,
		7,
		5136
	],
	"./00003/00003-11/00003-11-09/look at the monkey.mp3": [
		6462,
		7,
		5137
	],
	"./00003/00003-11/00003-11-09/look at the octopus.mp3": [
		6463,
		7,
		5138
	],
	"./00003/00003-11/00003-11-09/look at the rabbit.mp3": [
		6464,
		7,
		5139
	],
	"./00003/00003-11/00003-11-09/main idea.mp3": [
		1091,
		7
	],
	"./00003/00003-11/00003-11-09/module": [
		1525,
		9,
		389
	],
	"./00003/00003-11/00003-11-09/module.js": [
		1525,
		9,
		389
	],
	"./00003/00003-11/00003-11-09/monkey likes the green balloon.mp3": [
		6465,
		7,
		5140
	],
	"./00003/00003-11/00003-11-09/octopus likes the balloons.mp3": [
		6466,
		7,
		5141
	],
	"./00003/00003-11/00003-11-09/rabbit likes the pink balloon.mp3": [
		6467,
		7,
		5142
	],
	"./00003/00003-11/00003-11-10/0.jpg": [
		7076,
		7,
		5753
	],
	"./00003/00003-11/00003-11-10/1.jpg": [
		9960,
		7,
		9982
	],
	"./00003/00003-11/00003-11-10/2.jpg": [
		9961,
		7,
		9983
	],
	"./00003/00003-11/00003-11-10/3.jpg": [
		9962,
		7,
		9984
	],
	"./00003/00003-11/00003-11-10/4.jpg": [
		9963,
		7,
		9985
	],
	"./00003/00003-11/00003-11-10/5.jpg": [
		9964,
		7,
		9986
	],
	"./00003/00003-11/00003-11-10/6.jpg": [
		9965,
		7,
		9987
	],
	"./00003/00003-11/00003-11-10/7.jpg": [
		9966,
		7,
		9988
	],
	"./00003/00003-11/00003-11-10/ant sees the yellow flower.mp3": [
		6468,
		7,
		5143
	],
	"./00003/00003-11/00003-11-10/bee sees the orange flower.mp3": [
		6469,
		7,
		5144
	],
	"./00003/00003-11/00003-11-10/butterfly sees the red flower.mp3": [
		6470,
		7,
		5145
	],
	"./00003/00003-11/00003-11-10/do you.mp3": [
		6471,
		7,
		5146
	],
	"./00003/00003-11/00003-11-10/grasshopper sees the pink flower.mp3": [
		6472,
		7,
		5147
	],
	"./00003/00003-11/00003-11-10/he likes flowers.mp3": [
		6473,
		7,
		5148
	],
	"./00003/00003-11/00003-11-10/hummingbird sees the blue flower.mp3": [
		6474,
		7,
		5149
	],
	"./00003/00003-11/00003-11-10/i like flowers he said.mp3": [
		6475,
		7,
		5150
	],
	"./00003/00003-11/00003-11-10/i like flowers she said.mp3": [
		6476,
		7,
		5151
	],
	"./00003/00003-11/00003-11-10/insects.mp3": [
		6477,
		7,
		5152
	],
	"./00003/00003-11/00003-11-10/intro.mp3": [
		711,
		7
	],
	"./00003/00003-11/00003-11-10/ladybug sees the purple flower.mp3": [
		6478,
		7,
		5153
	],
	"./00003/00003-11/00003-11-10/look at the flowers.mp3": [
		6479,
		7,
		5154
	],
	"./00003/00003-11/00003-11-10/main idea.mp3": [
		1092,
		7
	],
	"./00003/00003-11/00003-11-10/module": [
		1526,
		9,
		390
	],
	"./00003/00003-11/00003-11-10/module.js": [
		1526,
		9,
		390
	],
	"./00003/00003-11/00003-11-10/she likes flowers.mp3": [
		6480,
		7,
		5155
	],
	"./00003/00003-11/00003-11-10/we see flowers.mp3": [
		6481,
		7,
		5156
	],
	"./00003/00003-11/00003-11-10/we see the flowers.mp3": [
		6482,
		7,
		5157
	],
	"./00003/00003-11/00003-11-10/yes said the insects.mp3": [
		6483,
		7,
		5158
	],
	"./00003/00003-11/00003-11-10/yes.mp3": [
		6484,
		7,
		5159
	],
	"./00003/00003-11/cover.jpg": [
		7077,
		7,
		5754
	],
	"./00003/00003-11/story town.mp3": [
		6485,
		7,
		5160
	],
	"./00003/00003-11/unit": [
		1527,
		9,
		391
	],
	"./00003/00003-11/unit.js": [
		1527,
		9,
		391
	],
	"./00003/00003-12/00003-12-01/0.jpg": [
		7078,
		7,
		5755
	],
	"./00003/00003-12/00003-12-01/1.jpg": [
		9967,
		7,
		9989
	],
	"./00003/00003-12/00003-12-01/2.jpg": [
		9968,
		7,
		9990
	],
	"./00003/00003-12/00003-12-01/3.jpg": [
		9969,
		7,
		9991
	],
	"./00003/00003-12/00003-12-01/4.jpg": [
		9970,
		7,
		9992
	],
	"./00003/00003-12/00003-12-01/5.jpg": [
		9971,
		7,
		9993
	],
	"./00003/00003-12/00003-12-01/6.jpg": [
		9972,
		7,
		9994
	],
	"./00003/00003-12/00003-12-01/7.jpg": [
		9973,
		7,
		9995
	],
	"./00003/00003-12/00003-12-01/alligator wants an airplane.mp3": [
		6486,
		7,
		5161
	],
	"./00003/00003-12/00003-12-01/bear wants a bike.mp3": [
		6487,
		7,
		5162
	],
	"./00003/00003-12/00003-12-01/cat wants a car.mp3": [
		6488,
		7,
		5163
	],
	"./00003/00003-12/00003-12-01/christmas is here.mp3": [
		6489,
		7,
		5164
	],
	"./00003/00003-12/00003-12-01/dog wants a dinosaur.mp3": [
		6490,
		7,
		5165
	],
	"./00003/00003-12/00003-12-01/fox wants a fire truck.mp3": [
		6491,
		7,
		5166
	],
	"./00003/00003-12/00003-12-01/here comes the gray hippo.mp3": [
		6492,
		7,
		5167
	],
	"./00003/00003-12/00003-12-01/hippo wants a helicopter.mp3": [
		6493,
		7,
		5168
	],
	"./00003/00003-12/00003-12-01/i see a wagon.mp3": [
		6494,
		7,
		5169
	],
	"./00003/00003-12/00003-12-01/i see a wolf.mp3": [
		6495,
		7,
		5170
	],
	"./00003/00003-12/00003-12-01/i see the alligator.mp3": [
		6496,
		7,
		5171
	],
	"./00003/00003-12/00003-12-01/intro.mp3": [
		712,
		7
	],
	"./00003/00003-12/00003-12-01/look at the airplane.mp3": [
		6497,
		7,
		5172
	],
	"./00003/00003-12/00003-12-01/look at the alligator.mp3": [
		6498,
		7,
		5173
	],
	"./00003/00003-12/00003-12-01/look at the bear.mp3": [
		6499,
		7,
		5174
	],
	"./00003/00003-12/00003-12-01/look at the bike.mp3": [
		6500,
		7,
		5175
	],
	"./00003/00003-12/00003-12-01/look at the car.mp3": [
		6501,
		7,
		5176
	],
	"./00003/00003-12/00003-12-01/look at the cat.mp3": [
		6502,
		7,
		5177
	],
	"./00003/00003-12/00003-12-01/look at the dinosaur.mp3": [
		6503,
		7,
		5178
	],
	"./00003/00003-12/00003-12-01/look at the dog.mp3": [
		6504,
		7,
		5179
	],
	"./00003/00003-12/00003-12-01/look at the fox.mp3": [
		6505,
		7,
		5180
	],
	"./00003/00003-12/00003-12-01/look at the helicopter.mp3": [
		6506,
		7,
		5181
	],
	"./00003/00003-12/00003-12-01/main idea.mp3": [
		1093,
		7
	],
	"./00003/00003-12/00003-12-01/module": [
		1528,
		9,
		392
	],
	"./00003/00003-12/00003-12-01/module.js": [
		1528,
		9,
		392
	],
	"./00003/00003-12/00003-12-01/the fire truck is red.mp3": [
		6507,
		7,
		5182
	],
	"./00003/00003-12/00003-12-01/toys.mp3": [
		6508,
		7,
		5183
	],
	"./00003/00003-12/00003-12-01/vehicles.mp3": [
		6509,
		7,
		5184
	],
	"./00003/00003-12/00003-12-01/wolf wants a wagon.mp3": [
		6510,
		7,
		5185
	],
	"./00003/00003-12/00003-12-02/0.jpg": [
		7079,
		7,
		5756
	],
	"./00003/00003-12/00003-12-02/1.jpg": [
		9974,
		7,
		9996
	],
	"./00003/00003-12/00003-12-02/2.jpg": [
		9975,
		7,
		9997
	],
	"./00003/00003-12/00003-12-02/3.jpg": [
		9976,
		7,
		9998
	],
	"./00003/00003-12/00003-12-02/4.jpg": [
		9977,
		7,
		9999
	],
	"./00003/00003-12/00003-12-02/5.jpg": [
		9978,
		7,
		10000
	],
	"./00003/00003-12/00003-12-02/6.jpg": [
		9979,
		7,
		10001
	],
	"./00003/00003-12/00003-12-02/7.jpg": [
		9980,
		7,
		10002
	],
	"./00003/00003-12/00003-12-02/alligator got a saxophone.mp3": [
		6511,
		7,
		5186
	],
	"./00003/00003-12/00003-12-02/bear got a guitar.mp3": [
		6512,
		7,
		5187
	],
	"./00003/00003-12/00003-12-02/beaver got a xylophone.mp3": [
		6513,
		7,
		5188
	],
	"./00003/00003-12/00003-12-02/dog got a tambourine.mp3": [
		6514,
		7,
		5189
	],
	"./00003/00003-12/00003-12-02/fox got a fiddle.mp3": [
		6515,
		7,
		5190
	],
	"./00003/00003-12/00003-12-02/i love music he said.mp3": [
		6516,
		7,
		5191
	],
	"./00003/00003-12/00003-12-02/i love music she said.mp3": [
		6517,
		7,
		5192
	],
	"./00003/00003-12/00003-12-02/i love music.mp3": [
		6518,
		7,
		5193
	],
	"./00003/00003-12/00003-12-02/intro.mp3": [
		713,
		7
	],
	"./00003/00003-12/00003-12-02/look at the banjo.mp3": [
		6519,
		7,
		5194
	],
	"./00003/00003-12/00003-12-02/look at the fiddle.mp3": [
		6520,
		7,
		5195
	],
	"./00003/00003-12/00003-12-02/look at the guitar.mp3": [
		6521,
		7,
		5196
	],
	"./00003/00003-12/00003-12-02/look at the saxophone.mp3": [
		6522,
		7,
		5197
	],
	"./00003/00003-12/00003-12-02/look at the tambourine.mp3": [
		6523,
		7,
		5198
	],
	"./00003/00003-12/00003-12-02/look at the triangle.mp3": [
		6524,
		7,
		5199
	],
	"./00003/00003-12/00003-12-02/look at the xylophone.mp3": [
		6525,
		7,
		5200
	],
	"./00003/00003-12/00003-12-02/main idea.mp3": [
		1094,
		7
	],
	"./00003/00003-12/00003-12-02/module": [
		1529,
		9,
		393
	],
	"./00003/00003-12/00003-12-02/module.js": [
		1529,
		9,
		393
	],
	"./00003/00003-12/00003-12-02/monkey got a triangle.mp3": [
		6526,
		7,
		5201
	],
	"./00003/00003-12/00003-12-02/musical instruments.mp3": [
		6527,
		7,
		5202
	],
	"./00003/00003-12/00003-12-02/raccoon got a banjo.mp3": [
		6528,
		7,
		5203
	],
	"./00003/00003-12/00003-12-03/0.jpg": [
		7080,
		7,
		5757
	],
	"./00003/00003-12/00003-12-03/1.jpg": [
		9981,
		7,
		10003
	],
	"./00003/00003-12/00003-12-03/2.jpg": [
		9982,
		7,
		10004
	],
	"./00003/00003-12/00003-12-03/3.jpg": [
		9983,
		7,
		10005
	],
	"./00003/00003-12/00003-12-03/4.jpg": [
		9984,
		7,
		10006
	],
	"./00003/00003-12/00003-12-03/5.jpg": [
		9985,
		7,
		10007
	],
	"./00003/00003-12/00003-12-03/6.jpg": [
		9986,
		7,
		10008
	],
	"./00003/00003-12/00003-12-03/7.jpg": [
		9987,
		7,
		10009
	],
	"./00003/00003-12/00003-12-03/alligator is going to the party.mp3": [
		6529,
		7,
		5204
	],
	"./00003/00003-12/00003-12-03/cat is going to the party.mp3": [
		6530,
		7,
		5205
	],
	"./00003/00003-12/00003-12-03/characters in the book.mp3": [
		6531,
		7,
		5206
	],
	"./00003/00003-12/00003-12-03/crocodile is going to the party.mp3": [
		6532,
		7,
		5207
	],
	"./00003/00003-12/00003-12-03/dog is going to the party.mp3": [
		6533,
		7,
		5208
	],
	"./00003/00003-12/00003-12-03/elephant is going to the party.mp3": [
		6534,
		7,
		5209
	],
	"./00003/00003-12/00003-12-03/going to the party.mp3": [
		6535,
		7,
		5210
	],
	"./00003/00003-12/00003-12-03/he is going to the party.mp3": [
		6536,
		7,
		5211
	],
	"./00003/00003-12/00003-12-03/here is the party.mp3": [
		6537,
		7,
		5212
	],
	"./00003/00003-12/00003-12-03/intro.mp3": [
		714,
		7
	],
	"./00003/00003-12/00003-12-03/jaguar is going to the party.mp3": [
		6538,
		7,
		5213
	],
	"./00003/00003-12/00003-12-03/look at the alligator.mp3": [
		6539,
		7,
		5214
	],
	"./00003/00003-12/00003-12-03/look at the animals.mp3": [
		6540,
		7,
		5215
	],
	"./00003/00003-12/00003-12-03/look at the cat.mp3": [
		6541,
		7,
		5216
	],
	"./00003/00003-12/00003-12-03/look at the dog.mp3": [
		6542,
		7,
		5217
	],
	"./00003/00003-12/00003-12-03/look at the elephant.mp3": [
		6543,
		7,
		5218
	],
	"./00003/00003-12/00003-12-03/look at the jaguar.mp3": [
		6544,
		7,
		5219
	],
	"./00003/00003-12/00003-12-03/look at the tiger.mp3": [
		6545,
		7,
		5220
	],
	"./00003/00003-12/00003-12-03/look at the zebra.mp3": [
		6546,
		7,
		5221
	],
	"./00003/00003-12/00003-12-03/main idea.mp3": [
		1095,
		7
	],
	"./00003/00003-12/00003-12-03/module": [
		1530,
		9,
		394
	],
	"./00003/00003-12/00003-12-03/module.js": [
		1530,
		9,
		394
	],
	"./00003/00003-12/00003-12-03/panda is going to the party.mp3": [
		6547,
		7,
		5222
	],
	"./00003/00003-12/00003-12-03/she is going to the party.mp3": [
		6548,
		7,
		5223
	],
	"./00003/00003-12/00003-12-03/they are going to the party.mp3": [
		6549,
		7,
		5224
	],
	"./00003/00003-12/00003-12-03/tiger is going to the party.mp3": [
		6550,
		7,
		5225
	],
	"./00003/00003-12/00003-12-03/wild animals.mp3": [
		6551,
		7,
		5226
	],
	"./00003/00003-12/00003-12-03/zebra is going to the party.mp3": [
		6552,
		7,
		5227
	],
	"./00003/00003-12/00003-12-04/0.jpg": [
		7081,
		7,
		5758
	],
	"./00003/00003-12/00003-12-04/1.jpg": [
		9988,
		7,
		10010
	],
	"./00003/00003-12/00003-12-04/2.jpg": [
		9989,
		7,
		10011
	],
	"./00003/00003-12/00003-12-04/3.jpg": [
		9990,
		7,
		10012
	],
	"./00003/00003-12/00003-12-04/4.jpg": [
		9991,
		7,
		10013
	],
	"./00003/00003-12/00003-12-04/5.jpg": [
		9992,
		7,
		10014
	],
	"./00003/00003-12/00003-12-04/6.jpg": [
		9993,
		7,
		10015
	],
	"./00003/00003-12/00003-12-04/7.jpg": [
		9994,
		7,
		10016
	],
	"./00003/00003-12/00003-12-04/a friend for yellow duck.mp3": [
		6553,
		7,
		5228
	],
	"./00003/00003-12/00003-12-04/animals with 4 legs.mp3": [
		6554,
		7,
		5229
	],
	"./00003/00003-12/00003-12-04/can we play too said the fox and the deer.mp3": [
		6555,
		7,
		5230
	],
	"./00003/00003-12/00003-12-04/can we play too said the squirrel the skunk and the sheep.mp3": [
		6556,
		7,
		5231
	],
	"./00003/00003-12/00003-12-04/hello deer said yellow duck.mp3": [
		6557,
		7,
		5232
	],
	"./00003/00003-12/00003-12-04/hello sheep said yellow duck.mp3": [
		6558,
		7,
		5233
	],
	"./00003/00003-12/00003-12-04/here is brown duck.mp3": [
		6559,
		7,
		5234
	],
	"./00003/00003-12/00003-12-04/here is fox.mp3": [
		6560,
		7,
		5235
	],
	"./00003/00003-12/00003-12-04/here is skunk.mp3": [
		6561,
		7,
		5236
	],
	"./00003/00003-12/00003-12-04/i will not play with you.mp3": [
		6562,
		7,
		5237
	],
	"./00003/00003-12/00003-12-04/intro.mp3": [
		715,
		7
	],
	"./00003/00003-12/00003-12-04/look at the deer.mp3": [
		6563,
		7,
		5238
	],
	"./00003/00003-12/00003-12-04/main idea.mp3": [
		1096,
		7
	],
	"./00003/00003-12/00003-12-04/module": [
		1531,
		9,
		395
	],
	"./00003/00003-12/00003-12-04/module.js": [
		1531,
		9,
		395
	],
	"./00003/00003-12/00003-12-04/no i will not said skunk.mp3": [
		6564,
		7,
		5239
	],
	"./00003/00003-12/00003-12-04/no no no said sheep.mp3": [
		6565,
		7,
		5240
	],
	"./00003/00003-12/00003-12-04/no said fox.mp3": [
		6566,
		7,
		5241
	],
	"./00003/00003-12/00003-12-04/no said squirrel.mp3": [
		6567,
		7,
		5242
	],
	"./00003/00003-12/00003-12-04/not me said deer.mp3": [
		6568,
		7,
		5243
	],
	"./00003/00003-12/00003-12-04/squirrel will you play with me said yellow duck.mp3": [
		6569,
		7,
		5244
	],
	"./00003/00003-12/00003-12-04/will you play with me said yellow duck.mp3": [
		6570,
		7,
		5245
	],
	"./00003/00003-12/00003-12-04/will you play with me she said.mp3": [
		6571,
		7,
		5246
	],
	"./00003/00003-12/00003-12-04/will you play with me.mp3": [
		6572,
		7,
		5247
	],
	"./00003/00003-12/00003-12-04/yellow duck is looking for a friend.mp3": [
		6573,
		7,
		5248
	],
	"./00003/00003-12/00003-12-04/yellow duck said will you play with me.mp3": [
		6574,
		7,
		5249
	],
	"./00003/00003-12/00003-12-04/yes said brown duck.mp3": [
		6575,
		7,
		5250
	],
	"./00003/00003-12/00003-12-04/yes said yellow duck.mp3": [
		6576,
		7,
		5251
	],
	"./00003/00003-12/00003-12-05/0.jpg": [
		7082,
		7,
		5759
	],
	"./00003/00003-12/00003-12-05/1.jpg": [
		9995,
		7,
		10017
	],
	"./00003/00003-12/00003-12-05/2.jpg": [
		9996,
		7,
		10018
	],
	"./00003/00003-12/00003-12-05/3.jpg": [
		9997,
		7,
		10019
	],
	"./00003/00003-12/00003-12-05/4.jpg": [
		9998,
		7,
		10020
	],
	"./00003/00003-12/00003-12-05/5.jpg": [
		9999,
		7,
		10021
	],
	"./00003/00003-12/00003-12-05/6.jpg": [
		10000,
		7,
		10022
	],
	"./00003/00003-12/00003-12-05/7.jpg": [
		10001,
		7,
		10023
	],
	"./00003/00003-12/00003-12-05/cat likes to play soccer.mp3": [
		6577,
		7,
		5252
	],
	"./00003/00003-12/00003-12-05/fox likes to play soccer.mp3": [
		6578,
		7,
		5253
	],
	"./00003/00003-12/00003-12-05/goal said snake.mp3": [
		6579,
		7,
		5254
	],
	"./00003/00003-12/00003-12-05/i can not kick the ball.mp3": [
		6580,
		7,
		5255
	],
	"./00003/00003-12/00003-12-05/i can not play soccer.mp3": [
		6581,
		7,
		5256
	],
	"./00003/00003-12/00003-12-05/i have no feet said snake.mp3": [
		6582,
		7,
		5257
	],
	"./00003/00003-12/00003-12-05/intro.mp3": [
		716,
		7
	],
	"./00003/00003-12/00003-12-05/lion kicks the ball to skunk.mp3": [
		6583,
		7,
		5258
	],
	"./00003/00003-12/00003-12-05/lion likes to play soccer.mp3": [
		6584,
		7,
		5259
	],
	"./00003/00003-12/00003-12-05/main idea.mp3": [
		1097,
		7
	],
	"./00003/00003-12/00003-12-05/module": [
		1532,
		9,
		396
	],
	"./00003/00003-12/00003-12-05/module.js": [
		1532,
		9,
		396
	],
	"./00003/00003-12/00003-12-05/rabbit kicks the ball at the goal.mp3": [
		6585,
		7,
		5260
	],
	"./00003/00003-12/00003-12-05/rabbit kicks the ball to lion.mp3": [
		6586,
		7,
		5261
	],
	"./00003/00003-12/00003-12-05/rabbit likes to play soccer too.mp3": [
		6587,
		7,
		5262
	],
	"./00003/00003-12/00003-12-05/sheep likes to play soccer.mp3": [
		6588,
		7,
		5263
	],
	"./00003/00003-12/00003-12-05/skunk kicks the ball to rabbit.mp3": [
		6589,
		7,
		5264
	],
	"./00003/00003-12/00003-12-05/skunk likes to play soccer.mp3": [
		6590,
		7,
		5265
	],
	"./00003/00003-12/00003-12-05/the ball goes in the goal.mp3": [
		6591,
		7,
		5266
	],
	"./00003/00003-12/00003-12-05/the soccer game.mp3": [
		6592,
		7,
		5267
	],
	"./00003/00003-12/00003-12-05/tiger likes to play soccer.mp3": [
		6593,
		7,
		5268
	],
	"./00003/00003-12/00003-12-05/wild animals.mp3": [
		6594,
		7,
		5269
	],
	"./00003/00003-12/00003-12-06/0.jpg": [
		7083,
		7,
		5760
	],
	"./00003/00003-12/00003-12-06/1.jpg": [
		10002,
		7,
		10024
	],
	"./00003/00003-12/00003-12-06/2.jpg": [
		10003,
		7,
		10025
	],
	"./00003/00003-12/00003-12-06/3.jpg": [
		10004,
		7,
		10026
	],
	"./00003/00003-12/00003-12-06/4.jpg": [
		10005,
		7,
		10027
	],
	"./00003/00003-12/00003-12-06/5.jpg": [
		10006,
		7,
		10028
	],
	"./00003/00003-12/00003-12-06/6.jpg": [
		10007,
		7,
		10029
	],
	"./00003/00003-12/00003-12-06/7.jpg": [
		10008,
		7,
		10030
	],
	"./00003/00003-12/00003-12-06/baby animals.mp3": [
		6595,
		7,
		5270
	],
	"./00003/00003-12/00003-12-06/can i be your mother said the rabbit.mp3": [
		6596,
		7,
		5271
	],
	"./00003/00003-12/00003-12-06/can i be your mother.mp3": [
		6597,
		7,
		5272
	],
	"./00003/00003-12/00003-12-06/farm animals.mp3": [
		6598,
		7,
		5273
	],
	"./00003/00003-12/00003-12-06/i do not have a mother.mp3": [
		6599,
		7,
		5274
	],
	"./00003/00003-12/00003-12-06/i have a mother said the baby fox.mp3": [
		6600,
		7,
		5275
	],
	"./00003/00003-12/00003-12-06/i have a mother said the baby sheep.mp3": [
		6601,
		7,
		5276
	],
	"./00003/00003-12/00003-12-06/i have a mother said the chick.mp3": [
		6602,
		7,
		5277
	],
	"./00003/00003-12/00003-12-06/i have a mother.mp3": [
		6603,
		7,
		5278
	],
	"./00003/00003-12/00003-12-06/intro.mp3": [
		717,
		7
	],
	"./00003/00003-12/00003-12-06/main idea.mp3": [
		1098,
		7
	],
	"./00003/00003-12/00003-12-06/module": [
		1533,
		9,
		397
	],
	"./00003/00003-12/00003-12-06/module.js": [
		1533,
		9,
		397
	],
	"./00003/00003-12/00003-12-06/my mother is a cat.mp3": [
		6604,
		7,
		5279
	],
	"./00003/00003-12/00003-12-06/my mother is a chicken.mp3": [
		6605,
		7,
		5280
	],
	"./00003/00003-12/00003-12-06/my mother is a dog.mp3": [
		6606,
		7,
		5281
	],
	"./00003/00003-12/00003-12-06/my mother is a fox.mp3": [
		6607,
		7,
		5282
	],
	"./00003/00003-12/00003-12-06/my mother is a goat.mp3": [
		6608,
		7,
		5283
	],
	"./00003/00003-12/00003-12-06/my mother is a sheep.mp3": [
		6609,
		7,
		5284
	],
	"./00003/00003-12/00003-12-06/no said the baby goat.mp3": [
		6610,
		7,
		5285
	],
	"./00003/00003-12/00003-12-06/no said the kitten.mp3": [
		6611,
		7,
		5286
	],
	"./00003/00003-12/00003-12-06/no said the puppy.mp3": [
		6612,
		7,
		5287
	],
	"./00003/00003-12/00003-12-06/no.mp3": [
		6613,
		7,
		5288
	],
	"./00003/00003-12/00003-12-06/the rabbit said can i be your mother.mp3": [
		6614,
		7,
		5289
	],
	"./00003/00003-12/00003-12-06/yes said the baby turtle.mp3": [
		6615,
		7,
		5290
	],
	"./00003/00003-12/00003-12-06/yes.mp3": [
		6616,
		7,
		5291
	],
	"./00003/00003-12/00003-12-06/you can be my mother.mp3": [
		6617,
		7,
		5292
	],
	"./00003/00003-12/00003-12-07/0.jpg": [
		7084,
		7,
		5761
	],
	"./00003/00003-12/00003-12-07/1.jpg": [
		10009,
		7,
		10031
	],
	"./00003/00003-12/00003-12-07/2.jpg": [
		10010,
		7,
		10032
	],
	"./00003/00003-12/00003-12-07/3.jpg": [
		10011,
		7,
		10033
	],
	"./00003/00003-12/00003-12-07/4.jpg": [
		10012,
		7,
		10034
	],
	"./00003/00003-12/00003-12-07/5.jpg": [
		10013,
		7,
		10035
	],
	"./00003/00003-12/00003-12-07/6.jpg": [
		10014,
		7,
		10036
	],
	"./00003/00003-12/00003-12-07/7.jpg": [
		10015,
		7,
		10037
	],
	"./00003/00003-12/00003-12-07/an apple fell on her head.mp3": [
		6618,
		7,
		5293
	],
	"./00003/00003-12/00003-12-07/an apple fell on your head.mp3": [
		6619,
		7,
		5294
	],
	"./00003/00003-12/00003-12-07/birds.mp3": [
		6620,
		7,
		5295
	],
	"./00003/00003-12/00003-12-07/characters in the book.mp3": [
		6621,
		7,
		5296
	],
	"./00003/00003-12/00003-12-07/chicken little was sitting under a tree.mp3": [
		6622,
		7,
		5297
	],
	"./00003/00003-12/00003-12-07/i am the king said the lion.mp3": [
		6623,
		7,
		5298
	],
	"./00003/00003-12/00003-12-07/i must tell the king.mp3": [
		6624,
		7,
		5299
	],
	"./00003/00003-12/00003-12-07/intro.mp3": [
		718,
		7
	],
	"./00003/00003-12/00003-12-07/look at the deer.mp3": [
		6625,
		7,
		5300
	],
	"./00003/00003-12/00003-12-07/look at the elephant.mp3": [
		6626,
		7,
		5301
	],
	"./00003/00003-12/00003-12-07/look at the fox.mp3": [
		6627,
		7,
		5302
	],
	"./00003/00003-12/00003-12-07/look at the jaguar.mp3": [
		6628,
		7,
		5303
	],
	"./00003/00003-12/00003-12-07/look at the lion.mp3": [
		6629,
		7,
		5304
	],
	"./00003/00003-12/00003-12-07/look at the tiger.mp3": [
		6630,
		7,
		5305
	],
	"./00003/00003-12/00003-12-07/main idea.mp3": [
		1099,
		7
	],
	"./00003/00003-12/00003-12-07/module": [
		1534,
		9,
		398
	],
	"./00003/00003-12/00003-12-07/module.js": [
		1534,
		9,
		398
	],
	"./00003/00003-12/00003-12-07/the sky is falling said chicken little.mp3": [
		6631,
		7,
		5306
	],
	"./00003/00003-12/00003-12-07/the sky is falling said elephant.mp3": [
		6632,
		7,
		5307
	],
	"./00003/00003-12/00003-12-07/the sky is falling said jaguar.mp3": [
		6633,
		7,
		5308
	],
	"./00003/00003-12/00003-12-07/the sky is falling.mp3": [
		6634,
		7,
		5309
	],
	"./00003/00003-12/00003-12-07/the sky is not falling.mp3": [
		6635,
		7,
		5310
	],
	"./00003/00003-12/00003-12-07/we must tell the king.mp3": [
		6636,
		7,
		5311
	],
	"./00003/00003-12/00003-12-07/where are you going said elephant.mp3": [
		6637,
		7,
		5312
	],
	"./00003/00003-12/00003-12-07/where are you going said jaguar.mp3": [
		6638,
		7,
		5313
	],
	"./00003/00003-12/00003-12-07/where are you going said tiger.mp3": [
		6639,
		7,
		5314
	],
	"./00003/00003-12/00003-12-07/where are you going said wolf.mp3": [
		6640,
		7,
		5315
	],
	"./00003/00003-12/00003-12-08/0.jpg": [
		7085,
		7,
		5762
	],
	"./00003/00003-12/00003-12-08/1.jpg": [
		10016,
		7,
		10038
	],
	"./00003/00003-12/00003-12-08/2.jpg": [
		10017,
		7,
		10039
	],
	"./00003/00003-12/00003-12-08/3.jpg": [
		10018,
		7,
		10040
	],
	"./00003/00003-12/00003-12-08/4.jpg": [
		10019,
		7,
		10041
	],
	"./00003/00003-12/00003-12-08/5.jpg": [
		10020,
		7,
		10042
	],
	"./00003/00003-12/00003-12-08/6.jpg": [
		10021,
		7,
		10043
	],
	"./00003/00003-12/00003-12-08/7.jpg": [
		10022,
		7,
		10044
	],
	"./00003/00003-12/00003-12-08/here i am said the kitten.mp3": [
		6641,
		7,
		5316
	],
	"./00003/00003-12/00003-12-08/here you are said mother cat.mp3": [
		6642,
		7,
		5317
	],
	"./00003/00003-12/00003-12-08/intro.mp3": [
		719,
		7
	],
	"./00003/00003-12/00003-12-08/kitten where are you.mp3": [
		6643,
		7,
		5318
	],
	"./00003/00003-12/00003-12-08/main idea.mp3": [
		1100,
		7
	],
	"./00003/00003-12/00003-12-08/module": [
		1535,
		9,
		399
	],
	"./00003/00003-12/00003-12-08/module.js": [
		1535,
		9,
		399
	],
	"./00003/00003-12/00003-12-08/mother cat looked and looked.mp3": [
		6644,
		7,
		5319
	],
	"./00003/00003-12/00003-12-08/mother cat looked in the bathroom.mp3": [
		6645,
		7,
		5320
	],
	"./00003/00003-12/00003-12-08/mother cat looked in the bathtub.mp3": [
		6646,
		7,
		5321
	],
	"./00003/00003-12/00003-12-08/mother cat looked in the bedroom.mp3": [
		6647,
		7,
		5322
	],
	"./00003/00003-12/00003-12-08/mother cat looked in the living room.mp3": [
		6648,
		7,
		5323
	],
	"./00003/00003-12/00003-12-08/mother cat looked on the bed.mp3": [
		6649,
		7,
		5324
	],
	"./00003/00003-12/00003-12-08/mother cat looked on the couch.mp3": [
		6650,
		7,
		5325
	],
	"./00003/00003-12/00003-12-08/mother cat looked on the table.mp3": [
		6651,
		7,
		5326
	],
	"./00003/00003-12/00003-12-08/mother cat looked.mp3": [
		6652,
		7,
		5327
	],
	"./00003/00003-12/00003-12-08/no kittens here she said.mp3": [
		6653,
		7,
		5328
	],
	"./00003/00003-12/00003-12-08/non living things.mp3": [
		6654,
		7,
		5329
	],
	"./00003/00003-12/00003-12-08/she looked and looked.mp3": [
		6655,
		7,
		5330
	],
	"./00003/00003-12/00003-12-08/she looked in the box.mp3": [
		6656,
		7,
		5331
	],
	"./00003/00003-12/00003-12-08/she looked in the car.mp3": [
		6657,
		7,
		5332
	],
	"./00003/00003-12/00003-12-08/where is my kitten said mother cat.mp3": [
		6658,
		7,
		5333
	],
	"./00003/00003-12/00003-12-08/where is the kitten.mp3": [
		6659,
		7,
		5334
	],
	"./00003/00003-12/00003-12-09/0.jpg": [
		7086,
		7,
		5763
	],
	"./00003/00003-12/00003-12-09/1.jpg": [
		10023,
		7,
		10045
	],
	"./00003/00003-12/00003-12-09/2.jpg": [
		10024,
		7,
		10046
	],
	"./00003/00003-12/00003-12-09/3.jpg": [
		10025,
		7,
		10047
	],
	"./00003/00003-12/00003-12-09/4.jpg": [
		10026,
		7,
		10048
	],
	"./00003/00003-12/00003-12-09/5.jpg": [
		10027,
		7,
		10049
	],
	"./00003/00003-12/00003-12-09/6.jpg": [
		10028,
		7,
		10050
	],
	"./00003/00003-12/00003-12-09/7.jpg": [
		10029,
		7,
		10051
	],
	"./00003/00003-12/00003-12-09/i love the butterflies.mp3": [
		6660,
		7,
		5335
	],
	"./00003/00003-12/00003-12-09/i love the dragonflies.mp3": [
		6661,
		7,
		5336
	],
	"./00003/00003-12/00003-12-09/i love the farms.mp3": [
		6662,
		7,
		5337
	],
	"./00003/00003-12/00003-12-09/i love the mountains.mp3": [
		6663,
		7,
		5338
	],
	"./00003/00003-12/00003-12-09/i love the ocean.mp3": [
		6664,
		7,
		5339
	],
	"./00003/00003-12/00003-12-09/i love the ponds.mp3": [
		6665,
		7,
		5340
	],
	"./00003/00003-12/00003-12-09/i love to see the bees.mp3": [
		6666,
		7,
		5341
	],
	"./00003/00003-12/00003-12-09/i love to see the boats.mp3": [
		6667,
		7,
		5342
	],
	"./00003/00003-12/00003-12-09/i love to see the dogs.mp3": [
		6668,
		7,
		5343
	],
	"./00003/00003-12/00003-12-09/i love to see the frogs.mp3": [
		6669,
		7,
		5344
	],
	"./00003/00003-12/00003-12-09/i love to see the goats.mp3": [
		6670,
		7,
		5345
	],
	"./00003/00003-12/00003-12-09/i love to see the trees.mp3": [
		6671,
		7,
		5346
	],
	"./00003/00003-12/00003-12-09/intro.mp3": [
		720,
		7
	],
	"./00003/00003-12/00003-12-09/main idea.mp3": [
		1101,
		7
	],
	"./00003/00003-12/00003-12-09/module": [
		1536,
		9,
		400
	],
	"./00003/00003-12/00003-12-09/module.js": [
		1536,
		9,
		400
	],
	"./00003/00003-12/00003-12-09/things on the earth.mp3": [
		6672,
		7,
		5347
	],
	"./00003/00003-12/00003-12-09/we love the animals.mp3": [
		6673,
		7,
		5348
	],
	"./00003/00003-12/00003-12-09/we love the earth.mp3": [
		6674,
		7,
		5349
	],
	"./00003/00003-12/00003-12-10/0.jpg": [
		7087,
		7,
		5764
	],
	"./00003/00003-12/00003-12-10/1.jpg": [
		10030,
		7,
		10052
	],
	"./00003/00003-12/00003-12-10/2.jpg": [
		10031,
		7,
		10053
	],
	"./00003/00003-12/00003-12-10/3.jpg": [
		10032,
		7,
		10054
	],
	"./00003/00003-12/00003-12-10/4.jpg": [
		10033,
		7,
		10055
	],
	"./00003/00003-12/00003-12-10/5.jpg": [
		10034,
		7,
		10056
	],
	"./00003/00003-12/00003-12-10/6.jpg": [
		10035,
		7,
		10057
	],
	"./00003/00003-12/00003-12-10/7.jpg": [
		10036,
		7,
		10058
	],
	"./00003/00003-12/00003-12-10/birds.mp3": [
		6675,
		7,
		5350
	],
	"./00003/00003-12/00003-12-10/have you seen my mother said baby bird.mp3": [
		6676,
		7,
		5351
	],
	"./00003/00003-12/00003-12-10/have you seen my mother.mp3": [
		6677,
		7,
		5352
	],
	"./00003/00003-12/00003-12-10/help mother said baby bird.mp3": [
		6678,
		7,
		5353
	],
	"./00003/00003-12/00003-12-10/here is a dog.mp3": [
		6679,
		7,
		5354
	],
	"./00003/00003-12/00003-12-10/here is a worm said mother bird.mp3": [
		6680,
		7,
		5355
	],
	"./00003/00003-12/00003-12-10/here is baby bird.mp3": [
		6681,
		7,
		5356
	],
	"./00003/00003-12/00003-12-10/here is mother bird.mp3": [
		6682,
		7,
		5357
	],
	"./00003/00003-12/00003-12-10/i can see a pig.mp3": [
		6683,
		7,
		5358
	],
	"./00003/00003-12/00003-12-10/i can see a snake.mp3": [
		6684,
		7,
		5359
	],
	"./00003/00003-12/00003-12-10/intro.mp3": [
		721,
		7
	],
	"./00003/00003-12/00003-12-10/look at the duck.mp3": [
		6685,
		7,
		5360
	],
	"./00003/00003-12/00003-12-10/look at the rabbit.mp3": [
		6686,
		7,
		5361
	],
	"./00003/00003-12/00003-12-10/main idea.mp3": [
		1102,
		7
	],
	"./00003/00003-12/00003-12-10/module": [
		1537,
		9,
		401
	],
	"./00003/00003-12/00003-12-10/module.js": [
		1537,
		9,
		401
	],
	"./00003/00003-12/cover.jpg": [
		7088,
		7,
		5765
	],
	"./00003/00003-12/story land.mp3": [
		6687,
		7,
		5362
	],
	"./00003/00003-12/unit": [
		1538,
		9,
		402
	],
	"./00003/00003-12/unit.js": [
		1538,
		9,
		402
	],
	"./00003/course": [
		1539,
		9,
		403
	],
	"./00003/course.js": [
		1539,
		9,
		403
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(2).map(__webpack_require__.e)).then(function() {
		return __webpack_require__.t(id, ids[1])
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = 1602;
module.exports = webpackAsyncContext;